var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "20000": {
    "AGUASCALIENTES": {
      "20000": true
    }
  },
  "20010": {
    "AGUASCALIENTES": {
      "20010": true
    }
  },
  "20016": {
    "AGUASCALIENTES": {
      "20016": true
    }
  },
  "20018": {
    "AGUASCALIENTES": {
      "20018": true
    }
  },
  "20020": {
    "AGUASCALIENTES": {
      "20020": true
    }
  },
  "20029": {
    "AGUASCALIENTES": {
      "20029": true
    }
  },
  "20030": {
    "AGUASCALIENTES": {
      "20030": true
    }
  },
  "20040": {
    "AGUASCALIENTES": {
      "20040": true
    }
  },
  "20049": {
    "AGUASCALIENTES": {
      "20049": true
    }
  },
  "20050": {
    "AGUASCALIENTES": {
      "20050": true
    }
  },
  "20059": {
    "AGUASCALIENTES": {
      "20059": true
    }
  },
  "20060": {
    "AGUASCALIENTES": {
      "20060": true
    }
  },
  "20064": {
    "AGUASCALIENTES": {
      "20064": true
    }
  },
  "20070": {
    "AGUASCALIENTES": {
      "20070": true
    }
  },
  "20078": {
    "AGUASCALIENTES": {
      "20078": true
    }
  },
  "20080": {
    "AGUASCALIENTES": {
      "20080": true
    }
  },
  "20089": {
    "AGUASCALIENTES": {
      "20089": true
    }
  },
  "20115": {
    "AGUASCALIENTES": {
      "20115": true
    }
  },
  "20116": {
    "AGUASCALIENTES": {
      "20116": true
    }
  },
  "20117": {
    "AGUASCALIENTES": {
      "20117": true
    }
  },
  "20118": {
    "AGUASCALIENTES": {
      "20118": true
    }
  },
  "20119": {
    "AGUASCALIENTES": {
      "20119": true
    }
  },
  "20120": {
    "AGUASCALIENTES": {
      "20120": true
    }
  },
  "20123": {
    "AGUASCALIENTES": {
      "20123": true
    }
  },
  "20124": {
    "AGUASCALIENTES": {
      "20124": true
    }
  },
  "20126": {
    "AGUASCALIENTES": {
      "20126": true
    }
  },
  "20127": {
    "AGUASCALIENTES": {
      "20127": true
    }
  },
  "20129": {
    "AGUASCALIENTES": {
      "20129": true
    }
  },
  "20130": {
    "AGUASCALIENTES": {
      "20130": true
    }
  },
  "20135": {
    "AGUASCALIENTES": {
      "20135": true
    }
  },
  "20136": {
    "AGUASCALIENTES": {
      "20136": true
    }
  },
  "20137": {
    "AGUASCALIENTES": {
      "20137": true
    }
  },
  "20138": {
    "AGUASCALIENTES": {
      "20138": true
    }
  },
  "20140": {
    "AGUASCALIENTES": {
      "20140": true
    }
  },
  "20146": {
    "AGUASCALIENTES": {
      "20146": true
    }
  },
  "20149": {
    "AGUASCALIENTES": {
      "20149": true
    }
  },
  "20150": {
    "AGUASCALIENTES": {
      "20150": true
    }
  },
  "20157": {
    "AGUASCALIENTES": {
      "20157": true
    }
  },
  "20158": {
    "AGUASCALIENTES": {
      "20158": true
    }
  },
  "20159": {
    "AGUASCALIENTES": {
      "20159": true
    }
  },
  "20160": {
    "AGUASCALIENTES": {
      "20160": true
    }
  },
  "20164": {
    "AGUASCALIENTES": {
      "20164": true
    }
  },
  "20169": {
    "AGUASCALIENTES": {
      "20169": true
    }
  },
  "20170": {
    "AGUASCALIENTES": {
      "20170": true
    }
  },
  "20172": {
    "AGUASCALIENTES": {
      "20172": true
    }
  },
  "20174": {
    "AGUASCALIENTES": {
      "20174": true
    }
  },
  "20175": {
    "AGUASCALIENTES": {
      "20175": true
    }
  },
  "20177": {
    "AGUASCALIENTES": {
      "20177": true
    }
  },
  "20179": {
    "AGUASCALIENTES": {
      "20179": true
    }
  },
  "20180": {
    "AGUASCALIENTES": {
      "20180": true
    }
  },
  "20190": {
    "AGUASCALIENTES": {
      "20190": true
    }
  },
  "20196": {
    "AGUASCALIENTES": {
      "20196": true
    }
  },
  "20198": {
    "AGUASCALIENTES": {
      "20198": true
    }
  },
  "20199": {
    "AGUASCALIENTES": {
      "20199": true
    }
  },
  "20200": {
    "AGUASCALIENTES": {
      "20200": true
    }
  },
  "20205": {
    "AGUASCALIENTES": {
      "20205": true
    }
  },
  "20206": {
    "AGUASCALIENTES": {
      "20206": true
    }
  },
  "20207": {
    "AGUASCALIENTES": {
      "20207": true
    }
  },
  "20208": {
    "AGUASCALIENTES": {
      "20208": true
    }
  },
  "20210": {
    "AGUASCALIENTES": {
      "20210": true
    }
  },
  "20216": {
    "AGUASCALIENTES": {
      "20216": true
    }
  },
  "20217": {
    "AGUASCALIENTES": {
      "20217": true
    }
  },
  "20218": {
    "AGUASCALIENTES": {
      "20218": true
    }
  },
  "20219": {
    "AGUASCALIENTES": {
      "20219": true
    }
  },
  "20220": {
    "AGUASCALIENTES": {
      "20220": true
    }
  },
  "20229": {
    "AGUASCALIENTES": {
      "20229": true
    }
  },
  "20230": {
    "AGUASCALIENTES": {
      "20230": true
    }
  },
  "20234": {
    "AGUASCALIENTES": {
      "20234": true
    }
  },
  "20235": {
    "AGUASCALIENTES": {
      "20235": true
    }
  },
  "20236": {
    "AGUASCALIENTES": {
      "20236": true
    }
  },
  "20237": {
    "AGUASCALIENTES": {
      "20237": true
    }
  },
  "20238": {
    "AGUASCALIENTES": {
      "20238": true
    }
  },
  "20239": {
    "AGUASCALIENTES": {
      "20239": true
    }
  },
  "20240": {
    "AGUASCALIENTES": {
      "20240": true
    }
  },
  "20247": {
    "AGUASCALIENTES": {
      "20247": true
    }
  },
  "20248": {
    "AGUASCALIENTES": {
      "20248": true
    }
  },
  "20249": {
    "AGUASCALIENTES": {
      "20249": true
    }
  },
  "20250": {
    "AGUASCALIENTES": {
      "20250": true
    }
  },
  "20255": {
    "AGUASCALIENTES": {
      "20255": true
    }
  },
  "20256": {
    "AGUASCALIENTES": {
      "20256": true
    }
  },
  "20257": {
    "AGUASCALIENTES": {
      "20257": true
    }
  },
  "20259": {
    "AGUASCALIENTES": {
      "20259": true
    }
  },
  "20260": {
    "AGUASCALIENTES": {
      "20260": true
    }
  },
  "20263": {
    "AGUASCALIENTES": {
      "20263": true
    }
  },
  "20264": {
    "AGUASCALIENTES": {
      "20264": true
    }
  },
  "20265": {
    "AGUASCALIENTES": {
      "20265": true
    }
  },
  "20266": {
    "AGUASCALIENTES": {
      "20266": true
    }
  },
  "20267": {
    "AGUASCALIENTES": {
      "20267": true
    }
  },
  "20268": {
    "AGUASCALIENTES": {
      "20268": true
    }
  },
  "20269": {
    "AGUASCALIENTES": {
      "20269": true
    }
  },
  "20270": {
    "AGUASCALIENTES": {
      "20270": true
    }
  },
  "20276": {
    "AGUASCALIENTES": {
      "20276": true
    }
  },
  "20277": {
    "AGUASCALIENTES": {
      "20277": true
    }
  },
  "20278": {
    "AGUASCALIENTES": {
      "20278": true
    }
  },
  "20280": {
    "AGUASCALIENTES": {
      "20280": true
    }
  },
  "20283": {
    "AGUASCALIENTES": {
      "20283": true
    }
  },
  "20284": {
    "AGUASCALIENTES": {
      "20284": true
    }
  },
  "20285": {
    "AGUASCALIENTES": {
      "20285": true
    }
  },
  "20286": {
    "AGUASCALIENTES": {
      "20286": true
    }
  },
  "20287": {
    "AGUASCALIENTES": {
      "20287": true
    }
  },
  "20288": {
    "AGUASCALIENTES": {
      "20288": true
    }
  },
  "20289": {
    "AGUASCALIENTES": {
      "20289": true
    }
  },
  "20290": {
    "AGUASCALIENTES": {
      "20290": true
    }
  },
  "20291": {
    "AGUASCALIENTES": {
      "20291": true
    }
  },
  "20296": {
    "AGUASCALIENTES": {
      "20296": true
    }
  },
  "20297": {
    "AGUASCALIENTES": {
      "20297": true
    }
  },
  "20298": {
    "AGUASCALIENTES": {
      "20298": true
    }
  },
  "20299": {
    "AGUASCALIENTES": {
      "20299": true
    }
  },
  "20310": {
    "AGUASCALIENTES": {
      "20310": true
    }
  },
  "20311": {
    "AGUASCALIENTES": {
      "20311": true
    }
  },
  "20313": {
    "AGUASCALIENTES": {
      "20313": true
    }
  },
  "20314": {
    "AGUASCALIENTES": {
      "20314": true
    }
  },
  "20315": {
    "AGUASCALIENTES": {
      "20315": true
    }
  },
  "20317": {
    "AGUASCALIENTES": {
      "20317": true
    }
  },
  "20319": {
    "AGUASCALIENTES": {
      "20319": true
    }
  },
  "20320": {
    "AGUASCALIENTES": {
      "20320": true
    }
  },
  "20321": {
    "AGUASCALIENTES": {
      "20321": true
    }
  },
  "20323": {
    "AGUASCALIENTES": {
      "20323": true
    }
  },
  "20326": {
    "AGUASCALIENTES": {
      "20326": true
    }
  },
  "20328": {
    "AGUASCALIENTES": {
      "20328": true
    }
  },
  "20329": {
    "AGUASCALIENTES": {
      "20329": true
    }
  },
  "20340": {
    "AGUASCALIENTES": {
      "20340": true
    }
  },
  "20342": {
    "AGUASCALIENTES": {
      "20342": true
    }
  },
  "20344": {
    "AGUASCALIENTES": {
      "20344": true
    }
  },
  "20345": {
    "AGUASCALIENTES": {
      "20345": true
    }
  },
  "20346": {
    "AGUASCALIENTES": {
      "20346": true
    }
  },
  "20348": {
    "AGUASCALIENTES": {
      "20348": true
    }
  },
  "20355": {
    "AGUASCALIENTES": {
      "20355": true
    }
  },
  "20358": {
    "AGUASCALIENTES": {
      "20358": true
    }
  },
  "20363": {
    "AGUASCALIENTES": {
      "20363": true
    }
  },
  "20364": {
    "AGUASCALIENTES": {
      "20364": true
    }
  },
  "20366": {
    "AGUASCALIENTES": {
      "20366": true
    }
  },
  "20367": {
    "AGUASCALIENTES": {
      "20367": true
    }
  },
  "20369": {
    "AGUASCALIENTES": {
      "20369": true
    }
  },
  "20370": {
    "AGUASCALIENTES": {
      "20370": true
    }
  },
  "20372": {
    "AGUASCALIENTES": {
      "20372": true
    }
  },
  "20375": {
    "AGUASCALIENTES": {
      "20375": true
    }
  },
  "20379": {
    "AGUASCALIENTES": {
      "20379": true
    }
  },
  "20385": {
    "AGUASCALIENTES": {
      "20385": true
    }
  },
  "20386": {
    "AGUASCALIENTES": {
      "20386": true
    }
  },
  "20389": {
    "AGUASCALIENTES": {
      "20389": true
    }
  },
  "20390": {
    "AGUASCALIENTES": {
      "20390": true
    }
  },
  "20391": {
    "AGUASCALIENTES": {
      "20391": true
    }
  },
  "20392": {
    "AGUASCALIENTES": {
      "20392": true
    }
  },
  "20393": {
    "AGUASCALIENTES": {
      "20393": true
    }
  },
  "20395": {
    "AGUASCALIENTES": {
      "20395": true
    }
  },
  "20396": {
    "AGUASCALIENTES": {
      "20396": true
    }
  },
  "20399": {
    "AGUASCALIENTES": {
      "20399": true
    }
  },
  "20900": {
    "AGUASCALIENTES": {
      "20900": true
    }
  },
  "20904": {
    "AGUASCALIENTES": {
      "20904": true
    }
  },
  "20905": {
    "AGUASCALIENTES": {
      "20905": true
    }
  },
  "20907": {
    "AGUASCALIENTES": {
      "20907": true
    }
  },
  "20908": {
    "AGUASCALIENTES": {
      "20908": true
    }
  },
  "20920": {
    "AGUASCALIENTES": {
      "20920": true
    }
  },
  "20922": {
    "AGUASCALIENTES": {
      "20922": true
    }
  },
  "20923": {
    "AGUASCALIENTES": {
      "20923": true
    }
  },
  "20924": {
    "AGUASCALIENTES": {
      "20924": true
    }
  },
  "20925": {
    "AGUASCALIENTES": {
      "20925": true
    }
  },
  "20926": {
    "AGUASCALIENTES": {
      "20926": true
    }
  },
  "20927": {
    "AGUASCALIENTES": {
      "20927": true
    }
  },
  "20928": {
    "AGUASCALIENTES": {
      "20928": true
    }
  },
  "20933": {
    "AGUASCALIENTES": {
      "20933": true
    }
  },
  "20983": {
    "AGUASCALIENTES": {
      "20983": true
    }
  },
  "20984": {
    "AGUASCALIENTES": {
      "20984": true
    }
  },
  "20995": {
    "AGUASCALIENTES": {
      "20995": true
    }
  },
  "20997": {
    "AGUASCALIENTES": {
      "20997": true
    }
  },
  "24000": {
    "CAMPECHE": {
      "24000": true
    }
  },
  "24010": {
    "CAMPECHE": {
      "24010": true
    }
  },
  "24014": {
    "CAMPECHE": {
      "24014": true
    }
  },
  "24020": {
    "CAMPECHE": {
      "24020": true
    }
  },
  "24022": {
    "CAMPECHE": {
      "24022": true
    }
  },
  "24023": {
    "CAMPECHE": {
      "24023": true
    }
  },
  "24024": {
    "CAMPECHE": {
      "24024": true
    }
  },
  "24025": {
    "CAMPECHE": {
      "24025": true
    }
  },
  "24026": {
    "CAMPECHE": {
      "24026": true
    }
  },
  "24027": {
    "CAMPECHE": {
      "24027": true
    }
  },
  "24028": {
    "CAMPECHE": {
      "24028": true
    }
  },
  "24029": {
    "CAMPECHE": {
      "24029": true
    }
  },
  "24030": {
    "CAMPECHE": {
      "24030": true
    }
  },
  "24035": {
    "CAMPECHE": {
      "24035": true
    }
  },
  "24036": {
    "CAMPECHE": {
      "24036": true
    }
  },
  "24037": {
    "CAMPECHE": {
      "24037": true
    }
  },
  "24038": {
    "CAMPECHE": {
      "24038": true
    }
  },
  "24039": {
    "CAMPECHE": {
      "24039": true
    }
  },
  "24040": {
    "CAMPECHE": {
      "24040": true
    }
  },
  "24044": {
    "CAMPECHE": {
      "24044": true
    }
  },
  "24049": {
    "CAMPECHE": {
      "24049": true
    }
  },
  "24050": {
    "CAMPECHE": {
      "24050": true
    }
  },
  "24058": {
    "CAMPECHE": {
      "24058": true
    }
  },
  "24060": {
    "CAMPECHE": {
      "24060": true
    }
  },
  "24063": {
    "CAMPECHE": {
      "24063": true
    }
  },
  "24069": {
    "CAMPECHE": {
      "24069": true
    }
  },
  "24070": {
    "CAMPECHE": {
      "24070": true
    }
  },
  "24073": {
    "CAMPECHE": {
      "24073": true
    }
  },
  "24075": {
    "CAMPECHE": {
      "24075": true
    }
  },
  "24079": {
    "CAMPECHE": {
      "24079": true
    }
  },
  "24080": {
    "CAMPECHE": {
      "24080": true
    }
  },
  "24083": {
    "CAMPECHE": {
      "24083": true
    }
  },
  "24084": {
    "CAMPECHE": {
      "24084": true
    }
  },
  "24085": {
    "CAMPECHE": {
      "24085": true
    }
  },
  "24086": {
    "CAMPECHE": {
      "24086": true
    }
  },
  "24087": {
    "CAMPECHE": {
      "24087": true
    }
  },
  "24088": {
    "CAMPECHE": {
      "24088": true
    }
  },
  "24089": {
    "CAMPECHE": {
      "24089": true
    }
  },
  "24090": {
    "CAMPECHE": {
      "24090": true
    }
  },
  "24093": {
    "CAMPECHE": {
      "24093": true
    }
  },
  "24094": {
    "CAMPECHE": {
      "24094": true
    }
  },
  "24095": {
    "CAMPECHE": {
      "24095": true
    }
  },
  "24096": {
    "CAMPECHE": {
      "24096": true
    }
  },
  "24097": {
    "CAMPECHE": {
      "24097": true
    }
  },
  "24098": {
    "CAMPECHE": {
      "24098": true
    }
  },
  "24099": {
    "CAMPECHE": {
      "24099": true
    }
  },
  "28000": {
    "COLIMA": {
      "28000": true
    }
  },
  "28001": {
    "COLIMA": {
      "28001": true
    }
  },
  "28002": {
    "COLIMA": {
      "28002": true
    }
  },
  "28003": {
    "COLIMA": {
      "28003": true
    }
  },
  "28004": {
    "COLIMA": {
      "28004": true
    }
  },
  "28005": {
    "COLIMA": {
      "28005": true
    }
  },
  "28006": {
    "COLIMA": {
      "28006": true
    }
  },
  "28007": {
    "COLIMA": {
      "28007": true
    }
  },
  "28008": {
    "COLIMA": {
      "28008": true
    }
  },
  "28009": {
    "COLIMA": {
      "28009": true
    }
  },
  "28010": {
    "COLIMA": {
      "28010": true
    }
  },
  "28014": {
    "COLIMA": {
      "28014": true
    }
  },
  "28016": {
    "COLIMA": {
      "28016": true
    }
  },
  "28017": {
    "COLIMA": {
      "28017": true
    }
  },
  "28018": {
    "COLIMA": {
      "28018": true
    }
  },
  "28019": {
    "COLIMA": {
      "28019": true
    }
  },
  "28020": {
    "COLIMA": {
      "28020": true
    }
  },
  "28023": {
    "COLIMA": {
      "28023": true
    }
  },
  "28025": {
    "COLIMA": {
      "28025": true
    }
  },
  "28028": {
    "COLIMA": {
      "28028": true
    }
  },
  "28030": {
    "COLIMA": {
      "28030": true
    }
  },
  "28035": {
    "COLIMA": {
      "28035": true
    }
  },
  "28037": {
    "COLIMA": {
      "28037": true
    }
  },
  "28040": {
    "COLIMA": {
      "28040": true
    }
  },
  "28043": {
    "COLIMA": {
      "28043": true
    }
  },
  "28044": {
    "COLIMA": {
      "28044": true
    }
  },
  "28045": {
    "COLIMA": {
      "28045": true
    }
  },
  "28046": {
    "COLIMA": {
      "28046": true
    }
  },
  "28047": {
    "COLIMA": {
      "28047": true
    }
  },
  "28048": {
    "COLIMA": {
      "28048": true
    }
  },
  "28050": {
    "COLIMA": {
      "28050": true
    }
  },
  "28060": {
    "COLIMA": {
      "28060": true
    }
  },
  "28063": {
    "COLIMA": {
      "28063": true
    }
  },
  "28067": {
    "COLIMA": {
      "28067": true
    }
  },
  "28068": {
    "COLIMA": {
      "28068": true
    }
  },
  "28069": {
    "COLIMA": {
      "28069": true
    }
  },
  "28070": {
    "COLIMA": {
      "28070": true
    }
  },
  "28071": {
    "COLIMA": {
      "28071": true
    }
  },
  "28075": {
    "COLIMA": {
      "28075": true
    }
  },
  "28076": {
    "COLIMA": {
      "28076": true
    }
  },
  "28077": {
    "COLIMA": {
      "28077": true
    }
  },
  "28078": {
    "COLIMA": {
      "28078": true
    }
  },
  "28079": {
    "COLIMA": {
      "28079": true
    }
  },
  "28080": {
    "COLIMA": {
      "28080": true
    }
  },
  "28085": {
    "COLIMA": {
      "28085": true
    }
  },
  "28089": {
    "COLIMA": {
      "28089": true
    }
  },
  "28090": {
    "COLIMA": {
      "28090": true
    }
  },
  "28100": {
    "COLIMA": {
      "28100": true
    }
  },
  "28134": {
    "COLIMA": {
      "28134": true
    }
  },
  "28140": {
    "COLIMA": {
      "28140": true
    }
  },
  "28200": {
    "COLIMA": {
      "28200": true
    }
  },
  "28209": {
    "COLIMA": {
      "28209": true
    }
  },
  "28210": {
    "COLIMA": {
      "28210": true
    }
  },
  "28218": {
    "COLIMA": {
      "28218": true
    }
  },
  "28219": {
    "COLIMA": {
      "28219": true
    }
  },
  "28230": {
    "COLIMA": {
      "28230": true
    }
  },
  "28236": {
    "COLIMA": {
      "28236": true
    }
  },
  "28237": {
    "COLIMA": {
      "28237": true
    }
  },
  "28238": {
    "COLIMA": {
      "28238": true
    }
  },
  "28239": {
    "COLIMA": {
      "28239": true
    }
  },
  "28240": {
    "COLIMA": {
      "28240": true
    }
  },
  "28250": {
    "COLIMA": {
      "28250": true
    }
  },
  "28259": {
    "COLIMA": {
      "28259": true
    }
  },
  "28260": {
    "COLIMA": {
      "28260": true
    }
  },
  "28269": {
    "COLIMA": {
      "28269": true
    }
  },
  "28270": {
    "COLIMA": {
      "28270": true
    }
  },
  "28278": {
    "COLIMA": {
      "28278": true
    }
  },
  "28279": {
    "COLIMA": {
      "28279": true
    }
  },
  "28280": {
    "COLIMA": {
      "28280": true
    }
  },
  "28450": {
    "COLIMA": {
      "28450": true
    }
  },
  "28500": {
    "COLIMA": {
      "28500": true
    }
  },
  "28600": {
    "COLIMA": {
      "28600": true
    }
  },
  "28610": {
    "COLIMA": {
      "28610": true
    }
  },
  "28627": {
    "COLIMA": {
      "28627": true
    }
  },
  "28628": {
    "COLIMA": {
      "28628": true
    }
  },
  "28629": {
    "COLIMA": {
      "28629": true
    }
  },
  "28630": {
    "COLIMA": {
      "28630": true
    }
  },
  "28633": {
    "COLIMA": {
      "28633": true
    }
  },
  "28634": {
    "COLIMA": {
      "28634": true
    }
  },
  "28635": {
    "COLIMA": {
      "28635": true
    }
  },
  "28646": {
    "COLIMA": {
      "28646": true
    }
  },
  "28647": {
    "COLIMA": {
      "28647": true
    }
  },
  "28656": {
    "COLIMA": {
      "28656": true
    }
  },
  "28750": {
    "COLIMA": {
      "28750": true
    }
  },
  "28800": {
    "COLIMA": {
      "28800": true
    }
  },
  "28807": {
    "COLIMA": {
      "28807": true
    }
  },
  "28812": {
    "COLIMA": {
      "28812": true
    }
  },
  "28813": {
    "COLIMA": {
      "28813": true
    }
  },
  "28814": {
    "COLIMA": {
      "28814": true
    }
  },
  "28815": {
    "COLIMA": {
      "28815": true
    }
  },
  "28820": {
    "COLIMA": {
      "28820": true
    }
  },
  "28823": {
    "COLIMA": {
      "28823": true
    }
  },
  "28826": {
    "COLIMA": {
      "28826": true
    }
  },
  "28830": {
    "COLIMA": {
      "28830": true
    }
  },
  "28833": {
    "COLIMA": {
      "28833": true
    }
  },
  "28834": {
    "COLIMA": {
      "28834": true
    }
  },
  "28836": {
    "COLIMA": {
      "28836": true
    }
  },
  "28838": {
    "COLIMA": {
      "28838": true
    }
  },
  "28840": {
    "COLIMA": {
      "28840": true
    }
  },
  "28855": {
    "COLIMA": {
      "28855": true
    }
  },
  "28860": {
    "COLIMA": {
      "28860": true
    }
  },
  "28863": {
    "COLIMA": {
      "28863": true
    }
  },
  "28864": {
    "COLIMA": {
      "28864": true
    }
  },
  "28865": {
    "COLIMA": {
      "28865": true
    }
  },
  "28867": {
    "COLIMA": {
      "28867": true
    }
  },
  "28868": {
    "COLIMA": {
      "28868": true
    }
  },
  "28869": {
    "COLIMA": {
      "28869": true
    }
  },
  "28872": {
    "COLIMA": {
      "28872": true
    }
  },
  "28876": {
    "COLIMA": {
      "28876": true
    }
  },
  "28877": {
    "COLIMA": {
      "28877": true
    }
  },
  "28878": {
    "COLIMA": {
      "28878": true
    }
  },
  "28879": {
    "COLIMA": {
      "28879": true
    }
  },
  "28950": {
    "COLIMA": {
      "28950": true
    }
  },
  "28952": {
    "COLIMA": {
      "28952": true
    }
  },
  "28955": {
    "COLIMA": {
      "28955": true
    }
  },
  "28958": {
    "COLIMA": {
      "28958": true
    }
  },
  "28959": {
    "COLIMA": {
      "28959": true
    }
  },
  "28960": {
    "COLIMA": {
      "28960": true
    }
  },
  "28963": {
    "COLIMA": {
      "28963": true
    }
  },
  "28964": {
    "COLIMA": {
      "28964": true
    }
  },
  "28965": {
    "COLIMA": {
      "28965": true
    }
  },
  "28968": {
    "COLIMA": {
      "28968": true
    }
  },
  "28970": {
    "COLIMA": {
      "28970": true
    }
  },
  "28972": {
    "COLIMA": {
      "28972": true
    }
  },
  "28973": {
    "COLIMA": {
      "28973": true
    }
  },
  "28974": {
    "COLIMA": {
      "28974": true
    }
  },
  "28975": {
    "COLIMA": {
      "28975": true
    }
  },
  "28976": {
    "COLIMA": {
      "28976": true
    }
  },
  "28977": {
    "COLIMA": {
      "28977": true
    }
  },
  "28978": {
    "COLIMA": {
      "28978": true
    }
  },
  "28979": {
    "COLIMA": {
      "28979": true
    }
  },
  "28980": {
    "COLIMA": {
      "28980": true
    }
  },
  "28982": {
    "COLIMA": {
      "28982": true
    }
  },
  "28983": {
    "COLIMA": {
      "28983": true
    }
  },
  "28984": {
    "COLIMA": {
      "28984": true
    }
  },
  "28985": {
    "COLIMA": {
      "28985": true
    }
  },
  "28986": {
    "COLIMA": {
      "28986": true
    }
  },
  "28987": {
    "COLIMA": {
      "28987": true
    }
  },
  "28988": {
    "COLIMA": {
      "28988": true
    }
  },
  "28989": {
    "COLIMA": {
      "28989": true
    }
  },
  "29000": {
    "CHIAPAS": {
      "29000": true
    }
  },
  "29007": {
    "CHIAPAS": {
      "29007": true
    }
  },
  "29008": {
    "CHIAPAS": {
      "29008": true
    }
  },
  "29009": {
    "CHIAPAS": {
      "29009": true
    }
  },
  "29010": {
    "CHIAPAS": {
      "29010": true
    }
  },
  "29014": {
    "CHIAPAS": {
      "29014": true
    }
  },
  "29016": {
    "CHIAPAS": {
      "29016": true
    }
  },
  "29017": {
    "CHIAPAS": {
      "29017": true
    }
  },
  "29018": {
    "CHIAPAS": {
      "29018": true
    }
  },
  "29019": {
    "CHIAPAS": {
      "29019": true
    }
  },
  "29020": {
    "CHIAPAS": {
      "29020": true
    }
  },
  "29023": {
    "CHIAPAS": {
      "29023": true
    }
  },
  "29024": {
    "CHIAPAS": {
      "29024": true
    }
  },
  "29025": {
    "CHIAPAS": {
      "29025": true
    }
  },
  "29026": {
    "CHIAPAS": {
      "29026": true
    }
  },
  "29027": {
    "CHIAPAS": {
      "29027": true
    }
  },
  "29028": {
    "CHIAPAS": {
      "29028": true
    }
  },
  "29030": {
    "CHIAPAS": {
      "29030": true
    }
  },
  "29034": {
    "CHIAPAS": {
      "29034": true
    }
  },
  "29037": {
    "CHIAPAS": {
      "29037": true
    }
  },
  "29038": {
    "CHIAPAS": {
      "29038": true
    }
  },
  "29039": {
    "CHIAPAS": {
      "29039": true
    }
  },
  "29040": {
    "CHIAPAS": {
      "29040": true
    }
  },
  "29043": {
    "CHIAPAS": {
      "29043": true
    }
  },
  "29044": {
    "CHIAPAS": {
      "29044": true
    }
  },
  "29045": {
    "CHIAPAS": {
      "29045": true
    }
  },
  "29047": {
    "CHIAPAS": {
      "29047": true
    }
  },
  "29049": {
    "CHIAPAS": {
      "29049": true
    }
  },
  "29050": {
    "CHIAPAS": {
      "29050": true
    }
  },
  "29054": {
    "CHIAPAS": {
      "29054": true
    }
  },
  "29055": {
    "CHIAPAS": {
      "29055": true
    }
  },
  "29056": {
    "CHIAPAS": {
      "29056": true
    }
  },
  "29057": {
    "CHIAPAS": {
      "29057": true
    }
  },
  "29058": {
    "CHIAPAS": {
      "29058": true
    }
  },
  "29059": {
    "CHIAPAS": {
      "29059": true
    }
  },
  "29060": {
    "CHIAPAS": {
      "29060": true
    }
  },
  "29064": {
    "CHIAPAS": {
      "29064": true
    }
  },
  "29065": {
    "CHIAPAS": {
      "29065": true
    }
  },
  "29066": {
    "CHIAPAS": {
      "29066": true
    }
  },
  "29067": {
    "CHIAPAS": {
      "29067": true
    }
  },
  "29070": {
    "CHIAPAS": {
      "29070": true
    }
  },
  "29073": {
    "CHIAPAS": {
      "29073": true
    }
  },
  "29075": {
    "CHIAPAS": {
      "29075": true
    }
  },
  "29076": {
    "CHIAPAS": {
      "29076": true
    }
  },
  "29077": {
    "CHIAPAS": {
      "29077": true
    }
  },
  "29078": {
    "CHIAPAS": {
      "29078": true
    }
  },
  "29079": {
    "CHIAPAS": {
      "29079": true
    }
  },
  "29080": {
    "CHIAPAS": {
      "29080": true
    }
  },
  "29086": {
    "CHIAPAS": {
      "29086": true
    }
  },
  "29087": {
    "CHIAPAS": {
      "29087": true
    }
  },
  "29089": {
    "CHIAPAS": {
      "29089": true
    }
  },
  "29090": {
    "CHIAPAS": {
      "29090": true
    }
  },
  "29094": {
    "CHIAPAS": {
      "29094": true
    }
  },
  "29096": {
    "CHIAPAS": {
      "29096": true
    }
  },
  "29098": {
    "CHIAPAS": {
      "29098": true
    }
  },
  "37000": {
    "GUANAJUATO": {
      "37000": true
    }
  },
  "37004": {
    "GUANAJUATO": {
      "37004": true
    }
  },
  "37010": {
    "GUANAJUATO": {
      "37010": true
    }
  },
  "37020": {
    "GUANAJUATO": {
      "37020": true
    }
  },
  "37100": {
    "GUANAJUATO": {
      "37100": true
    }
  },
  "37104": {
    "GUANAJUATO": {
      "37104": true
    }
  },
  "37105": {
    "GUANAJUATO": {
      "37105": true
    }
  },
  "37106": {
    "GUANAJUATO": {
      "37106": true
    }
  },
  "37107": {
    "GUANAJUATO": {
      "37107": true
    }
  },
  "37108": {
    "GUANAJUATO": {
      "37108": true
    }
  },
  "37109": {
    "GUANAJUATO": {
      "37109": true
    }
  },
  "37110": {
    "GUANAJUATO": {
      "37110": true
    }
  },
  "37118": {
    "GUANAJUATO": {
      "37118": true
    }
  },
  "37119": {
    "GUANAJUATO": {
      "37119": true
    }
  },
  "37120": {
    "GUANAJUATO": {
      "37120": true
    }
  },
  "37123": {
    "GUANAJUATO": {
      "37123": true
    }
  },
  "37125": {
    "GUANAJUATO": {
      "37125": true
    }
  },
  "37128": {
    "GUANAJUATO": {
      "37128": true
    }
  },
  "37129": {
    "GUANAJUATO": {
      "37129": true
    }
  },
  "37130": {
    "GUANAJUATO": {
      "37130": true
    }
  },
  "37134": {
    "GUANAJUATO": {
      "37134": true
    }
  },
  "37138": {
    "GUANAJUATO": {
      "37138": true
    }
  },
  "37140": {
    "GUANAJUATO": {
      "37140": true
    }
  },
  "37147": {
    "GUANAJUATO": {
      "37147": true
    }
  },
  "37148": {
    "GUANAJUATO": {
      "37148": true
    }
  },
  "37149": {
    "GUANAJUATO": {
      "37149": true
    }
  },
  "37150": {
    "GUANAJUATO": {
      "37150": true
    }
  },
  "37156": {
    "GUANAJUATO": {
      "37156": true
    }
  },
  "37157": {
    "GUANAJUATO": {
      "37157": true
    }
  },
  "37160": {
    "GUANAJUATO": {
      "37160": true
    }
  },
  "37168": {
    "GUANAJUATO": {
      "37168": true
    }
  },
  "37170": {
    "GUANAJUATO": {
      "37170": true
    }
  },
  "37178": {
    "GUANAJUATO": {
      "37178": true
    }
  },
  "37179": {
    "GUANAJUATO": {
      "37179": true
    }
  },
  "37180": {
    "GUANAJUATO": {
      "37180": true
    }
  },
  "37187": {
    "GUANAJUATO": {
      "37187": true
    }
  },
  "37188": {
    "GUANAJUATO": {
      "37188": true
    }
  },
  "37189": {
    "GUANAJUATO": {
      "37189": true
    }
  },
  "37190": {
    "GUANAJUATO": {
      "37190": true
    }
  },
  "37199": {
    "GUANAJUATO": {
      "37199": true
    }
  },
  "37200": {
    "GUANAJUATO": {
      "37200": true
    }
  },
  "37204": {
    "GUANAJUATO": {
      "37204": true
    }
  },
  "37205": {
    "GUANAJUATO": {
      "37205": true
    }
  },
  "37206": {
    "GUANAJUATO": {
      "37206": true
    }
  },
  "37207": {
    "GUANAJUATO": {
      "37207": true
    }
  },
  "37208": {
    "GUANAJUATO": {
      "37208": true
    }
  },
  "37209": {
    "GUANAJUATO": {
      "37209": true
    }
  },
  "37210": {
    "GUANAJUATO": {
      "37210": true
    }
  },
  "37217": {
    "GUANAJUATO": {
      "37217": true
    }
  },
  "37218": {
    "GUANAJUATO": {
      "37218": true
    }
  },
  "37219": {
    "GUANAJUATO": {
      "37219": true
    }
  },
  "37220": {
    "GUANAJUATO": {
      "37220": true
    }
  },
  "37225": {
    "GUANAJUATO": {
      "37225": true
    }
  },
  "37227": {
    "GUANAJUATO": {
      "37227": true
    }
  },
  "37230": {
    "GUANAJUATO": {
      "37230": true
    }
  },
  "37233": {
    "GUANAJUATO": {
      "37233": true
    }
  },
  "37234": {
    "GUANAJUATO": {
      "37234": true
    }
  },
  "37235": {
    "GUANAJUATO": {
      "37235": true
    }
  },
  "37236": {
    "GUANAJUATO": {
      "37236": true
    }
  },
  "37237": {
    "GUANAJUATO": {
      "37237": true
    }
  },
  "37238": {
    "GUANAJUATO": {
      "37238": true
    }
  },
  "37239": {
    "GUANAJUATO": {
      "37239": true
    }
  },
  "37240": {
    "GUANAJUATO": {
      "37240": true
    }
  },
  "37249": {
    "GUANAJUATO": {
      "37249": true
    }
  },
  "37250": {
    "GUANAJUATO": {
      "37250": true
    }
  },
  "37257": {
    "GUANAJUATO": {
      "37257": true
    }
  },
  "37258": {
    "GUANAJUATO": {
      "37258": true
    }
  },
  "37259": {
    "GUANAJUATO": {
      "37259": true
    }
  },
  "37260": {
    "GUANAJUATO": {
      "37260": true
    }
  },
  "37266": {
    "GUANAJUATO": {
      "37266": true
    }
  },
  "37267": {
    "GUANAJUATO": {
      "37267": true
    }
  },
  "37268": {
    "GUANAJUATO": {
      "37268": true
    }
  },
  "37269": {
    "GUANAJUATO": {
      "37269": true
    }
  },
  "37270": {
    "GUANAJUATO": {
      "37270": true
    }
  },
  "37276": {
    "GUANAJUATO": {
      "37276": true
    }
  },
  "37277": {
    "GUANAJUATO": {
      "37277": true
    }
  },
  "37278": {
    "GUANAJUATO": {
      "37278": true
    }
  },
  "37279": {
    "GUANAJUATO": {
      "37279": true
    }
  },
  "37280": {
    "GUANAJUATO": {
      "37280": true
    }
  },
  "37287": {
    "GUANAJUATO": {
      "37287": true
    }
  },
  "37288": {
    "GUANAJUATO": {
      "37288": true
    }
  },
  "37289": {
    "GUANAJUATO": {
      "37289": true
    }
  },
  "37290": {
    "GUANAJUATO": {
      "37290": true
    }
  },
  "37293": {
    "GUANAJUATO": {
      "37293": true
    }
  },
  "37294": {
    "GUANAJUATO": {
      "37294": true
    }
  },
  "37295": {
    "GUANAJUATO": {
      "37295": true
    }
  },
  "37296": {
    "GUANAJUATO": {
      "37296": true
    }
  },
  "37297": {
    "GUANAJUATO": {
      "37297": true
    }
  },
  "37298": {
    "GUANAJUATO": {
      "37298": true
    }
  },
  "37299": {
    "GUANAJUATO": {
      "37299": true
    }
  },
  "37300": {
    "GUANAJUATO": {
      "37300": true
    }
  },
  "37306": {
    "GUANAJUATO": {
      "37306": true
    }
  },
  "37310": {
    "GUANAJUATO": {
      "37310": true
    }
  },
  "37315": {
    "GUANAJUATO": {
      "37315": true
    }
  },
  "37316": {
    "GUANAJUATO": {
      "37316": true
    }
  },
  "37317": {
    "GUANAJUATO": {
      "37317": true
    }
  },
  "37318": {
    "GUANAJUATO": {
      "37318": true
    }
  },
  "37319": {
    "GUANAJUATO": {
      "37319": true
    }
  },
  "37320": {
    "GUANAJUATO": {
      "37320": true
    }
  },
  "37327": {
    "GUANAJUATO": {
      "37327": true
    }
  },
  "37328": {
    "GUANAJUATO": {
      "37328": true
    }
  },
  "37330": {
    "GUANAJUATO": {
      "37330": true
    }
  },
  "37340": {
    "GUANAJUATO": {
      "37340": true
    }
  },
  "37350": {
    "GUANAJUATO": {
      "37350": true
    }
  },
  "37353": {
    "GUANAJUATO": {
      "37353": true
    }
  },
  "37354": {
    "GUANAJUATO": {
      "37354": true
    }
  },
  "37355": {
    "GUANAJUATO": {
      "37355": true
    }
  },
  "37357": {
    "GUANAJUATO": {
      "37357": true
    }
  },
  "37358": {
    "GUANAJUATO": {
      "37358": true
    }
  },
  "37359": {
    "GUANAJUATO": {
      "37359": true
    }
  },
  "37360": {
    "GUANAJUATO": {
      "37360": true
    }
  },
  "37364": {
    "GUANAJUATO": {
      "37364": true
    }
  },
  "37366": {
    "GUANAJUATO": {
      "37366": true
    }
  },
  "37368": {
    "GUANAJUATO": {
      "37368": true
    }
  },
  "37369": {
    "GUANAJUATO": {
      "37369": true
    }
  },
  "37380": {
    "GUANAJUATO": {
      "37380": true
    }
  },
  "37390": {
    "GUANAJUATO": {
      "37390": true
    }
  },
  "37399": {
    "GUANAJUATO": {
      "37399": true
    }
  },
  "37400": {
    "GUANAJUATO": {
      "37400": true
    }
  },
  "37407": {
    "GUANAJUATO": {
      "37407": true
    }
  },
  "37410": {
    "GUANAJUATO": {
      "37410": true
    }
  },
  "37414": {
    "GUANAJUATO": {
      "37414": true
    }
  },
  "37415": {
    "GUANAJUATO": {
      "37415": true
    }
  },
  "37416": {
    "GUANAJUATO": {
      "37416": true
    }
  },
  "37417": {
    "GUANAJUATO": {
      "37417": true
    }
  },
  "37418": {
    "GUANAJUATO": {
      "37418": true
    }
  },
  "37419": {
    "GUANAJUATO": {
      "37419": true
    }
  },
  "37420": {
    "GUANAJUATO": {
      "37420": true
    }
  },
  "37425": {
    "GUANAJUATO": {
      "37425": true
    }
  },
  "37426": {
    "GUANAJUATO": {
      "37426": true
    }
  },
  "37427": {
    "GUANAJUATO": {
      "37427": true
    }
  },
  "37428": {
    "GUANAJUATO": {
      "37428": true
    }
  },
  "37430": {
    "GUANAJUATO": {
      "37430": true
    }
  },
  "37433": {
    "GUANAJUATO": {
      "37433": true
    }
  },
  "37434": {
    "GUANAJUATO": {
      "37434": true
    }
  },
  "37436": {
    "GUANAJUATO": {
      "37436": true
    }
  },
  "37438": {
    "GUANAJUATO": {
      "37438": true
    }
  },
  "37439": {
    "GUANAJUATO": {
      "37439": true
    }
  },
  "37440": {
    "GUANAJUATO": {
      "37440": true
    }
  },
  "37443": {
    "GUANAJUATO": {
      "37443": true
    }
  },
  "37444": {
    "GUANAJUATO": {
      "37444": true
    }
  },
  "37446": {
    "GUANAJUATO": {
      "37446": true
    }
  },
  "37448": {
    "GUANAJUATO": {
      "37448": true
    }
  },
  "37450": {
    "GUANAJUATO": {
      "37450": true
    }
  },
  "37455": {
    "GUANAJUATO": {
      "37455": true
    }
  },
  "37456": {
    "GUANAJUATO": {
      "37456": true
    }
  },
  "37457": {
    "GUANAJUATO": {
      "37457": true
    }
  },
  "37458": {
    "GUANAJUATO": {
      "37458": true
    }
  },
  "37459": {
    "GUANAJUATO": {
      "37459": true
    }
  },
  "37460": {
    "GUANAJUATO": {
      "37460": true
    }
  },
  "37468": {
    "GUANAJUATO": {
      "37468": true
    }
  },
  "37470": {
    "GUANAJUATO": {
      "37470": true
    }
  },
  "37477": {
    "GUANAJUATO": {
      "37477": true
    }
  },
  "37478": {
    "GUANAJUATO": {
      "37478": true
    }
  },
  "37479": {
    "GUANAJUATO": {
      "37479": true
    }
  },
  "37480": {
    "GUANAJUATO": {
      "37480": true
    }
  },
  "37487": {
    "GUANAJUATO": {
      "37487": true
    }
  },
  "37490": {
    "GUANAJUATO": {
      "37490": true
    }
  },
  "37499": {
    "GUANAJUATO": {
      "37499": true
    }
  },
  "37500": {
    "GUANAJUATO": {
      "37500": true
    }
  },
  "37510": {
    "GUANAJUATO": {
      "37510": true
    }
  },
  "37520": {
    "GUANAJUATO": {
      "37520": true
    }
  },
  "37526": {
    "GUANAJUATO": {
      "37526": true
    }
  },
  "37530": {
    "GUANAJUATO": {
      "37530": true
    }
  },
  "37536": {
    "GUANAJUATO": {
      "37536": true
    }
  },
  "37537": {
    "GUANAJUATO": {
      "37537": true
    }
  },
  "37538": {
    "GUANAJUATO": {
      "37538": true
    }
  },
  "37539": {
    "GUANAJUATO": {
      "37539": true
    }
  },
  "37544": {
    "GUANAJUATO": {
      "37544": true
    }
  },
  "37545": {
    "GUANAJUATO": {
      "37545": true
    }
  },
  "37547": {
    "GUANAJUATO": {
      "37547": true
    }
  },
  "37548": {
    "GUANAJUATO": {
      "37548": true
    }
  },
  "37549": {
    "GUANAJUATO": {
      "37549": true
    }
  },
  "37550": {
    "GUANAJUATO": {
      "37550": true
    }
  },
  "37555": {
    "GUANAJUATO": {
      "37555": true
    }
  },
  "37557": {
    "GUANAJUATO": {
      "37557": true
    }
  },
  "37560": {
    "GUANAJUATO": {
      "37560": true
    }
  },
  "37564": {
    "GUANAJUATO": {
      "37564": true
    }
  },
  "37566": {
    "GUANAJUATO": {
      "37566": true
    }
  },
  "37570": {
    "GUANAJUATO": {
      "37570": true
    }
  },
  "37580": {
    "GUANAJUATO": {
      "37580": true
    }
  },
  "37590": {
    "GUANAJUATO": {
      "37590": true
    }
  },
  "37669": {
    "GUANAJUATO": {
      "37669": true
    }
  },
  "37685": {
    "GUANAJUATO": {
      "37685": true
    }
  },
  "42000": {
    "HIDALGO": {
      "42000": true
    }
  },
  "42004": {
    "HIDALGO": {
      "42004": true
    }
  },
  "42010": {
    "HIDALGO": {
      "42010": true
    }
  },
  "42014": {
    "HIDALGO": {
      "42014": true
    }
  },
  "42015": {
    "HIDALGO": {
      "42015": true
    }
  },
  "42018": {
    "HIDALGO": {
      "42018": true
    }
  },
  "42020": {
    "HIDALGO": {
      "42020": true
    }
  },
  "42026": {
    "HIDALGO": {
      "42026": true
    }
  },
  "42027": {
    "HIDALGO": {
      "42027": true
    }
  },
  "42029": {
    "HIDALGO": {
      "42029": true
    }
  },
  "42030": {
    "HIDALGO": {
      "42030": true
    }
  },
  "42032": {
    "HIDALGO": {
      "42032": true
    }
  },
  "42033": {
    "HIDALGO": {
      "42033": true
    }
  },
  "42034": {
    "HIDALGO": {
      "42034": true
    }
  },
  "42035": {
    "HIDALGO": {
      "42035": true
    }
  },
  "42036": {
    "HIDALGO": {
      "42036": true
    }
  },
  "42037": {
    "HIDALGO": {
      "42037": true
    }
  },
  "42039": {
    "HIDALGO": {
      "42039": true
    }
  },
  "42040": {
    "HIDALGO": {
      "42040": true
    }
  },
  "42050": {
    "HIDALGO": {
      "42050": true
    }
  },
  "42055": {
    "HIDALGO": {
      "42055": true
    }
  },
  "42056": {
    "HIDALGO": {
      "42056": true
    }
  },
  "42057": {
    "HIDALGO": {
      "42057": true
    }
  },
  "42058": {
    "HIDALGO": {
      "42058": true
    }
  },
  "42060": {
    "HIDALGO": {
      "42060": true
    }
  },
  "42064": {
    "HIDALGO": {
      "42064": true
    }
  },
  "42070": {
    "HIDALGO": {
      "42070": true
    }
  },
  "42075": {
    "HIDALGO": {
      "42075": true
    }
  },
  "42078": {
    "HIDALGO": {
      "42078": true
    }
  },
  "42079": {
    "HIDALGO": {
      "42079": true
    }
  },
  "42080": {
    "HIDALGO": {
      "42080": true
    }
  },
  "42082": {
    "HIDALGO": {
      "42082": true
    }
  },
  "42083": {
    "HIDALGO": {
      "42083": true
    }
  },
  "42084": {
    "HIDALGO": {
      "42084": true
    }
  },
  "42086": {
    "HIDALGO": {
      "42086": true
    }
  },
  "42088": {
    "HIDALGO": {
      "42088": true
    }
  },
  "42090": {
    "HIDALGO": {
      "42090": true
    }
  },
  "42092": {
    "HIDALGO": {
      "42092": true
    }
  },
  "42094": {
    "HIDALGO": {
      "42094": true
    }
  },
  "42095": {
    "HIDALGO": {
      "42095": true
    }
  },
  "42097": {
    "HIDALGO": {
      "42097": true
    }
  },
  "42098": {
    "HIDALGO": {
      "42098": true
    }
  },
  "42099": {
    "HIDALGO": {
      "42099": true
    }
  },
  "42100": {
    "HIDALGO": {
      "42100": true
    }
  },
  "42101": {
    "HIDALGO": {
      "42101": true
    }
  },
  "42102": {
    "HIDALGO": {
      "42102": true
    }
  },
  "42110": {
    "HIDALGO": {
      "42110": true
    }
  },
  "42111": {
    "HIDALGO": {
      "42111": true
    }
  },
  "42113": {
    "HIDALGO": {
      "42113": true
    }
  },
  "42115": {
    "HIDALGO": {
      "42115": true
    }
  },
  "42116": {
    "HIDALGO": {
      "42116": true
    }
  },
  "42117": {
    "HIDALGO": {
      "42117": true
    }
  },
  "42119": {
    "HIDALGO": {
      "42119": true
    }
  },
  "42180": {
    "HIDALGO": {
      "42180": true
    }
  },
  "42181": {
    "HIDALGO": {
      "42181": true
    }
  },
  "42182": {
    "HIDALGO": {
      "42182": true
    }
  },
  "42183": {
    "HIDALGO": {
      "42183": true
    }
  },
  "42184": {
    "HIDALGO": {
      "42184": true
    }
  },
  "42185": {
    "HIDALGO": {
      "42185": true
    }
  },
  "42186": {
    "HIDALGO": {
      "42186": true
    }
  },
  "42187": {
    "HIDALGO": {
      "42187": true
    }
  },
  "42188": {
    "HIDALGO": {
      "42188": true
    }
  },
  "43840": {
    "HIDALGO": {
      "43840": true
    }
  },
  "43845": {
    "HIDALGO": {
      "43845": true
    }
  },
  "44100": {
    "JALISCO": {
      "44100": true
    }
  },
  "44101": {
    "JALISCO": {
      "44101": true
    }
  },
  "44104": {
    "JALISCO": {
      "44104": true
    }
  },
  "44105": {
    "JALISCO": {
      "44105": true
    }
  },
  "44106": {
    "JALISCO": {
      "44106": true
    }
  },
  "44107": {
    "JALISCO": {
      "44107": true
    }
  },
  "44108": {
    "JALISCO": {
      "44108": true
    }
  },
  "44109": {
    "JALISCO": {
      "44109": true
    }
  },
  "44110": {
    "JALISCO": {
      "44110": true
    }
  },
  "44111": {
    "JALISCO": {
      "44111": true
    }
  },
  "44116": {
    "JALISCO": {
      "44116": true
    }
  },
  "44118": {
    "JALISCO": {
      "44118": true
    }
  },
  "44119": {
    "JALISCO": {
      "44119": true
    }
  },
  "44120": {
    "JALISCO": {
      "44120": true
    }
  },
  "44125": {
    "JALISCO": {
      "44125": true
    }
  },
  "44126": {
    "JALISCO": {
      "44126": true
    }
  },
  "44128": {
    "JALISCO": {
      "44128": true
    }
  },
  "44129": {
    "JALISCO": {
      "44129": true
    }
  },
  "44130": {
    "JALISCO": {
      "44130": true
    }
  },
  "44132": {
    "JALISCO": {
      "44132": true
    }
  },
  "44133": {
    "JALISCO": {
      "44133": true
    }
  },
  "44135": {
    "JALISCO": {
      "44135": true
    }
  },
  "44136": {
    "JALISCO": {
      "44136": true
    }
  },
  "44138": {
    "JALISCO": {
      "44138": true
    }
  },
  "44140": {
    "JALISCO": {
      "44140": true
    }
  },
  "44142": {
    "JALISCO": {
      "44142": true
    }
  },
  "44144": {
    "JALISCO": {
      "44144": true
    }
  },
  "44145": {
    "JALISCO": {
      "44145": true
    }
  },
  "44146": {
    "JALISCO": {
      "44146": true
    }
  },
  "44149": {
    "JALISCO": {
      "44149": true
    }
  },
  "44150": {
    "JALISCO": {
      "44150": true
    }
  },
  "44151": {
    "JALISCO": {
      "44151": true
    }
  },
  "44156": {
    "JALISCO": {
      "44156": true
    }
  },
  "44158": {
    "JALISCO": {
      "44158": true
    }
  },
  "44159": {
    "JALISCO": {
      "44159": true
    }
  },
  "44160": {
    "JALISCO": {
      "44160": true
    }
  },
  "44161": {
    "JALISCO": {
      "44161": true
    }
  },
  "44162": {
    "JALISCO": {
      "44162": true
    }
  },
  "44164": {
    "JALISCO": {
      "44164": true
    }
  },
  "44165": {
    "JALISCO": {
      "44165": true
    }
  },
  "44166": {
    "JALISCO": {
      "44166": true
    }
  },
  "44169": {
    "JALISCO": {
      "44169": true
    }
  },
  "44170": {
    "JALISCO": {
      "44170": true
    }
  },
  "44171": {
    "JALISCO": {
      "44171": true
    }
  },
  "44176": {
    "JALISCO": {
      "44176": true
    }
  },
  "44179": {
    "JALISCO": {
      "44179": true
    }
  },
  "44180": {
    "JALISCO": {
      "44180": true
    }
  },
  "44181": {
    "JALISCO": {
      "44181": true
    }
  },
  "44185": {
    "JALISCO": {
      "44185": true
    }
  },
  "44188": {
    "JALISCO": {
      "44188": true
    }
  },
  "44189": {
    "JALISCO": {
      "44189": true
    }
  },
  "44190": {
    "JALISCO": {
      "44190": true
    }
  },
  "44191": {
    "JALISCO": {
      "44191": true
    }
  },
  "44192": {
    "JALISCO": {
      "44192": true
    }
  },
  "44195": {
    "JALISCO": {
      "44195": true
    }
  },
  "44196": {
    "JALISCO": {
      "44196": true
    }
  },
  "44198": {
    "JALISCO": {
      "44198": true
    }
  },
  "44199": {
    "JALISCO": {
      "44199": true
    }
  },
  "44200": {
    "JALISCO": {
      "44200": true
    }
  },
  "44205": {
    "JALISCO": {
      "44205": true
    }
  },
  "44208": {
    "JALISCO": {
      "44208": true
    }
  },
  "44210": {
    "JALISCO": {
      "44210": true
    }
  },
  "44214": {
    "JALISCO": {
      "44214": true
    }
  },
  "44215": {
    "JALISCO": {
      "44215": true
    }
  },
  "44216": {
    "JALISCO": {
      "44216": true
    }
  },
  "44217": {
    "JALISCO": {
      "44217": true
    }
  },
  "44218": {
    "JALISCO": {
      "44218": true
    }
  },
  "44219": {
    "JALISCO": {
      "44219": true
    }
  },
  "44220": {
    "JALISCO": {
      "44220": true
    }
  },
  "44221": {
    "JALISCO": {
      "44221": true
    }
  },
  "44226": {
    "JALISCO": {
      "44226": true
    }
  },
  "44227": {
    "JALISCO": {
      "44227": true
    }
  },
  "44228": {
    "JALISCO": {
      "44228": true
    }
  },
  "44229": {
    "JALISCO": {
      "44229": true
    }
  },
  "44230": {
    "JALISCO": {
      "44230": true
    }
  },
  "44233": {
    "JALISCO": {
      "44233": true
    }
  },
  "44235": {
    "JALISCO": {
      "44235": true
    }
  },
  "44236": {
    "JALISCO": {
      "44236": true
    }
  },
  "44238": {
    "JALISCO": {
      "44238": true
    }
  },
  "44239": {
    "JALISCO": {
      "44239": true
    }
  },
  "44240": {
    "JALISCO": {
      "44240": true
    }
  },
  "44241": {
    "JALISCO": {
      "44241": true
    }
  },
  "44246": {
    "JALISCO": {
      "44246": true
    }
  },
  "44247": {
    "JALISCO": {
      "44247": true
    }
  },
  "44248": {
    "JALISCO": {
      "44248": true
    }
  },
  "44249": {
    "JALISCO": {
      "44249": true
    }
  },
  "44250": {
    "JALISCO": {
      "44250": true
    }
  },
  "44257": {
    "JALISCO": {
      "44257": true
    }
  },
  "44258": {
    "JALISCO": {
      "44258": true
    }
  },
  "44259": {
    "JALISCO": {
      "44259": true
    }
  },
  "44260": {
    "JALISCO": {
      "44260": true
    }
  },
  "44261": {
    "JALISCO": {
      "44261": true
    }
  },
  "44265": {
    "JALISCO": {
      "44265": true
    }
  },
  "44266": {
    "JALISCO": {
      "44266": true
    }
  },
  "44267": {
    "JALISCO": {
      "44267": true
    }
  },
  "44268": {
    "JALISCO": {
      "44268": true
    }
  },
  "44269": {
    "JALISCO": {
      "44269": true
    }
  },
  "44270": {
    "JALISCO": {
      "44270": true
    }
  },
  "44271": {
    "JALISCO": {
      "44271": true
    }
  },
  "44275": {
    "JALISCO": {
      "44275": true
    }
  },
  "44277": {
    "JALISCO": {
      "44277": true
    }
  },
  "44278": {
    "JALISCO": {
      "44278": true
    }
  },
  "44280": {
    "JALISCO": {
      "44280": true
    }
  },
  "44281": {
    "JALISCO": {
      "44281": true
    }
  },
  "44282": {
    "JALISCO": {
      "44282": true
    }
  },
  "44286": {
    "JALISCO": {
      "44286": true
    }
  },
  "44288": {
    "JALISCO": {
      "44288": true
    }
  },
  "44289": {
    "JALISCO": {
      "44289": true
    }
  },
  "44290": {
    "JALISCO": {
      "44290": true
    }
  },
  "44291": {
    "JALISCO": {
      "44291": true
    }
  },
  "44292": {
    "JALISCO": {
      "44292": true
    }
  },
  "44293": {
    "JALISCO": {
      "44293": true
    }
  },
  "44296": {
    "JALISCO": {
      "44296": true
    }
  },
  "44297": {
    "JALISCO": {
      "44297": true
    }
  },
  "44298": {
    "JALISCO": {
      "44298": true
    }
  },
  "44299": {
    "JALISCO": {
      "44299": true
    }
  },
  "44300": {
    "JALISCO": {
      "44300": true
    }
  },
  "44301": {
    "JALISCO": {
      "44301": true
    }
  },
  "44304": {
    "JALISCO": {
      "44304": true
    }
  },
  "44306": {
    "JALISCO": {
      "44306": true
    }
  },
  "44307": {
    "JALISCO": {
      "44307": true
    }
  },
  "44308": {
    "JALISCO": {
      "44308": true
    }
  },
  "44309": {
    "JALISCO": {
      "44309": true
    }
  },
  "44310": {
    "JALISCO": {
      "44310": true
    }
  },
  "44319": {
    "JALISCO": {
      "44319": true
    }
  },
  "44320": {
    "JALISCO": {
      "44320": true
    }
  },
  "44329": {
    "JALISCO": {
      "44329": true
    }
  },
  "44330": {
    "JALISCO": {
      "44330": true
    }
  },
  "44332": {
    "JALISCO": {
      "44332": true
    }
  },
  "44334": {
    "JALISCO": {
      "44334": true
    }
  },
  "44339": {
    "JALISCO": {
      "44339": true
    }
  },
  "44340": {
    "JALISCO": {
      "44340": true
    }
  },
  "44344": {
    "JALISCO": {
      "44344": true
    }
  },
  "44348": {
    "JALISCO": {
      "44348": true
    }
  },
  "44349": {
    "JALISCO": {
      "44349": true
    }
  },
  "44350": {
    "JALISCO": {
      "44350": true
    }
  },
  "44359": {
    "JALISCO": {
      "44359": true
    }
  },
  "44360": {
    "JALISCO": {
      "44360": true
    }
  },
  "44362": {
    "JALISCO": {
      "44362": true
    }
  },
  "44363": {
    "JALISCO": {
      "44363": true
    }
  },
  "44366": {
    "JALISCO": {
      "44366": true
    }
  },
  "44367": {
    "JALISCO": {
      "44367": true
    }
  },
  "44368": {
    "JALISCO": {
      "44368": true
    }
  },
  "44369": {
    "JALISCO": {
      "44369": true
    }
  },
  "44370": {
    "JALISCO": {
      "44370": true
    }
  },
  "44377": {
    "JALISCO": {
      "44377": true
    }
  },
  "44379": {
    "JALISCO": {
      "44379": true
    }
  },
  "44380": {
    "JALISCO": {
      "44380": true
    }
  },
  "44381": {
    "JALISCO": {
      "44381": true
    }
  },
  "44382": {
    "JALISCO": {
      "44382": true
    }
  },
  "44386": {
    "JALISCO": {
      "44386": true
    }
  },
  "44390": {
    "JALISCO": {
      "44390": true
    }
  },
  "44394": {
    "JALISCO": {
      "44394": true
    }
  },
  "44395": {
    "JALISCO": {
      "44395": true
    }
  },
  "44396": {
    "JALISCO": {
      "44396": true
    }
  },
  "44398": {
    "JALISCO": {
      "44398": true
    }
  },
  "44399": {
    "JALISCO": {
      "44399": true
    }
  },
  "44400": {
    "JALISCO": {
      "44400": true
    }
  },
  "44404": {
    "JALISCO": {
      "44404": true
    }
  },
  "44405": {
    "JALISCO": {
      "44405": true
    }
  },
  "44408": {
    "JALISCO": {
      "44408": true
    }
  },
  "44409": {
    "JALISCO": {
      "44409": true
    }
  },
  "44410": {
    "JALISCO": {
      "44410": true
    }
  },
  "44415": {
    "JALISCO": {
      "44415": true
    }
  },
  "44416": {
    "JALISCO": {
      "44416": true
    }
  },
  "44418": {
    "JALISCO": {
      "44418": true
    }
  },
  "44419": {
    "JALISCO": {
      "44419": true
    }
  },
  "44420": {
    "JALISCO": {
      "44420": true
    }
  },
  "44421": {
    "JALISCO": {
      "44421": true
    }
  },
  "44429": {
    "JALISCO": {
      "44429": true
    }
  },
  "44430": {
    "JALISCO": {
      "44430": true
    }
  },
  "44432": {
    "JALISCO": {
      "44432": true
    }
  },
  "44434": {
    "JALISCO": {
      "44434": true
    }
  },
  "44436": {
    "JALISCO": {
      "44436": true
    }
  },
  "44437": {
    "JALISCO": {
      "44437": true
    }
  },
  "44438": {
    "JALISCO": {
      "44438": true
    }
  },
  "44439": {
    "JALISCO": {
      "44439": true
    }
  },
  "44440": {
    "JALISCO": {
      "44440": true
    }
  },
  "44444": {
    "JALISCO": {
      "44444": true
    }
  },
  "44446": {
    "JALISCO": {
      "44446": true
    }
  },
  "44447": {
    "JALISCO": {
      "44447": true
    }
  },
  "44449": {
    "JALISCO": {
      "44449": true
    }
  },
  "44450": {
    "JALISCO": {
      "44450": true
    }
  },
  "44455": {
    "JALISCO": {
      "44455": true
    }
  },
  "44459": {
    "JALISCO": {
      "44459": true
    }
  },
  "44460": {
    "JALISCO": {
      "44460": true
    }
  },
  "44462": {
    "JALISCO": {
      "44462": true
    }
  },
  "44466": {
    "JALISCO": {
      "44466": true
    }
  },
  "44467": {
    "JALISCO": {
      "44467": true
    }
  },
  "44468": {
    "JALISCO": {
      "44468": true
    }
  },
  "44469": {
    "JALISCO": {
      "44469": true
    }
  },
  "44470": {
    "JALISCO": {
      "44470": true
    }
  },
  "44471": {
    "JALISCO": {
      "44471": true
    }
  },
  "44473": {
    "JALISCO": {
      "44473": true
    }
  },
  "44478": {
    "JALISCO": {
      "44478": true
    }
  },
  "44480": {
    "JALISCO": {
      "44480": true
    }
  },
  "44483": {
    "JALISCO": {
      "44483": true
    }
  },
  "44487": {
    "JALISCO": {
      "44487": true
    }
  },
  "44489": {
    "JALISCO": {
      "44489": true
    }
  },
  "44490": {
    "JALISCO": {
      "44490": true
    }
  },
  "44491": {
    "JALISCO": {
      "44491": true
    }
  },
  "44492": {
    "JALISCO": {
      "44492": true
    }
  },
  "44493": {
    "JALISCO": {
      "44493": true
    }
  },
  "44496": {
    "JALISCO": {
      "44496": true
    }
  },
  "44497": {
    "JALISCO": {
      "44497": true
    }
  },
  "44499": {
    "JALISCO": {
      "44499": true
    }
  },
  "44500": {
    "JALISCO": {
      "44500": true
    }
  },
  "44501": {
    "JALISCO": {
      "44501": true
    }
  },
  "44503": {
    "JALISCO": {
      "44503": true
    }
  },
  "44504": {
    "JALISCO": {
      "44504": true
    }
  },
  "44505": {
    "JALISCO": {
      "44505": true
    }
  },
  "44506": {
    "JALISCO": {
      "44506": true
    }
  },
  "44508": {
    "JALISCO": {
      "44508": true
    }
  },
  "44509": {
    "JALISCO": {
      "44509": true
    }
  },
  "44510": {
    "JALISCO": {
      "44510": true
    }
  },
  "44514": {
    "JALISCO": {
      "44514": true
    }
  },
  "44517": {
    "JALISCO": {
      "44517": true
    }
  },
  "44519": {
    "JALISCO": {
      "44519": true
    }
  },
  "44520": {
    "JALISCO": {
      "44520": true
    }
  },
  "44522": {
    "JALISCO": {
      "44522": true
    }
  },
  "44523": {
    "JALISCO": {
      "44523": true
    }
  },
  "44524": {
    "JALISCO": {
      "44524": true
    }
  },
  "44525": {
    "JALISCO": {
      "44525": true
    }
  },
  "44528": {
    "JALISCO": {
      "44528": true
    }
  },
  "44529": {
    "JALISCO": {
      "44529": true
    }
  },
  "44530": {
    "JALISCO": {
      "44530": true
    }
  },
  "44531": {
    "JALISCO": {
      "44531": true
    }
  },
  "44532": {
    "JALISCO": {
      "44532": true
    }
  },
  "44533": {
    "JALISCO": {
      "44533": true
    }
  },
  "44534": {
    "JALISCO": {
      "44534": true
    }
  },
  "44535": {
    "JALISCO": {
      "44535": true
    }
  },
  "44536": {
    "JALISCO": {
      "44536": true
    }
  },
  "44537": {
    "JALISCO": {
      "44537": true
    }
  },
  "44538": {
    "JALISCO": {
      "44538": true
    }
  },
  "44539": {
    "JALISCO": {
      "44539": true
    }
  },
  "44540": {
    "JALISCO": {
      "44540": true
    }
  },
  "44541": {
    "JALISCO": {
      "44541": true
    }
  },
  "44543": {
    "JALISCO": {
      "44543": true
    }
  },
  "44546": {
    "JALISCO": {
      "44546": true
    }
  },
  "44548": {
    "JALISCO": {
      "44548": true
    }
  },
  "44549": {
    "JALISCO": {
      "44549": true
    }
  },
  "44550": {
    "JALISCO": {
      "44550": true
    }
  },
  "44552": {
    "JALISCO": {
      "44552": true
    }
  },
  "44555": {
    "JALISCO": {
      "44555": true
    }
  },
  "44556": {
    "JALISCO": {
      "44556": true
    }
  },
  "44557": {
    "JALISCO": {
      "44557": true
    }
  },
  "44558": {
    "JALISCO": {
      "44558": true
    }
  },
  "44559": {
    "JALISCO": {
      "44559": true
    }
  },
  "44560": {
    "JALISCO": {
      "44560": true
    }
  },
  "44563": {
    "JALISCO": {
      "44563": true
    }
  },
  "44565": {
    "JALISCO": {
      "44565": true
    }
  },
  "44566": {
    "JALISCO": {
      "44566": true
    }
  },
  "44567": {
    "JALISCO": {
      "44567": true
    }
  },
  "44569": {
    "JALISCO": {
      "44569": true
    }
  },
  "44570": {
    "JALISCO": {
      "44570": true
    }
  },
  "44575": {
    "JALISCO": {
      "44575": true
    }
  },
  "44580": {
    "JALISCO": {
      "44580": true
    }
  },
  "44588": {
    "JALISCO": {
      "44588": true
    }
  },
  "44589": {
    "JALISCO": {
      "44589": true
    }
  },
  "44590": {
    "JALISCO": {
      "44590": true
    }
  },
  "44597": {
    "JALISCO": {
      "44597": true
    }
  },
  "44599": {
    "JALISCO": {
      "44599": true
    }
  },
  "44600": {
    "JALISCO": {
      "44600": true
    }
  },
  "44601": {
    "JALISCO": {
      "44601": true
    }
  },
  "44602": {
    "JALISCO": {
      "44602": true
    }
  },
  "44603": {
    "JALISCO": {
      "44603": true
    }
  },
  "44605": {
    "JALISCO": {
      "44605": true
    }
  },
  "44606": {
    "JALISCO": {
      "44606": true
    }
  },
  "44607": {
    "JALISCO": {
      "44607": true
    }
  },
  "44608": {
    "JALISCO": {
      "44608": true
    }
  },
  "44609": {
    "JALISCO": {
      "44609": true
    }
  },
  "44610": {
    "JALISCO": {
      "44610": true
    }
  },
  "44611": {
    "JALISCO": {
      "44611": true
    }
  },
  "44612": {
    "JALISCO": {
      "44612": true
    }
  },
  "44615": {
    "JALISCO": {
      "44615": true
    }
  },
  "44616": {
    "JALISCO": {
      "44616": true
    }
  },
  "44619": {
    "JALISCO": {
      "44619": true
    }
  },
  "44620": {
    "JALISCO": {
      "44620": true
    }
  },
  "44622": {
    "JALISCO": {
      "44622": true
    }
  },
  "44626": {
    "JALISCO": {
      "44626": true
    }
  },
  "44629": {
    "JALISCO": {
      "44629": true
    }
  },
  "44630": {
    "JALISCO": {
      "44630": true
    }
  },
  "44631": {
    "JALISCO": {
      "44631": true
    }
  },
  "44632": {
    "JALISCO": {
      "44632": true
    }
  },
  "44633": {
    "JALISCO": {
      "44633": true
    }
  },
  "44634": {
    "JALISCO": {
      "44634": true
    }
  },
  "44635": {
    "JALISCO": {
      "44635": true
    }
  },
  "44636": {
    "JALISCO": {
      "44636": true
    }
  },
  "44637": {
    "JALISCO": {
      "44637": true
    }
  },
  "44638": {
    "JALISCO": {
      "44638": true
    }
  },
  "44639": {
    "JALISCO": {
      "44639": true
    }
  },
  "44640": {
    "JALISCO": {
      "44640": true
    }
  },
  "44642": {
    "JALISCO": {
      "44642": true
    }
  },
  "44643": {
    "JALISCO": {
      "44643": true
    }
  },
  "44645": {
    "JALISCO": {
      "44645": true
    }
  },
  "44646": {
    "JALISCO": {
      "44646": true
    }
  },
  "44647": {
    "JALISCO": {
      "44647": true
    }
  },
  "44648": {
    "JALISCO": {
      "44648": true
    }
  },
  "44649": {
    "JALISCO": {
      "44649": true
    }
  },
  "44650": {
    "JALISCO": {
      "44650": true
    }
  },
  "44651": {
    "JALISCO": {
      "44651": true
    }
  },
  "44652": {
    "JALISCO": {
      "44652": true
    }
  },
  "44654": {
    "JALISCO": {
      "44654": true
    }
  },
  "44655": {
    "JALISCO": {
      "44655": true
    }
  },
  "44656": {
    "JALISCO": {
      "44656": true
    }
  },
  "44657": {
    "JALISCO": {
      "44657": true
    }
  },
  "44658": {
    "JALISCO": {
      "44658": true
    }
  },
  "44659": {
    "JALISCO": {
      "44659": true
    }
  },
  "44660": {
    "JALISCO": {
      "44660": true
    }
  },
  "44662": {
    "JALISCO": {
      "44662": true
    }
  },
  "44663": {
    "JALISCO": {
      "44663": true
    }
  },
  "44664": {
    "JALISCO": {
      "44664": true
    }
  },
  "44665": {
    "JALISCO": {
      "44665": true
    }
  },
  "44666": {
    "JALISCO": {
      "44666": true
    }
  },
  "44667": {
    "JALISCO": {
      "44667": true
    }
  },
  "44668": {
    "JALISCO": {
      "44668": true
    }
  },
  "44669": {
    "JALISCO": {
      "44669": true
    }
  },
  "44670": {
    "JALISCO": {
      "44670": true
    }
  },
  "44673": {
    "JALISCO": {
      "44673": true
    }
  },
  "44675": {
    "JALISCO": {
      "44675": true
    }
  },
  "44676": {
    "JALISCO": {
      "44676": true
    }
  },
  "44678": {
    "JALISCO": {
      "44678": true
    }
  },
  "44679": {
    "JALISCO": {
      "44679": true
    }
  },
  "44680": {
    "JALISCO": {
      "44680": true
    }
  },
  "44681": {
    "JALISCO": {
      "44681": true
    }
  },
  "44683": {
    "JALISCO": {
      "44683": true
    }
  },
  "44684": {
    "JALISCO": {
      "44684": true
    }
  },
  "44685": {
    "JALISCO": {
      "44685": true
    }
  },
  "44686": {
    "JALISCO": {
      "44686": true
    }
  },
  "44687": {
    "JALISCO": {
      "44687": true
    }
  },
  "44688": {
    "JALISCO": {
      "44688": true
    }
  },
  "44689": {
    "JALISCO": {
      "44689": true
    }
  },
  "44690": {
    "JALISCO": {
      "44690": true
    }
  },
  "44691": {
    "JALISCO": {
      "44691": true
    }
  },
  "44692": {
    "JALISCO": {
      "44692": true
    }
  },
  "44695": {
    "JALISCO": {
      "44695": true
    }
  },
  "44696": {
    "JALISCO": {
      "44696": true
    }
  },
  "44697": {
    "JALISCO": {
      "44697": true
    }
  },
  "44698": {
    "JALISCO": {
      "44698": true
    }
  },
  "44699": {
    "JALISCO": {
      "44699": true
    }
  },
  "44700": {
    "JALISCO": {
      "44700": true
    }
  },
  "44701": {
    "JALISCO": {
      "44701": true
    }
  },
  "44705": {
    "JALISCO": {
      "44705": true
    }
  },
  "44706": {
    "JALISCO": {
      "44706": true
    }
  },
  "44709": {
    "JALISCO": {
      "44709": true
    }
  },
  "44710": {
    "JALISCO": {
      "44710": true
    }
  },
  "44713": {
    "JALISCO": {
      "44713": true
    }
  },
  "44714": {
    "JALISCO": {
      "44714": true
    }
  },
  "44715": {
    "JALISCO": {
      "44715": true
    }
  },
  "44716": {
    "JALISCO": {
      "44716": true
    }
  },
  "44717": {
    "JALISCO": {
      "44717": true
    }
  },
  "44718": {
    "JALISCO": {
      "44718": true
    }
  },
  "44719": {
    "JALISCO": {
      "44719": true
    }
  },
  "44720": {
    "JALISCO": {
      "44720": true
    }
  },
  "44721": {
    "JALISCO": {
      "44721": true
    }
  },
  "44723": {
    "JALISCO": {
      "44723": true
    }
  },
  "44724": {
    "JALISCO": {
      "44724": true
    }
  },
  "44725": {
    "JALISCO": {
      "44725": true
    }
  },
  "44726": {
    "JALISCO": {
      "44726": true
    }
  },
  "44727": {
    "JALISCO": {
      "44727": true
    }
  },
  "44728": {
    "JALISCO": {
      "44728": true
    }
  },
  "44729": {
    "JALISCO": {
      "44729": true
    }
  },
  "44730": {
    "JALISCO": {
      "44730": true
    }
  },
  "44731": {
    "JALISCO": {
      "44731": true
    }
  },
  "44735": {
    "JALISCO": {
      "44735": true
    }
  },
  "44736": {
    "JALISCO": {
      "44736": true
    }
  },
  "44737": {
    "JALISCO": {
      "44737": true
    }
  },
  "44739": {
    "JALISCO": {
      "44739": true
    }
  },
  "44740": {
    "JALISCO": {
      "44740": true
    }
  },
  "44742": {
    "JALISCO": {
      "44742": true
    }
  },
  "44748": {
    "JALISCO": {
      "44748": true
    }
  },
  "44749": {
    "JALISCO": {
      "44749": true
    }
  },
  "44750": {
    "JALISCO": {
      "44750": true
    }
  },
  "44755": {
    "JALISCO": {
      "44755": true
    }
  },
  "44756": {
    "JALISCO": {
      "44756": true
    }
  },
  "44757": {
    "JALISCO": {
      "44757": true
    }
  },
  "44758": {
    "JALISCO": {
      "44758": true
    }
  },
  "44760": {
    "JALISCO": {
      "44760": true
    }
  },
  "44761": {
    "JALISCO": {
      "44761": true
    }
  },
  "44763": {
    "JALISCO": {
      "44763": true
    }
  },
  "44765": {
    "JALISCO": {
      "44765": true
    }
  },
  "44766": {
    "JALISCO": {
      "44766": true
    }
  },
  "44767": {
    "JALISCO": {
      "44767": true
    }
  },
  "44768": {
    "JALISCO": {
      "44768": true
    }
  },
  "44769": {
    "JALISCO": {
      "44769": true
    }
  },
  "44770": {
    "JALISCO": {
      "44770": true
    }
  },
  "44776": {
    "JALISCO": {
      "44776": true
    }
  },
  "44777": {
    "JALISCO": {
      "44777": true
    }
  },
  "44780": {
    "JALISCO": {
      "44780": true
    }
  },
  "44789": {
    "JALISCO": {
      "44789": true
    }
  },
  "44790": {
    "JALISCO": {
      "44790": true
    }
  },
  "44799": {
    "JALISCO": {
      "44799": true
    }
  },
  "44800": {
    "JALISCO": {
      "44800": true
    }
  },
  "44801": {
    "JALISCO": {
      "44801": true
    }
  },
  "44807": {
    "JALISCO": {
      "44807": true
    }
  },
  "44808": {
    "JALISCO": {
      "44808": true
    }
  },
  "44809": {
    "JALISCO": {
      "44809": true
    }
  },
  "44810": {
    "JALISCO": {
      "44810": true
    }
  },
  "44814": {
    "JALISCO": {
      "44814": true
    }
  },
  "44815": {
    "JALISCO": {
      "44815": true
    }
  },
  "44816": {
    "JALISCO": {
      "44816": true
    }
  },
  "44817": {
    "JALISCO": {
      "44817": true
    }
  },
  "44818": {
    "JALISCO": {
      "44818": true
    }
  },
  "44819": {
    "JALISCO": {
      "44819": true
    }
  },
  "44820": {
    "JALISCO": {
      "44820": true
    }
  },
  "44821": {
    "JALISCO": {
      "44821": true
    }
  },
  "44824": {
    "JALISCO": {
      "44824": true
    }
  },
  "44825": {
    "JALISCO": {
      "44825": true
    }
  },
  "44826": {
    "JALISCO": {
      "44826": true
    }
  },
  "44827": {
    "JALISCO": {
      "44827": true
    }
  },
  "44828": {
    "JALISCO": {
      "44828": true
    }
  },
  "44829": {
    "JALISCO": {
      "44829": true
    }
  },
  "44830": {
    "JALISCO": {
      "44830": true
    }
  },
  "44837": {
    "JALISCO": {
      "44837": true
    }
  },
  "44840": {
    "JALISCO": {
      "44840": true
    }
  },
  "44844": {
    "JALISCO": {
      "44844": true
    }
  },
  "44848": {
    "JALISCO": {
      "44848": true
    }
  },
  "44849": {
    "JALISCO": {
      "44849": true
    }
  },
  "44850": {
    "JALISCO": {
      "44850": true
    }
  },
  "44860": {
    "JALISCO": {
      "44860": true
    }
  },
  "44869": {
    "JALISCO": {
      "44869": true
    }
  },
  "44870": {
    "JALISCO": {
      "44870": true
    }
  },
  "44876": {
    "JALISCO": {
      "44876": true
    }
  },
  "44878": {
    "JALISCO": {
      "44878": true
    }
  },
  "44879": {
    "JALISCO": {
      "44879": true
    }
  },
  "44880": {
    "JALISCO": {
      "44880": true
    }
  },
  "44885": {
    "JALISCO": {
      "44885": true
    }
  },
  "44890": {
    "JALISCO": {
      "44890": true
    }
  },
  "44891": {
    "JALISCO": {
      "44891": true
    }
  },
  "44893": {
    "JALISCO": {
      "44893": true
    }
  },
  "44895": {
    "JALISCO": {
      "44895": true
    }
  },
  "44896": {
    "JALISCO": {
      "44896": true
    }
  },
  "44897": {
    "JALISCO": {
      "44897": true
    }
  },
  "44898": {
    "JALISCO": {
      "44898": true
    }
  },
  "44899": {
    "JALISCO": {
      "44899": true
    }
  },
  "44900": {
    "JALISCO": {
      "44900": true
    }
  },
  "44901": {
    "JALISCO": {
      "44901": true
    }
  },
  "44902": {
    "JALISCO": {
      "44902": true
    }
  },
  "44904": {
    "JALISCO": {
      "44904": true
    }
  },
  "44906": {
    "JALISCO": {
      "44906": true
    }
  },
  "44907": {
    "JALISCO": {
      "44907": true
    }
  },
  "44908": {
    "JALISCO": {
      "44908": true
    }
  },
  "44909": {
    "JALISCO": {
      "44909": true
    }
  },
  "44910": {
    "JALISCO": {
      "44910": true
    }
  },
  "44911": {
    "JALISCO": {
      "44911": true
    }
  },
  "44915": {
    "JALISCO": {
      "44915": true
    }
  },
  "44918": {
    "JALISCO": {
      "44918": true
    }
  },
  "44919": {
    "JALISCO": {
      "44919": true
    }
  },
  "44920": {
    "JALISCO": {
      "44920": true
    }
  },
  "44921": {
    "JALISCO": {
      "44921": true
    }
  },
  "44926": {
    "JALISCO": {
      "44926": true
    }
  },
  "44929": {
    "JALISCO": {
      "44929": true
    }
  },
  "44930": {
    "JALISCO": {
      "44930": true
    }
  },
  "44940": {
    "JALISCO": {
      "44940": true
    }
  },
  "44941": {
    "JALISCO": {
      "44941": true
    }
  },
  "44943": {
    "JALISCO": {
      "44943": true
    }
  },
  "44944": {
    "JALISCO": {
      "44944": true
    }
  },
  "44945": {
    "JALISCO": {
      "44945": true
    }
  },
  "44946": {
    "JALISCO": {
      "44946": true
    }
  },
  "44947": {
    "JALISCO": {
      "44947": true
    }
  },
  "44948": {
    "JALISCO": {
      "44948": true
    }
  },
  "44949": {
    "JALISCO": {
      "44949": true
    }
  },
  "44950": {
    "JALISCO": {
      "44950": true
    }
  },
  "44954": {
    "JALISCO": {
      "44954": true
    }
  },
  "44955": {
    "JALISCO": {
      "44955": true
    }
  },
  "44956": {
    "JALISCO": {
      "44956": true
    }
  },
  "44957": {
    "JALISCO": {
      "44957": true
    }
  },
  "44958": {
    "JALISCO": {
      "44958": true
    }
  },
  "44959": {
    "JALISCO": {
      "44959": true
    }
  },
  "44960": {
    "JALISCO": {
      "44960": true
    }
  },
  "44964": {
    "JALISCO": {
      "44964": true
    }
  },
  "44965": {
    "JALISCO": {
      "44965": true
    }
  },
  "44966": {
    "JALISCO": {
      "44966": true
    }
  },
  "44967": {
    "JALISCO": {
      "44967": true
    }
  },
  "44968": {
    "JALISCO": {
      "44968": true
    }
  },
  "44969": {
    "JALISCO": {
      "44969": true
    }
  },
  "44970": {
    "JALISCO": {
      "44970": true
    }
  },
  "44971": {
    "JALISCO": {
      "44971": true
    }
  },
  "44974": {
    "JALISCO": {
      "44974": true
    }
  },
  "44977": {
    "JALISCO": {
      "44977": true
    }
  },
  "44978": {
    "JALISCO": {
      "44978": true
    }
  },
  "44979": {
    "JALISCO": {
      "44979": true
    }
  },
  "44980": {
    "JALISCO": {
      "44980": true
    }
  },
  "44981": {
    "JALISCO": {
      "44981": true
    }
  },
  "44982": {
    "JALISCO": {
      "44982": true
    }
  },
  "44983": {
    "JALISCO": {
      "44983": true
    }
  },
  "44984": {
    "JALISCO": {
      "44984": true
    }
  },
  "44985": {
    "JALISCO": {
      "44985": true
    }
  },
  "44986": {
    "JALISCO": {
      "44986": true
    }
  },
  "44987": {
    "JALISCO": {
      "44987": true
    }
  },
  "44988": {
    "JALISCO": {
      "44988": true
    }
  },
  "44989": {
    "JALISCO": {
      "44989": true
    }
  },
  "44990": {
    "JALISCO": {
      "44990": true
    }
  },
  "45000": {
    "JALISCO": {
      "45000": true
    }
  },
  "45010": {
    "JALISCO": {
      "45010": true
    }
  },
  "45011": {
    "JALISCO": {
      "45011": true
    }
  },
  "45012": {
    "JALISCO": {
      "45012": true
    }
  },
  "45013": {
    "JALISCO": {
      "45013": true
    }
  },
  "45014": {
    "JALISCO": {
      "45014": true
    }
  },
  "45015": {
    "JALISCO": {
      "45015": true
    }
  },
  "45016": {
    "JALISCO": {
      "45016": true
    }
  },
  "45017": {
    "JALISCO": {
      "45017": true
    }
  },
  "45018": {
    "JALISCO": {
      "45018": true
    }
  },
  "45019": {
    "JALISCO": {
      "45019": true
    }
  },
  "45020": {
    "JALISCO": {
      "45020": true
    }
  },
  "45021": {
    "JALISCO": {
      "45021": true
    }
  },
  "45022": {
    "JALISCO": {
      "45022": true
    }
  },
  "45024": {
    "JALISCO": {
      "45024": true
    }
  },
  "45025": {
    "JALISCO": {
      "45025": true
    }
  },
  "45026": {
    "JALISCO": {
      "45026": true
    }
  },
  "45027": {
    "JALISCO": {
      "45027": true
    }
  },
  "45028": {
    "JALISCO": {
      "45028": true
    }
  },
  "45029": {
    "JALISCO": {
      "45029": true
    }
  },
  "45030": {
    "JALISCO": {
      "45030": true
    }
  },
  "45031": {
    "JALISCO": {
      "45031": true
    }
  },
  "45032": {
    "JALISCO": {
      "45032": true
    }
  },
  "45033": {
    "JALISCO": {
      "45033": true
    }
  },
  "45034": {
    "JALISCO": {
      "45034": true
    }
  },
  "45035": {
    "JALISCO": {
      "45035": true
    }
  },
  "45036": {
    "JALISCO": {
      "45036": true
    }
  },
  "45037": {
    "JALISCO": {
      "45037": true
    }
  },
  "45038": {
    "JALISCO": {
      "45038": true
    }
  },
  "45039": {
    "JALISCO": {
      "45039": true
    }
  },
  "45040": {
    "JALISCO": {
      "45040": true
    }
  },
  "45041": {
    "JALISCO": {
      "45041": true
    }
  },
  "45042": {
    "JALISCO": {
      "45042": true
    }
  },
  "45043": {
    "JALISCO": {
      "45043": true
    }
  },
  "45044": {
    "JALISCO": {
      "45044": true
    }
  },
  "45045": {
    "JALISCO": {
      "45045": true
    }
  },
  "45046": {
    "JALISCO": {
      "45046": true
    }
  },
  "45047": {
    "JALISCO": {
      "45047": true
    }
  },
  "45048": {
    "JALISCO": {
      "45048": true
    }
  },
  "45049": {
    "JALISCO": {
      "45049": true
    }
  },
  "45050": {
    "JALISCO": {
      "45050": true
    }
  },
  "45051": {
    "JALISCO": {
      "45051": true
    }
  },
  "45052": {
    "JALISCO": {
      "45052": true
    }
  },
  "45053": {
    "JALISCO": {
      "45053": true
    }
  },
  "45054": {
    "JALISCO": {
      "45054": true
    }
  },
  "45055": {
    "JALISCO": {
      "45055": true
    }
  },
  "45056": {
    "JALISCO": {
      "45056": true
    }
  },
  "45057": {
    "JALISCO": {
      "45057": true
    }
  },
  "45058": {
    "JALISCO": {
      "45058": true
    }
  },
  "45059": {
    "JALISCO": {
      "45059": true
    }
  },
  "45060": {
    "JALISCO": {
      "45060": true
    }
  },
  "45061": {
    "JALISCO": {
      "45061": true
    }
  },
  "45062": {
    "JALISCO": {
      "45062": true
    }
  },
  "45063": {
    "JALISCO": {
      "45063": true
    }
  },
  "45064": {
    "JALISCO": {
      "45064": true
    }
  },
  "45065": {
    "JALISCO": {
      "45065": true
    }
  },
  "45066": {
    "JALISCO": {
      "45066": true
    }
  },
  "45067": {
    "JALISCO": {
      "45067": true
    }
  },
  "45068": {
    "JALISCO": {
      "45068": true
    }
  },
  "45069": {
    "JALISCO": {
      "45069": true
    }
  },
  "45070": {
    "JALISCO": {
      "45070": true
    }
  },
  "45071": {
    "JALISCO": {
      "45071": true
    }
  },
  "45072": {
    "JALISCO": {
      "45072": true
    }
  },
  "45074": {
    "JALISCO": {
      "45074": true
    }
  },
  "45075": {
    "JALISCO": {
      "45075": true
    }
  },
  "45076": {
    "JALISCO": {
      "45076": true
    }
  },
  "45077": {
    "JALISCO": {
      "45077": true
    }
  },
  "45078": {
    "JALISCO": {
      "45078": true
    }
  },
  "45079": {
    "JALISCO": {
      "45079": true
    }
  },
  "45080": {
    "JALISCO": {
      "45080": true
    }
  },
  "45081": {
    "JALISCO": {
      "45081": true
    }
  },
  "45082": {
    "JALISCO": {
      "45082": true
    }
  },
  "45083": {
    "JALISCO": {
      "45083": true
    }
  },
  "45084": {
    "JALISCO": {
      "45084": true
    }
  },
  "45085": {
    "JALISCO": {
      "45085": true
    }
  },
  "45086": {
    "JALISCO": {
      "45086": true
    }
  },
  "45087": {
    "JALISCO": {
      "45087": true
    }
  },
  "45088": {
    "JALISCO": {
      "45088": true
    }
  },
  "45089": {
    "JALISCO": {
      "45089": true
    }
  },
  "45090": {
    "JALISCO": {
      "45090": true
    }
  },
  "45091": {
    "JALISCO": {
      "45091": true
    }
  },
  "45093": {
    "JALISCO": {
      "45093": true
    }
  },
  "45094": {
    "JALISCO": {
      "45094": true
    }
  },
  "45095": {
    "JALISCO": {
      "45095": true
    }
  },
  "45098": {
    "JALISCO": {
      "45098": true
    }
  },
  "45099": {
    "JALISCO": {
      "45099": true
    }
  },
  "45100": {
    "JALISCO": {
      "45100": true
    }
  },
  "45101": {
    "JALISCO": {
      "45101": true
    }
  },
  "45103": {
    "JALISCO": {
      "45103": true
    }
  },
  "45104": {
    "JALISCO": {
      "45104": true
    }
  },
  "45105": {
    "JALISCO": {
      "45105": true
    }
  },
  "45106": {
    "JALISCO": {
      "45106": true
    }
  },
  "45107": {
    "JALISCO": {
      "45107": true
    }
  },
  "45108": {
    "JALISCO": {
      "45108": true
    }
  },
  "45109": {
    "JALISCO": {
      "45109": true
    }
  },
  "45110": {
    "JALISCO": {
      "45110": true
    }
  },
  "45111": {
    "JALISCO": {
      "45111": true
    }
  },
  "45113": {
    "JALISCO": {
      "45113": true
    }
  },
  "45115": {
    "JALISCO": {
      "45115": true
    }
  },
  "45116": {
    "JALISCO": {
      "45116": true
    }
  },
  "45117": {
    "JALISCO": {
      "45117": true
    }
  },
  "45118": {
    "JALISCO": {
      "45118": true
    }
  },
  "45119": {
    "JALISCO": {
      "45119": true
    }
  },
  "45120": {
    "JALISCO": {
      "45120": true
    }
  },
  "45121": {
    "JALISCO": {
      "45121": true
    }
  },
  "45123": {
    "JALISCO": {
      "45123": true
    }
  },
  "45124": {
    "JALISCO": {
      "45124": true
    }
  },
  "45125": {
    "JALISCO": {
      "45125": true
    }
  },
  "45126": {
    "JALISCO": {
      "45126": true
    }
  },
  "45127": {
    "JALISCO": {
      "45127": true
    }
  },
  "45128": {
    "JALISCO": {
      "45128": true
    }
  },
  "45129": {
    "JALISCO": {
      "45129": true
    }
  },
  "45130": {
    "JALISCO": {
      "45130": true
    }
  },
  "45131": {
    "JALISCO": {
      "45131": true
    }
  },
  "45132": {
    "JALISCO": {
      "45132": true
    }
  },
  "45133": {
    "JALISCO": {
      "45133": true
    }
  },
  "45134": {
    "JALISCO": {
      "45134": true
    }
  },
  "45135": {
    "JALISCO": {
      "45135": true
    }
  },
  "45136": {
    "JALISCO": {
      "45136": true
    }
  },
  "45137": {
    "JALISCO": {
      "45137": true
    }
  },
  "45138": {
    "JALISCO": {
      "45138": true
    }
  },
  "45139": {
    "JALISCO": {
      "45139": true
    }
  },
  "45140": {
    "JALISCO": {
      "45140": true
    }
  },
  "45141": {
    "JALISCO": {
      "45141": true
    }
  },
  "45145": {
    "JALISCO": {
      "45145": true
    }
  },
  "45146": {
    "JALISCO": {
      "45146": true
    }
  },
  "45147": {
    "JALISCO": {
      "45147": true
    }
  },
  "45148": {
    "JALISCO": {
      "45148": true
    }
  },
  "45149": {
    "JALISCO": {
      "45149": true
    }
  },
  "45150": {
    "JALISCO": {
      "45150": true
    }
  },
  "45151": {
    "JALISCO": {
      "45151": true
    }
  },
  "45152": {
    "JALISCO": {
      "45152": true
    }
  },
  "45154": {
    "JALISCO": {
      "45154": true
    }
  },
  "45155": {
    "JALISCO": {
      "45155": true
    }
  },
  "45156": {
    "JALISCO": {
      "45156": true
    }
  },
  "45157": {
    "JALISCO": {
      "45157": true
    }
  },
  "45158": {
    "JALISCO": {
      "45158": true
    }
  },
  "45159": {
    "JALISCO": {
      "45159": true
    }
  },
  "45160": {
    "JALISCO": {
      "45160": true
    }
  },
  "45161": {
    "JALISCO": {
      "45161": true
    }
  },
  "45162": {
    "JALISCO": {
      "45162": true
    }
  },
  "45163": {
    "JALISCO": {
      "45163": true
    }
  },
  "45165": {
    "JALISCO": {
      "45165": true
    }
  },
  "45166": {
    "JALISCO": {
      "45166": true
    }
  },
  "45167": {
    "JALISCO": {
      "45167": true
    }
  },
  "45168": {
    "JALISCO": {
      "45168": true
    }
  },
  "45169": {
    "JALISCO": {
      "45169": true
    }
  },
  "45170": {
    "JALISCO": {
      "45170": true
    }
  },
  "45171": {
    "JALISCO": {
      "45171": true
    }
  },
  "45173": {
    "JALISCO": {
      "45173": true
    }
  },
  "45176": {
    "JALISCO": {
      "45176": true
    }
  },
  "45177": {
    "JALISCO": {
      "45177": true
    }
  },
  "45178": {
    "JALISCO": {
      "45178": true
    }
  },
  "45179": {
    "JALISCO": {
      "45179": true
    }
  },
  "45180": {
    "JALISCO": {
      "45180": true
    }
  },
  "45181": {
    "JALISCO": {
      "45181": true
    }
  },
  "45182": {
    "JALISCO": {
      "45182": true
    }
  },
  "45183": {
    "JALISCO": {
      "45183": true
    }
  },
  "45184": {
    "JALISCO": {
      "45184": true
    }
  },
  "45185": {
    "JALISCO": {
      "45185": true
    }
  },
  "45186": {
    "JALISCO": {
      "45186": true
    }
  },
  "45187": {
    "JALISCO": {
      "45187": true
    }
  },
  "45188": {
    "JALISCO": {
      "45188": true
    }
  },
  "45189": {
    "JALISCO": {
      "45189": true
    }
  },
  "45190": {
    "JALISCO": {
      "45190": true
    }
  },
  "45191": {
    "JALISCO": {
      "45191": true
    }
  },
  "45192": {
    "JALISCO": {
      "45192": true
    }
  },
  "45194": {
    "JALISCO": {
      "45194": true
    }
  },
  "45195": {
    "JALISCO": {
      "45195": true
    }
  },
  "45196": {
    "JALISCO": {
      "45196": true
    }
  },
  "45197": {
    "JALISCO": {
      "45197": true
    }
  },
  "45198": {
    "JALISCO": {
      "45198": true
    }
  },
  "45199": {
    "JALISCO": {
      "45199": true
    }
  },
  "45200": {
    "JALISCO": {
      "45200": true
    }
  },
  "45201": {
    "JALISCO": {
      "45201": true
    }
  },
  "45202": {
    "JALISCO": {
      "45202": true
    }
  },
  "45203": {
    "JALISCO": {
      "45203": true
    }
  },
  "45204": {
    "JALISCO": {
      "45204": true
    }
  },
  "45205": {
    "JALISCO": {
      "45205": true
    }
  },
  "45206": {
    "JALISCO": {
      "45206": true
    }
  },
  "45207": {
    "JALISCO": {
      "45207": true
    }
  },
  "45208": {
    "JALISCO": {
      "45208": true
    }
  },
  "45209": {
    "JALISCO": {
      "45209": true
    }
  },
  "45210": {
    "JALISCO": {
      "45210": true
    }
  },
  "45211": {
    "JALISCO": {
      "45211": true
    }
  },
  "45212": {
    "JALISCO": {
      "45212": true
    }
  },
  "45213": {
    "JALISCO": {
      "45213": true
    }
  },
  "45215": {
    "JALISCO": {
      "45215": true
    }
  },
  "45216": {
    "JALISCO": {
      "45216": true
    }
  },
  "45217": {
    "JALISCO": {
      "45217": true
    }
  },
  "45218": {
    "JALISCO": {
      "45218": true
    }
  },
  "45219": {
    "JALISCO": {
      "45219": true
    }
  },
  "45220": {
    "JALISCO": {
      "45220": true
    }
  },
  "45221": {
    "JALISCO": {
      "45221": true
    }
  },
  "45222": {
    "JALISCO": {
      "45222": true
    }
  },
  "45225": {
    "JALISCO": {
      "45225": true
    }
  },
  "45226": {
    "JALISCO": {
      "45226": true
    }
  },
  "45227": {
    "JALISCO": {
      "45227": true
    }
  },
  "45229": {
    "JALISCO": {
      "45229": true
    }
  },
  "45230": {
    "JALISCO": {
      "45230": true
    }
  },
  "45231": {
    "JALISCO": {
      "45231": true
    }
  },
  "45232": {
    "JALISCO": {
      "45232": true
    }
  },
  "45233": {
    "JALISCO": {
      "45233": true
    }
  },
  "45234": {
    "JALISCO": {
      "45234": true
    }
  },
  "45235": {
    "JALISCO": {
      "45235": true
    }
  },
  "45236": {
    "JALISCO": {
      "45236": true
    }
  },
  "45237": {
    "JALISCO": {
      "45237": true
    }
  },
  "45238": {
    "JALISCO": {
      "45238": true
    }
  },
  "45239": {
    "JALISCO": {
      "45239": true
    }
  },
  "45242": {
    "JALISCO": {
      "45242": true
    }
  },
  "45245": {
    "JALISCO": {
      "45245": true
    }
  },
  "45350": {
    "JALISCO": {
      "45350": true
    }
  },
  "45380": {
    "JALISCO": {
      "45380": true
    }
  },
  "45420": {
    "JALISCO": {
      "45420": true
    }
  },
  "45470": {
    "JALISCO": {
      "45470": true
    }
  },
  "45500": {
    "JALISCO": {
      "45500": true
    }
  },
  "45501": {
    "JALISCO": {
      "45501": true
    }
  },
  "45502": {
    "JALISCO": {
      "45502": true
    }
  },
  "45503": {
    "JALISCO": {
      "45503": true
    }
  },
  "45505": {
    "JALISCO": {
      "45505": true
    }
  },
  "45506": {
    "JALISCO": {
      "45506": true
    }
  },
  "45509": {
    "JALISCO": {
      "45509": true
    }
  },
  "45510": {
    "JALISCO": {
      "45510": true
    }
  },
  "45515": {
    "JALISCO": {
      "45515": true
    }
  },
  "45516": {
    "JALISCO": {
      "45516": true
    }
  },
  "45519": {
    "JALISCO": {
      "45519": true
    }
  },
  "45520": {
    "JALISCO": {
      "45520": true
    }
  },
  "45521": {
    "JALISCO": {
      "45521": true
    }
  },
  "45525": {
    "JALISCO": {
      "45525": true
    }
  },
  "45526": {
    "JALISCO": {
      "45526": true
    }
  },
  "45527": {
    "JALISCO": {
      "45527": true
    }
  },
  "45528": {
    "JALISCO": {
      "45528": true
    }
  },
  "45529": {
    "JALISCO": {
      "45529": true
    }
  },
  "45530": {
    "JALISCO": {
      "45530": true
    }
  },
  "45531": {
    "JALISCO": {
      "45531": true
    }
  },
  "45532": {
    "JALISCO": {
      "45532": true
    }
  },
  "45534": {
    "JALISCO": {
      "45534": true
    }
  },
  "45535": {
    "JALISCO": {
      "45535": true
    }
  },
  "45536": {
    "JALISCO": {
      "45536": true
    }
  },
  "45540": {
    "JALISCO": {
      "45540": true
    }
  },
  "45542": {
    "JALISCO": {
      "45542": true
    }
  },
  "45543": {
    "JALISCO": {
      "45543": true
    }
  },
  "45544": {
    "JALISCO": {
      "45544": true
    }
  },
  "45545": {
    "JALISCO": {
      "45545": true
    }
  },
  "45550": {
    "JALISCO": {
      "45550": true
    }
  },
  "45555": {
    "JALISCO": {
      "45555": true
    }
  },
  "45556": {
    "JALISCO": {
      "45556": true
    }
  },
  "45559": {
    "JALISCO": {
      "45559": true
    }
  },
  "45560": {
    "JALISCO": {
      "45560": true
    }
  },
  "45561": {
    "JALISCO": {
      "45561": true
    }
  },
  "45567": {
    "JALISCO": {
      "45567": true
    }
  },
  "45568": {
    "JALISCO": {
      "45568": true
    }
  },
  "45569": {
    "JALISCO": {
      "45569": true
    }
  },
  "45570": {
    "JALISCO": {
      "45570": true
    }
  },
  "45578": {
    "JALISCO": {
      "45578": true
    }
  },
  "45579": {
    "JALISCO": {
      "45579": true
    }
  },
  "45580": {
    "JALISCO": {
      "45580": true
    }
  },
  "45581": {
    "JALISCO": {
      "45581": true
    }
  },
  "45582": {
    "JALISCO": {
      "45582": true
    }
  },
  "45583": {
    "JALISCO": {
      "45583": true
    }
  },
  "45584": {
    "JALISCO": {
      "45584": true
    }
  },
  "45585": {
    "JALISCO": {
      "45585": true
    }
  },
  "45588": {
    "JALISCO": {
      "45588": true
    }
  },
  "45589": {
    "JALISCO": {
      "45589": true
    }
  },
  "45590": {
    "JALISCO": {
      "45590": true
    }
  },
  "45591": {
    "JALISCO": {
      "45591": true
    }
  },
  "45592": {
    "JALISCO": {
      "45592": true
    }
  },
  "45593": {
    "JALISCO": {
      "45593": true
    }
  },
  "45594": {
    "JALISCO": {
      "45594": true
    }
  },
  "45595": {
    "JALISCO": {
      "45595": true
    }
  },
  "45596": {
    "JALISCO": {
      "45596": true
    }
  },
  "45597": {
    "JALISCO": {
      "45597": true
    }
  },
  "45598": {
    "JALISCO": {
      "45598": true
    }
  },
  "45599": {
    "JALISCO": {
      "45599": true
    }
  },
  "45600": {
    "JALISCO": {
      "45600": true
    }
  },
  "45601": {
    "JALISCO": {
      "45601": true
    }
  },
  "45602": {
    "JALISCO": {
      "45602": true
    }
  },
  "45603": {
    "JALISCO": {
      "45603": true
    }
  },
  "45604": {
    "JALISCO": {
      "45604": true
    }
  },
  "45605": {
    "JALISCO": {
      "45605": true
    }
  },
  "45606": {
    "JALISCO": {
      "45606": true
    }
  },
  "45607": {
    "JALISCO": {
      "45607": true
    }
  },
  "45608": {
    "JALISCO": {
      "45608": true
    }
  },
  "45609": {
    "JALISCO": {
      "45609": true
    }
  },
  "45610": {
    "JALISCO": {
      "45610": true
    }
  },
  "45611": {
    "JALISCO": {
      "45611": true
    }
  },
  "45613": {
    "JALISCO": {
      "45613": true
    }
  },
  "45615": {
    "JALISCO": {
      "45615": true
    }
  },
  "45616": {
    "JALISCO": {
      "45616": true
    }
  },
  "45618": {
    "JALISCO": {
      "45618": true
    }
  },
  "45619": {
    "JALISCO": {
      "45619": true
    }
  },
  "45620": {
    "JALISCO": {
      "45620": true
    }
  },
  "45622": {
    "JALISCO": {
      "45622": true
    }
  },
  "45623": {
    "JALISCO": {
      "45623": true
    }
  },
  "45624": {
    "JALISCO": {
      "45624": true
    }
  },
  "45625": {
    "JALISCO": {
      "45625": true
    }
  },
  "45626": {
    "JALISCO": {
      "45626": true
    }
  },
  "45627": {
    "JALISCO": {
      "45627": true
    }
  },
  "45628": {
    "JALISCO": {
      "45628": true
    }
  },
  "45629": {
    "JALISCO": {
      "45629": true
    }
  },
  "45630": {
    "JALISCO": {
      "45630": true
    }
  },
  "45634": {
    "JALISCO": {
      "45634": true
    }
  },
  "45635": {
    "JALISCO": {
      "45635": true
    }
  },
  "45637": {
    "JALISCO": {
      "45637": true
    }
  },
  "45638": {
    "JALISCO": {
      "45638": true
    }
  },
  "45680": {
    "JALISCO": {
      "45680": true
    }
  },
  "45685": {
    "JALISCO": {
      "45685": true
    }
  },
  "45690": {
    "JALISCO": {
      "45690": true
    }
  },
  "45693": {
    "JALISCO": {
      "45693": true
    }
  },
  "45750": {
    "JALISCO": {
      "45750": true
    }
  },
  "45800": {
    "JALISCO": {
      "45800": true
    }
  },
  "45900": {
    "JALISCO": {
      "45900": true
    }
  },
  "45920": {
    "JALISCO": {
      "45920": true
    }
  },
  "45950": {
    "JALISCO": {
      "45950": true
    }
  },
  "46200": {
    "JALISCO": {
      "46200": true
    }
  },
  "46470": {
    "JALISCO": {
      "46470": true
    }
  },
  "46500": {
    "JALISCO": {
      "46500": true
    }
  },
  "46600": {
    "JALISCO": {
      "46600": true
    }
  },
  "46730": {
    "JALISCO": {
      "46730": true
    }
  },
  "46770": {
    "JALISCO": {
      "46770": true
    }
  },
  "46900": {
    "JALISCO": {
      "46900": true
    }
  },
  "47000": {
    "JALISCO": {
      "47000": true
    }
  },
  "47140": {
    "JALISCO": {
      "47140": true
    }
  },
  "47180": {
    "JALISCO": {
      "47180": true
    }
  },
  "47270": {
    "JALISCO": {
      "47270": true
    }
  },
  "47400": {
    "JALISCO": {
      "47400": true
    }
  },
  "47420": {
    "JALISCO": {
      "47420": true
    }
  },
  "47540": {
    "JALISCO": {
      "47540": true
    }
  },
  "47730": {
    "JALISCO": {
      "47730": true
    }
  },
  "47750": {
    "JALISCO": {
      "47750": true
    }
  },
  "47800": {
    "JALISCO": {
      "47800": true
    }
  },
  "47829": {
    "JALISCO": {
      "47829": true
    }
  },
  "47860": {
    "JALISCO": {
      "47860": true
    }
  },
  "47899": {
    "JALISCO": {
      "47899": true
    }
  },
  "47900": {
    "JALISCO": {
      "47900": true
    }
  },
  "47910": {
    "JALISCO": {
      "47910": true
    }
  },
  "47912": {
    "JALISCO": {
      "47912": true
    }
  },
  "47930": {
    "JALISCO": {
      "47930": true
    }
  },
  "47980": {
    "JALISCO": {
      "47980": true
    }
  },
  "48200": {
    "JALISCO": {
      "48200": true
    }
  },
  "48260": {
    "JALISCO": {
      "48260": true
    }
  },
  "48290": {
    "JALISCO": {
      "48290": true
    }
  },
  "48291": {
    "JALISCO": {
      "48291": true
    }
  },
  "48310": {
    "JALISCO": {
      "48310": true
    }
  },
  "48312": {
    "JALISCO": {
      "48312": true
    }
  },
  "48314": {
    "JALISCO": {
      "48314": true
    }
  },
  "48315": {
    "JALISCO": {
      "48315": true
    }
  },
  "48320": {
    "JALISCO": {
      "48320": true
    }
  },
  "48325": {
    "JALISCO": {
      "48325": true
    }
  },
  "48338": {
    "JALISCO": {
      "48338": true
    }
  },
  "48340": {
    "JALISCO": {
      "48340": true
    }
  },
  "48344": {
    "JALISCO": {
      "48344": true
    }
  },
  "48350": {
    "JALISCO": {
      "48350": true
    }
  },
  "48380": {
    "JALISCO": {
      "48380": true
    }
  },
  "48400": {
    "JALISCO": {
      "48400": true
    }
  },
  "48450": {
    "JALISCO": {
      "48450": true
    }
  },
  "48500": {
    "JALISCO": {
      "48500": true
    }
  },
  "48540": {
    "JALISCO": {
      "48540": true
    }
  },
  "48740": {
    "JALISCO": {
      "48740": true
    }
  },
  "48850": {
    "JALISCO": {
      "48850": true
    }
  },
  "48900": {
    "JALISCO": {
      "48900": true
    }
  },
  "48930": {
    "JALISCO": {
      "48930": true
    }
  },
  "48980": {
    "JALISCO": {
      "48980": true
    }
  },
  "49097": {
    "JALISCO": {
      "49097": true
    }
  },
  "49170": {
    "JALISCO": {
      "49170": true
    }
  },
  "49500": {
    "JALISCO": {
      "49500": true
    }
  },
  "49600": {
    "JALISCO": {
      "49600": true
    }
  },
  "49800": {
    "JALISCO": {
      "49800": true
    }
  },
  "49900": {
    "JALISCO": {
      "49900": true
    }
  },
  "58000": {
    "MICHOACÁN": {
      "58000": true
    }
  },
  "58004": {
    "MICHOACÁN": {
      "58004": true
    }
  },
  "58006": {
    "MICHOACÁN": {
      "58006": true
    }
  },
  "58009": {
    "MICHOACÁN": {
      "58009": true
    }
  },
  "58010": {
    "MICHOACÁN": {
      "58010": true
    }
  },
  "58013": {
    "MICHOACÁN": {
      "58013": true
    }
  },
  "58020": {
    "MICHOACÁN": {
      "58020": true
    }
  },
  "58030": {
    "MICHOACÁN": {
      "58030": true
    }
  },
  "58040": {
    "MICHOACÁN": {
      "58040": true
    }
  },
  "58048": {
    "MICHOACÁN": {
      "58048": true
    }
  },
  "58049": {
    "MICHOACÁN": {
      "58049": true
    }
  },
  "58050": {
    "MICHOACÁN": {
      "58050": true
    }
  },
  "58055": {
    "MICHOACÁN": {
      "58055": true
    }
  },
  "58056": {
    "MICHOACÁN": {
      "58056": true
    }
  },
  "58057": {
    "MICHOACÁN": {
      "58057": true
    }
  },
  "58058": {
    "MICHOACÁN": {
      "58058": true
    }
  },
  "58060": {
    "MICHOACÁN": {
      "58060": true
    }
  },
  "58066": {
    "MICHOACÁN": {
      "58066": true
    }
  },
  "58067": {
    "MICHOACÁN": {
      "58067": true
    }
  },
  "58069": {
    "MICHOACÁN": {
      "58069": true
    }
  },
  "58070": {
    "MICHOACÁN": {
      "58070": true
    }
  },
  "58078": {
    "MICHOACÁN": {
      "58078": true
    }
  },
  "58079": {
    "MICHOACÁN": {
      "58079": true
    }
  },
  "58080": {
    "MICHOACÁN": {
      "58080": true
    }
  },
  "58085": {
    "MICHOACÁN": {
      "58085": true
    }
  },
  "58086": {
    "MICHOACÁN": {
      "58086": true
    }
  },
  "58087": {
    "MICHOACÁN": {
      "58087": true
    }
  },
  "58088": {
    "MICHOACÁN": {
      "58088": true
    }
  },
  "58089": {
    "MICHOACÁN": {
      "58089": true
    }
  },
  "58090": {
    "MICHOACÁN": {
      "58090": true
    }
  },
  "58093": {
    "MICHOACÁN": {
      "58093": true
    }
  },
  "58095": {
    "MICHOACÁN": {
      "58095": true
    }
  },
  "58096": {
    "MICHOACÁN": {
      "58096": true
    }
  },
  "58097": {
    "MICHOACÁN": {
      "58097": true
    }
  },
  "58098": {
    "MICHOACÁN": {
      "58098": true
    }
  },
  "58099": {
    "MICHOACÁN": {
      "58099": true
    }
  },
  "58100": {
    "MICHOACÁN": {
      "58100": true
    }
  },
  "58110": {
    "MICHOACÁN": {
      "58110": true
    }
  },
  "58114": {
    "MICHOACÁN": {
      "58114": true
    }
  },
  "58115": {
    "MICHOACÁN": {
      "58115": true
    }
  },
  "58116": {
    "MICHOACÁN": {
      "58116": true
    }
  },
  "58117": {
    "MICHOACÁN": {
      "58117": true
    }
  },
  "58118": {
    "MICHOACÁN": {
      "58118": true
    }
  },
  "58120": {
    "MICHOACÁN": {
      "58120": true
    }
  },
  "58127": {
    "MICHOACÁN": {
      "58127": true
    }
  },
  "58128": {
    "MICHOACÁN": {
      "58128": true
    }
  },
  "58130": {
    "MICHOACÁN": {
      "58130": true
    }
  },
  "58140": {
    "MICHOACÁN": {
      "58140": true
    }
  },
  "58145": {
    "MICHOACÁN": {
      "58145": true
    }
  },
  "58146": {
    "MICHOACÁN": {
      "58146": true
    }
  },
  "58147": {
    "MICHOACÁN": {
      "58147": true
    }
  },
  "58148": {
    "MICHOACÁN": {
      "58148": true
    }
  },
  "58149": {
    "MICHOACÁN": {
      "58149": true
    }
  },
  "58150": {
    "MICHOACÁN": {
      "58150": true
    }
  },
  "58158": {
    "MICHOACÁN": {
      "58158": true
    }
  },
  "58160": {
    "MICHOACÁN": {
      "58160": true
    }
  },
  "58168": {
    "MICHOACÁN": {
      "58168": true
    }
  },
  "58170": {
    "MICHOACÁN": {
      "58170": true
    }
  },
  "58175": {
    "MICHOACÁN": {
      "58175": true
    }
  },
  "58178": {
    "MICHOACÁN": {
      "58178": true
    }
  },
  "58179": {
    "MICHOACÁN": {
      "58179": true
    }
  },
  "58180": {
    "MICHOACÁN": {
      "58180": true
    }
  },
  "58183": {
    "MICHOACÁN": {
      "58183": true
    }
  },
  "58186": {
    "MICHOACÁN": {
      "58186": true
    }
  },
  "58187": {
    "MICHOACÁN": {
      "58187": true
    }
  },
  "58188": {
    "MICHOACÁN": {
      "58188": true
    }
  },
  "58189": {
    "MICHOACÁN": {
      "58189": true
    }
  },
  "58190": {
    "MICHOACÁN": {
      "58190": true
    }
  },
  "58194": {
    "MICHOACÁN": {
      "58194": true
    }
  },
  "58195": {
    "MICHOACÁN": {
      "58195": true
    }
  },
  "58196": {
    "MICHOACÁN": {
      "58196": true
    }
  },
  "58197": {
    "MICHOACÁN": {
      "58197": true
    }
  },
  "58199": {
    "MICHOACÁN": {
      "58199": true
    }
  },
  "58200": {
    "MICHOACÁN": {
      "58200": true
    }
  },
  "58210": {
    "MICHOACÁN": {
      "58210": true
    }
  },
  "58216": {
    "MICHOACÁN": {
      "58216": true
    }
  },
  "58217": {
    "MICHOACÁN": {
      "58217": true
    }
  },
  "58218": {
    "MICHOACÁN": {
      "58218": true
    }
  },
  "58219": {
    "MICHOACÁN": {
      "58219": true
    }
  },
  "58220": {
    "MICHOACÁN": {
      "58220": true
    }
  },
  "58226": {
    "MICHOACÁN": {
      "58226": true
    }
  },
  "58227": {
    "MICHOACÁN": {
      "58227": true
    }
  },
  "58228": {
    "MICHOACÁN": {
      "58228": true
    }
  },
  "58229": {
    "MICHOACÁN": {
      "58229": true
    }
  },
  "58230": {
    "MICHOACÁN": {
      "58230": true
    }
  },
  "58240": {
    "MICHOACÁN": {
      "58240": true
    }
  },
  "58244": {
    "MICHOACÁN": {
      "58244": true
    }
  },
  "58245": {
    "MICHOACÁN": {
      "58245": true
    }
  },
  "58248": {
    "MICHOACÁN": {
      "58248": true
    }
  },
  "58249": {
    "MICHOACÁN": {
      "58249": true
    }
  },
  "58250": {
    "MICHOACÁN": {
      "58250": true
    }
  },
  "58253": {
    "MICHOACÁN": {
      "58253": true
    }
  },
  "58254": {
    "MICHOACÁN": {
      "58254": true
    }
  },
  "58255": {
    "MICHOACÁN": {
      "58255": true
    }
  },
  "58256": {
    "MICHOACÁN": {
      "58256": true
    }
  },
  "58257": {
    "MICHOACÁN": {
      "58257": true
    }
  },
  "58258": {
    "MICHOACÁN": {
      "58258": true
    }
  },
  "58259": {
    "MICHOACÁN": {
      "58259": true
    }
  },
  "58260": {
    "MICHOACÁN": {
      "58260": true
    }
  },
  "58270": {
    "MICHOACÁN": {
      "58270": true
    }
  },
  "58277": {
    "MICHOACÁN": {
      "58277": true
    }
  },
  "58278": {
    "MICHOACÁN": {
      "58278": true
    }
  },
  "58280": {
    "MICHOACÁN": {
      "58280": true
    }
  },
  "58290": {
    "MICHOACÁN": {
      "58290": true
    }
  },
  "58295": {
    "MICHOACÁN": {
      "58295": true
    }
  },
  "58296": {
    "MICHOACÁN": {
      "58296": true
    }
  },
  "58297": {
    "MICHOACÁN": {
      "58297": true
    }
  },
  "58300": {
    "MICHOACÁN": {
      "58300": true
    }
  },
  "58301": {
    "MICHOACÁN": {
      "58301": true
    }
  },
  "58302": {
    "MICHOACÁN": {
      "58302": true
    }
  },
  "58303": {
    "MICHOACÁN": {
      "58303": true
    }
  },
  "58304": {
    "MICHOACÁN": {
      "58304": true
    }
  },
  "58310": {
    "MICHOACÁN": {
      "58310": true
    }
  },
  "58314": {
    "MICHOACÁN": {
      "58314": true
    }
  },
  "58317": {
    "MICHOACÁN": {
      "58317": true
    }
  },
  "58320": {
    "MICHOACÁN": {
      "58320": true
    }
  },
  "58321": {
    "MICHOACÁN": {
      "58321": true
    }
  },
  "58330": {
    "MICHOACÁN": {
      "58330": true
    }
  },
  "58331": {
    "MICHOACÁN": {
      "58331": true
    }
  },
  "58332": {
    "MICHOACÁN": {
      "58332": true
    }
  },
  "58333": {
    "MICHOACÁN": {
      "58333": true
    }
  },
  "58335": {
    "MICHOACÁN": {
      "58335": true
    }
  },
  "58336": {
    "MICHOACÁN": {
      "58336": true
    }
  },
  "58337": {
    "MICHOACÁN": {
      "58337": true
    }
  },
  "58340": {
    "MICHOACÁN": {
      "58340": true
    }
  },
  "58341": {
    "MICHOACÁN": {
      "58341": true
    }
  },
  "58342": {
    "MICHOACÁN": {
      "58342": true
    }
  },
  "58343": {
    "MICHOACÁN": {
      "58343": true
    }
  },
  "58344": {
    "MICHOACÁN": {
      "58344": true
    }
  },
  "58345": {
    "MICHOACÁN": {
      "58345": true
    }
  },
  "58346": {
    "MICHOACÁN": {
      "58346": true
    }
  },
  "58348": {
    "MICHOACÁN": {
      "58348": true
    }
  },
  "58350": {
    "MICHOACÁN": {
      "58350": true
    }
  },
  "58353": {
    "MICHOACÁN": {
      "58353": true
    }
  },
  "58355": {
    "MICHOACÁN": {
      "58355": true
    }
  },
  "58356": {
    "MICHOACÁN": {
      "58356": true
    }
  },
  "58357": {
    "MICHOACÁN": {
      "58357": true
    }
  },
  "58358": {
    "MICHOACÁN": {
      "58358": true
    }
  },
  "58359": {
    "MICHOACÁN": {
      "58359": true
    }
  },
  "58420": {
    "MICHOACÁN": {
      "58420": true
    }
  },
  "58500": {
    "MICHOACÁN": {
      "58500": true
    }
  },
  "58600": {
    "MICHOACÁN": {
      "58600": true
    }
  },
  "58893": {
    "MICHOACÁN": {
      "58893": true
    }
  },
  "58920": {
    "MICHOACÁN": {
      "58920": true
    }
  },
  "58930": {
    "MICHOACÁN": {
      "58930": true
    }
  },
  "59160": {
    "MICHOACÁN": {
      "59160": true
    }
  },
  "59180": {
    "MICHOACÁN": {
      "59180": true
    }
  },
  "59200": {
    "MICHOACÁN": {
      "59200": true
    }
  },
  "59230": {
    "MICHOACÁN": {
      "59230": true
    }
  },
  "59250": {
    "MICHOACÁN": {
      "59250": true
    }
  },
  "59300": {
    "MICHOACÁN": {
      "59300": true
    }
  },
  "59310": {
    "MICHOACÁN": {
      "59310": true
    }
  },
  "59430": {
    "MICHOACÁN": {
      "59430": true
    }
  },
  "59500": {
    "MICHOACÁN": {
      "59500": true
    }
  },
  "59510": {
    "MICHOACÁN": {
      "59510": true
    }
  },
  "59610": {
    "MICHOACÁN": {
      "59610": true
    }
  },
  "59699": {
    "MICHOACÁN": {
      "59699": true
    }
  },
  "59780": {
    "MICHOACÁN": {
      "59780": true
    }
  },
  "59940": {
    "MICHOACÁN": {
      "59940": true
    }
  },
  "60000": {
    "MICHOACÁN": {
      "60000": true
    }
  },
  "60010": {
    "MICHOACÁN": {
      "60010": true
    }
  },
  "60030": {
    "MICHOACÁN": {
      "60030": true
    }
  },
  "60040": {
    "MICHOACÁN": {
      "60040": true
    }
  },
  "60050": {
    "MICHOACÁN": {
      "60050": true
    }
  },
  "60080": {
    "MICHOACÁN": {
      "60080": true
    }
  },
  "60090": {
    "MICHOACÁN": {
      "60090": true
    }
  },
  "60120": {
    "MICHOACÁN": {
      "60120": true
    }
  },
  "60130": {
    "MICHOACÁN": {
      "60130": true
    }
  },
  "60156": {
    "MICHOACÁN": {
      "60156": true
    }
  },
  "60190": {
    "MICHOACÁN": {
      "60190": true
    }
  },
  "60250": {
    "MICHOACÁN": {
      "60250": true
    }
  },
  "60290": {
    "MICHOACÁN": {
      "60290": true
    }
  },
  "60300": {
    "MICHOACÁN": {
      "60300": true
    }
  },
  "60460": {
    "MICHOACÁN": {
      "60460": true
    }
  },
  "60500": {
    "MICHOACÁN": {
      "60500": true
    }
  },
  "60540": {
    "MICHOACÁN": {
      "60540": true
    }
  },
  "60600": {
    "MICHOACÁN": {
      "60600": true
    }
  },
  "60630": {
    "MICHOACÁN": {
      "60630": true
    }
  },
  "60840": {
    "MICHOACÁN": {
      "60840": true
    }
  },
  "60920": {
    "MICHOACÁN": {
      "60920": true
    }
  },
  "60953": {
    "MICHOACÁN": {
      "60953": true
    }
  },
  "60954": {
    "MICHOACÁN": {
      "60954": true
    }
  },
  "60956": {
    "MICHOACÁN": {
      "60956": true
    }
  },
  "60990": {
    "MICHOACÁN": {
      "60990": true
    }
  },
  "60994": {
    "MICHOACÁN": {
      "60994": true
    }
  },
  "60998": {
    "MICHOACÁN": {
      "60998": true
    }
  },
  "61100": {
    "MICHOACÁN": {
      "61100": true
    }
  },
  "61250": {
    "MICHOACÁN": {
      "61250": true
    }
  },
  "61252": {
    "MICHOACÁN": {
      "61252": true
    }
  },
  "61500": {
    "MICHOACÁN": {
      "61500": true
    }
  },
  "61509": {
    "MICHOACÁN": {
      "61509": true
    }
  },
  "61516": {
    "MICHOACÁN": {
      "61516": true
    }
  },
  "61518": {
    "MICHOACÁN": {
      "61518": true
    }
  },
  "61600": {
    "MICHOACÁN": {
      "61600": true
    }
  },
  "61608": {
    "MICHOACÁN": {
      "61608": true
    }
  },
  "61650": {
    "MICHOACÁN": {
      "61650": true
    }
  },
  "61730": {
    "MICHOACÁN": {
      "61730": true
    }
  },
  "61830": {
    "MICHOACÁN": {
      "61830": true
    }
  },
  "63000": {
    "NAYARIT": {
      "63000": true
    }
  },
  "63001": {
    "NAYARIT": {
      "63001": true
    }
  },
  "63002": {
    "NAYARIT": {
      "63002": true
    }
  },
  "63003": {
    "NAYARIT": {
      "63003": true
    }
  },
  "63004": {
    "NAYARIT": {
      "63004": true
    }
  },
  "63005": {
    "NAYARIT": {
      "63005": true
    }
  },
  "63006": {
    "NAYARIT": {
      "63006": true
    }
  },
  "63009": {
    "NAYARIT": {
      "63009": true
    }
  },
  "63010": {
    "NAYARIT": {
      "63010": true
    }
  },
  "63018": {
    "NAYARIT": {
      "63018": true
    }
  },
  "63019": {
    "NAYARIT": {
      "63019": true
    }
  },
  "63020": {
    "NAYARIT": {
      "63020": true
    }
  },
  "63021": {
    "NAYARIT": {
      "63021": true
    }
  },
  "63022": {
    "NAYARIT": {
      "63022": true
    }
  },
  "63023": {
    "NAYARIT": {
      "63023": true
    }
  },
  "63025": {
    "NAYARIT": {
      "63025": true
    }
  },
  "63027": {
    "NAYARIT": {
      "63027": true
    }
  },
  "63030": {
    "NAYARIT": {
      "63030": true
    }
  },
  "63032": {
    "NAYARIT": {
      "63032": true
    }
  },
  "63034": {
    "NAYARIT": {
      "63034": true
    }
  },
  "63035": {
    "NAYARIT": {
      "63035": true
    }
  },
  "63036": {
    "NAYARIT": {
      "63036": true
    }
  },
  "63037": {
    "NAYARIT": {
      "63037": true
    }
  },
  "63038": {
    "NAYARIT": {
      "63038": true
    }
  },
  "63039": {
    "NAYARIT": {
      "63039": true
    }
  },
  "63040": {
    "NAYARIT": {
      "63040": true
    }
  },
  "63044": {
    "NAYARIT": {
      "63044": true
    }
  },
  "63050": {
    "NAYARIT": {
      "63050": true
    }
  },
  "63057": {
    "NAYARIT": {
      "63057": true
    }
  },
  "63058": {
    "NAYARIT": {
      "63058": true
    }
  },
  "63059": {
    "NAYARIT": {
      "63059": true
    }
  },
  "63060": {
    "NAYARIT": {
      "63060": true
    }
  },
  "63061": {
    "NAYARIT": {
      "63061": true
    }
  },
  "63062": {
    "NAYARIT": {
      "63062": true
    }
  },
  "63063": {
    "NAYARIT": {
      "63063": true
    }
  },
  "63064": {
    "NAYARIT": {
      "63064": true
    }
  },
  "63066": {
    "NAYARIT": {
      "63066": true
    }
  },
  "63067": {
    "NAYARIT": {
      "63067": true
    }
  },
  "63068": {
    "NAYARIT": {
      "63068": true
    }
  },
  "63069": {
    "NAYARIT": {
      "63069": true
    }
  },
  "63070": {
    "NAYARIT": {
      "63070": true
    }
  },
  "63073": {
    "NAYARIT": {
      "63073": true
    }
  },
  "63076": {
    "NAYARIT": {
      "63076": true
    }
  },
  "63079": {
    "NAYARIT": {
      "63079": true
    }
  },
  "63080": {
    "NAYARIT": {
      "63080": true
    }
  },
  "63081": {
    "NAYARIT": {
      "63081": true
    }
  },
  "63082": {
    "NAYARIT": {
      "63082": true
    }
  },
  "63083": {
    "NAYARIT": {
      "63083": true
    }
  },
  "63084": {
    "NAYARIT": {
      "63084": true
    }
  },
  "63085": {
    "NAYARIT": {
      "63085": true
    }
  },
  "63088": {
    "NAYARIT": {
      "63088": true
    }
  },
  "63089": {
    "NAYARIT": {
      "63089": true
    }
  },
  "63090": {
    "NAYARIT": {
      "63090": true
    }
  },
  "63096": {
    "NAYARIT": {
      "63096": true
    }
  },
  "63100": {
    "NAYARIT": {
      "63100": true
    }
  },
  "63101": {
    "NAYARIT": {
      "63101": true
    }
  },
  "63105": {
    "NAYARIT": {
      "63105": true
    }
  },
  "63109": {
    "NAYARIT": {
      "63109": true
    }
  },
  "63110": {
    "NAYARIT": {
      "63110": true
    }
  },
  "63111": {
    "NAYARIT": {
      "63111": true
    }
  },
  "63113": {
    "NAYARIT": {
      "63113": true
    }
  },
  "63114": {
    "NAYARIT": {
      "63114": true
    }
  },
  "63115": {
    "NAYARIT": {
      "63115": true
    }
  },
  "63116": {
    "NAYARIT": {
      "63116": true
    }
  },
  "63117": {
    "NAYARIT": {
      "63117": true
    }
  },
  "63118": {
    "NAYARIT": {
      "63118": true
    }
  },
  "63119": {
    "NAYARIT": {
      "63119": true
    }
  },
  "63120": {
    "NAYARIT": {
      "63120": true
    }
  },
  "63125": {
    "NAYARIT": {
      "63125": true
    }
  },
  "63128": {
    "NAYARIT": {
      "63128": true
    }
  },
  "63129": {
    "NAYARIT": {
      "63129": true
    }
  },
  "63130": {
    "NAYARIT": {
      "63130": true
    }
  },
  "63131": {
    "NAYARIT": {
      "63131": true
    }
  },
  "63132": {
    "NAYARIT": {
      "63132": true
    }
  },
  "63133": {
    "NAYARIT": {
      "63133": true
    }
  },
  "63134": {
    "NAYARIT": {
      "63134": true
    }
  },
  "63135": {
    "NAYARIT": {
      "63135": true
    }
  },
  "63136": {
    "NAYARIT": {
      "63136": true
    }
  },
  "63137": {
    "NAYARIT": {
      "63137": true
    }
  },
  "63138": {
    "NAYARIT": {
      "63138": true
    }
  },
  "63139": {
    "NAYARIT": {
      "63139": true
    }
  },
  "63140": {
    "NAYARIT": {
      "63140": true
    }
  },
  "63145": {
    "NAYARIT": {
      "63145": true
    }
  },
  "63147": {
    "NAYARIT": {
      "63147": true
    }
  },
  "63148": {
    "NAYARIT": {
      "63148": true
    }
  },
  "63149": {
    "NAYARIT": {
      "63149": true
    }
  },
  "63150": {
    "NAYARIT": {
      "63150": true
    }
  },
  "63152": {
    "NAYARIT": {
      "63152": true
    }
  },
  "63153": {
    "NAYARIT": {
      "63153": true
    }
  },
  "63154": {
    "NAYARIT": {
      "63154": true
    }
  },
  "63155": {
    "NAYARIT": {
      "63155": true
    }
  },
  "63156": {
    "NAYARIT": {
      "63156": true
    }
  },
  "63157": {
    "NAYARIT": {
      "63157": true
    }
  },
  "63158": {
    "NAYARIT": {
      "63158": true
    }
  },
  "63159": {
    "NAYARIT": {
      "63159": true
    }
  },
  "63160": {
    "NAYARIT": {
      "63160": true
    }
  },
  "63163": {
    "NAYARIT": {
      "63163": true
    }
  },
  "63164": {
    "NAYARIT": {
      "63164": true
    }
  },
  "63165": {
    "NAYARIT": {
      "63165": true
    }
  },
  "63166": {
    "NAYARIT": {
      "63166": true
    }
  },
  "63167": {
    "NAYARIT": {
      "63167": true
    }
  },
  "63168": {
    "NAYARIT": {
      "63168": true
    }
  },
  "63169": {
    "NAYARIT": {
      "63169": true
    }
  },
  "63170": {
    "NAYARIT": {
      "63170": true
    }
  },
  "63171": {
    "NAYARIT": {
      "63171": true
    }
  },
  "63172": {
    "NAYARIT": {
      "63172": true
    }
  },
  "63173": {
    "NAYARIT": {
      "63173": true
    }
  },
  "63174": {
    "NAYARIT": {
      "63174": true
    }
  },
  "63175": {
    "NAYARIT": {
      "63175": true
    }
  },
  "63176": {
    "NAYARIT": {
      "63176": true
    }
  },
  "63177": {
    "NAYARIT": {
      "63177": true
    }
  },
  "63178": {
    "NAYARIT": {
      "63178": true
    }
  },
  "63179": {
    "NAYARIT": {
      "63179": true
    }
  },
  "63180": {
    "NAYARIT": {
      "63180": true
    }
  },
  "63183": {
    "NAYARIT": {
      "63183": true
    }
  },
  "63184": {
    "NAYARIT": {
      "63184": true
    }
  },
  "63185": {
    "NAYARIT": {
      "63185": true
    }
  },
  "63186": {
    "NAYARIT": {
      "63186": true
    }
  },
  "63187": {
    "NAYARIT": {
      "63187": true
    }
  },
  "63188": {
    "NAYARIT": {
      "63188": true
    }
  },
  "63189": {
    "NAYARIT": {
      "63189": true
    }
  },
  "63190": {
    "NAYARIT": {
      "63190": true
    }
  },
  "63192": {
    "NAYARIT": {
      "63192": true
    }
  },
  "63193": {
    "NAYARIT": {
      "63193": true
    }
  },
  "63194": {
    "NAYARIT": {
      "63194": true
    }
  },
  "63195": {
    "NAYARIT": {
      "63195": true
    }
  },
  "63196": {
    "NAYARIT": {
      "63196": true
    }
  },
  "63197": {
    "NAYARIT": {
      "63197": true
    }
  },
  "63198": {
    "NAYARIT": {
      "63198": true
    }
  },
  "63199": {
    "NAYARIT": {
      "63199": true
    }
  },
  "63200": {
    "NAYARIT": {
      "63200": true
    }
  },
  "63300": {
    "NAYARIT": {
      "63300": true
    }
  },
  "63430": {
    "NAYARIT": {
      "63430": true
    }
  },
  "63450": {
    "NAYARIT": {
      "63450": true
    }
  },
  "63700": {
    "NAYARIT": {
      "63700": true
    }
  },
  "63710": {
    "NAYARIT": {
      "63710": true
    }
  },
  "63715": {
    "NAYARIT": {
      "63715": true
    }
  },
  "63729": {
    "NAYARIT": {
      "63729": true
    }
  },
  "63730": {
    "NAYARIT": {
      "63730": true
    }
  },
  "63732": {
    "NAYARIT": {
      "63732": true
    }
  },
  "63734": {
    "NAYARIT": {
      "63734": true
    }
  },
  "63735": {
    "NAYARIT": {
      "63735": true
    }
  },
  "63737": {
    "NAYARIT": {
      "63737": true
    }
  },
  "63738": {
    "NAYARIT": {
      "63738": true
    }
  },
  "63940": {
    "NAYARIT": {
      "63940": true
    }
  },
  "68000": {
    "OAXACA": {
      "68000": true
    }
  },
  "68008": {
    "OAXACA": {
      "68008": true
    }
  },
  "68009": {
    "OAXACA": {
      "68009": true
    }
  },
  "68010": {
    "OAXACA": {
      "68010": true
    }
  },
  "68013": {
    "OAXACA": {
      "68013": true
    }
  },
  "68016": {
    "OAXACA": {
      "68016": true
    }
  },
  "68020": {
    "OAXACA": {
      "68020": true
    }
  },
  "68023": {
    "OAXACA": {
      "68023": true
    }
  },
  "68024": {
    "OAXACA": {
      "68024": true
    }
  },
  "68025": {
    "OAXACA": {
      "68025": true
    }
  },
  "68026": {
    "OAXACA": {
      "68026": true
    }
  },
  "68027": {
    "OAXACA": {
      "68027": true
    }
  },
  "68028": {
    "OAXACA": {
      "68028": true
    }
  },
  "68030": {
    "OAXACA": {
      "68030": true
    }
  },
  "68033": {
    "OAXACA": {
      "68033": true
    }
  },
  "68034": {
    "OAXACA": {
      "68034": true
    }
  },
  "68036": {
    "OAXACA": {
      "68036": true
    }
  },
  "68039": {
    "OAXACA": {
      "68039": true
    }
  },
  "68040": {
    "OAXACA": {
      "68040": true
    }
  },
  "68043": {
    "OAXACA": {
      "68043": true
    }
  },
  "68044": {
    "OAXACA": {
      "68044": true
    }
  },
  "68045": {
    "OAXACA": {
      "68045": true
    }
  },
  "68050": {
    "OAXACA": {
      "68050": true
    }
  },
  "68060": {
    "OAXACA": {
      "68060": true
    }
  },
  "68067": {
    "OAXACA": {
      "68067": true
    }
  },
  "68068": {
    "OAXACA": {
      "68068": true
    }
  },
  "68070": {
    "OAXACA": {
      "68070": true
    }
  },
  "68075": {
    "OAXACA": {
      "68075": true
    }
  },
  "68080": {
    "OAXACA": {
      "68080": true
    }
  },
  "68083": {
    "OAXACA": {
      "68083": true
    }
  },
  "68088": {
    "OAXACA": {
      "68088": true
    }
  },
  "68089": {
    "OAXACA": {
      "68089": true
    }
  },
  "68090": {
    "OAXACA": {
      "68090": true
    }
  },
  "68100": {
    "OAXACA": {
      "68100": true
    }
  },
  "68103": {
    "OAXACA": {
      "68103": true
    }
  },
  "68104": {
    "OAXACA": {
      "68104": true
    }
  },
  "68110": {
    "OAXACA": {
      "68110": true
    }
  },
  "68115": {
    "OAXACA": {
      "68115": true
    }
  },
  "68120": {
    "OAXACA": {
      "68120": true
    }
  },
  "68125": {
    "OAXACA": {
      "68125": true
    }
  },
  "68126": {
    "OAXACA": {
      "68126": true
    }
  },
  "68127": {
    "OAXACA": {
      "68127": true
    }
  },
  "68128": {
    "OAXACA": {
      "68128": true
    }
  },
  "68130": {
    "OAXACA": {
      "68130": true
    }
  },
  "68133": {
    "OAXACA": {
      "68133": true
    }
  },
  "68140": {
    "OAXACA": {
      "68140": true
    }
  },
  "68143": {
    "OAXACA": {
      "68143": true
    }
  },
  "68144": {
    "OAXACA": {
      "68144": true
    }
  },
  "68146": {
    "OAXACA": {
      "68146": true
    }
  },
  "68148": {
    "OAXACA": {
      "68148": true
    }
  },
  "68149": {
    "OAXACA": {
      "68149": true
    }
  },
  "68150": {
    "OAXACA": {
      "68150": true
    }
  },
  "68153": {
    "OAXACA": {
      "68153": true
    }
  },
  "68154": {
    "OAXACA": {
      "68154": true
    }
  },
  "68155": {
    "OAXACA": {
      "68155": true
    }
  },
  "68156": {
    "OAXACA": {
      "68156": true
    }
  },
  "68157": {
    "OAXACA": {
      "68157": true
    }
  },
  "68159": {
    "OAXACA": {
      "68159": true
    }
  },
  "68274": {
    "OAXACA": {
      "68274": true
    }
  },
  "68275": {
    "OAXACA": {
      "68275": true
    }
  },
  "68276": {
    "OAXACA": {
      "68276": true
    }
  },
  "68277": {
    "OAXACA": {
      "68277": true
    }
  },
  "68278": {
    "OAXACA": {
      "68278": true
    }
  },
  "68280": {
    "OAXACA": {
      "68280": true
    }
  },
  "68283": {
    "OAXACA": {
      "68283": true
    }
  },
  "68284": {
    "OAXACA": {
      "68284": true
    }
  },
  "76000": {
    "QUERÉTARO": {
      "76000": true
    }
  },
  "76001": {
    "QUERÉTARO": {
      "76001": true
    }
  },
  "76002": {
    "QUERÉTARO": {
      "76002": true
    }
  },
  "76003": {
    "QUERÉTARO": {
      "76003": true
    }
  },
  "76004": {
    "QUERÉTARO": {
      "76004": true
    }
  },
  "76005": {
    "QUERÉTARO": {
      "76005": true
    }
  },
  "76006": {
    "QUERÉTARO": {
      "76006": true
    }
  },
  "76007": {
    "QUERÉTARO": {
      "76007": true
    }
  },
  "76008": {
    "QUERÉTARO": {
      "76008": true
    }
  },
  "76009": {
    "QUERÉTARO": {
      "76009": true
    }
  },
  "76010": {
    "QUERÉTARO": {
      "76010": true
    }
  },
  "76011": {
    "QUERÉTARO": {
      "76011": true
    }
  },
  "76012": {
    "QUERÉTARO": {
      "76012": true
    }
  },
  "76013": {
    "QUERÉTARO": {
      "76013": true
    }
  },
  "76016": {
    "QUERÉTARO": {
      "76016": true
    }
  },
  "76017": {
    "QUERÉTARO": {
      "76017": true
    }
  },
  "76018": {
    "QUERÉTARO": {
      "76018": true
    }
  },
  "76019": {
    "QUERÉTARO": {
      "76019": true
    }
  },
  "76020": {
    "QUERÉTARO": {
      "76020": true
    }
  },
  "76021": {
    "QUERÉTARO": {
      "76021": true
    }
  },
  "76022": {
    "QUERÉTARO": {
      "76022": true
    }
  },
  "76024": {
    "QUERÉTARO": {
      "76024": true
    }
  },
  "76025": {
    "QUERÉTARO": {
      "76025": true
    }
  },
  "76026": {
    "QUERÉTARO": {
      "76026": true
    }
  },
  "76027": {
    "QUERÉTARO": {
      "76027": true
    }
  },
  "76028": {
    "QUERÉTARO": {
      "76028": true
    }
  },
  "76029": {
    "QUERÉTARO": {
      "76029": true
    }
  },
  "76030": {
    "QUERÉTARO": {
      "76030": true
    }
  },
  "76031": {
    "QUERÉTARO": {
      "76031": true
    }
  },
  "76032": {
    "QUERÉTARO": {
      "76032": true
    }
  },
  "76033": {
    "QUERÉTARO": {
      "76033": true
    }
  },
  "76034": {
    "QUERÉTARO": {
      "76034": true
    }
  },
  "76035": {
    "QUERÉTARO": {
      "76035": true
    }
  },
  "76036": {
    "QUERÉTARO": {
      "76036": true
    }
  },
  "76037": {
    "QUERÉTARO": {
      "76037": true
    }
  },
  "76038": {
    "QUERÉTARO": {
      "76038": true
    }
  },
  "76039": {
    "QUERÉTARO": {
      "76039": true
    }
  },
  "76040": {
    "QUERÉTARO": {
      "76040": true
    }
  },
  "76041": {
    "QUERÉTARO": {
      "76041": true
    }
  },
  "76042": {
    "QUERÉTARO": {
      "76042": true
    }
  },
  "76043": {
    "QUERÉTARO": {
      "76043": true
    }
  },
  "76044": {
    "QUERÉTARO": {
      "76044": true
    }
  },
  "76045": {
    "QUERÉTARO": {
      "76045": true
    }
  },
  "76046": {
    "QUERÉTARO": {
      "76046": true
    }
  },
  "76047": {
    "QUERÉTARO": {
      "76047": true
    }
  },
  "76048": {
    "QUERÉTARO": {
      "76048": true
    }
  },
  "76049": {
    "QUERÉTARO": {
      "76049": true
    }
  },
  "76050": {
    "QUERÉTARO": {
      "76050": true
    }
  },
  "76052": {
    "QUERÉTARO": {
      "76052": true
    }
  },
  "76054": {
    "QUERÉTARO": {
      "76054": true
    }
  },
  "76055": {
    "QUERÉTARO": {
      "76055": true
    }
  },
  "76057": {
    "QUERÉTARO": {
      "76057": true
    }
  },
  "76058": {
    "QUERÉTARO": {
      "76058": true
    }
  },
  "76059": {
    "QUERÉTARO": {
      "76059": true
    }
  },
  "76060": {
    "QUERÉTARO": {
      "76060": true
    }
  },
  "76061": {
    "QUERÉTARO": {
      "76061": true
    }
  },
  "76063": {
    "QUERÉTARO": {
      "76063": true
    }
  },
  "76064": {
    "QUERÉTARO": {
      "76064": true
    }
  },
  "76065": {
    "QUERÉTARO": {
      "76065": true
    }
  },
  "76066": {
    "QUERÉTARO": {
      "76066": true
    }
  },
  "76067": {
    "QUERÉTARO": {
      "76067": true
    }
  },
  "76068": {
    "QUERÉTARO": {
      "76068": true
    }
  },
  "76069": {
    "QUERÉTARO": {
      "76069": true
    }
  },
  "76070": {
    "QUERÉTARO": {
      "76070": true
    }
  },
  "76073": {
    "QUERÉTARO": {
      "76073": true
    }
  },
  "76074": {
    "QUERÉTARO": {
      "76074": true
    }
  },
  "76076": {
    "QUERÉTARO": {
      "76076": true
    }
  },
  "76078": {
    "QUERÉTARO": {
      "76078": true
    }
  },
  "76079": {
    "QUERÉTARO": {
      "76079": true
    }
  },
  "76080": {
    "QUERÉTARO": {
      "76080": true
    }
  },
  "76081": {
    "QUERÉTARO": {
      "76081": true
    }
  },
  "76082": {
    "QUERÉTARO": {
      "76082": true
    }
  },
  "76083": {
    "QUERÉTARO": {
      "76083": true
    }
  },
  "76084": {
    "QUERÉTARO": {
      "76084": true
    }
  },
  "76085": {
    "QUERÉTARO": {
      "76085": true
    }
  },
  "76086": {
    "QUERÉTARO": {
      "76086": true
    }
  },
  "76087": {
    "QUERÉTARO": {
      "76087": true
    }
  },
  "76088": {
    "QUERÉTARO": {
      "76088": true
    }
  },
  "76089": {
    "QUERÉTARO": {
      "76089": true
    }
  },
  "76090": {
    "QUERÉTARO": {
      "76090": true
    }
  },
  "76091": {
    "QUERÉTARO": {
      "76091": true
    }
  },
  "76092": {
    "QUERÉTARO": {
      "76092": true
    }
  },
  "76093": {
    "QUERÉTARO": {
      "76093": true
    }
  },
  "76094": {
    "QUERÉTARO": {
      "76094": true
    }
  },
  "76095": {
    "QUERÉTARO": {
      "76095": true
    }
  },
  "76096": {
    "QUERÉTARO": {
      "76096": true
    }
  },
  "76097": {
    "QUERÉTARO": {
      "76097": true
    }
  },
  "76098": {
    "QUERÉTARO": {
      "76098": true
    }
  },
  "76099": {
    "QUERÉTARO": {
      "76099": true
    }
  },
  "76100": {
    "QUERÉTARO": {
      "76100": true
    }
  },
  "76101": {
    "QUERÉTARO": {
      "76101": true
    }
  },
  "76102": {
    "QUERÉTARO": {
      "76102": true
    }
  },
  "76103": {
    "QUERÉTARO": {
      "76103": true
    }
  },
  "76104": {
    "QUERÉTARO": {
      "76104": true
    }
  },
  "76105": {
    "QUERÉTARO": {
      "76105": true
    }
  },
  "76106": {
    "QUERÉTARO": {
      "76106": true
    }
  },
  "76108": {
    "QUERÉTARO": {
      "76108": true
    }
  },
  "76109": {
    "QUERÉTARO": {
      "76109": true
    }
  },
  "76110": {
    "QUERÉTARO": {
      "76110": true
    }
  },
  "76111": {
    "QUERÉTARO": {
      "76111": true
    }
  },
  "76112": {
    "QUERÉTARO": {
      "76112": true
    }
  },
  "76113": {
    "QUERÉTARO": {
      "76113": true
    }
  },
  "76114": {
    "QUERÉTARO": {
      "76114": true
    }
  },
  "76115": {
    "QUERÉTARO": {
      "76115": true
    }
  },
  "76116": {
    "QUERÉTARO": {
      "76116": true
    }
  },
  "76117": {
    "QUERÉTARO": {
      "76117": true
    }
  },
  "76118": {
    "QUERÉTARO": {
      "76118": true
    }
  },
  "76119": {
    "QUERÉTARO": {
      "76119": true
    }
  },
  "76120": {
    "QUERÉTARO": {
      "76120": true
    }
  },
  "76121": {
    "QUERÉTARO": {
      "76121": true
    }
  },
  "76122": {
    "QUERÉTARO": {
      "76122": true
    }
  },
  "76123": {
    "QUERÉTARO": {
      "76123": true
    }
  },
  "76124": {
    "QUERÉTARO": {
      "76124": true
    }
  },
  "76125": {
    "QUERÉTARO": {
      "76125": true
    }
  },
  "76126": {
    "QUERÉTARO": {
      "76126": true
    }
  },
  "76127": {
    "QUERÉTARO": {
      "76127": true
    }
  },
  "76128": {
    "QUERÉTARO": {
      "76128": true
    }
  },
  "76129": {
    "QUERÉTARO": {
      "76129": true
    }
  },
  "76130": {
    "QUERÉTARO": {
      "76130": true
    }
  },
  "76131": {
    "QUERÉTARO": {
      "76131": true
    }
  },
  "76132": {
    "QUERÉTARO": {
      "76132": true
    }
  },
  "76133": {
    "QUERÉTARO": {
      "76133": true
    }
  },
  "76134": {
    "QUERÉTARO": {
      "76134": true
    }
  },
  "76135": {
    "QUERÉTARO": {
      "76135": true
    }
  },
  "76136": {
    "QUERÉTARO": {
      "76136": true
    }
  },
  "76137": {
    "QUERÉTARO": {
      "76137": true
    }
  },
  "76138": {
    "QUERÉTARO": {
      "76138": true
    }
  },
  "76139": {
    "QUERÉTARO": {
      "76139": true
    }
  },
  "76140": {
    "QUERÉTARO": {
      "76140": true
    }
  },
  "76141": {
    "QUERÉTARO": {
      "76141": true
    }
  },
  "76142": {
    "QUERÉTARO": {
      "76142": true
    }
  },
  "76143": {
    "QUERÉTARO": {
      "76143": true
    }
  },
  "76144": {
    "QUERÉTARO": {
      "76144": true
    }
  },
  "76145": {
    "QUERÉTARO": {
      "76145": true
    }
  },
  "76146": {
    "QUERÉTARO": {
      "76146": true
    }
  },
  "76147": {
    "QUERÉTARO": {
      "76147": true
    }
  },
  "76148": {
    "QUERÉTARO": {
      "76148": true
    }
  },
  "76149": {
    "QUERÉTARO": {
      "76149": true
    }
  },
  "76150": {
    "QUERÉTARO": {
      "76150": true
    }
  },
  "76151": {
    "QUERÉTARO": {
      "76151": true
    }
  },
  "76152": {
    "QUERÉTARO": {
      "76152": true
    }
  },
  "76153": {
    "QUERÉTARO": {
      "76153": true
    }
  },
  "76154": {
    "QUERÉTARO": {
      "76154": true
    }
  },
  "76155": {
    "QUERÉTARO": {
      "76155": true
    }
  },
  "76156": {
    "QUERÉTARO": {
      "76156": true
    }
  },
  "76157": {
    "QUERÉTARO": {
      "76157": true
    }
  },
  "76158": {
    "QUERÉTARO": {
      "76158": true
    }
  },
  "76159": {
    "QUERÉTARO": {
      "76159": true
    }
  },
  "76160": {
    "QUERÉTARO": {
      "76160": true
    }
  },
  "76161": {
    "QUERÉTARO": {
      "76161": true
    }
  },
  "76162": {
    "QUERÉTARO": {
      "76162": true
    }
  },
  "76163": {
    "QUERÉTARO": {
      "76163": true
    }
  },
  "76164": {
    "QUERÉTARO": {
      "76164": true
    }
  },
  "76165": {
    "QUERÉTARO": {
      "76165": true
    }
  },
  "76166": {
    "QUERÉTARO": {
      "76166": true
    }
  },
  "76167": {
    "QUERÉTARO": {
      "76167": true
    }
  },
  "76168": {
    "QUERÉTARO": {
      "76168": true
    }
  },
  "76169": {
    "QUERÉTARO": {
      "76169": true
    }
  },
  "76170": {
    "QUERÉTARO": {
      "76170": true
    }
  },
  "76171": {
    "QUERÉTARO": {
      "76171": true
    }
  },
  "76172": {
    "QUERÉTARO": {
      "76172": true
    }
  },
  "76173": {
    "QUERÉTARO": {
      "76173": true
    }
  },
  "76175": {
    "QUERÉTARO": {
      "76175": true
    }
  },
  "76176": {
    "QUERÉTARO": {
      "76176": true
    }
  },
  "76177": {
    "QUERÉTARO": {
      "76177": true
    }
  },
  "76178": {
    "QUERÉTARO": {
      "76178": true
    }
  },
  "76179": {
    "QUERÉTARO": {
      "76179": true
    }
  },
  "76180": {
    "QUERÉTARO": {
      "76180": true
    }
  },
  "76181": {
    "QUERÉTARO": {
      "76181": true
    }
  },
  "76182": {
    "QUERÉTARO": {
      "76182": true
    }
  },
  "76184": {
    "QUERÉTARO": {
      "76184": true
    }
  },
  "76185": {
    "QUERÉTARO": {
      "76185": true
    }
  },
  "76186": {
    "QUERÉTARO": {
      "76186": true
    }
  },
  "76187": {
    "QUERÉTARO": {
      "76187": true
    }
  },
  "76188": {
    "QUERÉTARO": {
      "76188": true
    }
  },
  "76189": {
    "QUERÉTARO": {
      "76189": true
    }
  },
  "76190": {
    "QUERÉTARO": {
      "76190": true
    }
  },
  "76191": {
    "QUERÉTARO": {
      "76191": true
    }
  },
  "76192": {
    "QUERÉTARO": {
      "76192": true
    }
  },
  "76193": {
    "QUERÉTARO": {
      "76193": true
    }
  },
  "76195": {
    "QUERÉTARO": {
      "76195": true
    }
  },
  "76196": {
    "QUERÉTARO": {
      "76196": true
    }
  },
  "76197": {
    "QUERÉTARO": {
      "76197": true
    }
  },
  "76198": {
    "QUERÉTARO": {
      "76198": true
    }
  },
  "76199": {
    "QUERÉTARO": {
      "76199": true
    }
  },
  "76206": {
    "QUERÉTARO": {
      "76206": true
    }
  },
  "76208": {
    "QUERÉTARO": {
      "76208": true
    }
  },
  "76212": {
    "QUERÉTARO": {
      "76212": true
    }
  },
  "76215": {
    "QUERÉTARO": {
      "76215": true
    }
  },
  "76220": {
    "QUERÉTARO": {
      "76220": true
    }
  },
  "76223": {
    "QUERÉTARO": {
      "76223": true
    }
  },
  "76225": {
    "QUERÉTARO": {
      "76225": true
    }
  },
  "76227": {
    "QUERÉTARO": {
      "76227": true
    }
  },
  "76229": {
    "QUERÉTARO": {
      "76229": true
    }
  },
  "76230": {
    "QUERÉTARO": {
      "76230": true
    }
  },
  "76233": {
    "QUERÉTARO": {
      "76233": true
    }
  },
  "76234": {
    "QUERÉTARO": {
      "76234": true
    }
  },
  "76235": {
    "QUERÉTARO": {
      "76235": true
    }
  },
  "76237": {
    "QUERÉTARO": {
      "76237": true
    }
  },
  "76238": {
    "QUERÉTARO": {
      "76238": true
    }
  },
  "77500": {
    "QUINTANA ROO": {
      "77500": true
    }
  },
  "77503": {
    "QUINTANA ROO": {
      "77503": true
    }
  },
  "77504": {
    "QUINTANA ROO": {
      "77504": true
    }
  },
  "77505": {
    "QUINTANA ROO": {
      "77505": true
    }
  },
  "77506": {
    "QUINTANA ROO": {
      "77506": true
    }
  },
  "77507": {
    "QUINTANA ROO": {
      "77507": true
    }
  },
  "77508": {
    "QUINTANA ROO": {
      "77508": true
    }
  },
  "77509": {
    "QUINTANA ROO": {
      "77509": true
    }
  },
  "77510": {
    "QUINTANA ROO": {
      "77510": true
    }
  },
  "77513": {
    "QUINTANA ROO": {
      "77513": true
    }
  },
  "77514": {
    "QUINTANA ROO": {
      "77514": true
    }
  },
  "77515": {
    "QUINTANA ROO": {
      "77515": true
    }
  },
  "77516": {
    "QUINTANA ROO": {
      "77516": true
    }
  },
  "77517": {
    "QUINTANA ROO": {
      "77517": true
    }
  },
  "77518": {
    "QUINTANA ROO": {
      "77518": true
    }
  },
  "77519": {
    "QUINTANA ROO": {
      "77519": true
    }
  },
  "77520": {
    "QUINTANA ROO": {
      "77520": true
    }
  },
  "77524": {
    "QUINTANA ROO": {
      "77524": true
    }
  },
  "77525": {
    "QUINTANA ROO": {
      "77525": true
    }
  },
  "77526": {
    "QUINTANA ROO": {
      "77526": true
    }
  },
  "77527": {
    "QUINTANA ROO": {
      "77527": true
    }
  },
  "77528": {
    "QUINTANA ROO": {
      "77528": true
    }
  },
  "77530": {
    "QUINTANA ROO": {
      "77530": true
    }
  },
  "77533": {
    "QUINTANA ROO": {
      "77533": true
    }
  },
  "77534": {
    "QUINTANA ROO": {
      "77534": true
    }
  },
  "77535": {
    "QUINTANA ROO": {
      "77535": true
    }
  },
  "77536": {
    "QUINTANA ROO": {
      "77536": true
    }
  },
  "77537": {
    "QUINTANA ROO": {
      "77537": true
    }
  },
  "77538": {
    "QUINTANA ROO": {
      "77538": true
    }
  },
  "77539": {
    "QUINTANA ROO": {
      "77539": true
    }
  },
  "77560": {
    "QUINTANA ROO": {
      "77560": true
    }
  },
  "77567": {
    "QUINTANA ROO": {
      "77567": true
    }
  },
  "77569": {
    "QUINTANA ROO": {
      "77569": true
    }
  },
  "80000": {
    "SINALOA": {
      "80000": true
    }
  },
  "80001": {
    "SINALOA": {
      "80001": true
    }
  },
  "80002": {
    "SINALOA": {
      "80002": true
    }
  },
  "80003": {
    "SINALOA": {
      "80003": true
    }
  },
  "80004": {
    "SINALOA": {
      "80004": true
    }
  },
  "80005": {
    "SINALOA": {
      "80005": true
    }
  },
  "80006": {
    "SINALOA": {
      "80006": true
    }
  },
  "80007": {
    "SINALOA": {
      "80007": true
    }
  },
  "80008": {
    "SINALOA": {
      "80008": true
    }
  },
  "80009": {
    "SINALOA": {
      "80009": true
    }
  },
  "80010": {
    "SINALOA": {
      "80010": true
    }
  },
  "80011": {
    "SINALOA": {
      "80011": true
    }
  },
  "80013": {
    "SINALOA": {
      "80013": true
    }
  },
  "80014": {
    "SINALOA": {
      "80014": true
    }
  },
  "80015": {
    "SINALOA": {
      "80015": true
    }
  },
  "80016": {
    "SINALOA": {
      "80016": true
    }
  },
  "80017": {
    "SINALOA": {
      "80017": true
    }
  },
  "80018": {
    "SINALOA": {
      "80018": true
    }
  },
  "80019": {
    "SINALOA": {
      "80019": true
    }
  },
  "80020": {
    "SINALOA": {
      "80020": true
    }
  },
  "80021": {
    "SINALOA": {
      "80021": true
    }
  },
  "80023": {
    "SINALOA": {
      "80023": true
    }
  },
  "80024": {
    "SINALOA": {
      "80024": true
    }
  },
  "80025": {
    "SINALOA": {
      "80025": true
    }
  },
  "80026": {
    "SINALOA": {
      "80026": true
    }
  },
  "80027": {
    "SINALOA": {
      "80027": true
    }
  },
  "80028": {
    "SINALOA": {
      "80028": true
    }
  },
  "80029": {
    "SINALOA": {
      "80029": true
    }
  },
  "80030": {
    "SINALOA": {
      "80030": true
    }
  },
  "80034": {
    "SINALOA": {
      "80034": true
    }
  },
  "80035": {
    "SINALOA": {
      "80035": true
    }
  },
  "80036": {
    "SINALOA": {
      "80036": true
    }
  },
  "80038": {
    "SINALOA": {
      "80038": true
    }
  },
  "80040": {
    "SINALOA": {
      "80040": true
    }
  },
  "80045": {
    "SINALOA": {
      "80045": true
    }
  },
  "80048": {
    "SINALOA": {
      "80048": true
    }
  },
  "80049": {
    "SINALOA": {
      "80049": true
    }
  },
  "80050": {
    "SINALOA": {
      "80050": true
    }
  },
  "80054": {
    "SINALOA": {
      "80054": true
    }
  },
  "80055": {
    "SINALOA": {
      "80055": true
    }
  },
  "80056": {
    "SINALOA": {
      "80056": true
    }
  },
  "80057": {
    "SINALOA": {
      "80057": true
    }
  },
  "80058": {
    "SINALOA": {
      "80058": true
    }
  },
  "80059": {
    "SINALOA": {
      "80059": true
    }
  },
  "80060": {
    "SINALOA": {
      "80060": true
    }
  },
  "80063": {
    "SINALOA": {
      "80063": true
    }
  },
  "80064": {
    "SINALOA": {
      "80064": true
    }
  },
  "80065": {
    "SINALOA": {
      "80065": true
    }
  },
  "80070": {
    "SINALOA": {
      "80070": true
    }
  },
  "80071": {
    "SINALOA": {
      "80071": true
    }
  },
  "80075": {
    "SINALOA": {
      "80075": true
    }
  },
  "80076": {
    "SINALOA": {
      "80076": true
    }
  },
  "80077": {
    "SINALOA": {
      "80077": true
    }
  },
  "80080": {
    "SINALOA": {
      "80080": true
    }
  },
  "80082": {
    "SINALOA": {
      "80082": true
    }
  },
  "80088": {
    "SINALOA": {
      "80088": true
    }
  },
  "80090": {
    "SINALOA": {
      "80090": true
    }
  },
  "80091": {
    "SINALOA": {
      "80091": true
    }
  },
  "80093": {
    "SINALOA": {
      "80093": true
    }
  },
  "80094": {
    "SINALOA": {
      "80094": true
    }
  },
  "80096": {
    "SINALOA": {
      "80096": true
    }
  },
  "80100": {
    "SINALOA": {
      "80100": true
    }
  },
  "80101": {
    "SINALOA": {
      "80101": true
    }
  },
  "80102": {
    "SINALOA": {
      "80102": true
    }
  },
  "80103": {
    "SINALOA": {
      "80103": true
    }
  },
  "80104": {
    "SINALOA": {
      "80104": true
    }
  },
  "80105": {
    "SINALOA": {
      "80105": true
    }
  },
  "80106": {
    "SINALOA": {
      "80106": true
    }
  },
  "80107": {
    "SINALOA": {
      "80107": true
    }
  },
  "80108": {
    "SINALOA": {
      "80108": true
    }
  },
  "80109": {
    "SINALOA": {
      "80109": true
    }
  },
  "80110": {
    "SINALOA": {
      "80110": true
    }
  },
  "80111": {
    "SINALOA": {
      "80111": true
    }
  },
  "80114": {
    "SINALOA": {
      "80114": true
    }
  },
  "80115": {
    "SINALOA": {
      "80115": true
    }
  },
  "80120": {
    "SINALOA": {
      "80120": true
    }
  },
  "80123": {
    "SINALOA": {
      "80123": true
    }
  },
  "80124": {
    "SINALOA": {
      "80124": true
    }
  },
  "80126": {
    "SINALOA": {
      "80126": true
    }
  },
  "80127": {
    "SINALOA": {
      "80127": true
    }
  },
  "80128": {
    "SINALOA": {
      "80128": true
    }
  },
  "80129": {
    "SINALOA": {
      "80129": true
    }
  },
  "80130": {
    "SINALOA": {
      "80130": true
    }
  },
  "80135": {
    "SINALOA": {
      "80135": true
    }
  },
  "80137": {
    "SINALOA": {
      "80137": true
    }
  },
  "80138": {
    "SINALOA": {
      "80138": true
    }
  },
  "80139": {
    "SINALOA": {
      "80139": true
    }
  },
  "80140": {
    "SINALOA": {
      "80140": true
    }
  },
  "80141": {
    "SINALOA": {
      "80141": true
    }
  },
  "80143": {
    "SINALOA": {
      "80143": true
    }
  },
  "80144": {
    "SINALOA": {
      "80144": true
    }
  },
  "80145": {
    "SINALOA": {
      "80145": true
    }
  },
  "80147": {
    "SINALOA": {
      "80147": true
    }
  },
  "80148": {
    "SINALOA": {
      "80148": true
    }
  },
  "80149": {
    "SINALOA": {
      "80149": true
    }
  },
  "80150": {
    "SINALOA": {
      "80150": true
    }
  },
  "80151": {
    "SINALOA": {
      "80151": true
    }
  },
  "80153": {
    "SINALOA": {
      "80153": true
    }
  },
  "80154": {
    "SINALOA": {
      "80154": true
    }
  },
  "80155": {
    "SINALOA": {
      "80155": true
    }
  },
  "80156": {
    "SINALOA": {
      "80156": true
    }
  },
  "80158": {
    "SINALOA": {
      "80158": true
    }
  },
  "80159": {
    "SINALOA": {
      "80159": true
    }
  },
  "80160": {
    "SINALOA": {
      "80160": true
    }
  },
  "80163": {
    "SINALOA": {
      "80163": true
    }
  },
  "80165": {
    "SINALOA": {
      "80165": true
    }
  },
  "80166": {
    "SINALOA": {
      "80166": true
    }
  },
  "80167": {
    "SINALOA": {
      "80167": true
    }
  },
  "80168": {
    "SINALOA": {
      "80168": true
    }
  },
  "80169": {
    "SINALOA": {
      "80169": true
    }
  },
  "80170": {
    "SINALOA": {
      "80170": true
    }
  },
  "80171": {
    "SINALOA": {
      "80171": true
    }
  },
  "80174": {
    "SINALOA": {
      "80174": true
    }
  },
  "80176": {
    "SINALOA": {
      "80176": true
    }
  },
  "80177": {
    "SINALOA": {
      "80177": true
    }
  },
  "80178": {
    "SINALOA": {
      "80178": true
    }
  },
  "80179": {
    "SINALOA": {
      "80179": true
    }
  },
  "80180": {
    "SINALOA": {
      "80180": true
    }
  },
  "80184": {
    "SINALOA": {
      "80184": true
    }
  },
  "80186": {
    "SINALOA": {
      "80186": true
    }
  },
  "80187": {
    "SINALOA": {
      "80187": true
    }
  },
  "80189": {
    "SINALOA": {
      "80189": true
    }
  },
  "80190": {
    "SINALOA": {
      "80190": true
    }
  },
  "80193": {
    "SINALOA": {
      "80193": true
    }
  },
  "80194": {
    "SINALOA": {
      "80194": true
    }
  },
  "80195": {
    "SINALOA": {
      "80195": true
    }
  },
  "80196": {
    "SINALOA": {
      "80196": true
    }
  },
  "80197": {
    "SINALOA": {
      "80197": true
    }
  },
  "80198": {
    "SINALOA": {
      "80198": true
    }
  },
  "80199": {
    "SINALOA": {
      "80199": true
    }
  },
  "80200": {
    "SINALOA": {
      "80200": true
    }
  },
  "80201": {
    "SINALOA": {
      "80201": true
    }
  },
  "80203": {
    "SINALOA": {
      "80203": true
    }
  },
  "80205": {
    "SINALOA": {
      "80205": true
    }
  },
  "80206": {
    "SINALOA": {
      "80206": true
    }
  },
  "80208": {
    "SINALOA": {
      "80208": true
    }
  },
  "80209": {
    "SINALOA": {
      "80209": true
    }
  },
  "80210": {
    "SINALOA": {
      "80210": true
    }
  },
  "80214": {
    "SINALOA": {
      "80214": true
    }
  },
  "80217": {
    "SINALOA": {
      "80217": true
    }
  },
  "80218": {
    "SINALOA": {
      "80218": true
    }
  },
  "80219": {
    "SINALOA": {
      "80219": true
    }
  },
  "80220": {
    "SINALOA": {
      "80220": true
    }
  },
  "80222": {
    "SINALOA": {
      "80222": true
    }
  },
  "80225": {
    "SINALOA": {
      "80225": true
    }
  },
  "80226": {
    "SINALOA": {
      "80226": true
    }
  },
  "80227": {
    "SINALOA": {
      "80227": true
    }
  },
  "80228": {
    "SINALOA": {
      "80228": true
    }
  },
  "80229": {
    "SINALOA": {
      "80229": true
    }
  },
  "80230": {
    "SINALOA": {
      "80230": true
    }
  },
  "80233": {
    "SINALOA": {
      "80233": true
    }
  },
  "80235": {
    "SINALOA": {
      "80235": true
    }
  },
  "80236": {
    "SINALOA": {
      "80236": true
    }
  },
  "80237": {
    "SINALOA": {
      "80237": true
    }
  },
  "80239": {
    "SINALOA": {
      "80239": true
    }
  },
  "80240": {
    "SINALOA": {
      "80240": true
    }
  },
  "80243": {
    "SINALOA": {
      "80243": true
    }
  },
  "80245": {
    "SINALOA": {
      "80245": true
    }
  },
  "80246": {
    "SINALOA": {
      "80246": true
    }
  },
  "80247": {
    "SINALOA": {
      "80247": true
    }
  },
  "80248": {
    "SINALOA": {
      "80248": true
    }
  },
  "80249": {
    "SINALOA": {
      "80249": true
    }
  },
  "80250": {
    "SINALOA": {
      "80250": true
    }
  },
  "80256": {
    "SINALOA": {
      "80256": true
    }
  },
  "80258": {
    "SINALOA": {
      "80258": true
    }
  },
  "80260": {
    "SINALOA": {
      "80260": true
    }
  },
  "80262": {
    "SINALOA": {
      "80262": true
    }
  },
  "80265": {
    "SINALOA": {
      "80265": true
    }
  },
  "80269": {
    "SINALOA": {
      "80269": true
    }
  },
  "80270": {
    "SINALOA": {
      "80270": true
    }
  },
  "80276": {
    "SINALOA": {
      "80276": true
    }
  },
  "80277": {
    "SINALOA": {
      "80277": true
    }
  },
  "80279": {
    "SINALOA": {
      "80279": true
    }
  },
  "80280": {
    "SINALOA": {
      "80280": true
    }
  },
  "80286": {
    "SINALOA": {
      "80286": true
    }
  },
  "80288": {
    "SINALOA": {
      "80288": true
    }
  },
  "80290": {
    "SINALOA": {
      "80290": true
    }
  },
  "80293": {
    "SINALOA": {
      "80293": true
    }
  },
  "80294": {
    "SINALOA": {
      "80294": true
    }
  },
  "80295": {
    "SINALOA": {
      "80295": true
    }
  },
  "80296": {
    "SINALOA": {
      "80296": true
    }
  },
  "80297": {
    "SINALOA": {
      "80297": true
    }
  },
  "80298": {
    "SINALOA": {
      "80298": true
    }
  },
  "80299": {
    "SINALOA": {
      "80299": true
    }
  },
  "80308": {
    "SINALOA": {
      "80308": true
    }
  },
  "82000": {
    "SINALOA": {
      "82000": true
    }
  },
  "82001": {
    "SINALOA": {
      "82001": true
    }
  },
  "82005": {
    "SINALOA": {
      "82005": true
    }
  },
  "82007": {
    "SINALOA": {
      "82007": true
    }
  },
  "82008": {
    "SINALOA": {
      "82008": true
    }
  },
  "82009": {
    "SINALOA": {
      "82009": true
    }
  },
  "82010": {
    "SINALOA": {
      "82010": true
    }
  },
  "82013": {
    "SINALOA": {
      "82013": true
    }
  },
  "82014": {
    "SINALOA": {
      "82014": true
    }
  },
  "82015": {
    "SINALOA": {
      "82015": true
    }
  },
  "82016": {
    "SINALOA": {
      "82016": true
    }
  },
  "82017": {
    "SINALOA": {
      "82017": true
    }
  },
  "82018": {
    "SINALOA": {
      "82018": true
    }
  },
  "82019": {
    "SINALOA": {
      "82019": true
    }
  },
  "82020": {
    "SINALOA": {
      "82020": true
    }
  },
  "82021": {
    "SINALOA": {
      "82021": true
    }
  },
  "82023": {
    "SINALOA": {
      "82023": true
    }
  },
  "82024": {
    "SINALOA": {
      "82024": true
    }
  },
  "82026": {
    "SINALOA": {
      "82026": true
    }
  },
  "82027": {
    "SINALOA": {
      "82027": true
    }
  },
  "82028": {
    "SINALOA": {
      "82028": true
    }
  },
  "82030": {
    "SINALOA": {
      "82030": true
    }
  },
  "82033": {
    "SINALOA": {
      "82033": true
    }
  },
  "82035": {
    "SINALOA": {
      "82035": true
    }
  },
  "82036": {
    "SINALOA": {
      "82036": true
    }
  },
  "82037": {
    "SINALOA": {
      "82037": true
    }
  },
  "82038": {
    "SINALOA": {
      "82038": true
    }
  },
  "82039": {
    "SINALOA": {
      "82039": true
    }
  },
  "82040": {
    "SINALOA": {
      "82040": true
    }
  },
  "82043": {
    "SINALOA": {
      "82043": true
    }
  },
  "82046": {
    "SINALOA": {
      "82046": true
    }
  },
  "82047": {
    "SINALOA": {
      "82047": true
    }
  },
  "82048": {
    "SINALOA": {
      "82048": true
    }
  },
  "82049": {
    "SINALOA": {
      "82049": true
    }
  },
  "82050": {
    "SINALOA": {
      "82050": true
    }
  },
  "82057": {
    "SINALOA": {
      "82057": true
    }
  },
  "82058": {
    "SINALOA": {
      "82058": true
    }
  },
  "82059": {
    "SINALOA": {
      "82059": true
    }
  },
  "82060": {
    "SINALOA": {
      "82060": true
    }
  },
  "82065": {
    "SINALOA": {
      "82065": true
    }
  },
  "82069": {
    "SINALOA": {
      "82069": true
    }
  },
  "82070": {
    "SINALOA": {
      "82070": true
    }
  },
  "82080": {
    "SINALOA": {
      "82080": true
    }
  },
  "82086": {
    "SINALOA": {
      "82086": true
    }
  },
  "82088": {
    "SINALOA": {
      "82088": true
    }
  },
  "82089": {
    "SINALOA": {
      "82089": true
    }
  },
  "82090": {
    "SINALOA": {
      "82090": true
    }
  },
  "82099": {
    "SINALOA": {
      "82099": true
    }
  },
  "82100": {
    "SINALOA": {
      "82100": true
    }
  },
  "82101": {
    "SINALOA": {
      "82101": true
    }
  },
  "82102": {
    "SINALOA": {
      "82102": true
    }
  },
  "82103": {
    "SINALOA": {
      "82103": true
    }
  },
  "82104": {
    "SINALOA": {
      "82104": true
    }
  },
  "82106": {
    "SINALOA": {
      "82106": true
    }
  },
  "82108": {
    "SINALOA": {
      "82108": true
    }
  },
  "82110": {
    "SINALOA": {
      "82110": true
    }
  },
  "82111": {
    "SINALOA": {
      "82111": true
    }
  },
  "82112": {
    "SINALOA": {
      "82112": true
    }
  },
  "82113": {
    "SINALOA": {
      "82113": true
    }
  },
  "82114": {
    "SINALOA": {
      "82114": true
    }
  },
  "82115": {
    "SINALOA": {
      "82115": true
    }
  },
  "82117": {
    "SINALOA": {
      "82117": true
    }
  },
  "82118": {
    "SINALOA": {
      "82118": true
    }
  },
  "82119": {
    "SINALOA": {
      "82119": true
    }
  },
  "82120": {
    "SINALOA": {
      "82120": true
    }
  },
  "82123": {
    "SINALOA": {
      "82123": true
    }
  },
  "82124": {
    "SINALOA": {
      "82124": true
    }
  },
  "82125": {
    "SINALOA": {
      "82125": true
    }
  },
  "82126": {
    "SINALOA": {
      "82126": true
    }
  },
  "82127": {
    "SINALOA": {
      "82127": true
    }
  },
  "82128": {
    "SINALOA": {
      "82128": true
    }
  },
  "82129": {
    "SINALOA": {
      "82129": true
    }
  },
  "82130": {
    "SINALOA": {
      "82130": true
    }
  },
  "82132": {
    "SINALOA": {
      "82132": true
    }
  },
  "82133": {
    "SINALOA": {
      "82133": true
    }
  },
  "82134": {
    "SINALOA": {
      "82134": true
    }
  },
  "82135": {
    "SINALOA": {
      "82135": true
    }
  },
  "82136": {
    "SINALOA": {
      "82136": true
    }
  },
  "82137": {
    "SINALOA": {
      "82137": true
    }
  },
  "82138": {
    "SINALOA": {
      "82138": true
    }
  },
  "82139": {
    "SINALOA": {
      "82139": true
    }
  },
  "82140": {
    "SINALOA": {
      "82140": true
    }
  },
  "82143": {
    "SINALOA": {
      "82143": true
    }
  },
  "82144": {
    "SINALOA": {
      "82144": true
    }
  },
  "82145": {
    "SINALOA": {
      "82145": true
    }
  },
  "82146": {
    "SINALOA": {
      "82146": true
    }
  },
  "82147": {
    "SINALOA": {
      "82147": true
    }
  },
  "82148": {
    "SINALOA": {
      "82148": true
    }
  },
  "82149": {
    "SINALOA": {
      "82149": true
    }
  },
  "82150": {
    "SINALOA": {
      "82150": true
    }
  },
  "82151": {
    "SINALOA": {
      "82151": true
    }
  },
  "82153": {
    "SINALOA": {
      "82153": true
    }
  },
  "82154": {
    "SINALOA": {
      "82154": true
    }
  },
  "82155": {
    "SINALOA": {
      "82155": true
    }
  },
  "82156": {
    "SINALOA": {
      "82156": true
    }
  },
  "82157": {
    "SINALOA": {
      "82157": true
    }
  },
  "82158": {
    "SINALOA": {
      "82158": true
    }
  },
  "82159": {
    "SINALOA": {
      "82159": true
    }
  },
  "82160": {
    "SINALOA": {
      "82160": true
    }
  },
  "82161": {
    "SINALOA": {
      "82161": true
    }
  },
  "82163": {
    "SINALOA": {
      "82163": true
    }
  },
  "82164": {
    "SINALOA": {
      "82164": true
    }
  },
  "82165": {
    "SINALOA": {
      "82165": true
    }
  },
  "82166": {
    "SINALOA": {
      "82166": true
    }
  },
  "82168": {
    "SINALOA": {
      "82168": true
    }
  },
  "82169": {
    "SINALOA": {
      "82169": true
    }
  },
  "82170": {
    "SINALOA": {
      "82170": true
    }
  },
  "82180": {
    "SINALOA": {
      "82180": true
    }
  },
  "82181": {
    "SINALOA": {
      "82181": true
    }
  },
  "82182": {
    "SINALOA": {
      "82182": true
    }
  },
  "82183": {
    "SINALOA": {
      "82183": true
    }
  },
  "82185": {
    "SINALOA": {
      "82185": true
    }
  },
  "82186": {
    "SINALOA": {
      "82186": true
    }
  },
  "82187": {
    "SINALOA": {
      "82187": true
    }
  },
  "82188": {
    "SINALOA": {
      "82188": true
    }
  },
  "82189": {
    "SINALOA": {
      "82189": true
    }
  },
  "82190": {
    "SINALOA": {
      "82190": true
    }
  },
  "82192": {
    "SINALOA": {
      "82192": true
    }
  },
  "82193": {
    "SINALOA": {
      "82193": true
    }
  },
  "82195": {
    "SINALOA": {
      "82195": true
    }
  },
  "82196": {
    "SINALOA": {
      "82196": true
    }
  },
  "82197": {
    "SINALOA": {
      "82197": true
    }
  },
  "82198": {
    "SINALOA": {
      "82198": true
    }
  },
  "82199": {
    "SINALOA": {
      "82199": true
    }
  },
  "86000": {
    "TABASCO": {
      "86000": true
    }
  },
  "86010": {
    "TABASCO": {
      "86010": true
    }
  },
  "86017": {
    "TABASCO": {
      "86017": true
    }
  },
  "86018": {
    "TABASCO": {
      "86018": true
    }
  },
  "86019": {
    "TABASCO": {
      "86019": true
    }
  },
  "86020": {
    "TABASCO": {
      "86020": true
    }
  },
  "86026": {
    "TABASCO": {
      "86026": true
    }
  },
  "86029": {
    "TABASCO": {
      "86029": true
    }
  },
  "86030": {
    "TABASCO": {
      "86030": true
    }
  },
  "86035": {
    "TABASCO": {
      "86035": true
    }
  },
  "86037": {
    "TABASCO": {
      "86037": true
    }
  },
  "86038": {
    "TABASCO": {
      "86038": true
    }
  },
  "86039": {
    "TABASCO": {
      "86039": true
    }
  },
  "86040": {
    "TABASCO": {
      "86040": true
    }
  },
  "86049": {
    "TABASCO": {
      "86049": true
    }
  },
  "86050": {
    "TABASCO": {
      "86050": true
    }
  },
  "86060": {
    "TABASCO": {
      "86060": true
    }
  },
  "86067": {
    "TABASCO": {
      "86067": true
    }
  },
  "86068": {
    "TABASCO": {
      "86068": true
    }
  },
  "86069": {
    "TABASCO": {
      "86069": true
    }
  },
  "86070": {
    "TABASCO": {
      "86070": true
    }
  },
  "86079": {
    "TABASCO": {
      "86079": true
    }
  },
  "86080": {
    "TABASCO": {
      "86080": true
    }
  },
  "86087": {
    "TABASCO": {
      "86087": true
    }
  },
  "86096": {
    "TABASCO": {
      "86096": true
    }
  },
  "86097": {
    "TABASCO": {
      "86097": true
    }
  },
  "86098": {
    "TABASCO": {
      "86098": true
    }
  },
  "86099": {
    "TABASCO": {
      "86099": true
    }
  },
  "86100": {
    "TABASCO": {
      "86100": true
    }
  },
  "86107": {
    "TABASCO": {
      "86107": true
    }
  },
  "86108": {
    "TABASCO": {
      "86108": true
    }
  },
  "86109": {
    "TABASCO": {
      "86109": true
    }
  },
  "86120": {
    "TABASCO": {
      "86120": true
    }
  },
  "86125": {
    "TABASCO": {
      "86125": true
    }
  },
  "86126": {
    "TABASCO": {
      "86126": true
    }
  },
  "86127": {
    "TABASCO": {
      "86127": true
    }
  },
  "86129": {
    "TABASCO": {
      "86129": true
    }
  },
  "86130": {
    "TABASCO": {
      "86130": true
    }
  },
  "86137": {
    "TABASCO": {
      "86137": true
    }
  },
  "86140": {
    "TABASCO": {
      "86140": true
    }
  },
  "86143": {
    "TABASCO": {
      "86143": true
    }
  },
  "86149": {
    "TABASCO": {
      "86149": true
    }
  },
  "86150": {
    "TABASCO": {
      "86150": true
    }
  },
  "86153": {
    "TABASCO": {
      "86153": true
    }
  },
  "86160": {
    "TABASCO": {
      "86160": true
    }
  },
  "86167": {
    "TABASCO": {
      "86167": true
    }
  },
  "86168": {
    "TABASCO": {
      "86168": true
    }
  },
  "86169": {
    "TABASCO": {
      "86169": true
    }
  },
  "86170": {
    "TABASCO": {
      "86170": true
    }
  },
  "86179": {
    "TABASCO": {
      "86179": true
    }
  },
  "86180": {
    "TABASCO": {
      "86180": true
    }
  },
  "86189": {
    "TABASCO": {
      "86189": true
    }
  },
  "86190": {
    "TABASCO": {
      "86190": true
    }
  },
  "86193": {
    "TABASCO": {
      "86193": true
    }
  },
  "97000": {
    "YUCATÁN": {
      "97000": true
    }
  },
  "97003": {
    "YUCATÁN": {
      "97003": true
    }
  },
  "97050": {
    "YUCATÁN": {
      "97050": true
    }
  },
  "97059": {
    "YUCATÁN": {
      "97059": true
    }
  },
  "97060": {
    "YUCATÁN": {
      "97060": true
    }
  },
  "97068": {
    "YUCATÁN": {
      "97068": true
    }
  },
  "97069": {
    "YUCATÁN": {
      "97069": true
    }
  },
  "97070": {
    "YUCATÁN": {
      "97070": true
    }
  },
  "97080": {
    "YUCATÁN": {
      "97080": true
    }
  },
  "97088": {
    "YUCATÁN": {
      "97088": true
    }
  },
  "97089": {
    "YUCATÁN": {
      "97089": true
    }
  },
  "97098": {
    "YUCATÁN": {
      "97098": true
    }
  },
  "97099": {
    "YUCATÁN": {
      "97099": true
    }
  },
  "97100": {
    "YUCATÁN": {
      "97100": true
    }
  },
  "97107": {
    "YUCATÁN": {
      "97107": true
    }
  },
  "97108": {
    "YUCATÁN": {
      "97108": true
    }
  },
  "97109": {
    "YUCATÁN": {
      "97109": true
    }
  },
  "97110": {
    "YUCATÁN": {
      "97110": true
    }
  },
  "97113": {
    "YUCATÁN": {
      "97113": true
    }
  },
  "97114": {
    "YUCATÁN": {
      "97114": true
    }
  },
  "97115": {
    "YUCATÁN": {
      "97115": true
    }
  },
  "97116": {
    "YUCATÁN": {
      "97116": true
    }
  },
  "97117": {
    "YUCATÁN": {
      "97117": true
    }
  },
  "97118": {
    "YUCATÁN": {
      "97118": true
    }
  },
  "97119": {
    "YUCATÁN": {
      "97119": true
    }
  },
  "97120": {
    "YUCATÁN": {
      "97120": true
    }
  },
  "97121": {
    "YUCATÁN": {
      "97121": true
    }
  },
  "97125": {
    "YUCATÁN": {
      "97125": true
    }
  },
  "97127": {
    "YUCATÁN": {
      "97127": true
    }
  },
  "97128": {
    "YUCATÁN": {
      "97128": true
    }
  },
  "97129": {
    "YUCATÁN": {
      "97129": true
    }
  },
  "97130": {
    "YUCATÁN": {
      "97130": true
    }
  },
  "97133": {
    "YUCATÁN": {
      "97133": true
    }
  },
  "97134": {
    "YUCATÁN": {
      "97134": true
    }
  },
  "97135": {
    "YUCATÁN": {
      "97135": true
    }
  },
  "97136": {
    "YUCATÁN": {
      "97136": true
    }
  },
  "97137": {
    "YUCATÁN": {
      "97137": true
    }
  },
  "97138": {
    "YUCATÁN": {
      "97138": true
    }
  },
  "97139": {
    "YUCATÁN": {
      "97139": true
    }
  },
  "97140": {
    "YUCATÁN": {
      "97140": true
    }
  },
  "97142": {
    "YUCATÁN": {
      "97142": true
    }
  },
  "97143": {
    "YUCATÁN": {
      "97143": true
    }
  },
  "97144": {
    "YUCATÁN": {
      "97144": true
    }
  },
  "97145": {
    "YUCATÁN": {
      "97145": true
    }
  },
  "97146": {
    "YUCATÁN": {
      "97146": true
    }
  },
  "97147": {
    "YUCATÁN": {
      "97147": true
    }
  },
  "97148": {
    "YUCATÁN": {
      "97148": true
    }
  },
  "97149": {
    "YUCATÁN": {
      "97149": true
    }
  },
  "97150": {
    "YUCATÁN": {
      "97150": true
    }
  },
  "97155": {
    "YUCATÁN": {
      "97155": true
    }
  },
  "97156": {
    "YUCATÁN": {
      "97156": true
    }
  },
  "97157": {
    "YUCATÁN": {
      "97157": true
    }
  },
  "97158": {
    "YUCATÁN": {
      "97158": true
    }
  },
  "97159": {
    "YUCATÁN": {
      "97159": true
    }
  },
  "97160": {
    "YUCATÁN": {
      "97160": true
    }
  },
  "97165": {
    "YUCATÁN": {
      "97165": true
    }
  },
  "97166": {
    "YUCATÁN": {
      "97166": true
    }
  },
  "97167": {
    "YUCATÁN": {
      "97167": true
    }
  },
  "97168": {
    "YUCATÁN": {
      "97168": true
    }
  },
  "97169": {
    "YUCATÁN": {
      "97169": true
    }
  },
  "97170": {
    "YUCATÁN": {
      "97170": true
    }
  },
  "97173": {
    "YUCATÁN": {
      "97173": true
    }
  },
  "97174": {
    "YUCATÁN": {
      "97174": true
    }
  },
  "97175": {
    "YUCATÁN": {
      "97175": true
    }
  },
  "97176": {
    "YUCATÁN": {
      "97176": true
    }
  },
  "97177": {
    "YUCATÁN": {
      "97177": true
    }
  },
  "97178": {
    "YUCATÁN": {
      "97178": true
    }
  },
  "97179": {
    "YUCATÁN": {
      "97179": true
    }
  },
  "97180": {
    "YUCATÁN": {
      "97180": true
    }
  },
  "97189": {
    "YUCATÁN": {
      "97189": true
    }
  },
  "97190": {
    "YUCATÁN": {
      "97190": true
    }
  },
  "97195": {
    "YUCATÁN": {
      "97195": true
    }
  },
  "97196": {
    "YUCATÁN": {
      "97196": true
    }
  },
  "97197": {
    "YUCATÁN": {
      "97197": true
    }
  },
  "97198": {
    "YUCATÁN": {
      "97198": true
    }
  },
  "97199": {
    "YUCATÁN": {
      "97199": true
    }
  },
  "97200": {
    "YUCATÁN": {
      "97200": true
    }
  },
  "97203": {
    "YUCATÁN": {
      "97203": true
    }
  },
  "97204": {
    "YUCATÁN": {
      "97204": true
    }
  },
  "97205": {
    "YUCATÁN": {
      "97205": true
    }
  },
  "97206": {
    "YUCATÁN": {
      "97206": true
    }
  },
  "97207": {
    "YUCATÁN": {
      "97207": true
    }
  },
  "97208": {
    "YUCATÁN": {
      "97208": true
    }
  },
  "97209": {
    "YUCATÁN": {
      "97209": true
    }
  },
  "97210": {
    "YUCATÁN": {
      "97210": true
    }
  },
  "97215": {
    "YUCATÁN": {
      "97215": true
    }
  },
  "97217": {
    "YUCATÁN": {
      "97217": true
    }
  },
  "97218": {
    "YUCATÁN": {
      "97218": true
    }
  },
  "97219": {
    "YUCATÁN": {
      "97219": true
    }
  },
  "97220": {
    "YUCATÁN": {
      "97220": true
    }
  },
  "97225": {
    "YUCATÁN": {
      "97225": true
    }
  },
  "97226": {
    "YUCATÁN": {
      "97226": true
    }
  },
  "97227": {
    "YUCATÁN": {
      "97227": true
    }
  },
  "97229": {
    "YUCATÁN": {
      "97229": true
    }
  },
  "97230": {
    "YUCATÁN": {
      "97230": true
    }
  },
  "97237": {
    "YUCATÁN": {
      "97237": true
    }
  },
  "97238": {
    "YUCATÁN": {
      "97238": true
    }
  },
  "97239": {
    "YUCATÁN": {
      "97239": true
    }
  },
  "97240": {
    "YUCATÁN": {
      "97240": true
    }
  },
  "97245": {
    "YUCATÁN": {
      "97245": true
    }
  },
  "97246": {
    "YUCATÁN": {
      "97246": true
    }
  },
  "97247": {
    "YUCATÁN": {
      "97247": true
    }
  },
  "97249": {
    "YUCATÁN": {
      "97249": true
    }
  },
  "97250": {
    "YUCATÁN": {
      "97250": true
    }
  },
  "97255": {
    "YUCATÁN": {
      "97255": true
    }
  },
  "97256": {
    "YUCATÁN": {
      "97256": true
    }
  },
  "97258": {
    "YUCATÁN": {
      "97258": true
    }
  },
  "97259": {
    "YUCATÁN": {
      "97259": true
    }
  },
  "97260": {
    "YUCATÁN": {
      "97260": true
    }
  },
  "97267": {
    "YUCATÁN": {
      "97267": true
    }
  },
  "97268": {
    "YUCATÁN": {
      "97268": true
    }
  },
  "97269": {
    "YUCATÁN": {
      "97269": true
    }
  },
  "97270": {
    "YUCATÁN": {
      "97270": true
    }
  },
  "97277": {
    "YUCATÁN": {
      "97277": true
    }
  },
  "97278": {
    "YUCATÁN": {
      "97278": true
    }
  },
  "97279": {
    "YUCATÁN": {
      "97279": true
    }
  },
  "97280": {
    "YUCATÁN": {
      "97280": true
    }
  },
  "97284": {
    "YUCATÁN": {
      "97284": true
    }
  },
  "97285": {
    "YUCATÁN": {
      "97285": true
    }
  },
  "97286": {
    "YUCATÁN": {
      "97286": true
    }
  },
  "97287": {
    "YUCATÁN": {
      "97287": true
    }
  },
  "97288": {
    "YUCATÁN": {
      "97288": true
    }
  },
  "97289": {
    "YUCATÁN": {
      "97289": true
    }
  },
  "97290": {
    "YUCATÁN": {
      "97290": true
    }
  },
  "97295": {
    "YUCATÁN": {
      "97295": true
    }
  },
  "97296": {
    "YUCATÁN": {
      "97296": true
    }
  },
  "97297": {
    "YUCATÁN": {
      "97297": true
    }
  },
  "97298": {
    "YUCATÁN": {
      "97298": true
    }
  },
  "97299": {
    "YUCATÁN": {
      "97299": true
    }
  },
  "AGUASCALIENTES": {
    "AGUASCALIENTES": {
      "20000": true,
      "20001": true,
      "20002": true,
      "20003": true,
      "20004": true,
      "20005": true,
      "20006": true,
      "20007": true,
      "20008": true,
      "20009": true,
      "20010": true,
      "20011": true,
      "20012": true,
      "20013": true,
      "20014": true,
      "20015": true,
      "20016": true,
      "20017": true,
      "20018": true,
      "20019": true,
      "20020": true,
      "20021": true,
      "20022": true,
      "20023": true,
      "20024": true,
      "20025": true,
      "20026": true,
      "20027": true,
      "20028": true,
      "20029": true,
      "20030": true,
      "20031": true,
      "20032": true,
      "20033": true,
      "20034": true,
      "20035": true,
      "20036": true,
      "20037": true,
      "20038": true,
      "20039": true,
      "20040": true,
      "20041": true,
      "20042": true,
      "20043": true,
      "20044": true,
      "20045": true,
      "20046": true,
      "20047": true,
      "20048": true,
      "20049": true,
      "20050": true,
      "20051": true,
      "20052": true,
      "20053": true,
      "20054": true,
      "20055": true,
      "20056": true,
      "20057": true,
      "20058": true,
      "20059": true,
      "20060": true,
      "20061": true,
      "20062": true,
      "20063": true,
      "20064": true,
      "20065": true,
      "20066": true,
      "20067": true,
      "20068": true,
      "20069": true,
      "20070": true,
      "20071": true,
      "20072": true,
      "20073": true,
      "20074": true,
      "20075": true,
      "20076": true,
      "20077": true,
      "20078": true,
      "20079": true,
      "20080": true,
      "20081": true,
      "20082": true,
      "20083": true,
      "20084": true,
      "20085": true,
      "20086": true,
      "20087": true,
      "20088": true,
      "20089": true,
      "20090": true,
      "20091": true,
      "20092": true,
      "20093": true,
      "20094": true,
      "20095": true,
      "20096": true,
      "20097": true,
      "20098": true,
      "20099": true,
      "20100": true,
      "20101": true,
      "20102": true,
      "20103": true,
      "20104": true,
      "20105": true,
      "20106": true,
      "20107": true,
      "20108": true,
      "20109": true,
      "20110": true,
      "20111": true,
      "20112": true,
      "20113": true,
      "20114": true,
      "20115": true,
      "20116": true,
      "20117": true,
      "20118": true,
      "20119": true,
      "20120": true,
      "20121": true,
      "20122": true,
      "20123": true,
      "20124": true,
      "20125": true,
      "20126": true,
      "20127": true,
      "20128": true,
      "20129": true,
      "20130": true,
      "20131": true,
      "20132": true,
      "20133": true,
      "20134": true,
      "20135": true,
      "20136": true,
      "20137": true,
      "20138": true,
      "20139": true,
      "20140": true,
      "20141": true,
      "20142": true,
      "20143": true,
      "20144": true,
      "20145": true,
      "20146": true,
      "20147": true,
      "20148": true,
      "20149": true,
      "20150": true,
      "20151": true,
      "20152": true,
      "20153": true,
      "20154": true,
      "20155": true,
      "20156": true,
      "20157": true,
      "20158": true,
      "20159": true,
      "20160": true,
      "20161": true,
      "20162": true,
      "20163": true,
      "20164": true,
      "20165": true,
      "20166": true,
      "20167": true,
      "20168": true,
      "20169": true,
      "20170": true,
      "20171": true,
      "20172": true,
      "20173": true,
      "20174": true,
      "20175": true,
      "20176": true,
      "20177": true,
      "20178": true,
      "20179": true,
      "20180": true,
      "20181": true,
      "20182": true,
      "20183": true,
      "20184": true,
      "20185": true,
      "20186": true,
      "20187": true,
      "20188": true,
      "20189": true,
      "20190": true,
      "20191": true,
      "20192": true,
      "20193": true,
      "20194": true,
      "20195": true,
      "20196": true,
      "20197": true,
      "20198": true,
      "20199": true,
      "20200": true,
      "20201": true,
      "20202": true,
      "20203": true,
      "20204": true,
      "20205": true,
      "20206": true,
      "20207": true,
      "20208": true,
      "20209": true,
      "20210": true,
      "20211": true,
      "20212": true,
      "20213": true,
      "20214": true,
      "20215": true,
      "20216": true,
      "20217": true,
      "20218": true,
      "20219": true,
      "20220": true,
      "20221": true,
      "20222": true,
      "20223": true,
      "20224": true,
      "20225": true,
      "20226": true,
      "20227": true,
      "20228": true,
      "20229": true,
      "20230": true,
      "20231": true,
      "20232": true,
      "20233": true,
      "20234": true,
      "20235": true,
      "20236": true,
      "20237": true,
      "20238": true,
      "20239": true,
      "20240": true,
      "20241": true,
      "20242": true,
      "20243": true,
      "20244": true,
      "20245": true,
      "20246": true,
      "20247": true,
      "20248": true,
      "20249": true,
      "20250": true,
      "20251": true,
      "20252": true,
      "20253": true,
      "20254": true,
      "20255": true,
      "20256": true,
      "20257": true,
      "20258": true,
      "20259": true,
      "20260": true,
      "20261": true,
      "20262": true,
      "20263": true,
      "20264": true,
      "20265": true,
      "20266": true,
      "20267": true,
      "20268": true,
      "20269": true,
      "20270": true,
      "20271": true,
      "20272": true,
      "20273": true,
      "20274": true,
      "20275": true,
      "20276": true,
      "20277": true,
      "20278": true,
      "20279": true,
      "20280": true,
      "20281": true,
      "20282": true,
      "20283": true,
      "20284": true,
      "20285": true,
      "20286": true,
      "20287": true,
      "20288": true,
      "20289": true,
      "20290": true,
      "20291": true,
      "20292": true,
      "20293": true,
      "20294": true,
      "20295": true,
      "20296": true,
      "20297": true,
      "20298": true,
      "20299": true,
      "20310": true,
      "20311": true,
      "20312": true,
      "20313": true,
      "20314": true,
      "20315": true,
      "20316": true,
      "20317": true,
      "20318": true,
      "20319": true,
      "20320": true,
      "20321": true,
      "20322": true,
      "20323": true,
      "20324": true,
      "20325": true,
      "20326": true,
      "20327": true,
      "20328": true,
      "20329": true,
      "20340": true,
      "20341": true,
      "20342": true,
      "20343": true,
      "20344": true,
      "20345": true,
      "20346": true,
      "20347": true,
      "20348": true,
      "20349": true,
      "20363": true,
      "20364": true,
      "20365": true,
      "20366": true,
      "20367": true,
      "20368": true,
      "20369": true,
      "20370": true,
      "20371": true,
      "20372": true,
      "20373": true,
      "20374": true,
      "20375": true,
      "20376": true,
      "20377": true,
      "20378": true,
      "20379": true,
      "20380": true,
      "20381": true,
      "20382": true,
      "20383": true,
      "20384": true,
      "20385": true,
      "20386": true,
      "20387": true,
      "20388": true,
      "20389": true,
      "20390": true,
      "20391": true,
      "20392": true,
      "20393": true,
      "20394": true,
      "20395": true,
      "20396": true,
      "20397": true,
      "20398": true,
      "20399": true
    },
    "ASIENTOS": {
      "20700": true,
      "20701": true,
      "20702": true,
      "20703": true,
      "20704": true,
      "20705": true,
      "20706": true,
      "20707": true,
      "20708": true,
      "20709": true,
      "20710": true,
      "20711": true,
      "20712": true,
      "20713": true,
      "20714": true,
      "20715": true,
      "20716": true,
      "20717": true,
      "20718": true,
      "20719": true,
      "20720": true,
      "20721": true,
      "20722": true,
      "20723": true,
      "20724": true,
      "20725": true,
      "20726": true,
      "20727": true,
      "20728": true,
      "20729": true,
      "20730": true,
      "20731": true,
      "20732": true,
      "20733": true,
      "20734": true,
      "20735": true,
      "20736": true,
      "20737": true,
      "20738": true,
      "20739": true,
      "20740": true,
      "20741": true,
      "20742": true,
      "20743": true,
      "20744": true,
      "20745": true,
      "20746": true,
      "20747": true,
      "20748": true,
      "20749": true,
      "20750": true,
      "20751": true,
      "20752": true,
      "20753": true,
      "20754": true,
      "20755": true,
      "20756": true,
      "20757": true,
      "20758": true,
      "20759": true,
      "20760": true,
      "20761": true,
      "20762": true,
      "20763": true,
      "20764": true,
      "20765": true,
      "20766": true,
      "20767": true,
      "20768": true,
      "20769": true,
      "20770": true,
      "20771": true,
      "20772": true,
      "20773": true,
      "20774": true,
      "20775": true,
      "20776": true,
      "20777": true,
      "20778": true,
      "20779": true,
      "20780": true,
      "20781": true,
      "20782": true,
      "20783": true,
      "20784": true,
      "20785": true,
      "20786": true,
      "20787": true,
      "20788": true,
      "20789": true,
      "20790": true,
      "20791": true,
      "20792": true,
      "20793": true,
      "20794": true,
      "20795": true,
      "20796": true,
      "20797": true,
      "20798": true,
      "20799": true
    },
    "CALVILLO": {
      "20800": true,
      "20801": true,
      "20802": true,
      "20803": true,
      "20804": true,
      "20805": true,
      "20806": true,
      "20807": true,
      "20808": true,
      "20809": true,
      "20816": true,
      "20817": true,
      "20818": true,
      "20819": true,
      "20820": true,
      "20821": true,
      "20822": true,
      "20823": true,
      "20824": true,
      "20825": true,
      "20826": true,
      "20827": true,
      "20828": true,
      "20829": true,
      "20830": true,
      "20831": true,
      "20832": true,
      "20833": true,
      "20834": true,
      "20835": true,
      "20836": true,
      "20837": true,
      "20838": true,
      "20839": true,
      "20840": true,
      "20841": true,
      "20842": true,
      "20843": true,
      "20844": true,
      "20845": true,
      "20846": true,
      "20847": true,
      "20848": true,
      "20849": true,
      "20850": true,
      "20851": true,
      "20852": true,
      "20853": true,
      "20854": true,
      "20856": true,
      "20857": true,
      "20858": true,
      "20859": true,
      "20860": true,
      "20861": true,
      "20862": true,
      "20863": true,
      "20864": true,
      "20865": true,
      "20866": true,
      "20867": true,
      "20868": true,
      "20869": true,
      "20870": true,
      "20871": true,
      "20872": true,
      "20873": true,
      "20880": true,
      "20881": true,
      "20882": true,
      "20883": true,
      "20884": true,
      "20885": true,
      "20886": true,
      "20887": true,
      "20888": true,
      "20889": true,
      "20890": true,
      "20891": true,
      "20892": true,
      "20893": true,
      "20894": true,
      "20895": true,
      "20896": true,
      "20897": true,
      "20898": true,
      "20899": true
    },
    "COSIO": {
      "20460": true,
      "20461": true,
      "20462": true,
      "20463": true,
      "20464": true,
      "20465": true,
      "20466": true,
      "20467": true,
      "20468": true,
      "20469": true,
      "20470": true,
      "20471": true,
      "20472": true,
      "20473": true,
      "20474": true,
      "20475": true,
      "20476": true,
      "20477": true,
      "20478": true,
      "20479": true,
      "20480": true,
      "20481": true,
      "20482": true,
      "20483": true,
      "20484": true,
      "20485": true,
      "20486": true,
      "20487": true,
      "20488": true,
      "20489": true,
      "20490": true,
      "20491": true,
      "20492": true,
      "20493": true,
      "20494": true,
      "20495": true,
      "20496": true,
      "20497": true,
      "20498": true,
      "20499": true
    },
    "JESÚS MARÍA": {
      "20900": true,
      "20901": true,
      "20902": true,
      "20903": true,
      "20904": true,
      "20905": true,
      "20906": true,
      "20907": true,
      "20908": true,
      "20909": true,
      "20910": true,
      "20911": true,
      "20912": true,
      "20913": true,
      "20914": true,
      "20915": true,
      "20916": true,
      "20917": true,
      "20918": true,
      "20919": true,
      "20920": true,
      "20921": true,
      "20922": true,
      "20923": true,
      "20924": true,
      "20925": true,
      "20926": true,
      "20927": true,
      "20928": true,
      "20929": true,
      "20930": true,
      "20931": true,
      "20932": true,
      "20933": true,
      "20934": true,
      "20935": true,
      "20936": true,
      "20937": true,
      "20938": true,
      "20939": true,
      "20940": true,
      "20941": true,
      "20942": true,
      "20943": true,
      "20945": true,
      "20947": true,
      "20948": true,
      "20949": true,
      "20950": true,
      "20951": true,
      "20952": true,
      "20953": true,
      "20954": true,
      "20955": true,
      "20956": true,
      "20957": true,
      "20958": true,
      "20959": true,
      "20960": true,
      "20961": true,
      "20962": true,
      "20963": true,
      "20964": true,
      "20965": true,
      "20966": true,
      "20967": true,
      "20968": true,
      "20969": true,
      "20970": true,
      "20971": true,
      "20972": true,
      "20973": true,
      "20974": true,
      "20975": true,
      "20976": true,
      "20977": true,
      "20978": true,
      "20979": true,
      "20980": true,
      "20981": true,
      "20982": true,
      "20983": true,
      "20984": true,
      "20985": true,
      "20986": true,
      "20987": true,
      "20988": true,
      "20989": true,
      "20990": true,
      "20991": true,
      "20992": true,
      "20993": true,
      "20994": true,
      "20995": true,
      "20996": true,
      "20997": true,
      "20998": true,
      "20999": true
    },
    "PABELLON DE ARTEAGA": {
      "20663": true,
      "20664": true,
      "20665": true,
      "20666": true,
      "20667": true,
      "20668": true,
      "20669": true,
      "20670": true,
      "20671": true,
      "20672": true,
      "20673": true,
      "20674": true,
      "20675": true,
      "20676": true,
      "20677": true,
      "20678": true,
      "20679": true,
      "20680": true,
      "20681": true,
      "20682": true,
      "20683": true,
      "20684": true,
      "20685": true,
      "20686": true,
      "20687": true,
      "20688": true,
      "20689": true,
      "20690": true,
      "20691": true,
      "20692": true,
      "20693": true,
      "20694": true,
      "20695": true,
      "20696": true,
      "20697": true,
      "20698": true,
      "20699": true
    },
    "RINCON DE ROMOS": {
      "20400": true,
      "20401": true,
      "20402": true,
      "20403": true,
      "20404": true,
      "20405": true,
      "20406": true,
      "20407": true,
      "20408": true,
      "20409": true,
      "20410": true,
      "20411": true,
      "20412": true,
      "20413": true,
      "20414": true,
      "20415": true,
      "20416": true,
      "20417": true,
      "20418": true,
      "20419": true,
      "20420": true,
      "20421": true,
      "20422": true,
      "20423": true,
      "20424": true,
      "20425": true,
      "20426": true,
      "20427": true,
      "20428": true,
      "20429": true,
      "20430": true,
      "20431": true,
      "20432": true,
      "20433": true,
      "20434": true,
      "20435": true,
      "20436": true,
      "20437": true,
      "20438": true,
      "20439": true,
      "20440": true,
      "20441": true,
      "20442": true,
      "20443": true,
      "20444": true,
      "20445": true,
      "20446": true,
      "20447": true,
      "20448": true,
      "20449": true,
      "20450": true,
      "20451": true,
      "20452": true,
      "20453": true
    },
    "SAN FRANCISCO DE LOS ROMO": {
      "20300": true,
      "20301": true,
      "20302": true,
      "20303": true,
      "20304": true,
      "20305": true,
      "20306": true,
      "20307": true,
      "20308": true,
      "20309": true,
      "20350": true,
      "20351": true,
      "20352": true,
      "20353": true,
      "20354": true,
      "20355": true,
      "20356": true,
      "20357": true,
      "20358": true,
      "20359": true,
      "20360": true,
      "20361": true,
      "20362": true
    },
    "SAN JOSE DE GRACIA": {
      "20500": true,
      "20501": true,
      "20502": true,
      "20503": true,
      "20504": true,
      "20505": true,
      "20506": true,
      "20507": true,
      "20508": true,
      "20509": true,
      "20510": true,
      "20511": true,
      "20512": true,
      "20513": true,
      "20514": true,
      "20515": true,
      "20516": true,
      "20517": true,
      "20518": true,
      "20519": true,
      "20540": true,
      "20541": true,
      "20542": true,
      "20543": true,
      "20544": true,
      "20545": true,
      "20546": true,
      "20547": true,
      "20548": true,
      "20549": true,
      "20550": true,
      "20551": true,
      "20552": true,
      "20553": true,
      "20554": true,
      "20555": true,
      "20556": true,
      "20557": true,
      "20558": true,
      "20559": true,
      "20560": true,
      "20561": true,
      "20562": true,
      "20563": true,
      "20564": true,
      "20565": true,
      "20566": true,
      "20567": true,
      "20568": true,
      "20569": true,
      "20576": true,
      "20577": true,
      "20578": true,
      "20579": true,
      "20580": true,
      "20581": true,
      "20582": true,
      "20583": true,
      "20584": true,
      "20585": true,
      "20586": true,
      "20587": true,
      "20588": true,
      "20589": true,
      "20590": true,
      "20591": true,
      "20592": true,
      "20593": true,
      "20594": true,
      "20595": true,
      "20596": true,
      "20597": true,
      "20598": true,
      "20599": true
    },
    "TEPEZALA": {
      "20600": true,
      "20601": true,
      "20602": true,
      "20603": true,
      "20604": true,
      "20605": true,
      "20606": true,
      "20607": true,
      "20608": true,
      "20609": true,
      "20610": true,
      "20611": true,
      "20612": true,
      "20613": true,
      "20614": true,
      "20615": true,
      "20616": true,
      "20617": true,
      "20618": true,
      "20619": true,
      "20620": true,
      "20621": true,
      "20622": true,
      "20623": true,
      "20624": true,
      "20625": true,
      "20626": true,
      "20627": true,
      "20628": true,
      "20629": true,
      "20630": true,
      "20631": true,
      "20632": true,
      "20633": true,
      "20634": true,
      "20635": true,
      "20636": true,
      "20637": true,
      "20638": true,
      "20639": true,
      "20640": true,
      "20641": true,
      "20642": true,
      "20643": true,
      "20644": true,
      "20645": true,
      "20646": true,
      "20647": true,
      "20648": true,
      "20649": true,
      "20650": true,
      "20651": true,
      "20652": true,
      "20653": true,
      "20654": true,
      "20655": true,
      "20656": true,
      "20657": true,
      "20658": true,
      "20659": true,
      "20660": true,
      "20661": true,
      "20662": true
    }
  },
  "BAJA CALIFORNIA": {
    "ENSENADA": {
      "22750": true,
      "22751": true,
      "22752": true,
      "22753": true,
      "22754": true,
      "22755": true,
      "22760": true,
      "22761": true,
      "22765": true,
      "22766": true,
      "22767": true,
      "22768": true,
      "22769": true,
      "22770": true,
      "22771": true,
      "22772": true,
      "22773": true,
      "22774": true,
      "22775": true,
      "22776": true,
      "22777": true,
      "22778": true,
      "22779": true,
      "22780": true,
      "22781": true,
      "22782": true,
      "22783": true,
      "22784": true,
      "22785": true,
      "22786": true,
      "22787": true,
      "22788": true,
      "22789": true,
      "22790": true,
      "22791": true,
      "22792": true,
      "22793": true,
      "22794": true,
      "22795": true,
      "22796": true,
      "22798": true,
      "22799": true,
      "22800": true,
      "22801": true,
      "22802": true,
      "22803": true,
      "22804": true,
      "22805": true,
      "22806": true,
      "22807": true,
      "22808": true,
      "22809": true,
      "22810": true,
      "22811": true,
      "22812": true,
      "22813": true,
      "22814": true,
      "22815": true,
      "22816": true,
      "22817": true,
      "22818": true,
      "22819": true,
      "22820": true,
      "22821": true,
      "22822": true,
      "22823": true,
      "22824": true,
      "22825": true,
      "22826": true,
      "22827": true,
      "22828": true,
      "22829": true,
      "22830": true,
      "22831": true,
      "22832": true,
      "22833": true,
      "22834": true,
      "22835": true,
      "22836": true,
      "22837": true,
      "22838": true,
      "22839": true,
      "22840": true,
      "22841": true,
      "22842": true,
      "22843": true,
      "22844": true,
      "22845": true,
      "22846": true,
      "22847": true,
      "22848": true,
      "22849": true,
      "22850": true,
      "22851": true,
      "22852": true,
      "22853": true,
      "22854": true,
      "22855": true,
      "22856": true,
      "22857": true,
      "22858": true,
      "22859": true,
      "22860": true,
      "22861": true,
      "22862": true,
      "22863": true,
      "22864": true,
      "22865": true,
      "22866": true,
      "22867": true,
      "22868": true,
      "22869": true,
      "22870": true,
      "22871": true,
      "22872": true,
      "22873": true,
      "22874": true,
      "22875": true,
      "22876": true,
      "22877": true,
      "22878": true,
      "22879": true,
      "22880": true,
      "22881": true,
      "22882": true,
      "22883": true,
      "22884": true,
      "22885": true,
      "22886": true,
      "22887": true,
      "22888": true,
      "22889": true,
      "22890": true,
      "22891": true,
      "22892": true,
      "22893": true,
      "22894": true,
      "22895": true,
      "22896": true,
      "22897": true,
      "22898": true,
      "22899": true,
      "22900": true,
      "22901": true,
      "22902": true,
      "22905": true,
      "22906": true,
      "22907": true,
      "22909": true
    },
    "MEXICALI": {
      "21000": true,
      "21001": true,
      "21002": true,
      "21003": true,
      "21004": true,
      "21005": true,
      "21006": true,
      "21007": true,
      "21008": true,
      "21009": true,
      "21010": true,
      "21011": true,
      "21012": true,
      "21013": true,
      "21014": true,
      "21015": true,
      "21016": true,
      "21017": true,
      "21018": true,
      "21019": true,
      "21020": true,
      "21021": true,
      "21022": true,
      "21023": true,
      "21024": true,
      "21025": true,
      "21026": true,
      "21027": true,
      "21028": true,
      "21029": true,
      "21030": true,
      "21031": true,
      "21032": true,
      "21033": true,
      "21034": true,
      "21035": true,
      "21036": true,
      "21037": true,
      "21038": true,
      "21039": true,
      "21040": true,
      "21041": true,
      "21042": true,
      "21043": true,
      "21044": true,
      "21045": true,
      "21046": true,
      "21047": true,
      "21048": true,
      "21049": true,
      "21050": true,
      "21051": true,
      "21052": true,
      "21053": true,
      "21054": true,
      "21055": true,
      "21056": true,
      "21057": true,
      "21058": true,
      "21059": true,
      "21060": true,
      "21061": true,
      "21062": true,
      "21063": true,
      "21064": true,
      "21065": true,
      "21066": true,
      "21067": true,
      "21068": true,
      "21069": true,
      "21070": true,
      "21071": true,
      "21072": true,
      "21073": true,
      "21074": true,
      "21075": true,
      "21076": true,
      "21077": true,
      "21078": true,
      "21079": true,
      "21080": true,
      "21081": true,
      "21082": true,
      "21083": true,
      "21084": true,
      "21085": true,
      "21086": true,
      "21087": true,
      "21088": true,
      "21089": true,
      "21090": true,
      "21091": true,
      "21092": true,
      "21093": true,
      "21094": true,
      "21095": true,
      "21096": true,
      "21097": true,
      "21098": true,
      "21099": true,
      "21100": true,
      "21101": true,
      "21102": true,
      "21103": true,
      "21104": true,
      "21105": true,
      "21106": true,
      "21107": true,
      "21108": true,
      "21109": true,
      "21110": true,
      "21111": true,
      "21112": true,
      "21113": true,
      "21114": true,
      "21115": true,
      "21116": true,
      "21117": true,
      "21118": true,
      "21119": true,
      "21120": true,
      "21121": true,
      "21122": true,
      "21123": true,
      "21124": true,
      "21125": true,
      "21126": true,
      "21127": true,
      "21128": true,
      "21129": true,
      "21130": true,
      "21131": true,
      "21132": true,
      "21133": true,
      "21134": true,
      "21135": true,
      "21136": true,
      "21137": true,
      "21138": true,
      "21139": true,
      "21140": true,
      "21141": true,
      "21142": true,
      "21143": true,
      "21144": true,
      "21145": true,
      "21146": true,
      "21147": true,
      "21148": true,
      "21149": true,
      "21150": true,
      "21151": true,
      "21152": true,
      "21153": true,
      "21154": true,
      "21155": true,
      "21156": true,
      "21157": true,
      "21158": true,
      "21159": true,
      "21160": true,
      "21161": true,
      "21162": true,
      "21163": true,
      "21164": true,
      "21165": true,
      "21166": true,
      "21167": true,
      "21168": true,
      "21169": true,
      "21170": true,
      "21171": true,
      "21172": true,
      "21173": true,
      "21174": true,
      "21175": true,
      "21176": true,
      "21177": true,
      "21178": true,
      "21179": true,
      "21180": true,
      "21181": true,
      "21182": true,
      "21183": true,
      "21184": true,
      "21185": true,
      "21186": true,
      "21187": true,
      "21188": true,
      "21189": true,
      "21190": true,
      "21191": true,
      "21192": true,
      "21193": true,
      "21194": true,
      "21195": true,
      "21196": true,
      "21197": true,
      "21198": true,
      "21199": true,
      "21200": true,
      "21201": true,
      "21202": true,
      "21203": true,
      "21204": true,
      "21205": true,
      "21206": true,
      "21207": true,
      "21208": true,
      "21209": true,
      "21210": true,
      "21211": true,
      "21212": true,
      "21213": true,
      "21214": true,
      "21215": true,
      "21216": true,
      "21217": true,
      "21218": true,
      "21219": true,
      "21220": true,
      "21221": true,
      "21222": true,
      "21223": true,
      "21224": true,
      "21225": true,
      "21226": true,
      "21227": true,
      "21228": true,
      "21229": true,
      "21230": true,
      "21231": true,
      "21232": true,
      "21233": true,
      "21234": true,
      "21235": true,
      "21236": true,
      "21237": true,
      "21238": true,
      "21239": true,
      "21240": true,
      "21241": true,
      "21242": true,
      "21243": true,
      "21244": true,
      "21245": true,
      "21246": true,
      "21247": true,
      "21248": true,
      "21249": true,
      "21250": true,
      "21251": true,
      "21252": true,
      "21253": true,
      "21254": true,
      "21255": true,
      "21256": true,
      "21257": true,
      "21258": true,
      "21259": true,
      "21260": true,
      "21261": true,
      "21262": true,
      "21263": true,
      "21264": true,
      "21265": true,
      "21266": true,
      "21267": true,
      "21268": true,
      "21269": true,
      "21270": true,
      "21271": true,
      "21272": true,
      "21273": true,
      "21274": true,
      "21275": true,
      "21276": true,
      "21277": true,
      "21278": true,
      "21279": true,
      "21280": true,
      "21281": true,
      "21282": true,
      "21283": true,
      "21284": true,
      "21285": true,
      "21286": true,
      "21287": true,
      "21288": true,
      "21289": true,
      "21290": true,
      "21291": true,
      "21292": true,
      "21293": true,
      "21294": true,
      "21295": true,
      "21296": true,
      "21297": true,
      "21298": true,
      "21299": true,
      "21300": true,
      "21301": true,
      "21302": true,
      "21303": true,
      "21304": true,
      "21305": true,
      "21306": true,
      "21307": true,
      "21308": true,
      "21309": true,
      "21310": true,
      "21311": true,
      "21312": true,
      "21313": true,
      "21314": true,
      "21315": true,
      "21316": true,
      "21317": true,
      "21318": true,
      "21319": true,
      "21320": true,
      "21321": true,
      "21322": true,
      "21323": true,
      "21324": true,
      "21325": true,
      "21326": true,
      "21327": true,
      "21328": true,
      "21329": true,
      "21330": true,
      "21331": true,
      "21332": true,
      "21333": true,
      "21334": true,
      "21335": true,
      "21336": true,
      "21337": true,
      "21338": true,
      "21339": true,
      "21340": true,
      "21341": true,
      "21342": true,
      "21343": true,
      "21344": true,
      "21345": true,
      "21346": true,
      "21347": true,
      "21348": true,
      "21349": true,
      "21350": true,
      "21351": true,
      "21352": true,
      "21353": true,
      "21354": true,
      "21355": true,
      "21356": true,
      "21357": true,
      "21358": true,
      "21359": true,
      "21360": true,
      "21361": true,
      "21362": true,
      "21363": true,
      "21364": true,
      "21365": true,
      "21366": true,
      "21367": true,
      "21368": true,
      "21369": true,
      "21370": true,
      "21371": true,
      "21372": true,
      "21373": true,
      "21374": true,
      "21375": true,
      "21376": true,
      "21377": true,
      "21378": true,
      "21379": true,
      "21380": true,
      "21381": true,
      "21382": true,
      "21383": true,
      "21384": true,
      "21385": true,
      "21386": true,
      "21387": true,
      "21388": true,
      "21389": true,
      "21390": true,
      "21391": true,
      "21392": true,
      "21393": true,
      "21394": true,
      "21395": true,
      "21396": true,
      "21397": true,
      "21398": true,
      "21399": true,
      "21600": true,
      "21601": true,
      "21602": true,
      "21603": true,
      "21604": true,
      "21605": true,
      "21606": true,
      "21607": true,
      "21608": true,
      "21609": true,
      "21610": true,
      "21611": true,
      "21612": true,
      "21613": true,
      "21614": true,
      "21615": true,
      "21616": true,
      "21617": true,
      "21618": true,
      "21619": true,
      "21620": true,
      "21621": true,
      "21622": true,
      "21623": true,
      "21624": true,
      "21625": true,
      "21626": true,
      "21627": true,
      "21628": true,
      "21629": true,
      "21630": true,
      "21631": true,
      "21632": true,
      "21633": true,
      "21634": true,
      "21635": true,
      "21636": true,
      "21637": true,
      "21638": true,
      "21639": true,
      "21640": true,
      "21641": true,
      "21642": true,
      "21643": true,
      "21644": true,
      "21645": true,
      "21646": true,
      "21647": true,
      "21648": true,
      "21649": true,
      "21650": true,
      "21651": true,
      "21652": true,
      "21653": true,
      "21654": true,
      "21655": true,
      "21656": true,
      "21657": true,
      "21658": true,
      "21659": true,
      "21660": true,
      "21661": true,
      "21662": true,
      "21663": true,
      "21664": true,
      "21665": true,
      "21666": true,
      "21667": true,
      "21668": true,
      "21669": true,
      "21670": true,
      "21671": true,
      "21672": true,
      "21673": true,
      "21674": true,
      "21675": true,
      "21676": true,
      "21677": true,
      "21678": true,
      "21679": true,
      "21680": true,
      "21681": true,
      "21682": true,
      "21683": true,
      "21684": true,
      "21685": true,
      "21686": true,
      "21687": true,
      "21688": true,
      "21689": true,
      "21690": true,
      "21691": true,
      "21692": true,
      "21693": true,
      "21694": true,
      "21695": true,
      "21696": true,
      "21697": true,
      "21698": true,
      "21699": true,
      "21700": true,
      "21701": true,
      "21702": true,
      "21703": true,
      "21704": true,
      "21705": true,
      "21706": true,
      "21707": true,
      "21708": true,
      "21709": true,
      "21710": true,
      "21711": true,
      "21712": true,
      "21713": true,
      "21714": true,
      "21715": true,
      "21716": true,
      "21717": true,
      "21718": true,
      "21719": true,
      "21720": true,
      "21721": true,
      "21722": true,
      "21723": true,
      "21724": true,
      "21725": true,
      "21726": true,
      "21727": true,
      "21728": true,
      "21729": true,
      "21730": true,
      "21731": true,
      "21732": true,
      "21733": true,
      "21734": true,
      "21735": true,
      "21736": true,
      "21737": true,
      "21738": true,
      "21739": true,
      "21740": true,
      "21741": true,
      "21742": true,
      "21743": true,
      "21744": true,
      "21745": true,
      "21746": true,
      "21747": true,
      "21748": true,
      "21749": true,
      "21750": true,
      "21751": true,
      "21752": true,
      "21753": true,
      "21754": true,
      "21755": true,
      "21756": true,
      "21757": true,
      "21758": true,
      "21759": true,
      "21760": true,
      "21761": true,
      "21762": true,
      "21763": true,
      "21764": true,
      "21765": true,
      "21766": true,
      "21767": true,
      "21768": true,
      "21769": true,
      "21770": true,
      "21771": true,
      "21772": true,
      "21773": true,
      "21774": true,
      "21775": true,
      "21776": true,
      "21777": true,
      "21778": true,
      "21779": true,
      "21780": true,
      "21781": true,
      "21782": true,
      "21783": true,
      "21784": true,
      "21785": true,
      "21786": true,
      "21787": true,
      "21788": true,
      "21789": true,
      "21790": true,
      "21791": true,
      "21792": true,
      "21793": true,
      "21794": true,
      "21795": true,
      "21796": true,
      "21797": true,
      "21798": true,
      "21799": true,
      "21800": true,
      "21801": true,
      "21802": true,
      "21803": true,
      "21804": true,
      "21805": true,
      "21806": true,
      "21807": true,
      "21808": true,
      "21809": true,
      "21810": true,
      "21811": true,
      "21812": true,
      "21813": true,
      "21814": true,
      "21815": true,
      "21816": true,
      "21817": true,
      "21818": true,
      "21819": true,
      "21820": true,
      "21821": true,
      "21822": true,
      "21823": true,
      "21824": true,
      "21825": true,
      "21826": true,
      "21827": true,
      "21828": true,
      "21829": true,
      "21830": true,
      "21831": true,
      "21832": true,
      "21833": true,
      "21834": true,
      "21835": true,
      "21836": true,
      "21837": true,
      "21838": true,
      "21839": true,
      "21840": true,
      "21841": true,
      "21842": true,
      "21843": true,
      "21844": true,
      "21845": true,
      "21846": true,
      "21847": true,
      "21848": true,
      "21849": true,
      "21850": true,
      "21851": true,
      "21852": true,
      "21853": true,
      "21854": true,
      "21855": true,
      "21856": true,
      "21857": true,
      "21858": true,
      "21859": true,
      "21860": true,
      "21861": true,
      "21862": true,
      "21863": true,
      "21864": true,
      "21865": true,
      "21866": true,
      "21867": true,
      "21868": true,
      "21869": true,
      "21870": true,
      "21871": true,
      "21872": true,
      "21873": true,
      "21874": true,
      "21875": true,
      "21876": true,
      "21877": true,
      "21878": true,
      "21879": true,
      "21880": true,
      "21881": true,
      "21882": true,
      "21883": true,
      "21884": true,
      "21885": true,
      "21886": true,
      "21887": true,
      "21888": true,
      "21889": true,
      "21890": true,
      "21891": true,
      "21892": true,
      "21893": true,
      "21894": true,
      "21895": true,
      "21896": true,
      "21897": true,
      "21898": true,
      "21899": true,
      "21900": true,
      "21901": true,
      "21902": true,
      "21903": true,
      "21904": true,
      "21905": true,
      "21906": true,
      "21907": true,
      "21908": true,
      "21909": true,
      "21910": true,
      "21911": true,
      "21912": true,
      "21913": true,
      "21914": true,
      "21915": true,
      "21916": true,
      "21917": true,
      "21918": true,
      "21919": true,
      "21920": true,
      "21921": true,
      "21922": true,
      "21923": true,
      "21924": true,
      "21925": true,
      "21926": true,
      "21927": true,
      "21928": true,
      "21929": true,
      "21930": true,
      "21931": true,
      "21932": true,
      "21933": true,
      "21934": true,
      "21935": true,
      "21936": true,
      "21937": true,
      "21938": true,
      "21939": true,
      "21940": true,
      "21941": true,
      "21942": true,
      "21943": true,
      "21944": true,
      "21945": true,
      "21946": true,
      "21947": true,
      "21948": true,
      "21949": true,
      "21950": true,
      "21951": true,
      "21952": true,
      "21953": true,
      "21954": true,
      "21955": true,
      "21956": true,
      "21957": true,
      "21958": true,
      "21959": true,
      "21960": true,
      "21961": true,
      "21962": true,
      "21963": true,
      "21964": true,
      "21965": true,
      "21966": true,
      "21967": true,
      "21968": true,
      "21969": true,
      "21970": true,
      "21971": true,
      "21972": true,
      "21973": true,
      "21974": true,
      "21975": true,
      "21976": true,
      "21977": true,
      "21978": true,
      "21979": true,
      "21980": true,
      "21981": true,
      "21982": true,
      "21983": true,
      "21984": true,
      "21985": true,
      "21986": true,
      "21987": true,
      "21988": true,
      "21989": true,
      "21990": true,
      "21991": true,
      "21992": true,
      "21993": true,
      "21994": true,
      "21995": true,
      "21996": true,
      "21997": true,
      "21998": true,
      "21999": true
    },
    "PLAYAS DE ROSARITO": {
      "22700": true,
      "22701": true,
      "22702": true,
      "22703": true,
      "22704": true,
      "22705": true,
      "22706": true,
      "22707": true,
      "22708": true,
      "22709": true,
      "22710": true,
      "22711": true,
      "22712": true,
      "22713": true,
      "22714": true,
      "22715": true,
      "22716": true,
      "22717": true,
      "22718": true,
      "22719": true,
      "22720": true,
      "22721": true,
      "22722": true,
      "22723": true,
      "22724": true,
      "22725": true,
      "22726": true,
      "22727": true,
      "22728": true,
      "22729": true,
      "22730": true,
      "22731": true,
      "22732": true,
      "22733": true,
      "22734": true,
      "22735": true,
      "22736": true,
      "22737": true,
      "22738": true,
      "22739": true,
      "22740": true,
      "22741": true,
      "22742": true,
      "22743": true,
      "22744": true,
      "22745": true,
      "22746": true,
      "22747": true,
      "22748": true,
      "22749": true
    },
    "SAN QUINTIN": {
      "22910": true,
      "22911": true,
      "22912": true,
      "22913": true,
      "22914": true,
      "22915": true,
      "22916": true,
      "22917": true,
      "22918": true,
      "22919": true,
      "22920": true,
      "22921": true,
      "22922": true,
      "22923": true,
      "22924": true,
      "22925": true,
      "22926": true,
      "22927": true,
      "22928": true,
      "22929": true,
      "22930": true,
      "22931": true,
      "22932": true,
      "22933": true,
      "22940": true,
      "22941": true,
      "22942": true,
      "22943": true,
      "22944": true,
      "22945": true,
      "22946": true,
      "22947": true,
      "22948": true,
      "22949": true,
      "22950": true,
      "22960": true,
      "22961": true,
      "22962": true,
      "22963": true,
      "22964": true,
      "22965": true,
      "22966": true,
      "22967": true,
      "22968": true,
      "22969": true,
      "22973": true,
      "22974": true,
      "22975": true,
      "22976": true,
      "22977": true,
      "22978": true,
      "22979": true,
      "22997": true,
      "22998": true,
      "22999": true
    },
    "TECATE": {
      "21400": true,
      "21401": true,
      "21402": true,
      "21403": true,
      "21404": true,
      "21405": true,
      "21406": true,
      "21407": true,
      "21408": true,
      "21409": true,
      "21410": true,
      "21411": true,
      "21412": true,
      "21413": true,
      "21414": true,
      "21415": true,
      "21416": true,
      "21417": true,
      "21418": true,
      "21419": true,
      "21420": true,
      "21421": true,
      "21422": true,
      "21423": true,
      "21424": true,
      "21425": true,
      "21426": true,
      "21427": true,
      "21428": true,
      "21429": true,
      "21430": true,
      "21431": true,
      "21432": true,
      "21433": true,
      "21434": true,
      "21435": true,
      "21436": true,
      "21437": true,
      "21438": true,
      "21439": true,
      "21440": true,
      "21441": true,
      "21442": true,
      "21443": true,
      "21444": true,
      "21445": true,
      "21446": true,
      "21447": true,
      "21448": true,
      "21449": true,
      "21450": true,
      "21451": true,
      "21452": true,
      "21453": true,
      "21454": true,
      "21455": true,
      "21456": true,
      "21457": true,
      "21458": true,
      "21459": true,
      "21460": true,
      "21461": true,
      "21462": true,
      "21463": true,
      "21464": true,
      "21465": true,
      "21466": true,
      "21467": true,
      "21468": true,
      "21469": true,
      "21470": true,
      "21471": true,
      "21472": true,
      "21473": true,
      "21474": true,
      "21475": true,
      "21476": true,
      "21477": true,
      "21478": true,
      "21479": true,
      "21480": true,
      "21481": true,
      "21482": true,
      "21483": true,
      "21484": true,
      "21485": true,
      "21486": true,
      "21487": true,
      "21488": true,
      "21489": true,
      "21490": true,
      "21491": true,
      "21492": true,
      "21493": true,
      "21494": true,
      "21495": true,
      "21496": true,
      "21497": true,
      "21498": true,
      "21499": true,
      "21500": true,
      "21501": true,
      "21502": true,
      "21503": true,
      "21504": true,
      "21505": true,
      "21506": true,
      "21507": true,
      "21520": true,
      "21521": true,
      "21522": true,
      "21523": true,
      "21524": true,
      "21525": true,
      "21526": true,
      "21527": true,
      "21528": true,
      "21529": true,
      "21530": true,
      "21531": true,
      "21532": true,
      "21533": true,
      "21534": true,
      "21535": true,
      "21536": true,
      "21537": true,
      "21538": true,
      "21539": true,
      "21540": true,
      "21541": true,
      "21542": true,
      "21543": true,
      "21544": true,
      "21545": true,
      "21546": true,
      "21547": true,
      "21548": true,
      "21549": true
    },
    "TIJUANA": {
      "22000": true,
      "22001": true,
      "22002": true,
      "22003": true,
      "22004": true,
      "22005": true,
      "22006": true,
      "22007": true,
      "22008": true,
      "22009": true,
      "22010": true,
      "22011": true,
      "22012": true,
      "22013": true,
      "22014": true,
      "22015": true,
      "22016": true,
      "22017": true,
      "22018": true,
      "22019": true,
      "22020": true,
      "22021": true,
      "22022": true,
      "22023": true,
      "22024": true,
      "22025": true,
      "22026": true,
      "22027": true,
      "22028": true,
      "22029": true,
      "22030": true,
      "22031": true,
      "22032": true,
      "22033": true,
      "22034": true,
      "22035": true,
      "22036": true,
      "22037": true,
      "22038": true,
      "22039": true,
      "22040": true,
      "22041": true,
      "22042": true,
      "22043": true,
      "22044": true,
      "22045": true,
      "22046": true,
      "22047": true,
      "22048": true,
      "22049": true,
      "22050": true,
      "22051": true,
      "22052": true,
      "22053": true,
      "22054": true,
      "22055": true,
      "22056": true,
      "22057": true,
      "22058": true,
      "22059": true,
      "22060": true,
      "22061": true,
      "22062": true,
      "22063": true,
      "22064": true,
      "22065": true,
      "22066": true,
      "22067": true,
      "22068": true,
      "22069": true,
      "22070": true,
      "22071": true,
      "22072": true,
      "22073": true,
      "22074": true,
      "22075": true,
      "22076": true,
      "22077": true,
      "22078": true,
      "22079": true,
      "22080": true,
      "22081": true,
      "22082": true,
      "22083": true,
      "22084": true,
      "22085": true,
      "22086": true,
      "22087": true,
      "22088": true,
      "22089": true,
      "22090": true,
      "22091": true,
      "22092": true,
      "22093": true,
      "22094": true,
      "22095": true,
      "22096": true,
      "22097": true,
      "22098": true,
      "22099": true,
      "22100": true,
      "22101": true,
      "22102": true,
      "22103": true,
      "22104": true,
      "22105": true,
      "22106": true,
      "22107": true,
      "22108": true,
      "22109": true,
      "22110": true,
      "22111": true,
      "22112": true,
      "22113": true,
      "22114": true,
      "22115": true,
      "22116": true,
      "22117": true,
      "22118": true,
      "22119": true,
      "22120": true,
      "22121": true,
      "22122": true,
      "22123": true,
      "22124": true,
      "22125": true,
      "22126": true,
      "22127": true,
      "22128": true,
      "22129": true,
      "22130": true,
      "22131": true,
      "22132": true,
      "22133": true,
      "22134": true,
      "22135": true,
      "22136": true,
      "22137": true,
      "22138": true,
      "22139": true,
      "22140": true,
      "22141": true,
      "22142": true,
      "22143": true,
      "22144": true,
      "22145": true,
      "22146": true,
      "22147": true,
      "22148": true,
      "22149": true,
      "22150": true,
      "22151": true,
      "22152": true,
      "22153": true,
      "22154": true,
      "22155": true,
      "22156": true,
      "22157": true,
      "22158": true,
      "22159": true,
      "22160": true,
      "22161": true,
      "22162": true,
      "22163": true,
      "22164": true,
      "22165": true,
      "22166": true,
      "22167": true,
      "22168": true,
      "22169": true,
      "22170": true,
      "22171": true,
      "22172": true,
      "22173": true,
      "22174": true,
      "22175": true,
      "22176": true,
      "22177": true,
      "22178": true,
      "22179": true,
      "22180": true,
      "22181": true,
      "22182": true,
      "22183": true,
      "22184": true,
      "22185": true,
      "22186": true,
      "22187": true,
      "22188": true,
      "22189": true,
      "22190": true,
      "22191": true,
      "22192": true,
      "22193": true,
      "22194": true,
      "22195": true,
      "22196": true,
      "22197": true,
      "22198": true,
      "22199": true,
      "22200": true,
      "22201": true,
      "22202": true,
      "22203": true,
      "22204": true,
      "22205": true,
      "22206": true,
      "22207": true,
      "22208": true,
      "22209": true,
      "22210": true,
      "22211": true,
      "22212": true,
      "22213": true,
      "22214": true,
      "22215": true,
      "22216": true,
      "22217": true,
      "22218": true,
      "22219": true,
      "22220": true,
      "22221": true,
      "22222": true,
      "22223": true,
      "22224": true,
      "22225": true,
      "22226": true,
      "22227": true,
      "22228": true,
      "22229": true,
      "22230": true,
      "22231": true,
      "22232": true,
      "22233": true,
      "22234": true,
      "22235": true,
      "22236": true,
      "22237": true,
      "22238": true,
      "22239": true,
      "22240": true,
      "22241": true,
      "22242": true,
      "22243": true,
      "22244": true,
      "22245": true,
      "22246": true,
      "22247": true,
      "22248": true,
      "22249": true,
      "22250": true,
      "22251": true,
      "22252": true,
      "22253": true,
      "22254": true,
      "22255": true,
      "22256": true,
      "22257": true,
      "22258": true,
      "22259": true,
      "22260": true,
      "22261": true,
      "22262": true,
      "22263": true,
      "22264": true,
      "22265": true,
      "22266": true,
      "22267": true,
      "22268": true,
      "22269": true,
      "22270": true,
      "22271": true,
      "22272": true,
      "22273": true,
      "22274": true,
      "22275": true,
      "22276": true,
      "22277": true,
      "22278": true,
      "22279": true,
      "22280": true,
      "22281": true,
      "22282": true,
      "22283": true,
      "22284": true,
      "22285": true,
      "22286": true,
      "22287": true,
      "22288": true,
      "22289": true,
      "22290": true,
      "22291": true,
      "22292": true,
      "22293": true,
      "22294": true,
      "22295": true,
      "22296": true,
      "22297": true,
      "22298": true,
      "22299": true,
      "22300": true,
      "22301": true,
      "22302": true,
      "22303": true,
      "22304": true,
      "22305": true,
      "22306": true,
      "22307": true,
      "22308": true,
      "22309": true,
      "22310": true,
      "22311": true,
      "22312": true,
      "22313": true,
      "22314": true,
      "22315": true,
      "22316": true,
      "22317": true,
      "22318": true,
      "22319": true,
      "22320": true,
      "22321": true,
      "22322": true,
      "22323": true,
      "22324": true,
      "22325": true,
      "22326": true,
      "22327": true,
      "22328": true,
      "22329": true,
      "22330": true,
      "22331": true,
      "22332": true,
      "22333": true,
      "22334": true,
      "22335": true,
      "22336": true,
      "22337": true,
      "22338": true,
      "22339": true,
      "22340": true,
      "22341": true,
      "22342": true,
      "22343": true,
      "22344": true,
      "22345": true,
      "22346": true,
      "22347": true,
      "22348": true,
      "22349": true,
      "22350": true,
      "22351": true,
      "22352": true,
      "22353": true,
      "22354": true,
      "22355": true,
      "22356": true,
      "22357": true,
      "22358": true,
      "22359": true,
      "22360": true,
      "22361": true,
      "22362": true,
      "22363": true,
      "22364": true,
      "22365": true,
      "22366": true,
      "22367": true,
      "22368": true,
      "22369": true,
      "22370": true,
      "22371": true,
      "22372": true,
      "22373": true,
      "22374": true,
      "22375": true,
      "22376": true,
      "22377": true,
      "22378": true,
      "22379": true,
      "22380": true,
      "22381": true,
      "22382": true,
      "22383": true,
      "22384": true,
      "22385": true,
      "22386": true,
      "22387": true,
      "22388": true,
      "22389": true,
      "22390": true,
      "22391": true,
      "22392": true,
      "22393": true,
      "22394": true,
      "22395": true,
      "22396": true,
      "22397": true,
      "22398": true,
      "22399": true,
      "22400": true,
      "22401": true,
      "22402": true,
      "22403": true,
      "22404": true,
      "22405": true,
      "22406": true,
      "22407": true,
      "22408": true,
      "22409": true,
      "22410": true,
      "22411": true,
      "22412": true,
      "22413": true,
      "22414": true,
      "22415": true,
      "22416": true,
      "22417": true,
      "22418": true,
      "22419": true,
      "22420": true,
      "22421": true,
      "22422": true,
      "22423": true,
      "22424": true,
      "22425": true,
      "22426": true,
      "22427": true,
      "22428": true,
      "22429": true,
      "22430": true,
      "22431": true,
      "22432": true,
      "22433": true,
      "22434": true,
      "22435": true,
      "22436": true,
      "22437": true,
      "22438": true,
      "22439": true,
      "22440": true,
      "22441": true,
      "22442": true,
      "22443": true,
      "22444": true,
      "22445": true,
      "22446": true,
      "22447": true,
      "22448": true,
      "22449": true,
      "22450": true,
      "22451": true,
      "22452": true,
      "22453": true,
      "22454": true,
      "22455": true,
      "22456": true,
      "22457": true,
      "22458": true,
      "22459": true,
      "22460": true,
      "22461": true,
      "22462": true,
      "22463": true,
      "22464": true,
      "22465": true,
      "22466": true,
      "22467": true,
      "22468": true,
      "22469": true,
      "22470": true,
      "22471": true,
      "22472": true,
      "22473": true,
      "22474": true,
      "22475": true,
      "22476": true,
      "22477": true,
      "22478": true,
      "22479": true,
      "22480": true,
      "22481": true,
      "22482": true,
      "22483": true,
      "22484": true,
      "22485": true,
      "22486": true,
      "22487": true,
      "22488": true,
      "22489": true,
      "22490": true,
      "22491": true,
      "22492": true,
      "22493": true,
      "22494": true,
      "22495": true,
      "22496": true,
      "22497": true,
      "22498": true,
      "22499": true,
      "22500": true,
      "22501": true,
      "22502": true,
      "22503": true,
      "22504": true,
      "22505": true,
      "22506": true,
      "22507": true,
      "22508": true,
      "22509": true,
      "22510": true,
      "22511": true,
      "22512": true,
      "22513": true,
      "22514": true,
      "22515": true,
      "22516": true,
      "22517": true,
      "22518": true,
      "22519": true,
      "22520": true,
      "22521": true,
      "22522": true,
      "22523": true,
      "22524": true,
      "22525": true,
      "22526": true,
      "22527": true,
      "22528": true,
      "22529": true,
      "22530": true,
      "22531": true,
      "22532": true,
      "22533": true,
      "22534": true,
      "22535": true,
      "22536": true,
      "22537": true,
      "22538": true,
      "22539": true,
      "22540": true,
      "22541": true,
      "22542": true,
      "22543": true,
      "22544": true,
      "22545": true,
      "22546": true,
      "22547": true,
      "22548": true,
      "22549": true,
      "22550": true,
      "22551": true,
      "22552": true,
      "22553": true,
      "22554": true,
      "22555": true,
      "22556": true,
      "22557": true,
      "22558": true,
      "22559": true,
      "22560": true,
      "22561": true,
      "22562": true,
      "22563": true,
      "22564": true,
      "22565": true,
      "22566": true,
      "22567": true,
      "22568": true,
      "22569": true,
      "22570": true,
      "22571": true,
      "22572": true,
      "22573": true,
      "22574": true,
      "22575": true,
      "22576": true,
      "22577": true,
      "22578": true,
      "22579": true,
      "22580": true,
      "22581": true,
      "22582": true,
      "22583": true,
      "22584": true,
      "22585": true,
      "22586": true,
      "22587": true,
      "22588": true,
      "22589": true,
      "22590": true,
      "22591": true,
      "22592": true,
      "22593": true,
      "22594": true,
      "22595": true,
      "22596": true,
      "22597": true,
      "22598": true,
      "22599": true,
      "22600": true,
      "22601": true,
      "22602": true,
      "22603": true,
      "22604": true,
      "22605": true,
      "22606": true,
      "22607": true,
      "22608": true,
      "22609": true,
      "22610": true,
      "22611": true,
      "22612": true,
      "22613": true,
      "22614": true,
      "22615": true,
      "22616": true,
      "22617": true,
      "22618": true,
      "22619": true,
      "22620": true,
      "22621": true,
      "22622": true,
      "22623": true,
      "22624": true,
      "22625": true,
      "22626": true,
      "22627": true,
      "22628": true,
      "22629": true,
      "22630": true,
      "22631": true,
      "22632": true,
      "22633": true,
      "22634": true,
      "22635": true,
      "22636": true,
      "22637": true,
      "22638": true,
      "22639": true,
      "22640": true,
      "22641": true,
      "22642": true,
      "22643": true,
      "22644": true,
      "22645": true,
      "22646": true,
      "22647": true,
      "22648": true,
      "22649": true,
      "22650": true,
      "22651": true,
      "22652": true,
      "22653": true,
      "22654": true,
      "22655": true,
      "22656": true,
      "22657": true,
      "22658": true,
      "22659": true,
      "22660": true,
      "22661": true,
      "22662": true,
      "22663": true,
      "22664": true,
      "22665": true,
      "22666": true,
      "22667": true,
      "22668": true,
      "22669": true,
      "22670": true,
      "22671": true,
      "22672": true,
      "22673": true,
      "22674": true,
      "22675": true,
      "22676": true,
      "22677": true,
      "22678": true,
      "22679": true,
      "22680": true,
      "22681": true,
      "22682": true,
      "22683": true,
      "22684": true,
      "22685": true,
      "22686": true,
      "22687": true,
      "22688": true,
      "22689": true,
      "22690": true,
      "22691": true,
      "22692": true,
      "22693": true,
      "22694": true,
      "22695": true,
      "22696": true,
      "22697": true,
      "22698": true,
      "22699": true
    }
  },
  "BAJA CALIFORNIA SUR": {
    "LA PAZ": {
      "23000": true,
      "23001": true,
      "23002": true,
      "23003": true,
      "23004": true,
      "23005": true,
      "23006": true,
      "23007": true,
      "23008": true,
      "23009": true,
      "23010": true,
      "23011": true,
      "23012": true,
      "23013": true,
      "23014": true,
      "23015": true,
      "23016": true,
      "23017": true,
      "23018": true,
      "23019": true,
      "23020": true,
      "23021": true,
      "23022": true,
      "23023": true,
      "23024": true,
      "23025": true,
      "23026": true,
      "23027": true,
      "23028": true,
      "23029": true,
      "23030": true,
      "23031": true,
      "23032": true,
      "23033": true,
      "23034": true,
      "23035": true,
      "23036": true,
      "23037": true,
      "23038": true,
      "23039": true,
      "23040": true,
      "23041": true,
      "23042": true,
      "23043": true,
      "23044": true,
      "23045": true,
      "23046": true,
      "23047": true,
      "23048": true,
      "23049": true,
      "23050": true,
      "23051": true,
      "23052": true,
      "23053": true,
      "23054": true,
      "23055": true,
      "23056": true,
      "23057": true,
      "23058": true,
      "23059": true,
      "23060": true,
      "23061": true,
      "23062": true,
      "23063": true,
      "23064": true,
      "23065": true,
      "23066": true,
      "23067": true,
      "23068": true,
      "23069": true,
      "23070": true,
      "23071": true,
      "23072": true,
      "23073": true,
      "23074": true,
      "23075": true,
      "23076": true,
      "23077": true,
      "23078": true,
      "23079": true,
      "23080": true,
      "23081": true,
      "23082": true,
      "23083": true,
      "23084": true,
      "23085": true,
      "23086": true,
      "23087": true,
      "23088": true,
      "23089": true,
      "23090": true,
      "23091": true,
      "23092": true,
      "23093": true,
      "23094": true,
      "23095": true,
      "23096": true,
      "23097": true,
      "23098": true,
      "23099": true,
      "23100": true,
      "23101": true,
      "23102": true,
      "23103": true,
      "23104": true,
      "23105": true,
      "23106": true,
      "23107": true,
      "23108": true,
      "23109": true,
      "23110": true,
      "23111": true,
      "23112": true,
      "23113": true,
      "23114": true,
      "23115": true,
      "23116": true,
      "23117": true,
      "23118": true,
      "23119": true,
      "23120": true,
      "23121": true,
      "23122": true,
      "23123": true,
      "23124": true,
      "23125": true,
      "23126": true,
      "23127": true,
      "23128": true,
      "23129": true,
      "23130": true,
      "23131": true,
      "23132": true,
      "23133": true,
      "23134": true,
      "23135": true,
      "23136": true,
      "23137": true,
      "23138": true,
      "23139": true,
      "23140": true,
      "23141": true,
      "23142": true,
      "23143": true,
      "23144": true,
      "23145": true,
      "23146": true,
      "23147": true,
      "23148": true,
      "23149": true,
      "23150": true,
      "23151": true,
      "23152": true,
      "23153": true,
      "23154": true,
      "23155": true,
      "23156": true,
      "23157": true,
      "23158": true,
      "23159": true,
      "23160": true,
      "23161": true,
      "23162": true,
      "23163": true,
      "23164": true,
      "23165": true,
      "23166": true,
      "23167": true,
      "23168": true,
      "23169": true,
      "23170": true,
      "23171": true,
      "23172": true,
      "23173": true,
      "23174": true,
      "23175": true,
      "23176": true,
      "23177": true,
      "23178": true,
      "23179": true,
      "23180": true,
      "23181": true,
      "23182": true,
      "23183": true,
      "23184": true,
      "23185": true,
      "23186": true,
      "23187": true,
      "23188": true,
      "23189": true,
      "23190": true,
      "23191": true,
      "23192": true,
      "23193": true,
      "23194": true,
      "23195": true,
      "23196": true,
      "23197": true,
      "23198": true,
      "23199": true,
      "23200": true,
      "23201": true,
      "23202": true,
      "23203": true,
      "23204": true,
      "23205": true,
      "23206": true,
      "23207": true,
      "23208": true,
      "23209": true,
      "23210": true,
      "23211": true,
      "23212": true,
      "23213": true,
      "23214": true,
      "23215": true,
      "23216": true,
      "23217": true,
      "23218": true,
      "23219": true,
      "23220": true,
      "23221": true,
      "23222": true,
      "23223": true,
      "23224": true,
      "23225": true,
      "23226": true,
      "23227": true,
      "23228": true,
      "23229": true,
      "23230": true,
      "23231": true,
      "23232": true,
      "23233": true,
      "23234": true,
      "23235": true,
      "23236": true,
      "23237": true,
      "23238": true,
      "23239": true,
      "23240": true,
      "23241": true,
      "23242": true,
      "23243": true,
      "23244": true,
      "23245": true,
      "23246": true,
      "23247": true,
      "23248": true,
      "23249": true,
      "23250": true,
      "23251": true,
      "23252": true,
      "23253": true,
      "23254": true,
      "23255": true,
      "23256": true,
      "23257": true,
      "23258": true,
      "23259": true,
      "23260": true,
      "23261": true,
      "23262": true,
      "23263": true,
      "23264": true,
      "23265": true,
      "23266": true,
      "23267": true,
      "23268": true,
      "23269": true,
      "23270": true,
      "23271": true,
      "23272": true,
      "23273": true,
      "23274": true,
      "23275": true,
      "23276": true,
      "23277": true,
      "23278": true,
      "23279": true,
      "23280": true,
      "23281": true,
      "23282": true,
      "23283": true,
      "23284": true,
      "23285": true,
      "23286": true,
      "23287": true,
      "23288": true,
      "23289": true,
      "23290": true,
      "23291": true,
      "23292": true,
      "23293": true,
      "23294": true,
      "23295": true,
      "23296": true,
      "23297": true,
      "23298": true,
      "23299": true,
      "23300": true,
      "23301": true,
      "23302": true,
      "23303": true,
      "23304": true,
      "23305": true,
      "23306": true,
      "23307": true,
      "23308": true,
      "23309": true,
      "23310": true,
      "23311": true,
      "23312": true,
      "23313": true,
      "23314": true,
      "23315": true,
      "23316": true,
      "23317": true,
      "23318": true,
      "23319": true,
      "23320": true,
      "23321": true,
      "23322": true,
      "23323": true,
      "23324": true,
      "23325": true,
      "23326": true,
      "23327": true,
      "23328": true,
      "23329": true,
      "23330": true,
      "23331": true,
      "23332": true,
      "23333": true,
      "23334": true,
      "23335": true,
      "23336": true,
      "23337": true,
      "23338": true,
      "23339": true,
      "23340": true,
      "23341": true,
      "23342": true,
      "23343": true,
      "23344": true,
      "23345": true,
      "23346": true,
      "23347": true,
      "23348": true,
      "23349": true,
      "23350": true,
      "23351": true,
      "23352": true,
      "23353": true,
      "23354": true,
      "23355": true,
      "23356": true,
      "23357": true,
      "23358": true,
      "23359": true,
      "23360": true,
      "23361": true,
      "23362": true,
      "23363": true,
      "23364": true,
      "23365": true,
      "23366": true,
      "23367": true,
      "23368": true,
      "23369": true,
      "23370": true,
      "23371": true,
      "23372": true,
      "23373": true,
      "23374": true,
      "23375": true,
      "23376": true,
      "23377": true,
      "23378": true,
      "23379": true,
      "23380": true,
      "23381": true,
      "23382": true,
      "23383": true,
      "23384": true,
      "23385": true,
      "23386": true,
      "23387": true,
      "23388": true,
      "23389": true,
      "23390": true,
      "23391": true,
      "23392": true,
      "23393": true,
      "23394": true,
      "23395": true,
      "23396": true,
      "23397": true,
      "23398": true,
      "23399": true
    },
    "LORETO": {
      "23880": true,
      "23881": true,
      "23882": true,
      "23883": true,
      "23884": true,
      "23885": true,
      "23886": true,
      "23889": true,
      "23894": true,
      "23895": true,
      "23897": true,
      "23898": true,
      "23899": true
    }
  },
  "CAMPECHE": {
    "CALKINI": {
      "24900": true,
      "24901": true,
      "24902": true,
      "24903": true,
      "24904": true,
      "24905": true,
      "24906": true,
      "24907": true,
      "24908": true,
      "24909": true,
      "24910": true,
      "24911": true,
      "24912": true,
      "24913": true,
      "24914": true,
      "24915": true,
      "24920": true,
      "24921": true,
      "24922": true,
      "24923": true,
      "24924": true,
      "24925": true,
      "24926": true,
      "24927": true,
      "24928": true,
      "24929": true,
      "24930": true,
      "24931": true,
      "24932": true,
      "24933": true,
      "24934": true,
      "24935": true,
      "24936": true,
      "24937": true,
      "24938": true,
      "24939": true,
      "24940": true,
      "24941": true,
      "24942": true,
      "24943": true,
      "24944": true,
      "24945": true,
      "24946": true,
      "24947": true,
      "24948": true,
      "24949": true,
      "24950": true,
      "24951": true,
      "24952": true,
      "24953": true,
      "24954": true,
      "24955": true,
      "24956": true,
      "24957": true,
      "24958": true,
      "24959": true,
      "24960": true,
      "24961": true,
      "24962": true,
      "24963": true,
      "24964": true,
      "24965": true,
      "24966": true,
      "24967": true,
      "24968": true,
      "24969": true,
      "24970": true,
      "24971": true,
      "24972": true,
      "24973": true,
      "24974": true,
      "24975": true,
      "24976": true,
      "24977": true,
      "24978": true,
      "24979": true,
      "24980": true,
      "24981": true,
      "24982": true,
      "24983": true,
      "24984": true,
      "24985": true,
      "24986": true,
      "24987": true,
      "24988": true,
      "24989": true,
      "24990": true,
      "24991": true,
      "24992": true,
      "24993": true,
      "24994": true,
      "24995": true,
      "24996": true,
      "24997": true,
      "24998": true,
      "24999": true
    },
    "CAMPECHE": {
      "24000": true,
      "24001": true,
      "24002": true,
      "24003": true,
      "24004": true,
      "24005": true,
      "24006": true,
      "24007": true,
      "24008": true,
      "24009": true,
      "24010": true,
      "24011": true,
      "24012": true,
      "24013": true,
      "24014": true,
      "24015": true,
      "24016": true,
      "24017": true,
      "24018": true,
      "24019": true,
      "24020": true,
      "24021": true,
      "24022": true,
      "24023": true,
      "24024": true,
      "24025": true,
      "24026": true,
      "24027": true,
      "24028": true,
      "24029": true,
      "24030": true,
      "24031": true,
      "24032": true,
      "24033": true,
      "24034": true,
      "24035": true,
      "24036": true,
      "24037": true,
      "24038": true,
      "24039": true,
      "24040": true,
      "24041": true,
      "24042": true,
      "24043": true,
      "24044": true,
      "24045": true,
      "24046": true,
      "24047": true,
      "24048": true,
      "24049": true,
      "24050": true,
      "24051": true,
      "24052": true,
      "24053": true,
      "24054": true,
      "24055": true,
      "24056": true,
      "24057": true,
      "24058": true,
      "24059": true,
      "24060": true,
      "24061": true,
      "24062": true,
      "24063": true,
      "24064": true,
      "24065": true,
      "24066": true,
      "24067": true,
      "24068": true,
      "24069": true,
      "24070": true,
      "24071": true,
      "24072": true,
      "24073": true,
      "24074": true,
      "24075": true,
      "24076": true,
      "24077": true,
      "24078": true,
      "24079": true,
      "24080": true,
      "24081": true,
      "24082": true,
      "24083": true,
      "24084": true,
      "24085": true,
      "24086": true,
      "24087": true,
      "24088": true,
      "24089": true,
      "24090": true,
      "24091": true,
      "24092": true,
      "24093": true,
      "24094": true,
      "24095": true,
      "24096": true,
      "24097": true,
      "24098": true,
      "24099": true,
      "24500": true,
      "24501": true,
      "24502": true,
      "24503": true,
      "24504": true,
      "24505": true,
      "24506": true,
      "24507": true,
      "24508": true,
      "24509": true,
      "24510": true,
      "24511": true,
      "24512": true,
      "24513": true,
      "24514": true,
      "24515": true,
      "24516": true,
      "24517": true,
      "24518": true,
      "24519": true,
      "24520": true,
      "24521": true,
      "24522": true,
      "24523": true,
      "24524": true,
      "24525": true,
      "24526": true,
      "24527": true,
      "24528": true,
      "24529": true,
      "24530": true,
      "24531": true,
      "24532": true,
      "24533": true,
      "24534": true,
      "24535": true,
      "24536": true,
      "24537": true,
      "24538": true,
      "24539": true,
      "24540": true,
      "24541": true,
      "24542": true,
      "24543": true,
      "24544": true,
      "24545": true,
      "24546": true,
      "24547": true,
      "24548": true,
      "24549": true,
      "24550": true,
      "24551": true,
      "24552": true,
      "24553": true,
      "24554": true,
      "24555": true,
      "24556": true,
      "24557": true,
      "24558": true,
      "24559": true,
      "24560": true,
      "24561": true,
      "24562": true,
      "24563": true,
      "24564": true,
      "24565": true,
      "24566": true,
      "24567": true,
      "24568": true,
      "24569": true,
      "24570": true,
      "24571": true,
      "24572": true,
      "24573": true,
      "24574": true,
      "24575": true,
      "24576": true,
      "24577": true,
      "24578": true,
      "24579": true,
      "24580": true,
      "24581": true,
      "24582": true,
      "24583": true,
      "24584": true,
      "24585": true,
      "24586": true,
      "24587": true,
      "24588": true,
      "24589": true,
      "24590": true,
      "24591": true,
      "24592": true,
      "24593": true,
      "24594": true,
      "24595": true,
      "24596": true,
      "24597": true,
      "24598": true,
      "24599": true
    },
    "CARMEN": {
      "24100": true,
      "24101": true,
      "24102": true,
      "24103": true,
      "24104": true,
      "24105": true,
      "24106": true,
      "24107": true,
      "24108": true,
      "24109": true,
      "24110": true,
      "24111": true,
      "24112": true,
      "24113": true,
      "24114": true,
      "24115": true,
      "24116": true,
      "24117": true,
      "24118": true,
      "24119": true,
      "24120": true,
      "24121": true,
      "24122": true,
      "24123": true,
      "24124": true,
      "24125": true,
      "24126": true,
      "24127": true,
      "24128": true,
      "24129": true,
      "24130": true,
      "24131": true,
      "24132": true,
      "24133": true,
      "24134": true,
      "24135": true,
      "24136": true,
      "24137": true,
      "24138": true,
      "24139": true,
      "24140": true,
      "24141": true,
      "24142": true,
      "24143": true,
      "24144": true,
      "24145": true,
      "24146": true,
      "24147": true,
      "24148": true,
      "24149": true,
      "24150": true,
      "24151": true,
      "24152": true,
      "24153": true,
      "24154": true,
      "24155": true,
      "24156": true,
      "24157": true,
      "24158": true,
      "24159": true,
      "24160": true,
      "24161": true,
      "24162": true,
      "24163": true,
      "24164": true,
      "24165": true,
      "24166": true,
      "24167": true,
      "24168": true,
      "24169": true,
      "24170": true,
      "24171": true,
      "24172": true,
      "24173": true,
      "24174": true,
      "24175": true,
      "24176": true,
      "24177": true,
      "24178": true,
      "24179": true,
      "24180": true,
      "24181": true,
      "24182": true,
      "24183": true,
      "24184": true,
      "24185": true,
      "24186": true,
      "24187": true,
      "24188": true,
      "24189": true,
      "24190": true,
      "24191": true,
      "24192": true,
      "24193": true,
      "24194": true,
      "24195": true,
      "24196": true,
      "24197": true,
      "24198": true,
      "24199": true,
      "24315": true,
      "24316": true,
      "24320": true,
      "24321": true,
      "24322": true,
      "24325": true,
      "24327": true,
      "24328": true,
      "24329": true
    },
    "CHAMPOTON": {
      "24400": true,
      "24401": true,
      "24402": true,
      "24403": true,
      "24404": true,
      "24405": true,
      "24406": true,
      "24407": true,
      "24408": true,
      "24409": true,
      "24416": true,
      "24417": true,
      "24418": true,
      "24420": true,
      "24440": true,
      "24443": true,
      "24444": true,
      "24445": true,
      "24446": true,
      "24447": true,
      "24448": true,
      "24449": true,
      "24450": true,
      "24451": true,
      "24452": true,
      "24453": true,
      "24454": true,
      "24455": true,
      "24456": true,
      "24457": true,
      "24458": true,
      "24459": true
    },
    "ESCARCEGA": {
      "24350": true,
      "24351": true,
      "24352": true,
      "24353": true,
      "24354": true,
      "24356": true,
      "24368": true,
      "24369": true,
      "24370": true,
      "24371": true,
      "24372": true,
      "24375": true,
      "24376": true,
      "24377": true,
      "24378": true,
      "24379": true,
      "24380": true,
      "24381": true,
      "24382": true,
      "24383": true,
      "24384": true,
      "24385": true,
      "24386": true,
      "24387": true,
      "24388": true,
      "24389": true,
      "24390": true,
      "24391": true,
      "24392": true,
      "24393": true,
      "24394": true,
      "24395": true,
      "24396": true,
      "24397": true,
      "24398": true,
      "24399": true
    },
    "HECELCHAKAN": {
      "24800": true,
      "24801": true,
      "24802": true,
      "24803": true,
      "24804": true,
      "24805": true,
      "24806": true,
      "24807": true,
      "24808": true,
      "24809": true,
      "24810": true,
      "24811": true,
      "24812": true,
      "24813": true,
      "24814": true,
      "24815": true,
      "24816": true,
      "24817": true,
      "24818": true,
      "24819": true,
      "24820": true,
      "24821": true,
      "24822": true,
      "24823": true,
      "24824": true,
      "24825": true,
      "24826": true,
      "24827": true,
      "24830": true,
      "24831": true,
      "24832": true,
      "24833": true,
      "24834": true,
      "24835": true,
      "24836": true,
      "24837": true,
      "24838": true,
      "24839": true,
      "24840": true,
      "24841": true,
      "24842": true,
      "24843": true,
      "24844": true,
      "24845": true,
      "24846": true,
      "24847": true,
      "24848": true,
      "24849": true,
      "24850": true,
      "24851": true,
      "24852": true,
      "24853": true,
      "24854": true,
      "24855": true,
      "24856": true,
      "24857": true,
      "24858": true,
      "24859": true,
      "24863": true,
      "24864": true,
      "24865": true,
      "24866": true,
      "24867": true,
      "24868": true,
      "24869": true,
      "24870": true,
      "24871": true,
      "24872": true,
      "24873": true,
      "24874": true,
      "24875": true,
      "24876": true,
      "24877": true,
      "24878": true,
      "24879": true,
      "24880": true,
      "24881": true,
      "24882": true,
      "24883": true,
      "24884": true,
      "24885": true,
      "24886": true,
      "24887": true,
      "24888": true,
      "24889": true,
      "24890": true,
      "24891": true,
      "24892": true,
      "24893": true,
      "24894": true,
      "24895": true,
      "24896": true,
      "24897": true,
      "24898": true,
      "24899": true
    },
    "HOPELCHEN": {
      "24600": true,
      "24601": true,
      "24602": true,
      "24603": true,
      "24604": true,
      "24605": true,
      "24606": true,
      "24609": true,
      "24612": true,
      "24615": true,
      "24616": true,
      "24617": true,
      "24618": true,
      "24619": true,
      "24663": true,
      "24664": true,
      "24665": true,
      "24666": true,
      "24667": true,
      "24670": true,
      "24671": true,
      "24672": true,
      "24673": true,
      "24674": true,
      "24675": true,
      "24676": true,
      "24677": true,
      "24678": true,
      "24679": true,
      "24680": true,
      "24681": true,
      "24682": true,
      "24683": true,
      "24684": true,
      "24685": true,
      "24686": true,
      "24687": true,
      "24688": true,
      "24689": true,
      "24690": true,
      "24691": true,
      "24692": true,
      "24693": true,
      "24694": true,
      "24695": true,
      "24696": true,
      "24697": true,
      "24698": true,
      "24699": true
    },
    "SEYBAPLAYA": {
      "24460": true,
      "24461": true,
      "24462": true,
      "24463": true,
      "24464": true,
      "24465": true,
      "24466": true,
      "24467": true,
      "24468": true,
      "24469": true,
      "24470": true,
      "24471": true,
      "24472": true,
      "24473": true,
      "24474": true,
      "24475": true,
      "24476": true,
      "24477": true,
      "24478": true,
      "24479": true,
      "24480": true,
      "24481": true,
      "24482": true,
      "24483": true,
      "24484": true,
      "24485": true,
      "24486": true,
      "24487": true,
      "24488": true,
      "24489": true,
      "24490": true,
      "24491": true,
      "24492": true,
      "24493": true,
      "24494": true,
      "24495": true,
      "24496": true,
      "24497": true,
      "24498": true,
      "24499": true
    },
    "TENABO": {
      "24700": true,
      "24701": true,
      "24702": true,
      "24703": true,
      "24704": true,
      "24705": true,
      "24706": true,
      "24707": true,
      "24708": true,
      "24709": true,
      "24710": true,
      "24711": true,
      "24712": true,
      "24713": true,
      "24714": true,
      "24715": true,
      "24716": true,
      "24717": true,
      "24718": true,
      "24719": true,
      "24720": true,
      "24721": true,
      "24722": true,
      "24723": true,
      "24724": true,
      "24725": true,
      "24726": true,
      "24727": true,
      "24728": true,
      "24729": true,
      "24730": true,
      "24731": true,
      "24732": true,
      "24733": true,
      "24734": true,
      "24735": true,
      "24736": true,
      "24737": true,
      "24738": true,
      "24739": true,
      "24740": true,
      "24741": true,
      "24742": true,
      "24743": true,
      "24744": true,
      "24745": true,
      "24746": true,
      "24747": true,
      "24748": true,
      "24749": true,
      "24750": true,
      "24751": true,
      "24752": true,
      "24753": true,
      "24754": true,
      "24755": true,
      "24756": true,
      "24757": true,
      "24758": true,
      "24759": true,
      "24760": true,
      "24761": true,
      "24762": true,
      "24763": true,
      "24764": true,
      "24765": true,
      "24766": true,
      "24767": true,
      "24768": true,
      "24769": true,
      "24770": true,
      "24771": true,
      "24772": true,
      "24773": true,
      "24774": true,
      "24775": true,
      "24776": true,
      "24777": true,
      "24778": true,
      "24779": true,
      "24780": true,
      "24781": true,
      "24782": true,
      "24783": true,
      "24784": true,
      "24785": true,
      "24786": true,
      "24787": true,
      "24788": true,
      "24789": true,
      "24790": true,
      "24791": true,
      "24792": true,
      "24793": true,
      "24794": true,
      "24795": true,
      "24796": true,
      "24797": true,
      "24798": true,
      "24799": true
    }
  },
  "CHIAPAS": {
    "COMITAN DE DOMINGUEZ": {
      "30000": true,
      "30010": true,
      "30013": true,
      "30015": true,
      "30017": true,
      "30018": true,
      "30019": true,
      "30020": true,
      "30023": true,
      "30028": true,
      "30029": true,
      "30030": true,
      "30033": true,
      "30034": true,
      "30036": true,
      "30037": true,
      "30038": true,
      "30039": true,
      "30040": true,
      "30043": true,
      "30060": true,
      "30063": true,
      "30064": true,
      "30065": true,
      "30067": true,
      "30068": true,
      "30069": true,
      "30070": true,
      "30073": true,
      "30074": true,
      "30075": true,
      "30076": true,
      "30077": true,
      "30078": true,
      "30090": true,
      "30093": true,
      "30096": true,
      "30099": true,
      "30100": true,
      "30103": true,
      "30104": true,
      "30105": true,
      "30106": true,
      "30107": true,
      "30108": true,
      "30109": true
    },
    "JIQUIPILAS": {
      "30430": true,
      "30431": true,
      "30433": true,
      "30434": true,
      "30435": true,
      "30436": true,
      "30437": true,
      "30438": true,
      "30439": true,
      "30441": true,
      "30442": true,
      "30444": true,
      "30445": true,
      "30446": true
    },
    "TAPACHULA": {
      "30700": true,
      "30701": true,
      "30702": true,
      "30703": true,
      "30704": true,
      "30705": true,
      "30706": true,
      "30707": true,
      "30708": true,
      "30710": true,
      "30711": true,
      "30712": true,
      "30713": true,
      "30714": true,
      "30715": true,
      "30716": true,
      "30717": true,
      "30718": true,
      "30719": true,
      "30720": true,
      "30721": true,
      "30722": true,
      "30723": true,
      "30724": true,
      "30725": true,
      "30726": true,
      "30727": true,
      "30728": true,
      "30729": true,
      "30730": true,
      "30731": true,
      "30732": true,
      "30733": true,
      "30734": true,
      "30735": true,
      "30737": true,
      "30738": true,
      "30739": true,
      "30740": true,
      "30741": true,
      "30742": true,
      "30743": true,
      "30744": true,
      "30745": true,
      "30746": true,
      "30747": true,
      "30748": true,
      "30749": true,
      "30750": true,
      "30751": true,
      "30752": true,
      "30753": true,
      "30754": true,
      "30755": true,
      "30756": true,
      "30757": true,
      "30758": true,
      "30759": true,
      "30760": true,
      "30761": true,
      "30762": true,
      "30763": true,
      "30764": true,
      "30765": true,
      "30766": true,
      "30767": true,
      "30768": true,
      "30769": true,
      "30770": true,
      "30771": true,
      "30772": true,
      "30773": true,
      "30774": true,
      "30775": true,
      "30776": true,
      "30777": true,
      "30778": true,
      "30779": true,
      "30780": true,
      "30781": true,
      "30782": true,
      "30783": true,
      "30784": true,
      "30785": true,
      "30786": true,
      "30787": true,
      "30788": true,
      "30789": true,
      "30790": true,
      "30791": true,
      "30792": true,
      "30793": true,
      "30794": true,
      "30795": true,
      "30796": true,
      "30797": true,
      "30798": true,
      "30799": true
    },
    "TUXTLA GUTIÉRREZ": {
      "29000": true,
      "29001": true,
      "29002": true,
      "29003": true,
      "29004": true,
      "29005": true,
      "29006": true,
      "29007": true,
      "29008": true,
      "29009": true,
      "29010": true,
      "29011": true,
      "29012": true,
      "29013": true,
      "29014": true,
      "29016": true,
      "29017": true,
      "29018": true,
      "29019": true,
      "29020": true,
      "29021": true,
      "29022": true,
      "29023": true,
      "29024": true,
      "29025": true,
      "29026": true,
      "29027": true,
      "29028": true,
      "29029": true,
      "29030": true,
      "29031": true,
      "29032": true,
      "29033": true,
      "29034": true,
      "29035": true,
      "29036": true,
      "29037": true,
      "29038": true,
      "29039": true,
      "29040": true,
      "29041": true,
      "29042": true,
      "29043": true,
      "29044": true,
      "29045": true,
      "29046": true,
      "29047": true,
      "29048": true,
      "29049": true,
      "29050": true,
      "29051": true,
      "29052": true,
      "29054": true,
      "29055": true,
      "29056": true,
      "29057": true,
      "29059": true,
      "29060": true,
      "29061": true,
      "29062": true,
      "29063": true,
      "29064": true,
      "29065": true,
      "29066": true,
      "29067": true,
      "29068": true,
      "29069": true,
      "29070": true,
      "29071": true,
      "29072": true,
      "29073": true,
      "29074": true,
      "29075": true,
      "29076": true,
      "29077": true,
      "29078": true,
      "29079": true,
      "29080": true,
      "29081": true,
      "29082": true,
      "29083": true,
      "29084": true,
      "29085": true,
      "29086": true,
      "29087": true,
      "29088": true,
      "29089": true,
      "29090": true,
      "29091": true,
      "29092": true,
      "29093": true,
      "29094": true,
      "29095": true,
      "29096": true,
      "29097": true,
      "29098": true,
      "29099": true,
      "29100": true,
      "29101": true,
      "29102": true
    },
    "VENUSTIANO CARRANZA": {
      "30200": true,
      "30201": true,
      "30202": true,
      "30203": true,
      "30204": true,
      "30205": true,
      "30206": true,
      "30207": true,
      "30208": true,
      "30209": true,
      "30210": true,
      "30211": true,
      "30212": true,
      "30213": true,
      "30215": true,
      "30216": true,
      "30223": true,
      "30224": true,
      "30225": true,
      "30226": true
    },
    "VILLAFLORES": {
      "30470": true,
      "30471": true,
      "30472": true,
      "30473": true,
      "30474": true,
      "30475": true,
      "30476": true,
      "30478": true,
      "30479": true,
      "30484": true,
      "30485": true,
      "30486": true,
      "30487": true,
      "30492": true,
      "30493": true,
      "30494": true,
      "30495": true,
      "30496": true
    }
  },
  "CHIHUAHUA": {
    "AHUMADA": {
      "32800": true,
      "32801": true,
      "32802": true,
      "32803": true,
      "32804": true,
      "32805": true,
      "32806": true,
      "32807": true,
      "32808": true,
      "32809": true,
      "32810": true,
      "32812": true,
      "32814": true,
      "32815": true,
      "32820": true,
      "32821": true,
      "32822": true,
      "32832": true,
      "32833": true,
      "32834": true,
      "32835": true,
      "32836": true,
      "32837": true,
      "32838": true,
      "32839": true
    },
    "ALDAMA": {
      "32900": true,
      "32901": true,
      "32902": true,
      "32903": true,
      "32904": true,
      "32905": true,
      "32906": true,
      "32910": true,
      "32911": true,
      "32912": true,
      "32913": true,
      "32914": true,
      "32915": true,
      "32916": true,
      "32917": true,
      "32918": true,
      "32919": true,
      "32930": true,
      "32931": true
    },
    "CAMARGO": {
      "33600": true,
      "33601": true,
      "33602": true,
      "33603": true,
      "33610": true,
      "33611": true,
      "33612": true,
      "33613": true,
      "33614": true,
      "33615": true,
      "33616": true,
      "33617": true,
      "33700": true,
      "33701": true,
      "33702": true,
      "33703": true,
      "33704": true,
      "33705": true,
      "33706": true,
      "33707": true,
      "33708": true,
      "33709": true,
      "33710": true,
      "33711": true,
      "33712": true,
      "33713": true,
      "33714": true,
      "33715": true,
      "33716": true,
      "33717": true,
      "33718": true,
      "33719": true,
      "33720": true,
      "33721": true,
      "33722": true,
      "33723": true,
      "33724": true,
      "33725": true,
      "33726": true,
      "33727": true,
      "33728": true,
      "33729": true,
      "33730": true,
      "33731": true,
      "33732": true,
      "33733": true,
      "33734": true,
      "33735": true,
      "33736": true,
      "33737": true,
      "33738": true,
      "33739": true,
      "33740": true,
      "33741": true,
      "33742": true,
      "33743": true,
      "33744": true,
      "33745": true,
      "33746": true,
      "33747": true,
      "33748": true,
      "33749": true,
      "33750": true,
      "33751": true,
      "33752": true,
      "33753": true,
      "33754": true,
      "33755": true,
      "33756": true,
      "33757": true,
      "33758": true,
      "33759": true,
      "33760": true,
      "33761": true,
      "33762": true,
      "33763": true,
      "33764": true,
      "33765": true,
      "33766": true,
      "33767": true,
      "33768": true,
      "33769": true,
      "33770": true,
      "33771": true,
      "33772": true,
      "33773": true,
      "33774": true,
      "33775": true,
      "33776": true,
      "33777": true,
      "33778": true,
      "33779": true,
      "33780": true,
      "33781": true,
      "33782": true,
      "33783": true,
      "33784": true,
      "33785": true,
      "33786": true,
      "33787": true,
      "33788": true,
      "33789": true,
      "33790": true,
      "33791": true,
      "33792": true,
      "33793": true,
      "33794": true,
      "33795": true,
      "33796": true,
      "33797": true,
      "33798": true,
      "33799": true
    },
    "CHIHUAHUA": {
      "31000": true,
      "31001": true,
      "31002": true,
      "31003": true,
      "31004": true,
      "31005": true,
      "31006": true,
      "31007": true,
      "31008": true,
      "31009": true,
      "31010": true,
      "31011": true,
      "31012": true,
      "31013": true,
      "31014": true,
      "31015": true,
      "31016": true,
      "31017": true,
      "31018": true,
      "31019": true,
      "31020": true,
      "31021": true,
      "31022": true,
      "31023": true,
      "31024": true,
      "31025": true,
      "31026": true,
      "31027": true,
      "31028": true,
      "31029": true,
      "31030": true,
      "31031": true,
      "31032": true,
      "31033": true,
      "31034": true,
      "31035": true,
      "31036": true,
      "31037": true,
      "31038": true,
      "31039": true,
      "31040": true,
      "31041": true,
      "31042": true,
      "31043": true,
      "31044": true,
      "31045": true,
      "31046": true,
      "31047": true,
      "31048": true,
      "31049": true,
      "31050": true,
      "31051": true,
      "31052": true,
      "31053": true,
      "31054": true,
      "31055": true,
      "31056": true,
      "31057": true,
      "31058": true,
      "31059": true,
      "31060": true,
      "31061": true,
      "31062": true,
      "31063": true,
      "31064": true,
      "31065": true,
      "31066": true,
      "31067": true,
      "31068": true,
      "31069": true,
      "31070": true,
      "31071": true,
      "31072": true,
      "31073": true,
      "31074": true,
      "31075": true,
      "31076": true,
      "31077": true,
      "31078": true,
      "31079": true,
      "31080": true,
      "31081": true,
      "31082": true,
      "31083": true,
      "31084": true,
      "31085": true,
      "31086": true,
      "31087": true,
      "31088": true,
      "31089": true,
      "31090": true,
      "31091": true,
      "31092": true,
      "31093": true,
      "31094": true,
      "31095": true,
      "31096": true,
      "31097": true,
      "31098": true,
      "31099": true,
      "31100": true,
      "31101": true,
      "31102": true,
      "31103": true,
      "31104": true,
      "31105": true,
      "31106": true,
      "31107": true,
      "31108": true,
      "31109": true,
      "31110": true,
      "31111": true,
      "31112": true,
      "31113": true,
      "31114": true,
      "31115": true,
      "31116": true,
      "31117": true,
      "31118": true,
      "31119": true,
      "31120": true,
      "31121": true,
      "31122": true,
      "31123": true,
      "31124": true,
      "31125": true,
      "31126": true,
      "31127": true,
      "31128": true,
      "31129": true,
      "31130": true,
      "31131": true,
      "31132": true,
      "31133": true,
      "31134": true,
      "31135": true,
      "31136": true,
      "31137": true,
      "31138": true,
      "31139": true,
      "31140": true,
      "31141": true,
      "31142": true,
      "31143": true,
      "31144": true,
      "31145": true,
      "31146": true,
      "31147": true,
      "31148": true,
      "31149": true,
      "31150": true,
      "31151": true,
      "31152": true,
      "31153": true,
      "31154": true,
      "31155": true,
      "31156": true,
      "31157": true,
      "31158": true,
      "31159": true,
      "31160": true,
      "31161": true,
      "31162": true,
      "31163": true,
      "31164": true,
      "31165": true,
      "31166": true,
      "31167": true,
      "31168": true,
      "31169": true,
      "31170": true,
      "31171": true,
      "31172": true,
      "31173": true,
      "31174": true,
      "31175": true,
      "31176": true,
      "31177": true,
      "31178": true,
      "31179": true,
      "31180": true,
      "31181": true,
      "31182": true,
      "31183": true,
      "31184": true,
      "31185": true,
      "31186": true,
      "31187": true,
      "31188": true,
      "31189": true,
      "31190": true,
      "31191": true,
      "31192": true,
      "31193": true,
      "31194": true,
      "31195": true,
      "31196": true,
      "31197": true,
      "31198": true,
      "31199": true,
      "31200": true,
      "31201": true,
      "31202": true,
      "31203": true,
      "31204": true,
      "31205": true,
      "31206": true,
      "31207": true,
      "31208": true,
      "31209": true,
      "31210": true,
      "31211": true,
      "31212": true,
      "31213": true,
      "31214": true,
      "31215": true,
      "31216": true,
      "31217": true,
      "31218": true,
      "31219": true,
      "31220": true,
      "31221": true,
      "31222": true,
      "31223": true,
      "31224": true,
      "31225": true,
      "31226": true,
      "31227": true,
      "31228": true,
      "31229": true,
      "31230": true,
      "31231": true,
      "31232": true,
      "31233": true,
      "31234": true,
      "31235": true,
      "31236": true,
      "31237": true,
      "31238": true,
      "31239": true,
      "31240": true,
      "31241": true,
      "31242": true,
      "31243": true,
      "31244": true,
      "31245": true,
      "31246": true,
      "31247": true,
      "31248": true,
      "31249": true,
      "31250": true,
      "31251": true,
      "31252": true,
      "31253": true,
      "31254": true,
      "31255": true,
      "31256": true,
      "31257": true,
      "31258": true,
      "31259": true,
      "31260": true,
      "31261": true,
      "31262": true,
      "31263": true,
      "31264": true,
      "31265": true,
      "31266": true,
      "31267": true,
      "31268": true,
      "31269": true,
      "31270": true,
      "31271": true,
      "31272": true,
      "31273": true,
      "31274": true,
      "31275": true,
      "31276": true,
      "31277": true,
      "31278": true,
      "31279": true,
      "31280": true,
      "31281": true,
      "31282": true,
      "31283": true,
      "31284": true,
      "31285": true,
      "31286": true,
      "31287": true,
      "31288": true,
      "31289": true,
      "31290": true,
      "31291": true,
      "31292": true,
      "31293": true,
      "31294": true,
      "31295": true,
      "31296": true,
      "31297": true,
      "31298": true,
      "31299": true,
      "31300": true,
      "31301": true,
      "31302": true,
      "31303": true,
      "31304": true,
      "31305": true,
      "31306": true,
      "31307": true,
      "31308": true,
      "31309": true,
      "31310": true,
      "31311": true,
      "31312": true,
      "31313": true,
      "31314": true,
      "31315": true,
      "31316": true,
      "31317": true,
      "31318": true,
      "31319": true,
      "31320": true,
      "31321": true,
      "31322": true,
      "31323": true,
      "31324": true,
      "31325": true,
      "31326": true,
      "31327": true,
      "31328": true,
      "31329": true,
      "31330": true,
      "31331": true,
      "31332": true,
      "31333": true,
      "31334": true,
      "31335": true,
      "31336": true,
      "31337": true,
      "31338": true,
      "31339": true,
      "31340": true,
      "31341": true,
      "31342": true,
      "31343": true,
      "31344": true,
      "31345": true,
      "31346": true,
      "31347": true,
      "31348": true,
      "31349": true,
      "31350": true,
      "31351": true,
      "31352": true,
      "31353": true,
      "31354": true,
      "31355": true,
      "31356": true,
      "31357": true,
      "31358": true,
      "31359": true,
      "31360": true,
      "31361": true,
      "31362": true,
      "31363": true,
      "31364": true,
      "31365": true,
      "31366": true,
      "31367": true,
      "31368": true,
      "31369": true,
      "31370": true,
      "31371": true,
      "31372": true,
      "31373": true,
      "31374": true,
      "31375": true,
      "31376": true,
      "31377": true,
      "31378": true,
      "31379": true,
      "31380": true,
      "31381": true,
      "31382": true,
      "31383": true,
      "31384": true,
      "31385": true,
      "31386": true,
      "31387": true,
      "31388": true,
      "31389": true,
      "31390": true,
      "31391": true,
      "31392": true,
      "31393": true,
      "31394": true,
      "31395": true,
      "31396": true,
      "31397": true,
      "31398": true,
      "31399": true,
      "31400": true,
      "31401": true,
      "31402": true,
      "31403": true,
      "31404": true,
      "31405": true,
      "31406": true,
      "31407": true,
      "31408": true,
      "31409": true,
      "31410": true,
      "31411": true,
      "31412": true,
      "31413": true,
      "31414": true,
      "31415": true,
      "31416": true,
      "31417": true,
      "31418": true,
      "31419": true,
      "31420": true,
      "31421": true,
      "31422": true,
      "31423": true,
      "31424": true,
      "31425": true,
      "31426": true,
      "31427": true,
      "31428": true,
      "31429": true,
      "31430": true,
      "31431": true,
      "31432": true,
      "31433": true,
      "31434": true,
      "31435": true,
      "31436": true,
      "31437": true,
      "31438": true,
      "31439": true,
      "31440": true,
      "31441": true,
      "31442": true,
      "31443": true,
      "31444": true,
      "31445": true,
      "31446": true,
      "31447": true,
      "31448": true,
      "31449": true,
      "31450": true,
      "31451": true,
      "31452": true,
      "31453": true,
      "31454": true,
      "31455": true,
      "31456": true,
      "31457": true,
      "31458": true,
      "31459": true,
      "31460": true,
      "31461": true,
      "31462": true,
      "31463": true,
      "31464": true,
      "31465": true,
      "31466": true,
      "31467": true,
      "31468": true,
      "31469": true,
      "31470": true,
      "31471": true,
      "31472": true,
      "31473": true,
      "31474": true,
      "31475": true,
      "31476": true,
      "31477": true,
      "31478": true,
      "31479": true,
      "31480": true,
      "31481": true,
      "31482": true,
      "31483": true,
      "31484": true,
      "31485": true,
      "31486": true,
      "31487": true,
      "31488": true,
      "31489": true,
      "31490": true,
      "31491": true,
      "31492": true,
      "31493": true,
      "31494": true,
      "31495": true,
      "31496": true,
      "31497": true,
      "31498": true,
      "31499": true,
      "31620": true,
      "31621": true,
      "31622": true,
      "31623": true,
      "31624": true,
      "31625": true,
      "31626": true,
      "31627": true,
      "31628": true,
      "31629": true,
      "31630": true,
      "31631": true,
      "31632": true,
      "31633": true,
      "31634": true,
      "31635": true,
      "31636": true,
      "31637": true,
      "31638": true,
      "31639": true
    },
    "CUAUHTÉMOC": {
      "31500": true,
      "31501": true,
      "31502": true,
      "31503": true,
      "31504": true,
      "31505": true,
      "31506": true,
      "31507": true,
      "31508": true,
      "31509": true,
      "31510": true,
      "31511": true,
      "31512": true,
      "31513": true,
      "31514": true,
      "31515": true,
      "31516": true,
      "31517": true,
      "31518": true,
      "31519": true,
      "31520": true,
      "31521": true,
      "31522": true,
      "31523": true,
      "31524": true,
      "31525": true,
      "31526": true,
      "31527": true,
      "31528": true,
      "31529": true,
      "31530": true,
      "31531": true,
      "31532": true,
      "31533": true,
      "31534": true,
      "31535": true,
      "31536": true,
      "31537": true,
      "31538": true,
      "31539": true,
      "31540": true,
      "31541": true,
      "31542": true,
      "31543": true,
      "31544": true,
      "31545": true,
      "31546": true,
      "31547": true,
      "31548": true,
      "31549": true,
      "31550": true,
      "31551": true,
      "31552": true,
      "31553": true,
      "31554": true,
      "31555": true,
      "31556": true,
      "31557": true,
      "31558": true,
      "31559": true,
      "31560": true,
      "31561": true,
      "31562": true,
      "31563": true,
      "31564": true,
      "31565": true,
      "31566": true,
      "31567": true,
      "31568": true,
      "31569": true,
      "31570": true,
      "31571": true,
      "31572": true,
      "31573": true,
      "31574": true,
      "31575": true,
      "31576": true,
      "31577": true,
      "31578": true,
      "31579": true,
      "31580": true,
      "31581": true,
      "31582": true,
      "31583": true,
      "31584": true,
      "31585": true,
      "31586": true,
      "31587": true,
      "31588": true,
      "31589": true,
      "31590": true,
      "31591": true,
      "31592": true,
      "31593": true,
      "31594": true,
      "31595": true,
      "31596": true,
      "31597": true,
      "31598": true,
      "31599": true,
      "31600": true,
      "31601": true,
      "31602": true,
      "31603": true,
      "31604": true,
      "31605": true,
      "31606": true,
      "31607": true,
      "31608": true,
      "31609": true,
      "31610": true,
      "31613": true,
      "31614": true,
      "31615": true,
      "31616": true,
      "31617": true,
      "31618": true,
      "31619": true
    },
    "DELICIAS": {
      "33000": true,
      "33001": true,
      "33002": true,
      "33003": true,
      "33004": true,
      "33005": true,
      "33006": true,
      "33007": true,
      "33008": true,
      "33009": true,
      "33010": true,
      "33011": true,
      "33012": true,
      "33013": true,
      "33014": true,
      "33015": true,
      "33016": true,
      "33017": true,
      "33018": true,
      "33019": true,
      "33020": true,
      "33021": true,
      "33022": true,
      "33023": true,
      "33024": true,
      "33025": true,
      "33026": true,
      "33027": true,
      "33028": true,
      "33029": true,
      "33030": true,
      "33031": true,
      "33032": true,
      "33033": true,
      "33034": true,
      "33035": true,
      "33036": true,
      "33037": true,
      "33038": true,
      "33039": true,
      "33040": true,
      "33041": true,
      "33042": true,
      "33043": true,
      "33044": true,
      "33045": true,
      "33046": true,
      "33047": true,
      "33048": true,
      "33049": true,
      "33050": true,
      "33051": true,
      "33052": true,
      "33053": true,
      "33054": true,
      "33055": true,
      "33056": true,
      "33057": true,
      "33058": true,
      "33059": true,
      "33060": true,
      "33061": true,
      "33062": true,
      "33063": true,
      "33064": true,
      "33065": true,
      "33066": true,
      "33067": true,
      "33068": true,
      "33069": true,
      "33070": true,
      "33071": true,
      "33072": true,
      "33073": true,
      "33074": true,
      "33075": true,
      "33076": true,
      "33077": true,
      "33078": true,
      "33079": true,
      "33080": true,
      "33081": true,
      "33082": true,
      "33083": true,
      "33084": true,
      "33085": true,
      "33086": true,
      "33087": true,
      "33088": true,
      "33089": true,
      "33090": true,
      "33091": true,
      "33092": true,
      "33093": true,
      "33094": true,
      "33095": true,
      "33096": true,
      "33097": true,
      "33098": true,
      "33099": true,
      "33100": true,
      "33101": true,
      "33102": true,
      "33103": true,
      "33104": true,
      "33105": true,
      "33106": true,
      "33107": true,
      "33108": true,
      "33109": true,
      "33113": true,
      "33114": true,
      "33115": true,
      "33116": true
    },
    "GUACHOCHI": {
      "33180": true,
      "33181": true,
      "33182": true,
      "33183": true,
      "33184": true,
      "33185": true,
      "33186": true,
      "33187": true,
      "33197": true
    },
    "HIDALGO DEL PARRAL": {
      "33800": true,
      "33801": true,
      "33802": true,
      "33803": true,
      "33804": true,
      "33805": true,
      "33806": true,
      "33807": true,
      "33808": true,
      "33809": true,
      "33810": true,
      "33811": true,
      "33812": true,
      "33813": true,
      "33814": true,
      "33815": true,
      "33816": true,
      "33817": true,
      "33818": true,
      "33819": true,
      "33820": true,
      "33821": true,
      "33822": true,
      "33823": true,
      "33824": true,
      "33825": true,
      "33826": true,
      "33827": true,
      "33828": true,
      "33829": true,
      "33830": true,
      "33831": true,
      "33832": true,
      "33833": true,
      "33834": true,
      "33835": true,
      "33836": true,
      "33837": true,
      "33838": true,
      "33839": true,
      "33840": true,
      "33841": true,
      "33842": true,
      "33843": true,
      "33844": true,
      "33845": true,
      "33846": true,
      "33847": true,
      "33848": true,
      "33849": true,
      "33850": true,
      "33851": true,
      "33852": true,
      "33853": true,
      "33854": true,
      "33855": true,
      "33856": true,
      "33857": true,
      "33858": true,
      "33859": true,
      "33860": true,
      "33861": true,
      "33862": true,
      "33863": true,
      "33864": true,
      "33865": true,
      "33866": true,
      "33867": true,
      "33868": true,
      "33869": true,
      "33870": true,
      "33871": true,
      "33872": true,
      "33873": true,
      "33874": true,
      "33875": true,
      "33876": true,
      "33877": true,
      "33878": true,
      "33879": true,
      "33880": true,
      "33881": true,
      "33882": true,
      "33883": true,
      "33884": true,
      "33885": true,
      "33886": true,
      "33887": true,
      "33888": true,
      "33889": true,
      "33890": true,
      "33891": true,
      "33892": true,
      "33893": true,
      "33894": true,
      "33895": true,
      "33896": true,
      "33897": true,
      "33898": true,
      "33899": true,
      "33900": true,
      "33901": true,
      "33902": true,
      "33903": true,
      "33905": true,
      "33906": true,
      "33907": true,
      "33908": true,
      "33909": true,
      "33913": true,
      "33914": true,
      "33917": true,
      "33918": true,
      "33919": true
    },
    "JIMENEZ": {
      "33970": true,
      "33971": true,
      "33972": true,
      "33974": true,
      "33976": true,
      "33980": true,
      "33981": true,
      "33982": true,
      "33983": true,
      "33984": true,
      "33985": true,
      "33986": true,
      "33987": true,
      "33988": true,
      "33989": true
    },
    "JUÁREZ": {
      "32000": true,
      "32001": true,
      "32002": true,
      "32003": true,
      "32004": true,
      "32005": true,
      "32006": true,
      "32007": true,
      "32008": true,
      "32009": true,
      "32010": true,
      "32011": true,
      "32012": true,
      "32013": true,
      "32014": true,
      "32015": true,
      "32016": true,
      "32017": true,
      "32018": true,
      "32019": true,
      "32020": true,
      "32021": true,
      "32022": true,
      "32023": true,
      "32024": true,
      "32025": true,
      "32026": true,
      "32027": true,
      "32028": true,
      "32029": true,
      "32030": true,
      "32031": true,
      "32032": true,
      "32033": true,
      "32034": true,
      "32035": true,
      "32036": true,
      "32037": true,
      "32038": true,
      "32039": true,
      "32040": true,
      "32041": true,
      "32042": true,
      "32043": true,
      "32044": true,
      "32045": true,
      "32046": true,
      "32047": true,
      "32048": true,
      "32049": true,
      "32050": true,
      "32051": true,
      "32052": true,
      "32053": true,
      "32054": true,
      "32055": true,
      "32056": true,
      "32057": true,
      "32058": true,
      "32059": true,
      "32060": true,
      "32061": true,
      "32062": true,
      "32063": true,
      "32064": true,
      "32065": true,
      "32066": true,
      "32067": true,
      "32068": true,
      "32069": true,
      "32070": true,
      "32071": true,
      "32072": true,
      "32073": true,
      "32074": true,
      "32075": true,
      "32076": true,
      "32077": true,
      "32078": true,
      "32079": true,
      "32080": true,
      "32081": true,
      "32082": true,
      "32083": true,
      "32084": true,
      "32085": true,
      "32086": true,
      "32087": true,
      "32088": true,
      "32089": true,
      "32090": true,
      "32091": true,
      "32092": true,
      "32093": true,
      "32094": true,
      "32095": true,
      "32096": true,
      "32097": true,
      "32098": true,
      "32099": true,
      "32100": true,
      "32101": true,
      "32102": true,
      "32103": true,
      "32104": true,
      "32105": true,
      "32106": true,
      "32107": true,
      "32108": true,
      "32109": true,
      "32110": true,
      "32111": true,
      "32112": true,
      "32113": true,
      "32114": true,
      "32115": true,
      "32116": true,
      "32117": true,
      "32118": true,
      "32119": true,
      "32120": true,
      "32121": true,
      "32122": true,
      "32123": true,
      "32124": true,
      "32125": true,
      "32126": true,
      "32127": true,
      "32128": true,
      "32129": true,
      "32130": true,
      "32131": true,
      "32132": true,
      "32133": true,
      "32134": true,
      "32135": true,
      "32136": true,
      "32137": true,
      "32138": true,
      "32139": true,
      "32140": true,
      "32141": true,
      "32142": true,
      "32143": true,
      "32144": true,
      "32145": true,
      "32146": true,
      "32147": true,
      "32148": true,
      "32149": true,
      "32150": true,
      "32151": true,
      "32152": true,
      "32153": true,
      "32154": true,
      "32155": true,
      "32156": true,
      "32157": true,
      "32158": true,
      "32159": true,
      "32160": true,
      "32161": true,
      "32162": true,
      "32163": true,
      "32164": true,
      "32165": true,
      "32166": true,
      "32167": true,
      "32168": true,
      "32169": true,
      "32170": true,
      "32171": true,
      "32172": true,
      "32173": true,
      "32174": true,
      "32175": true,
      "32176": true,
      "32177": true,
      "32178": true,
      "32179": true,
      "32180": true,
      "32181": true,
      "32182": true,
      "32183": true,
      "32184": true,
      "32185": true,
      "32186": true,
      "32187": true,
      "32188": true,
      "32189": true,
      "32190": true,
      "32191": true,
      "32192": true,
      "32193": true,
      "32194": true,
      "32195": true,
      "32196": true,
      "32197": true,
      "32198": true,
      "32199": true,
      "32200": true,
      "32201": true,
      "32202": true,
      "32203": true,
      "32204": true,
      "32205": true,
      "32206": true,
      "32207": true,
      "32208": true,
      "32209": true,
      "32210": true,
      "32211": true,
      "32212": true,
      "32213": true,
      "32214": true,
      "32215": true,
      "32216": true,
      "32217": true,
      "32218": true,
      "32219": true,
      "32220": true,
      "32221": true,
      "32222": true,
      "32223": true,
      "32224": true,
      "32225": true,
      "32226": true,
      "32227": true,
      "32228": true,
      "32229": true,
      "32230": true,
      "32231": true,
      "32232": true,
      "32233": true,
      "32234": true,
      "32235": true,
      "32236": true,
      "32237": true,
      "32238": true,
      "32239": true,
      "32240": true,
      "32241": true,
      "32242": true,
      "32243": true,
      "32244": true,
      "32245": true,
      "32246": true,
      "32247": true,
      "32248": true,
      "32249": true,
      "32250": true,
      "32251": true,
      "32252": true,
      "32253": true,
      "32254": true,
      "32255": true,
      "32256": true,
      "32257": true,
      "32258": true,
      "32259": true,
      "32260": true,
      "32261": true,
      "32262": true,
      "32263": true,
      "32264": true,
      "32265": true,
      "32266": true,
      "32267": true,
      "32268": true,
      "32269": true,
      "32270": true,
      "32271": true,
      "32272": true,
      "32273": true,
      "32274": true,
      "32275": true,
      "32276": true,
      "32277": true,
      "32278": true,
      "32279": true,
      "32280": true,
      "32281": true,
      "32282": true,
      "32283": true,
      "32284": true,
      "32285": true,
      "32286": true,
      "32287": true,
      "32288": true,
      "32289": true,
      "32290": true,
      "32291": true,
      "32292": true,
      "32293": true,
      "32294": true,
      "32295": true,
      "32296": true,
      "32297": true,
      "32298": true,
      "32299": true,
      "32300": true,
      "32301": true,
      "32302": true,
      "32303": true,
      "32304": true,
      "32305": true,
      "32306": true,
      "32307": true,
      "32308": true,
      "32309": true,
      "32310": true,
      "32311": true,
      "32312": true,
      "32313": true,
      "32314": true,
      "32315": true,
      "32316": true,
      "32317": true,
      "32318": true,
      "32319": true,
      "32320": true,
      "32321": true,
      "32322": true,
      "32323": true,
      "32324": true,
      "32325": true,
      "32326": true,
      "32327": true,
      "32328": true,
      "32329": true,
      "32330": true,
      "32331": true,
      "32332": true,
      "32333": true,
      "32334": true,
      "32335": true,
      "32336": true,
      "32337": true,
      "32338": true,
      "32339": true,
      "32340": true,
      "32341": true,
      "32342": true,
      "32343": true,
      "32344": true,
      "32345": true,
      "32346": true,
      "32347": true,
      "32348": true,
      "32349": true,
      "32350": true,
      "32351": true,
      "32352": true,
      "32353": true,
      "32354": true,
      "32355": true,
      "32356": true,
      "32357": true,
      "32358": true,
      "32359": true,
      "32360": true,
      "32361": true,
      "32362": true,
      "32363": true,
      "32364": true,
      "32365": true,
      "32366": true,
      "32367": true,
      "32368": true,
      "32369": true,
      "32370": true,
      "32371": true,
      "32372": true,
      "32373": true,
      "32374": true,
      "32375": true,
      "32376": true,
      "32377": true,
      "32378": true,
      "32379": true,
      "32380": true,
      "32381": true,
      "32382": true,
      "32383": true,
      "32384": true,
      "32385": true,
      "32386": true,
      "32387": true,
      "32388": true,
      "32389": true,
      "32390": true,
      "32391": true,
      "32392": true,
      "32393": true,
      "32394": true,
      "32395": true,
      "32396": true,
      "32397": true,
      "32398": true,
      "32399": true,
      "32400": true,
      "32401": true,
      "32402": true,
      "32403": true,
      "32404": true,
      "32405": true,
      "32406": true,
      "32407": true,
      "32408": true,
      "32409": true,
      "32410": true,
      "32411": true,
      "32412": true,
      "32413": true,
      "32414": true,
      "32415": true,
      "32416": true,
      "32417": true,
      "32418": true,
      "32419": true,
      "32420": true,
      "32421": true,
      "32422": true,
      "32423": true,
      "32424": true,
      "32425": true,
      "32426": true,
      "32427": true,
      "32428": true,
      "32429": true,
      "32430": true,
      "32431": true,
      "32432": true,
      "32433": true,
      "32434": true,
      "32435": true,
      "32436": true,
      "32437": true,
      "32438": true,
      "32439": true,
      "32440": true,
      "32441": true,
      "32442": true,
      "32443": true,
      "32444": true,
      "32445": true,
      "32446": true,
      "32447": true,
      "32448": true,
      "32449": true,
      "32450": true,
      "32451": true,
      "32452": true,
      "32453": true,
      "32454": true,
      "32455": true,
      "32456": true,
      "32457": true,
      "32458": true,
      "32459": true,
      "32460": true,
      "32461": true,
      "32462": true,
      "32463": true,
      "32464": true,
      "32465": true,
      "32466": true,
      "32467": true,
      "32468": true,
      "32469": true,
      "32470": true,
      "32471": true,
      "32472": true,
      "32473": true,
      "32474": true,
      "32475": true,
      "32476": true,
      "32477": true,
      "32478": true,
      "32479": true,
      "32480": true,
      "32481": true,
      "32482": true,
      "32483": true,
      "32484": true,
      "32485": true,
      "32486": true,
      "32487": true,
      "32488": true,
      "32489": true,
      "32490": true,
      "32491": true,
      "32492": true,
      "32493": true,
      "32494": true,
      "32495": true,
      "32496": true,
      "32497": true,
      "32498": true,
      "32499": true,
      "32500": true,
      "32501": true,
      "32502": true,
      "32503": true,
      "32504": true,
      "32505": true,
      "32506": true,
      "32507": true,
      "32508": true,
      "32509": true,
      "32510": true,
      "32511": true,
      "32512": true,
      "32513": true,
      "32514": true,
      "32515": true,
      "32516": true,
      "32517": true,
      "32518": true,
      "32519": true,
      "32520": true,
      "32521": true,
      "32522": true,
      "32523": true,
      "32524": true,
      "32525": true,
      "32526": true,
      "32527": true,
      "32528": true,
      "32529": true,
      "32530": true,
      "32531": true,
      "32532": true,
      "32533": true,
      "32534": true,
      "32535": true,
      "32536": true,
      "32537": true,
      "32538": true,
      "32539": true,
      "32540": true,
      "32541": true,
      "32542": true,
      "32543": true,
      "32544": true,
      "32545": true,
      "32546": true,
      "32547": true,
      "32548": true,
      "32549": true,
      "32550": true,
      "32551": true,
      "32552": true,
      "32553": true,
      "32554": true,
      "32555": true,
      "32556": true,
      "32557": true,
      "32558": true,
      "32559": true,
      "32560": true,
      "32561": true,
      "32562": true,
      "32563": true,
      "32564": true,
      "32565": true,
      "32566": true,
      "32567": true,
      "32568": true,
      "32569": true,
      "32570": true,
      "32571": true,
      "32572": true,
      "32573": true,
      "32574": true,
      "32575": true,
      "32576": true,
      "32577": true,
      "32578": true,
      "32579": true,
      "32580": true,
      "32581": true,
      "32582": true,
      "32583": true,
      "32584": true,
      "32585": true,
      "32586": true,
      "32587": true,
      "32588": true,
      "32589": true,
      "32590": true,
      "32591": true,
      "32592": true,
      "32593": true,
      "32594": true,
      "32595": true,
      "32596": true,
      "32597": true,
      "32598": true,
      "32599": true,
      "32600": true,
      "32601": true,
      "32602": true,
      "32603": true,
      "32604": true,
      "32605": true,
      "32606": true,
      "32607": true,
      "32608": true,
      "32609": true,
      "32610": true,
      "32611": true,
      "32612": true,
      "32613": true,
      "32614": true,
      "32615": true,
      "32616": true,
      "32617": true,
      "32618": true,
      "32619": true,
      "32620": true,
      "32621": true,
      "32622": true,
      "32623": true,
      "32624": true,
      "32625": true,
      "32626": true,
      "32627": true,
      "32628": true,
      "32629": true,
      "32630": true,
      "32631": true,
      "32632": true,
      "32633": true,
      "32634": true,
      "32635": true,
      "32636": true,
      "32637": true,
      "32638": true,
      "32639": true,
      "32640": true,
      "32641": true,
      "32642": true,
      "32643": true,
      "32644": true,
      "32645": true,
      "32646": true,
      "32647": true,
      "32648": true,
      "32649": true,
      "32650": true,
      "32651": true,
      "32652": true,
      "32653": true,
      "32654": true,
      "32655": true,
      "32656": true,
      "32657": true,
      "32658": true,
      "32659": true,
      "32660": true,
      "32661": true,
      "32662": true,
      "32663": true,
      "32664": true,
      "32665": true,
      "32666": true,
      "32667": true,
      "32668": true,
      "32669": true,
      "32670": true,
      "32671": true,
      "32672": true,
      "32673": true,
      "32674": true,
      "32675": true,
      "32676": true,
      "32677": true,
      "32678": true,
      "32679": true,
      "32680": true,
      "32681": true,
      "32682": true,
      "32683": true,
      "32684": true,
      "32685": true,
      "32686": true,
      "32687": true,
      "32688": true,
      "32689": true,
      "32690": true,
      "32691": true,
      "32692": true,
      "32693": true,
      "32694": true,
      "32695": true,
      "32696": true,
      "32697": true,
      "32698": true,
      "32699": true,
      "32700": true,
      "32701": true,
      "32702": true,
      "32703": true,
      "32704": true,
      "32705": true,
      "32706": true,
      "32707": true,
      "32708": true,
      "32709": true,
      "32710": true,
      "32711": true,
      "32712": true,
      "32713": true,
      "32714": true,
      "32715": true,
      "32716": true,
      "32717": true,
      "32718": true,
      "32719": true,
      "32720": true,
      "32721": true,
      "32722": true,
      "32723": true,
      "32724": true,
      "32725": true,
      "32726": true,
      "32727": true,
      "32728": true,
      "32729": true,
      "32730": true,
      "32731": true,
      "32732": true,
      "32733": true,
      "32734": true,
      "32735": true,
      "32736": true,
      "32737": true,
      "32738": true,
      "32739": true
    },
    "OJINAGA": {
      "32880": true,
      "32881": true,
      "32882": true,
      "32883": true,
      "32884": true,
      "32885": true,
      "32886": true,
      "32888": true,
      "32894": true,
      "32895": true,
      "32896": true,
      "32897": true,
      "32898": true,
      "32899": true
    }
  },
  "CIUDAD DE MÉXICO": {
    "ALVARO OBREGÓN": {
      "01000": true,
      "01001": true,
      "01002": true,
      "01003": true,
      "01004": true,
      "01005": true,
      "01006": true,
      "01007": true,
      "01008": true,
      "01009": true,
      "01010": true,
      "01011": true,
      "01012": true,
      "01013": true,
      "01014": true,
      "01015": true,
      "01016": true,
      "01017": true,
      "01018": true,
      "01019": true,
      "01020": true,
      "01021": true,
      "01022": true,
      "01023": true,
      "01024": true,
      "01025": true,
      "01026": true,
      "01027": true,
      "01028": true,
      "01029": true,
      "01030": true,
      "01031": true,
      "01032": true,
      "01033": true,
      "01034": true,
      "01035": true,
      "01036": true,
      "01037": true,
      "01038": true,
      "01039": true,
      "01040": true,
      "01041": true,
      "01042": true,
      "01043": true,
      "01044": true,
      "01045": true,
      "01046": true,
      "01047": true,
      "01048": true,
      "01049": true,
      "01050": true,
      "01051": true,
      "01052": true,
      "01053": true,
      "01054": true,
      "01055": true,
      "01056": true,
      "01057": true,
      "01058": true,
      "01059": true,
      "01060": true,
      "01061": true,
      "01062": true,
      "01063": true,
      "01064": true,
      "01065": true,
      "01066": true,
      "01067": true,
      "01068": true,
      "01069": true,
      "01070": true,
      "01071": true,
      "01072": true,
      "01073": true,
      "01074": true,
      "01075": true,
      "01076": true,
      "01077": true,
      "01078": true,
      "01079": true,
      "01080": true,
      "01081": true,
      "01082": true,
      "01083": true,
      "01084": true,
      "01085": true,
      "01086": true,
      "01087": true,
      "01088": true,
      "01089": true,
      "01090": true,
      "01091": true,
      "01092": true,
      "01093": true,
      "01094": true,
      "01095": true,
      "01096": true,
      "01097": true,
      "01098": true,
      "01099": true,
      "01100": true,
      "01101": true,
      "01102": true,
      "01103": true,
      "01104": true,
      "01105": true,
      "01106": true,
      "01107": true,
      "01108": true,
      "01109": true,
      "01110": true,
      "01111": true,
      "01112": true,
      "01113": true,
      "01114": true,
      "01115": true,
      "01116": true,
      "01117": true,
      "01118": true,
      "01119": true,
      "01120": true,
      "01121": true,
      "01122": true,
      "01123": true,
      "01124": true,
      "01125": true,
      "01126": true,
      "01127": true,
      "01128": true,
      "01129": true,
      "01130": true,
      "01131": true,
      "01132": true,
      "01133": true,
      "01134": true,
      "01135": true,
      "01136": true,
      "01137": true,
      "01138": true,
      "01139": true,
      "01140": true,
      "01141": true,
      "01142": true,
      "01143": true,
      "01144": true,
      "01145": true,
      "01146": true,
      "01147": true,
      "01148": true,
      "01149": true,
      "01150": true,
      "01151": true,
      "01152": true,
      "01153": true,
      "01154": true,
      "01155": true,
      "01156": true,
      "01157": true,
      "01158": true,
      "01159": true,
      "01160": true,
      "01161": true,
      "01162": true,
      "01163": true,
      "01164": true,
      "01165": true,
      "01166": true,
      "01167": true,
      "01168": true,
      "01169": true,
      "01170": true,
      "01171": true,
      "01172": true,
      "01173": true,
      "01174": true,
      "01175": true,
      "01176": true,
      "01177": true,
      "01178": true,
      "01179": true,
      "01180": true,
      "01181": true,
      "01182": true,
      "01183": true,
      "01184": true,
      "01185": true,
      "01186": true,
      "01187": true,
      "01188": true,
      "01189": true,
      "01190": true,
      "01191": true,
      "01192": true,
      "01193": true,
      "01194": true,
      "01195": true,
      "01196": true,
      "01197": true,
      "01198": true,
      "01199": true,
      "01200": true,
      "01201": true,
      "01202": true,
      "01203": true,
      "01204": true,
      "01205": true,
      "01206": true,
      "01207": true,
      "01208": true,
      "01209": true,
      "01210": true,
      "01211": true,
      "01212": true,
      "01213": true,
      "01214": true,
      "01215": true,
      "01216": true,
      "01217": true,
      "01218": true,
      "01219": true,
      "01220": true,
      "01221": true,
      "01222": true,
      "01223": true,
      "01224": true,
      "01225": true,
      "01226": true,
      "01227": true,
      "01228": true,
      "01229": true,
      "01230": true,
      "01231": true,
      "01232": true,
      "01233": true,
      "01234": true,
      "01235": true,
      "01236": true,
      "01237": true,
      "01238": true,
      "01239": true,
      "01240": true,
      "01241": true,
      "01242": true,
      "01243": true,
      "01244": true,
      "01245": true,
      "01246": true,
      "01247": true,
      "01248": true,
      "01249": true,
      "01250": true,
      "01251": true,
      "01252": true,
      "01253": true,
      "01254": true,
      "01255": true,
      "01256": true,
      "01257": true,
      "01258": true,
      "01259": true,
      "01260": true,
      "01261": true,
      "01262": true,
      "01263": true,
      "01264": true,
      "01265": true,
      "01266": true,
      "01267": true,
      "01268": true,
      "01269": true,
      "01270": true,
      "01271": true,
      "01272": true,
      "01273": true,
      "01274": true,
      "01275": true,
      "01276": true,
      "01277": true,
      "01278": true,
      "01279": true,
      "01280": true,
      "01281": true,
      "01282": true,
      "01283": true,
      "01284": true,
      "01285": true,
      "01286": true,
      "01287": true,
      "01288": true,
      "01289": true,
      "01290": true,
      "01291": true,
      "01292": true,
      "01293": true,
      "01294": true,
      "01295": true,
      "01296": true,
      "01297": true,
      "01298": true,
      "01299": true,
      "01300": true,
      "01301": true,
      "01302": true,
      "01303": true,
      "01304": true,
      "01305": true,
      "01306": true,
      "01307": true,
      "01308": true,
      "01309": true,
      "01310": true,
      "01311": true,
      "01312": true,
      "01313": true,
      "01314": true,
      "01315": true,
      "01316": true,
      "01317": true,
      "01318": true,
      "01319": true,
      "01320": true,
      "01321": true,
      "01322": true,
      "01323": true,
      "01324": true,
      "01325": true,
      "01326": true,
      "01327": true,
      "01328": true,
      "01329": true,
      "01330": true,
      "01331": true,
      "01332": true,
      "01333": true,
      "01334": true,
      "01335": true,
      "01336": true,
      "01337": true,
      "01338": true,
      "01339": true,
      "01340": true,
      "01341": true,
      "01342": true,
      "01343": true,
      "01344": true,
      "01345": true,
      "01346": true,
      "01347": true,
      "01348": true,
      "01349": true,
      "01350": true,
      "01351": true,
      "01352": true,
      "01353": true,
      "01354": true,
      "01355": true,
      "01356": true,
      "01357": true,
      "01358": true,
      "01359": true,
      "01360": true,
      "01361": true,
      "01362": true,
      "01363": true,
      "01364": true,
      "01365": true,
      "01366": true,
      "01367": true,
      "01368": true,
      "01369": true,
      "01370": true,
      "01371": true,
      "01372": true,
      "01373": true,
      "01374": true,
      "01375": true,
      "01376": true,
      "01377": true,
      "01378": true,
      "01379": true,
      "01380": true,
      "01381": true,
      "01382": true,
      "01383": true,
      "01384": true,
      "01385": true,
      "01386": true,
      "01387": true,
      "01388": true,
      "01389": true,
      "01390": true,
      "01391": true,
      "01392": true,
      "01393": true,
      "01394": true,
      "01395": true,
      "01396": true,
      "01397": true,
      "01398": true,
      "01399": true,
      "01400": true,
      "01401": true,
      "01402": true,
      "01403": true,
      "01404": true,
      "01405": true,
      "01406": true,
      "01407": true,
      "01408": true,
      "01409": true,
      "01410": true,
      "01411": true,
      "01412": true,
      "01413": true,
      "01414": true,
      "01415": true,
      "01416": true,
      "01417": true,
      "01418": true,
      "01419": true,
      "01420": true,
      "01421": true,
      "01422": true,
      "01423": true,
      "01424": true,
      "01425": true,
      "01426": true,
      "01427": true,
      "01428": true,
      "01429": true,
      "01430": true,
      "01431": true,
      "01432": true,
      "01433": true,
      "01434": true,
      "01435": true,
      "01436": true,
      "01437": true,
      "01438": true,
      "01439": true,
      "01440": true,
      "01441": true,
      "01442": true,
      "01443": true,
      "01444": true,
      "01445": true,
      "01446": true,
      "01447": true,
      "01448": true,
      "01449": true,
      "01450": true,
      "01451": true,
      "01452": true,
      "01453": true,
      "01454": true,
      "01455": true,
      "01456": true,
      "01457": true,
      "01458": true,
      "01459": true,
      "01460": true,
      "01461": true,
      "01462": true,
      "01463": true,
      "01464": true,
      "01465": true,
      "01466": true,
      "01467": true,
      "01468": true,
      "01469": true,
      "01470": true,
      "01471": true,
      "01472": true,
      "01473": true,
      "01474": true,
      "01475": true,
      "01476": true,
      "01477": true,
      "01478": true,
      "01479": true,
      "01480": true,
      "01481": true,
      "01482": true,
      "01483": true,
      "01484": true,
      "01485": true,
      "01486": true,
      "01487": true,
      "01488": true,
      "01489": true,
      "01490": true,
      "01491": true,
      "01492": true,
      "01493": true,
      "01494": true,
      "01495": true,
      "01496": true,
      "01497": true,
      "01498": true,
      "01499": true,
      "01500": true,
      "01501": true,
      "01502": true,
      "01503": true,
      "01504": true,
      "01505": true,
      "01506": true,
      "01507": true,
      "01508": true,
      "01509": true,
      "01510": true,
      "01511": true,
      "01512": true,
      "01513": true,
      "01514": true,
      "01515": true,
      "01516": true,
      "01517": true,
      "01518": true,
      "01519": true,
      "01520": true,
      "01521": true,
      "01522": true,
      "01523": true,
      "01524": true,
      "01525": true,
      "01526": true,
      "01527": true,
      "01528": true,
      "01529": true,
      "01530": true,
      "01531": true,
      "01532": true,
      "01533": true,
      "01534": true,
      "01535": true,
      "01536": true,
      "01537": true,
      "01538": true,
      "01539": true,
      "01540": true,
      "01541": true,
      "01542": true,
      "01543": true,
      "01544": true,
      "01545": true,
      "01546": true,
      "01547": true,
      "01548": true,
      "01549": true,
      "01550": true,
      "01551": true,
      "01552": true,
      "01553": true,
      "01554": true,
      "01555": true,
      "01556": true,
      "01557": true,
      "01558": true,
      "01559": true,
      "01560": true,
      "01561": true,
      "01562": true,
      "01563": true,
      "01564": true,
      "01565": true,
      "01566": true,
      "01567": true,
      "01568": true,
      "01569": true,
      "01570": true,
      "01571": true,
      "01572": true,
      "01573": true,
      "01574": true,
      "01575": true,
      "01576": true,
      "01577": true,
      "01578": true,
      "01579": true,
      "01580": true,
      "01581": true,
      "01582": true,
      "01583": true,
      "01584": true,
      "01585": true,
      "01586": true,
      "01587": true,
      "01588": true,
      "01589": true,
      "01590": true,
      "01591": true,
      "01592": true,
      "01593": true,
      "01594": true,
      "01595": true,
      "01596": true,
      "01597": true,
      "01598": true,
      "01599": true,
      "01600": true,
      "01601": true,
      "01602": true,
      "01603": true,
      "01604": true,
      "01605": true,
      "01606": true,
      "01607": true,
      "01608": true,
      "01609": true,
      "01610": true,
      "01611": true,
      "01612": true,
      "01613": true,
      "01614": true,
      "01615": true,
      "01616": true,
      "01617": true,
      "01618": true,
      "01619": true,
      "01620": true,
      "01621": true,
      "01622": true,
      "01623": true,
      "01624": true,
      "01625": true,
      "01626": true,
      "01627": true,
      "01628": true,
      "01629": true,
      "01630": true,
      "01631": true,
      "01632": true,
      "01633": true,
      "01634": true,
      "01635": true,
      "01636": true,
      "01637": true,
      "01638": true,
      "01639": true,
      "01640": true,
      "01641": true,
      "01642": true,
      "01643": true,
      "01644": true,
      "01645": true,
      "01646": true,
      "01647": true,
      "01648": true,
      "01649": true,
      "01650": true,
      "01651": true,
      "01652": true,
      "01653": true,
      "01654": true,
      "01655": true,
      "01656": true,
      "01657": true,
      "01658": true,
      "01659": true,
      "01660": true,
      "01661": true,
      "01662": true,
      "01663": true,
      "01664": true,
      "01665": true,
      "01666": true,
      "01667": true,
      "01668": true,
      "01669": true,
      "01670": true,
      "01671": true,
      "01672": true,
      "01673": true,
      "01674": true,
      "01675": true,
      "01676": true,
      "01677": true,
      "01678": true,
      "01679": true,
      "01680": true,
      "01681": true,
      "01682": true,
      "01683": true,
      "01684": true,
      "01685": true,
      "01686": true,
      "01687": true,
      "01688": true,
      "01689": true,
      "01690": true,
      "01691": true,
      "01692": true,
      "01693": true,
      "01694": true,
      "01695": true,
      "01696": true,
      "01697": true,
      "01698": true,
      "01699": true,
      "01700": true,
      "01701": true,
      "01702": true,
      "01703": true,
      "01704": true,
      "01705": true,
      "01706": true,
      "01707": true,
      "01708": true,
      "01709": true,
      "01710": true,
      "01711": true,
      "01712": true,
      "01713": true,
      "01714": true,
      "01715": true,
      "01716": true,
      "01717": true,
      "01718": true,
      "01719": true,
      "01720": true,
      "01721": true,
      "01722": true,
      "01723": true,
      "01724": true,
      "01725": true,
      "01726": true,
      "01727": true,
      "01728": true,
      "01729": true,
      "01730": true,
      "01731": true,
      "01732": true,
      "01733": true,
      "01734": true,
      "01735": true,
      "01736": true,
      "01737": true,
      "01738": true,
      "01739": true,
      "01740": true,
      "01741": true,
      "01742": true,
      "01743": true,
      "01744": true,
      "01745": true,
      "01746": true,
      "01747": true,
      "01748": true,
      "01749": true,
      "01750": true,
      "01751": true,
      "01752": true,
      "01753": true,
      "01754": true,
      "01755": true,
      "01756": true,
      "01757": true,
      "01758": true,
      "01759": true,
      "01760": true,
      "01761": true,
      "01762": true,
      "01763": true,
      "01764": true,
      "01765": true,
      "01766": true,
      "01767": true,
      "01768": true,
      "01769": true,
      "01770": true,
      "01771": true,
      "01772": true,
      "01773": true,
      "01774": true,
      "01775": true,
      "01776": true,
      "01777": true,
      "01778": true,
      "01779": true,
      "01780": true,
      "01781": true,
      "01782": true,
      "01783": true,
      "01784": true,
      "01785": true,
      "01786": true,
      "01787": true,
      "01788": true,
      "01789": true,
      "01790": true,
      "01791": true,
      "01792": true,
      "01793": true,
      "01794": true,
      "01795": true,
      "01796": true,
      "01797": true,
      "01798": true,
      "01799": true,
      "01800": true,
      "01801": true,
      "01802": true,
      "01803": true,
      "01804": true,
      "01805": true,
      "01806": true,
      "01807": true,
      "01808": true,
      "01809": true,
      "01810": true,
      "01811": true,
      "01812": true,
      "01813": true,
      "01814": true,
      "01815": true,
      "01816": true,
      "01817": true,
      "01818": true,
      "01819": true,
      "01820": true,
      "01821": true,
      "01822": true,
      "01823": true,
      "01824": true,
      "01825": true,
      "01826": true,
      "01827": true,
      "01828": true,
      "01829": true,
      "01830": true,
      "01831": true,
      "01832": true,
      "01833": true,
      "01834": true,
      "01835": true,
      "01836": true,
      "01837": true,
      "01838": true,
      "01839": true,
      "01840": true,
      "01841": true,
      "01842": true,
      "01843": true,
      "01844": true,
      "01845": true,
      "01846": true,
      "01847": true,
      "01848": true,
      "01849": true,
      "01850": true,
      "01851": true,
      "01852": true,
      "01853": true,
      "01854": true,
      "01855": true,
      "01856": true,
      "01857": true,
      "01858": true,
      "01859": true,
      "01860": true,
      "01861": true,
      "01862": true,
      "01863": true,
      "01864": true,
      "01865": true,
      "01866": true,
      "01867": true,
      "01868": true,
      "01869": true,
      "01870": true,
      "01871": true,
      "01872": true,
      "01873": true,
      "01874": true,
      "01875": true,
      "01876": true,
      "01877": true,
      "01878": true,
      "01879": true,
      "01880": true,
      "01881": true,
      "01882": true,
      "01883": true,
      "01884": true,
      "01885": true,
      "01886": true,
      "01887": true,
      "01888": true,
      "01889": true,
      "01890": true,
      "01891": true,
      "01892": true,
      "01893": true,
      "01894": true,
      "01895": true,
      "01896": true,
      "01897": true,
      "01898": true,
      "01899": true,
      "01900": true,
      "01901": true,
      "01902": true,
      "01903": true,
      "01904": true,
      "01905": true,
      "01906": true,
      "01907": true,
      "01908": true,
      "01909": true,
      "01910": true,
      "01911": true,
      "01912": true,
      "01913": true,
      "01914": true,
      "01915": true,
      "01916": true,
      "01917": true,
      "01918": true,
      "01919": true,
      "01920": true,
      "01921": true,
      "01922": true,
      "01923": true,
      "01924": true,
      "01925": true,
      "01926": true,
      "01927": true,
      "01928": true,
      "01929": true,
      "01930": true,
      "01931": true,
      "01932": true,
      "01933": true,
      "01934": true,
      "01935": true,
      "01936": true,
      "01937": true,
      "01938": true,
      "01939": true,
      "01940": true,
      "01941": true,
      "01942": true,
      "01943": true,
      "01944": true,
      "01945": true,
      "01946": true,
      "01947": true,
      "01948": true,
      "01949": true,
      "01950": true,
      "01951": true,
      "01952": true,
      "01953": true,
      "01954": true,
      "01955": true,
      "01956": true,
      "01957": true,
      "01958": true,
      "01959": true,
      "01960": true,
      "01961": true,
      "01962": true,
      "01963": true,
      "01964": true,
      "01965": true,
      "01966": true,
      "01967": true,
      "01968": true,
      "01969": true,
      "01970": true,
      "01971": true,
      "01972": true,
      "01973": true,
      "01974": true,
      "01975": true,
      "01976": true,
      "01977": true,
      "01978": true,
      "01979": true,
      "01980": true,
      "01981": true,
      "01982": true,
      "01983": true,
      "01984": true,
      "01985": true,
      "01986": true,
      "01987": true,
      "01988": true,
      "01989": true,
      "01990": true,
      "01991": true,
      "01992": true,
      "01993": true,
      "01994": true,
      "01995": true,
      "01996": true,
      "01997": true,
      "01998": true,
      "01999": true
    },
    "AZCAPOTZALCO": {
      "02000": true,
      "02001": true,
      "02002": true,
      "02003": true,
      "02004": true,
      "02005": true,
      "02006": true,
      "02007": true,
      "02008": true,
      "02009": true,
      "02010": true,
      "02011": true,
      "02012": true,
      "02013": true,
      "02014": true,
      "02015": true,
      "02016": true,
      "02017": true,
      "02018": true,
      "02019": true,
      "02020": true,
      "02021": true,
      "02022": true,
      "02023": true,
      "02024": true,
      "02025": true,
      "02026": true,
      "02027": true,
      "02028": true,
      "02029": true,
      "02030": true,
      "02031": true,
      "02032": true,
      "02033": true,
      "02034": true,
      "02035": true,
      "02036": true,
      "02037": true,
      "02038": true,
      "02039": true,
      "02040": true,
      "02041": true,
      "02042": true,
      "02043": true,
      "02044": true,
      "02045": true,
      "02046": true,
      "02047": true,
      "02048": true,
      "02049": true,
      "02050": true,
      "02051": true,
      "02052": true,
      "02053": true,
      "02054": true,
      "02055": true,
      "02056": true,
      "02057": true,
      "02058": true,
      "02059": true,
      "02060": true,
      "02061": true,
      "02062": true,
      "02063": true,
      "02064": true,
      "02065": true,
      "02066": true,
      "02067": true,
      "02068": true,
      "02069": true,
      "02070": true,
      "02071": true,
      "02072": true,
      "02073": true,
      "02074": true,
      "02075": true,
      "02076": true,
      "02077": true,
      "02078": true,
      "02079": true,
      "02080": true,
      "02081": true,
      "02082": true,
      "02083": true,
      "02084": true,
      "02085": true,
      "02086": true,
      "02087": true,
      "02088": true,
      "02089": true,
      "02090": true,
      "02091": true,
      "02092": true,
      "02093": true,
      "02094": true,
      "02095": true,
      "02096": true,
      "02097": true,
      "02098": true,
      "02099": true,
      "02100": true,
      "02101": true,
      "02102": true,
      "02103": true,
      "02104": true,
      "02105": true,
      "02106": true,
      "02107": true,
      "02108": true,
      "02109": true,
      "02110": true,
      "02111": true,
      "02112": true,
      "02113": true,
      "02114": true,
      "02115": true,
      "02116": true,
      "02117": true,
      "02118": true,
      "02119": true,
      "02120": true,
      "02121": true,
      "02122": true,
      "02123": true,
      "02124": true,
      "02125": true,
      "02126": true,
      "02127": true,
      "02128": true,
      "02129": true,
      "02130": true,
      "02131": true,
      "02132": true,
      "02133": true,
      "02134": true,
      "02135": true,
      "02136": true,
      "02137": true,
      "02138": true,
      "02139": true,
      "02140": true,
      "02141": true,
      "02142": true,
      "02143": true,
      "02144": true,
      "02145": true,
      "02146": true,
      "02147": true,
      "02148": true,
      "02149": true,
      "02150": true,
      "02151": true,
      "02152": true,
      "02153": true,
      "02154": true,
      "02155": true,
      "02156": true,
      "02157": true,
      "02158": true,
      "02159": true,
      "02160": true,
      "02161": true,
      "02162": true,
      "02163": true,
      "02164": true,
      "02165": true,
      "02166": true,
      "02167": true,
      "02168": true,
      "02169": true,
      "02170": true,
      "02171": true,
      "02172": true,
      "02173": true,
      "02174": true,
      "02175": true,
      "02176": true,
      "02177": true,
      "02178": true,
      "02179": true,
      "02180": true,
      "02181": true,
      "02182": true,
      "02183": true,
      "02184": true,
      "02185": true,
      "02186": true,
      "02187": true,
      "02188": true,
      "02189": true,
      "02190": true,
      "02191": true,
      "02192": true,
      "02193": true,
      "02194": true,
      "02195": true,
      "02196": true,
      "02197": true,
      "02198": true,
      "02199": true,
      "02200": true,
      "02201": true,
      "02202": true,
      "02203": true,
      "02204": true,
      "02205": true,
      "02206": true,
      "02207": true,
      "02208": true,
      "02209": true,
      "02210": true,
      "02211": true,
      "02212": true,
      "02213": true,
      "02214": true,
      "02215": true,
      "02216": true,
      "02217": true,
      "02218": true,
      "02219": true,
      "02220": true,
      "02221": true,
      "02222": true,
      "02223": true,
      "02224": true,
      "02225": true,
      "02226": true,
      "02227": true,
      "02228": true,
      "02229": true,
      "02230": true,
      "02231": true,
      "02232": true,
      "02233": true,
      "02234": true,
      "02235": true,
      "02236": true,
      "02237": true,
      "02238": true,
      "02239": true,
      "02240": true,
      "02241": true,
      "02242": true,
      "02243": true,
      "02244": true,
      "02245": true,
      "02246": true,
      "02247": true,
      "02248": true,
      "02249": true,
      "02250": true,
      "02251": true,
      "02252": true,
      "02253": true,
      "02254": true,
      "02255": true,
      "02256": true,
      "02257": true,
      "02258": true,
      "02259": true,
      "02260": true,
      "02261": true,
      "02262": true,
      "02263": true,
      "02264": true,
      "02265": true,
      "02266": true,
      "02267": true,
      "02268": true,
      "02269": true,
      "02270": true,
      "02271": true,
      "02272": true,
      "02273": true,
      "02274": true,
      "02275": true,
      "02276": true,
      "02277": true,
      "02278": true,
      "02279": true,
      "02280": true,
      "02281": true,
      "02282": true,
      "02283": true,
      "02284": true,
      "02285": true,
      "02286": true,
      "02287": true,
      "02288": true,
      "02289": true,
      "02290": true,
      "02291": true,
      "02292": true,
      "02293": true,
      "02294": true,
      "02295": true,
      "02296": true,
      "02297": true,
      "02298": true,
      "02299": true,
      "02300": true,
      "02301": true,
      "02302": true,
      "02303": true,
      "02304": true,
      "02305": true,
      "02306": true,
      "02307": true,
      "02308": true,
      "02309": true,
      "02310": true,
      "02311": true,
      "02312": true,
      "02313": true,
      "02314": true,
      "02315": true,
      "02316": true,
      "02317": true,
      "02318": true,
      "02319": true,
      "02320": true,
      "02321": true,
      "02322": true,
      "02323": true,
      "02324": true,
      "02325": true,
      "02326": true,
      "02327": true,
      "02328": true,
      "02329": true,
      "02330": true,
      "02331": true,
      "02332": true,
      "02333": true,
      "02334": true,
      "02335": true,
      "02336": true,
      "02337": true,
      "02338": true,
      "02339": true,
      "02340": true,
      "02341": true,
      "02342": true,
      "02343": true,
      "02344": true,
      "02345": true,
      "02346": true,
      "02347": true,
      "02348": true,
      "02349": true,
      "02350": true,
      "02351": true,
      "02352": true,
      "02353": true,
      "02354": true,
      "02355": true,
      "02356": true,
      "02357": true,
      "02358": true,
      "02359": true,
      "02360": true,
      "02361": true,
      "02362": true,
      "02363": true,
      "02364": true,
      "02365": true,
      "02366": true,
      "02367": true,
      "02368": true,
      "02369": true,
      "02370": true,
      "02371": true,
      "02372": true,
      "02373": true,
      "02374": true,
      "02375": true,
      "02376": true,
      "02377": true,
      "02378": true,
      "02379": true,
      "02380": true,
      "02381": true,
      "02382": true,
      "02383": true,
      "02384": true,
      "02385": true,
      "02386": true,
      "02387": true,
      "02388": true,
      "02389": true,
      "02390": true,
      "02391": true,
      "02392": true,
      "02393": true,
      "02394": true,
      "02395": true,
      "02396": true,
      "02397": true,
      "02398": true,
      "02399": true,
      "02400": true,
      "02401": true,
      "02402": true,
      "02403": true,
      "02404": true,
      "02405": true,
      "02406": true,
      "02407": true,
      "02408": true,
      "02409": true,
      "02410": true,
      "02411": true,
      "02412": true,
      "02413": true,
      "02414": true,
      "02415": true,
      "02416": true,
      "02417": true,
      "02418": true,
      "02419": true,
      "02420": true,
      "02421": true,
      "02422": true,
      "02423": true,
      "02424": true,
      "02425": true,
      "02426": true,
      "02427": true,
      "02428": true,
      "02429": true,
      "02430": true,
      "02431": true,
      "02432": true,
      "02433": true,
      "02434": true,
      "02435": true,
      "02436": true,
      "02437": true,
      "02438": true,
      "02439": true,
      "02440": true,
      "02441": true,
      "02442": true,
      "02443": true,
      "02444": true,
      "02445": true,
      "02446": true,
      "02447": true,
      "02448": true,
      "02449": true,
      "02450": true,
      "02451": true,
      "02452": true,
      "02453": true,
      "02454": true,
      "02455": true,
      "02456": true,
      "02457": true,
      "02458": true,
      "02459": true,
      "02460": true,
      "02461": true,
      "02462": true,
      "02463": true,
      "02464": true,
      "02465": true,
      "02466": true,
      "02467": true,
      "02468": true,
      "02469": true,
      "02470": true,
      "02471": true,
      "02472": true,
      "02473": true,
      "02474": true,
      "02475": true,
      "02476": true,
      "02477": true,
      "02478": true,
      "02479": true,
      "02480": true,
      "02481": true,
      "02482": true,
      "02483": true,
      "02484": true,
      "02485": true,
      "02486": true,
      "02487": true,
      "02488": true,
      "02489": true,
      "02490": true,
      "02491": true,
      "02492": true,
      "02493": true,
      "02494": true,
      "02495": true,
      "02496": true,
      "02497": true,
      "02498": true,
      "02499": true,
      "02500": true,
      "02501": true,
      "02502": true,
      "02503": true,
      "02504": true,
      "02505": true,
      "02506": true,
      "02507": true,
      "02508": true,
      "02509": true,
      "02510": true,
      "02511": true,
      "02512": true,
      "02513": true,
      "02514": true,
      "02515": true,
      "02516": true,
      "02517": true,
      "02518": true,
      "02519": true,
      "02520": true,
      "02521": true,
      "02522": true,
      "02523": true,
      "02524": true,
      "02525": true,
      "02526": true,
      "02527": true,
      "02528": true,
      "02529": true,
      "02530": true,
      "02531": true,
      "02532": true,
      "02533": true,
      "02534": true,
      "02535": true,
      "02536": true,
      "02537": true,
      "02538": true,
      "02539": true,
      "02540": true,
      "02541": true,
      "02542": true,
      "02543": true,
      "02544": true,
      "02545": true,
      "02546": true,
      "02547": true,
      "02548": true,
      "02549": true,
      "02550": true,
      "02551": true,
      "02552": true,
      "02553": true,
      "02554": true,
      "02555": true,
      "02556": true,
      "02557": true,
      "02558": true,
      "02559": true,
      "02560": true,
      "02561": true,
      "02562": true,
      "02563": true,
      "02564": true,
      "02565": true,
      "02566": true,
      "02567": true,
      "02568": true,
      "02569": true,
      "02570": true,
      "02571": true,
      "02572": true,
      "02573": true,
      "02574": true,
      "02575": true,
      "02576": true,
      "02577": true,
      "02578": true,
      "02579": true,
      "02580": true,
      "02581": true,
      "02582": true,
      "02583": true,
      "02584": true,
      "02585": true,
      "02586": true,
      "02587": true,
      "02588": true,
      "02589": true,
      "02590": true,
      "02591": true,
      "02592": true,
      "02593": true,
      "02594": true,
      "02595": true,
      "02596": true,
      "02597": true,
      "02598": true,
      "02599": true,
      "02600": true,
      "02601": true,
      "02602": true,
      "02603": true,
      "02604": true,
      "02605": true,
      "02606": true,
      "02607": true,
      "02608": true,
      "02609": true,
      "02610": true,
      "02611": true,
      "02612": true,
      "02613": true,
      "02614": true,
      "02615": true,
      "02616": true,
      "02617": true,
      "02618": true,
      "02619": true,
      "02620": true,
      "02621": true,
      "02622": true,
      "02623": true,
      "02624": true,
      "02625": true,
      "02626": true,
      "02627": true,
      "02628": true,
      "02629": true,
      "02630": true,
      "02631": true,
      "02632": true,
      "02633": true,
      "02634": true,
      "02635": true,
      "02636": true,
      "02637": true,
      "02638": true,
      "02639": true,
      "02640": true,
      "02641": true,
      "02642": true,
      "02643": true,
      "02644": true,
      "02645": true,
      "02646": true,
      "02647": true,
      "02648": true,
      "02649": true,
      "02650": true,
      "02651": true,
      "02652": true,
      "02653": true,
      "02654": true,
      "02655": true,
      "02656": true,
      "02657": true,
      "02658": true,
      "02659": true,
      "02660": true,
      "02661": true,
      "02662": true,
      "02663": true,
      "02664": true,
      "02665": true,
      "02666": true,
      "02667": true,
      "02668": true,
      "02669": true,
      "02670": true,
      "02671": true,
      "02672": true,
      "02673": true,
      "02674": true,
      "02675": true,
      "02676": true,
      "02677": true,
      "02678": true,
      "02679": true,
      "02680": true,
      "02681": true,
      "02682": true,
      "02683": true,
      "02684": true,
      "02685": true,
      "02686": true,
      "02687": true,
      "02688": true,
      "02689": true,
      "02690": true,
      "02691": true,
      "02692": true,
      "02693": true,
      "02694": true,
      "02695": true,
      "02696": true,
      "02697": true,
      "02698": true,
      "02699": true,
      "02700": true,
      "02701": true,
      "02702": true,
      "02703": true,
      "02704": true,
      "02705": true,
      "02706": true,
      "02707": true,
      "02708": true,
      "02709": true,
      "02710": true,
      "02711": true,
      "02712": true,
      "02713": true,
      "02714": true,
      "02715": true,
      "02716": true,
      "02717": true,
      "02718": true,
      "02719": true,
      "02720": true,
      "02721": true,
      "02722": true,
      "02723": true,
      "02724": true,
      "02725": true,
      "02726": true,
      "02727": true,
      "02728": true,
      "02729": true,
      "02730": true,
      "02731": true,
      "02732": true,
      "02733": true,
      "02734": true,
      "02735": true,
      "02736": true,
      "02737": true,
      "02738": true,
      "02739": true,
      "02740": true,
      "02741": true,
      "02742": true,
      "02743": true,
      "02744": true,
      "02745": true,
      "02746": true,
      "02747": true,
      "02748": true,
      "02749": true,
      "02750": true,
      "02751": true,
      "02752": true,
      "02753": true,
      "02754": true,
      "02755": true,
      "02756": true,
      "02757": true,
      "02758": true,
      "02759": true,
      "02760": true,
      "02761": true,
      "02762": true,
      "02763": true,
      "02764": true,
      "02765": true,
      "02766": true,
      "02767": true,
      "02768": true,
      "02769": true,
      "02770": true,
      "02771": true,
      "02772": true,
      "02773": true,
      "02774": true,
      "02775": true,
      "02776": true,
      "02777": true,
      "02778": true,
      "02779": true,
      "02780": true,
      "02781": true,
      "02782": true,
      "02783": true,
      "02784": true,
      "02785": true,
      "02786": true,
      "02787": true,
      "02788": true,
      "02789": true,
      "02790": true,
      "02791": true,
      "02792": true,
      "02793": true,
      "02794": true,
      "02795": true,
      "02796": true,
      "02797": true,
      "02798": true,
      "02799": true,
      "02800": true,
      "02801": true,
      "02802": true,
      "02803": true,
      "02804": true,
      "02805": true,
      "02806": true,
      "02807": true,
      "02808": true,
      "02809": true,
      "02810": true,
      "02811": true,
      "02812": true,
      "02813": true,
      "02814": true,
      "02815": true,
      "02816": true,
      "02817": true,
      "02818": true,
      "02819": true,
      "02820": true,
      "02821": true,
      "02822": true,
      "02823": true,
      "02824": true,
      "02825": true,
      "02826": true,
      "02827": true,
      "02828": true,
      "02829": true,
      "02830": true,
      "02831": true,
      "02832": true,
      "02833": true,
      "02834": true,
      "02835": true,
      "02836": true,
      "02837": true,
      "02838": true,
      "02839": true,
      "02840": true,
      "02841": true,
      "02842": true,
      "02843": true,
      "02844": true,
      "02845": true,
      "02846": true,
      "02847": true,
      "02848": true,
      "02849": true,
      "02850": true,
      "02851": true,
      "02852": true,
      "02853": true,
      "02854": true,
      "02855": true,
      "02856": true,
      "02857": true,
      "02858": true,
      "02859": true,
      "02860": true,
      "02861": true,
      "02862": true,
      "02863": true,
      "02864": true,
      "02865": true,
      "02866": true,
      "02867": true,
      "02868": true,
      "02869": true,
      "02870": true,
      "02871": true,
      "02872": true,
      "02873": true,
      "02874": true,
      "02875": true,
      "02876": true,
      "02877": true,
      "02878": true,
      "02879": true,
      "02880": true,
      "02881": true,
      "02882": true,
      "02883": true,
      "02884": true,
      "02885": true,
      "02886": true,
      "02887": true,
      "02888": true,
      "02889": true,
      "02890": true,
      "02891": true,
      "02892": true,
      "02893": true,
      "02894": true,
      "02895": true,
      "02896": true,
      "02897": true,
      "02898": true,
      "02899": true,
      "02900": true,
      "02901": true,
      "02902": true,
      "02903": true,
      "02904": true,
      "02905": true,
      "02906": true,
      "02907": true,
      "02908": true,
      "02909": true,
      "02910": true,
      "02911": true,
      "02912": true,
      "02913": true,
      "02914": true,
      "02915": true,
      "02916": true,
      "02917": true,
      "02918": true,
      "02919": true,
      "02920": true,
      "02921": true,
      "02922": true,
      "02923": true,
      "02924": true,
      "02925": true,
      "02926": true,
      "02927": true,
      "02928": true,
      "02929": true,
      "02930": true,
      "02931": true,
      "02932": true,
      "02933": true,
      "02934": true,
      "02935": true,
      "02936": true,
      "02937": true,
      "02938": true,
      "02939": true,
      "02940": true,
      "02941": true,
      "02942": true,
      "02943": true,
      "02944": true,
      "02945": true,
      "02946": true,
      "02947": true,
      "02948": true,
      "02949": true,
      "02950": true,
      "02951": true,
      "02952": true,
      "02953": true,
      "02954": true,
      "02955": true,
      "02956": true,
      "02957": true,
      "02958": true,
      "02959": true,
      "02960": true,
      "02961": true,
      "02962": true,
      "02963": true,
      "02964": true,
      "02965": true,
      "02966": true,
      "02967": true,
      "02968": true,
      "02969": true,
      "02970": true,
      "02971": true,
      "02972": true,
      "02973": true,
      "02974": true,
      "02975": true,
      "02976": true,
      "02977": true,
      "02978": true,
      "02979": true,
      "02980": true,
      "02981": true,
      "02982": true,
      "02983": true,
      "02984": true,
      "02985": true,
      "02986": true,
      "02987": true,
      "02988": true,
      "02989": true,
      "02990": true,
      "02991": true,
      "02992": true,
      "02993": true,
      "02994": true,
      "02995": true,
      "02996": true,
      "02997": true,
      "02998": true,
      "02999": true
    },
    "BENITO JUÁREZ": {
      "03000": true,
      "03001": true,
      "03002": true,
      "03003": true,
      "03004": true,
      "03005": true,
      "03006": true,
      "03007": true,
      "03008": true,
      "03009": true,
      "03010": true,
      "03011": true,
      "03012": true,
      "03013": true,
      "03014": true,
      "03015": true,
      "03016": true,
      "03017": true,
      "03018": true,
      "03019": true,
      "03020": true,
      "03021": true,
      "03022": true,
      "03023": true,
      "03024": true,
      "03025": true,
      "03026": true,
      "03027": true,
      "03028": true,
      "03029": true,
      "03030": true,
      "03031": true,
      "03032": true,
      "03033": true,
      "03034": true,
      "03035": true,
      "03036": true,
      "03037": true,
      "03038": true,
      "03039": true,
      "03040": true,
      "03041": true,
      "03042": true,
      "03043": true,
      "03044": true,
      "03045": true,
      "03046": true,
      "03047": true,
      "03048": true,
      "03049": true,
      "03050": true,
      "03051": true,
      "03052": true,
      "03053": true,
      "03054": true,
      "03055": true,
      "03056": true,
      "03057": true,
      "03058": true,
      "03059": true,
      "03060": true,
      "03061": true,
      "03062": true,
      "03063": true,
      "03064": true,
      "03065": true,
      "03066": true,
      "03067": true,
      "03068": true,
      "03069": true,
      "03070": true,
      "03071": true,
      "03072": true,
      "03073": true,
      "03074": true,
      "03075": true,
      "03076": true,
      "03077": true,
      "03078": true,
      "03079": true,
      "03080": true,
      "03081": true,
      "03082": true,
      "03083": true,
      "03084": true,
      "03085": true,
      "03086": true,
      "03087": true,
      "03088": true,
      "03089": true,
      "03090": true,
      "03091": true,
      "03092": true,
      "03093": true,
      "03094": true,
      "03095": true,
      "03096": true,
      "03097": true,
      "03098": true,
      "03099": true,
      "03100": true,
      "03101": true,
      "03102": true,
      "03103": true,
      "03104": true,
      "03105": true,
      "03106": true,
      "03107": true,
      "03108": true,
      "03109": true,
      "03110": true,
      "03111": true,
      "03112": true,
      "03113": true,
      "03114": true,
      "03115": true,
      "03116": true,
      "03117": true,
      "03118": true,
      "03119": true,
      "03120": true,
      "03121": true,
      "03122": true,
      "03123": true,
      "03124": true,
      "03125": true,
      "03126": true,
      "03127": true,
      "03128": true,
      "03129": true,
      "03130": true,
      "03131": true,
      "03132": true,
      "03133": true,
      "03134": true,
      "03135": true,
      "03136": true,
      "03137": true,
      "03138": true,
      "03139": true,
      "03140": true,
      "03141": true,
      "03142": true,
      "03143": true,
      "03144": true,
      "03145": true,
      "03146": true,
      "03147": true,
      "03148": true,
      "03149": true,
      "03150": true,
      "03151": true,
      "03152": true,
      "03153": true,
      "03154": true,
      "03155": true,
      "03156": true,
      "03157": true,
      "03158": true,
      "03159": true,
      "03160": true,
      "03161": true,
      "03162": true,
      "03163": true,
      "03164": true,
      "03165": true,
      "03166": true,
      "03167": true,
      "03168": true,
      "03169": true,
      "03170": true,
      "03171": true,
      "03172": true,
      "03173": true,
      "03174": true,
      "03175": true,
      "03176": true,
      "03177": true,
      "03178": true,
      "03179": true,
      "03180": true,
      "03181": true,
      "03182": true,
      "03183": true,
      "03184": true,
      "03185": true,
      "03186": true,
      "03187": true,
      "03188": true,
      "03189": true,
      "03190": true,
      "03191": true,
      "03192": true,
      "03193": true,
      "03194": true,
      "03195": true,
      "03196": true,
      "03197": true,
      "03198": true,
      "03199": true,
      "03200": true,
      "03201": true,
      "03202": true,
      "03203": true,
      "03204": true,
      "03205": true,
      "03206": true,
      "03207": true,
      "03208": true,
      "03209": true,
      "03210": true,
      "03211": true,
      "03212": true,
      "03213": true,
      "03214": true,
      "03215": true,
      "03216": true,
      "03217": true,
      "03218": true,
      "03219": true,
      "03220": true,
      "03221": true,
      "03222": true,
      "03223": true,
      "03224": true,
      "03225": true,
      "03226": true,
      "03227": true,
      "03228": true,
      "03229": true,
      "03230": true,
      "03231": true,
      "03232": true,
      "03233": true,
      "03234": true,
      "03235": true,
      "03236": true,
      "03237": true,
      "03238": true,
      "03239": true,
      "03240": true,
      "03241": true,
      "03242": true,
      "03243": true,
      "03244": true,
      "03245": true,
      "03246": true,
      "03247": true,
      "03248": true,
      "03249": true,
      "03250": true,
      "03251": true,
      "03252": true,
      "03253": true,
      "03254": true,
      "03255": true,
      "03256": true,
      "03257": true,
      "03258": true,
      "03259": true,
      "03260": true,
      "03261": true,
      "03262": true,
      "03263": true,
      "03264": true,
      "03265": true,
      "03266": true,
      "03267": true,
      "03268": true,
      "03269": true,
      "03270": true,
      "03271": true,
      "03272": true,
      "03273": true,
      "03274": true,
      "03275": true,
      "03276": true,
      "03277": true,
      "03278": true,
      "03279": true,
      "03280": true,
      "03281": true,
      "03282": true,
      "03283": true,
      "03284": true,
      "03285": true,
      "03286": true,
      "03287": true,
      "03288": true,
      "03289": true,
      "03290": true,
      "03291": true,
      "03292": true,
      "03293": true,
      "03294": true,
      "03295": true,
      "03296": true,
      "03297": true,
      "03298": true,
      "03299": true,
      "03300": true,
      "03301": true,
      "03302": true,
      "03303": true,
      "03304": true,
      "03305": true,
      "03306": true,
      "03307": true,
      "03308": true,
      "03309": true,
      "03310": true,
      "03311": true,
      "03312": true,
      "03313": true,
      "03314": true,
      "03315": true,
      "03316": true,
      "03317": true,
      "03318": true,
      "03319": true,
      "03320": true,
      "03321": true,
      "03322": true,
      "03323": true,
      "03324": true,
      "03325": true,
      "03326": true,
      "03327": true,
      "03328": true,
      "03329": true,
      "03330": true,
      "03331": true,
      "03332": true,
      "03333": true,
      "03334": true,
      "03335": true,
      "03336": true,
      "03337": true,
      "03338": true,
      "03339": true,
      "03340": true,
      "03341": true,
      "03342": true,
      "03343": true,
      "03344": true,
      "03345": true,
      "03346": true,
      "03347": true,
      "03348": true,
      "03349": true,
      "03350": true,
      "03351": true,
      "03352": true,
      "03353": true,
      "03354": true,
      "03355": true,
      "03356": true,
      "03357": true,
      "03358": true,
      "03359": true,
      "03360": true,
      "03361": true,
      "03362": true,
      "03363": true,
      "03364": true,
      "03365": true,
      "03366": true,
      "03367": true,
      "03368": true,
      "03369": true,
      "03370": true,
      "03371": true,
      "03372": true,
      "03373": true,
      "03374": true,
      "03375": true,
      "03376": true,
      "03377": true,
      "03378": true,
      "03379": true,
      "03380": true,
      "03381": true,
      "03382": true,
      "03383": true,
      "03384": true,
      "03385": true,
      "03386": true,
      "03387": true,
      "03388": true,
      "03389": true,
      "03390": true,
      "03391": true,
      "03392": true,
      "03393": true,
      "03394": true,
      "03395": true,
      "03396": true,
      "03397": true,
      "03398": true,
      "03399": true,
      "03400": true,
      "03401": true,
      "03402": true,
      "03403": true,
      "03404": true,
      "03405": true,
      "03406": true,
      "03407": true,
      "03408": true,
      "03409": true,
      "03410": true,
      "03411": true,
      "03412": true,
      "03413": true,
      "03414": true,
      "03415": true,
      "03416": true,
      "03417": true,
      "03418": true,
      "03419": true,
      "03420": true,
      "03421": true,
      "03422": true,
      "03423": true,
      "03424": true,
      "03425": true,
      "03426": true,
      "03427": true,
      "03428": true,
      "03429": true,
      "03430": true,
      "03431": true,
      "03432": true,
      "03433": true,
      "03434": true,
      "03435": true,
      "03436": true,
      "03437": true,
      "03438": true,
      "03439": true,
      "03440": true,
      "03441": true,
      "03442": true,
      "03443": true,
      "03444": true,
      "03445": true,
      "03446": true,
      "03447": true,
      "03448": true,
      "03449": true,
      "03450": true,
      "03451": true,
      "03452": true,
      "03453": true,
      "03454": true,
      "03455": true,
      "03456": true,
      "03457": true,
      "03458": true,
      "03459": true,
      "03460": true,
      "03461": true,
      "03462": true,
      "03463": true,
      "03464": true,
      "03465": true,
      "03466": true,
      "03467": true,
      "03468": true,
      "03469": true,
      "03470": true,
      "03471": true,
      "03472": true,
      "03473": true,
      "03474": true,
      "03475": true,
      "03476": true,
      "03477": true,
      "03478": true,
      "03479": true,
      "03480": true,
      "03481": true,
      "03482": true,
      "03483": true,
      "03484": true,
      "03485": true,
      "03486": true,
      "03487": true,
      "03488": true,
      "03489": true,
      "03490": true,
      "03491": true,
      "03492": true,
      "03493": true,
      "03494": true,
      "03495": true,
      "03496": true,
      "03497": true,
      "03498": true,
      "03499": true,
      "03500": true,
      "03501": true,
      "03502": true,
      "03503": true,
      "03504": true,
      "03505": true,
      "03506": true,
      "03507": true,
      "03508": true,
      "03509": true,
      "03510": true,
      "03511": true,
      "03512": true,
      "03513": true,
      "03514": true,
      "03515": true,
      "03516": true,
      "03517": true,
      "03518": true,
      "03519": true,
      "03520": true,
      "03521": true,
      "03522": true,
      "03523": true,
      "03524": true,
      "03525": true,
      "03526": true,
      "03527": true,
      "03528": true,
      "03529": true,
      "03530": true,
      "03531": true,
      "03532": true,
      "03533": true,
      "03534": true,
      "03535": true,
      "03536": true,
      "03537": true,
      "03538": true,
      "03539": true,
      "03540": true,
      "03541": true,
      "03542": true,
      "03543": true,
      "03544": true,
      "03545": true,
      "03546": true,
      "03547": true,
      "03548": true,
      "03549": true,
      "03550": true,
      "03551": true,
      "03552": true,
      "03553": true,
      "03554": true,
      "03555": true,
      "03556": true,
      "03557": true,
      "03558": true,
      "03559": true,
      "03560": true,
      "03561": true,
      "03562": true,
      "03563": true,
      "03564": true,
      "03565": true,
      "03566": true,
      "03567": true,
      "03568": true,
      "03569": true,
      "03570": true,
      "03571": true,
      "03572": true,
      "03573": true,
      "03574": true,
      "03575": true,
      "03576": true,
      "03577": true,
      "03578": true,
      "03579": true,
      "03580": true,
      "03581": true,
      "03582": true,
      "03583": true,
      "03584": true,
      "03585": true,
      "03586": true,
      "03587": true,
      "03588": true,
      "03589": true,
      "03590": true,
      "03591": true,
      "03592": true,
      "03593": true,
      "03594": true,
      "03595": true,
      "03596": true,
      "03597": true,
      "03598": true,
      "03599": true,
      "03600": true,
      "03601": true,
      "03602": true,
      "03603": true,
      "03604": true,
      "03605": true,
      "03606": true,
      "03607": true,
      "03608": true,
      "03609": true,
      "03610": true,
      "03611": true,
      "03612": true,
      "03613": true,
      "03614": true,
      "03615": true,
      "03616": true,
      "03617": true,
      "03618": true,
      "03619": true,
      "03620": true,
      "03621": true,
      "03622": true,
      "03623": true,
      "03624": true,
      "03625": true,
      "03626": true,
      "03627": true,
      "03628": true,
      "03629": true,
      "03630": true,
      "03631": true,
      "03632": true,
      "03633": true,
      "03634": true,
      "03635": true,
      "03636": true,
      "03637": true,
      "03638": true,
      "03639": true,
      "03640": true,
      "03641": true,
      "03642": true,
      "03643": true,
      "03644": true,
      "03645": true,
      "03646": true,
      "03647": true,
      "03648": true,
      "03649": true,
      "03650": true,
      "03651": true,
      "03652": true,
      "03653": true,
      "03654": true,
      "03655": true,
      "03656": true,
      "03657": true,
      "03658": true,
      "03659": true,
      "03660": true,
      "03661": true,
      "03662": true,
      "03663": true,
      "03664": true,
      "03665": true,
      "03666": true,
      "03667": true,
      "03668": true,
      "03669": true,
      "03670": true,
      "03671": true,
      "03672": true,
      "03673": true,
      "03674": true,
      "03675": true,
      "03676": true,
      "03677": true,
      "03678": true,
      "03679": true,
      "03680": true,
      "03681": true,
      "03682": true,
      "03683": true,
      "03684": true,
      "03685": true,
      "03686": true,
      "03687": true,
      "03688": true,
      "03689": true,
      "03690": true,
      "03691": true,
      "03692": true,
      "03693": true,
      "03694": true,
      "03695": true,
      "03696": true,
      "03697": true,
      "03698": true,
      "03699": true,
      "03700": true,
      "03701": true,
      "03702": true,
      "03703": true,
      "03704": true,
      "03705": true,
      "03706": true,
      "03707": true,
      "03708": true,
      "03709": true,
      "03710": true,
      "03711": true,
      "03712": true,
      "03713": true,
      "03714": true,
      "03715": true,
      "03716": true,
      "03717": true,
      "03718": true,
      "03719": true,
      "03720": true,
      "03721": true,
      "03722": true,
      "03723": true,
      "03724": true,
      "03725": true,
      "03726": true,
      "03727": true,
      "03728": true,
      "03729": true,
      "03730": true,
      "03731": true,
      "03732": true,
      "03733": true,
      "03734": true,
      "03735": true,
      "03736": true,
      "03737": true,
      "03738": true,
      "03739": true,
      "03740": true,
      "03741": true,
      "03742": true,
      "03743": true,
      "03744": true,
      "03745": true,
      "03746": true,
      "03747": true,
      "03748": true,
      "03749": true,
      "03750": true,
      "03751": true,
      "03752": true,
      "03753": true,
      "03754": true,
      "03755": true,
      "03756": true,
      "03757": true,
      "03758": true,
      "03759": true,
      "03760": true,
      "03761": true,
      "03762": true,
      "03763": true,
      "03764": true,
      "03765": true,
      "03766": true,
      "03767": true,
      "03768": true,
      "03769": true,
      "03770": true,
      "03771": true,
      "03772": true,
      "03773": true,
      "03774": true,
      "03775": true,
      "03776": true,
      "03777": true,
      "03778": true,
      "03779": true,
      "03780": true,
      "03781": true,
      "03782": true,
      "03783": true,
      "03784": true,
      "03785": true,
      "03786": true,
      "03787": true,
      "03788": true,
      "03789": true,
      "03790": true,
      "03791": true,
      "03792": true,
      "03793": true,
      "03794": true,
      "03795": true,
      "03796": true,
      "03797": true,
      "03798": true,
      "03799": true,
      "03800": true,
      "03801": true,
      "03802": true,
      "03803": true,
      "03804": true,
      "03805": true,
      "03806": true,
      "03807": true,
      "03808": true,
      "03809": true,
      "03810": true,
      "03811": true,
      "03812": true,
      "03813": true,
      "03814": true,
      "03815": true,
      "03816": true,
      "03817": true,
      "03818": true,
      "03819": true,
      "03820": true,
      "03821": true,
      "03822": true,
      "03823": true,
      "03824": true,
      "03825": true,
      "03826": true,
      "03827": true,
      "03828": true,
      "03829": true,
      "03830": true,
      "03831": true,
      "03832": true,
      "03833": true,
      "03834": true,
      "03835": true,
      "03836": true,
      "03837": true,
      "03838": true,
      "03839": true,
      "03840": true,
      "03841": true,
      "03842": true,
      "03843": true,
      "03844": true,
      "03845": true,
      "03846": true,
      "03847": true,
      "03848": true,
      "03849": true,
      "03850": true,
      "03851": true,
      "03852": true,
      "03853": true,
      "03854": true,
      "03855": true,
      "03856": true,
      "03857": true,
      "03858": true,
      "03859": true,
      "03860": true,
      "03861": true,
      "03862": true,
      "03863": true,
      "03864": true,
      "03865": true,
      "03866": true,
      "03867": true,
      "03868": true,
      "03869": true,
      "03870": true,
      "03871": true,
      "03872": true,
      "03873": true,
      "03874": true,
      "03875": true,
      "03876": true,
      "03877": true,
      "03878": true,
      "03879": true,
      "03880": true,
      "03881": true,
      "03882": true,
      "03883": true,
      "03884": true,
      "03885": true,
      "03886": true,
      "03887": true,
      "03888": true,
      "03889": true,
      "03890": true,
      "03891": true,
      "03892": true,
      "03893": true,
      "03894": true,
      "03895": true,
      "03896": true,
      "03897": true,
      "03898": true,
      "03899": true,
      "03900": true,
      "03901": true,
      "03902": true,
      "03903": true,
      "03904": true,
      "03905": true,
      "03906": true,
      "03907": true,
      "03908": true,
      "03909": true,
      "03910": true,
      "03911": true,
      "03912": true,
      "03913": true,
      "03914": true,
      "03915": true,
      "03916": true,
      "03917": true,
      "03918": true,
      "03919": true,
      "03920": true,
      "03921": true,
      "03922": true,
      "03923": true,
      "03924": true,
      "03925": true,
      "03926": true,
      "03927": true,
      "03928": true,
      "03929": true,
      "03930": true,
      "03931": true,
      "03932": true,
      "03933": true,
      "03934": true,
      "03935": true,
      "03936": true,
      "03937": true,
      "03938": true,
      "03939": true,
      "03940": true,
      "03941": true,
      "03942": true,
      "03943": true,
      "03944": true,
      "03945": true,
      "03946": true,
      "03947": true,
      "03948": true,
      "03949": true,
      "03950": true,
      "03951": true,
      "03952": true,
      "03953": true,
      "03954": true,
      "03955": true,
      "03956": true,
      "03957": true,
      "03958": true,
      "03959": true,
      "03960": true,
      "03961": true,
      "03962": true,
      "03963": true,
      "03964": true,
      "03965": true,
      "03966": true,
      "03967": true,
      "03968": true,
      "03969": true,
      "03970": true,
      "03971": true,
      "03972": true,
      "03973": true,
      "03974": true,
      "03975": true,
      "03976": true,
      "03977": true,
      "03978": true,
      "03979": true,
      "03980": true,
      "03981": true,
      "03982": true,
      "03983": true,
      "03984": true,
      "03985": true,
      "03986": true,
      "03987": true,
      "03988": true,
      "03989": true,
      "03990": true,
      "03991": true,
      "03992": true,
      "03993": true,
      "03994": true,
      "03995": true,
      "03996": true,
      "03997": true,
      "03998": true,
      "03999": true
    },
    "COYOACÁN": {
      "04000": true,
      "04001": true,
      "04002": true,
      "04003": true,
      "04004": true,
      "04005": true,
      "04006": true,
      "04007": true,
      "04008": true,
      "04009": true,
      "04010": true,
      "04011": true,
      "04012": true,
      "04013": true,
      "04014": true,
      "04015": true,
      "04016": true,
      "04017": true,
      "04018": true,
      "04019": true,
      "04020": true,
      "04021": true,
      "04022": true,
      "04023": true,
      "04024": true,
      "04025": true,
      "04026": true,
      "04027": true,
      "04028": true,
      "04029": true,
      "04030": true,
      "04031": true,
      "04032": true,
      "04033": true,
      "04034": true,
      "04035": true,
      "04036": true,
      "04037": true,
      "04038": true,
      "04039": true,
      "04040": true,
      "04041": true,
      "04042": true,
      "04043": true,
      "04044": true,
      "04045": true,
      "04046": true,
      "04047": true,
      "04048": true,
      "04049": true,
      "04050": true,
      "04051": true,
      "04052": true,
      "04053": true,
      "04054": true,
      "04055": true,
      "04056": true,
      "04057": true,
      "04058": true,
      "04059": true,
      "04060": true,
      "04061": true,
      "04062": true,
      "04063": true,
      "04064": true,
      "04065": true,
      "04066": true,
      "04067": true,
      "04068": true,
      "04069": true,
      "04070": true,
      "04071": true,
      "04072": true,
      "04073": true,
      "04074": true,
      "04075": true,
      "04076": true,
      "04077": true,
      "04078": true,
      "04079": true,
      "04080": true,
      "04081": true,
      "04082": true,
      "04083": true,
      "04084": true,
      "04085": true,
      "04086": true,
      "04087": true,
      "04088": true,
      "04089": true,
      "04090": true,
      "04091": true,
      "04092": true,
      "04093": true,
      "04094": true,
      "04095": true,
      "04096": true,
      "04097": true,
      "04098": true,
      "04099": true,
      "04100": true,
      "04101": true,
      "04102": true,
      "04103": true,
      "04104": true,
      "04105": true,
      "04106": true,
      "04107": true,
      "04108": true,
      "04109": true,
      "04110": true,
      "04111": true,
      "04112": true,
      "04113": true,
      "04114": true,
      "04115": true,
      "04116": true,
      "04117": true,
      "04118": true,
      "04119": true,
      "04120": true,
      "04121": true,
      "04122": true,
      "04123": true,
      "04124": true,
      "04125": true,
      "04126": true,
      "04127": true,
      "04128": true,
      "04129": true,
      "04130": true,
      "04131": true,
      "04132": true,
      "04133": true,
      "04134": true,
      "04135": true,
      "04136": true,
      "04137": true,
      "04138": true,
      "04139": true,
      "04140": true,
      "04141": true,
      "04142": true,
      "04143": true,
      "04144": true,
      "04145": true,
      "04146": true,
      "04147": true,
      "04148": true,
      "04149": true,
      "04150": true,
      "04151": true,
      "04152": true,
      "04153": true,
      "04154": true,
      "04155": true,
      "04156": true,
      "04157": true,
      "04158": true,
      "04159": true,
      "04160": true,
      "04161": true,
      "04162": true,
      "04163": true,
      "04164": true,
      "04165": true,
      "04166": true,
      "04167": true,
      "04168": true,
      "04169": true,
      "04170": true,
      "04171": true,
      "04172": true,
      "04173": true,
      "04174": true,
      "04175": true,
      "04176": true,
      "04177": true,
      "04178": true,
      "04179": true,
      "04180": true,
      "04181": true,
      "04182": true,
      "04183": true,
      "04184": true,
      "04185": true,
      "04186": true,
      "04187": true,
      "04188": true,
      "04189": true,
      "04190": true,
      "04191": true,
      "04192": true,
      "04193": true,
      "04194": true,
      "04195": true,
      "04196": true,
      "04197": true,
      "04198": true,
      "04199": true,
      "04200": true,
      "04201": true,
      "04202": true,
      "04203": true,
      "04204": true,
      "04205": true,
      "04206": true,
      "04207": true,
      "04208": true,
      "04209": true,
      "04210": true,
      "04211": true,
      "04212": true,
      "04213": true,
      "04214": true,
      "04215": true,
      "04216": true,
      "04217": true,
      "04218": true,
      "04219": true,
      "04220": true,
      "04221": true,
      "04222": true,
      "04223": true,
      "04224": true,
      "04225": true,
      "04226": true,
      "04227": true,
      "04228": true,
      "04229": true,
      "04230": true,
      "04231": true,
      "04232": true,
      "04233": true,
      "04234": true,
      "04235": true,
      "04236": true,
      "04237": true,
      "04238": true,
      "04239": true,
      "04240": true,
      "04241": true,
      "04242": true,
      "04243": true,
      "04244": true,
      "04245": true,
      "04246": true,
      "04247": true,
      "04248": true,
      "04249": true,
      "04250": true,
      "04251": true,
      "04252": true,
      "04253": true,
      "04254": true,
      "04255": true,
      "04256": true,
      "04257": true,
      "04258": true,
      "04259": true,
      "04260": true,
      "04261": true,
      "04262": true,
      "04263": true,
      "04264": true,
      "04265": true,
      "04266": true,
      "04267": true,
      "04268": true,
      "04269": true,
      "04270": true,
      "04271": true,
      "04272": true,
      "04273": true,
      "04274": true,
      "04275": true,
      "04276": true,
      "04277": true,
      "04278": true,
      "04279": true,
      "04280": true,
      "04281": true,
      "04282": true,
      "04283": true,
      "04284": true,
      "04285": true,
      "04286": true,
      "04287": true,
      "04288": true,
      "04289": true,
      "04290": true,
      "04291": true,
      "04292": true,
      "04293": true,
      "04294": true,
      "04295": true,
      "04296": true,
      "04297": true,
      "04298": true,
      "04299": true,
      "04300": true,
      "04301": true,
      "04302": true,
      "04303": true,
      "04304": true,
      "04305": true,
      "04306": true,
      "04307": true,
      "04308": true,
      "04309": true,
      "04310": true,
      "04311": true,
      "04312": true,
      "04313": true,
      "04314": true,
      "04315": true,
      "04316": true,
      "04317": true,
      "04318": true,
      "04319": true,
      "04320": true,
      "04321": true,
      "04322": true,
      "04323": true,
      "04324": true,
      "04325": true,
      "04326": true,
      "04327": true,
      "04328": true,
      "04329": true,
      "04330": true,
      "04331": true,
      "04332": true,
      "04333": true,
      "04334": true,
      "04335": true,
      "04336": true,
      "04337": true,
      "04338": true,
      "04339": true,
      "04340": true,
      "04341": true,
      "04342": true,
      "04343": true,
      "04344": true,
      "04345": true,
      "04346": true,
      "04347": true,
      "04348": true,
      "04349": true,
      "04350": true,
      "04351": true,
      "04352": true,
      "04353": true,
      "04354": true,
      "04355": true,
      "04356": true,
      "04357": true,
      "04358": true,
      "04359": true,
      "04360": true,
      "04361": true,
      "04362": true,
      "04363": true,
      "04364": true,
      "04365": true,
      "04366": true,
      "04367": true,
      "04368": true,
      "04369": true,
      "04370": true,
      "04371": true,
      "04372": true,
      "04373": true,
      "04374": true,
      "04375": true,
      "04376": true,
      "04377": true,
      "04378": true,
      "04379": true,
      "04380": true,
      "04381": true,
      "04382": true,
      "04383": true,
      "04384": true,
      "04385": true,
      "04386": true,
      "04387": true,
      "04388": true,
      "04389": true,
      "04390": true,
      "04391": true,
      "04392": true,
      "04393": true,
      "04394": true,
      "04395": true,
      "04396": true,
      "04397": true,
      "04398": true,
      "04399": true,
      "04400": true,
      "04401": true,
      "04402": true,
      "04403": true,
      "04404": true,
      "04405": true,
      "04406": true,
      "04407": true,
      "04408": true,
      "04409": true,
      "04410": true,
      "04411": true,
      "04412": true,
      "04413": true,
      "04414": true,
      "04415": true,
      "04416": true,
      "04417": true,
      "04418": true,
      "04419": true,
      "04420": true,
      "04421": true,
      "04422": true,
      "04423": true,
      "04424": true,
      "04425": true,
      "04426": true,
      "04427": true,
      "04428": true,
      "04429": true,
      "04430": true,
      "04431": true,
      "04432": true,
      "04433": true,
      "04434": true,
      "04435": true,
      "04436": true,
      "04437": true,
      "04438": true,
      "04439": true,
      "04440": true,
      "04441": true,
      "04442": true,
      "04443": true,
      "04444": true,
      "04445": true,
      "04446": true,
      "04447": true,
      "04448": true,
      "04449": true,
      "04450": true,
      "04451": true,
      "04452": true,
      "04453": true,
      "04454": true,
      "04455": true,
      "04456": true,
      "04457": true,
      "04458": true,
      "04459": true,
      "04460": true,
      "04461": true,
      "04462": true,
      "04463": true,
      "04464": true,
      "04465": true,
      "04466": true,
      "04467": true,
      "04468": true,
      "04469": true,
      "04470": true,
      "04471": true,
      "04472": true,
      "04473": true,
      "04474": true,
      "04475": true,
      "04476": true,
      "04477": true,
      "04478": true,
      "04479": true,
      "04480": true,
      "04481": true,
      "04482": true,
      "04483": true,
      "04484": true,
      "04485": true,
      "04486": true,
      "04487": true,
      "04488": true,
      "04489": true,
      "04490": true,
      "04491": true,
      "04492": true,
      "04493": true,
      "04494": true,
      "04495": true,
      "04496": true,
      "04497": true,
      "04498": true,
      "04499": true,
      "04500": true,
      "04501": true,
      "04502": true,
      "04503": true,
      "04504": true,
      "04505": true,
      "04506": true,
      "04507": true,
      "04508": true,
      "04509": true,
      "04510": true,
      "04511": true,
      "04512": true,
      "04513": true,
      "04514": true,
      "04515": true,
      "04516": true,
      "04517": true,
      "04518": true,
      "04519": true,
      "04520": true,
      "04521": true,
      "04522": true,
      "04523": true,
      "04524": true,
      "04525": true,
      "04526": true,
      "04527": true,
      "04528": true,
      "04529": true,
      "04530": true,
      "04531": true,
      "04532": true,
      "04533": true,
      "04534": true,
      "04535": true,
      "04536": true,
      "04537": true,
      "04538": true,
      "04539": true,
      "04540": true,
      "04541": true,
      "04542": true,
      "04543": true,
      "04544": true,
      "04545": true,
      "04546": true,
      "04547": true,
      "04548": true,
      "04549": true,
      "04550": true,
      "04551": true,
      "04552": true,
      "04553": true,
      "04554": true,
      "04555": true,
      "04556": true,
      "04557": true,
      "04558": true,
      "04559": true,
      "04560": true,
      "04561": true,
      "04562": true,
      "04563": true,
      "04564": true,
      "04565": true,
      "04566": true,
      "04567": true,
      "04568": true,
      "04569": true,
      "04570": true,
      "04571": true,
      "04572": true,
      "04573": true,
      "04574": true,
      "04575": true,
      "04576": true,
      "04577": true,
      "04578": true,
      "04579": true,
      "04580": true,
      "04581": true,
      "04582": true,
      "04583": true,
      "04584": true,
      "04585": true,
      "04586": true,
      "04587": true,
      "04588": true,
      "04589": true,
      "04590": true,
      "04591": true,
      "04592": true,
      "04593": true,
      "04594": true,
      "04595": true,
      "04596": true,
      "04597": true,
      "04598": true,
      "04599": true,
      "04600": true,
      "04601": true,
      "04602": true,
      "04603": true,
      "04604": true,
      "04605": true,
      "04606": true,
      "04607": true,
      "04608": true,
      "04609": true,
      "04610": true,
      "04611": true,
      "04612": true,
      "04613": true,
      "04614": true,
      "04615": true,
      "04616": true,
      "04617": true,
      "04618": true,
      "04619": true,
      "04620": true,
      "04621": true,
      "04622": true,
      "04623": true,
      "04624": true,
      "04625": true,
      "04626": true,
      "04627": true,
      "04628": true,
      "04629": true,
      "04630": true,
      "04631": true,
      "04632": true,
      "04633": true,
      "04634": true,
      "04635": true,
      "04636": true,
      "04637": true,
      "04638": true,
      "04639": true,
      "04640": true,
      "04641": true,
      "04642": true,
      "04643": true,
      "04644": true,
      "04645": true,
      "04646": true,
      "04647": true,
      "04648": true,
      "04649": true,
      "04650": true,
      "04651": true,
      "04652": true,
      "04653": true,
      "04654": true,
      "04655": true,
      "04656": true,
      "04657": true,
      "04658": true,
      "04659": true,
      "04660": true,
      "04661": true,
      "04662": true,
      "04663": true,
      "04664": true,
      "04665": true,
      "04666": true,
      "04667": true,
      "04668": true,
      "04669": true,
      "04670": true,
      "04671": true,
      "04672": true,
      "04673": true,
      "04674": true,
      "04675": true,
      "04676": true,
      "04677": true,
      "04678": true,
      "04679": true,
      "04680": true,
      "04681": true,
      "04682": true,
      "04683": true,
      "04684": true,
      "04685": true,
      "04686": true,
      "04687": true,
      "04688": true,
      "04689": true,
      "04690": true,
      "04691": true,
      "04692": true,
      "04693": true,
      "04694": true,
      "04695": true,
      "04696": true,
      "04697": true,
      "04698": true,
      "04699": true,
      "04700": true,
      "04701": true,
      "04702": true,
      "04703": true,
      "04704": true,
      "04705": true,
      "04706": true,
      "04707": true,
      "04708": true,
      "04709": true,
      "04710": true,
      "04711": true,
      "04712": true,
      "04713": true,
      "04714": true,
      "04715": true,
      "04716": true,
      "04717": true,
      "04718": true,
      "04719": true,
      "04720": true,
      "04721": true,
      "04722": true,
      "04723": true,
      "04724": true,
      "04725": true,
      "04726": true,
      "04727": true,
      "04728": true,
      "04729": true,
      "04730": true,
      "04731": true,
      "04732": true,
      "04733": true,
      "04734": true,
      "04735": true,
      "04736": true,
      "04737": true,
      "04738": true,
      "04739": true,
      "04740": true,
      "04741": true,
      "04742": true,
      "04743": true,
      "04744": true,
      "04745": true,
      "04746": true,
      "04747": true,
      "04748": true,
      "04749": true,
      "04750": true,
      "04751": true,
      "04752": true,
      "04753": true,
      "04754": true,
      "04755": true,
      "04756": true,
      "04757": true,
      "04758": true,
      "04759": true,
      "04760": true,
      "04761": true,
      "04762": true,
      "04763": true,
      "04764": true,
      "04765": true,
      "04766": true,
      "04767": true,
      "04768": true,
      "04769": true,
      "04770": true,
      "04771": true,
      "04772": true,
      "04773": true,
      "04774": true,
      "04775": true,
      "04776": true,
      "04777": true,
      "04778": true,
      "04779": true,
      "04780": true,
      "04781": true,
      "04782": true,
      "04783": true,
      "04784": true,
      "04785": true,
      "04786": true,
      "04787": true,
      "04788": true,
      "04789": true,
      "04790": true,
      "04791": true,
      "04792": true,
      "04793": true,
      "04794": true,
      "04795": true,
      "04796": true,
      "04797": true,
      "04798": true,
      "04799": true,
      "04800": true,
      "04801": true,
      "04802": true,
      "04803": true,
      "04804": true,
      "04805": true,
      "04806": true,
      "04807": true,
      "04808": true,
      "04809": true,
      "04810": true,
      "04811": true,
      "04812": true,
      "04813": true,
      "04814": true,
      "04815": true,
      "04816": true,
      "04817": true,
      "04818": true,
      "04819": true,
      "04820": true,
      "04821": true,
      "04822": true,
      "04823": true,
      "04824": true,
      "04825": true,
      "04826": true,
      "04827": true,
      "04828": true,
      "04829": true,
      "04830": true,
      "04831": true,
      "04832": true,
      "04833": true,
      "04834": true,
      "04835": true,
      "04836": true,
      "04837": true,
      "04838": true,
      "04839": true,
      "04840": true,
      "04841": true,
      "04842": true,
      "04843": true,
      "04844": true,
      "04845": true,
      "04846": true,
      "04847": true,
      "04848": true,
      "04849": true,
      "04850": true,
      "04851": true,
      "04852": true,
      "04853": true,
      "04854": true,
      "04855": true,
      "04856": true,
      "04857": true,
      "04858": true,
      "04859": true,
      "04860": true,
      "04861": true,
      "04862": true,
      "04863": true,
      "04864": true,
      "04865": true,
      "04866": true,
      "04867": true,
      "04868": true,
      "04869": true,
      "04870": true,
      "04871": true,
      "04872": true,
      "04873": true,
      "04874": true,
      "04875": true,
      "04876": true,
      "04877": true,
      "04878": true,
      "04879": true,
      "04880": true,
      "04881": true,
      "04882": true,
      "04883": true,
      "04884": true,
      "04885": true,
      "04886": true,
      "04887": true,
      "04888": true,
      "04889": true,
      "04890": true,
      "04891": true,
      "04892": true,
      "04893": true,
      "04894": true,
      "04895": true,
      "04896": true,
      "04897": true,
      "04898": true,
      "04899": true,
      "04900": true,
      "04901": true,
      "04902": true,
      "04903": true,
      "04904": true,
      "04905": true,
      "04906": true,
      "04907": true,
      "04908": true,
      "04909": true,
      "04910": true,
      "04911": true,
      "04912": true,
      "04913": true,
      "04914": true,
      "04915": true,
      "04916": true,
      "04917": true,
      "04918": true,
      "04919": true,
      "04920": true,
      "04921": true,
      "04922": true,
      "04923": true,
      "04924": true,
      "04925": true,
      "04926": true,
      "04927": true,
      "04928": true,
      "04929": true,
      "04930": true,
      "04931": true,
      "04932": true,
      "04933": true,
      "04934": true,
      "04935": true,
      "04936": true,
      "04937": true,
      "04938": true,
      "04939": true,
      "04940": true,
      "04941": true,
      "04942": true,
      "04943": true,
      "04944": true,
      "04945": true,
      "04946": true,
      "04947": true,
      "04948": true,
      "04949": true,
      "04950": true,
      "04951": true,
      "04952": true,
      "04953": true,
      "04954": true,
      "04955": true,
      "04956": true,
      "04957": true,
      "04958": true,
      "04959": true,
      "04960": true,
      "04961": true,
      "04962": true,
      "04963": true,
      "04964": true,
      "04965": true,
      "04966": true,
      "04967": true,
      "04968": true,
      "04969": true,
      "04970": true,
      "04971": true,
      "04972": true,
      "04973": true,
      "04974": true,
      "04975": true,
      "04976": true,
      "04977": true,
      "04978": true,
      "04979": true,
      "04980": true,
      "04981": true,
      "04982": true,
      "04983": true,
      "04984": true,
      "04985": true,
      "04986": true,
      "04987": true,
      "04988": true,
      "04989": true,
      "04990": true,
      "04991": true,
      "04992": true,
      "04993": true,
      "04994": true,
      "04995": true,
      "04996": true,
      "04997": true,
      "04998": true,
      "04999": true
    },
    "CUAJIMALPA DE MORELOS": {
      "05000": true,
      "05009": true,
      "05010": true,
      "05020": true,
      "05030": true,
      "05039": true,
      "05060": true,
      "05100": true,
      "05110": true,
      "05118": true,
      "05119": true,
      "05120": true,
      "05126": true,
      "05128": true,
      "05129": true,
      "05130": true,
      "05200": true,
      "05214": true,
      "05219": true,
      "05220": true,
      "05230": true,
      "05238": true,
      "05240": true,
      "05249": true,
      "05260": true,
      "05268": true,
      "05269": true,
      "05270": true,
      "05280": true,
      "05310": true,
      "05320": true,
      "05330": true,
      "05348": true,
      "05349": true,
      "05360": true,
      "05370": true,
      "05379": true,
      "05500": true,
      "05520": true,
      "05530": true,
      "05600": true,
      "05619": true,
      "05620": true,
      "05700": true,
      "05750": true
    },
    "CUAUHTÉMOC": {
      "06000": true,
      "06001": true,
      "06002": true,
      "06003": true,
      "06004": true,
      "06005": true,
      "06006": true,
      "06007": true,
      "06008": true,
      "06009": true,
      "06010": true,
      "06011": true,
      "06012": true,
      "06013": true,
      "06014": true,
      "06015": true,
      "06016": true,
      "06017": true,
      "06018": true,
      "06019": true,
      "06020": true,
      "06021": true,
      "06022": true,
      "06023": true,
      "06024": true,
      "06025": true,
      "06026": true,
      "06027": true,
      "06028": true,
      "06029": true,
      "06030": true,
      "06031": true,
      "06032": true,
      "06033": true,
      "06034": true,
      "06035": true,
      "06036": true,
      "06037": true,
      "06038": true,
      "06039": true,
      "06040": true,
      "06041": true,
      "06042": true,
      "06043": true,
      "06044": true,
      "06045": true,
      "06046": true,
      "06047": true,
      "06048": true,
      "06049": true,
      "06050": true,
      "06051": true,
      "06052": true,
      "06053": true,
      "06054": true,
      "06055": true,
      "06056": true,
      "06057": true,
      "06058": true,
      "06059": true,
      "06060": true,
      "06061": true,
      "06062": true,
      "06063": true,
      "06064": true,
      "06065": true,
      "06066": true,
      "06067": true,
      "06068": true,
      "06069": true,
      "06070": true,
      "06071": true,
      "06072": true,
      "06073": true,
      "06074": true,
      "06075": true,
      "06076": true,
      "06077": true,
      "06078": true,
      "06079": true,
      "06080": true,
      "06081": true,
      "06082": true,
      "06083": true,
      "06084": true,
      "06085": true,
      "06086": true,
      "06087": true,
      "06088": true,
      "06089": true,
      "06090": true,
      "06091": true,
      "06092": true,
      "06093": true,
      "06094": true,
      "06095": true,
      "06096": true,
      "06097": true,
      "06098": true,
      "06099": true,
      "06100": true,
      "06101": true,
      "06102": true,
      "06103": true,
      "06104": true,
      "06105": true,
      "06106": true,
      "06107": true,
      "06108": true,
      "06109": true,
      "06110": true,
      "06111": true,
      "06112": true,
      "06113": true,
      "06114": true,
      "06115": true,
      "06116": true,
      "06117": true,
      "06118": true,
      "06119": true,
      "06120": true,
      "06121": true,
      "06122": true,
      "06123": true,
      "06124": true,
      "06125": true,
      "06126": true,
      "06127": true,
      "06128": true,
      "06129": true,
      "06130": true,
      "06131": true,
      "06132": true,
      "06133": true,
      "06134": true,
      "06135": true,
      "06136": true,
      "06137": true,
      "06138": true,
      "06139": true,
      "06140": true,
      "06141": true,
      "06142": true,
      "06143": true,
      "06144": true,
      "06145": true,
      "06146": true,
      "06147": true,
      "06148": true,
      "06149": true,
      "06150": true,
      "06151": true,
      "06152": true,
      "06153": true,
      "06154": true,
      "06155": true,
      "06156": true,
      "06157": true,
      "06158": true,
      "06159": true,
      "06160": true,
      "06161": true,
      "06162": true,
      "06163": true,
      "06164": true,
      "06165": true,
      "06166": true,
      "06167": true,
      "06168": true,
      "06169": true,
      "06170": true,
      "06171": true,
      "06172": true,
      "06173": true,
      "06174": true,
      "06175": true,
      "06176": true,
      "06177": true,
      "06178": true,
      "06179": true,
      "06180": true,
      "06181": true,
      "06182": true,
      "06183": true,
      "06184": true,
      "06185": true,
      "06186": true,
      "06187": true,
      "06188": true,
      "06189": true,
      "06190": true,
      "06191": true,
      "06192": true,
      "06193": true,
      "06194": true,
      "06195": true,
      "06196": true,
      "06197": true,
      "06198": true,
      "06199": true,
      "06200": true,
      "06201": true,
      "06202": true,
      "06203": true,
      "06204": true,
      "06205": true,
      "06206": true,
      "06207": true,
      "06208": true,
      "06209": true,
      "06210": true,
      "06211": true,
      "06212": true,
      "06213": true,
      "06214": true,
      "06215": true,
      "06216": true,
      "06217": true,
      "06218": true,
      "06219": true,
      "06220": true,
      "06221": true,
      "06222": true,
      "06223": true,
      "06224": true,
      "06225": true,
      "06226": true,
      "06227": true,
      "06228": true,
      "06229": true,
      "06230": true,
      "06231": true,
      "06232": true,
      "06233": true,
      "06234": true,
      "06235": true,
      "06236": true,
      "06237": true,
      "06238": true,
      "06239": true,
      "06240": true,
      "06241": true,
      "06242": true,
      "06243": true,
      "06244": true,
      "06245": true,
      "06246": true,
      "06247": true,
      "06248": true,
      "06249": true,
      "06250": true,
      "06251": true,
      "06252": true,
      "06253": true,
      "06254": true,
      "06255": true,
      "06256": true,
      "06257": true,
      "06258": true,
      "06259": true,
      "06260": true,
      "06261": true,
      "06262": true,
      "06263": true,
      "06264": true,
      "06265": true,
      "06266": true,
      "06267": true,
      "06268": true,
      "06269": true,
      "06270": true,
      "06271": true,
      "06272": true,
      "06273": true,
      "06274": true,
      "06275": true,
      "06276": true,
      "06277": true,
      "06278": true,
      "06279": true,
      "06280": true,
      "06281": true,
      "06282": true,
      "06283": true,
      "06284": true,
      "06285": true,
      "06286": true,
      "06287": true,
      "06288": true,
      "06289": true,
      "06290": true,
      "06291": true,
      "06292": true,
      "06293": true,
      "06294": true,
      "06295": true,
      "06296": true,
      "06297": true,
      "06298": true,
      "06299": true,
      "06300": true,
      "06301": true,
      "06302": true,
      "06303": true,
      "06304": true,
      "06305": true,
      "06306": true,
      "06307": true,
      "06308": true,
      "06309": true,
      "06310": true,
      "06311": true,
      "06312": true,
      "06313": true,
      "06314": true,
      "06315": true,
      "06316": true,
      "06317": true,
      "06318": true,
      "06319": true,
      "06320": true,
      "06321": true,
      "06322": true,
      "06323": true,
      "06324": true,
      "06325": true,
      "06326": true,
      "06327": true,
      "06328": true,
      "06329": true,
      "06330": true,
      "06331": true,
      "06332": true,
      "06333": true,
      "06334": true,
      "06335": true,
      "06336": true,
      "06337": true,
      "06338": true,
      "06339": true,
      "06340": true,
      "06341": true,
      "06342": true,
      "06343": true,
      "06344": true,
      "06345": true,
      "06346": true,
      "06347": true,
      "06348": true,
      "06349": true,
      "06350": true,
      "06351": true,
      "06352": true,
      "06353": true,
      "06354": true,
      "06355": true,
      "06356": true,
      "06357": true,
      "06358": true,
      "06359": true,
      "06360": true,
      "06361": true,
      "06362": true,
      "06363": true,
      "06364": true,
      "06365": true,
      "06366": true,
      "06367": true,
      "06368": true,
      "06369": true,
      "06370": true,
      "06371": true,
      "06372": true,
      "06373": true,
      "06374": true,
      "06375": true,
      "06376": true,
      "06377": true,
      "06378": true,
      "06379": true,
      "06380": true,
      "06381": true,
      "06382": true,
      "06383": true,
      "06384": true,
      "06385": true,
      "06386": true,
      "06387": true,
      "06388": true,
      "06389": true,
      "06390": true,
      "06391": true,
      "06392": true,
      "06393": true,
      "06394": true,
      "06395": true,
      "06396": true,
      "06397": true,
      "06398": true,
      "06399": true,
      "06400": true,
      "06401": true,
      "06402": true,
      "06403": true,
      "06404": true,
      "06405": true,
      "06406": true,
      "06407": true,
      "06408": true,
      "06409": true,
      "06410": true,
      "06411": true,
      "06412": true,
      "06413": true,
      "06414": true,
      "06415": true,
      "06416": true,
      "06417": true,
      "06418": true,
      "06419": true,
      "06420": true,
      "06421": true,
      "06422": true,
      "06423": true,
      "06424": true,
      "06425": true,
      "06426": true,
      "06427": true,
      "06428": true,
      "06429": true,
      "06430": true,
      "06431": true,
      "06432": true,
      "06433": true,
      "06434": true,
      "06435": true,
      "06436": true,
      "06437": true,
      "06438": true,
      "06439": true,
      "06440": true,
      "06441": true,
      "06442": true,
      "06443": true,
      "06444": true,
      "06445": true,
      "06446": true,
      "06447": true,
      "06448": true,
      "06449": true,
      "06450": true,
      "06451": true,
      "06452": true,
      "06453": true,
      "06454": true,
      "06455": true,
      "06456": true,
      "06457": true,
      "06458": true,
      "06459": true,
      "06460": true,
      "06461": true,
      "06462": true,
      "06463": true,
      "06464": true,
      "06465": true,
      "06466": true,
      "06467": true,
      "06468": true,
      "06469": true,
      "06470": true,
      "06471": true,
      "06472": true,
      "06473": true,
      "06474": true,
      "06475": true,
      "06476": true,
      "06477": true,
      "06478": true,
      "06479": true,
      "06480": true,
      "06481": true,
      "06482": true,
      "06483": true,
      "06484": true,
      "06485": true,
      "06486": true,
      "06487": true,
      "06488": true,
      "06489": true,
      "06490": true,
      "06491": true,
      "06492": true,
      "06493": true,
      "06494": true,
      "06495": true,
      "06496": true,
      "06497": true,
      "06498": true,
      "06499": true,
      "06500": true,
      "06501": true,
      "06502": true,
      "06503": true,
      "06504": true,
      "06505": true,
      "06506": true,
      "06507": true,
      "06508": true,
      "06509": true,
      "06510": true,
      "06511": true,
      "06512": true,
      "06513": true,
      "06514": true,
      "06515": true,
      "06516": true,
      "06517": true,
      "06518": true,
      "06519": true,
      "06520": true,
      "06521": true,
      "06522": true,
      "06523": true,
      "06524": true,
      "06525": true,
      "06526": true,
      "06527": true,
      "06528": true,
      "06529": true,
      "06530": true,
      "06531": true,
      "06532": true,
      "06533": true,
      "06534": true,
      "06535": true,
      "06536": true,
      "06537": true,
      "06538": true,
      "06539": true,
      "06540": true,
      "06541": true,
      "06542": true,
      "06543": true,
      "06544": true,
      "06545": true,
      "06546": true,
      "06547": true,
      "06548": true,
      "06549": true,
      "06550": true,
      "06551": true,
      "06552": true,
      "06553": true,
      "06554": true,
      "06555": true,
      "06556": true,
      "06557": true,
      "06558": true,
      "06559": true,
      "06560": true,
      "06561": true,
      "06562": true,
      "06563": true,
      "06564": true,
      "06565": true,
      "06566": true,
      "06567": true,
      "06568": true,
      "06569": true,
      "06570": true,
      "06571": true,
      "06572": true,
      "06573": true,
      "06574": true,
      "06575": true,
      "06576": true,
      "06577": true,
      "06578": true,
      "06579": true,
      "06580": true,
      "06581": true,
      "06582": true,
      "06583": true,
      "06584": true,
      "06585": true,
      "06586": true,
      "06587": true,
      "06588": true,
      "06589": true,
      "06590": true,
      "06591": true,
      "06592": true,
      "06593": true,
      "06594": true,
      "06595": true,
      "06596": true,
      "06597": true,
      "06598": true,
      "06599": true,
      "06600": true,
      "06601": true,
      "06602": true,
      "06603": true,
      "06604": true,
      "06605": true,
      "06606": true,
      "06607": true,
      "06608": true,
      "06609": true,
      "06610": true,
      "06611": true,
      "06612": true,
      "06613": true,
      "06614": true,
      "06615": true,
      "06616": true,
      "06617": true,
      "06618": true,
      "06619": true,
      "06620": true,
      "06621": true,
      "06622": true,
      "06623": true,
      "06624": true,
      "06625": true,
      "06626": true,
      "06627": true,
      "06628": true,
      "06629": true,
      "06630": true,
      "06631": true,
      "06632": true,
      "06633": true,
      "06634": true,
      "06635": true,
      "06636": true,
      "06637": true,
      "06638": true,
      "06639": true,
      "06640": true,
      "06641": true,
      "06642": true,
      "06643": true,
      "06644": true,
      "06645": true,
      "06646": true,
      "06647": true,
      "06648": true,
      "06649": true,
      "06650": true,
      "06651": true,
      "06652": true,
      "06653": true,
      "06654": true,
      "06655": true,
      "06656": true,
      "06657": true,
      "06658": true,
      "06659": true,
      "06660": true,
      "06661": true,
      "06662": true,
      "06663": true,
      "06664": true,
      "06665": true,
      "06666": true,
      "06667": true,
      "06668": true,
      "06669": true,
      "06670": true,
      "06671": true,
      "06672": true,
      "06673": true,
      "06674": true,
      "06675": true,
      "06676": true,
      "06677": true,
      "06678": true,
      "06679": true,
      "06680": true,
      "06681": true,
      "06682": true,
      "06683": true,
      "06684": true,
      "06685": true,
      "06686": true,
      "06687": true,
      "06688": true,
      "06689": true,
      "06690": true,
      "06691": true,
      "06692": true,
      "06693": true,
      "06694": true,
      "06695": true,
      "06696": true,
      "06697": true,
      "06698": true,
      "06699": true,
      "06700": true,
      "06701": true,
      "06702": true,
      "06703": true,
      "06704": true,
      "06705": true,
      "06706": true,
      "06707": true,
      "06708": true,
      "06709": true,
      "06710": true,
      "06711": true,
      "06712": true,
      "06713": true,
      "06714": true,
      "06715": true,
      "06716": true,
      "06717": true,
      "06718": true,
      "06719": true,
      "06720": true,
      "06721": true,
      "06722": true,
      "06723": true,
      "06724": true,
      "06725": true,
      "06726": true,
      "06727": true,
      "06728": true,
      "06729": true,
      "06730": true,
      "06731": true,
      "06732": true,
      "06733": true,
      "06734": true,
      "06735": true,
      "06736": true,
      "06737": true,
      "06738": true,
      "06739": true,
      "06740": true,
      "06741": true,
      "06742": true,
      "06743": true,
      "06744": true,
      "06745": true,
      "06746": true,
      "06747": true,
      "06748": true,
      "06749": true,
      "06750": true,
      "06751": true,
      "06752": true,
      "06753": true,
      "06754": true,
      "06755": true,
      "06756": true,
      "06757": true,
      "06758": true,
      "06759": true,
      "06760": true,
      "06761": true,
      "06762": true,
      "06763": true,
      "06764": true,
      "06765": true,
      "06766": true,
      "06767": true,
      "06768": true,
      "06769": true,
      "06770": true,
      "06771": true,
      "06772": true,
      "06773": true,
      "06774": true,
      "06775": true,
      "06776": true,
      "06777": true,
      "06778": true,
      "06779": true,
      "06780": true,
      "06781": true,
      "06782": true,
      "06783": true,
      "06784": true,
      "06785": true,
      "06786": true,
      "06787": true,
      "06788": true,
      "06789": true,
      "06790": true,
      "06791": true,
      "06792": true,
      "06793": true,
      "06794": true,
      "06795": true,
      "06796": true,
      "06797": true,
      "06798": true,
      "06799": true,
      "06800": true,
      "06801": true,
      "06802": true,
      "06803": true,
      "06804": true,
      "06805": true,
      "06806": true,
      "06807": true,
      "06808": true,
      "06809": true,
      "06810": true,
      "06811": true,
      "06812": true,
      "06813": true,
      "06814": true,
      "06815": true,
      "06816": true,
      "06817": true,
      "06818": true,
      "06819": true,
      "06820": true,
      "06821": true,
      "06822": true,
      "06823": true,
      "06824": true,
      "06825": true,
      "06826": true,
      "06827": true,
      "06828": true,
      "06829": true,
      "06830": true,
      "06831": true,
      "06832": true,
      "06833": true,
      "06834": true,
      "06835": true,
      "06836": true,
      "06837": true,
      "06838": true,
      "06839": true,
      "06840": true,
      "06841": true,
      "06842": true,
      "06843": true,
      "06844": true,
      "06845": true,
      "06846": true,
      "06847": true,
      "06848": true,
      "06849": true,
      "06850": true,
      "06851": true,
      "06852": true,
      "06853": true,
      "06854": true,
      "06855": true,
      "06856": true,
      "06857": true,
      "06858": true,
      "06859": true,
      "06860": true,
      "06861": true,
      "06862": true,
      "06863": true,
      "06864": true,
      "06865": true,
      "06866": true,
      "06867": true,
      "06868": true,
      "06869": true,
      "06870": true,
      "06871": true,
      "06872": true,
      "06873": true,
      "06874": true,
      "06875": true,
      "06876": true,
      "06877": true,
      "06878": true,
      "06879": true,
      "06880": true,
      "06881": true,
      "06882": true,
      "06883": true,
      "06884": true,
      "06885": true,
      "06886": true,
      "06887": true,
      "06888": true,
      "06889": true,
      "06890": true,
      "06891": true,
      "06892": true,
      "06893": true,
      "06894": true,
      "06895": true,
      "06896": true,
      "06897": true,
      "06898": true,
      "06899": true,
      "06900": true,
      "06901": true,
      "06902": true,
      "06903": true,
      "06904": true,
      "06905": true,
      "06906": true,
      "06907": true,
      "06908": true,
      "06909": true,
      "06910": true,
      "06911": true,
      "06912": true,
      "06913": true,
      "06914": true,
      "06915": true,
      "06916": true,
      "06917": true,
      "06918": true,
      "06919": true,
      "06920": true,
      "06921": true,
      "06922": true,
      "06923": true,
      "06924": true,
      "06925": true,
      "06926": true,
      "06927": true,
      "06928": true,
      "06929": true,
      "06930": true,
      "06931": true,
      "06932": true,
      "06933": true,
      "06934": true,
      "06935": true,
      "06936": true,
      "06937": true,
      "06938": true,
      "06939": true,
      "06940": true,
      "06941": true,
      "06942": true,
      "06943": true,
      "06944": true,
      "06945": true,
      "06946": true,
      "06947": true,
      "06948": true,
      "06949": true,
      "06950": true,
      "06951": true,
      "06952": true,
      "06953": true,
      "06954": true,
      "06955": true,
      "06956": true,
      "06957": true,
      "06958": true,
      "06959": true,
      "06960": true,
      "06961": true,
      "06962": true,
      "06963": true,
      "06964": true,
      "06965": true,
      "06966": true,
      "06967": true,
      "06968": true,
      "06969": true,
      "06970": true,
      "06971": true,
      "06972": true,
      "06973": true,
      "06974": true,
      "06975": true,
      "06976": true,
      "06977": true,
      "06978": true,
      "06979": true,
      "06980": true,
      "06981": true,
      "06982": true,
      "06983": true,
      "06984": true,
      "06985": true,
      "06986": true,
      "06987": true,
      "06988": true,
      "06989": true,
      "06990": true,
      "06991": true,
      "06992": true,
      "06993": true,
      "06994": true,
      "06995": true,
      "06996": true,
      "06997": true,
      "06998": true,
      "06999": true
    },
    "GUSTAVO A. MADERO": {
      "07000": true,
      "07001": true,
      "07002": true,
      "07003": true,
      "07004": true,
      "07005": true,
      "07006": true,
      "07007": true,
      "07008": true,
      "07009": true,
      "07010": true,
      "07011": true,
      "07012": true,
      "07013": true,
      "07014": true,
      "07015": true,
      "07016": true,
      "07017": true,
      "07018": true,
      "07019": true,
      "07020": true,
      "07021": true,
      "07022": true,
      "07023": true,
      "07024": true,
      "07025": true,
      "07026": true,
      "07027": true,
      "07028": true,
      "07029": true,
      "07030": true,
      "07031": true,
      "07032": true,
      "07033": true,
      "07034": true,
      "07035": true,
      "07036": true,
      "07037": true,
      "07038": true,
      "07039": true,
      "07040": true,
      "07041": true,
      "07042": true,
      "07043": true,
      "07044": true,
      "07045": true,
      "07046": true,
      "07047": true,
      "07048": true,
      "07049": true,
      "07050": true,
      "07051": true,
      "07052": true,
      "07053": true,
      "07054": true,
      "07055": true,
      "07056": true,
      "07057": true,
      "07058": true,
      "07059": true,
      "07060": true,
      "07061": true,
      "07062": true,
      "07063": true,
      "07064": true,
      "07065": true,
      "07066": true,
      "07067": true,
      "07068": true,
      "07069": true,
      "07070": true,
      "07071": true,
      "07072": true,
      "07073": true,
      "07074": true,
      "07075": true,
      "07076": true,
      "07077": true,
      "07078": true,
      "07079": true,
      "07080": true,
      "07081": true,
      "07082": true,
      "07083": true,
      "07084": true,
      "07085": true,
      "07086": true,
      "07087": true,
      "07088": true,
      "07089": true,
      "07090": true,
      "07091": true,
      "07092": true,
      "07093": true,
      "07094": true,
      "07095": true,
      "07096": true,
      "07097": true,
      "07098": true,
      "07099": true,
      "07100": true,
      "07101": true,
      "07102": true,
      "07103": true,
      "07104": true,
      "07105": true,
      "07106": true,
      "07107": true,
      "07108": true,
      "07109": true,
      "07110": true,
      "07111": true,
      "07112": true,
      "07113": true,
      "07114": true,
      "07115": true,
      "07116": true,
      "07117": true,
      "07118": true,
      "07119": true,
      "07120": true,
      "07121": true,
      "07122": true,
      "07123": true,
      "07124": true,
      "07125": true,
      "07126": true,
      "07127": true,
      "07128": true,
      "07129": true,
      "07130": true,
      "07131": true,
      "07132": true,
      "07133": true,
      "07134": true,
      "07135": true,
      "07136": true,
      "07137": true,
      "07138": true,
      "07139": true,
      "07140": true,
      "07141": true,
      "07142": true,
      "07143": true,
      "07144": true,
      "07145": true,
      "07146": true,
      "07147": true,
      "07148": true,
      "07149": true,
      "07150": true,
      "07151": true,
      "07152": true,
      "07153": true,
      "07154": true,
      "07155": true,
      "07156": true,
      "07157": true,
      "07158": true,
      "07159": true,
      "07160": true,
      "07161": true,
      "07162": true,
      "07163": true,
      "07164": true,
      "07165": true,
      "07166": true,
      "07167": true,
      "07168": true,
      "07169": true,
      "07170": true,
      "07171": true,
      "07172": true,
      "07173": true,
      "07174": true,
      "07175": true,
      "07176": true,
      "07177": true,
      "07178": true,
      "07179": true,
      "07180": true,
      "07181": true,
      "07182": true,
      "07183": true,
      "07184": true,
      "07185": true,
      "07186": true,
      "07187": true,
      "07188": true,
      "07189": true,
      "07190": true,
      "07191": true,
      "07192": true,
      "07193": true,
      "07194": true,
      "07195": true,
      "07196": true,
      "07197": true,
      "07198": true,
      "07199": true,
      "07200": true,
      "07201": true,
      "07202": true,
      "07203": true,
      "07204": true,
      "07205": true,
      "07206": true,
      "07207": true,
      "07208": true,
      "07209": true,
      "07210": true,
      "07211": true,
      "07212": true,
      "07213": true,
      "07214": true,
      "07215": true,
      "07216": true,
      "07217": true,
      "07218": true,
      "07219": true,
      "07220": true,
      "07221": true,
      "07222": true,
      "07223": true,
      "07224": true,
      "07225": true,
      "07226": true,
      "07227": true,
      "07228": true,
      "07229": true,
      "07230": true,
      "07231": true,
      "07232": true,
      "07233": true,
      "07234": true,
      "07235": true,
      "07236": true,
      "07237": true,
      "07238": true,
      "07239": true,
      "07240": true,
      "07241": true,
      "07242": true,
      "07243": true,
      "07244": true,
      "07245": true,
      "07246": true,
      "07247": true,
      "07248": true,
      "07249": true,
      "07250": true,
      "07251": true,
      "07252": true,
      "07253": true,
      "07254": true,
      "07255": true,
      "07256": true,
      "07257": true,
      "07258": true,
      "07259": true,
      "07260": true,
      "07261": true,
      "07262": true,
      "07263": true,
      "07264": true,
      "07265": true,
      "07266": true,
      "07267": true,
      "07268": true,
      "07269": true,
      "07270": true,
      "07271": true,
      "07272": true,
      "07273": true,
      "07274": true,
      "07275": true,
      "07276": true,
      "07277": true,
      "07278": true,
      "07279": true,
      "07280": true,
      "07281": true,
      "07282": true,
      "07283": true,
      "07284": true,
      "07285": true,
      "07286": true,
      "07287": true,
      "07288": true,
      "07289": true,
      "07290": true,
      "07291": true,
      "07292": true,
      "07293": true,
      "07294": true,
      "07295": true,
      "07296": true,
      "07297": true,
      "07298": true,
      "07299": true,
      "07300": true,
      "07301": true,
      "07302": true,
      "07303": true,
      "07304": true,
      "07305": true,
      "07306": true,
      "07307": true,
      "07308": true,
      "07309": true,
      "07310": true,
      "07311": true,
      "07312": true,
      "07313": true,
      "07314": true,
      "07315": true,
      "07316": true,
      "07317": true,
      "07318": true,
      "07319": true,
      "07320": true,
      "07321": true,
      "07322": true,
      "07323": true,
      "07324": true,
      "07325": true,
      "07326": true,
      "07327": true,
      "07328": true,
      "07329": true,
      "07330": true,
      "07331": true,
      "07332": true,
      "07333": true,
      "07334": true,
      "07335": true,
      "07336": true,
      "07337": true,
      "07338": true,
      "07339": true,
      "07340": true,
      "07341": true,
      "07342": true,
      "07343": true,
      "07344": true,
      "07345": true,
      "07346": true,
      "07347": true,
      "07348": true,
      "07349": true,
      "07350": true,
      "07351": true,
      "07352": true,
      "07353": true,
      "07354": true,
      "07355": true,
      "07356": true,
      "07357": true,
      "07358": true,
      "07359": true,
      "07360": true,
      "07361": true,
      "07362": true,
      "07363": true,
      "07364": true,
      "07365": true,
      "07366": true,
      "07367": true,
      "07368": true,
      "07369": true,
      "07370": true,
      "07371": true,
      "07372": true,
      "07373": true,
      "07374": true,
      "07375": true,
      "07376": true,
      "07377": true,
      "07378": true,
      "07379": true,
      "07380": true,
      "07381": true,
      "07382": true,
      "07383": true,
      "07384": true,
      "07385": true,
      "07386": true,
      "07387": true,
      "07388": true,
      "07389": true,
      "07390": true,
      "07391": true,
      "07392": true,
      "07393": true,
      "07394": true,
      "07395": true,
      "07396": true,
      "07397": true,
      "07398": true,
      "07399": true,
      "07400": true,
      "07401": true,
      "07402": true,
      "07403": true,
      "07404": true,
      "07405": true,
      "07406": true,
      "07407": true,
      "07408": true,
      "07409": true,
      "07410": true,
      "07411": true,
      "07412": true,
      "07413": true,
      "07414": true,
      "07415": true,
      "07416": true,
      "07417": true,
      "07418": true,
      "07419": true,
      "07420": true,
      "07421": true,
      "07422": true,
      "07423": true,
      "07424": true,
      "07425": true,
      "07426": true,
      "07427": true,
      "07428": true,
      "07429": true,
      "07430": true,
      "07431": true,
      "07432": true,
      "07433": true,
      "07434": true,
      "07435": true,
      "07436": true,
      "07437": true,
      "07438": true,
      "07439": true,
      "07440": true,
      "07441": true,
      "07442": true,
      "07443": true,
      "07444": true,
      "07445": true,
      "07446": true,
      "07447": true,
      "07448": true,
      "07449": true,
      "07450": true,
      "07451": true,
      "07452": true,
      "07453": true,
      "07454": true,
      "07455": true,
      "07456": true,
      "07457": true,
      "07458": true,
      "07459": true,
      "07460": true,
      "07461": true,
      "07462": true,
      "07463": true,
      "07464": true,
      "07465": true,
      "07466": true,
      "07467": true,
      "07468": true,
      "07469": true,
      "07470": true,
      "07471": true,
      "07472": true,
      "07473": true,
      "07474": true,
      "07475": true,
      "07476": true,
      "07477": true,
      "07478": true,
      "07479": true,
      "07480": true,
      "07481": true,
      "07482": true,
      "07483": true,
      "07484": true,
      "07485": true,
      "07486": true,
      "07487": true,
      "07488": true,
      "07489": true,
      "07490": true,
      "07491": true,
      "07492": true,
      "07493": true,
      "07494": true,
      "07495": true,
      "07496": true,
      "07497": true,
      "07498": true,
      "07499": true,
      "07500": true,
      "07501": true,
      "07502": true,
      "07503": true,
      "07504": true,
      "07505": true,
      "07506": true,
      "07507": true,
      "07508": true,
      "07509": true,
      "07510": true,
      "07511": true,
      "07512": true,
      "07513": true,
      "07514": true,
      "07515": true,
      "07516": true,
      "07517": true,
      "07518": true,
      "07519": true,
      "07520": true,
      "07521": true,
      "07522": true,
      "07523": true,
      "07524": true,
      "07525": true,
      "07526": true,
      "07527": true,
      "07528": true,
      "07529": true,
      "07530": true,
      "07531": true,
      "07532": true,
      "07533": true,
      "07534": true,
      "07535": true,
      "07536": true,
      "07537": true,
      "07538": true,
      "07539": true,
      "07540": true,
      "07541": true,
      "07542": true,
      "07543": true,
      "07544": true,
      "07545": true,
      "07546": true,
      "07547": true,
      "07548": true,
      "07549": true,
      "07550": true,
      "07551": true,
      "07552": true,
      "07553": true,
      "07554": true,
      "07555": true,
      "07556": true,
      "07557": true,
      "07558": true,
      "07559": true,
      "07560": true,
      "07561": true,
      "07562": true,
      "07563": true,
      "07564": true,
      "07565": true,
      "07566": true,
      "07567": true,
      "07568": true,
      "07569": true,
      "07570": true,
      "07571": true,
      "07572": true,
      "07573": true,
      "07574": true,
      "07575": true,
      "07576": true,
      "07577": true,
      "07578": true,
      "07579": true,
      "07580": true,
      "07581": true,
      "07582": true,
      "07583": true,
      "07584": true,
      "07585": true,
      "07586": true,
      "07587": true,
      "07588": true,
      "07589": true,
      "07590": true,
      "07591": true,
      "07592": true,
      "07593": true,
      "07594": true,
      "07595": true,
      "07596": true,
      "07597": true,
      "07598": true,
      "07599": true,
      "07600": true,
      "07601": true,
      "07602": true,
      "07603": true,
      "07604": true,
      "07605": true,
      "07606": true,
      "07607": true,
      "07608": true,
      "07609": true,
      "07610": true,
      "07611": true,
      "07612": true,
      "07613": true,
      "07614": true,
      "07615": true,
      "07616": true,
      "07617": true,
      "07618": true,
      "07619": true,
      "07620": true,
      "07621": true,
      "07622": true,
      "07623": true,
      "07624": true,
      "07625": true,
      "07626": true,
      "07627": true,
      "07628": true,
      "07629": true,
      "07630": true,
      "07631": true,
      "07632": true,
      "07633": true,
      "07634": true,
      "07635": true,
      "07636": true,
      "07637": true,
      "07638": true,
      "07639": true,
      "07640": true,
      "07641": true,
      "07642": true,
      "07643": true,
      "07644": true,
      "07645": true,
      "07646": true,
      "07647": true,
      "07648": true,
      "07649": true,
      "07650": true,
      "07651": true,
      "07652": true,
      "07653": true,
      "07654": true,
      "07655": true,
      "07656": true,
      "07657": true,
      "07658": true,
      "07659": true,
      "07660": true,
      "07661": true,
      "07662": true,
      "07663": true,
      "07664": true,
      "07665": true,
      "07666": true,
      "07667": true,
      "07668": true,
      "07669": true,
      "07670": true,
      "07671": true,
      "07672": true,
      "07673": true,
      "07674": true,
      "07675": true,
      "07676": true,
      "07677": true,
      "07678": true,
      "07679": true,
      "07680": true,
      "07681": true,
      "07682": true,
      "07683": true,
      "07684": true,
      "07685": true,
      "07686": true,
      "07687": true,
      "07688": true,
      "07689": true,
      "07690": true,
      "07691": true,
      "07692": true,
      "07693": true,
      "07694": true,
      "07695": true,
      "07696": true,
      "07697": true,
      "07698": true,
      "07699": true,
      "07700": true,
      "07701": true,
      "07702": true,
      "07703": true,
      "07704": true,
      "07705": true,
      "07706": true,
      "07707": true,
      "07708": true,
      "07709": true,
      "07710": true,
      "07711": true,
      "07712": true,
      "07713": true,
      "07714": true,
      "07715": true,
      "07716": true,
      "07717": true,
      "07718": true,
      "07719": true,
      "07720": true,
      "07721": true,
      "07722": true,
      "07723": true,
      "07724": true,
      "07725": true,
      "07726": true,
      "07727": true,
      "07728": true,
      "07729": true,
      "07730": true,
      "07731": true,
      "07732": true,
      "07733": true,
      "07734": true,
      "07735": true,
      "07736": true,
      "07737": true,
      "07738": true,
      "07739": true,
      "07740": true,
      "07741": true,
      "07742": true,
      "07743": true,
      "07744": true,
      "07745": true,
      "07746": true,
      "07747": true,
      "07748": true,
      "07749": true,
      "07750": true,
      "07751": true,
      "07752": true,
      "07753": true,
      "07754": true,
      "07755": true,
      "07756": true,
      "07757": true,
      "07758": true,
      "07759": true,
      "07760": true,
      "07761": true,
      "07762": true,
      "07763": true,
      "07764": true,
      "07765": true,
      "07766": true,
      "07767": true,
      "07768": true,
      "07769": true,
      "07770": true,
      "07771": true,
      "07772": true,
      "07773": true,
      "07774": true,
      "07775": true,
      "07776": true,
      "07777": true,
      "07778": true,
      "07779": true,
      "07780": true,
      "07781": true,
      "07782": true,
      "07783": true,
      "07784": true,
      "07785": true,
      "07786": true,
      "07787": true,
      "07788": true,
      "07789": true,
      "07790": true,
      "07791": true,
      "07792": true,
      "07793": true,
      "07794": true,
      "07795": true,
      "07796": true,
      "07797": true,
      "07798": true,
      "07799": true,
      "07800": true,
      "07801": true,
      "07802": true,
      "07803": true,
      "07804": true,
      "07805": true,
      "07806": true,
      "07807": true,
      "07808": true,
      "07809": true,
      "07810": true,
      "07811": true,
      "07812": true,
      "07813": true,
      "07814": true,
      "07815": true,
      "07816": true,
      "07817": true,
      "07818": true,
      "07819": true,
      "07820": true,
      "07821": true,
      "07822": true,
      "07823": true,
      "07824": true,
      "07825": true,
      "07826": true,
      "07827": true,
      "07828": true,
      "07829": true,
      "07830": true,
      "07831": true,
      "07832": true,
      "07833": true,
      "07834": true,
      "07835": true,
      "07836": true,
      "07837": true,
      "07838": true,
      "07839": true,
      "07840": true,
      "07841": true,
      "07842": true,
      "07843": true,
      "07844": true,
      "07845": true,
      "07846": true,
      "07847": true,
      "07848": true,
      "07849": true,
      "07850": true,
      "07851": true,
      "07852": true,
      "07853": true,
      "07854": true,
      "07855": true,
      "07856": true,
      "07857": true,
      "07858": true,
      "07859": true,
      "07860": true,
      "07861": true,
      "07862": true,
      "07863": true,
      "07864": true,
      "07865": true,
      "07866": true,
      "07867": true,
      "07868": true,
      "07869": true,
      "07870": true,
      "07871": true,
      "07872": true,
      "07873": true,
      "07874": true,
      "07875": true,
      "07876": true,
      "07877": true,
      "07878": true,
      "07879": true,
      "07880": true,
      "07881": true,
      "07882": true,
      "07883": true,
      "07884": true,
      "07885": true,
      "07886": true,
      "07887": true,
      "07888": true,
      "07889": true,
      "07890": true,
      "07891": true,
      "07892": true,
      "07893": true,
      "07894": true,
      "07895": true,
      "07896": true,
      "07897": true,
      "07898": true,
      "07899": true,
      "07900": true,
      "07901": true,
      "07902": true,
      "07903": true,
      "07904": true,
      "07905": true,
      "07906": true,
      "07907": true,
      "07908": true,
      "07909": true,
      "07910": true,
      "07911": true,
      "07912": true,
      "07913": true,
      "07914": true,
      "07915": true,
      "07916": true,
      "07917": true,
      "07918": true,
      "07919": true,
      "07920": true,
      "07921": true,
      "07922": true,
      "07923": true,
      "07924": true,
      "07925": true,
      "07926": true,
      "07927": true,
      "07928": true,
      "07929": true,
      "07930": true,
      "07931": true,
      "07932": true,
      "07933": true,
      "07934": true,
      "07935": true,
      "07936": true,
      "07937": true,
      "07938": true,
      "07939": true,
      "07940": true,
      "07941": true,
      "07942": true,
      "07943": true,
      "07944": true,
      "07945": true,
      "07946": true,
      "07947": true,
      "07948": true,
      "07949": true,
      "07950": true,
      "07951": true,
      "07952": true,
      "07953": true,
      "07954": true,
      "07955": true,
      "07956": true,
      "07957": true,
      "07958": true,
      "07959": true,
      "07960": true,
      "07961": true,
      "07962": true,
      "07963": true,
      "07964": true,
      "07965": true,
      "07966": true,
      "07967": true,
      "07968": true,
      "07969": true,
      "07970": true,
      "07971": true,
      "07972": true,
      "07973": true,
      "07974": true,
      "07975": true,
      "07976": true,
      "07977": true,
      "07978": true,
      "07979": true,
      "07980": true,
      "07981": true,
      "07982": true,
      "07983": true,
      "07984": true,
      "07985": true,
      "07986": true,
      "07987": true,
      "07988": true,
      "07989": true,
      "07990": true,
      "07991": true,
      "07992": true,
      "07993": true,
      "07994": true,
      "07995": true,
      "07996": true,
      "07997": true,
      "07998": true,
      "07999": true
    },
    "IZTACALCO": {
      "08000": true,
      "08001": true,
      "08002": true,
      "08003": true,
      "08004": true,
      "08005": true,
      "08006": true,
      "08007": true,
      "08008": true,
      "08009": true,
      "08010": true,
      "08011": true,
      "08012": true,
      "08013": true,
      "08014": true,
      "08015": true,
      "08016": true,
      "08017": true,
      "08018": true,
      "08019": true,
      "08020": true,
      "08021": true,
      "08022": true,
      "08023": true,
      "08024": true,
      "08025": true,
      "08026": true,
      "08027": true,
      "08028": true,
      "08029": true,
      "08030": true,
      "08031": true,
      "08032": true,
      "08033": true,
      "08034": true,
      "08035": true,
      "08036": true,
      "08037": true,
      "08038": true,
      "08039": true,
      "08040": true,
      "08041": true,
      "08042": true,
      "08043": true,
      "08044": true,
      "08045": true,
      "08046": true,
      "08047": true,
      "08048": true,
      "08049": true,
      "08050": true,
      "08051": true,
      "08052": true,
      "08053": true,
      "08054": true,
      "08055": true,
      "08056": true,
      "08057": true,
      "08058": true,
      "08059": true,
      "08060": true,
      "08061": true,
      "08062": true,
      "08063": true,
      "08064": true,
      "08065": true,
      "08066": true,
      "08067": true,
      "08068": true,
      "08069": true,
      "08070": true,
      "08071": true,
      "08072": true,
      "08073": true,
      "08074": true,
      "08075": true,
      "08076": true,
      "08077": true,
      "08078": true,
      "08079": true,
      "08080": true,
      "08081": true,
      "08082": true,
      "08083": true,
      "08084": true,
      "08085": true,
      "08086": true,
      "08087": true,
      "08088": true,
      "08089": true,
      "08090": true,
      "08091": true,
      "08092": true,
      "08093": true,
      "08094": true,
      "08095": true,
      "08096": true,
      "08097": true,
      "08098": true,
      "08099": true,
      "08100": true,
      "08101": true,
      "08102": true,
      "08103": true,
      "08104": true,
      "08105": true,
      "08106": true,
      "08107": true,
      "08108": true,
      "08109": true,
      "08110": true,
      "08111": true,
      "08112": true,
      "08113": true,
      "08114": true,
      "08115": true,
      "08116": true,
      "08117": true,
      "08118": true,
      "08119": true,
      "08120": true,
      "08121": true,
      "08122": true,
      "08123": true,
      "08124": true,
      "08125": true,
      "08126": true,
      "08127": true,
      "08128": true,
      "08129": true,
      "08130": true,
      "08131": true,
      "08132": true,
      "08133": true,
      "08134": true,
      "08135": true,
      "08136": true,
      "08137": true,
      "08138": true,
      "08139": true,
      "08140": true,
      "08141": true,
      "08142": true,
      "08143": true,
      "08144": true,
      "08145": true,
      "08146": true,
      "08147": true,
      "08148": true,
      "08149": true,
      "08150": true,
      "08151": true,
      "08152": true,
      "08153": true,
      "08154": true,
      "08155": true,
      "08156": true,
      "08157": true,
      "08158": true,
      "08159": true,
      "08160": true,
      "08161": true,
      "08162": true,
      "08163": true,
      "08164": true,
      "08165": true,
      "08166": true,
      "08167": true,
      "08168": true,
      "08169": true,
      "08170": true,
      "08171": true,
      "08172": true,
      "08173": true,
      "08174": true,
      "08175": true,
      "08176": true,
      "08177": true,
      "08178": true,
      "08179": true,
      "08180": true,
      "08181": true,
      "08182": true,
      "08183": true,
      "08184": true,
      "08185": true,
      "08186": true,
      "08187": true,
      "08188": true,
      "08189": true,
      "08190": true,
      "08191": true,
      "08192": true,
      "08193": true,
      "08194": true,
      "08195": true,
      "08196": true,
      "08197": true,
      "08198": true,
      "08199": true,
      "08200": true,
      "08201": true,
      "08202": true,
      "08203": true,
      "08204": true,
      "08205": true,
      "08206": true,
      "08207": true,
      "08208": true,
      "08209": true,
      "08210": true,
      "08211": true,
      "08212": true,
      "08213": true,
      "08214": true,
      "08215": true,
      "08216": true,
      "08217": true,
      "08218": true,
      "08219": true,
      "08220": true,
      "08221": true,
      "08222": true,
      "08223": true,
      "08224": true,
      "08225": true,
      "08226": true,
      "08227": true,
      "08228": true,
      "08229": true,
      "08230": true,
      "08231": true,
      "08232": true,
      "08233": true,
      "08234": true,
      "08235": true,
      "08236": true,
      "08237": true,
      "08238": true,
      "08239": true,
      "08240": true,
      "08241": true,
      "08242": true,
      "08243": true,
      "08244": true,
      "08245": true,
      "08246": true,
      "08247": true,
      "08248": true,
      "08249": true,
      "08250": true,
      "08251": true,
      "08252": true,
      "08253": true,
      "08254": true,
      "08255": true,
      "08256": true,
      "08257": true,
      "08258": true,
      "08259": true,
      "08260": true,
      "08261": true,
      "08262": true,
      "08263": true,
      "08264": true,
      "08265": true,
      "08266": true,
      "08267": true,
      "08268": true,
      "08269": true,
      "08270": true,
      "08271": true,
      "08272": true,
      "08273": true,
      "08274": true,
      "08275": true,
      "08276": true,
      "08277": true,
      "08278": true,
      "08279": true,
      "08280": true,
      "08281": true,
      "08282": true,
      "08283": true,
      "08284": true,
      "08285": true,
      "08286": true,
      "08287": true,
      "08288": true,
      "08289": true,
      "08290": true,
      "08291": true,
      "08292": true,
      "08293": true,
      "08294": true,
      "08295": true,
      "08296": true,
      "08297": true,
      "08298": true,
      "08299": true,
      "08300": true,
      "08301": true,
      "08302": true,
      "08303": true,
      "08304": true,
      "08305": true,
      "08306": true,
      "08307": true,
      "08308": true,
      "08309": true,
      "08310": true,
      "08311": true,
      "08312": true,
      "08313": true,
      "08314": true,
      "08315": true,
      "08316": true,
      "08317": true,
      "08318": true,
      "08319": true,
      "08320": true,
      "08321": true,
      "08322": true,
      "08323": true,
      "08324": true,
      "08325": true,
      "08326": true,
      "08327": true,
      "08328": true,
      "08329": true,
      "08330": true,
      "08331": true,
      "08332": true,
      "08333": true,
      "08334": true,
      "08335": true,
      "08336": true,
      "08337": true,
      "08338": true,
      "08339": true,
      "08340": true,
      "08341": true,
      "08342": true,
      "08343": true,
      "08344": true,
      "08345": true,
      "08346": true,
      "08347": true,
      "08348": true,
      "08349": true,
      "08350": true,
      "08351": true,
      "08352": true,
      "08353": true,
      "08354": true,
      "08355": true,
      "08356": true,
      "08357": true,
      "08358": true,
      "08359": true,
      "08360": true,
      "08361": true,
      "08362": true,
      "08363": true,
      "08364": true,
      "08365": true,
      "08366": true,
      "08367": true,
      "08368": true,
      "08369": true,
      "08370": true,
      "08371": true,
      "08372": true,
      "08373": true,
      "08374": true,
      "08375": true,
      "08376": true,
      "08377": true,
      "08378": true,
      "08379": true,
      "08380": true,
      "08381": true,
      "08382": true,
      "08383": true,
      "08384": true,
      "08385": true,
      "08386": true,
      "08387": true,
      "08388": true,
      "08389": true,
      "08390": true,
      "08391": true,
      "08392": true,
      "08393": true,
      "08394": true,
      "08395": true,
      "08396": true,
      "08397": true,
      "08398": true,
      "08399": true,
      "08400": true,
      "08401": true,
      "08402": true,
      "08403": true,
      "08404": true,
      "08405": true,
      "08406": true,
      "08407": true,
      "08408": true,
      "08409": true,
      "08410": true,
      "08411": true,
      "08412": true,
      "08413": true,
      "08414": true,
      "08415": true,
      "08416": true,
      "08417": true,
      "08418": true,
      "08419": true,
      "08420": true,
      "08421": true,
      "08422": true,
      "08423": true,
      "08424": true,
      "08425": true,
      "08426": true,
      "08427": true,
      "08428": true,
      "08429": true,
      "08430": true,
      "08431": true,
      "08432": true,
      "08433": true,
      "08434": true,
      "08435": true,
      "08436": true,
      "08437": true,
      "08438": true,
      "08439": true,
      "08440": true,
      "08441": true,
      "08442": true,
      "08443": true,
      "08444": true,
      "08445": true,
      "08446": true,
      "08447": true,
      "08448": true,
      "08449": true,
      "08450": true,
      "08451": true,
      "08452": true,
      "08453": true,
      "08454": true,
      "08455": true,
      "08456": true,
      "08457": true,
      "08458": true,
      "08459": true,
      "08460": true,
      "08461": true,
      "08462": true,
      "08463": true,
      "08464": true,
      "08465": true,
      "08466": true,
      "08467": true,
      "08468": true,
      "08469": true,
      "08470": true,
      "08471": true,
      "08472": true,
      "08473": true,
      "08474": true,
      "08475": true,
      "08476": true,
      "08477": true,
      "08478": true,
      "08479": true,
      "08480": true,
      "08481": true,
      "08482": true,
      "08483": true,
      "08484": true,
      "08485": true,
      "08486": true,
      "08487": true,
      "08488": true,
      "08489": true,
      "08490": true,
      "08491": true,
      "08492": true,
      "08493": true,
      "08494": true,
      "08495": true,
      "08496": true,
      "08497": true,
      "08498": true,
      "08499": true,
      "08500": true,
      "08501": true,
      "08502": true,
      "08503": true,
      "08504": true,
      "08505": true,
      "08506": true,
      "08507": true,
      "08508": true,
      "08509": true,
      "08510": true,
      "08511": true,
      "08512": true,
      "08513": true,
      "08514": true,
      "08515": true,
      "08516": true,
      "08517": true,
      "08518": true,
      "08519": true,
      "08520": true,
      "08521": true,
      "08522": true,
      "08523": true,
      "08524": true,
      "08525": true,
      "08526": true,
      "08527": true,
      "08528": true,
      "08529": true,
      "08530": true,
      "08531": true,
      "08532": true,
      "08533": true,
      "08534": true,
      "08535": true,
      "08536": true,
      "08537": true,
      "08538": true,
      "08539": true,
      "08540": true,
      "08541": true,
      "08542": true,
      "08543": true,
      "08544": true,
      "08545": true,
      "08546": true,
      "08547": true,
      "08548": true,
      "08549": true,
      "08550": true,
      "08551": true,
      "08552": true,
      "08553": true,
      "08554": true,
      "08555": true,
      "08556": true,
      "08557": true,
      "08558": true,
      "08559": true,
      "08560": true,
      "08561": true,
      "08562": true,
      "08563": true,
      "08564": true,
      "08565": true,
      "08566": true,
      "08567": true,
      "08568": true,
      "08569": true,
      "08570": true,
      "08571": true,
      "08572": true,
      "08573": true,
      "08574": true,
      "08575": true,
      "08576": true,
      "08577": true,
      "08578": true,
      "08579": true,
      "08580": true,
      "08581": true,
      "08582": true,
      "08583": true,
      "08584": true,
      "08585": true,
      "08586": true,
      "08587": true,
      "08588": true,
      "08589": true,
      "08590": true,
      "08591": true,
      "08592": true,
      "08593": true,
      "08594": true,
      "08595": true,
      "08596": true,
      "08597": true,
      "08598": true,
      "08599": true,
      "08600": true,
      "08601": true,
      "08602": true,
      "08603": true,
      "08604": true,
      "08605": true,
      "08606": true,
      "08607": true,
      "08608": true,
      "08609": true,
      "08610": true,
      "08611": true,
      "08612": true,
      "08613": true,
      "08614": true,
      "08615": true,
      "08616": true,
      "08617": true,
      "08618": true,
      "08619": true,
      "08620": true,
      "08621": true,
      "08622": true,
      "08623": true,
      "08624": true,
      "08625": true,
      "08626": true,
      "08627": true,
      "08628": true,
      "08629": true,
      "08630": true,
      "08631": true,
      "08632": true,
      "08633": true,
      "08634": true,
      "08635": true,
      "08636": true,
      "08637": true,
      "08638": true,
      "08639": true,
      "08640": true,
      "08641": true,
      "08642": true,
      "08643": true,
      "08644": true,
      "08645": true,
      "08646": true,
      "08647": true,
      "08648": true,
      "08649": true,
      "08650": true,
      "08651": true,
      "08652": true,
      "08653": true,
      "08654": true,
      "08655": true,
      "08656": true,
      "08657": true,
      "08658": true,
      "08659": true,
      "08660": true,
      "08661": true,
      "08662": true,
      "08663": true,
      "08664": true,
      "08665": true,
      "08666": true,
      "08667": true,
      "08668": true,
      "08669": true,
      "08670": true,
      "08671": true,
      "08672": true,
      "08673": true,
      "08674": true,
      "08675": true,
      "08676": true,
      "08677": true,
      "08678": true,
      "08679": true,
      "08680": true,
      "08681": true,
      "08682": true,
      "08683": true,
      "08684": true,
      "08685": true,
      "08686": true,
      "08687": true,
      "08688": true,
      "08689": true,
      "08690": true,
      "08691": true,
      "08692": true,
      "08693": true,
      "08694": true,
      "08695": true,
      "08696": true,
      "08697": true,
      "08698": true,
      "08699": true,
      "08700": true,
      "08701": true,
      "08702": true,
      "08703": true,
      "08704": true,
      "08705": true,
      "08706": true,
      "08707": true,
      "08708": true,
      "08709": true,
      "08710": true,
      "08711": true,
      "08712": true,
      "08713": true,
      "08714": true,
      "08715": true,
      "08716": true,
      "08717": true,
      "08718": true,
      "08719": true,
      "08720": true,
      "08721": true,
      "08722": true,
      "08723": true,
      "08724": true,
      "08725": true,
      "08726": true,
      "08727": true,
      "08728": true,
      "08729": true,
      "08730": true,
      "08731": true,
      "08732": true,
      "08733": true,
      "08734": true,
      "08735": true,
      "08736": true,
      "08737": true,
      "08738": true,
      "08739": true,
      "08740": true,
      "08741": true,
      "08742": true,
      "08743": true,
      "08744": true,
      "08745": true,
      "08746": true,
      "08747": true,
      "08748": true,
      "08749": true,
      "08750": true,
      "08751": true,
      "08752": true,
      "08753": true,
      "08754": true,
      "08755": true,
      "08756": true,
      "08757": true,
      "08758": true,
      "08759": true,
      "08760": true,
      "08761": true,
      "08762": true,
      "08763": true,
      "08764": true,
      "08765": true,
      "08766": true,
      "08767": true,
      "08768": true,
      "08769": true,
      "08770": true,
      "08771": true,
      "08772": true,
      "08773": true,
      "08774": true,
      "08775": true,
      "08776": true,
      "08777": true,
      "08778": true,
      "08779": true,
      "08780": true,
      "08781": true,
      "08782": true,
      "08783": true,
      "08784": true,
      "08785": true,
      "08786": true,
      "08787": true,
      "08788": true,
      "08789": true,
      "08790": true,
      "08791": true,
      "08792": true,
      "08793": true,
      "08794": true,
      "08795": true,
      "08796": true,
      "08797": true,
      "08798": true,
      "08799": true,
      "08800": true,
      "08801": true,
      "08802": true,
      "08803": true,
      "08804": true,
      "08805": true,
      "08806": true,
      "08807": true,
      "08808": true,
      "08809": true,
      "08810": true,
      "08811": true,
      "08812": true,
      "08813": true,
      "08814": true,
      "08815": true,
      "08816": true,
      "08817": true,
      "08818": true,
      "08819": true,
      "08820": true,
      "08821": true,
      "08822": true,
      "08823": true,
      "08824": true,
      "08825": true,
      "08826": true,
      "08827": true,
      "08828": true,
      "08829": true,
      "08830": true,
      "08831": true,
      "08832": true,
      "08833": true,
      "08834": true,
      "08835": true,
      "08836": true,
      "08837": true,
      "08838": true,
      "08839": true,
      "08840": true,
      "08841": true,
      "08842": true,
      "08843": true,
      "08844": true,
      "08845": true,
      "08846": true,
      "08847": true,
      "08848": true,
      "08849": true,
      "08850": true,
      "08851": true,
      "08852": true,
      "08853": true,
      "08854": true,
      "08855": true,
      "08856": true,
      "08857": true,
      "08858": true,
      "08859": true,
      "08860": true,
      "08861": true,
      "08862": true,
      "08863": true,
      "08864": true,
      "08865": true,
      "08866": true,
      "08867": true,
      "08868": true,
      "08869": true,
      "08870": true,
      "08871": true,
      "08872": true,
      "08873": true,
      "08874": true,
      "08875": true,
      "08876": true,
      "08877": true,
      "08878": true,
      "08879": true,
      "08880": true,
      "08881": true,
      "08882": true,
      "08883": true,
      "08884": true,
      "08885": true,
      "08886": true,
      "08887": true,
      "08888": true,
      "08889": true,
      "08890": true,
      "08891": true,
      "08892": true,
      "08893": true,
      "08894": true,
      "08895": true,
      "08896": true,
      "08897": true,
      "08898": true,
      "08899": true,
      "08900": true,
      "08901": true,
      "08902": true,
      "08903": true,
      "08904": true,
      "08905": true,
      "08906": true,
      "08907": true,
      "08908": true,
      "08909": true,
      "08910": true,
      "08911": true,
      "08912": true,
      "08913": true,
      "08914": true,
      "08915": true,
      "08916": true,
      "08917": true,
      "08918": true,
      "08919": true,
      "08920": true,
      "08921": true,
      "08922": true,
      "08923": true,
      "08924": true,
      "08925": true,
      "08926": true,
      "08927": true,
      "08928": true,
      "08929": true,
      "08930": true,
      "08931": true,
      "08932": true,
      "08933": true,
      "08934": true,
      "08935": true,
      "08936": true,
      "08937": true,
      "08938": true,
      "08939": true,
      "08940": true,
      "08941": true,
      "08942": true,
      "08943": true,
      "08944": true,
      "08945": true,
      "08946": true,
      "08947": true,
      "08948": true,
      "08949": true,
      "08950": true,
      "08951": true,
      "08952": true,
      "08953": true,
      "08954": true,
      "08955": true,
      "08956": true,
      "08957": true,
      "08958": true,
      "08959": true,
      "08960": true,
      "08961": true,
      "08962": true,
      "08963": true,
      "08964": true,
      "08965": true,
      "08966": true,
      "08967": true,
      "08968": true,
      "08969": true,
      "08970": true,
      "08971": true,
      "08972": true,
      "08973": true,
      "08974": true,
      "08975": true,
      "08976": true,
      "08977": true,
      "08978": true,
      "08979": true,
      "08980": true,
      "08981": true,
      "08982": true,
      "08983": true,
      "08984": true,
      "08985": true,
      "08986": true,
      "08987": true,
      "08988": true,
      "08989": true,
      "08990": true,
      "08991": true,
      "08992": true,
      "08993": true,
      "08994": true,
      "08995": true,
      "08996": true,
      "08997": true,
      "08998": true,
      "08999": true
    },
    "IZTAPALAPA": {
      "09000": true,
      "09010": true,
      "09020": true,
      "09030": true,
      "09040": true,
      "09060": true,
      "09070": true,
      "09080": true,
      "09089": true,
      "09090": true,
      "09099": true,
      "09100": true,
      "09130": true,
      "09140": true,
      "09150": true,
      "09160": true,
      "09170": true,
      "09180": true,
      "09200": true,
      "09207": true,
      "09208": true,
      "09209": true,
      "09210": true,
      "09219": true,
      "09220": true,
      "09226": true,
      "09227": true,
      "09228": true,
      "09229": true,
      "09230": true,
      "09233": true,
      "09239": true,
      "09240": true,
      "09250": true,
      "09260": true,
      "09270": true,
      "09280": true,
      "09290": true,
      "09300": true,
      "09310": true,
      "09319": true,
      "09320": true,
      "09350": true,
      "09359": true,
      "09360": true,
      "09400": true,
      "09410": true,
      "09420": true,
      "09429": true,
      "09430": true,
      "09437": true,
      "09438": true,
      "09440": true,
      "09450": true,
      "09460": true,
      "09470": true,
      "09479": true,
      "09480": true,
      "09500": true,
      "09510": true,
      "09520": true,
      "09530": true,
      "09550": true,
      "09560": true,
      "09570": true,
      "09578": true,
      "09600": true,
      "09608": true,
      "09609": true,
      "09620": true,
      "09630": true,
      "09637": true,
      "09638": true,
      "09640": true,
      "09648": true,
      "09660": true,
      "09670": true,
      "09680": true,
      "09689": true,
      "09690": true,
      "09696": true,
      "09698": true,
      "09700": true,
      "09704": true,
      "09705": true,
      "09706": true,
      "09708": true,
      "09709": true,
      "09710": true,
      "09720": true,
      "09730": true,
      "09740": true,
      "09750": true,
      "09760": true,
      "09768": true,
      "09769": true,
      "09770": true,
      "09779": true,
      "09780": true,
      "09789": true,
      "09790": true,
      "09800": true,
      "09810": true,
      "09819": true,
      "09820": true,
      "09828": true,
      "09829": true,
      "09830": true,
      "09837": true,
      "09838": true,
      "09839": true,
      "09840": true,
      "09849": true,
      "09850": true,
      "09856": true,
      "09858": true,
      "09859": true,
      "09860": true,
      "09868": true,
      "09870": true,
      "09880": true,
      "09890": true,
      "09897": true,
      "09900": true,
      "09910": true,
      "09920": true,
      "09930": true,
      "09940": true,
      "09960": true,
      "09969": true,
      "09970": true
    },
    "LA MAGDALENA CONTRERAS": {
      "10000": true,
      "10010": true,
      "10020": true,
      "10100": true,
      "10110": true,
      "10130": true,
      "10200": true,
      "10340": true,
      "10350": true,
      "10368": true,
      "10370": true,
      "10379": true,
      "10380": true,
      "10400": true,
      "10500": true,
      "10508": true,
      "10509": true,
      "10580": true,
      "10610": true,
      "10660": true,
      "10700": true,
      "10710": true,
      "10720": true,
      "10730": true,
      "10740": true,
      "10800": true,
      "10810": true,
      "10820": true,
      "10830": true,
      "10840": true,
      "10910": true,
      "10920": true
    },
    "MIGUEL HIDALGO": {
      "11000": true,
      "11001": true,
      "11002": true,
      "11003": true,
      "11004": true,
      "11005": true,
      "11006": true,
      "11007": true,
      "11008": true,
      "11009": true,
      "11010": true,
      "11011": true,
      "11012": true,
      "11013": true,
      "11014": true,
      "11015": true,
      "11016": true,
      "11017": true,
      "11018": true,
      "11019": true,
      "11020": true,
      "11021": true,
      "11022": true,
      "11023": true,
      "11024": true,
      "11025": true,
      "11026": true,
      "11027": true,
      "11028": true,
      "11029": true,
      "11030": true,
      "11031": true,
      "11032": true,
      "11033": true,
      "11034": true,
      "11035": true,
      "11036": true,
      "11037": true,
      "11038": true,
      "11039": true,
      "11040": true,
      "11041": true,
      "11042": true,
      "11043": true,
      "11044": true,
      "11045": true,
      "11046": true,
      "11047": true,
      "11048": true,
      "11049": true,
      "11050": true,
      "11051": true,
      "11052": true,
      "11053": true,
      "11054": true,
      "11055": true,
      "11056": true,
      "11057": true,
      "11058": true,
      "11059": true,
      "11060": true,
      "11061": true,
      "11062": true,
      "11063": true,
      "11064": true,
      "11065": true,
      "11066": true,
      "11067": true,
      "11068": true,
      "11069": true,
      "11070": true,
      "11071": true,
      "11072": true,
      "11073": true,
      "11074": true,
      "11075": true,
      "11076": true,
      "11077": true,
      "11078": true,
      "11079": true,
      "11080": true,
      "11081": true,
      "11082": true,
      "11083": true,
      "11084": true,
      "11085": true,
      "11086": true,
      "11087": true,
      "11088": true,
      "11089": true,
      "11090": true,
      "11091": true,
      "11092": true,
      "11093": true,
      "11094": true,
      "11095": true,
      "11096": true,
      "11097": true,
      "11098": true,
      "11099": true,
      "11100": true,
      "11101": true,
      "11102": true,
      "11103": true,
      "11104": true,
      "11105": true,
      "11106": true,
      "11107": true,
      "11108": true,
      "11109": true,
      "11110": true,
      "11111": true,
      "11112": true,
      "11113": true,
      "11114": true,
      "11115": true,
      "11116": true,
      "11117": true,
      "11118": true,
      "11119": true,
      "11120": true,
      "11121": true,
      "11122": true,
      "11123": true,
      "11124": true,
      "11125": true,
      "11126": true,
      "11127": true,
      "11128": true,
      "11129": true,
      "11130": true,
      "11131": true,
      "11132": true,
      "11133": true,
      "11134": true,
      "11135": true,
      "11136": true,
      "11137": true,
      "11138": true,
      "11139": true,
      "11140": true,
      "11141": true,
      "11142": true,
      "11143": true,
      "11144": true,
      "11145": true,
      "11146": true,
      "11147": true,
      "11148": true,
      "11149": true,
      "11150": true,
      "11151": true,
      "11152": true,
      "11153": true,
      "11154": true,
      "11155": true,
      "11156": true,
      "11157": true,
      "11158": true,
      "11159": true,
      "11160": true,
      "11161": true,
      "11162": true,
      "11163": true,
      "11164": true,
      "11165": true,
      "11166": true,
      "11167": true,
      "11168": true,
      "11169": true,
      "11170": true,
      "11171": true,
      "11172": true,
      "11173": true,
      "11174": true,
      "11175": true,
      "11176": true,
      "11177": true,
      "11178": true,
      "11179": true,
      "11180": true,
      "11181": true,
      "11182": true,
      "11183": true,
      "11184": true,
      "11185": true,
      "11186": true,
      "11187": true,
      "11188": true,
      "11189": true,
      "11190": true,
      "11191": true,
      "11192": true,
      "11193": true,
      "11194": true,
      "11195": true,
      "11196": true,
      "11197": true,
      "11198": true,
      "11199": true,
      "11200": true,
      "11201": true,
      "11202": true,
      "11203": true,
      "11204": true,
      "11205": true,
      "11206": true,
      "11207": true,
      "11208": true,
      "11209": true,
      "11210": true,
      "11211": true,
      "11212": true,
      "11213": true,
      "11214": true,
      "11215": true,
      "11216": true,
      "11217": true,
      "11218": true,
      "11219": true,
      "11220": true,
      "11221": true,
      "11222": true,
      "11223": true,
      "11224": true,
      "11225": true,
      "11226": true,
      "11227": true,
      "11228": true,
      "11229": true,
      "11230": true,
      "11231": true,
      "11232": true,
      "11233": true,
      "11234": true,
      "11235": true,
      "11236": true,
      "11237": true,
      "11238": true,
      "11239": true,
      "11240": true,
      "11241": true,
      "11242": true,
      "11243": true,
      "11244": true,
      "11245": true,
      "11246": true,
      "11247": true,
      "11248": true,
      "11249": true,
      "11250": true,
      "11251": true,
      "11252": true,
      "11253": true,
      "11254": true,
      "11255": true,
      "11256": true,
      "11257": true,
      "11258": true,
      "11259": true,
      "11260": true,
      "11261": true,
      "11262": true,
      "11263": true,
      "11264": true,
      "11265": true,
      "11266": true,
      "11267": true,
      "11268": true,
      "11269": true,
      "11270": true,
      "11271": true,
      "11272": true,
      "11273": true,
      "11274": true,
      "11275": true,
      "11276": true,
      "11277": true,
      "11278": true,
      "11279": true,
      "11280": true,
      "11281": true,
      "11282": true,
      "11283": true,
      "11284": true,
      "11285": true,
      "11286": true,
      "11287": true,
      "11288": true,
      "11289": true,
      "11290": true,
      "11291": true,
      "11292": true,
      "11293": true,
      "11294": true,
      "11295": true,
      "11296": true,
      "11297": true,
      "11298": true,
      "11299": true,
      "11300": true,
      "11301": true,
      "11302": true,
      "11303": true,
      "11304": true,
      "11305": true,
      "11306": true,
      "11307": true,
      "11308": true,
      "11309": true,
      "11310": true,
      "11311": true,
      "11312": true,
      "11313": true,
      "11314": true,
      "11315": true,
      "11316": true,
      "11317": true,
      "11318": true,
      "11319": true,
      "11320": true,
      "11321": true,
      "11322": true,
      "11323": true,
      "11324": true,
      "11325": true,
      "11326": true,
      "11327": true,
      "11328": true,
      "11329": true,
      "11330": true,
      "11331": true,
      "11332": true,
      "11333": true,
      "11334": true,
      "11335": true,
      "11336": true,
      "11337": true,
      "11338": true,
      "11339": true,
      "11340": true,
      "11341": true,
      "11342": true,
      "11343": true,
      "11344": true,
      "11345": true,
      "11346": true,
      "11347": true,
      "11348": true,
      "11349": true,
      "11350": true,
      "11351": true,
      "11352": true,
      "11353": true,
      "11354": true,
      "11355": true,
      "11356": true,
      "11357": true,
      "11358": true,
      "11359": true,
      "11360": true,
      "11361": true,
      "11362": true,
      "11363": true,
      "11364": true,
      "11365": true,
      "11366": true,
      "11367": true,
      "11368": true,
      "11369": true,
      "11370": true,
      "11371": true,
      "11372": true,
      "11373": true,
      "11374": true,
      "11375": true,
      "11376": true,
      "11377": true,
      "11378": true,
      "11379": true,
      "11380": true,
      "11381": true,
      "11382": true,
      "11383": true,
      "11384": true,
      "11385": true,
      "11386": true,
      "11387": true,
      "11388": true,
      "11389": true,
      "11390": true,
      "11391": true,
      "11392": true,
      "11393": true,
      "11394": true,
      "11395": true,
      "11396": true,
      "11397": true,
      "11398": true,
      "11399": true,
      "11400": true,
      "11401": true,
      "11402": true,
      "11403": true,
      "11404": true,
      "11405": true,
      "11406": true,
      "11407": true,
      "11408": true,
      "11409": true,
      "11410": true,
      "11411": true,
      "11412": true,
      "11413": true,
      "11414": true,
      "11415": true,
      "11416": true,
      "11417": true,
      "11418": true,
      "11419": true,
      "11420": true,
      "11421": true,
      "11422": true,
      "11423": true,
      "11424": true,
      "11425": true,
      "11426": true,
      "11427": true,
      "11428": true,
      "11429": true,
      "11430": true,
      "11431": true,
      "11432": true,
      "11433": true,
      "11434": true,
      "11435": true,
      "11436": true,
      "11437": true,
      "11438": true,
      "11439": true,
      "11440": true,
      "11441": true,
      "11442": true,
      "11443": true,
      "11444": true,
      "11445": true,
      "11446": true,
      "11447": true,
      "11448": true,
      "11449": true,
      "11450": true,
      "11451": true,
      "11452": true,
      "11453": true,
      "11454": true,
      "11455": true,
      "11456": true,
      "11457": true,
      "11458": true,
      "11459": true,
      "11460": true,
      "11461": true,
      "11462": true,
      "11463": true,
      "11464": true,
      "11465": true,
      "11466": true,
      "11467": true,
      "11468": true,
      "11469": true,
      "11470": true,
      "11471": true,
      "11472": true,
      "11473": true,
      "11474": true,
      "11475": true,
      "11476": true,
      "11477": true,
      "11478": true,
      "11479": true,
      "11480": true,
      "11481": true,
      "11482": true,
      "11483": true,
      "11484": true,
      "11485": true,
      "11486": true,
      "11487": true,
      "11488": true,
      "11489": true,
      "11490": true,
      "11491": true,
      "11492": true,
      "11493": true,
      "11494": true,
      "11495": true,
      "11496": true,
      "11497": true,
      "11498": true,
      "11499": true,
      "11500": true,
      "11501": true,
      "11502": true,
      "11503": true,
      "11504": true,
      "11505": true,
      "11506": true,
      "11507": true,
      "11508": true,
      "11509": true,
      "11510": true,
      "11511": true,
      "11512": true,
      "11513": true,
      "11514": true,
      "11515": true,
      "11516": true,
      "11517": true,
      "11518": true,
      "11519": true,
      "11520": true,
      "11521": true,
      "11522": true,
      "11523": true,
      "11524": true,
      "11525": true,
      "11526": true,
      "11527": true,
      "11528": true,
      "11529": true,
      "11530": true,
      "11531": true,
      "11532": true,
      "11533": true,
      "11534": true,
      "11535": true,
      "11536": true,
      "11537": true,
      "11538": true,
      "11539": true,
      "11540": true,
      "11541": true,
      "11542": true,
      "11543": true,
      "11544": true,
      "11545": true,
      "11546": true,
      "11547": true,
      "11548": true,
      "11549": true,
      "11550": true,
      "11551": true,
      "11552": true,
      "11553": true,
      "11554": true,
      "11555": true,
      "11556": true,
      "11557": true,
      "11558": true,
      "11559": true,
      "11560": true,
      "11561": true,
      "11562": true,
      "11563": true,
      "11564": true,
      "11565": true,
      "11566": true,
      "11567": true,
      "11568": true,
      "11569": true,
      "11570": true,
      "11571": true,
      "11572": true,
      "11573": true,
      "11574": true,
      "11575": true,
      "11576": true,
      "11577": true,
      "11578": true,
      "11579": true,
      "11580": true,
      "11581": true,
      "11582": true,
      "11583": true,
      "11584": true,
      "11585": true,
      "11586": true,
      "11587": true,
      "11588": true,
      "11589": true,
      "11590": true,
      "11591": true,
      "11592": true,
      "11593": true,
      "11594": true,
      "11595": true,
      "11596": true,
      "11597": true,
      "11598": true,
      "11599": true,
      "11600": true,
      "11601": true,
      "11602": true,
      "11603": true,
      "11604": true,
      "11605": true,
      "11606": true,
      "11607": true,
      "11608": true,
      "11609": true,
      "11610": true,
      "11611": true,
      "11612": true,
      "11613": true,
      "11614": true,
      "11615": true,
      "11616": true,
      "11617": true,
      "11618": true,
      "11619": true,
      "11620": true,
      "11621": true,
      "11622": true,
      "11623": true,
      "11624": true,
      "11625": true,
      "11626": true,
      "11627": true,
      "11628": true,
      "11629": true,
      "11630": true,
      "11631": true,
      "11632": true,
      "11633": true,
      "11634": true,
      "11635": true,
      "11636": true,
      "11637": true,
      "11638": true,
      "11639": true,
      "11640": true,
      "11641": true,
      "11642": true,
      "11643": true,
      "11644": true,
      "11645": true,
      "11646": true,
      "11647": true,
      "11648": true,
      "11649": true,
      "11650": true,
      "11651": true,
      "11652": true,
      "11653": true,
      "11654": true,
      "11655": true,
      "11656": true,
      "11657": true,
      "11658": true,
      "11659": true,
      "11660": true,
      "11661": true,
      "11662": true,
      "11663": true,
      "11664": true,
      "11665": true,
      "11666": true,
      "11667": true,
      "11668": true,
      "11669": true,
      "11670": true,
      "11671": true,
      "11672": true,
      "11673": true,
      "11674": true,
      "11675": true,
      "11676": true,
      "11677": true,
      "11678": true,
      "11679": true,
      "11680": true,
      "11681": true,
      "11682": true,
      "11683": true,
      "11684": true,
      "11685": true,
      "11686": true,
      "11687": true,
      "11688": true,
      "11689": true,
      "11690": true,
      "11691": true,
      "11692": true,
      "11693": true,
      "11694": true,
      "11695": true,
      "11696": true,
      "11697": true,
      "11698": true,
      "11699": true,
      "11700": true,
      "11701": true,
      "11702": true,
      "11703": true,
      "11704": true,
      "11705": true,
      "11706": true,
      "11707": true,
      "11708": true,
      "11709": true,
      "11710": true,
      "11711": true,
      "11712": true,
      "11713": true,
      "11714": true,
      "11715": true,
      "11716": true,
      "11717": true,
      "11718": true,
      "11719": true,
      "11720": true,
      "11721": true,
      "11722": true,
      "11723": true,
      "11724": true,
      "11725": true,
      "11726": true,
      "11727": true,
      "11728": true,
      "11729": true,
      "11730": true,
      "11731": true,
      "11732": true,
      "11733": true,
      "11734": true,
      "11735": true,
      "11736": true,
      "11737": true,
      "11738": true,
      "11739": true,
      "11740": true,
      "11741": true,
      "11742": true,
      "11743": true,
      "11744": true,
      "11745": true,
      "11746": true,
      "11747": true,
      "11748": true,
      "11749": true,
      "11750": true,
      "11751": true,
      "11752": true,
      "11753": true,
      "11754": true,
      "11755": true,
      "11756": true,
      "11757": true,
      "11758": true,
      "11759": true,
      "11760": true,
      "11761": true,
      "11762": true,
      "11763": true,
      "11764": true,
      "11765": true,
      "11766": true,
      "11767": true,
      "11768": true,
      "11769": true,
      "11770": true,
      "11771": true,
      "11772": true,
      "11773": true,
      "11774": true,
      "11775": true,
      "11776": true,
      "11777": true,
      "11778": true,
      "11779": true,
      "11780": true,
      "11781": true,
      "11782": true,
      "11783": true,
      "11784": true,
      "11785": true,
      "11786": true,
      "11787": true,
      "11788": true,
      "11789": true,
      "11790": true,
      "11791": true,
      "11792": true,
      "11793": true,
      "11794": true,
      "11795": true,
      "11796": true,
      "11797": true,
      "11798": true,
      "11799": true,
      "11800": true,
      "11801": true,
      "11802": true,
      "11803": true,
      "11804": true,
      "11805": true,
      "11806": true,
      "11807": true,
      "11808": true,
      "11809": true,
      "11810": true,
      "11811": true,
      "11812": true,
      "11813": true,
      "11814": true,
      "11815": true,
      "11816": true,
      "11817": true,
      "11818": true,
      "11819": true,
      "11820": true,
      "11821": true,
      "11822": true,
      "11823": true,
      "11824": true,
      "11825": true,
      "11826": true,
      "11827": true,
      "11828": true,
      "11829": true,
      "11830": true,
      "11831": true,
      "11832": true,
      "11833": true,
      "11834": true,
      "11835": true,
      "11836": true,
      "11837": true,
      "11838": true,
      "11839": true,
      "11840": true,
      "11841": true,
      "11842": true,
      "11843": true,
      "11844": true,
      "11845": true,
      "11846": true,
      "11847": true,
      "11848": true,
      "11849": true,
      "11850": true,
      "11851": true,
      "11852": true,
      "11853": true,
      "11854": true,
      "11855": true,
      "11856": true,
      "11857": true,
      "11858": true,
      "11859": true,
      "11860": true,
      "11861": true,
      "11862": true,
      "11863": true,
      "11864": true,
      "11865": true,
      "11866": true,
      "11867": true,
      "11868": true,
      "11869": true,
      "11870": true,
      "11871": true,
      "11872": true,
      "11873": true,
      "11874": true,
      "11875": true,
      "11876": true,
      "11877": true,
      "11878": true,
      "11879": true,
      "11880": true,
      "11881": true,
      "11882": true,
      "11883": true,
      "11884": true,
      "11885": true,
      "11886": true,
      "11887": true,
      "11888": true,
      "11889": true,
      "11890": true,
      "11891": true,
      "11892": true,
      "11893": true,
      "11894": true,
      "11895": true,
      "11896": true,
      "11897": true,
      "11898": true,
      "11899": true,
      "11900": true,
      "11901": true,
      "11902": true,
      "11903": true,
      "11904": true,
      "11905": true,
      "11906": true,
      "11907": true,
      "11908": true,
      "11909": true,
      "11910": true,
      "11911": true,
      "11912": true,
      "11913": true,
      "11914": true,
      "11915": true,
      "11916": true,
      "11917": true,
      "11918": true,
      "11919": true,
      "11920": true,
      "11921": true,
      "11922": true,
      "11923": true,
      "11924": true,
      "11925": true,
      "11926": true,
      "11927": true,
      "11928": true,
      "11929": true,
      "11930": true,
      "11931": true,
      "11932": true,
      "11933": true,
      "11934": true,
      "11935": true,
      "11936": true,
      "11937": true,
      "11938": true,
      "11939": true,
      "11940": true,
      "11941": true,
      "11942": true,
      "11943": true,
      "11944": true,
      "11945": true,
      "11946": true,
      "11947": true,
      "11948": true,
      "11949": true,
      "11950": true,
      "11951": true,
      "11952": true,
      "11953": true,
      "11954": true,
      "11955": true,
      "11956": true,
      "11957": true,
      "11958": true,
      "11959": true,
      "11960": true,
      "11961": true,
      "11962": true,
      "11963": true,
      "11964": true,
      "11965": true,
      "11966": true,
      "11967": true,
      "11968": true,
      "11969": true,
      "11970": true,
      "11971": true,
      "11972": true,
      "11973": true,
      "11974": true,
      "11975": true,
      "11976": true,
      "11977": true,
      "11978": true,
      "11979": true,
      "11980": true,
      "11981": true,
      "11982": true,
      "11983": true,
      "11984": true,
      "11985": true,
      "11986": true,
      "11987": true,
      "11988": true,
      "11989": true,
      "11990": true,
      "11991": true,
      "11992": true,
      "11993": true,
      "11994": true,
      "11995": true,
      "11996": true,
      "11997": true,
      "11998": true,
      "11999": true
    },
    "MILPA ALTA": {
      "12000": true,
      "12001": true,
      "12002": true,
      "12003": true,
      "12004": true,
      "12005": true,
      "12006": true,
      "12007": true,
      "12008": true,
      "12009": true,
      "12010": true,
      "12011": true,
      "12012": true,
      "12013": true,
      "12014": true,
      "12015": true,
      "12016": true,
      "12017": true,
      "12018": true,
      "12019": true,
      "12020": true,
      "12021": true,
      "12022": true,
      "12023": true,
      "12024": true,
      "12025": true,
      "12026": true,
      "12027": true,
      "12028": true,
      "12029": true,
      "12030": true,
      "12031": true,
      "12032": true,
      "12033": true,
      "12034": true,
      "12035": true,
      "12036": true,
      "12037": true,
      "12038": true,
      "12039": true,
      "12040": true,
      "12041": true,
      "12042": true,
      "12043": true,
      "12044": true,
      "12045": true,
      "12046": true,
      "12047": true,
      "12048": true,
      "12049": true,
      "12050": true,
      "12051": true,
      "12052": true,
      "12053": true,
      "12054": true,
      "12055": true,
      "12056": true,
      "12057": true,
      "12058": true,
      "12059": true,
      "12060": true,
      "12061": true,
      "12062": true,
      "12063": true,
      "12064": true,
      "12065": true,
      "12066": true,
      "12067": true,
      "12068": true,
      "12069": true,
      "12070": true,
      "12071": true,
      "12072": true,
      "12073": true,
      "12074": true,
      "12075": true,
      "12076": true,
      "12077": true,
      "12078": true,
      "12079": true,
      "12080": true,
      "12081": true,
      "12082": true,
      "12083": true,
      "12084": true,
      "12085": true,
      "12086": true,
      "12087": true,
      "12088": true,
      "12089": true,
      "12090": true,
      "12091": true,
      "12092": true,
      "12093": true,
      "12094": true,
      "12095": true,
      "12096": true,
      "12097": true,
      "12098": true,
      "12099": true,
      "12100": true,
      "12101": true,
      "12102": true,
      "12103": true,
      "12104": true,
      "12105": true,
      "12106": true,
      "12107": true,
      "12108": true,
      "12109": true,
      "12110": true,
      "12111": true,
      "12112": true,
      "12113": true,
      "12114": true,
      "12115": true,
      "12116": true,
      "12117": true,
      "12118": true,
      "12119": true,
      "12120": true,
      "12121": true,
      "12122": true,
      "12123": true,
      "12124": true,
      "12125": true,
      "12126": true,
      "12127": true,
      "12128": true,
      "12129": true,
      "12130": true,
      "12131": true,
      "12132": true,
      "12133": true,
      "12134": true,
      "12135": true,
      "12136": true,
      "12137": true,
      "12138": true,
      "12139": true,
      "12140": true,
      "12141": true,
      "12142": true,
      "12143": true,
      "12144": true,
      "12145": true,
      "12146": true,
      "12147": true,
      "12148": true,
      "12149": true,
      "12150": true,
      "12151": true,
      "12152": true,
      "12153": true,
      "12154": true,
      "12155": true,
      "12156": true,
      "12157": true,
      "12158": true,
      "12159": true,
      "12160": true,
      "12161": true,
      "12162": true,
      "12163": true,
      "12164": true,
      "12165": true,
      "12166": true,
      "12167": true,
      "12168": true,
      "12169": true,
      "12170": true,
      "12171": true,
      "12172": true,
      "12173": true,
      "12174": true,
      "12175": true,
      "12176": true,
      "12177": true,
      "12178": true,
      "12179": true,
      "12180": true,
      "12181": true,
      "12182": true,
      "12183": true,
      "12184": true,
      "12185": true,
      "12186": true,
      "12187": true,
      "12188": true,
      "12189": true,
      "12190": true,
      "12191": true,
      "12192": true,
      "12193": true,
      "12194": true,
      "12195": true,
      "12196": true,
      "12197": true,
      "12198": true,
      "12199": true,
      "12200": true,
      "12201": true,
      "12202": true,
      "12203": true,
      "12204": true,
      "12205": true,
      "12206": true,
      "12207": true,
      "12208": true,
      "12209": true,
      "12210": true,
      "12211": true,
      "12212": true,
      "12213": true,
      "12214": true,
      "12215": true,
      "12216": true,
      "12217": true,
      "12218": true,
      "12219": true,
      "12220": true,
      "12221": true,
      "12222": true,
      "12223": true,
      "12224": true,
      "12225": true,
      "12226": true,
      "12227": true,
      "12228": true,
      "12229": true,
      "12230": true,
      "12231": true,
      "12232": true,
      "12233": true,
      "12234": true,
      "12235": true,
      "12236": true,
      "12237": true,
      "12238": true,
      "12239": true,
      "12240": true,
      "12241": true,
      "12242": true,
      "12243": true,
      "12244": true,
      "12245": true,
      "12246": true,
      "12247": true,
      "12248": true,
      "12249": true,
      "12250": true,
      "12251": true,
      "12252": true,
      "12253": true,
      "12254": true,
      "12255": true,
      "12256": true,
      "12257": true,
      "12258": true,
      "12259": true,
      "12260": true,
      "12261": true,
      "12262": true,
      "12263": true,
      "12264": true,
      "12265": true,
      "12266": true,
      "12267": true,
      "12268": true,
      "12269": true,
      "12270": true,
      "12271": true,
      "12272": true,
      "12273": true,
      "12274": true,
      "12275": true,
      "12276": true,
      "12277": true,
      "12278": true,
      "12279": true,
      "12280": true,
      "12281": true,
      "12282": true,
      "12283": true,
      "12284": true,
      "12285": true,
      "12286": true,
      "12287": true,
      "12288": true,
      "12289": true,
      "12290": true,
      "12291": true,
      "12292": true,
      "12293": true,
      "12294": true,
      "12295": true,
      "12296": true,
      "12297": true,
      "12298": true,
      "12299": true,
      "12300": true,
      "12301": true,
      "12302": true,
      "12303": true,
      "12304": true,
      "12305": true,
      "12306": true,
      "12307": true,
      "12308": true,
      "12309": true,
      "12310": true,
      "12311": true,
      "12312": true,
      "12313": true,
      "12314": true,
      "12315": true,
      "12316": true,
      "12317": true,
      "12318": true,
      "12319": true,
      "12320": true,
      "12321": true,
      "12322": true,
      "12323": true,
      "12324": true,
      "12325": true,
      "12326": true,
      "12327": true,
      "12328": true,
      "12329": true,
      "12330": true,
      "12331": true,
      "12332": true,
      "12333": true,
      "12334": true,
      "12335": true,
      "12336": true,
      "12337": true,
      "12338": true,
      "12339": true,
      "12340": true,
      "12341": true,
      "12342": true,
      "12343": true,
      "12344": true,
      "12345": true,
      "12346": true,
      "12347": true,
      "12348": true,
      "12349": true,
      "12350": true,
      "12351": true,
      "12352": true,
      "12353": true,
      "12354": true,
      "12355": true,
      "12356": true,
      "12357": true,
      "12358": true,
      "12359": true,
      "12360": true,
      "12361": true,
      "12362": true,
      "12363": true,
      "12364": true,
      "12365": true,
      "12366": true,
      "12367": true,
      "12368": true,
      "12369": true,
      "12370": true,
      "12371": true,
      "12372": true,
      "12373": true,
      "12374": true,
      "12375": true,
      "12376": true,
      "12377": true,
      "12378": true,
      "12379": true,
      "12380": true,
      "12381": true,
      "12382": true,
      "12383": true,
      "12384": true,
      "12385": true,
      "12386": true,
      "12387": true,
      "12388": true,
      "12389": true,
      "12390": true,
      "12391": true,
      "12392": true,
      "12393": true,
      "12394": true,
      "12395": true,
      "12396": true,
      "12397": true,
      "12398": true,
      "12399": true,
      "12400": true,
      "12401": true,
      "12402": true,
      "12403": true,
      "12404": true,
      "12405": true,
      "12406": true,
      "12407": true,
      "12408": true,
      "12409": true,
      "12410": true,
      "12411": true,
      "12412": true,
      "12413": true,
      "12414": true,
      "12415": true,
      "12416": true,
      "12417": true,
      "12418": true,
      "12419": true,
      "12420": true,
      "12421": true,
      "12422": true,
      "12423": true,
      "12424": true,
      "12425": true,
      "12426": true,
      "12427": true,
      "12428": true,
      "12429": true,
      "12430": true,
      "12431": true,
      "12432": true,
      "12433": true,
      "12434": true,
      "12435": true,
      "12436": true,
      "12437": true,
      "12438": true,
      "12439": true,
      "12440": true,
      "12441": true,
      "12442": true,
      "12443": true,
      "12444": true,
      "12445": true,
      "12446": true,
      "12447": true,
      "12448": true,
      "12449": true,
      "12450": true,
      "12451": true,
      "12452": true,
      "12453": true,
      "12454": true,
      "12455": true,
      "12456": true,
      "12457": true,
      "12458": true,
      "12459": true,
      "12460": true,
      "12461": true,
      "12462": true,
      "12463": true,
      "12464": true,
      "12465": true,
      "12466": true,
      "12467": true,
      "12468": true,
      "12469": true,
      "12470": true,
      "12471": true,
      "12472": true,
      "12473": true,
      "12474": true,
      "12475": true,
      "12476": true,
      "12477": true,
      "12478": true,
      "12479": true,
      "12480": true,
      "12481": true,
      "12482": true,
      "12483": true,
      "12484": true,
      "12485": true,
      "12486": true,
      "12487": true,
      "12488": true,
      "12489": true,
      "12490": true,
      "12491": true,
      "12492": true,
      "12493": true,
      "12494": true,
      "12495": true,
      "12496": true,
      "12497": true,
      "12498": true,
      "12499": true,
      "12500": true,
      "12501": true,
      "12502": true,
      "12503": true,
      "12504": true,
      "12505": true,
      "12506": true,
      "12507": true,
      "12508": true,
      "12509": true,
      "12510": true,
      "12511": true,
      "12512": true,
      "12513": true,
      "12514": true,
      "12515": true,
      "12516": true,
      "12517": true,
      "12518": true,
      "12519": true,
      "12520": true,
      "12521": true,
      "12522": true,
      "12523": true,
      "12524": true,
      "12525": true,
      "12526": true,
      "12527": true,
      "12528": true,
      "12529": true,
      "12530": true,
      "12531": true,
      "12532": true,
      "12533": true,
      "12534": true,
      "12535": true,
      "12536": true,
      "12537": true,
      "12538": true,
      "12539": true,
      "12540": true,
      "12541": true,
      "12542": true,
      "12543": true,
      "12544": true,
      "12545": true,
      "12546": true,
      "12547": true,
      "12548": true,
      "12549": true,
      "12550": true,
      "12551": true,
      "12552": true,
      "12553": true,
      "12554": true,
      "12555": true,
      "12556": true,
      "12557": true,
      "12558": true,
      "12559": true,
      "12560": true,
      "12561": true,
      "12562": true,
      "12563": true,
      "12564": true,
      "12565": true,
      "12566": true,
      "12567": true,
      "12568": true,
      "12569": true,
      "12570": true,
      "12571": true,
      "12572": true,
      "12573": true,
      "12574": true,
      "12575": true,
      "12576": true,
      "12577": true,
      "12578": true,
      "12579": true,
      "12580": true,
      "12581": true,
      "12582": true,
      "12583": true,
      "12584": true,
      "12585": true,
      "12586": true,
      "12587": true,
      "12588": true,
      "12589": true,
      "12590": true,
      "12591": true,
      "12592": true,
      "12593": true,
      "12594": true,
      "12595": true,
      "12596": true,
      "12597": true,
      "12598": true,
      "12599": true,
      "12600": true,
      "12601": true,
      "12602": true,
      "12603": true,
      "12604": true,
      "12605": true,
      "12606": true,
      "12607": true,
      "12608": true,
      "12609": true,
      "12610": true,
      "12611": true,
      "12612": true,
      "12613": true,
      "12614": true,
      "12615": true,
      "12616": true,
      "12617": true,
      "12618": true,
      "12619": true,
      "12620": true,
      "12621": true,
      "12622": true,
      "12623": true,
      "12624": true,
      "12625": true,
      "12626": true,
      "12627": true,
      "12628": true,
      "12629": true,
      "12630": true,
      "12631": true,
      "12632": true,
      "12633": true,
      "12634": true,
      "12635": true,
      "12636": true,
      "12637": true,
      "12638": true,
      "12639": true,
      "12640": true,
      "12641": true,
      "12642": true,
      "12643": true,
      "12644": true,
      "12645": true,
      "12646": true,
      "12647": true,
      "12648": true,
      "12649": true,
      "12650": true,
      "12651": true,
      "12652": true,
      "12653": true,
      "12654": true,
      "12655": true,
      "12656": true,
      "12657": true,
      "12658": true,
      "12659": true,
      "12660": true,
      "12661": true,
      "12662": true,
      "12663": true,
      "12664": true,
      "12665": true,
      "12666": true,
      "12667": true,
      "12668": true,
      "12669": true,
      "12670": true,
      "12671": true,
      "12672": true,
      "12673": true,
      "12674": true,
      "12675": true,
      "12676": true,
      "12677": true,
      "12678": true,
      "12679": true,
      "12680": true,
      "12681": true,
      "12682": true,
      "12683": true,
      "12684": true,
      "12685": true,
      "12686": true,
      "12687": true,
      "12688": true,
      "12689": true,
      "12690": true,
      "12691": true,
      "12692": true,
      "12693": true,
      "12694": true,
      "12695": true,
      "12696": true,
      "12697": true,
      "12698": true,
      "12699": true,
      "12700": true,
      "12701": true,
      "12702": true,
      "12703": true,
      "12704": true,
      "12705": true,
      "12706": true,
      "12707": true,
      "12708": true,
      "12709": true,
      "12710": true,
      "12711": true,
      "12712": true,
      "12713": true,
      "12714": true,
      "12715": true,
      "12716": true,
      "12717": true,
      "12718": true,
      "12719": true,
      "12720": true,
      "12721": true,
      "12722": true,
      "12723": true,
      "12724": true,
      "12725": true,
      "12726": true,
      "12727": true,
      "12728": true,
      "12729": true,
      "12730": true,
      "12731": true,
      "12732": true,
      "12733": true,
      "12734": true,
      "12735": true,
      "12736": true,
      "12737": true,
      "12738": true,
      "12739": true,
      "12740": true,
      "12741": true,
      "12742": true,
      "12743": true,
      "12744": true,
      "12745": true,
      "12746": true,
      "12747": true,
      "12748": true,
      "12749": true,
      "12750": true,
      "12751": true,
      "12752": true,
      "12753": true,
      "12754": true,
      "12755": true,
      "12756": true,
      "12757": true,
      "12758": true,
      "12759": true,
      "12760": true,
      "12761": true,
      "12762": true,
      "12763": true,
      "12764": true,
      "12765": true,
      "12766": true,
      "12767": true,
      "12768": true,
      "12769": true,
      "12770": true,
      "12771": true,
      "12772": true,
      "12773": true,
      "12774": true,
      "12775": true,
      "12776": true,
      "12777": true,
      "12778": true,
      "12779": true,
      "12780": true,
      "12781": true,
      "12782": true,
      "12783": true,
      "12784": true,
      "12785": true,
      "12786": true,
      "12787": true,
      "12788": true,
      "12789": true,
      "12790": true,
      "12791": true,
      "12792": true,
      "12793": true,
      "12794": true,
      "12795": true,
      "12796": true,
      "12797": true,
      "12798": true,
      "12799": true,
      "12800": true,
      "12801": true,
      "12802": true,
      "12803": true,
      "12804": true,
      "12805": true,
      "12806": true,
      "12807": true,
      "12808": true,
      "12809": true,
      "12810": true,
      "12811": true,
      "12812": true,
      "12813": true,
      "12814": true,
      "12815": true,
      "12816": true,
      "12817": true,
      "12818": true,
      "12819": true,
      "12820": true,
      "12821": true,
      "12822": true,
      "12823": true,
      "12824": true,
      "12825": true,
      "12826": true,
      "12827": true,
      "12828": true,
      "12829": true,
      "12830": true,
      "12831": true,
      "12832": true,
      "12833": true,
      "12834": true,
      "12835": true,
      "12836": true,
      "12837": true,
      "12838": true,
      "12839": true,
      "12840": true,
      "12841": true,
      "12842": true,
      "12843": true,
      "12844": true,
      "12845": true,
      "12846": true,
      "12847": true,
      "12848": true,
      "12849": true,
      "12850": true,
      "12851": true,
      "12852": true,
      "12853": true,
      "12854": true,
      "12855": true,
      "12856": true,
      "12857": true,
      "12858": true,
      "12859": true,
      "12860": true,
      "12861": true,
      "12862": true,
      "12863": true,
      "12864": true,
      "12865": true,
      "12866": true,
      "12867": true,
      "12868": true,
      "12869": true,
      "12870": true,
      "12871": true,
      "12872": true,
      "12873": true,
      "12874": true,
      "12875": true,
      "12876": true,
      "12877": true,
      "12878": true,
      "12879": true,
      "12880": true,
      "12881": true,
      "12882": true,
      "12883": true,
      "12884": true,
      "12885": true,
      "12886": true,
      "12887": true,
      "12888": true,
      "12889": true,
      "12890": true,
      "12891": true,
      "12892": true,
      "12893": true,
      "12894": true,
      "12895": true,
      "12896": true,
      "12897": true,
      "12898": true,
      "12899": true,
      "12900": true,
      "12901": true,
      "12902": true,
      "12903": true,
      "12904": true,
      "12905": true,
      "12906": true,
      "12907": true,
      "12908": true,
      "12909": true,
      "12910": true,
      "12911": true,
      "12912": true,
      "12913": true,
      "12914": true,
      "12915": true,
      "12916": true,
      "12917": true,
      "12918": true,
      "12919": true,
      "12920": true,
      "12921": true,
      "12922": true,
      "12923": true,
      "12924": true,
      "12925": true,
      "12926": true,
      "12927": true,
      "12928": true,
      "12929": true,
      "12930": true,
      "12931": true,
      "12932": true,
      "12933": true,
      "12934": true,
      "12935": true,
      "12936": true,
      "12937": true,
      "12938": true,
      "12939": true,
      "12940": true,
      "12941": true,
      "12942": true,
      "12943": true,
      "12944": true,
      "12945": true,
      "12946": true,
      "12947": true,
      "12948": true,
      "12949": true,
      "12950": true,
      "12951": true,
      "12952": true,
      "12953": true,
      "12954": true,
      "12955": true,
      "12956": true,
      "12957": true,
      "12958": true,
      "12959": true,
      "12960": true,
      "12961": true,
      "12962": true,
      "12963": true,
      "12964": true,
      "12965": true,
      "12966": true,
      "12967": true,
      "12968": true,
      "12969": true,
      "12970": true,
      "12971": true,
      "12972": true,
      "12973": true,
      "12974": true,
      "12975": true,
      "12976": true,
      "12977": true,
      "12978": true,
      "12979": true,
      "12980": true,
      "12981": true,
      "12982": true,
      "12983": true,
      "12984": true,
      "12985": true,
      "12986": true,
      "12987": true,
      "12988": true,
      "12989": true,
      "12990": true,
      "12991": true,
      "12992": true,
      "12993": true,
      "12994": true,
      "12995": true,
      "12996": true,
      "12997": true,
      "12998": true,
      "12999": true
    },
    "TLÁHUAC": {
      "13000": true,
      "13001": true,
      "13002": true,
      "13003": true,
      "13004": true,
      "13005": true,
      "13006": true,
      "13007": true,
      "13008": true,
      "13009": true,
      "13010": true,
      "13011": true,
      "13012": true,
      "13013": true,
      "13014": true,
      "13015": true,
      "13016": true,
      "13017": true,
      "13018": true,
      "13019": true,
      "13020": true,
      "13021": true,
      "13022": true,
      "13023": true,
      "13024": true,
      "13025": true,
      "13026": true,
      "13027": true,
      "13028": true,
      "13029": true,
      "13030": true,
      "13031": true,
      "13032": true,
      "13033": true,
      "13034": true,
      "13035": true,
      "13036": true,
      "13037": true,
      "13038": true,
      "13039": true,
      "13040": true,
      "13041": true,
      "13042": true,
      "13043": true,
      "13044": true,
      "13045": true,
      "13046": true,
      "13047": true,
      "13048": true,
      "13049": true,
      "13050": true,
      "13051": true,
      "13052": true,
      "13053": true,
      "13054": true,
      "13055": true,
      "13056": true,
      "13057": true,
      "13058": true,
      "13059": true,
      "13060": true,
      "13061": true,
      "13062": true,
      "13063": true,
      "13064": true,
      "13065": true,
      "13066": true,
      "13067": true,
      "13068": true,
      "13069": true,
      "13070": true,
      "13071": true,
      "13072": true,
      "13073": true,
      "13074": true,
      "13075": true,
      "13076": true,
      "13077": true,
      "13078": true,
      "13079": true,
      "13080": true,
      "13081": true,
      "13082": true,
      "13083": true,
      "13084": true,
      "13085": true,
      "13086": true,
      "13087": true,
      "13088": true,
      "13089": true,
      "13090": true,
      "13091": true,
      "13092": true,
      "13093": true,
      "13094": true,
      "13095": true,
      "13096": true,
      "13097": true,
      "13098": true,
      "13099": true,
      "13100": true,
      "13101": true,
      "13102": true,
      "13103": true,
      "13104": true,
      "13105": true,
      "13106": true,
      "13107": true,
      "13108": true,
      "13109": true,
      "13110": true,
      "13111": true,
      "13112": true,
      "13113": true,
      "13114": true,
      "13115": true,
      "13116": true,
      "13117": true,
      "13118": true,
      "13119": true,
      "13120": true,
      "13121": true,
      "13122": true,
      "13123": true,
      "13124": true,
      "13125": true,
      "13126": true,
      "13127": true,
      "13128": true,
      "13129": true,
      "13130": true,
      "13131": true,
      "13132": true,
      "13133": true,
      "13134": true,
      "13135": true,
      "13136": true,
      "13137": true,
      "13138": true,
      "13139": true,
      "13140": true,
      "13141": true,
      "13142": true,
      "13143": true,
      "13144": true,
      "13145": true,
      "13146": true,
      "13147": true,
      "13148": true,
      "13149": true,
      "13150": true,
      "13151": true,
      "13152": true,
      "13153": true,
      "13154": true,
      "13155": true,
      "13156": true,
      "13157": true,
      "13158": true,
      "13159": true,
      "13160": true,
      "13161": true,
      "13162": true,
      "13163": true,
      "13164": true,
      "13165": true,
      "13166": true,
      "13167": true,
      "13168": true,
      "13169": true,
      "13170": true,
      "13171": true,
      "13172": true,
      "13173": true,
      "13174": true,
      "13175": true,
      "13176": true,
      "13177": true,
      "13178": true,
      "13179": true,
      "13180": true,
      "13181": true,
      "13182": true,
      "13183": true,
      "13184": true,
      "13185": true,
      "13186": true,
      "13187": true,
      "13188": true,
      "13189": true,
      "13190": true,
      "13191": true,
      "13192": true,
      "13193": true,
      "13194": true,
      "13195": true,
      "13196": true,
      "13197": true,
      "13198": true,
      "13199": true,
      "13200": true,
      "13201": true,
      "13202": true,
      "13203": true,
      "13204": true,
      "13205": true,
      "13206": true,
      "13207": true,
      "13208": true,
      "13209": true,
      "13210": true,
      "13211": true,
      "13212": true,
      "13213": true,
      "13214": true,
      "13215": true,
      "13216": true,
      "13217": true,
      "13218": true,
      "13219": true,
      "13220": true,
      "13221": true,
      "13222": true,
      "13223": true,
      "13224": true,
      "13225": true,
      "13226": true,
      "13227": true,
      "13228": true,
      "13229": true,
      "13230": true,
      "13231": true,
      "13232": true,
      "13233": true,
      "13234": true,
      "13235": true,
      "13236": true,
      "13237": true,
      "13238": true,
      "13239": true,
      "13240": true,
      "13241": true,
      "13242": true,
      "13243": true,
      "13244": true,
      "13245": true,
      "13246": true,
      "13247": true,
      "13248": true,
      "13249": true,
      "13250": true,
      "13251": true,
      "13252": true,
      "13253": true,
      "13254": true,
      "13255": true,
      "13256": true,
      "13257": true,
      "13258": true,
      "13259": true,
      "13260": true,
      "13261": true,
      "13262": true,
      "13263": true,
      "13264": true,
      "13265": true,
      "13266": true,
      "13267": true,
      "13268": true,
      "13269": true,
      "13270": true,
      "13271": true,
      "13272": true,
      "13273": true,
      "13274": true,
      "13275": true,
      "13276": true,
      "13277": true,
      "13278": true,
      "13279": true,
      "13280": true,
      "13281": true,
      "13282": true,
      "13283": true,
      "13284": true,
      "13285": true,
      "13286": true,
      "13287": true,
      "13288": true,
      "13289": true,
      "13290": true,
      "13291": true,
      "13292": true,
      "13293": true,
      "13294": true,
      "13295": true,
      "13296": true,
      "13297": true,
      "13298": true,
      "13299": true,
      "13300": true,
      "13301": true,
      "13302": true,
      "13303": true,
      "13304": true,
      "13305": true,
      "13306": true,
      "13307": true,
      "13308": true,
      "13309": true,
      "13310": true,
      "13311": true,
      "13312": true,
      "13313": true,
      "13314": true,
      "13315": true,
      "13316": true,
      "13317": true,
      "13318": true,
      "13319": true,
      "13320": true,
      "13321": true,
      "13322": true,
      "13323": true,
      "13324": true,
      "13325": true,
      "13326": true,
      "13327": true,
      "13328": true,
      "13329": true,
      "13330": true,
      "13331": true,
      "13332": true,
      "13333": true,
      "13334": true,
      "13335": true,
      "13336": true,
      "13337": true,
      "13338": true,
      "13339": true,
      "13340": true,
      "13341": true,
      "13342": true,
      "13343": true,
      "13344": true,
      "13345": true,
      "13346": true,
      "13347": true,
      "13348": true,
      "13349": true,
      "13350": true,
      "13351": true,
      "13352": true,
      "13353": true,
      "13354": true,
      "13355": true,
      "13356": true,
      "13357": true,
      "13358": true,
      "13359": true,
      "13360": true,
      "13361": true,
      "13362": true,
      "13363": true,
      "13364": true,
      "13365": true,
      "13366": true,
      "13367": true,
      "13368": true,
      "13369": true,
      "13370": true,
      "13371": true,
      "13372": true,
      "13373": true,
      "13374": true,
      "13375": true,
      "13376": true,
      "13377": true,
      "13378": true,
      "13379": true,
      "13380": true,
      "13381": true,
      "13382": true,
      "13383": true,
      "13384": true,
      "13385": true,
      "13386": true,
      "13387": true,
      "13388": true,
      "13389": true,
      "13390": true,
      "13391": true,
      "13392": true,
      "13393": true,
      "13394": true,
      "13395": true,
      "13396": true,
      "13397": true,
      "13398": true,
      "13399": true,
      "13400": true,
      "13401": true,
      "13402": true,
      "13403": true,
      "13404": true,
      "13405": true,
      "13406": true,
      "13407": true,
      "13408": true,
      "13409": true,
      "13410": true,
      "13411": true,
      "13412": true,
      "13413": true,
      "13414": true,
      "13415": true,
      "13416": true,
      "13417": true,
      "13418": true,
      "13419": true,
      "13420": true,
      "13421": true,
      "13422": true,
      "13423": true,
      "13424": true,
      "13425": true,
      "13426": true,
      "13427": true,
      "13428": true,
      "13429": true,
      "13430": true,
      "13431": true,
      "13432": true,
      "13433": true,
      "13434": true,
      "13435": true,
      "13436": true,
      "13437": true,
      "13438": true,
      "13439": true,
      "13440": true,
      "13441": true,
      "13442": true,
      "13443": true,
      "13444": true,
      "13445": true,
      "13446": true,
      "13447": true,
      "13448": true,
      "13449": true,
      "13450": true,
      "13451": true,
      "13452": true,
      "13453": true,
      "13454": true,
      "13455": true,
      "13456": true,
      "13457": true,
      "13458": true,
      "13459": true,
      "13460": true,
      "13461": true,
      "13462": true,
      "13463": true,
      "13464": true,
      "13465": true,
      "13466": true,
      "13467": true,
      "13468": true,
      "13469": true,
      "13470": true,
      "13471": true,
      "13472": true,
      "13473": true,
      "13474": true,
      "13475": true,
      "13476": true,
      "13477": true,
      "13478": true,
      "13479": true,
      "13480": true,
      "13481": true,
      "13482": true,
      "13483": true,
      "13484": true,
      "13485": true,
      "13486": true,
      "13487": true,
      "13488": true,
      "13489": true,
      "13490": true,
      "13491": true,
      "13492": true,
      "13493": true,
      "13494": true,
      "13495": true,
      "13496": true,
      "13497": true,
      "13498": true,
      "13499": true,
      "13500": true,
      "13501": true,
      "13502": true,
      "13503": true,
      "13504": true,
      "13505": true,
      "13506": true,
      "13507": true,
      "13508": true,
      "13509": true,
      "13510": true,
      "13511": true,
      "13512": true,
      "13513": true,
      "13514": true,
      "13515": true,
      "13516": true,
      "13517": true,
      "13518": true,
      "13519": true,
      "13520": true,
      "13521": true,
      "13522": true,
      "13523": true,
      "13524": true,
      "13525": true,
      "13526": true,
      "13527": true,
      "13528": true,
      "13529": true,
      "13530": true,
      "13531": true,
      "13532": true,
      "13533": true,
      "13534": true,
      "13535": true,
      "13536": true,
      "13537": true,
      "13538": true,
      "13539": true,
      "13540": true,
      "13541": true,
      "13542": true,
      "13543": true,
      "13544": true,
      "13545": true,
      "13546": true,
      "13547": true,
      "13548": true,
      "13549": true,
      "13550": true,
      "13551": true,
      "13552": true,
      "13553": true,
      "13554": true,
      "13555": true,
      "13556": true,
      "13557": true,
      "13558": true,
      "13559": true,
      "13560": true,
      "13561": true,
      "13562": true,
      "13563": true,
      "13564": true,
      "13565": true,
      "13566": true,
      "13567": true,
      "13568": true,
      "13569": true,
      "13570": true,
      "13571": true,
      "13572": true,
      "13573": true,
      "13574": true,
      "13575": true,
      "13576": true,
      "13577": true,
      "13578": true,
      "13579": true,
      "13580": true,
      "13581": true,
      "13582": true,
      "13583": true,
      "13584": true,
      "13585": true,
      "13586": true,
      "13587": true,
      "13588": true,
      "13589": true,
      "13590": true,
      "13591": true,
      "13592": true,
      "13593": true,
      "13594": true,
      "13595": true,
      "13596": true,
      "13597": true,
      "13598": true,
      "13599": true,
      "13600": true,
      "13601": true,
      "13602": true,
      "13603": true,
      "13604": true,
      "13605": true,
      "13606": true,
      "13607": true,
      "13608": true,
      "13609": true,
      "13610": true,
      "13611": true,
      "13612": true,
      "13613": true,
      "13614": true,
      "13615": true,
      "13616": true,
      "13617": true,
      "13618": true,
      "13619": true,
      "13620": true,
      "13621": true,
      "13622": true,
      "13623": true,
      "13624": true,
      "13625": true,
      "13626": true,
      "13627": true,
      "13628": true,
      "13629": true,
      "13630": true,
      "13631": true,
      "13632": true,
      "13633": true,
      "13634": true,
      "13635": true,
      "13636": true,
      "13637": true,
      "13638": true,
      "13639": true,
      "13640": true,
      "13641": true,
      "13642": true,
      "13643": true,
      "13644": true,
      "13645": true,
      "13646": true,
      "13647": true,
      "13648": true,
      "13649": true,
      "13650": true,
      "13651": true,
      "13652": true,
      "13653": true,
      "13654": true,
      "13655": true,
      "13656": true,
      "13657": true,
      "13658": true,
      "13659": true,
      "13660": true,
      "13661": true,
      "13662": true,
      "13663": true,
      "13664": true,
      "13665": true,
      "13666": true,
      "13667": true,
      "13668": true,
      "13669": true,
      "13670": true,
      "13671": true,
      "13672": true,
      "13673": true,
      "13674": true,
      "13675": true,
      "13676": true,
      "13677": true,
      "13678": true,
      "13679": true,
      "13680": true,
      "13681": true,
      "13682": true,
      "13683": true,
      "13684": true,
      "13685": true,
      "13686": true,
      "13687": true,
      "13688": true,
      "13689": true,
      "13690": true,
      "13691": true,
      "13692": true,
      "13693": true,
      "13694": true,
      "13695": true,
      "13696": true,
      "13697": true,
      "13698": true,
      "13699": true,
      "13700": true,
      "13701": true,
      "13702": true,
      "13703": true,
      "13704": true,
      "13705": true,
      "13706": true,
      "13707": true,
      "13708": true,
      "13709": true,
      "13710": true,
      "13711": true,
      "13712": true,
      "13713": true,
      "13714": true,
      "13715": true,
      "13716": true,
      "13717": true,
      "13718": true,
      "13719": true,
      "13720": true,
      "13721": true,
      "13722": true,
      "13723": true,
      "13724": true,
      "13725": true,
      "13726": true,
      "13727": true,
      "13728": true,
      "13729": true,
      "13730": true,
      "13731": true,
      "13732": true,
      "13733": true,
      "13734": true,
      "13735": true,
      "13736": true,
      "13737": true,
      "13738": true,
      "13739": true,
      "13740": true,
      "13741": true,
      "13742": true,
      "13743": true,
      "13744": true,
      "13745": true,
      "13746": true,
      "13747": true,
      "13748": true,
      "13749": true,
      "13750": true,
      "13751": true,
      "13752": true,
      "13753": true,
      "13754": true,
      "13755": true,
      "13756": true,
      "13757": true,
      "13758": true,
      "13759": true,
      "13760": true,
      "13761": true,
      "13762": true,
      "13763": true,
      "13764": true,
      "13765": true,
      "13766": true,
      "13767": true,
      "13768": true,
      "13769": true,
      "13770": true,
      "13771": true,
      "13772": true,
      "13773": true,
      "13774": true,
      "13775": true,
      "13776": true,
      "13777": true,
      "13778": true,
      "13779": true,
      "13780": true,
      "13781": true,
      "13782": true,
      "13783": true,
      "13784": true,
      "13785": true,
      "13786": true,
      "13787": true,
      "13788": true,
      "13789": true,
      "13790": true,
      "13791": true,
      "13792": true,
      "13793": true,
      "13794": true,
      "13795": true,
      "13796": true,
      "13797": true,
      "13798": true,
      "13799": true,
      "13800": true,
      "13801": true,
      "13802": true,
      "13803": true,
      "13804": true,
      "13805": true,
      "13806": true,
      "13807": true,
      "13808": true,
      "13809": true,
      "13810": true,
      "13811": true,
      "13812": true,
      "13813": true,
      "13814": true,
      "13815": true,
      "13816": true,
      "13817": true,
      "13818": true,
      "13819": true,
      "13820": true,
      "13821": true,
      "13822": true,
      "13823": true,
      "13824": true,
      "13825": true,
      "13826": true,
      "13827": true,
      "13828": true,
      "13829": true,
      "13830": true,
      "13831": true,
      "13832": true,
      "13833": true,
      "13834": true,
      "13835": true,
      "13836": true,
      "13837": true,
      "13838": true,
      "13839": true,
      "13840": true,
      "13841": true,
      "13842": true,
      "13843": true,
      "13844": true,
      "13845": true,
      "13846": true,
      "13847": true,
      "13848": true,
      "13849": true,
      "13850": true,
      "13851": true,
      "13852": true,
      "13853": true,
      "13854": true,
      "13855": true,
      "13856": true,
      "13857": true,
      "13858": true,
      "13859": true,
      "13860": true,
      "13861": true,
      "13862": true,
      "13863": true,
      "13864": true,
      "13865": true,
      "13866": true,
      "13867": true,
      "13868": true,
      "13869": true,
      "13870": true,
      "13871": true,
      "13872": true,
      "13873": true,
      "13874": true,
      "13875": true,
      "13876": true,
      "13877": true,
      "13878": true,
      "13879": true,
      "13880": true,
      "13881": true,
      "13882": true,
      "13883": true,
      "13884": true,
      "13885": true,
      "13886": true,
      "13887": true,
      "13888": true,
      "13889": true,
      "13890": true,
      "13891": true,
      "13892": true,
      "13893": true,
      "13894": true,
      "13895": true,
      "13896": true,
      "13897": true,
      "13898": true,
      "13899": true,
      "13900": true,
      "13901": true,
      "13902": true,
      "13903": true,
      "13904": true,
      "13905": true,
      "13906": true,
      "13907": true,
      "13908": true,
      "13909": true,
      "13910": true,
      "13911": true,
      "13912": true,
      "13913": true,
      "13914": true,
      "13915": true,
      "13916": true,
      "13917": true,
      "13918": true,
      "13919": true,
      "13920": true,
      "13921": true,
      "13922": true,
      "13923": true,
      "13924": true,
      "13925": true,
      "13926": true,
      "13927": true,
      "13928": true,
      "13929": true,
      "13930": true,
      "13931": true,
      "13932": true,
      "13933": true,
      "13934": true,
      "13935": true,
      "13936": true,
      "13937": true,
      "13938": true,
      "13939": true,
      "13940": true,
      "13941": true,
      "13942": true,
      "13943": true,
      "13944": true,
      "13945": true,
      "13946": true,
      "13947": true,
      "13948": true,
      "13949": true,
      "13950": true,
      "13951": true,
      "13952": true,
      "13953": true,
      "13954": true,
      "13955": true,
      "13956": true,
      "13957": true,
      "13958": true,
      "13959": true,
      "13960": true,
      "13961": true,
      "13962": true,
      "13963": true,
      "13964": true,
      "13965": true,
      "13966": true,
      "13967": true,
      "13968": true,
      "13969": true,
      "13970": true,
      "13971": true,
      "13972": true,
      "13973": true,
      "13974": true,
      "13975": true,
      "13976": true,
      "13977": true,
      "13978": true,
      "13979": true,
      "13980": true,
      "13981": true,
      "13982": true,
      "13983": true,
      "13984": true,
      "13985": true,
      "13986": true,
      "13987": true,
      "13988": true,
      "13989": true,
      "13990": true,
      "13991": true,
      "13992": true,
      "13993": true,
      "13994": true,
      "13995": true,
      "13996": true,
      "13997": true,
      "13998": true,
      "13999": true
    },
    "TLALPAN": {
      "14000": true,
      "14009": true,
      "14010": true,
      "14017": true,
      "14020": true,
      "14030": true,
      "14038": true,
      "14039": true,
      "14040": true,
      "14049": true,
      "14050": true,
      "14060": true,
      "14070": true,
      "14080": true,
      "14090": true,
      "14098": true,
      "14100": true,
      "14108": true,
      "14110": true,
      "14120": true,
      "14129": true,
      "14130": true,
      "14140": true,
      "14150": true,
      "14160": true,
      "14200": true,
      "14208": true,
      "14209": true,
      "14210": true,
      "14219": true,
      "14220": true,
      "14230": true,
      "14239": true,
      "14240": true,
      "14248": true,
      "14250": true,
      "14260": true,
      "14266": true,
      "14267": true,
      "14268": true,
      "14269": true,
      "14270": true,
      "14273": true,
      "14275": true,
      "14300": true,
      "14307": true,
      "14308": true,
      "14309": true,
      "14310": true,
      "14320": true,
      "14324": true,
      "14325": true,
      "14326": true,
      "14327": true,
      "14328": true,
      "14329": true,
      "14330": true,
      "14334": true,
      "14335": true,
      "14336": true,
      "14337": true,
      "14338": true,
      "14339": true,
      "14340": true,
      "14350": true,
      "14356": true,
      "14357": true,
      "14358": true,
      "14360": true,
      "14370": true,
      "14376": true,
      "14377": true,
      "14378": true,
      "14380": true,
      "14386": true,
      "14387": true,
      "14388": true,
      "14389": true,
      "14390": true,
      "14400": true,
      "14406": true,
      "14408": true,
      "14409": true,
      "14410": true,
      "14420": true,
      "14426": true,
      "14427": true,
      "14428": true,
      "14429": true,
      "14430": true,
      "14438": true,
      "14439": true,
      "14440": true,
      "14449": true,
      "14450": true,
      "14456": true,
      "14460": true,
      "14470": true,
      "14476": true,
      "14479": true,
      "14480": true,
      "14490": true,
      "14500": true,
      "14520": true,
      "14529": true,
      "14550": true,
      "14600": true,
      "14608": true,
      "14609": true,
      "14610": true,
      "14620": true,
      "14629": true,
      "14630": true,
      "14639": true,
      "14640": true,
      "14643": true,
      "14646": true,
      "14647": true,
      "14650": true,
      "14653": true,
      "14655": true,
      "14657": true,
      "14658": true,
      "14659": true,
      "14700": true,
      "14710": true,
      "14720": true,
      "14730": true,
      "14734": true,
      "14735": true,
      "14737": true,
      "14738": true,
      "14739": true,
      "14740": true,
      "14748": true,
      "14749": true,
      "14750": true,
      "14760": true,
      "14780": true,
      "14790": true,
      "14900": true
    },
    "VENUSTIANO CARRANZA": {
      "15000": true,
      "15001": true,
      "15002": true,
      "15003": true,
      "15004": true,
      "15005": true,
      "15006": true,
      "15007": true,
      "15008": true,
      "15009": true,
      "15010": true,
      "15011": true,
      "15012": true,
      "15013": true,
      "15014": true,
      "15015": true,
      "15016": true,
      "15017": true,
      "15018": true,
      "15019": true,
      "15020": true,
      "15021": true,
      "15022": true,
      "15023": true,
      "15024": true,
      "15025": true,
      "15026": true,
      "15027": true,
      "15028": true,
      "15029": true,
      "15030": true,
      "15031": true,
      "15032": true,
      "15033": true,
      "15034": true,
      "15035": true,
      "15036": true,
      "15037": true,
      "15038": true,
      "15039": true,
      "15040": true,
      "15041": true,
      "15042": true,
      "15043": true,
      "15044": true,
      "15045": true,
      "15046": true,
      "15047": true,
      "15048": true,
      "15049": true,
      "15050": true,
      "15051": true,
      "15052": true,
      "15053": true,
      "15054": true,
      "15055": true,
      "15056": true,
      "15057": true,
      "15058": true,
      "15059": true,
      "15060": true,
      "15061": true,
      "15062": true,
      "15063": true,
      "15064": true,
      "15065": true,
      "15066": true,
      "15067": true,
      "15068": true,
      "15069": true,
      "15070": true,
      "15071": true,
      "15072": true,
      "15073": true,
      "15074": true,
      "15075": true,
      "15076": true,
      "15077": true,
      "15078": true,
      "15079": true,
      "15080": true,
      "15081": true,
      "15082": true,
      "15083": true,
      "15084": true,
      "15085": true,
      "15086": true,
      "15087": true,
      "15088": true,
      "15089": true,
      "15090": true,
      "15091": true,
      "15092": true,
      "15093": true,
      "15094": true,
      "15095": true,
      "15096": true,
      "15097": true,
      "15098": true,
      "15099": true,
      "15100": true,
      "15101": true,
      "15102": true,
      "15103": true,
      "15104": true,
      "15105": true,
      "15106": true,
      "15107": true,
      "15108": true,
      "15109": true,
      "15110": true,
      "15111": true,
      "15112": true,
      "15113": true,
      "15114": true,
      "15115": true,
      "15116": true,
      "15117": true,
      "15118": true,
      "15119": true,
      "15120": true,
      "15121": true,
      "15122": true,
      "15123": true,
      "15124": true,
      "15125": true,
      "15126": true,
      "15127": true,
      "15128": true,
      "15129": true,
      "15130": true,
      "15131": true,
      "15132": true,
      "15133": true,
      "15134": true,
      "15135": true,
      "15136": true,
      "15137": true,
      "15138": true,
      "15139": true,
      "15140": true,
      "15141": true,
      "15142": true,
      "15143": true,
      "15144": true,
      "15145": true,
      "15146": true,
      "15147": true,
      "15148": true,
      "15149": true,
      "15150": true,
      "15151": true,
      "15152": true,
      "15153": true,
      "15154": true,
      "15155": true,
      "15156": true,
      "15157": true,
      "15158": true,
      "15159": true,
      "15160": true,
      "15161": true,
      "15162": true,
      "15163": true,
      "15164": true,
      "15165": true,
      "15166": true,
      "15167": true,
      "15168": true,
      "15169": true,
      "15170": true,
      "15171": true,
      "15172": true,
      "15173": true,
      "15174": true,
      "15175": true,
      "15176": true,
      "15177": true,
      "15178": true,
      "15179": true,
      "15180": true,
      "15181": true,
      "15182": true,
      "15183": true,
      "15184": true,
      "15185": true,
      "15186": true,
      "15187": true,
      "15188": true,
      "15189": true,
      "15190": true,
      "15191": true,
      "15192": true,
      "15193": true,
      "15194": true,
      "15195": true,
      "15196": true,
      "15197": true,
      "15198": true,
      "15199": true,
      "15200": true,
      "15201": true,
      "15202": true,
      "15203": true,
      "15204": true,
      "15205": true,
      "15206": true,
      "15207": true,
      "15208": true,
      "15209": true,
      "15210": true,
      "15211": true,
      "15212": true,
      "15213": true,
      "15214": true,
      "15215": true,
      "15216": true,
      "15217": true,
      "15218": true,
      "15219": true,
      "15220": true,
      "15221": true,
      "15222": true,
      "15223": true,
      "15224": true,
      "15225": true,
      "15226": true,
      "15227": true,
      "15228": true,
      "15229": true,
      "15230": true,
      "15231": true,
      "15232": true,
      "15233": true,
      "15234": true,
      "15235": true,
      "15236": true,
      "15237": true,
      "15238": true,
      "15239": true,
      "15240": true,
      "15241": true,
      "15242": true,
      "15243": true,
      "15244": true,
      "15245": true,
      "15246": true,
      "15247": true,
      "15248": true,
      "15249": true,
      "15250": true,
      "15251": true,
      "15252": true,
      "15253": true,
      "15254": true,
      "15255": true,
      "15256": true,
      "15257": true,
      "15258": true,
      "15259": true,
      "15260": true,
      "15261": true,
      "15262": true,
      "15263": true,
      "15264": true,
      "15265": true,
      "15266": true,
      "15267": true,
      "15268": true,
      "15269": true,
      "15270": true,
      "15271": true,
      "15272": true,
      "15273": true,
      "15274": true,
      "15275": true,
      "15276": true,
      "15277": true,
      "15278": true,
      "15279": true,
      "15280": true,
      "15281": true,
      "15282": true,
      "15283": true,
      "15284": true,
      "15285": true,
      "15286": true,
      "15287": true,
      "15288": true,
      "15289": true,
      "15290": true,
      "15291": true,
      "15292": true,
      "15293": true,
      "15294": true,
      "15295": true,
      "15296": true,
      "15297": true,
      "15298": true,
      "15299": true,
      "15300": true,
      "15301": true,
      "15302": true,
      "15303": true,
      "15304": true,
      "15305": true,
      "15306": true,
      "15307": true,
      "15308": true,
      "15309": true,
      "15310": true,
      "15311": true,
      "15312": true,
      "15313": true,
      "15314": true,
      "15315": true,
      "15316": true,
      "15317": true,
      "15318": true,
      "15319": true,
      "15320": true,
      "15321": true,
      "15322": true,
      "15323": true,
      "15324": true,
      "15325": true,
      "15326": true,
      "15327": true,
      "15328": true,
      "15329": true,
      "15330": true,
      "15331": true,
      "15332": true,
      "15333": true,
      "15334": true,
      "15335": true,
      "15336": true,
      "15337": true,
      "15338": true,
      "15339": true,
      "15340": true,
      "15341": true,
      "15342": true,
      "15343": true,
      "15344": true,
      "15345": true,
      "15346": true,
      "15347": true,
      "15348": true,
      "15349": true,
      "15350": true,
      "15351": true,
      "15352": true,
      "15353": true,
      "15354": true,
      "15355": true,
      "15356": true,
      "15357": true,
      "15358": true,
      "15359": true,
      "15360": true,
      "15361": true,
      "15362": true,
      "15363": true,
      "15364": true,
      "15365": true,
      "15366": true,
      "15367": true,
      "15368": true,
      "15369": true,
      "15370": true,
      "15371": true,
      "15372": true,
      "15373": true,
      "15374": true,
      "15375": true,
      "15376": true,
      "15377": true,
      "15378": true,
      "15379": true,
      "15380": true,
      "15381": true,
      "15382": true,
      "15383": true,
      "15384": true,
      "15385": true,
      "15386": true,
      "15387": true,
      "15388": true,
      "15389": true,
      "15390": true,
      "15391": true,
      "15392": true,
      "15393": true,
      "15394": true,
      "15395": true,
      "15396": true,
      "15397": true,
      "15398": true,
      "15399": true,
      "15400": true,
      "15401": true,
      "15402": true,
      "15403": true,
      "15404": true,
      "15405": true,
      "15406": true,
      "15407": true,
      "15408": true,
      "15409": true,
      "15410": true,
      "15411": true,
      "15412": true,
      "15413": true,
      "15414": true,
      "15415": true,
      "15416": true,
      "15417": true,
      "15418": true,
      "15419": true,
      "15420": true,
      "15421": true,
      "15422": true,
      "15423": true,
      "15424": true,
      "15425": true,
      "15426": true,
      "15427": true,
      "15428": true,
      "15429": true,
      "15430": true,
      "15431": true,
      "15432": true,
      "15433": true,
      "15434": true,
      "15435": true,
      "15436": true,
      "15437": true,
      "15438": true,
      "15439": true,
      "15440": true,
      "15441": true,
      "15442": true,
      "15443": true,
      "15444": true,
      "15445": true,
      "15446": true,
      "15447": true,
      "15448": true,
      "15449": true,
      "15450": true,
      "15451": true,
      "15452": true,
      "15453": true,
      "15454": true,
      "15455": true,
      "15456": true,
      "15457": true,
      "15458": true,
      "15459": true,
      "15460": true,
      "15461": true,
      "15462": true,
      "15463": true,
      "15464": true,
      "15465": true,
      "15466": true,
      "15467": true,
      "15468": true,
      "15469": true,
      "15470": true,
      "15471": true,
      "15472": true,
      "15473": true,
      "15474": true,
      "15475": true,
      "15476": true,
      "15477": true,
      "15478": true,
      "15479": true,
      "15480": true,
      "15481": true,
      "15482": true,
      "15483": true,
      "15484": true,
      "15485": true,
      "15486": true,
      "15487": true,
      "15488": true,
      "15489": true,
      "15490": true,
      "15491": true,
      "15492": true,
      "15493": true,
      "15494": true,
      "15495": true,
      "15496": true,
      "15497": true,
      "15498": true,
      "15499": true,
      "15500": true,
      "15501": true,
      "15502": true,
      "15503": true,
      "15504": true,
      "15505": true,
      "15506": true,
      "15507": true,
      "15508": true,
      "15509": true,
      "15510": true,
      "15511": true,
      "15512": true,
      "15513": true,
      "15514": true,
      "15515": true,
      "15516": true,
      "15517": true,
      "15518": true,
      "15519": true,
      "15520": true,
      "15521": true,
      "15522": true,
      "15523": true,
      "15524": true,
      "15525": true,
      "15526": true,
      "15527": true,
      "15528": true,
      "15529": true,
      "15530": true,
      "15531": true,
      "15532": true,
      "15533": true,
      "15534": true,
      "15535": true,
      "15536": true,
      "15537": true,
      "15538": true,
      "15539": true,
      "15540": true,
      "15541": true,
      "15542": true,
      "15543": true,
      "15544": true,
      "15545": true,
      "15546": true,
      "15547": true,
      "15548": true,
      "15549": true,
      "15550": true,
      "15551": true,
      "15552": true,
      "15553": true,
      "15554": true,
      "15555": true,
      "15556": true,
      "15557": true,
      "15558": true,
      "15559": true,
      "15560": true,
      "15561": true,
      "15562": true,
      "15563": true,
      "15564": true,
      "15565": true,
      "15566": true,
      "15567": true,
      "15568": true,
      "15569": true,
      "15570": true,
      "15571": true,
      "15572": true,
      "15573": true,
      "15574": true,
      "15575": true,
      "15576": true,
      "15577": true,
      "15578": true,
      "15579": true,
      "15580": true,
      "15581": true,
      "15582": true,
      "15583": true,
      "15584": true,
      "15585": true,
      "15586": true,
      "15587": true,
      "15588": true,
      "15589": true,
      "15590": true,
      "15591": true,
      "15592": true,
      "15593": true,
      "15594": true,
      "15595": true,
      "15596": true,
      "15597": true,
      "15598": true,
      "15599": true,
      "15600": true,
      "15601": true,
      "15602": true,
      "15603": true,
      "15604": true,
      "15605": true,
      "15606": true,
      "15607": true,
      "15608": true,
      "15609": true,
      "15610": true,
      "15611": true,
      "15612": true,
      "15613": true,
      "15614": true,
      "15615": true,
      "15616": true,
      "15617": true,
      "15618": true,
      "15619": true,
      "15620": true,
      "15621": true,
      "15622": true,
      "15623": true,
      "15624": true,
      "15625": true,
      "15626": true,
      "15627": true,
      "15628": true,
      "15629": true,
      "15630": true,
      "15631": true,
      "15632": true,
      "15633": true,
      "15634": true,
      "15635": true,
      "15636": true,
      "15637": true,
      "15638": true,
      "15639": true,
      "15640": true,
      "15641": true,
      "15642": true,
      "15643": true,
      "15644": true,
      "15645": true,
      "15646": true,
      "15647": true,
      "15648": true,
      "15649": true,
      "15650": true,
      "15651": true,
      "15652": true,
      "15653": true,
      "15654": true,
      "15655": true,
      "15656": true,
      "15657": true,
      "15658": true,
      "15659": true,
      "15660": true,
      "15661": true,
      "15662": true,
      "15663": true,
      "15664": true,
      "15665": true,
      "15666": true,
      "15667": true,
      "15668": true,
      "15669": true,
      "15670": true,
      "15671": true,
      "15672": true,
      "15673": true,
      "15674": true,
      "15675": true,
      "15676": true,
      "15677": true,
      "15678": true,
      "15679": true,
      "15680": true,
      "15681": true,
      "15682": true,
      "15683": true,
      "15684": true,
      "15685": true,
      "15686": true,
      "15687": true,
      "15688": true,
      "15689": true,
      "15690": true,
      "15691": true,
      "15692": true,
      "15693": true,
      "15694": true,
      "15695": true,
      "15696": true,
      "15697": true,
      "15698": true,
      "15699": true,
      "15700": true,
      "15701": true,
      "15702": true,
      "15703": true,
      "15704": true,
      "15705": true,
      "15706": true,
      "15707": true,
      "15708": true,
      "15709": true,
      "15710": true,
      "15711": true,
      "15712": true,
      "15713": true,
      "15714": true,
      "15715": true,
      "15716": true,
      "15717": true,
      "15718": true,
      "15719": true,
      "15720": true,
      "15721": true,
      "15722": true,
      "15723": true,
      "15724": true,
      "15725": true,
      "15726": true,
      "15727": true,
      "15728": true,
      "15729": true,
      "15730": true,
      "15731": true,
      "15732": true,
      "15733": true,
      "15734": true,
      "15735": true,
      "15736": true,
      "15737": true,
      "15738": true,
      "15739": true,
      "15740": true,
      "15741": true,
      "15742": true,
      "15743": true,
      "15744": true,
      "15745": true,
      "15746": true,
      "15747": true,
      "15748": true,
      "15749": true,
      "15750": true,
      "15751": true,
      "15752": true,
      "15753": true,
      "15754": true,
      "15755": true,
      "15756": true,
      "15757": true,
      "15758": true,
      "15759": true,
      "15760": true,
      "15761": true,
      "15762": true,
      "15763": true,
      "15764": true,
      "15765": true,
      "15766": true,
      "15767": true,
      "15768": true,
      "15769": true,
      "15770": true,
      "15771": true,
      "15772": true,
      "15773": true,
      "15774": true,
      "15775": true,
      "15776": true,
      "15777": true,
      "15778": true,
      "15779": true,
      "15780": true,
      "15781": true,
      "15782": true,
      "15783": true,
      "15784": true,
      "15785": true,
      "15786": true,
      "15787": true,
      "15788": true,
      "15789": true,
      "15790": true,
      "15791": true,
      "15792": true,
      "15793": true,
      "15794": true,
      "15795": true,
      "15796": true,
      "15797": true,
      "15798": true,
      "15799": true,
      "15800": true,
      "15801": true,
      "15802": true,
      "15803": true,
      "15804": true,
      "15805": true,
      "15806": true,
      "15807": true,
      "15808": true,
      "15809": true,
      "15810": true,
      "15811": true,
      "15812": true,
      "15813": true,
      "15814": true,
      "15815": true,
      "15816": true,
      "15817": true,
      "15818": true,
      "15819": true,
      "15820": true,
      "15821": true,
      "15822": true,
      "15823": true,
      "15824": true,
      "15825": true,
      "15826": true,
      "15827": true,
      "15828": true,
      "15829": true,
      "15830": true,
      "15831": true,
      "15832": true,
      "15833": true,
      "15834": true,
      "15835": true,
      "15836": true,
      "15837": true,
      "15838": true,
      "15839": true,
      "15840": true,
      "15841": true,
      "15842": true,
      "15843": true,
      "15844": true,
      "15845": true,
      "15846": true,
      "15847": true,
      "15848": true,
      "15849": true,
      "15850": true,
      "15851": true,
      "15852": true,
      "15853": true,
      "15854": true,
      "15855": true,
      "15856": true,
      "15857": true,
      "15858": true,
      "15859": true,
      "15860": true,
      "15861": true,
      "15862": true,
      "15863": true,
      "15864": true,
      "15865": true,
      "15866": true,
      "15867": true,
      "15868": true,
      "15869": true,
      "15870": true,
      "15871": true,
      "15872": true,
      "15873": true,
      "15874": true,
      "15875": true,
      "15876": true,
      "15877": true,
      "15878": true,
      "15879": true,
      "15880": true,
      "15881": true,
      "15882": true,
      "15883": true,
      "15884": true,
      "15885": true,
      "15886": true,
      "15887": true,
      "15888": true,
      "15889": true,
      "15890": true,
      "15891": true,
      "15892": true,
      "15893": true,
      "15894": true,
      "15895": true,
      "15896": true,
      "15897": true,
      "15898": true,
      "15899": true,
      "15900": true,
      "15901": true,
      "15902": true,
      "15903": true,
      "15904": true,
      "15905": true,
      "15906": true,
      "15907": true,
      "15908": true,
      "15909": true,
      "15910": true,
      "15911": true,
      "15912": true,
      "15913": true,
      "15914": true,
      "15915": true,
      "15916": true,
      "15917": true,
      "15918": true,
      "15919": true,
      "15920": true,
      "15921": true,
      "15922": true,
      "15923": true,
      "15924": true,
      "15925": true,
      "15926": true,
      "15927": true,
      "15928": true,
      "15929": true,
      "15930": true,
      "15931": true,
      "15932": true,
      "15933": true,
      "15934": true,
      "15935": true,
      "15936": true,
      "15937": true,
      "15938": true,
      "15939": true,
      "15940": true,
      "15941": true,
      "15942": true,
      "15943": true,
      "15944": true,
      "15945": true,
      "15946": true,
      "15947": true,
      "15948": true,
      "15949": true,
      "15950": true,
      "15951": true,
      "15952": true,
      "15953": true,
      "15954": true,
      "15955": true,
      "15956": true,
      "15957": true,
      "15958": true,
      "15959": true,
      "15960": true,
      "15961": true,
      "15962": true,
      "15963": true,
      "15964": true,
      "15965": true,
      "15966": true,
      "15967": true,
      "15968": true,
      "15969": true,
      "15970": true,
      "15971": true,
      "15972": true,
      "15973": true,
      "15974": true,
      "15975": true,
      "15976": true,
      "15977": true,
      "15978": true,
      "15979": true,
      "15980": true,
      "15981": true,
      "15982": true,
      "15983": true,
      "15984": true,
      "15985": true,
      "15986": true,
      "15987": true,
      "15988": true,
      "15989": true,
      "15990": true,
      "15991": true,
      "15992": true,
      "15993": true,
      "15994": true,
      "15995": true,
      "15996": true,
      "15997": true,
      "15998": true,
      "15999": true
    },
    "XOCHIMILCO": {
      "16000": true,
      "16001": true,
      "16002": true,
      "16003": true,
      "16004": true,
      "16005": true,
      "16006": true,
      "16007": true,
      "16008": true,
      "16009": true,
      "16010": true,
      "16011": true,
      "16012": true,
      "16013": true,
      "16014": true,
      "16015": true,
      "16016": true,
      "16017": true,
      "16018": true,
      "16019": true,
      "16020": true,
      "16021": true,
      "16022": true,
      "16023": true,
      "16024": true,
      "16025": true,
      "16026": true,
      "16027": true,
      "16028": true,
      "16029": true,
      "16030": true,
      "16031": true,
      "16032": true,
      "16033": true,
      "16034": true,
      "16035": true,
      "16036": true,
      "16037": true,
      "16038": true,
      "16039": true,
      "16040": true,
      "16041": true,
      "16042": true,
      "16043": true,
      "16044": true,
      "16045": true,
      "16046": true,
      "16047": true,
      "16048": true,
      "16049": true,
      "16050": true,
      "16051": true,
      "16052": true,
      "16053": true,
      "16054": true,
      "16055": true,
      "16056": true,
      "16057": true,
      "16058": true,
      "16059": true,
      "16060": true,
      "16061": true,
      "16062": true,
      "16063": true,
      "16064": true,
      "16065": true,
      "16066": true,
      "16067": true,
      "16068": true,
      "16069": true,
      "16070": true,
      "16071": true,
      "16072": true,
      "16073": true,
      "16074": true,
      "16075": true,
      "16076": true,
      "16077": true,
      "16078": true,
      "16079": true,
      "16080": true,
      "16081": true,
      "16082": true,
      "16083": true,
      "16084": true,
      "16085": true,
      "16086": true,
      "16087": true,
      "16088": true,
      "16089": true,
      "16090": true,
      "16091": true,
      "16092": true,
      "16093": true,
      "16094": true,
      "16095": true,
      "16096": true,
      "16097": true,
      "16098": true,
      "16099": true,
      "16100": true,
      "16101": true,
      "16102": true,
      "16103": true,
      "16104": true,
      "16105": true,
      "16106": true,
      "16107": true,
      "16108": true,
      "16109": true,
      "16110": true,
      "16111": true,
      "16112": true,
      "16113": true,
      "16114": true,
      "16115": true,
      "16116": true,
      "16117": true,
      "16118": true,
      "16119": true,
      "16120": true,
      "16121": true,
      "16122": true,
      "16123": true,
      "16124": true,
      "16125": true,
      "16126": true,
      "16127": true,
      "16128": true,
      "16129": true,
      "16130": true,
      "16131": true,
      "16132": true,
      "16133": true,
      "16134": true,
      "16135": true,
      "16136": true,
      "16137": true,
      "16138": true,
      "16139": true,
      "16140": true,
      "16141": true,
      "16142": true,
      "16143": true,
      "16144": true,
      "16145": true,
      "16146": true,
      "16147": true,
      "16148": true,
      "16149": true,
      "16150": true,
      "16151": true,
      "16152": true,
      "16153": true,
      "16154": true,
      "16155": true,
      "16156": true,
      "16157": true,
      "16158": true,
      "16159": true,
      "16160": true,
      "16161": true,
      "16162": true,
      "16163": true,
      "16164": true,
      "16165": true,
      "16166": true,
      "16167": true,
      "16168": true,
      "16169": true,
      "16170": true,
      "16171": true,
      "16172": true,
      "16173": true,
      "16174": true,
      "16175": true,
      "16176": true,
      "16177": true,
      "16178": true,
      "16179": true,
      "16180": true,
      "16181": true,
      "16182": true,
      "16183": true,
      "16184": true,
      "16185": true,
      "16186": true,
      "16187": true,
      "16188": true,
      "16189": true,
      "16190": true,
      "16191": true,
      "16192": true,
      "16193": true,
      "16194": true,
      "16195": true,
      "16196": true,
      "16197": true,
      "16198": true,
      "16199": true,
      "16200": true,
      "16201": true,
      "16202": true,
      "16203": true,
      "16204": true,
      "16205": true,
      "16206": true,
      "16207": true,
      "16208": true,
      "16209": true,
      "16210": true,
      "16211": true,
      "16212": true,
      "16213": true,
      "16214": true,
      "16215": true,
      "16216": true,
      "16217": true,
      "16218": true,
      "16219": true,
      "16220": true,
      "16221": true,
      "16222": true,
      "16223": true,
      "16224": true,
      "16225": true,
      "16226": true,
      "16227": true,
      "16228": true,
      "16229": true,
      "16230": true,
      "16231": true,
      "16232": true,
      "16233": true,
      "16234": true,
      "16235": true,
      "16236": true,
      "16237": true,
      "16238": true,
      "16239": true,
      "16240": true,
      "16241": true,
      "16242": true,
      "16243": true,
      "16244": true,
      "16245": true,
      "16246": true,
      "16247": true,
      "16248": true,
      "16249": true,
      "16250": true,
      "16251": true,
      "16252": true,
      "16253": true,
      "16254": true,
      "16255": true,
      "16256": true,
      "16257": true,
      "16258": true,
      "16259": true,
      "16260": true,
      "16261": true,
      "16262": true,
      "16263": true,
      "16264": true,
      "16265": true,
      "16266": true,
      "16267": true,
      "16268": true,
      "16269": true,
      "16270": true,
      "16271": true,
      "16272": true,
      "16273": true,
      "16274": true,
      "16275": true,
      "16276": true,
      "16277": true,
      "16278": true,
      "16279": true,
      "16280": true,
      "16281": true,
      "16282": true,
      "16283": true,
      "16284": true,
      "16285": true,
      "16286": true,
      "16287": true,
      "16288": true,
      "16289": true,
      "16290": true,
      "16291": true,
      "16292": true,
      "16293": true,
      "16294": true,
      "16295": true,
      "16296": true,
      "16297": true,
      "16298": true,
      "16299": true,
      "16300": true,
      "16301": true,
      "16302": true,
      "16303": true,
      "16304": true,
      "16305": true,
      "16306": true,
      "16307": true,
      "16308": true,
      "16309": true,
      "16310": true,
      "16311": true,
      "16312": true,
      "16313": true,
      "16314": true,
      "16315": true,
      "16316": true,
      "16317": true,
      "16318": true,
      "16319": true,
      "16320": true,
      "16321": true,
      "16322": true,
      "16323": true,
      "16324": true,
      "16325": true,
      "16326": true,
      "16327": true,
      "16328": true,
      "16329": true,
      "16330": true,
      "16331": true,
      "16332": true,
      "16333": true,
      "16334": true,
      "16335": true,
      "16336": true,
      "16337": true,
      "16338": true,
      "16339": true,
      "16340": true,
      "16341": true,
      "16342": true,
      "16343": true,
      "16344": true,
      "16345": true,
      "16346": true,
      "16347": true,
      "16348": true,
      "16349": true,
      "16350": true,
      "16351": true,
      "16352": true,
      "16353": true,
      "16354": true,
      "16355": true,
      "16356": true,
      "16357": true,
      "16358": true,
      "16359": true,
      "16360": true,
      "16361": true,
      "16362": true,
      "16363": true,
      "16364": true,
      "16365": true,
      "16366": true,
      "16367": true,
      "16368": true,
      "16369": true,
      "16370": true,
      "16371": true,
      "16372": true,
      "16373": true,
      "16374": true,
      "16375": true,
      "16376": true,
      "16377": true,
      "16378": true,
      "16379": true,
      "16380": true,
      "16381": true,
      "16382": true,
      "16383": true,
      "16384": true,
      "16385": true,
      "16386": true,
      "16387": true,
      "16388": true,
      "16389": true,
      "16390": true,
      "16391": true,
      "16392": true,
      "16393": true,
      "16394": true,
      "16395": true,
      "16396": true,
      "16397": true,
      "16398": true,
      "16399": true,
      "16400": true,
      "16401": true,
      "16402": true,
      "16403": true,
      "16404": true,
      "16405": true,
      "16406": true,
      "16407": true,
      "16408": true,
      "16409": true,
      "16410": true,
      "16411": true,
      "16412": true,
      "16413": true,
      "16414": true,
      "16415": true,
      "16416": true,
      "16417": true,
      "16418": true,
      "16419": true,
      "16420": true,
      "16421": true,
      "16422": true,
      "16423": true,
      "16424": true,
      "16425": true,
      "16426": true,
      "16427": true,
      "16428": true,
      "16429": true,
      "16430": true,
      "16431": true,
      "16432": true,
      "16433": true,
      "16434": true,
      "16435": true,
      "16436": true,
      "16437": true,
      "16438": true,
      "16439": true,
      "16440": true,
      "16441": true,
      "16442": true,
      "16443": true,
      "16444": true,
      "16445": true,
      "16446": true,
      "16447": true,
      "16448": true,
      "16449": true,
      "16450": true,
      "16451": true,
      "16452": true,
      "16453": true,
      "16454": true,
      "16455": true,
      "16456": true,
      "16457": true,
      "16458": true,
      "16459": true,
      "16460": true,
      "16461": true,
      "16462": true,
      "16463": true,
      "16464": true,
      "16465": true,
      "16466": true,
      "16467": true,
      "16468": true,
      "16469": true,
      "16470": true,
      "16471": true,
      "16472": true,
      "16473": true,
      "16474": true,
      "16475": true,
      "16476": true,
      "16477": true,
      "16478": true,
      "16479": true,
      "16480": true,
      "16481": true,
      "16482": true,
      "16483": true,
      "16484": true,
      "16485": true,
      "16486": true,
      "16487": true,
      "16488": true,
      "16489": true,
      "16490": true,
      "16491": true,
      "16492": true,
      "16493": true,
      "16494": true,
      "16495": true,
      "16496": true,
      "16497": true,
      "16498": true,
      "16499": true,
      "16500": true,
      "16501": true,
      "16502": true,
      "16503": true,
      "16504": true,
      "16505": true,
      "16506": true,
      "16507": true,
      "16508": true,
      "16509": true,
      "16510": true,
      "16511": true,
      "16512": true,
      "16513": true,
      "16514": true,
      "16515": true,
      "16516": true,
      "16517": true,
      "16518": true,
      "16519": true,
      "16520": true,
      "16521": true,
      "16522": true,
      "16523": true,
      "16524": true,
      "16525": true,
      "16526": true,
      "16527": true,
      "16528": true,
      "16529": true,
      "16530": true,
      "16531": true,
      "16532": true,
      "16533": true,
      "16534": true,
      "16535": true,
      "16536": true,
      "16537": true,
      "16538": true,
      "16539": true,
      "16540": true,
      "16541": true,
      "16542": true,
      "16543": true,
      "16544": true,
      "16545": true,
      "16546": true,
      "16547": true,
      "16548": true,
      "16549": true,
      "16550": true,
      "16551": true,
      "16552": true,
      "16553": true,
      "16554": true,
      "16555": true,
      "16556": true,
      "16557": true,
      "16558": true,
      "16559": true,
      "16560": true,
      "16561": true,
      "16562": true,
      "16563": true,
      "16564": true,
      "16565": true,
      "16566": true,
      "16567": true,
      "16568": true,
      "16569": true,
      "16570": true,
      "16571": true,
      "16572": true,
      "16573": true,
      "16574": true,
      "16575": true,
      "16576": true,
      "16577": true,
      "16578": true,
      "16579": true,
      "16580": true,
      "16581": true,
      "16582": true,
      "16583": true,
      "16584": true,
      "16585": true,
      "16586": true,
      "16587": true,
      "16588": true,
      "16589": true,
      "16590": true,
      "16591": true,
      "16592": true,
      "16593": true,
      "16594": true,
      "16595": true,
      "16596": true,
      "16597": true,
      "16598": true,
      "16599": true,
      "16600": true,
      "16601": true,
      "16602": true,
      "16603": true,
      "16604": true,
      "16605": true,
      "16606": true,
      "16607": true,
      "16608": true,
      "16609": true,
      "16610": true,
      "16611": true,
      "16612": true,
      "16613": true,
      "16614": true,
      "16615": true,
      "16616": true,
      "16617": true,
      "16618": true,
      "16619": true,
      "16620": true,
      "16621": true,
      "16622": true,
      "16623": true,
      "16624": true,
      "16625": true,
      "16626": true,
      "16627": true,
      "16628": true,
      "16629": true,
      "16630": true,
      "16631": true,
      "16632": true,
      "16633": true,
      "16634": true,
      "16635": true,
      "16636": true,
      "16637": true,
      "16638": true,
      "16639": true,
      "16640": true,
      "16641": true,
      "16642": true,
      "16643": true,
      "16644": true,
      "16645": true,
      "16646": true,
      "16647": true,
      "16648": true,
      "16649": true,
      "16650": true,
      "16651": true,
      "16652": true,
      "16653": true,
      "16654": true,
      "16655": true,
      "16656": true,
      "16657": true,
      "16658": true,
      "16659": true,
      "16660": true,
      "16661": true,
      "16662": true,
      "16663": true,
      "16664": true,
      "16665": true,
      "16666": true,
      "16667": true,
      "16668": true,
      "16669": true,
      "16670": true,
      "16671": true,
      "16672": true,
      "16673": true,
      "16674": true,
      "16675": true,
      "16676": true,
      "16677": true,
      "16678": true,
      "16679": true,
      "16680": true,
      "16681": true,
      "16682": true,
      "16683": true,
      "16684": true,
      "16685": true,
      "16686": true,
      "16687": true,
      "16688": true,
      "16689": true,
      "16690": true,
      "16691": true,
      "16692": true,
      "16693": true,
      "16694": true,
      "16695": true,
      "16696": true,
      "16697": true,
      "16698": true,
      "16699": true,
      "16700": true,
      "16701": true,
      "16702": true,
      "16703": true,
      "16704": true,
      "16705": true,
      "16706": true,
      "16707": true,
      "16708": true,
      "16709": true,
      "16710": true,
      "16711": true,
      "16712": true,
      "16713": true,
      "16714": true,
      "16715": true,
      "16716": true,
      "16717": true,
      "16718": true,
      "16719": true,
      "16720": true,
      "16721": true,
      "16722": true,
      "16723": true,
      "16724": true,
      "16725": true,
      "16726": true,
      "16727": true,
      "16728": true,
      "16729": true,
      "16730": true,
      "16731": true,
      "16732": true,
      "16733": true,
      "16734": true,
      "16735": true,
      "16736": true,
      "16737": true,
      "16738": true,
      "16739": true,
      "16740": true,
      "16741": true,
      "16742": true,
      "16743": true,
      "16744": true,
      "16745": true,
      "16746": true,
      "16747": true,
      "16748": true,
      "16749": true,
      "16750": true,
      "16751": true,
      "16752": true,
      "16753": true,
      "16754": true,
      "16755": true,
      "16756": true,
      "16757": true,
      "16758": true,
      "16759": true,
      "16760": true,
      "16761": true,
      "16762": true,
      "16763": true,
      "16764": true,
      "16765": true,
      "16766": true,
      "16767": true,
      "16768": true,
      "16769": true,
      "16770": true,
      "16771": true,
      "16772": true,
      "16773": true,
      "16774": true,
      "16775": true,
      "16776": true,
      "16777": true,
      "16778": true,
      "16779": true,
      "16780": true,
      "16781": true,
      "16782": true,
      "16783": true,
      "16784": true,
      "16785": true,
      "16786": true,
      "16787": true,
      "16788": true,
      "16789": true,
      "16790": true,
      "16791": true,
      "16792": true,
      "16793": true,
      "16794": true,
      "16795": true,
      "16796": true,
      "16797": true,
      "16798": true,
      "16799": true,
      "16800": true,
      "16801": true,
      "16802": true,
      "16803": true,
      "16804": true,
      "16805": true,
      "16806": true,
      "16807": true,
      "16808": true,
      "16809": true,
      "16810": true,
      "16811": true,
      "16812": true,
      "16813": true,
      "16814": true,
      "16815": true,
      "16816": true,
      "16817": true,
      "16818": true,
      "16819": true,
      "16820": true,
      "16821": true,
      "16822": true,
      "16823": true,
      "16824": true,
      "16825": true,
      "16826": true,
      "16827": true,
      "16828": true,
      "16829": true,
      "16830": true,
      "16831": true,
      "16832": true,
      "16833": true,
      "16834": true,
      "16835": true,
      "16836": true,
      "16837": true,
      "16838": true,
      "16839": true,
      "16840": true,
      "16841": true,
      "16842": true,
      "16843": true,
      "16844": true,
      "16845": true,
      "16846": true,
      "16847": true,
      "16848": true,
      "16849": true,
      "16850": true,
      "16851": true,
      "16852": true,
      "16853": true,
      "16854": true,
      "16855": true,
      "16856": true,
      "16857": true,
      "16858": true,
      "16859": true,
      "16860": true,
      "16861": true,
      "16862": true,
      "16863": true,
      "16864": true,
      "16865": true,
      "16866": true,
      "16867": true,
      "16868": true,
      "16869": true,
      "16870": true,
      "16871": true,
      "16872": true,
      "16873": true,
      "16874": true,
      "16875": true,
      "16876": true,
      "16877": true,
      "16878": true,
      "16879": true,
      "16880": true,
      "16881": true,
      "16882": true,
      "16883": true,
      "16884": true,
      "16885": true,
      "16886": true,
      "16887": true,
      "16888": true,
      "16889": true,
      "16890": true,
      "16891": true,
      "16892": true,
      "16893": true,
      "16894": true,
      "16895": true,
      "16896": true,
      "16897": true,
      "16898": true,
      "16899": true,
      "16900": true,
      "16901": true,
      "16902": true,
      "16903": true,
      "16904": true,
      "16905": true,
      "16906": true,
      "16907": true,
      "16908": true,
      "16909": true,
      "16910": true,
      "16911": true,
      "16912": true,
      "16913": true,
      "16914": true,
      "16915": true,
      "16916": true,
      "16917": true,
      "16918": true,
      "16919": true,
      "16920": true,
      "16921": true,
      "16922": true,
      "16923": true,
      "16924": true,
      "16925": true,
      "16926": true,
      "16927": true,
      "16928": true,
      "16929": true,
      "16930": true,
      "16931": true,
      "16932": true,
      "16933": true,
      "16934": true,
      "16935": true,
      "16936": true,
      "16937": true,
      "16938": true,
      "16939": true,
      "16940": true,
      "16941": true,
      "16942": true,
      "16943": true,
      "16944": true,
      "16945": true,
      "16946": true,
      "16947": true,
      "16948": true,
      "16949": true,
      "16950": true,
      "16951": true,
      "16952": true,
      "16953": true,
      "16954": true,
      "16955": true,
      "16956": true,
      "16957": true,
      "16958": true,
      "16959": true,
      "16960": true,
      "16961": true,
      "16962": true,
      "16963": true,
      "16964": true,
      "16965": true,
      "16966": true,
      "16967": true,
      "16968": true,
      "16969": true,
      "16970": true,
      "16971": true,
      "16972": true,
      "16973": true,
      "16974": true,
      "16975": true,
      "16976": true,
      "16977": true,
      "16978": true,
      "16979": true,
      "16980": true,
      "16981": true,
      "16982": true,
      "16983": true,
      "16984": true,
      "16985": true,
      "16986": true,
      "16987": true,
      "16988": true,
      "16989": true,
      "16990": true,
      "16991": true,
      "16992": true,
      "16993": true,
      "16994": true,
      "16995": true,
      "16996": true,
      "16997": true,
      "16998": true,
      "16999": true,
      "17000": true,
      "17001": true,
      "17002": true,
      "17003": true,
      "17004": true,
      "17005": true,
      "17006": true,
      "17007": true,
      "17008": true,
      "17009": true,
      "17010": true,
      "17011": true,
      "17012": true,
      "17013": true,
      "17014": true,
      "17015": true,
      "17016": true,
      "17017": true,
      "17018": true,
      "17019": true,
      "17020": true,
      "17021": true,
      "17022": true,
      "17023": true,
      "17024": true,
      "17025": true,
      "17026": true,
      "17027": true,
      "17028": true,
      "17029": true,
      "17030": true,
      "17031": true,
      "17032": true,
      "17033": true,
      "17034": true,
      "17035": true,
      "17036": true,
      "17037": true,
      "17038": true,
      "17039": true,
      "17040": true,
      "17041": true,
      "17042": true,
      "17043": true,
      "17044": true,
      "17045": true,
      "17046": true,
      "17047": true,
      "17048": true,
      "17049": true,
      "17050": true,
      "17051": true,
      "17052": true,
      "17053": true,
      "17054": true,
      "17055": true,
      "17056": true,
      "17057": true,
      "17058": true,
      "17059": true,
      "17060": true,
      "17061": true,
      "17062": true,
      "17063": true,
      "17064": true,
      "17065": true,
      "17066": true,
      "17067": true,
      "17068": true,
      "17069": true,
      "17070": true,
      "17071": true,
      "17072": true,
      "17073": true,
      "17074": true,
      "17075": true,
      "17076": true,
      "17077": true,
      "17078": true,
      "17079": true,
      "17080": true,
      "17081": true,
      "17082": true,
      "17083": true,
      "17084": true,
      "17085": true,
      "17086": true,
      "17087": true,
      "17088": true,
      "17089": true,
      "17090": true,
      "17091": true,
      "17092": true,
      "17093": true,
      "17094": true,
      "17095": true,
      "17096": true,
      "17097": true,
      "17098": true,
      "17099": true,
      "17100": true,
      "17101": true,
      "17102": true,
      "17103": true,
      "17104": true,
      "17105": true,
      "17106": true,
      "17107": true,
      "17108": true,
      "17109": true,
      "17110": true,
      "17111": true,
      "17112": true,
      "17113": true,
      "17114": true,
      "17115": true,
      "17116": true,
      "17117": true,
      "17118": true,
      "17119": true,
      "17120": true,
      "17121": true,
      "17122": true,
      "17123": true,
      "17124": true,
      "17125": true,
      "17126": true,
      "17127": true,
      "17128": true,
      "17129": true,
      "17130": true,
      "17131": true,
      "17132": true,
      "17133": true,
      "17134": true,
      "17135": true,
      "17136": true,
      "17137": true,
      "17138": true,
      "17139": true,
      "17140": true,
      "17141": true,
      "17142": true,
      "17143": true,
      "17144": true,
      "17145": true,
      "17146": true,
      "17147": true,
      "17148": true,
      "17149": true,
      "17150": true,
      "17151": true,
      "17152": true,
      "17153": true,
      "17154": true,
      "17155": true,
      "17156": true,
      "17157": true,
      "17158": true,
      "17159": true,
      "17160": true,
      "17161": true,
      "17162": true,
      "17163": true,
      "17164": true,
      "17165": true,
      "17166": true,
      "17167": true,
      "17168": true,
      "17169": true,
      "17170": true,
      "17171": true,
      "17172": true,
      "17173": true,
      "17174": true,
      "17175": true,
      "17176": true,
      "17177": true,
      "17178": true,
      "17179": true,
      "17180": true,
      "17181": true,
      "17182": true,
      "17183": true,
      "17184": true,
      "17185": true,
      "17186": true,
      "17187": true,
      "17188": true,
      "17189": true,
      "17190": true,
      "17191": true,
      "17192": true,
      "17193": true,
      "17194": true,
      "17195": true,
      "17196": true,
      "17197": true,
      "17198": true,
      "17199": true,
      "17200": true,
      "17201": true,
      "17202": true,
      "17203": true,
      "17204": true,
      "17205": true,
      "17206": true,
      "17207": true,
      "17208": true,
      "17209": true,
      "17210": true,
      "17211": true,
      "17212": true,
      "17213": true,
      "17214": true,
      "17215": true,
      "17216": true,
      "17217": true,
      "17218": true,
      "17219": true,
      "17220": true,
      "17221": true,
      "17222": true,
      "17223": true,
      "17224": true,
      "17225": true,
      "17226": true,
      "17227": true,
      "17228": true,
      "17229": true,
      "17230": true,
      "17231": true,
      "17232": true,
      "17233": true,
      "17234": true,
      "17235": true,
      "17236": true,
      "17237": true,
      "17238": true,
      "17239": true,
      "17240": true,
      "17241": true,
      "17242": true,
      "17243": true,
      "17244": true,
      "17245": true,
      "17246": true,
      "17247": true,
      "17248": true,
      "17249": true,
      "17250": true,
      "17251": true,
      "17252": true,
      "17253": true,
      "17254": true,
      "17255": true,
      "17256": true,
      "17257": true,
      "17258": true,
      "17259": true,
      "17260": true,
      "17261": true,
      "17262": true,
      "17263": true,
      "17264": true,
      "17265": true,
      "17266": true,
      "17267": true,
      "17268": true,
      "17269": true,
      "17270": true,
      "17271": true,
      "17272": true,
      "17273": true,
      "17274": true,
      "17275": true,
      "17276": true,
      "17277": true,
      "17278": true,
      "17279": true,
      "17280": true,
      "17281": true,
      "17282": true,
      "17283": true,
      "17284": true,
      "17285": true,
      "17286": true,
      "17287": true,
      "17288": true,
      "17289": true,
      "17290": true,
      "17291": true,
      "17292": true,
      "17293": true,
      "17294": true,
      "17295": true,
      "17296": true,
      "17297": true,
      "17298": true,
      "17299": true,
      "17300": true,
      "17301": true,
      "17302": true,
      "17303": true,
      "17304": true,
      "17305": true,
      "17306": true,
      "17307": true,
      "17308": true,
      "17309": true,
      "17310": true,
      "17311": true,
      "17312": true,
      "17313": true,
      "17314": true,
      "17315": true,
      "17316": true,
      "17317": true,
      "17318": true,
      "17319": true,
      "17320": true,
      "17321": true,
      "17322": true,
      "17323": true,
      "17324": true,
      "17325": true,
      "17326": true,
      "17327": true,
      "17328": true,
      "17329": true,
      "17330": true,
      "17331": true,
      "17332": true,
      "17333": true,
      "17334": true,
      "17335": true,
      "17336": true,
      "17337": true,
      "17338": true,
      "17339": true,
      "17340": true,
      "17341": true,
      "17342": true,
      "17343": true,
      "17344": true,
      "17345": true,
      "17346": true,
      "17347": true,
      "17348": true,
      "17349": true,
      "17350": true,
      "17351": true,
      "17352": true,
      "17353": true,
      "17354": true,
      "17355": true,
      "17356": true,
      "17357": true,
      "17358": true,
      "17359": true,
      "17360": true,
      "17361": true,
      "17362": true,
      "17363": true,
      "17364": true,
      "17365": true,
      "17366": true,
      "17367": true,
      "17368": true,
      "17369": true,
      "17370": true,
      "17371": true,
      "17372": true,
      "17373": true,
      "17374": true,
      "17375": true,
      "17376": true,
      "17377": true,
      "17378": true,
      "17379": true,
      "17380": true,
      "17381": true,
      "17382": true,
      "17383": true,
      "17384": true,
      "17385": true,
      "17386": true,
      "17387": true,
      "17388": true,
      "17389": true,
      "17390": true,
      "17391": true,
      "17392": true,
      "17393": true,
      "17394": true,
      "17395": true,
      "17396": true,
      "17397": true,
      "17398": true,
      "17399": true,
      "17400": true,
      "17401": true,
      "17402": true,
      "17403": true,
      "17404": true,
      "17405": true,
      "17406": true,
      "17407": true,
      "17408": true,
      "17409": true,
      "17410": true,
      "17411": true,
      "17412": true,
      "17413": true,
      "17414": true,
      "17415": true,
      "17416": true,
      "17417": true,
      "17418": true,
      "17419": true,
      "17420": true,
      "17421": true,
      "17422": true,
      "17423": true,
      "17424": true,
      "17425": true,
      "17426": true,
      "17427": true,
      "17428": true,
      "17429": true,
      "17430": true,
      "17431": true,
      "17432": true,
      "17433": true,
      "17434": true,
      "17435": true,
      "17436": true,
      "17437": true,
      "17438": true,
      "17439": true,
      "17440": true,
      "17441": true,
      "17442": true,
      "17443": true,
      "17444": true,
      "17445": true,
      "17446": true,
      "17447": true,
      "17448": true,
      "17449": true,
      "17450": true,
      "17451": true,
      "17452": true,
      "17453": true,
      "17454": true,
      "17455": true,
      "17456": true,
      "17457": true,
      "17458": true,
      "17459": true,
      "17460": true,
      "17461": true,
      "17462": true,
      "17463": true,
      "17464": true,
      "17465": true,
      "17466": true,
      "17467": true,
      "17468": true,
      "17469": true,
      "17470": true,
      "17471": true,
      "17472": true,
      "17473": true,
      "17474": true,
      "17475": true,
      "17476": true,
      "17477": true,
      "17478": true,
      "17479": true,
      "17480": true,
      "17481": true,
      "17482": true,
      "17483": true,
      "17484": true,
      "17485": true,
      "17486": true,
      "17487": true,
      "17488": true,
      "17489": true,
      "17490": true,
      "17491": true,
      "17492": true,
      "17493": true,
      "17494": true,
      "17495": true,
      "17496": true,
      "17497": true,
      "17498": true,
      "17499": true,
      "17500": true,
      "17501": true,
      "17502": true,
      "17503": true,
      "17504": true,
      "17505": true,
      "17506": true,
      "17507": true,
      "17508": true,
      "17509": true,
      "17510": true,
      "17511": true,
      "17512": true,
      "17513": true,
      "17514": true,
      "17515": true,
      "17516": true,
      "17517": true,
      "17518": true,
      "17519": true,
      "17520": true,
      "17521": true,
      "17522": true,
      "17523": true,
      "17524": true,
      "17525": true,
      "17526": true,
      "17527": true,
      "17528": true,
      "17529": true,
      "17530": true,
      "17531": true,
      "17532": true,
      "17533": true,
      "17534": true,
      "17535": true,
      "17536": true,
      "17537": true,
      "17538": true,
      "17539": true,
      "17540": true,
      "17541": true,
      "17542": true,
      "17543": true,
      "17544": true,
      "17545": true,
      "17546": true,
      "17547": true,
      "17548": true,
      "17549": true,
      "17550": true,
      "17551": true,
      "17552": true,
      "17553": true,
      "17554": true,
      "17555": true,
      "17556": true,
      "17557": true,
      "17558": true,
      "17559": true,
      "17560": true,
      "17561": true,
      "17562": true,
      "17563": true,
      "17564": true,
      "17565": true,
      "17566": true,
      "17567": true,
      "17568": true,
      "17569": true,
      "17570": true,
      "17571": true,
      "17572": true,
      "17573": true,
      "17574": true,
      "17575": true,
      "17576": true,
      "17577": true,
      "17578": true,
      "17579": true,
      "17580": true,
      "17581": true,
      "17582": true,
      "17583": true,
      "17584": true,
      "17585": true,
      "17586": true,
      "17587": true,
      "17588": true,
      "17589": true,
      "17590": true,
      "17591": true,
      "17592": true,
      "17593": true,
      "17594": true,
      "17595": true,
      "17596": true,
      "17597": true,
      "17598": true,
      "17599": true,
      "17600": true,
      "17601": true,
      "17602": true,
      "17603": true,
      "17604": true,
      "17605": true,
      "17606": true,
      "17607": true,
      "17608": true,
      "17609": true,
      "17610": true,
      "17611": true,
      "17612": true,
      "17613": true,
      "17614": true,
      "17615": true,
      "17616": true,
      "17617": true,
      "17618": true,
      "17619": true,
      "17620": true,
      "17621": true,
      "17622": true,
      "17623": true,
      "17624": true,
      "17625": true,
      "17626": true,
      "17627": true,
      "17628": true,
      "17629": true,
      "17630": true,
      "17631": true,
      "17632": true,
      "17633": true,
      "17634": true,
      "17635": true,
      "17636": true,
      "17637": true,
      "17638": true,
      "17639": true,
      "17640": true,
      "17641": true,
      "17642": true,
      "17643": true,
      "17644": true,
      "17645": true,
      "17646": true,
      "17647": true,
      "17648": true,
      "17649": true,
      "17650": true,
      "17651": true,
      "17652": true,
      "17653": true,
      "17654": true,
      "17655": true,
      "17656": true,
      "17657": true,
      "17658": true,
      "17659": true,
      "17660": true,
      "17661": true,
      "17662": true,
      "17663": true,
      "17664": true,
      "17665": true,
      "17666": true,
      "17667": true,
      "17668": true,
      "17669": true,
      "17670": true,
      "17671": true,
      "17672": true,
      "17673": true,
      "17674": true,
      "17675": true,
      "17676": true,
      "17677": true,
      "17678": true,
      "17679": true,
      "17680": true,
      "17681": true,
      "17682": true,
      "17683": true,
      "17684": true,
      "17685": true,
      "17686": true,
      "17687": true,
      "17688": true,
      "17689": true,
      "17690": true,
      "17691": true,
      "17692": true,
      "17693": true,
      "17694": true,
      "17695": true,
      "17696": true,
      "17697": true,
      "17698": true,
      "17699": true,
      "17700": true,
      "17701": true,
      "17702": true,
      "17703": true,
      "17704": true,
      "17705": true,
      "17706": true,
      "17707": true,
      "17708": true,
      "17709": true,
      "17710": true,
      "17711": true,
      "17712": true,
      "17713": true,
      "17714": true,
      "17715": true,
      "17716": true,
      "17717": true,
      "17718": true,
      "17719": true,
      "17720": true,
      "17721": true,
      "17722": true,
      "17723": true,
      "17724": true,
      "17725": true,
      "17726": true,
      "17727": true,
      "17728": true,
      "17729": true,
      "17730": true,
      "17731": true,
      "17732": true,
      "17733": true,
      "17734": true,
      "17735": true,
      "17736": true,
      "17737": true,
      "17738": true,
      "17739": true,
      "17740": true,
      "17741": true,
      "17742": true,
      "17743": true,
      "17744": true,
      "17745": true,
      "17746": true,
      "17747": true,
      "17748": true,
      "17749": true,
      "17750": true,
      "17751": true,
      "17752": true,
      "17753": true,
      "17754": true,
      "17755": true,
      "17756": true,
      "17757": true,
      "17758": true,
      "17759": true,
      "17760": true,
      "17761": true,
      "17762": true,
      "17763": true,
      "17764": true,
      "17765": true,
      "17766": true,
      "17767": true,
      "17768": true,
      "17769": true,
      "17770": true,
      "17771": true,
      "17772": true,
      "17773": true,
      "17774": true,
      "17775": true,
      "17776": true,
      "17777": true,
      "17778": true,
      "17779": true,
      "17780": true,
      "17781": true,
      "17782": true,
      "17783": true,
      "17784": true,
      "17785": true,
      "17786": true,
      "17787": true,
      "17788": true,
      "17789": true,
      "17790": true,
      "17791": true,
      "17792": true,
      "17793": true,
      "17794": true,
      "17795": true,
      "17796": true,
      "17797": true,
      "17798": true,
      "17799": true,
      "17800": true,
      "17801": true,
      "17802": true,
      "17803": true,
      "17804": true,
      "17805": true,
      "17806": true,
      "17807": true,
      "17808": true,
      "17809": true,
      "17810": true,
      "17811": true,
      "17812": true,
      "17813": true,
      "17814": true,
      "17815": true,
      "17816": true,
      "17817": true,
      "17818": true,
      "17819": true,
      "17820": true,
      "17821": true,
      "17822": true,
      "17823": true,
      "17824": true,
      "17825": true,
      "17826": true,
      "17827": true,
      "17828": true,
      "17829": true,
      "17830": true,
      "17831": true,
      "17832": true,
      "17833": true,
      "17834": true,
      "17835": true,
      "17836": true,
      "17837": true,
      "17838": true,
      "17839": true,
      "17840": true,
      "17841": true,
      "17842": true,
      "17843": true,
      "17844": true,
      "17845": true,
      "17846": true,
      "17847": true,
      "17848": true,
      "17849": true,
      "17850": true,
      "17851": true,
      "17852": true,
      "17853": true,
      "17854": true,
      "17855": true,
      "17856": true,
      "17857": true,
      "17858": true,
      "17859": true,
      "17860": true,
      "17861": true,
      "17862": true,
      "17863": true,
      "17864": true,
      "17865": true,
      "17866": true,
      "17867": true,
      "17868": true,
      "17869": true,
      "17870": true,
      "17871": true,
      "17872": true,
      "17873": true,
      "17874": true,
      "17875": true,
      "17876": true,
      "17877": true,
      "17878": true,
      "17879": true,
      "17880": true,
      "17881": true,
      "17882": true,
      "17883": true,
      "17884": true,
      "17885": true,
      "17886": true,
      "17887": true,
      "17888": true,
      "17889": true,
      "17890": true,
      "17891": true,
      "17892": true,
      "17893": true,
      "17894": true,
      "17895": true,
      "17896": true,
      "17897": true,
      "17898": true,
      "17899": true,
      "17900": true,
      "17901": true,
      "17902": true,
      "17903": true,
      "17904": true,
      "17905": true,
      "17906": true,
      "17907": true,
      "17908": true,
      "17909": true,
      "17910": true,
      "17911": true,
      "17912": true,
      "17913": true,
      "17914": true,
      "17915": true,
      "17916": true,
      "17917": true,
      "17918": true,
      "17919": true,
      "17920": true,
      "17921": true,
      "17922": true,
      "17923": true,
      "17924": true,
      "17925": true,
      "17926": true,
      "17927": true,
      "17928": true,
      "17929": true,
      "17930": true,
      "17931": true,
      "17932": true,
      "17933": true,
      "17934": true,
      "17935": true,
      "17936": true,
      "17937": true,
      "17938": true,
      "17939": true,
      "17940": true,
      "17941": true,
      "17942": true,
      "17943": true,
      "17944": true,
      "17945": true,
      "17946": true,
      "17947": true,
      "17948": true,
      "17949": true,
      "17950": true,
      "17951": true,
      "17952": true,
      "17953": true,
      "17954": true,
      "17955": true,
      "17956": true,
      "17957": true,
      "17958": true,
      "17959": true,
      "17960": true,
      "17961": true,
      "17962": true,
      "17963": true,
      "17964": true,
      "17965": true,
      "17966": true,
      "17967": true,
      "17968": true,
      "17969": true,
      "17970": true,
      "17971": true,
      "17972": true,
      "17973": true,
      "17974": true,
      "17975": true,
      "17976": true,
      "17977": true,
      "17978": true,
      "17979": true,
      "17980": true,
      "17981": true,
      "17982": true,
      "17983": true,
      "17984": true,
      "17985": true,
      "17986": true,
      "17987": true,
      "17988": true,
      "17989": true,
      "17990": true,
      "17991": true,
      "17992": true,
      "17993": true,
      "17994": true,
      "17995": true,
      "17996": true,
      "17997": true,
      "17998": true,
      "17999": true,
      "18000": true,
      "18001": true,
      "18002": true,
      "18003": true,
      "18004": true,
      "18005": true,
      "18006": true,
      "18007": true,
      "18008": true,
      "18009": true,
      "18010": true,
      "18011": true,
      "18012": true,
      "18013": true,
      "18014": true,
      "18015": true,
      "18016": true,
      "18017": true,
      "18018": true,
      "18019": true,
      "18020": true,
      "18021": true,
      "18022": true,
      "18023": true,
      "18024": true,
      "18025": true,
      "18026": true,
      "18027": true,
      "18028": true,
      "18029": true,
      "18030": true,
      "18031": true,
      "18032": true,
      "18033": true,
      "18034": true,
      "18035": true,
      "18036": true,
      "18037": true,
      "18038": true,
      "18039": true,
      "18040": true,
      "18041": true,
      "18042": true,
      "18043": true,
      "18044": true,
      "18045": true,
      "18046": true,
      "18047": true,
      "18048": true,
      "18049": true,
      "18050": true,
      "18051": true,
      "18052": true,
      "18053": true,
      "18054": true,
      "18055": true,
      "18056": true,
      "18057": true,
      "18058": true,
      "18059": true,
      "18060": true,
      "18061": true,
      "18062": true,
      "18063": true,
      "18064": true,
      "18065": true,
      "18066": true,
      "18067": true,
      "18068": true,
      "18069": true,
      "18070": true,
      "18071": true,
      "18072": true,
      "18073": true,
      "18074": true,
      "18075": true,
      "18076": true,
      "18077": true,
      "18078": true,
      "18079": true,
      "18080": true,
      "18081": true,
      "18082": true,
      "18083": true,
      "18084": true,
      "18085": true,
      "18086": true,
      "18087": true,
      "18088": true,
      "18089": true,
      "18090": true,
      "18091": true,
      "18092": true,
      "18093": true,
      "18094": true,
      "18095": true,
      "18096": true,
      "18097": true,
      "18098": true,
      "18099": true,
      "18100": true,
      "18101": true,
      "18102": true,
      "18103": true,
      "18104": true,
      "18105": true,
      "18106": true,
      "18107": true,
      "18108": true,
      "18109": true,
      "18110": true,
      "18111": true,
      "18112": true,
      "18113": true,
      "18114": true,
      "18115": true,
      "18116": true,
      "18117": true,
      "18118": true,
      "18119": true,
      "18120": true,
      "18121": true,
      "18122": true,
      "18123": true,
      "18124": true,
      "18125": true,
      "18126": true,
      "18127": true,
      "18128": true,
      "18129": true,
      "18130": true,
      "18131": true,
      "18132": true,
      "18133": true,
      "18134": true,
      "18135": true,
      "18136": true,
      "18137": true,
      "18138": true,
      "18139": true,
      "18140": true,
      "18141": true,
      "18142": true,
      "18143": true,
      "18144": true,
      "18145": true,
      "18146": true,
      "18147": true,
      "18148": true,
      "18149": true,
      "18150": true,
      "18151": true,
      "18152": true,
      "18153": true,
      "18154": true,
      "18155": true,
      "18156": true,
      "18157": true,
      "18158": true,
      "18159": true,
      "18160": true,
      "18161": true,
      "18162": true,
      "18163": true,
      "18164": true,
      "18165": true,
      "18166": true,
      "18167": true,
      "18168": true,
      "18169": true,
      "18170": true,
      "18171": true,
      "18172": true,
      "18173": true,
      "18174": true,
      "18175": true,
      "18176": true,
      "18177": true,
      "18178": true,
      "18179": true,
      "18180": true,
      "18181": true,
      "18182": true,
      "18183": true,
      "18184": true,
      "18185": true,
      "18186": true,
      "18187": true,
      "18188": true,
      "18189": true,
      "18190": true,
      "18191": true,
      "18192": true,
      "18193": true,
      "18194": true,
      "18195": true,
      "18196": true,
      "18197": true,
      "18198": true,
      "18199": true,
      "18200": true,
      "18201": true,
      "18202": true,
      "18203": true,
      "18204": true,
      "18205": true,
      "18206": true,
      "18207": true,
      "18208": true,
      "18209": true,
      "18210": true,
      "18211": true,
      "18212": true,
      "18213": true,
      "18214": true,
      "18215": true,
      "18216": true,
      "18217": true,
      "18218": true,
      "18219": true,
      "18220": true,
      "18221": true,
      "18222": true,
      "18223": true,
      "18224": true,
      "18225": true,
      "18226": true,
      "18227": true,
      "18228": true,
      "18229": true,
      "18230": true,
      "18231": true,
      "18232": true,
      "18233": true,
      "18234": true,
      "18235": true,
      "18236": true,
      "18237": true,
      "18238": true,
      "18239": true,
      "18240": true,
      "18241": true,
      "18242": true,
      "18243": true,
      "18244": true,
      "18245": true,
      "18246": true,
      "18247": true,
      "18248": true,
      "18249": true,
      "18250": true,
      "18251": true,
      "18252": true,
      "18253": true,
      "18254": true,
      "18255": true,
      "18256": true,
      "18257": true,
      "18258": true,
      "18259": true,
      "18260": true,
      "18261": true,
      "18262": true,
      "18263": true,
      "18264": true,
      "18265": true,
      "18266": true,
      "18267": true,
      "18268": true,
      "18269": true,
      "18270": true,
      "18271": true,
      "18272": true,
      "18273": true,
      "18274": true,
      "18275": true,
      "18276": true,
      "18277": true,
      "18278": true,
      "18279": true,
      "18280": true,
      "18281": true,
      "18282": true,
      "18283": true,
      "18284": true,
      "18285": true,
      "18286": true,
      "18287": true,
      "18288": true,
      "18289": true,
      "18290": true,
      "18291": true,
      "18292": true,
      "18293": true,
      "18294": true,
      "18295": true,
      "18296": true,
      "18297": true,
      "18298": true,
      "18299": true,
      "18300": true,
      "18301": true,
      "18302": true,
      "18303": true,
      "18304": true,
      "18305": true,
      "18306": true,
      "18307": true,
      "18308": true,
      "18309": true,
      "18310": true,
      "18311": true,
      "18312": true,
      "18313": true,
      "18314": true,
      "18315": true,
      "18316": true,
      "18317": true,
      "18318": true,
      "18319": true,
      "18320": true,
      "18321": true,
      "18322": true,
      "18323": true,
      "18324": true,
      "18325": true,
      "18326": true,
      "18327": true,
      "18328": true,
      "18329": true,
      "18330": true,
      "18331": true,
      "18332": true,
      "18333": true,
      "18334": true,
      "18335": true,
      "18336": true,
      "18337": true,
      "18338": true,
      "18339": true,
      "18340": true,
      "18341": true,
      "18342": true,
      "18343": true,
      "18344": true,
      "18345": true,
      "18346": true,
      "18347": true,
      "18348": true,
      "18349": true,
      "18350": true,
      "18351": true,
      "18352": true,
      "18353": true,
      "18354": true,
      "18355": true,
      "18356": true,
      "18357": true,
      "18358": true,
      "18359": true,
      "18360": true,
      "18361": true,
      "18362": true,
      "18363": true,
      "18364": true,
      "18365": true,
      "18366": true,
      "18367": true,
      "18368": true,
      "18369": true,
      "18370": true,
      "18371": true,
      "18372": true,
      "18373": true,
      "18374": true,
      "18375": true,
      "18376": true,
      "18377": true,
      "18378": true,
      "18379": true,
      "18380": true,
      "18381": true,
      "18382": true,
      "18383": true,
      "18384": true,
      "18385": true,
      "18386": true,
      "18387": true,
      "18388": true,
      "18389": true,
      "18390": true,
      "18391": true,
      "18392": true,
      "18393": true,
      "18394": true,
      "18395": true,
      "18396": true,
      "18397": true,
      "18398": true,
      "18399": true,
      "18400": true,
      "18401": true,
      "18402": true,
      "18403": true,
      "18404": true,
      "18405": true,
      "18406": true,
      "18407": true,
      "18408": true,
      "18409": true,
      "18410": true,
      "18411": true,
      "18412": true,
      "18413": true,
      "18414": true,
      "18415": true,
      "18416": true,
      "18417": true,
      "18418": true,
      "18419": true,
      "18420": true,
      "18421": true,
      "18422": true,
      "18423": true,
      "18424": true,
      "18425": true,
      "18426": true,
      "18427": true,
      "18428": true,
      "18429": true,
      "18430": true,
      "18431": true,
      "18432": true,
      "18433": true,
      "18434": true,
      "18435": true,
      "18436": true,
      "18437": true,
      "18438": true,
      "18439": true,
      "18440": true,
      "18441": true,
      "18442": true,
      "18443": true,
      "18444": true,
      "18445": true,
      "18446": true,
      "18447": true,
      "18448": true,
      "18449": true,
      "18450": true,
      "18451": true,
      "18452": true,
      "18453": true,
      "18454": true,
      "18455": true,
      "18456": true,
      "18457": true,
      "18458": true,
      "18459": true,
      "18460": true,
      "18461": true,
      "18462": true,
      "18463": true,
      "18464": true,
      "18465": true,
      "18466": true,
      "18467": true,
      "18468": true,
      "18469": true,
      "18470": true,
      "18471": true,
      "18472": true,
      "18473": true,
      "18474": true,
      "18475": true,
      "18476": true,
      "18477": true,
      "18478": true,
      "18479": true,
      "18480": true,
      "18481": true,
      "18482": true,
      "18483": true,
      "18484": true,
      "18485": true,
      "18486": true,
      "18487": true,
      "18488": true,
      "18489": true,
      "18490": true,
      "18491": true,
      "18492": true,
      "18493": true,
      "18494": true,
      "18495": true,
      "18496": true,
      "18497": true,
      "18498": true,
      "18499": true,
      "18500": true,
      "18501": true,
      "18502": true,
      "18503": true,
      "18504": true,
      "18505": true,
      "18506": true,
      "18507": true,
      "18508": true,
      "18509": true,
      "18510": true,
      "18511": true,
      "18512": true,
      "18513": true,
      "18514": true,
      "18515": true,
      "18516": true,
      "18517": true,
      "18518": true,
      "18519": true,
      "18520": true,
      "18521": true,
      "18522": true,
      "18523": true,
      "18524": true,
      "18525": true,
      "18526": true,
      "18527": true,
      "18528": true,
      "18529": true,
      "18530": true,
      "18531": true,
      "18532": true,
      "18533": true,
      "18534": true,
      "18535": true,
      "18536": true,
      "18537": true,
      "18538": true,
      "18539": true,
      "18540": true,
      "18541": true,
      "18542": true,
      "18543": true,
      "18544": true,
      "18545": true,
      "18546": true,
      "18547": true,
      "18548": true,
      "18549": true,
      "18550": true,
      "18551": true,
      "18552": true,
      "18553": true,
      "18554": true,
      "18555": true,
      "18556": true,
      "18557": true,
      "18558": true,
      "18559": true,
      "18560": true,
      "18561": true,
      "18562": true,
      "18563": true,
      "18564": true,
      "18565": true,
      "18566": true,
      "18567": true,
      "18568": true,
      "18569": true,
      "18570": true,
      "18571": true,
      "18572": true,
      "18573": true,
      "18574": true,
      "18575": true,
      "18576": true,
      "18577": true,
      "18578": true,
      "18579": true,
      "18580": true,
      "18581": true,
      "18582": true,
      "18583": true,
      "18584": true,
      "18585": true,
      "18586": true,
      "18587": true,
      "18588": true,
      "18589": true,
      "18590": true,
      "18591": true,
      "18592": true,
      "18593": true,
      "18594": true,
      "18595": true,
      "18596": true,
      "18597": true,
      "18598": true,
      "18599": true,
      "18600": true,
      "18601": true,
      "18602": true,
      "18603": true,
      "18604": true,
      "18605": true,
      "18606": true,
      "18607": true,
      "18608": true,
      "18609": true,
      "18610": true,
      "18611": true,
      "18612": true,
      "18613": true,
      "18614": true,
      "18615": true,
      "18616": true,
      "18617": true,
      "18618": true,
      "18619": true,
      "18620": true,
      "18621": true,
      "18622": true,
      "18623": true,
      "18624": true,
      "18625": true,
      "18626": true,
      "18627": true,
      "18628": true,
      "18629": true,
      "18630": true,
      "18631": true,
      "18632": true,
      "18633": true,
      "18634": true,
      "18635": true,
      "18636": true,
      "18637": true,
      "18638": true,
      "18639": true,
      "18640": true,
      "18641": true,
      "18642": true,
      "18643": true,
      "18644": true,
      "18645": true,
      "18646": true,
      "18647": true,
      "18648": true,
      "18649": true,
      "18650": true,
      "18651": true,
      "18652": true,
      "18653": true,
      "18654": true,
      "18655": true,
      "18656": true,
      "18657": true,
      "18658": true,
      "18659": true,
      "18660": true,
      "18661": true,
      "18662": true,
      "18663": true,
      "18664": true,
      "18665": true,
      "18666": true,
      "18667": true,
      "18668": true,
      "18669": true,
      "18670": true,
      "18671": true,
      "18672": true,
      "18673": true,
      "18674": true,
      "18675": true,
      "18676": true,
      "18677": true,
      "18678": true,
      "18679": true,
      "18680": true,
      "18681": true,
      "18682": true,
      "18683": true,
      "18684": true,
      "18685": true,
      "18686": true,
      "18687": true,
      "18688": true,
      "18689": true,
      "18690": true,
      "18691": true,
      "18692": true,
      "18693": true,
      "18694": true,
      "18695": true,
      "18696": true,
      "18697": true,
      "18698": true,
      "18699": true,
      "18700": true,
      "18701": true,
      "18702": true,
      "18703": true,
      "18704": true,
      "18705": true,
      "18706": true,
      "18707": true,
      "18708": true,
      "18709": true,
      "18710": true,
      "18711": true,
      "18712": true,
      "18713": true,
      "18714": true,
      "18715": true,
      "18716": true,
      "18717": true,
      "18718": true,
      "18719": true,
      "18720": true,
      "18721": true,
      "18722": true,
      "18723": true,
      "18724": true,
      "18725": true,
      "18726": true,
      "18727": true,
      "18728": true,
      "18729": true,
      "18730": true,
      "18731": true,
      "18732": true,
      "18733": true,
      "18734": true,
      "18735": true,
      "18736": true,
      "18737": true,
      "18738": true,
      "18739": true,
      "18740": true,
      "18741": true,
      "18742": true,
      "18743": true,
      "18744": true,
      "18745": true,
      "18746": true,
      "18747": true,
      "18748": true,
      "18749": true,
      "18750": true,
      "18751": true,
      "18752": true,
      "18753": true,
      "18754": true,
      "18755": true,
      "18756": true,
      "18757": true,
      "18758": true,
      "18759": true,
      "18760": true,
      "18761": true,
      "18762": true,
      "18763": true,
      "18764": true,
      "18765": true,
      "18766": true,
      "18767": true,
      "18768": true,
      "18769": true,
      "18770": true,
      "18771": true,
      "18772": true,
      "18773": true,
      "18774": true,
      "18775": true,
      "18776": true,
      "18777": true,
      "18778": true,
      "18779": true,
      "18780": true,
      "18781": true,
      "18782": true,
      "18783": true,
      "18784": true,
      "18785": true,
      "18786": true,
      "18787": true,
      "18788": true,
      "18789": true,
      "18790": true,
      "18791": true,
      "18792": true,
      "18793": true,
      "18794": true,
      "18795": true,
      "18796": true,
      "18797": true,
      "18798": true,
      "18799": true,
      "18800": true,
      "18801": true,
      "18802": true,
      "18803": true,
      "18804": true,
      "18805": true,
      "18806": true,
      "18807": true,
      "18808": true,
      "18809": true,
      "18810": true,
      "18811": true,
      "18812": true,
      "18813": true,
      "18814": true,
      "18815": true,
      "18816": true,
      "18817": true,
      "18818": true,
      "18819": true,
      "18820": true,
      "18821": true,
      "18822": true,
      "18823": true,
      "18824": true,
      "18825": true,
      "18826": true,
      "18827": true,
      "18828": true,
      "18829": true,
      "18830": true,
      "18831": true,
      "18832": true,
      "18833": true,
      "18834": true,
      "18835": true,
      "18836": true,
      "18837": true,
      "18838": true,
      "18839": true,
      "18840": true,
      "18841": true,
      "18842": true,
      "18843": true,
      "18844": true,
      "18845": true,
      "18846": true,
      "18847": true,
      "18848": true,
      "18849": true,
      "18850": true,
      "18851": true,
      "18852": true,
      "18853": true,
      "18854": true,
      "18855": true,
      "18856": true,
      "18857": true,
      "18858": true,
      "18859": true,
      "18860": true,
      "18861": true,
      "18862": true,
      "18863": true,
      "18864": true,
      "18865": true,
      "18866": true,
      "18867": true,
      "18868": true,
      "18869": true,
      "18870": true,
      "18871": true,
      "18872": true,
      "18873": true,
      "18874": true,
      "18875": true,
      "18876": true,
      "18877": true,
      "18878": true,
      "18879": true,
      "18880": true,
      "18881": true,
      "18882": true,
      "18883": true,
      "18884": true,
      "18885": true,
      "18886": true,
      "18887": true,
      "18888": true,
      "18889": true,
      "18890": true,
      "18891": true,
      "18892": true,
      "18893": true,
      "18894": true,
      "18895": true,
      "18896": true,
      "18897": true,
      "18898": true,
      "18899": true,
      "18900": true,
      "18901": true,
      "18902": true,
      "18903": true,
      "18904": true,
      "18905": true,
      "18906": true,
      "18907": true,
      "18908": true,
      "18909": true,
      "18910": true,
      "18911": true,
      "18912": true,
      "18913": true,
      "18914": true,
      "18915": true,
      "18916": true,
      "18917": true,
      "18918": true,
      "18919": true,
      "18920": true,
      "18921": true,
      "18922": true,
      "18923": true,
      "18924": true,
      "18925": true,
      "18926": true,
      "18927": true,
      "18928": true,
      "18929": true,
      "18930": true,
      "18931": true,
      "18932": true,
      "18933": true,
      "18934": true,
      "18935": true,
      "18936": true,
      "18937": true,
      "18938": true,
      "18939": true,
      "18940": true,
      "18941": true,
      "18942": true,
      "18943": true,
      "18944": true,
      "18945": true,
      "18946": true,
      "18947": true,
      "18948": true,
      "18949": true,
      "18950": true,
      "18951": true,
      "18952": true,
      "18953": true,
      "18954": true,
      "18955": true,
      "18956": true,
      "18957": true,
      "18958": true,
      "18959": true,
      "18960": true,
      "18961": true,
      "18962": true,
      "18963": true,
      "18964": true,
      "18965": true,
      "18966": true,
      "18967": true,
      "18968": true,
      "18969": true,
      "18970": true,
      "18971": true,
      "18972": true,
      "18973": true,
      "18974": true,
      "18975": true,
      "18976": true,
      "18977": true,
      "18978": true,
      "18979": true,
      "18980": true,
      "18981": true,
      "18982": true,
      "18983": true,
      "18984": true,
      "18985": true,
      "18986": true,
      "18987": true,
      "18988": true,
      "18989": true,
      "18990": true,
      "18991": true,
      "18992": true,
      "18993": true,
      "18994": true,
      "18995": true,
      "18996": true,
      "18997": true,
      "18998": true,
      "18999": true,
      "19000": true,
      "19001": true,
      "19002": true,
      "19003": true,
      "19004": true,
      "19005": true,
      "19006": true,
      "19007": true,
      "19008": true,
      "19009": true,
      "19010": true,
      "19011": true,
      "19012": true,
      "19013": true,
      "19014": true,
      "19015": true,
      "19016": true,
      "19017": true,
      "19018": true,
      "19019": true,
      "19020": true,
      "19021": true,
      "19022": true,
      "19023": true,
      "19024": true,
      "19025": true,
      "19026": true,
      "19027": true,
      "19028": true,
      "19029": true,
      "19030": true,
      "19031": true,
      "19032": true,
      "19033": true,
      "19034": true,
      "19035": true,
      "19036": true,
      "19037": true,
      "19038": true,
      "19039": true,
      "19040": true,
      "19041": true,
      "19042": true,
      "19043": true,
      "19044": true,
      "19045": true,
      "19046": true,
      "19047": true,
      "19048": true,
      "19049": true,
      "19050": true,
      "19051": true,
      "19052": true,
      "19053": true,
      "19054": true,
      "19055": true,
      "19056": true,
      "19057": true,
      "19058": true,
      "19059": true,
      "19060": true,
      "19061": true,
      "19062": true,
      "19063": true,
      "19064": true,
      "19065": true,
      "19066": true,
      "19067": true,
      "19068": true,
      "19069": true,
      "19070": true,
      "19071": true,
      "19072": true,
      "19073": true,
      "19074": true,
      "19075": true,
      "19076": true,
      "19077": true,
      "19078": true,
      "19079": true,
      "19080": true,
      "19081": true,
      "19082": true,
      "19083": true,
      "19084": true,
      "19085": true,
      "19086": true,
      "19087": true,
      "19088": true,
      "19089": true,
      "19090": true,
      "19091": true,
      "19092": true,
      "19093": true,
      "19094": true,
      "19095": true,
      "19096": true,
      "19097": true,
      "19098": true,
      "19099": true,
      "19100": true,
      "19101": true,
      "19102": true,
      "19103": true,
      "19104": true,
      "19105": true,
      "19106": true,
      "19107": true,
      "19108": true,
      "19109": true,
      "19110": true,
      "19111": true,
      "19112": true,
      "19113": true,
      "19114": true,
      "19115": true,
      "19116": true,
      "19117": true,
      "19118": true,
      "19119": true,
      "19120": true,
      "19121": true,
      "19122": true,
      "19123": true,
      "19124": true,
      "19125": true,
      "19126": true,
      "19127": true,
      "19128": true,
      "19129": true,
      "19130": true,
      "19131": true,
      "19132": true,
      "19133": true,
      "19134": true,
      "19135": true,
      "19136": true,
      "19137": true,
      "19138": true,
      "19139": true,
      "19140": true,
      "19141": true,
      "19142": true,
      "19143": true,
      "19144": true,
      "19145": true,
      "19146": true,
      "19147": true,
      "19148": true,
      "19149": true,
      "19150": true,
      "19151": true,
      "19152": true,
      "19153": true,
      "19154": true,
      "19155": true,
      "19156": true,
      "19157": true,
      "19158": true,
      "19159": true,
      "19160": true,
      "19161": true,
      "19162": true,
      "19163": true,
      "19164": true,
      "19165": true,
      "19166": true,
      "19167": true,
      "19168": true,
      "19169": true,
      "19170": true,
      "19171": true,
      "19172": true,
      "19173": true,
      "19174": true,
      "19175": true,
      "19176": true,
      "19177": true,
      "19178": true,
      "19179": true,
      "19180": true,
      "19181": true,
      "19182": true,
      "19183": true,
      "19184": true,
      "19185": true,
      "19186": true,
      "19187": true,
      "19188": true,
      "19189": true,
      "19190": true,
      "19191": true,
      "19192": true,
      "19193": true,
      "19194": true,
      "19195": true,
      "19196": true,
      "19197": true,
      "19198": true,
      "19199": true,
      "19200": true,
      "19201": true,
      "19202": true,
      "19203": true,
      "19204": true,
      "19205": true,
      "19206": true,
      "19207": true,
      "19208": true,
      "19209": true,
      "19210": true,
      "19211": true,
      "19212": true,
      "19213": true,
      "19214": true,
      "19215": true,
      "19216": true,
      "19217": true,
      "19218": true,
      "19219": true,
      "19220": true,
      "19221": true,
      "19222": true,
      "19223": true,
      "19224": true,
      "19225": true,
      "19226": true,
      "19227": true,
      "19228": true,
      "19229": true,
      "19230": true,
      "19231": true,
      "19232": true,
      "19233": true,
      "19234": true,
      "19235": true,
      "19236": true,
      "19237": true,
      "19238": true,
      "19239": true,
      "19240": true,
      "19241": true,
      "19242": true,
      "19243": true,
      "19244": true,
      "19245": true,
      "19246": true,
      "19247": true,
      "19248": true,
      "19249": true,
      "19250": true,
      "19251": true,
      "19252": true,
      "19253": true,
      "19254": true,
      "19255": true,
      "19256": true,
      "19257": true,
      "19258": true,
      "19259": true,
      "19260": true,
      "19261": true,
      "19262": true,
      "19263": true,
      "19264": true,
      "19265": true,
      "19266": true,
      "19267": true,
      "19268": true,
      "19269": true,
      "19270": true,
      "19271": true,
      "19272": true,
      "19273": true,
      "19274": true,
      "19275": true,
      "19276": true,
      "19277": true,
      "19278": true,
      "19279": true,
      "19280": true,
      "19281": true,
      "19282": true,
      "19283": true,
      "19284": true,
      "19285": true,
      "19286": true,
      "19287": true,
      "19288": true,
      "19289": true,
      "19290": true,
      "19291": true,
      "19292": true,
      "19293": true,
      "19294": true,
      "19295": true,
      "19296": true,
      "19297": true,
      "19298": true,
      "19299": true,
      "19300": true,
      "19301": true,
      "19302": true,
      "19303": true,
      "19304": true,
      "19305": true,
      "19306": true,
      "19307": true,
      "19308": true,
      "19309": true,
      "19310": true,
      "19311": true,
      "19312": true,
      "19313": true,
      "19314": true,
      "19315": true,
      "19316": true,
      "19317": true,
      "19318": true,
      "19319": true,
      "19320": true,
      "19321": true,
      "19322": true,
      "19323": true,
      "19324": true,
      "19325": true,
      "19326": true,
      "19327": true,
      "19328": true,
      "19329": true,
      "19330": true,
      "19331": true,
      "19332": true,
      "19333": true,
      "19334": true,
      "19335": true,
      "19336": true,
      "19337": true,
      "19338": true,
      "19339": true,
      "19340": true,
      "19341": true,
      "19342": true,
      "19343": true,
      "19344": true,
      "19345": true,
      "19346": true,
      "19347": true,
      "19348": true,
      "19349": true,
      "19350": true,
      "19351": true,
      "19352": true,
      "19353": true,
      "19354": true,
      "19355": true,
      "19356": true,
      "19357": true,
      "19358": true,
      "19359": true,
      "19360": true,
      "19361": true,
      "19362": true,
      "19363": true,
      "19364": true,
      "19365": true,
      "19366": true,
      "19367": true,
      "19368": true,
      "19369": true,
      "19370": true,
      "19371": true,
      "19372": true,
      "19373": true,
      "19374": true,
      "19375": true,
      "19376": true,
      "19377": true,
      "19378": true,
      "19379": true,
      "19380": true,
      "19381": true,
      "19382": true,
      "19383": true,
      "19384": true,
      "19385": true,
      "19386": true,
      "19387": true,
      "19388": true,
      "19389": true,
      "19390": true,
      "19391": true,
      "19392": true,
      "19393": true,
      "19394": true,
      "19395": true,
      "19396": true,
      "19397": true,
      "19398": true,
      "19399": true,
      "19400": true,
      "19401": true,
      "19402": true,
      "19403": true,
      "19404": true,
      "19405": true,
      "19406": true,
      "19407": true,
      "19408": true,
      "19409": true,
      "19410": true,
      "19411": true,
      "19412": true,
      "19413": true,
      "19414": true,
      "19415": true,
      "19416": true,
      "19417": true,
      "19418": true,
      "19419": true,
      "19420": true,
      "19421": true,
      "19422": true,
      "19423": true,
      "19424": true,
      "19425": true,
      "19426": true,
      "19427": true,
      "19428": true,
      "19429": true,
      "19430": true,
      "19431": true,
      "19432": true,
      "19433": true,
      "19434": true,
      "19435": true,
      "19436": true,
      "19437": true,
      "19438": true,
      "19439": true,
      "19440": true,
      "19441": true,
      "19442": true,
      "19443": true,
      "19444": true,
      "19445": true,
      "19446": true,
      "19447": true,
      "19448": true,
      "19449": true,
      "19450": true,
      "19451": true,
      "19452": true,
      "19453": true,
      "19454": true,
      "19455": true,
      "19456": true,
      "19457": true,
      "19458": true,
      "19459": true,
      "19460": true,
      "19461": true,
      "19462": true,
      "19463": true,
      "19464": true,
      "19465": true,
      "19466": true,
      "19467": true,
      "19468": true,
      "19469": true,
      "19470": true,
      "19471": true,
      "19472": true,
      "19473": true,
      "19474": true,
      "19475": true,
      "19476": true,
      "19477": true,
      "19478": true,
      "19479": true,
      "19480": true,
      "19481": true,
      "19482": true,
      "19483": true,
      "19484": true,
      "19485": true,
      "19486": true,
      "19487": true,
      "19488": true,
      "19489": true,
      "19490": true,
      "19491": true,
      "19492": true,
      "19493": true,
      "19494": true,
      "19495": true,
      "19496": true,
      "19497": true,
      "19498": true,
      "19499": true,
      "19500": true,
      "19501": true,
      "19502": true,
      "19503": true,
      "19504": true,
      "19505": true,
      "19506": true,
      "19507": true,
      "19508": true,
      "19509": true,
      "19510": true,
      "19511": true,
      "19512": true,
      "19513": true,
      "19514": true,
      "19515": true,
      "19516": true,
      "19517": true,
      "19518": true,
      "19519": true,
      "19520": true,
      "19521": true,
      "19522": true,
      "19523": true,
      "19524": true,
      "19525": true,
      "19526": true,
      "19527": true,
      "19528": true,
      "19529": true,
      "19530": true,
      "19531": true,
      "19532": true,
      "19533": true,
      "19534": true,
      "19535": true,
      "19536": true,
      "19537": true,
      "19538": true,
      "19539": true,
      "19540": true,
      "19541": true,
      "19542": true,
      "19543": true,
      "19544": true,
      "19545": true,
      "19546": true,
      "19547": true,
      "19548": true,
      "19549": true,
      "19550": true,
      "19551": true,
      "19552": true,
      "19553": true,
      "19554": true,
      "19555": true,
      "19556": true,
      "19557": true,
      "19558": true,
      "19559": true,
      "19560": true,
      "19561": true,
      "19562": true,
      "19563": true,
      "19564": true,
      "19565": true,
      "19566": true,
      "19567": true,
      "19568": true,
      "19569": true,
      "19570": true,
      "19571": true,
      "19572": true,
      "19573": true,
      "19574": true,
      "19575": true,
      "19576": true,
      "19577": true,
      "19578": true,
      "19579": true,
      "19580": true,
      "19581": true,
      "19582": true,
      "19583": true,
      "19584": true,
      "19585": true,
      "19586": true,
      "19587": true,
      "19588": true,
      "19589": true,
      "19590": true,
      "19591": true,
      "19592": true,
      "19593": true,
      "19594": true,
      "19595": true,
      "19596": true,
      "19597": true,
      "19598": true,
      "19599": true,
      "19600": true,
      "19601": true,
      "19602": true,
      "19603": true,
      "19604": true,
      "19605": true,
      "19606": true,
      "19607": true,
      "19608": true,
      "19609": true,
      "19610": true,
      "19611": true,
      "19612": true,
      "19613": true,
      "19614": true,
      "19615": true,
      "19616": true,
      "19617": true,
      "19618": true,
      "19619": true,
      "19620": true,
      "19621": true,
      "19622": true,
      "19623": true,
      "19624": true,
      "19625": true,
      "19626": true,
      "19627": true,
      "19628": true,
      "19629": true,
      "19630": true,
      "19631": true,
      "19632": true,
      "19633": true,
      "19634": true,
      "19635": true,
      "19636": true,
      "19637": true,
      "19638": true,
      "19639": true,
      "19640": true,
      "19641": true,
      "19642": true,
      "19643": true,
      "19644": true,
      "19645": true,
      "19646": true,
      "19647": true,
      "19648": true,
      "19649": true,
      "19650": true,
      "19651": true,
      "19652": true,
      "19653": true,
      "19654": true,
      "19655": true,
      "19656": true,
      "19657": true,
      "19658": true,
      "19659": true,
      "19660": true,
      "19661": true,
      "19662": true,
      "19663": true,
      "19664": true,
      "19665": true,
      "19666": true,
      "19667": true,
      "19668": true,
      "19669": true,
      "19670": true,
      "19671": true,
      "19672": true,
      "19673": true,
      "19674": true,
      "19675": true,
      "19676": true,
      "19677": true,
      "19678": true,
      "19679": true,
      "19680": true,
      "19681": true,
      "19682": true,
      "19683": true,
      "19684": true,
      "19685": true,
      "19686": true,
      "19687": true,
      "19688": true,
      "19689": true,
      "19690": true,
      "19691": true,
      "19692": true,
      "19693": true,
      "19694": true,
      "19695": true,
      "19696": true,
      "19697": true,
      "19698": true,
      "19699": true,
      "19700": true,
      "19701": true,
      "19702": true,
      "19703": true,
      "19704": true,
      "19705": true,
      "19706": true,
      "19707": true,
      "19708": true,
      "19709": true,
      "19710": true,
      "19711": true,
      "19712": true,
      "19713": true,
      "19714": true,
      "19715": true,
      "19716": true,
      "19717": true,
      "19718": true,
      "19719": true,
      "19720": true,
      "19721": true,
      "19722": true,
      "19723": true,
      "19724": true,
      "19725": true,
      "19726": true,
      "19727": true,
      "19728": true,
      "19729": true,
      "19730": true,
      "19731": true,
      "19732": true,
      "19733": true,
      "19734": true,
      "19735": true,
      "19736": true,
      "19737": true,
      "19738": true,
      "19739": true,
      "19740": true,
      "19741": true,
      "19742": true,
      "19743": true,
      "19744": true,
      "19745": true,
      "19746": true,
      "19747": true,
      "19748": true,
      "19749": true,
      "19750": true,
      "19751": true,
      "19752": true,
      "19753": true,
      "19754": true,
      "19755": true,
      "19756": true,
      "19757": true,
      "19758": true,
      "19759": true,
      "19760": true,
      "19761": true,
      "19762": true,
      "19763": true,
      "19764": true,
      "19765": true,
      "19766": true,
      "19767": true,
      "19768": true,
      "19769": true,
      "19770": true,
      "19771": true,
      "19772": true,
      "19773": true,
      "19774": true,
      "19775": true,
      "19776": true,
      "19777": true,
      "19778": true,
      "19779": true,
      "19780": true,
      "19781": true,
      "19782": true,
      "19783": true,
      "19784": true,
      "19785": true,
      "19786": true,
      "19787": true,
      "19788": true,
      "19789": true,
      "19790": true,
      "19791": true,
      "19792": true,
      "19793": true,
      "19794": true,
      "19795": true,
      "19796": true,
      "19797": true,
      "19798": true,
      "19799": true,
      "19800": true,
      "19801": true,
      "19802": true,
      "19803": true,
      "19804": true,
      "19805": true,
      "19806": true,
      "19807": true,
      "19808": true,
      "19809": true,
      "19810": true,
      "19811": true,
      "19812": true,
      "19813": true,
      "19814": true,
      "19815": true,
      "19816": true,
      "19817": true,
      "19818": true,
      "19819": true,
      "19820": true,
      "19821": true,
      "19822": true,
      "19823": true,
      "19824": true,
      "19825": true,
      "19826": true,
      "19827": true,
      "19828": true,
      "19829": true,
      "19830": true,
      "19831": true,
      "19832": true,
      "19833": true,
      "19834": true,
      "19835": true,
      "19836": true,
      "19837": true,
      "19838": true,
      "19839": true,
      "19840": true,
      "19841": true,
      "19842": true,
      "19843": true,
      "19844": true,
      "19845": true,
      "19846": true,
      "19847": true,
      "19848": true,
      "19849": true,
      "19850": true,
      "19851": true,
      "19852": true,
      "19853": true,
      "19854": true,
      "19855": true,
      "19856": true,
      "19857": true,
      "19858": true,
      "19859": true,
      "19860": true,
      "19861": true,
      "19862": true,
      "19863": true,
      "19864": true,
      "19865": true,
      "19866": true,
      "19867": true,
      "19868": true,
      "19869": true,
      "19870": true,
      "19871": true,
      "19872": true,
      "19873": true,
      "19874": true,
      "19875": true,
      "19876": true,
      "19877": true,
      "19878": true,
      "19879": true,
      "19880": true,
      "19881": true,
      "19882": true,
      "19883": true,
      "19884": true,
      "19885": true,
      "19886": true,
      "19887": true,
      "19888": true,
      "19889": true,
      "19890": true,
      "19891": true,
      "19892": true,
      "19893": true,
      "19894": true,
      "19895": true,
      "19896": true,
      "19897": true,
      "19898": true,
      "19899": true,
      "19900": true,
      "19901": true,
      "19902": true,
      "19903": true,
      "19904": true,
      "19905": true,
      "19906": true,
      "19907": true,
      "19908": true,
      "19909": true,
      "19910": true,
      "19911": true,
      "19912": true,
      "19913": true,
      "19914": true,
      "19915": true,
      "19916": true,
      "19917": true,
      "19918": true,
      "19919": true,
      "19920": true,
      "19921": true,
      "19922": true,
      "19923": true,
      "19924": true,
      "19925": true,
      "19926": true,
      "19927": true,
      "19928": true,
      "19929": true,
      "19930": true,
      "19931": true,
      "19932": true,
      "19933": true,
      "19934": true,
      "19935": true,
      "19936": true,
      "19937": true,
      "19938": true,
      "19939": true,
      "19940": true,
      "19941": true,
      "19942": true,
      "19943": true,
      "19944": true,
      "19945": true,
      "19946": true,
      "19947": true,
      "19948": true,
      "19949": true,
      "19950": true,
      "19951": true,
      "19952": true,
      "19953": true,
      "19954": true,
      "19955": true,
      "19956": true,
      "19957": true,
      "19958": true,
      "19959": true,
      "19960": true,
      "19961": true,
      "19962": true,
      "19963": true,
      "19964": true,
      "19965": true,
      "19966": true,
      "19967": true,
      "19968": true,
      "19969": true,
      "19970": true,
      "19971": true,
      "19972": true,
      "19973": true,
      "19974": true,
      "19975": true,
      "19976": true,
      "19977": true,
      "19978": true,
      "19979": true,
      "19980": true,
      "19981": true,
      "19982": true,
      "19983": true,
      "19984": true,
      "19985": true,
      "19986": true,
      "19987": true,
      "19988": true,
      "19989": true,
      "19990": true,
      "19991": true,
      "19992": true,
      "19993": true,
      "19994": true,
      "19995": true,
      "19996": true,
      "19997": true,
      "19998": true,
      "19999": true
    }
  },
  "COAHUILA": {
    "ACUÑA": {
      "26200": true,
      "26201": true,
      "26202": true,
      "26203": true,
      "26204": true,
      "26205": true,
      "26206": true,
      "26207": true,
      "26208": true,
      "26209": true,
      "26210": true,
      "26211": true,
      "26212": true,
      "26213": true,
      "26214": true,
      "26215": true,
      "26216": true,
      "26217": true,
      "26218": true,
      "26219": true,
      "26220": true,
      "26221": true,
      "26222": true,
      "26223": true,
      "26224": true,
      "26225": true,
      "26226": true,
      "26227": true,
      "26228": true,
      "26229": true,
      "26230": true,
      "26231": true,
      "26232": true,
      "26233": true,
      "26234": true,
      "26235": true,
      "26236": true,
      "26237": true,
      "26238": true,
      "26239": true,
      "26240": true,
      "26241": true,
      "26242": true,
      "26243": true,
      "26244": true,
      "26245": true,
      "26246": true,
      "26247": true,
      "26248": true,
      "26249": true,
      "26250": true,
      "26251": true,
      "26252": true,
      "26253": true,
      "26254": true,
      "26255": true,
      "26256": true,
      "26257": true,
      "26258": true,
      "26259": true,
      "26260": true,
      "26261": true,
      "26262": true,
      "26263": true,
      "26264": true,
      "26265": true,
      "26266": true,
      "26267": true,
      "26268": true,
      "26269": true,
      "26270": true,
      "26271": true,
      "26272": true,
      "26273": true,
      "26274": true,
      "26275": true,
      "26276": true,
      "26277": true,
      "26278": true,
      "26279": true,
      "26280": true,
      "26281": true,
      "26282": true,
      "26283": true,
      "26284": true,
      "26285": true,
      "26286": true,
      "26287": true,
      "26288": true,
      "26289": true,
      "26290": true,
      "26291": true,
      "26292": true,
      "26293": true,
      "26294": true,
      "26295": true,
      "26296": true,
      "26297": true,
      "26298": true,
      "26299": true,
      "26300": true,
      "26301": true,
      "26302": true,
      "26303": true,
      "26308": true,
      "26309": true,
      "26328": true,
      "26329": true,
      "26330": true,
      "26331": true,
      "26332": true,
      "26333": true,
      "26334": true,
      "26335": true,
      "26336": true,
      "26337": true,
      "26338": true,
      "26339": true
    },
    "ALLENDE": {
      "26530": true,
      "26531": true,
      "26532": true,
      "26533": true,
      "26534": true,
      "26535": true,
      "26536": true,
      "26537": true,
      "26538": true,
      "26539": true,
      "26540": true,
      "26541": true,
      "26542": true,
      "26543": true,
      "26544": true,
      "26545": true,
      "26546": true,
      "26547": true,
      "26548": true,
      "26549": true,
      "26550": true,
      "26551": true,
      "26552": true,
      "26553": true,
      "26554": true,
      "26555": true,
      "26556": true,
      "26557": true,
      "26558": true,
      "26559": true,
      "26560": true,
      "26561": true,
      "26562": true,
      "26563": true,
      "26564": true,
      "26565": true,
      "26566": true,
      "26567": true,
      "26568": true,
      "26569": true,
      "26570": true,
      "26571": true,
      "26572": true,
      "26573": true,
      "26574": true,
      "26575": true,
      "26576": true,
      "26577": true,
      "26578": true,
      "26579": true,
      "26580": true,
      "26581": true,
      "26582": true,
      "26583": true,
      "26590": true,
      "26591": true,
      "26592": true,
      "26593": true,
      "26594": true,
      "26595": true
    },
    "ARTEAGA": {
      "25350": true,
      "25352": true,
      "25353": true,
      "25354": true,
      "25355": true,
      "25356": true,
      "25369": true
    },
    "CASTAÑOS": {
      "25870": true,
      "25871": true,
      "25872": true,
      "25873": true,
      "25874": true,
      "25875": true,
      "25876": true,
      "25879": true,
      "25884": true,
      "25886": true,
      "25887": true,
      "25888": true,
      "25889": true,
      "25896": true
    },
    "CUATRO CIENEGAS": {
      "27640": true,
      "27641": true,
      "27642": true,
      "27643": true,
      "27644": true,
      "27645": true,
      "27650": true,
      "27651": true,
      "27657": true,
      "27658": true,
      "27659": true,
      "27689": true,
      "27695": true,
      "27696": true,
      "27697": true,
      "27698": true,
      "27699": true
    },
    "FRANCISCO I. MADERO": {
      "27900": true,
      "27901": true,
      "27902": true,
      "27903": true,
      "27904": true,
      "27905": true,
      "27906": true,
      "27907": true,
      "27908": true,
      "27909": true,
      "27910": true,
      "27911": true,
      "27912": true,
      "27913": true,
      "27914": true,
      "27915": true,
      "27916": true,
      "27917": true,
      "27918": true,
      "27919": true,
      "27923": true,
      "27924": true,
      "27925": true,
      "27926": true,
      "27933": true,
      "27935": true,
      "27937": true,
      "27938": true,
      "27939": true
    },
    "FRONTERA": {
      "25600": true,
      "25601": true,
      "25602": true,
      "25603": true,
      "25604": true,
      "25605": true,
      "25606": true,
      "25607": true,
      "25608": true,
      "25609": true,
      "25610": true,
      "25611": true,
      "25612": true,
      "25613": true,
      "25614": true,
      "25615": true,
      "25616": true,
      "25617": true,
      "25618": true,
      "25619": true,
      "25620": true,
      "25621": true,
      "25622": true,
      "25623": true,
      "25624": true,
      "25625": true,
      "25626": true,
      "25627": true,
      "25628": true,
      "25629": true,
      "25630": true,
      "25631": true,
      "25632": true,
      "25633": true,
      "25634": true,
      "25635": true,
      "25636": true,
      "25637": true,
      "25638": true,
      "25639": true,
      "25640": true,
      "25641": true,
      "25642": true,
      "25643": true,
      "25644": true,
      "25645": true,
      "25646": true,
      "25647": true,
      "25648": true,
      "25649": true,
      "25650": true,
      "25651": true,
      "25652": true,
      "25653": true,
      "25654": true,
      "25655": true,
      "25656": true,
      "25657": true,
      "25658": true,
      "25659": true,
      "25660": true,
      "25661": true,
      "25662": true,
      "25663": true,
      "25664": true,
      "25665": true,
      "25666": true,
      "25667": true,
      "25668": true,
      "25669": true,
      "25670": true,
      "25671": true,
      "25672": true,
      "25673": true,
      "25674": true,
      "25675": true,
      "25676": true,
      "25677": true,
      "25678": true,
      "25679": true,
      "25680": true,
      "25681": true,
      "25682": true,
      "25683": true,
      "25684": true,
      "25685": true,
      "25686": true,
      "25687": true,
      "25688": true,
      "25689": true,
      "25690": true,
      "25691": true,
      "25692": true,
      "25693": true,
      "25694": true,
      "25695": true,
      "25696": true,
      "25697": true,
      "25698": true,
      "25699": true,
      "25800": true,
      "25801": true,
      "25802": true,
      "25803": true,
      "25804": true,
      "25805": true,
      "25806": true,
      "25807": true,
      "25808": true,
      "25809": true,
      "25810": true,
      "25811": true,
      "25812": true,
      "25813": true,
      "25814": true,
      "25815": true,
      "25816": true,
      "25817": true,
      "25818": true,
      "25819": true,
      "25820": true,
      "25821": true,
      "25822": true,
      "25823": true,
      "25824": true,
      "25825": true,
      "25826": true,
      "25827": true,
      "25828": true,
      "25829": true
    },
    "JIMENEZ": {
      "26400": true,
      "26401": true,
      "26402": true,
      "26403": true,
      "26404": true,
      "26409": true,
      "26420": true,
      "26421": true,
      "26422": true,
      "26423": true,
      "26424": true,
      "26425": true,
      "26426": true,
      "26427": true,
      "26428": true,
      "26431": true,
      "26432": true,
      "26433": true,
      "26434": true,
      "26435": true,
      "26436": true,
      "26437": true,
      "26438": true,
      "26439": true,
      "26440": true,
      "26441": true,
      "26442": true,
      "26443": true,
      "26444": true,
      "26445": true,
      "26446": true,
      "26447": true,
      "26448": true,
      "26449": true
    },
    "MATAMOROS": {
      "27440": true,
      "27441": true,
      "27442": true,
      "27443": true,
      "27444": true,
      "27445": true,
      "27446": true,
      "27447": true,
      "27448": true,
      "27449": true,
      "27450": true,
      "27451": true,
      "27453": true,
      "27454": true,
      "27455": true,
      "27456": true,
      "27457": true,
      "27458": true,
      "27459": true,
      "27460": true,
      "27461": true,
      "27462": true,
      "27463": true,
      "27464": true,
      "27465": true,
      "27466": true,
      "27467": true,
      "27468": true,
      "27469": true,
      "27470": true,
      "27471": true,
      "27472": true,
      "27473": true,
      "27475": true,
      "27477": true,
      "27478": true,
      "27479": true
    },
    "MONCLOVA": {
      "25700": true,
      "25701": true,
      "25702": true,
      "25703": true,
      "25704": true,
      "25705": true,
      "25706": true,
      "25707": true,
      "25708": true,
      "25709": true,
      "25710": true,
      "25711": true,
      "25712": true,
      "25713": true,
      "25714": true,
      "25715": true,
      "25716": true,
      "25717": true,
      "25718": true,
      "25719": true,
      "25720": true,
      "25721": true,
      "25722": true,
      "25723": true,
      "25724": true,
      "25725": true,
      "25726": true,
      "25727": true,
      "25728": true,
      "25729": true,
      "25730": true,
      "25731": true,
      "25732": true,
      "25733": true,
      "25734": true,
      "25735": true,
      "25736": true,
      "25737": true,
      "25738": true,
      "25739": true,
      "25740": true,
      "25741": true,
      "25742": true,
      "25743": true,
      "25744": true,
      "25745": true,
      "25746": true,
      "25747": true,
      "25748": true,
      "25749": true,
      "25750": true,
      "25751": true,
      "25752": true,
      "25753": true,
      "25754": true,
      "25755": true,
      "25756": true,
      "25757": true,
      "25758": true,
      "25759": true,
      "25760": true,
      "25761": true,
      "25762": true,
      "25763": true,
      "25764": true,
      "25765": true,
      "25766": true,
      "25767": true,
      "25768": true,
      "25769": true,
      "25770": true,
      "25771": true,
      "25772": true,
      "25773": true,
      "25774": true,
      "25775": true,
      "25776": true,
      "25777": true,
      "25778": true,
      "25779": true,
      "25780": true,
      "25781": true,
      "25782": true,
      "25783": true,
      "25784": true,
      "25785": true,
      "25786": true,
      "25787": true,
      "25788": true,
      "25789": true,
      "25790": true,
      "25791": true,
      "25792": true,
      "25793": true,
      "25794": true,
      "25795": true,
      "25796": true,
      "25797": true,
      "25798": true,
      "25799": true,
      "25830": true,
      "25831": true,
      "25832": true,
      "25833": true,
      "25834": true,
      "25835": true,
      "25836": true,
      "25837": true,
      "25838": true,
      "25839": true,
      "25840": true,
      "25841": true,
      "25842": true,
      "25843": true,
      "25844": true,
      "25845": true,
      "25846": true,
      "25847": true,
      "25848": true,
      "25849": true,
      "25850": true,
      "25851": true,
      "25852": true,
      "25853": true,
      "25854": true,
      "25855": true,
      "25856": true,
      "25857": true,
      "25858": true,
      "25859": true,
      "25860": true,
      "25861": true,
      "25862": true,
      "25863": true,
      "25864": true,
      "25865": true,
      "25866": true,
      "25867": true,
      "25868": true,
      "25869": true
    },
    "MUZQUIZ": {
      "26340": true,
      "26341": true,
      "26342": true,
      "26343": true,
      "26344": true,
      "26345": true,
      "26346": true,
      "26347": true,
      "26348": true,
      "26349": true,
      "26350": true,
      "26351": true,
      "26352": true,
      "26353": true,
      "26354": true,
      "26355": true,
      "26356": true,
      "26357": true,
      "26358": true,
      "26359": true,
      "26363": true,
      "26364": true,
      "26366": true,
      "26367": true,
      "26368": true,
      "26369": true,
      "26370": true,
      "26371": true,
      "26372": true,
      "26373": true,
      "26374": true,
      "26375": true,
      "26376": true,
      "26377": true,
      "26378": true,
      "26379": true,
      "26384": true,
      "26385": true,
      "26386": true,
      "26387": true,
      "26388": true,
      "26389": true,
      "26390": true,
      "26391": true,
      "26392": true,
      "26393": true,
      "26394": true,
      "26395": true,
      "26396": true,
      "26397": true,
      "26398": true,
      "26399": true
    },
    "NADADORES": {
      "27550": true,
      "27551": true,
      "27552": true,
      "27553": true,
      "27554": true,
      "27555": true,
      "27556": true,
      "27557": true,
      "27558": true,
      "27559": true,
      "27560": true,
      "27561": true,
      "27562": true,
      "27563": true,
      "27564": true,
      "27565": true,
      "27566": true,
      "27567": true,
      "27568": true,
      "27569": true,
      "27575": true,
      "27576": true,
      "27577": true,
      "27578": true,
      "27588": true,
      "27589": true,
      "27590": true,
      "27591": true,
      "27592": true,
      "27593": true,
      "27594": true,
      "27595": true,
      "27596": true,
      "27597": true,
      "27598": true,
      "27599": true
    },
    "NAVA": {
      "26170": true,
      "26171": true,
      "26172": true,
      "26173": true,
      "26174": true,
      "26175": true,
      "26176": true,
      "26177": true,
      "26178": true,
      "26179": true,
      "26183": true,
      "26190": true,
      "26191": true,
      "26192": true,
      "26193": true,
      "26194": true,
      "26195": true,
      "26196": true,
      "26197": true,
      "26198": true,
      "26199": true
    },
    "PARRAS": {
      "27980": true,
      "27981": true,
      "27982": true,
      "27983": true,
      "27984": true,
      "27985": true,
      "27986": true,
      "27987": true,
      "27988": true,
      "27989": true,
      "27990": true,
      "27992": true,
      "27995": true,
      "27996": true
    },
    "PIEDRAS NEGRAS": {
      "26000": true,
      "26001": true,
      "26002": true,
      "26003": true,
      "26004": true,
      "26005": true,
      "26006": true,
      "26007": true,
      "26008": true,
      "26009": true,
      "26010": true,
      "26011": true,
      "26012": true,
      "26013": true,
      "26014": true,
      "26015": true,
      "26016": true,
      "26017": true,
      "26018": true,
      "26019": true,
      "26020": true,
      "26021": true,
      "26022": true,
      "26023": true,
      "26024": true,
      "26025": true,
      "26026": true,
      "26027": true,
      "26028": true,
      "26029": true,
      "26030": true,
      "26031": true,
      "26032": true,
      "26033": true,
      "26034": true,
      "26035": true,
      "26036": true,
      "26037": true,
      "26038": true,
      "26039": true,
      "26040": true,
      "26041": true,
      "26042": true,
      "26043": true,
      "26044": true,
      "26045": true,
      "26046": true,
      "26047": true,
      "26048": true,
      "26049": true,
      "26050": true,
      "26051": true,
      "26052": true,
      "26053": true,
      "26054": true,
      "26055": true,
      "26056": true,
      "26057": true,
      "26058": true,
      "26059": true,
      "26060": true,
      "26061": true,
      "26062": true,
      "26063": true,
      "26064": true,
      "26065": true,
      "26066": true,
      "26067": true,
      "26068": true,
      "26069": true,
      "26070": true,
      "26071": true,
      "26072": true,
      "26073": true,
      "26074": true,
      "26075": true,
      "26076": true,
      "26077": true,
      "26078": true,
      "26079": true,
      "26080": true,
      "26081": true,
      "26082": true,
      "26083": true,
      "26084": true,
      "26085": true,
      "26086": true,
      "26087": true,
      "26088": true,
      "26089": true,
      "26090": true,
      "26091": true,
      "26092": true,
      "26093": true,
      "26094": true,
      "26095": true,
      "26096": true,
      "26097": true,
      "26098": true,
      "26099": true,
      "26100": true,
      "26101": true,
      "26102": true,
      "26103": true,
      "26104": true,
      "26105": true,
      "26106": true,
      "26107": true,
      "26108": true,
      "26109": true,
      "26110": true,
      "26111": true,
      "26112": true,
      "26113": true,
      "26114": true,
      "26115": true,
      "26116": true,
      "26117": true,
      "26118": true,
      "26119": true,
      "26120": true,
      "26121": true,
      "26122": true,
      "26123": true,
      "26124": true,
      "26125": true,
      "26126": true,
      "26127": true,
      "26128": true,
      "26129": true,
      "26130": true,
      "26131": true,
      "26132": true,
      "26133": true,
      "26134": true,
      "26135": true,
      "26136": true,
      "26137": true,
      "26138": true,
      "26139": true,
      "26140": true,
      "26141": true,
      "26142": true,
      "26143": true,
      "26144": true,
      "26145": true,
      "26146": true,
      "26147": true,
      "26148": true,
      "26149": true,
      "26150": true,
      "26151": true,
      "26152": true,
      "26153": true,
      "26154": true,
      "26155": true,
      "26156": true,
      "26157": true,
      "26158": true,
      "26159": true,
      "26160": true,
      "26161": true,
      "26162": true,
      "26163": true,
      "26164": true,
      "26165": true,
      "26166": true,
      "26167": true,
      "26168": true,
      "26169": true
    },
    "RAMOS ARIZPE": {
      "25900": true,
      "25901": true,
      "25902": true,
      "25903": true,
      "25904": true,
      "25905": true,
      "25906": true,
      "25907": true,
      "25908": true,
      "25909": true,
      "25910": true,
      "25911": true,
      "25912": true,
      "25913": true,
      "25914": true,
      "25915": true,
      "25916": true,
      "25917": true,
      "25918": true,
      "25919": true,
      "25920": true,
      "25921": true,
      "25922": true,
      "25923": true,
      "25924": true,
      "25925": true,
      "25926": true,
      "25927": true,
      "25928": true,
      "25929": true,
      "25930": true,
      "25931": true,
      "25932": true,
      "25933": true,
      "25934": true,
      "25935": true,
      "25936": true,
      "25937": true,
      "25938": true,
      "25939": true,
      "25940": true,
      "25941": true,
      "25942": true,
      "25943": true,
      "25944": true,
      "25945": true,
      "25946": true,
      "25947": true,
      "25948": true,
      "25949": true
    },
    "SABINAS": {
      "26700": true,
      "26701": true,
      "26702": true,
      "26703": true,
      "26704": true,
      "26705": true,
      "26706": true,
      "26707": true,
      "26708": true,
      "26709": true,
      "26710": true,
      "26711": true,
      "26712": true,
      "26713": true,
      "26714": true,
      "26715": true,
      "26716": true,
      "26717": true,
      "26718": true,
      "26719": true,
      "26720": true,
      "26721": true,
      "26722": true,
      "26723": true,
      "26724": true,
      "26725": true,
      "26726": true,
      "26727": true,
      "26728": true,
      "26729": true,
      "26730": true,
      "26731": true,
      "26732": true,
      "26733": true,
      "26734": true,
      "26735": true,
      "26736": true,
      "26737": true,
      "26738": true,
      "26739": true,
      "26740": true,
      "26741": true,
      "26742": true,
      "26743": true,
      "26744": true,
      "26745": true,
      "26746": true,
      "26747": true,
      "26748": true,
      "26749": true,
      "26750": true,
      "26751": true,
      "26752": true,
      "26753": true,
      "26754": true,
      "26755": true,
      "26756": true,
      "26757": true,
      "26758": true,
      "26759": true,
      "26760": true,
      "26761": true,
      "26762": true,
      "26763": true,
      "26764": true,
      "26765": true,
      "26766": true,
      "26767": true,
      "26768": true,
      "26769": true,
      "26770": true,
      "26771": true,
      "26772": true,
      "26773": true,
      "26774": true,
      "26775": true,
      "26776": true,
      "26777": true,
      "26778": true,
      "26779": true,
      "26780": true,
      "26781": true,
      "26782": true,
      "26783": true,
      "26784": true,
      "26785": true,
      "26786": true,
      "26787": true,
      "26788": true,
      "26789": true,
      "26790": true,
      "26791": true,
      "26792": true,
      "26793": true,
      "26794": true,
      "26795": true,
      "26796": true,
      "26797": true,
      "26798": true,
      "26799": true,
      "26950": true,
      "26951": true,
      "26952": true,
      "26953": true,
      "26959": true,
      "26960": true,
      "26961": true,
      "26962": true,
      "26963": true,
      "26980": true,
      "26981": true,
      "26982": true,
      "26983": true,
      "26984": true,
      "26985": true,
      "26986": true,
      "26987": true,
      "26988": true,
      "26989": true,
      "26990": true,
      "26991": true,
      "26992": true,
      "26993": true,
      "26994": true,
      "26995": true,
      "26996": true,
      "26997": true,
      "26998": true,
      "26999": true
    },
    "SACRAMENTO": {
      "27750": true,
      "27751": true,
      "27752": true,
      "27753": true,
      "27754": true,
      "27755": true,
      "27756": true,
      "27757": true,
      "27758": true,
      "27759": true,
      "27760": true,
      "27761": true,
      "27762": true,
      "27763": true,
      "27764": true,
      "27765": true,
      "27766": true,
      "27767": true,
      "27768": true,
      "27769": true,
      "27770": true,
      "27771": true,
      "27772": true,
      "27773": true,
      "27774": true,
      "27775": true,
      "27776": true,
      "27777": true,
      "27778": true,
      "27779": true,
      "27780": true,
      "27781": true,
      "27782": true,
      "27783": true,
      "27784": true,
      "27785": true,
      "27786": true,
      "27787": true,
      "27788": true,
      "27789": true,
      "27790": true,
      "27791": true,
      "27792": true,
      "27793": true,
      "27794": true,
      "27795": true,
      "27796": true,
      "27797": true,
      "27798": true,
      "27799": true
    },
    "SALTILLO": {
      "25000": true,
      "25001": true,
      "25002": true,
      "25003": true,
      "25004": true,
      "25005": true,
      "25006": true,
      "25007": true,
      "25008": true,
      "25009": true,
      "25010": true,
      "25011": true,
      "25012": true,
      "25013": true,
      "25014": true,
      "25015": true,
      "25016": true,
      "25017": true,
      "25018": true,
      "25019": true,
      "25020": true,
      "25021": true,
      "25022": true,
      "25023": true,
      "25024": true,
      "25025": true,
      "25026": true,
      "25027": true,
      "25028": true,
      "25029": true,
      "25030": true,
      "25031": true,
      "25032": true,
      "25033": true,
      "25034": true,
      "25035": true,
      "25036": true,
      "25037": true,
      "25038": true,
      "25039": true,
      "25040": true,
      "25041": true,
      "25042": true,
      "25043": true,
      "25044": true,
      "25045": true,
      "25046": true,
      "25047": true,
      "25048": true,
      "25049": true,
      "25050": true,
      "25051": true,
      "25052": true,
      "25053": true,
      "25054": true,
      "25055": true,
      "25056": true,
      "25057": true,
      "25058": true,
      "25059": true,
      "25060": true,
      "25061": true,
      "25062": true,
      "25063": true,
      "25064": true,
      "25065": true,
      "25066": true,
      "25067": true,
      "25068": true,
      "25069": true,
      "25070": true,
      "25071": true,
      "25072": true,
      "25073": true,
      "25074": true,
      "25075": true,
      "25076": true,
      "25077": true,
      "25078": true,
      "25079": true,
      "25080": true,
      "25081": true,
      "25082": true,
      "25083": true,
      "25084": true,
      "25085": true,
      "25086": true,
      "25087": true,
      "25088": true,
      "25089": true,
      "25090": true,
      "25091": true,
      "25092": true,
      "25093": true,
      "25094": true,
      "25095": true,
      "25096": true,
      "25097": true,
      "25098": true,
      "25099": true,
      "25100": true,
      "25101": true,
      "25102": true,
      "25103": true,
      "25104": true,
      "25105": true,
      "25106": true,
      "25107": true,
      "25108": true,
      "25109": true,
      "25110": true,
      "25111": true,
      "25112": true,
      "25113": true,
      "25114": true,
      "25115": true,
      "25116": true,
      "25117": true,
      "25118": true,
      "25119": true,
      "25120": true,
      "25121": true,
      "25122": true,
      "25123": true,
      "25124": true,
      "25125": true,
      "25126": true,
      "25127": true,
      "25128": true,
      "25129": true,
      "25130": true,
      "25131": true,
      "25132": true,
      "25133": true,
      "25134": true,
      "25135": true,
      "25136": true,
      "25137": true,
      "25138": true,
      "25139": true,
      "25140": true,
      "25141": true,
      "25142": true,
      "25143": true,
      "25144": true,
      "25145": true,
      "25146": true,
      "25147": true,
      "25148": true,
      "25149": true,
      "25150": true,
      "25151": true,
      "25152": true,
      "25153": true,
      "25154": true,
      "25155": true,
      "25156": true,
      "25157": true,
      "25158": true,
      "25159": true,
      "25160": true,
      "25161": true,
      "25162": true,
      "25163": true,
      "25164": true,
      "25165": true,
      "25166": true,
      "25167": true,
      "25168": true,
      "25169": true,
      "25170": true,
      "25171": true,
      "25172": true,
      "25173": true,
      "25174": true,
      "25175": true,
      "25176": true,
      "25177": true,
      "25178": true,
      "25179": true,
      "25180": true,
      "25181": true,
      "25182": true,
      "25183": true,
      "25184": true,
      "25185": true,
      "25186": true,
      "25187": true,
      "25188": true,
      "25189": true,
      "25190": true,
      "25191": true,
      "25192": true,
      "25193": true,
      "25194": true,
      "25195": true,
      "25196": true,
      "25197": true,
      "25198": true,
      "25199": true,
      "25200": true,
      "25201": true,
      "25202": true,
      "25203": true,
      "25204": true,
      "25205": true,
      "25206": true,
      "25207": true,
      "25208": true,
      "25209": true,
      "25210": true,
      "25211": true,
      "25212": true,
      "25213": true,
      "25214": true,
      "25215": true,
      "25216": true,
      "25217": true,
      "25218": true,
      "25219": true,
      "25220": true,
      "25221": true,
      "25222": true,
      "25223": true,
      "25224": true,
      "25225": true,
      "25226": true,
      "25227": true,
      "25228": true,
      "25229": true,
      "25230": true,
      "25231": true,
      "25232": true,
      "25233": true,
      "25234": true,
      "25235": true,
      "25236": true,
      "25237": true,
      "25238": true,
      "25239": true,
      "25240": true,
      "25241": true,
      "25242": true,
      "25243": true,
      "25244": true,
      "25245": true,
      "25246": true,
      "25247": true,
      "25248": true,
      "25249": true,
      "25250": true,
      "25251": true,
      "25252": true,
      "25253": true,
      "25254": true,
      "25255": true,
      "25256": true,
      "25257": true,
      "25258": true,
      "25259": true,
      "25260": true,
      "25261": true,
      "25262": true,
      "25263": true,
      "25264": true,
      "25265": true,
      "25266": true,
      "25267": true,
      "25268": true,
      "25269": true,
      "25270": true,
      "25271": true,
      "25272": true,
      "25273": true,
      "25274": true,
      "25275": true,
      "25276": true,
      "25277": true,
      "25278": true,
      "25279": true,
      "25280": true,
      "25281": true,
      "25282": true,
      "25283": true,
      "25284": true,
      "25285": true,
      "25286": true,
      "25287": true,
      "25288": true,
      "25289": true,
      "25290": true,
      "25291": true,
      "25292": true,
      "25293": true,
      "25294": true,
      "25295": true,
      "25296": true,
      "25297": true,
      "25298": true,
      "25299": true,
      "25300": true,
      "25301": true,
      "25302": true,
      "25303": true,
      "25304": true,
      "25305": true,
      "25306": true,
      "25307": true,
      "25308": true,
      "25309": true,
      "25310": true,
      "25311": true,
      "25312": true,
      "25313": true,
      "25314": true,
      "25315": true,
      "25316": true,
      "25317": true,
      "25318": true,
      "25319": true,
      "25320": true,
      "25321": true,
      "25322": true,
      "25323": true,
      "25324": true,
      "25325": true,
      "25326": true,
      "25327": true,
      "25328": true,
      "25329": true,
      "25330": true,
      "25331": true,
      "25332": true,
      "25333": true,
      "25334": true,
      "25335": true,
      "25336": true,
      "25337": true,
      "25338": true,
      "25339": true,
      "25340": true,
      "25341": true,
      "25342": true,
      "25343": true,
      "25344": true,
      "25345": true,
      "25346": true,
      "25347": true,
      "25348": true,
      "25349": true
    },
    "SAN BUENAVENTURA": {
      "25500": true,
      "25501": true,
      "25502": true,
      "25503": true,
      "25504": true,
      "25505": true,
      "25506": true,
      "25507": true,
      "25508": true,
      "25509": true,
      "25510": true,
      "25511": true,
      "25512": true,
      "25513": true,
      "25514": true,
      "25515": true,
      "25516": true,
      "25517": true,
      "25518": true,
      "25519": true,
      "25520": true,
      "25521": true,
      "25530": true,
      "25531": true,
      "25536": true,
      "25537": true,
      "25538": true,
      "25539": true
    },
    "SAN JUAN DE SABINAS": {
      "26800": true,
      "26801": true,
      "26802": true,
      "26803": true,
      "26804": true,
      "26805": true,
      "26806": true,
      "26807": true,
      "26808": true,
      "26809": true,
      "26810": true,
      "26811": true,
      "26812": true,
      "26813": true,
      "26814": true,
      "26815": true,
      "26816": true,
      "26817": true,
      "26818": true,
      "26819": true,
      "26820": true,
      "26821": true,
      "26822": true,
      "26823": true,
      "26824": true,
      "26825": true,
      "26826": true,
      "26827": true,
      "26828": true,
      "26829": true,
      "26830": true,
      "26831": true,
      "26832": true,
      "26833": true,
      "26834": true,
      "26835": true,
      "26836": true,
      "26837": true,
      "26838": true,
      "26839": true,
      "26840": true,
      "26841": true,
      "26842": true,
      "26843": true,
      "26844": true,
      "26845": true,
      "26846": true,
      "26847": true,
      "26848": true,
      "26849": true,
      "26850": true,
      "26851": true,
      "26852": true,
      "26853": true,
      "26854": true,
      "26855": true,
      "26856": true,
      "26857": true,
      "26858": true,
      "26859": true,
      "26860": true,
      "26861": true,
      "26862": true,
      "26863": true,
      "26864": true,
      "26865": true,
      "26866": true,
      "26867": true,
      "26868": true,
      "26869": true,
      "26870": true,
      "26871": true,
      "26872": true,
      "26873": true,
      "26874": true,
      "26875": true,
      "26876": true,
      "26877": true,
      "26878": true,
      "26879": true,
      "26880": true,
      "26881": true,
      "26882": true,
      "26883": true,
      "26884": true,
      "26885": true,
      "26886": true,
      "26887": true,
      "26888": true,
      "26889": true,
      "26890": true,
      "26891": true,
      "26892": true,
      "26893": true,
      "26894": true,
      "26895": true,
      "26896": true,
      "26897": true,
      "26898": true,
      "26899": true,
      "26900": true,
      "26901": true,
      "26902": true,
      "26903": true,
      "26904": true,
      "26905": true,
      "26906": true,
      "26907": true,
      "26908": true,
      "26909": true,
      "26940": true,
      "26941": true,
      "26942": true
    },
    "SAN PEDRO": {
      "27800": true,
      "27801": true,
      "27802": true,
      "27803": true,
      "27804": true,
      "27805": true,
      "27806": true,
      "27807": true,
      "27808": true,
      "27809": true,
      "27810": true,
      "27811": true,
      "27812": true,
      "27813": true,
      "27814": true,
      "27815": true,
      "27816": true,
      "27817": true,
      "27818": true,
      "27819": true,
      "27820": true,
      "27821": true,
      "27822": true,
      "27823": true,
      "27824": true,
      "27825": true,
      "27826": true,
      "27827": true,
      "27828": true,
      "27829": true,
      "27830": true,
      "27831": true,
      "27832": true,
      "27833": true,
      "27834": true,
      "27835": true,
      "27836": true,
      "27837": true,
      "27838": true,
      "27839": true,
      "27840": true,
      "27841": true,
      "27842": true,
      "27843": true,
      "27844": true,
      "27845": true,
      "27846": true,
      "27847": true,
      "27848": true,
      "27849": true,
      "27850": true,
      "27851": true,
      "27852": true,
      "27853": true,
      "27854": true,
      "27855": true,
      "27856": true,
      "27857": true,
      "27858": true,
      "27859": true,
      "27860": true,
      "27861": true,
      "27862": true,
      "27863": true,
      "27864": true,
      "27865": true,
      "27866": true,
      "27867": true,
      "27868": true,
      "27869": true,
      "27870": true,
      "27871": true,
      "27872": true,
      "27873": true,
      "27874": true,
      "27875": true,
      "27876": true,
      "27877": true,
      "27878": true,
      "27879": true,
      "27880": true,
      "27881": true,
      "27882": true,
      "27883": true,
      "27884": true,
      "27885": true,
      "27886": true,
      "27887": true,
      "27888": true,
      "27889": true,
      "27890": true,
      "27891": true,
      "27892": true,
      "27893": true,
      "27894": true,
      "27895": true,
      "27896": true,
      "27897": true,
      "27898": true,
      "27899": true,
      "27940": true,
      "27941": true,
      "27942": true,
      "27943": true,
      "27944": true,
      "27945": true,
      "27946": true,
      "27947": true,
      "27950": true,
      "27951": true,
      "27952": true,
      "27953": true,
      "27954": true,
      "27955": true,
      "27956": true,
      "27957": true,
      "27958": true,
      "27959": true,
      "27960": true,
      "27961": true,
      "27962": true,
      "27963": true,
      "27964": true,
      "27966": true,
      "27970": true,
      "27971": true,
      "27972": true,
      "27973": true,
      "27974": true
    },
    "TORREON": {
      "27000": true,
      "27001": true,
      "27002": true,
      "27003": true,
      "27004": true,
      "27005": true,
      "27006": true,
      "27007": true,
      "27008": true,
      "27009": true,
      "27010": true,
      "27011": true,
      "27012": true,
      "27013": true,
      "27014": true,
      "27015": true,
      "27016": true,
      "27017": true,
      "27018": true,
      "27019": true,
      "27020": true,
      "27021": true,
      "27022": true,
      "27023": true,
      "27024": true,
      "27025": true,
      "27026": true,
      "27027": true,
      "27028": true,
      "27029": true,
      "27030": true,
      "27031": true,
      "27032": true,
      "27033": true,
      "27034": true,
      "27035": true,
      "27036": true,
      "27037": true,
      "27038": true,
      "27039": true,
      "27040": true,
      "27041": true,
      "27042": true,
      "27043": true,
      "27044": true,
      "27045": true,
      "27046": true,
      "27047": true,
      "27048": true,
      "27049": true,
      "27050": true,
      "27051": true,
      "27052": true,
      "27053": true,
      "27054": true,
      "27055": true,
      "27056": true,
      "27057": true,
      "27058": true,
      "27059": true,
      "27060": true,
      "27061": true,
      "27062": true,
      "27063": true,
      "27064": true,
      "27065": true,
      "27066": true,
      "27067": true,
      "27068": true,
      "27069": true,
      "27070": true,
      "27071": true,
      "27072": true,
      "27073": true,
      "27074": true,
      "27075": true,
      "27076": true,
      "27077": true,
      "27078": true,
      "27079": true,
      "27080": true,
      "27081": true,
      "27082": true,
      "27083": true,
      "27084": true,
      "27085": true,
      "27086": true,
      "27087": true,
      "27088": true,
      "27089": true,
      "27090": true,
      "27091": true,
      "27092": true,
      "27093": true,
      "27094": true,
      "27095": true,
      "27096": true,
      "27097": true,
      "27098": true,
      "27099": true,
      "27100": true,
      "27101": true,
      "27102": true,
      "27103": true,
      "27104": true,
      "27105": true,
      "27106": true,
      "27107": true,
      "27108": true,
      "27109": true,
      "27110": true,
      "27111": true,
      "27112": true,
      "27113": true,
      "27114": true,
      "27115": true,
      "27116": true,
      "27117": true,
      "27118": true,
      "27119": true,
      "27120": true,
      "27121": true,
      "27122": true,
      "27123": true,
      "27124": true,
      "27125": true,
      "27126": true,
      "27127": true,
      "27128": true,
      "27129": true,
      "27130": true,
      "27131": true,
      "27132": true,
      "27133": true,
      "27134": true,
      "27135": true,
      "27136": true,
      "27137": true,
      "27138": true,
      "27139": true,
      "27140": true,
      "27141": true,
      "27142": true,
      "27143": true,
      "27144": true,
      "27145": true,
      "27146": true,
      "27147": true,
      "27148": true,
      "27149": true,
      "27150": true,
      "27151": true,
      "27152": true,
      "27153": true,
      "27154": true,
      "27155": true,
      "27156": true,
      "27157": true,
      "27158": true,
      "27159": true,
      "27160": true,
      "27161": true,
      "27162": true,
      "27163": true,
      "27164": true,
      "27165": true,
      "27166": true,
      "27167": true,
      "27168": true,
      "27169": true,
      "27170": true,
      "27171": true,
      "27172": true,
      "27173": true,
      "27174": true,
      "27175": true,
      "27176": true,
      "27177": true,
      "27178": true,
      "27179": true,
      "27180": true,
      "27181": true,
      "27182": true,
      "27183": true,
      "27184": true,
      "27185": true,
      "27186": true,
      "27187": true,
      "27188": true,
      "27189": true,
      "27190": true,
      "27191": true,
      "27192": true,
      "27193": true,
      "27194": true,
      "27195": true,
      "27196": true,
      "27197": true,
      "27198": true,
      "27199": true,
      "27200": true,
      "27201": true,
      "27202": true,
      "27203": true,
      "27204": true,
      "27205": true,
      "27206": true,
      "27207": true,
      "27208": true,
      "27209": true,
      "27210": true,
      "27211": true,
      "27212": true,
      "27213": true,
      "27214": true,
      "27215": true,
      "27216": true,
      "27217": true,
      "27218": true,
      "27219": true,
      "27220": true,
      "27221": true,
      "27222": true,
      "27223": true,
      "27224": true,
      "27225": true,
      "27226": true,
      "27227": true,
      "27228": true,
      "27229": true,
      "27230": true,
      "27231": true,
      "27232": true,
      "27233": true,
      "27234": true,
      "27235": true,
      "27236": true,
      "27237": true,
      "27238": true,
      "27239": true,
      "27240": true,
      "27241": true,
      "27242": true,
      "27243": true,
      "27244": true,
      "27245": true,
      "27246": true,
      "27247": true,
      "27248": true,
      "27249": true,
      "27250": true,
      "27251": true,
      "27252": true,
      "27253": true,
      "27254": true,
      "27255": true,
      "27256": true,
      "27257": true,
      "27258": true,
      "27259": true,
      "27260": true,
      "27261": true,
      "27262": true,
      "27263": true,
      "27264": true,
      "27265": true,
      "27266": true,
      "27267": true,
      "27268": true,
      "27269": true,
      "27270": true,
      "27271": true,
      "27272": true,
      "27273": true,
      "27274": true,
      "27275": true,
      "27276": true,
      "27277": true,
      "27278": true,
      "27279": true,
      "27280": true,
      "27281": true,
      "27282": true,
      "27283": true,
      "27284": true,
      "27285": true,
      "27286": true,
      "27287": true,
      "27288": true,
      "27289": true,
      "27290": true,
      "27291": true,
      "27292": true,
      "27293": true,
      "27294": true,
      "27295": true,
      "27296": true,
      "27297": true,
      "27298": true,
      "27299": true,
      "27300": true,
      "27301": true,
      "27302": true,
      "27303": true,
      "27304": true,
      "27305": true,
      "27306": true,
      "27307": true,
      "27308": true,
      "27309": true,
      "27310": true,
      "27311": true,
      "27312": true,
      "27313": true,
      "27314": true,
      "27315": true,
      "27316": true,
      "27317": true,
      "27318": true,
      "27319": true,
      "27320": true,
      "27321": true,
      "27322": true,
      "27323": true,
      "27324": true,
      "27325": true,
      "27326": true,
      "27327": true,
      "27328": true,
      "27329": true,
      "27330": true,
      "27331": true,
      "27332": true,
      "27333": true,
      "27334": true,
      "27335": true,
      "27336": true,
      "27337": true,
      "27338": true,
      "27339": true,
      "27340": true,
      "27341": true,
      "27342": true,
      "27343": true,
      "27344": true,
      "27345": true,
      "27346": true,
      "27347": true,
      "27348": true,
      "27349": true,
      "27350": true,
      "27351": true,
      "27352": true,
      "27353": true,
      "27354": true,
      "27355": true,
      "27356": true,
      "27357": true,
      "27358": true,
      "27359": true,
      "27360": true,
      "27361": true,
      "27362": true,
      "27363": true,
      "27364": true,
      "27365": true,
      "27366": true,
      "27367": true,
      "27368": true,
      "27369": true,
      "27370": true,
      "27371": true,
      "27372": true,
      "27373": true,
      "27374": true,
      "27375": true,
      "27376": true,
      "27377": true,
      "27378": true,
      "27379": true,
      "27380": true,
      "27381": true,
      "27382": true,
      "27383": true,
      "27384": true,
      "27385": true,
      "27386": true,
      "27387": true,
      "27388": true,
      "27389": true,
      "27390": true,
      "27391": true,
      "27392": true,
      "27393": true,
      "27394": true,
      "27395": true,
      "27396": true,
      "27397": true,
      "27398": true,
      "27399": true,
      "27400": true,
      "27401": true,
      "27402": true,
      "27403": true,
      "27404": true,
      "27405": true,
      "27406": true,
      "27407": true,
      "27408": true,
      "27409": true,
      "27410": true,
      "27411": true,
      "27412": true,
      "27413": true,
      "27414": true,
      "27415": true,
      "27416": true,
      "27417": true,
      "27418": true,
      "27419": true,
      "27420": true,
      "27421": true,
      "27422": true,
      "27423": true,
      "27424": true,
      "27425": true,
      "27426": true,
      "27427": true,
      "27428": true,
      "27429": true,
      "27430": true,
      "27431": true,
      "27432": true,
      "27433": true,
      "27434": true,
      "27435": true,
      "27436": true,
      "27437": true,
      "27438": true,
      "27439": true
    },
    "VIESCA": {
      "27480": true,
      "27481": true,
      "27482": true,
      "27483": true,
      "27485": true,
      "27487": true
    },
    "VILLA UNION": {
      "26600": true,
      "26601": true,
      "26602": true,
      "26603": true,
      "26604": true,
      "26605": true,
      "26606": true,
      "26607": true,
      "26608": true,
      "26609": true,
      "26610": true,
      "26611": true,
      "26612": true,
      "26613": true,
      "26617": true,
      "26618": true,
      "26619": true,
      "26624": true,
      "26630": true,
      "26631": true,
      "26632": true,
      "26633": true,
      "26636": true
    }
  },
  "COLIMA": {
    "ARMERIA": {
      "28300": true,
      "28301": true,
      "28302": true,
      "28303": true,
      "28304": true,
      "28305": true,
      "28306": true,
      "28307": true,
      "28308": true,
      "28309": true,
      "28310": true,
      "28311": true,
      "28312": true,
      "28313": true,
      "28314": true,
      "28315": true,
      "28316": true,
      "28317": true,
      "28318": true,
      "28319": true,
      "28320": true,
      "28321": true,
      "28322": true,
      "28323": true,
      "28324": true,
      "28325": true,
      "28326": true,
      "28327": true,
      "28328": true,
      "28329": true,
      "28330": true,
      "28331": true,
      "28332": true,
      "28333": true,
      "28334": true,
      "28335": true,
      "28336": true,
      "28337": true,
      "28338": true,
      "28339": true,
      "28340": true,
      "28341": true,
      "28342": true,
      "28343": true,
      "28344": true,
      "28345": true,
      "28346": true,
      "28347": true,
      "28348": true,
      "28349": true,
      "28350": true,
      "28351": true,
      "28352": true,
      "28353": true,
      "28354": true,
      "28355": true,
      "28356": true,
      "28357": true,
      "28358": true,
      "28359": true,
      "28360": true,
      "28361": true,
      "28362": true,
      "28363": true,
      "28364": true,
      "28365": true,
      "28366": true,
      "28367": true,
      "28368": true,
      "28369": true,
      "28370": true,
      "28371": true,
      "28372": true,
      "28373": true,
      "28374": true,
      "28375": true,
      "28376": true,
      "28377": true,
      "28378": true,
      "28379": true,
      "28380": true,
      "28381": true,
      "28382": true,
      "28383": true,
      "28384": true,
      "28385": true,
      "28386": true,
      "28387": true,
      "28388": true,
      "28389": true,
      "28390": true,
      "28391": true,
      "28392": true,
      "28393": true,
      "28394": true,
      "28395": true,
      "28396": true,
      "28397": true,
      "28398": true,
      "28399": true
    },
    "COLIMA": {
      "28000": true,
      "28001": true,
      "28002": true,
      "28003": true,
      "28004": true,
      "28005": true,
      "28006": true,
      "28007": true,
      "28008": true,
      "28009": true,
      "28010": true,
      "28011": true,
      "28012": true,
      "28013": true,
      "28014": true,
      "28015": true,
      "28016": true,
      "28017": true,
      "28018": true,
      "28019": true,
      "28020": true,
      "28021": true,
      "28022": true,
      "28023": true,
      "28024": true,
      "28025": true,
      "28026": true,
      "28027": true,
      "28028": true,
      "28029": true,
      "28030": true,
      "28031": true,
      "28032": true,
      "28033": true,
      "28034": true,
      "28035": true,
      "28036": true,
      "28037": true,
      "28038": true,
      "28039": true,
      "28040": true,
      "28041": true,
      "28042": true,
      "28043": true,
      "28044": true,
      "28045": true,
      "28046": true,
      "28047": true,
      "28048": true,
      "28049": true,
      "28050": true,
      "28051": true,
      "28052": true,
      "28053": true,
      "28054": true,
      "28055": true,
      "28056": true,
      "28057": true,
      "28058": true,
      "28059": true,
      "28060": true,
      "28061": true,
      "28062": true,
      "28063": true,
      "28064": true,
      "28065": true,
      "28066": true,
      "28067": true,
      "28068": true,
      "28069": true,
      "28070": true,
      "28071": true,
      "28072": true,
      "28073": true,
      "28074": true,
      "28075": true,
      "28076": true,
      "28077": true,
      "28078": true,
      "28079": true,
      "28080": true,
      "28081": true,
      "28082": true,
      "28083": true,
      "28084": true,
      "28085": true,
      "28086": true,
      "28087": true,
      "28088": true,
      "28089": true,
      "28090": true,
      "28091": true,
      "28092": true,
      "28093": true,
      "28094": true,
      "28095": true,
      "28096": true,
      "28097": true,
      "28098": true,
      "28099": true,
      "28600": true,
      "28601": true,
      "28602": true,
      "28603": true,
      "28604": true,
      "28605": true,
      "28606": true,
      "28607": true,
      "28608": true,
      "28609": true,
      "28610": true,
      "28611": true,
      "28612": true,
      "28613": true,
      "28614": true,
      "28615": true,
      "28616": true,
      "28617": true,
      "28618": true,
      "28619": true,
      "28620": true,
      "28621": true,
      "28622": true,
      "28623": true,
      "28624": true,
      "28625": true,
      "28626": true,
      "28627": true,
      "28628": true,
      "28629": true,
      "28630": true,
      "28631": true,
      "28632": true,
      "28633": true,
      "28634": true,
      "28635": true,
      "28636": true,
      "28637": true,
      "28638": true,
      "28639": true,
      "28640": true,
      "28641": true,
      "28642": true,
      "28643": true,
      "28644": true,
      "28645": true,
      "28646": true,
      "28647": true,
      "28648": true,
      "28649": true,
      "28650": true,
      "28651": true,
      "28652": true,
      "28653": true,
      "28654": true,
      "28655": true,
      "28656": true,
      "28657": true,
      "28658": true,
      "28659": true,
      "28660": true,
      "28661": true,
      "28662": true,
      "28663": true,
      "28664": true,
      "28665": true,
      "28666": true,
      "28667": true,
      "28668": true,
      "28669": true,
      "28670": true,
      "28671": true,
      "28672": true,
      "28673": true,
      "28674": true,
      "28675": true,
      "28676": true,
      "28677": true,
      "28678": true,
      "28679": true,
      "28680": true,
      "28681": true,
      "28682": true,
      "28683": true,
      "28684": true,
      "28685": true,
      "28686": true,
      "28687": true,
      "28688": true,
      "28689": true,
      "28690": true,
      "28691": true,
      "28692": true,
      "28693": true,
      "28694": true,
      "28695": true,
      "28696": true,
      "28697": true,
      "28698": true,
      "28699": true
    },
    "COMALA": {
      "28450": true,
      "28451": true,
      "28452": true,
      "28453": true,
      "28454": true,
      "28455": true,
      "28456": true,
      "28457": true,
      "28458": true,
      "28459": true,
      "28460": true,
      "28461": true,
      "28462": true,
      "28463": true,
      "28464": true,
      "28465": true,
      "28466": true,
      "28467": true,
      "28468": true,
      "28469": true,
      "28470": true,
      "28471": true,
      "28472": true,
      "28473": true,
      "28474": true,
      "28475": true,
      "28476": true,
      "28477": true,
      "28478": true,
      "28479": true,
      "28480": true,
      "28481": true,
      "28482": true,
      "28483": true,
      "28484": true,
      "28485": true,
      "28486": true,
      "28487": true,
      "28488": true,
      "28489": true,
      "28490": true,
      "28491": true,
      "28492": true,
      "28493": true,
      "28494": true,
      "28495": true,
      "28496": true,
      "28497": true,
      "28498": true,
      "28499": true
    },
    "COQUIMATLAN": {
      "28400": true,
      "28401": true,
      "28402": true,
      "28403": true,
      "28404": true,
      "28405": true,
      "28406": true,
      "28407": true,
      "28408": true,
      "28409": true,
      "28410": true,
      "28411": true,
      "28412": true,
      "28413": true,
      "28414": true,
      "28415": true,
      "28416": true,
      "28417": true,
      "28418": true,
      "28419": true,
      "28420": true,
      "28421": true,
      "28422": true,
      "28423": true,
      "28424": true,
      "28425": true,
      "28426": true,
      "28427": true,
      "28428": true,
      "28429": true,
      "28430": true,
      "28431": true,
      "28432": true,
      "28433": true,
      "28434": true,
      "28435": true,
      "28436": true,
      "28437": true,
      "28438": true,
      "28439": true,
      "28440": true,
      "28441": true,
      "28442": true,
      "28443": true,
      "28444": true,
      "28445": true,
      "28446": true,
      "28447": true,
      "28448": true,
      "28449": true
    },
    "CUAUHTÉMOC": {
      "28500": true,
      "28501": true,
      "28502": true,
      "28503": true,
      "28504": true,
      "28505": true,
      "28506": true,
      "28507": true,
      "28508": true,
      "28509": true,
      "28510": true,
      "28511": true,
      "28512": true,
      "28513": true,
      "28514": true,
      "28515": true,
      "28516": true,
      "28517": true,
      "28518": true,
      "28519": true,
      "28520": true,
      "28521": true,
      "28522": true,
      "28523": true,
      "28524": true,
      "28525": true,
      "28526": true,
      "28527": true,
      "28528": true,
      "28529": true,
      "28530": true,
      "28531": true,
      "28532": true,
      "28533": true,
      "28534": true,
      "28535": true,
      "28536": true,
      "28537": true,
      "28538": true,
      "28539": true,
      "28540": true,
      "28541": true,
      "28542": true,
      "28543": true,
      "28544": true,
      "28545": true,
      "28546": true,
      "28547": true,
      "28548": true,
      "28549": true,
      "28550": true,
      "28551": true,
      "28552": true,
      "28553": true,
      "28554": true,
      "28555": true,
      "28556": true,
      "28557": true,
      "28558": true,
      "28559": true,
      "28560": true,
      "28561": true,
      "28562": true,
      "28563": true,
      "28564": true,
      "28565": true,
      "28566": true,
      "28567": true,
      "28568": true,
      "28569": true,
      "28570": true,
      "28571": true,
      "28572": true,
      "28573": true,
      "28574": true,
      "28575": true,
      "28576": true,
      "28577": true,
      "28578": true,
      "28579": true,
      "28580": true,
      "28581": true,
      "28582": true,
      "28583": true,
      "28584": true,
      "28585": true,
      "28586": true,
      "28587": true,
      "28588": true,
      "28589": true,
      "28590": true,
      "28591": true,
      "28592": true,
      "28593": true,
      "28594": true,
      "28595": true,
      "28596": true,
      "28599": true
    },
    "TECOMAN": {
      "28100": true,
      "28101": true,
      "28102": true,
      "28103": true,
      "28104": true,
      "28105": true,
      "28106": true,
      "28107": true,
      "28108": true,
      "28109": true,
      "28110": true,
      "28111": true,
      "28112": true,
      "28113": true,
      "28114": true,
      "28115": true,
      "28116": true,
      "28117": true,
      "28118": true,
      "28119": true,
      "28120": true,
      "28121": true,
      "28122": true,
      "28123": true,
      "28124": true,
      "28125": true,
      "28126": true,
      "28127": true,
      "28128": true,
      "28129": true,
      "28130": true,
      "28131": true,
      "28132": true,
      "28133": true,
      "28134": true,
      "28135": true,
      "28136": true,
      "28137": true,
      "28138": true,
      "28139": true,
      "28140": true,
      "28141": true,
      "28142": true,
      "28143": true,
      "28144": true,
      "28145": true,
      "28146": true,
      "28147": true,
      "28148": true,
      "28149": true,
      "28150": true,
      "28151": true,
      "28152": true,
      "28153": true,
      "28154": true,
      "28155": true,
      "28156": true,
      "28157": true,
      "28158": true,
      "28159": true,
      "28160": true,
      "28161": true,
      "28162": true,
      "28163": true,
      "28164": true,
      "28165": true,
      "28166": true,
      "28167": true,
      "28168": true,
      "28169": true,
      "28170": true,
      "28171": true,
      "28172": true,
      "28173": true,
      "28174": true,
      "28175": true,
      "28176": true,
      "28177": true,
      "28178": true,
      "28179": true,
      "28180": true,
      "28181": true,
      "28182": true,
      "28183": true,
      "28184": true,
      "28185": true,
      "28186": true,
      "28187": true,
      "28188": true,
      "28189": true,
      "28190": true,
      "28191": true,
      "28192": true,
      "28193": true,
      "28194": true,
      "28195": true,
      "28196": true,
      "28197": true,
      "28198": true,
      "28199": true,
      "28900": true,
      "28901": true,
      "28902": true,
      "28903": true,
      "28904": true,
      "28905": true,
      "28906": true,
      "28907": true,
      "28908": true,
      "28909": true,
      "28910": true,
      "28911": true,
      "28912": true,
      "28913": true,
      "28914": true,
      "28915": true,
      "28916": true,
      "28917": true,
      "28918": true,
      "28919": true,
      "28920": true,
      "28921": true,
      "28922": true,
      "28930": true,
      "28931": true,
      "28932": true,
      "28933": true,
      "28934": true,
      "28935": true,
      "28936": true,
      "28937": true,
      "28938": true,
      "28939": true,
      "28944": true
    },
    "VILLA DE ÁLVAREZ": {
      "28950": true,
      "28951": true,
      "28952": true,
      "28953": true,
      "28954": true,
      "28955": true,
      "28956": true,
      "28957": true,
      "28958": true,
      "28959": true,
      "28960": true,
      "28961": true,
      "28962": true,
      "28963": true,
      "28964": true,
      "28965": true,
      "28966": true,
      "28967": true,
      "28968": true,
      "28969": true,
      "28970": true,
      "28971": true,
      "28972": true,
      "28973": true,
      "28974": true,
      "28975": true,
      "28976": true,
      "28977": true,
      "28978": true,
      "28979": true,
      "28980": true,
      "28981": true,
      "28982": true,
      "28983": true,
      "28984": true,
      "28985": true,
      "28986": true,
      "28987": true,
      "28988": true,
      "28989": true,
      "28990": true,
      "28991": true,
      "28992": true,
      "28993": true,
      "28994": true,
      "28995": true,
      "28996": true,
      "28997": true,
      "28998": true,
      "28999": true
    }
  },
  "DURANGO": {
    "CANATLAN": {
      "34400": true,
      "34401": true,
      "34402": true,
      "34405": true,
      "34406": true,
      "34407": true,
      "34408": true,
      "34409": true,
      "34444": true,
      "34446": true,
      "34447": true,
      "34448": true,
      "34449": true,
      "34450": true,
      "34451": true,
      "34452": true,
      "34453": true,
      "34454": true,
      "34455": true,
      "34456": true,
      "34457": true,
      "34458": true,
      "34459": true,
      "34460": true,
      "34461": true,
      "34462": true,
      "34464": true,
      "34465": true,
      "34466": true,
      "34467": true,
      "34468": true,
      "34469": true
    },
    "CUENCAME": {
      "35800": true,
      "35801": true,
      "35802": true,
      "35803": true,
      "35804": true,
      "35805": true,
      "35806": true,
      "35807": true,
      "35808": true,
      "35809": true,
      "35815": true,
      "35817": true,
      "35818": true,
      "35819": true,
      "35824": true,
      "35827": true,
      "35828": true,
      "35829": true,
      "35830": true,
      "35831": true,
      "35832": true,
      "35833": true,
      "35834": true,
      "35835": true,
      "35836": true,
      "35837": true,
      "35838": true,
      "35839": true
    },
    "DURANGO": {
      "34000": true,
      "34001": true,
      "34002": true,
      "34003": true,
      "34004": true,
      "34005": true,
      "34006": true,
      "34007": true,
      "34008": true,
      "34009": true,
      "34010": true,
      "34011": true,
      "34012": true,
      "34013": true,
      "34014": true,
      "34015": true,
      "34016": true,
      "34017": true,
      "34018": true,
      "34019": true,
      "34020": true,
      "34021": true,
      "34022": true,
      "34023": true,
      "34024": true,
      "34025": true,
      "34026": true,
      "34027": true,
      "34028": true,
      "34029": true,
      "34030": true,
      "34031": true,
      "34032": true,
      "34033": true,
      "34034": true,
      "34035": true,
      "34036": true,
      "34037": true,
      "34038": true,
      "34039": true,
      "34040": true,
      "34041": true,
      "34042": true,
      "34043": true,
      "34044": true,
      "34045": true,
      "34046": true,
      "34047": true,
      "34048": true,
      "34049": true,
      "34050": true,
      "34051": true,
      "34052": true,
      "34053": true,
      "34054": true,
      "34055": true,
      "34056": true,
      "34057": true,
      "34058": true,
      "34059": true,
      "34060": true,
      "34061": true,
      "34062": true,
      "34063": true,
      "34064": true,
      "34065": true,
      "34066": true,
      "34067": true,
      "34068": true,
      "34069": true,
      "34070": true,
      "34071": true,
      "34072": true,
      "34073": true,
      "34074": true,
      "34075": true,
      "34076": true,
      "34077": true,
      "34078": true,
      "34079": true,
      "34080": true,
      "34081": true,
      "34082": true,
      "34083": true,
      "34084": true,
      "34085": true,
      "34086": true,
      "34087": true,
      "34088": true,
      "34089": true,
      "34090": true,
      "34091": true,
      "34092": true,
      "34093": true,
      "34094": true,
      "34095": true,
      "34096": true,
      "34097": true,
      "34098": true,
      "34099": true,
      "34100": true,
      "34101": true,
      "34102": true,
      "34103": true,
      "34104": true,
      "34105": true,
      "34106": true,
      "34107": true,
      "34108": true,
      "34109": true,
      "34110": true,
      "34111": true,
      "34112": true,
      "34113": true,
      "34114": true,
      "34115": true,
      "34116": true,
      "34117": true,
      "34118": true,
      "34119": true,
      "34120": true,
      "34121": true,
      "34122": true,
      "34123": true,
      "34124": true,
      "34125": true,
      "34126": true,
      "34127": true,
      "34128": true,
      "34129": true,
      "34130": true,
      "34131": true,
      "34132": true,
      "34133": true,
      "34134": true,
      "34135": true,
      "34136": true,
      "34137": true,
      "34138": true,
      "34139": true,
      "34140": true,
      "34141": true,
      "34142": true,
      "34143": true,
      "34144": true,
      "34145": true,
      "34146": true,
      "34147": true,
      "34148": true,
      "34149": true,
      "34150": true,
      "34151": true,
      "34152": true,
      "34153": true,
      "34154": true,
      "34155": true,
      "34156": true,
      "34157": true,
      "34158": true,
      "34159": true,
      "34160": true,
      "34161": true,
      "34162": true,
      "34163": true,
      "34164": true,
      "34165": true,
      "34166": true,
      "34167": true,
      "34168": true,
      "34169": true,
      "34170": true,
      "34171": true,
      "34172": true,
      "34173": true,
      "34174": true,
      "34175": true,
      "34176": true,
      "34177": true,
      "34178": true,
      "34179": true,
      "34180": true,
      "34181": true,
      "34182": true,
      "34183": true,
      "34184": true,
      "34185": true,
      "34186": true,
      "34187": true,
      "34188": true,
      "34189": true,
      "34190": true,
      "34191": true,
      "34192": true,
      "34193": true,
      "34194": true,
      "34195": true,
      "34196": true,
      "34197": true,
      "34198": true,
      "34199": true,
      "34200": true,
      "34201": true,
      "34202": true,
      "34203": true,
      "34204": true,
      "34205": true,
      "34206": true,
      "34207": true,
      "34208": true,
      "34209": true,
      "34210": true,
      "34211": true,
      "34212": true,
      "34213": true,
      "34214": true,
      "34215": true,
      "34216": true,
      "34217": true,
      "34218": true,
      "34219": true,
      "34220": true,
      "34221": true,
      "34222": true,
      "34223": true,
      "34224": true,
      "34225": true,
      "34226": true,
      "34227": true,
      "34228": true,
      "34229": true,
      "34230": true,
      "34231": true,
      "34232": true,
      "34233": true,
      "34234": true,
      "34235": true,
      "34236": true,
      "34237": true,
      "34238": true,
      "34239": true,
      "34240": true,
      "34241": true,
      "34242": true,
      "34243": true,
      "34244": true,
      "34245": true,
      "34246": true,
      "34247": true,
      "34248": true,
      "34249": true,
      "34250": true,
      "34251": true,
      "34252": true,
      "34253": true,
      "34254": true,
      "34255": true,
      "34256": true,
      "34257": true,
      "34258": true,
      "34259": true,
      "34260": true,
      "34261": true,
      "34262": true,
      "34263": true,
      "34264": true,
      "34265": true,
      "34266": true,
      "34267": true,
      "34268": true,
      "34269": true,
      "34270": true,
      "34271": true,
      "34272": true,
      "34273": true,
      "34274": true,
      "34275": true,
      "34276": true,
      "34277": true,
      "34278": true,
      "34279": true,
      "34280": true,
      "34281": true,
      "34282": true,
      "34283": true,
      "34284": true,
      "34285": true,
      "34286": true,
      "34287": true,
      "34288": true,
      "34289": true,
      "34290": true,
      "34291": true,
      "34292": true,
      "34293": true,
      "34294": true,
      "34295": true,
      "34296": true,
      "34297": true,
      "34298": true,
      "34299": true,
      "34300": true,
      "34301": true,
      "34302": true,
      "34303": true,
      "34304": true,
      "34305": true,
      "34306": true,
      "34307": true,
      "34308": true,
      "34309": true,
      "34310": true,
      "34311": true,
      "34312": true,
      "34313": true,
      "34314": true,
      "34315": true,
      "34316": true,
      "34317": true,
      "34318": true,
      "34319": true,
      "34320": true,
      "34321": true,
      "34322": true,
      "34323": true,
      "34324": true,
      "34325": true,
      "34326": true,
      "34327": true,
      "34328": true,
      "34329": true,
      "34330": true,
      "34331": true,
      "34332": true,
      "34333": true,
      "34334": true,
      "34335": true,
      "34336": true,
      "34337": true,
      "34338": true,
      "34339": true,
      "34340": true,
      "34341": true,
      "34342": true,
      "34343": true,
      "34344": true,
      "34345": true,
      "34346": true,
      "34347": true,
      "34348": true,
      "34349": true,
      "34350": true,
      "34351": true,
      "34352": true,
      "34353": true,
      "34354": true,
      "34355": true,
      "34356": true,
      "34357": true,
      "34358": true,
      "34359": true,
      "34360": true,
      "34361": true,
      "34362": true,
      "34363": true,
      "34364": true,
      "34365": true,
      "34366": true,
      "34367": true,
      "34368": true,
      "34369": true,
      "34370": true,
      "34371": true,
      "34372": true,
      "34373": true,
      "34374": true,
      "34375": true,
      "34376": true,
      "34377": true,
      "34378": true,
      "34379": true,
      "34380": true,
      "34381": true,
      "34382": true,
      "34383": true,
      "34384": true,
      "34385": true,
      "34386": true,
      "34387": true,
      "34388": true,
      "34389": true,
      "34390": true,
      "34391": true,
      "34392": true,
      "34393": true,
      "34394": true,
      "34395": true,
      "34396": true,
      "34397": true,
      "34398": true,
      "34399": true
    },
    "GOMEZ PALACIO": {
      "35000": true,
      "35001": true,
      "35002": true,
      "35003": true,
      "35004": true,
      "35005": true,
      "35006": true,
      "35007": true,
      "35008": true,
      "35009": true,
      "35010": true,
      "35011": true,
      "35012": true,
      "35013": true,
      "35014": true,
      "35015": true,
      "35016": true,
      "35017": true,
      "35018": true,
      "35019": true,
      "35020": true,
      "35021": true,
      "35022": true,
      "35023": true,
      "35024": true,
      "35025": true,
      "35026": true,
      "35027": true,
      "35028": true,
      "35029": true,
      "35030": true,
      "35031": true,
      "35032": true,
      "35033": true,
      "35034": true,
      "35035": true,
      "35036": true,
      "35037": true,
      "35038": true,
      "35039": true,
      "35040": true,
      "35041": true,
      "35042": true,
      "35043": true,
      "35044": true,
      "35045": true,
      "35046": true,
      "35047": true,
      "35048": true,
      "35049": true,
      "35050": true,
      "35051": true,
      "35052": true,
      "35053": true,
      "35054": true,
      "35055": true,
      "35056": true,
      "35057": true,
      "35058": true,
      "35059": true,
      "35060": true,
      "35061": true,
      "35062": true,
      "35063": true,
      "35064": true,
      "35065": true,
      "35066": true,
      "35067": true,
      "35068": true,
      "35069": true,
      "35070": true,
      "35071": true,
      "35072": true,
      "35073": true,
      "35074": true,
      "35075": true,
      "35076": true,
      "35077": true,
      "35078": true,
      "35079": true,
      "35080": true,
      "35081": true,
      "35082": true,
      "35083": true,
      "35084": true,
      "35085": true,
      "35086": true,
      "35087": true,
      "35088": true,
      "35089": true,
      "35090": true,
      "35091": true,
      "35092": true,
      "35093": true,
      "35094": true,
      "35095": true,
      "35096": true,
      "35097": true,
      "35098": true,
      "35099": true,
      "35100": true,
      "35101": true,
      "35102": true,
      "35103": true,
      "35104": true,
      "35105": true,
      "35106": true,
      "35107": true,
      "35108": true,
      "35109": true,
      "35110": true,
      "35111": true,
      "35112": true,
      "35113": true,
      "35114": true,
      "35115": true,
      "35116": true,
      "35117": true,
      "35118": true,
      "35119": true,
      "35120": true,
      "35121": true,
      "35122": true,
      "35123": true,
      "35124": true,
      "35125": true,
      "35126": true,
      "35127": true,
      "35128": true,
      "35129": true,
      "35130": true,
      "35131": true,
      "35132": true,
      "35133": true,
      "35134": true,
      "35135": true,
      "35136": true,
      "35137": true,
      "35138": true,
      "35139": true,
      "35140": true,
      "35141": true,
      "35142": true,
      "35143": true,
      "35144": true,
      "35145": true,
      "35146": true,
      "35147": true,
      "35148": true,
      "35149": true
    },
    "GUADALUPE VICTORIA": {
      "34700": true,
      "34701": true,
      "34702": true,
      "34703": true,
      "34704": true,
      "34705": true,
      "34706": true,
      "34707": true,
      "34708": true,
      "34709": true,
      "34710": true,
      "34711": true,
      "34712": true,
      "34713": true,
      "34715": true,
      "34716": true,
      "34720": true,
      "34721": true,
      "34722": true,
      "34723": true,
      "34724": true,
      "34725": true,
      "34726": true,
      "34727": true,
      "34728": true,
      "34729": true,
      "34733": true
    },
    "LERDO": {
      "35150": true,
      "35151": true,
      "35152": true,
      "35153": true,
      "35154": true,
      "35155": true,
      "35156": true,
      "35157": true,
      "35158": true,
      "35159": true,
      "35160": true,
      "35161": true,
      "35162": true,
      "35163": true,
      "35164": true,
      "35165": true,
      "35166": true,
      "35167": true,
      "35168": true,
      "35169": true,
      "35170": true,
      "35179": true,
      "35180": true,
      "35181": true,
      "35185": true,
      "35186": true,
      "35187": true,
      "35188": true,
      "35189": true,
      "35190": true
    },
    "MAPIMI": {
      "35200": true,
      "35201": true,
      "35202": true,
      "35203": true,
      "35204": true,
      "35205": true,
      "35206": true,
      "35207": true,
      "35208": true,
      "35209": true,
      "35219": true,
      "35220": true,
      "35221": true,
      "35222": true,
      "35223": true,
      "35230": true,
      "35231": true,
      "35232": true,
      "35235": true,
      "35238": true,
      "35239": true,
      "35240": true
    },
    "MEZQUITAL": {
      "34970": true,
      "34971": true,
      "34972": true,
      "34973": true,
      "34974": true,
      "34975": true,
      "34978": true,
      "34979": true,
      "34987": true,
      "34996": true
    },
    "NAZAS": {
      "35700": true,
      "35701": true,
      "35702": true,
      "35703": true,
      "35704": true,
      "35705": true,
      "35706": true,
      "35707": true,
      "35708": true,
      "35709": true,
      "35710": true,
      "35711": true,
      "35712": true,
      "35713": true,
      "35714": true,
      "35715": true,
      "35716": true,
      "35717": true,
      "35718": true,
      "35719": true,
      "35720": true,
      "35721": true,
      "35722": true,
      "35724": true,
      "35725": true,
      "35726": true,
      "35727": true,
      "35728": true,
      "35729": true,
      "35730": true,
      "35731": true,
      "35732": true,
      "35733": true,
      "35734": true,
      "35735": true,
      "35736": true,
      "35737": true,
      "35738": true,
      "35739": true
    },
    "NOMBRE DE DIOS": {
      "34840": true,
      "34841": true,
      "34842": true,
      "34843": true,
      "34844": true,
      "34845": true,
      "34846": true,
      "34847": true,
      "34848": true,
      "34849": true,
      "34850": true,
      "34851": true,
      "34852": true,
      "34853": true,
      "34854": true,
      "34855": true,
      "34856": true,
      "34857": true,
      "34858": true,
      "34859": true,
      "34864": true,
      "34865": true,
      "34880": true,
      "34881": true,
      "34882": true,
      "34883": true,
      "34884": true,
      "34885": true,
      "34886": true,
      "34887": true,
      "34888": true,
      "34889": true
    },
    "NUEVO IDEAL": {
      "34410": true,
      "34411": true,
      "34412": true,
      "34413": true,
      "34414": true,
      "34415": true,
      "34416": true,
      "34417": true,
      "34418": true,
      "34419": true,
      "34420": true,
      "34421": true,
      "34422": true,
      "34423": true,
      "34424": true,
      "34425": true,
      "34426": true,
      "34427": true,
      "34428": true,
      "34429": true,
      "34430": true,
      "34431": true,
      "34432": true,
      "34433": true,
      "34434": true,
      "34435": true,
      "34436": true
    },
    "PANUCO DE CORONADO": {
      "34770": true,
      "34771": true,
      "34772": true,
      "34773": true,
      "34774": true,
      "34775": true,
      "34776": true,
      "34777": true,
      "34778": true,
      "34779": true,
      "34780": true,
      "34781": true,
      "34782": true,
      "34783": true,
      "34784": true,
      "34785": true,
      "34786": true,
      "34787": true,
      "34788": true,
      "34789": true,
      "34793": true
    },
    "PENON BLANCO": {
      "34740": true,
      "34741": true,
      "34742": true,
      "34743": true,
      "34744": true,
      "34745": true,
      "34748": true,
      "34749": true,
      "34750": true,
      "34751": true,
      "34752": true,
      "34755": true,
      "34756": true,
      "34760": true,
      "34761": true,
      "34762": true,
      "34763": true,
      "34764": true,
      "34765": true,
      "34766": true,
      "34767": true,
      "34768": true,
      "34769": true
    },
    "POANAS": {
      "34800": true,
      "34801": true,
      "34802": true,
      "34803": true,
      "34810": true,
      "34811": true,
      "34812": true,
      "34813": true,
      "34814": true,
      "34815": true,
      "34816": true,
      "34817": true,
      "34818": true,
      "34819": true,
      "34820": true,
      "34821": true,
      "34822": true,
      "34823": true,
      "34824": true,
      "34825": true,
      "34826": true,
      "34827": true,
      "34828": true,
      "34829": true,
      "34830": true,
      "34831": true,
      "34832": true,
      "34833": true,
      "34834": true,
      "34835": true,
      "34836": true,
      "34837": true,
      "34838": true,
      "34839": true
    },
    "PUEBLO NUEVO": {
      "34940": true,
      "34941": true,
      "34942": true,
      "34943": true,
      "34944": true,
      "34945": true,
      "34946": true,
      "34947": true,
      "34948": true,
      "34949": true,
      "34950": true,
      "34951": true,
      "34952": true,
      "34953": true,
      "34957": true,
      "34958": true,
      "34959": true,
      "34960": true,
      "34961": true,
      "34962": true,
      "34965": true,
      "34966": true
    },
    "SAN JUAN DEL RIO": {
      "34480": true,
      "34481": true,
      "34482": true,
      "34483": true,
      "34484": true,
      "34485": true,
      "34486": true,
      "34487": true,
      "34490": true,
      "34491": true,
      "34492": true,
      "34493": true,
      "34494": true,
      "34495": true,
      "34496": true,
      "34497": true,
      "34498": true,
      "34499": true
    },
    "SANTIAGO PAPASQUIARO": {
      "34600": true,
      "34601": true,
      "34602": true,
      "34605": true,
      "34606": true,
      "34607": true,
      "34608": true,
      "34609": true,
      "34610": true,
      "34611": true,
      "34612": true,
      "34614": true,
      "34630": true,
      "34631": true,
      "34632": true,
      "34633": true,
      "34634": true,
      "34635": true,
      "34636": true,
      "34637": true,
      "34638": true,
      "34639": true,
      "34640": true,
      "34641": true,
      "34642": true,
      "34643": true,
      "34644": true,
      "34645": true,
      "34646": true,
      "34647": true,
      "34648": true,
      "34649": true
    },
    "SUCHIL": {
      "34900": true,
      "34901": true,
      "34902": true,
      "34903": true,
      "34904": true,
      "34905": true,
      "34906": true,
      "34907": true,
      "34908": true,
      "34909": true,
      "34910": true,
      "34911": true,
      "34912": true,
      "34913": true,
      "34914": true,
      "34915": true,
      "34916": true,
      "34917": true,
      "34918": true,
      "34919": true,
      "34923": true,
      "34924": true,
      "34925": true,
      "34926": true,
      "34927": true,
      "34928": true,
      "34929": true,
      "34935": true
    },
    "TLAHUALILO": {
      "35250": true,
      "35251": true,
      "35252": true,
      "35253": true,
      "35254": true,
      "35255": true,
      "35256": true,
      "35257": true,
      "35258": true,
      "35259": true,
      "35260": true,
      "35261": true,
      "35262": true,
      "35263": true,
      "35264": true,
      "35265": true,
      "35266": true,
      "35270": true,
      "35271": true,
      "35272": true,
      "35273": true,
      "35274": true,
      "35280": true,
      "35281": true,
      "35282": true,
      "35283": true,
      "35284": true,
      "35285": true,
      "35286": true,
      "35287": true,
      "35288": true,
      "35289": true,
      "35290": true,
      "35291": true,
      "35292": true,
      "35296": true
    },
    "VICENTE GUERRERO": {
      "34890": true,
      "34891": true,
      "34892": true,
      "34893": true,
      "34894": true,
      "34895": true,
      "34896": true,
      "34897": true,
      "34898": true,
      "34899": true
    }
  },
  "ESTADO DE MÉXICO": {
    "ACAMBAY DE RUIZ CASTANEDA": {
      "50300": true,
      "50301": true,
      "50302": true,
      "50303": true,
      "50304": true,
      "50305": true,
      "50306": true,
      "50307": true,
      "50308": true,
      "50309": true,
      "50310": true,
      "50311": true,
      "50312": true,
      "50313": true,
      "50314": true,
      "50315": true,
      "50316": true,
      "50317": true,
      "50318": true,
      "50319": true,
      "50320": true,
      "50321": true,
      "50322": true,
      "50323": true,
      "50324": true,
      "50325": true,
      "50326": true,
      "50327": true,
      "50328": true,
      "50329": true,
      "50330": true,
      "50331": true,
      "50332": true,
      "50333": true,
      "50334": true,
      "50335": true,
      "50336": true,
      "50337": true,
      "50338": true,
      "50339": true,
      "50340": true,
      "50341": true,
      "50342": true,
      "50343": true,
      "50344": true,
      "50345": true,
      "50346": true,
      "50347": true,
      "50348": true,
      "50349": true,
      "50350": true,
      "50351": true,
      "50352": true
    },
    "ACOLMAN": {
      "55870": true,
      "55871": true,
      "55872": true,
      "55873": true,
      "55874": true,
      "55875": true,
      "55876": true,
      "55877": true,
      "55878": true,
      "55879": true,
      "55880": true,
      "55881": true,
      "55882": true,
      "55883": true,
      "55884": true,
      "55885": true,
      "55886": true,
      "55887": true,
      "55888": true,
      "55889": true,
      "55890": true,
      "55891": true,
      "55892": true,
      "55893": true,
      "55894": true,
      "55895": true,
      "55896": true,
      "55897": true,
      "55898": true,
      "55899": true
    },
    "ALMOLOYA DE JUÁREZ": {
      "50900": true,
      "50901": true,
      "50902": true,
      "50903": true,
      "50904": true,
      "50905": true,
      "50906": true,
      "50907": true,
      "50908": true,
      "50909": true,
      "50920": true,
      "50921": true,
      "50922": true,
      "50923": true,
      "50930": true,
      "50931": true,
      "50932": true,
      "50933": true,
      "50934": true,
      "50935": true,
      "50936": true,
      "50937": true,
      "50938": true,
      "50939": true,
      "50940": true,
      "50941": true,
      "50942": true,
      "50943": true,
      "50946": true,
      "50947": true,
      "50948": true,
      "50949": true,
      "50950": true,
      "50951": true,
      "50952": true,
      "50953": true,
      "50954": true,
      "50955": true,
      "50956": true,
      "50957": true,
      "50958": true,
      "50959": true
    },
    "AMECAMECA": {
      "56900": true,
      "56901": true,
      "56902": true,
      "56903": true,
      "56904": true,
      "56905": true,
      "56906": true,
      "56907": true,
      "56908": true,
      "56909": true,
      "56910": true,
      "56911": true,
      "56912": true,
      "56913": true,
      "56914": true,
      "56915": true,
      "56916": true,
      "56917": true,
      "56918": true,
      "56919": true,
      "56920": true,
      "56921": true,
      "56922": true,
      "56924": true,
      "56925": true,
      "56926": true,
      "56927": true,
      "56928": true,
      "56929": true,
      "56930": true,
      "56931": true,
      "56932": true,
      "56933": true,
      "56934": true,
      "56935": true,
      "56936": true,
      "56937": true,
      "56938": true,
      "56939": true,
      "56940": true,
      "56941": true,
      "56942": true,
      "56943": true,
      "56944": true,
      "56945": true,
      "56946": true,
      "56947": true,
      "56948": true,
      "56949": true,
      "56950": true,
      "56951": true,
      "56952": true,
      "56953": true,
      "56954": true,
      "56955": true,
      "56956": true,
      "56957": true,
      "56958": true,
      "56959": true,
      "56960": true,
      "56961": true,
      "56962": true,
      "56963": true,
      "56964": true,
      "56965": true,
      "56966": true,
      "56967": true,
      "56968": true,
      "56969": true
    },
    "APAXCO": {
      "55660": true,
      "55661": true,
      "55662": true,
      "55663": true,
      "55664": true,
      "55665": true,
      "55666": true,
      "55667": true,
      "55668": true,
      "55669": true
    },
    "ATIZAPÁN DE ZARAGOZA": {
      "52900": true,
      "52901": true,
      "52902": true,
      "52903": true,
      "52904": true,
      "52905": true,
      "52906": true,
      "52907": true,
      "52908": true,
      "52909": true,
      "52910": true,
      "52911": true,
      "52912": true,
      "52913": true,
      "52914": true,
      "52915": true,
      "52916": true,
      "52917": true,
      "52918": true,
      "52919": true,
      "52920": true,
      "52921": true,
      "52922": true,
      "52923": true,
      "52924": true,
      "52925": true,
      "52926": true,
      "52927": true,
      "52928": true,
      "52929": true,
      "52930": true,
      "52931": true,
      "52932": true,
      "52933": true,
      "52934": true,
      "52935": true,
      "52936": true,
      "52937": true,
      "52938": true,
      "52939": true,
      "52940": true,
      "52941": true,
      "52942": true,
      "52943": true,
      "52944": true,
      "52945": true,
      "52946": true,
      "52947": true,
      "52948": true,
      "52949": true,
      "52950": true,
      "52951": true,
      "52952": true,
      "52953": true,
      "52954": true,
      "52955": true,
      "52956": true,
      "52957": true,
      "52958": true,
      "52959": true,
      "52960": true,
      "52961": true,
      "52962": true,
      "52963": true,
      "52964": true,
      "52965": true,
      "52966": true,
      "52967": true,
      "52968": true,
      "52969": true,
      "52970": true,
      "52971": true,
      "52972": true,
      "52973": true,
      "52974": true,
      "52975": true,
      "52976": true,
      "52977": true,
      "52978": true,
      "52979": true,
      "52980": true,
      "52981": true,
      "52982": true,
      "52983": true,
      "52984": true,
      "52985": true,
      "52986": true,
      "52987": true,
      "52988": true,
      "52989": true,
      "52990": true,
      "52991": true,
      "52992": true,
      "52993": true,
      "52994": true,
      "52995": true,
      "52996": true,
      "52997": true,
      "52998": true,
      "52999": true
    },
    "ATLACOMULCO": {
      "50450": true,
      "50451": true,
      "50452": true,
      "50453": true,
      "50454": true,
      "50455": true,
      "50456": true,
      "50457": true,
      "50458": true,
      "50459": true,
      "50460": true,
      "50461": true,
      "50462": true,
      "50463": true,
      "50464": true,
      "50465": true,
      "50466": true,
      "50467": true,
      "50468": true,
      "50469": true,
      "50470": true,
      "50471": true,
      "50472": true,
      "50473": true,
      "50474": true,
      "50475": true,
      "50476": true,
      "50477": true,
      "50478": true,
      "50479": true,
      "50480": true,
      "50481": true,
      "50482": true,
      "50483": true,
      "50484": true,
      "50485": true,
      "50486": true,
      "50487": true,
      "50488": true,
      "50489": true,
      "50490": true,
      "50491": true,
      "50492": true,
      "50493": true,
      "50494": true,
      "50495": true,
      "50496": true,
      "50497": true,
      "50498": true,
      "50499": true
    },
    "ATLAUTLA": {
      "56970": true,
      "56971": true,
      "56972": true,
      "56973": true,
      "56974": true,
      "56975": true,
      "56976": true,
      "56977": true,
      "56978": true,
      "56979": true,
      "56980": true,
      "56981": true,
      "56982": true,
      "56983": true,
      "56984": true,
      "56985": true,
      "56986": true,
      "56987": true,
      "56988": true,
      "56989": true
    },
    "AXAPUSCO": {
      "55940": true,
      "55941": true,
      "55942": true,
      "55943": true,
      "55944": true,
      "55945": true,
      "55946": true,
      "55947": true,
      "55948": true,
      "55949": true,
      "55950": true,
      "55951": true,
      "55952": true,
      "55953": true,
      "55954": true,
      "55955": true,
      "55956": true,
      "55957": true,
      "55958": true,
      "55959": true,
      "55963": true,
      "55964": true,
      "55965": true,
      "55966": true,
      "55967": true,
      "55968": true,
      "55969": true
    },
    "AYAPANGO": {
      "56760": true,
      "56761": true,
      "56762": true,
      "56763": true,
      "56764": true,
      "56765": true,
      "56766": true,
      "56770": true,
      "56771": true,
      "56772": true,
      "56773": true,
      "56774": true,
      "56775": true,
      "56776": true,
      "56777": true,
      "56778": true,
      "56779": true
    },
    "CALIMAYA": {
      "52200": true,
      "52201": true,
      "52202": true,
      "52203": true,
      "52204": true,
      "52205": true,
      "52206": true,
      "52207": true,
      "52208": true,
      "52209": true,
      "52210": true,
      "52211": true,
      "52212": true,
      "52213": true,
      "52214": true,
      "52215": true,
      "52216": true,
      "52217": true,
      "52218": true,
      "52219": true,
      "52220": true,
      "52221": true,
      "52222": true,
      "52223": true,
      "52224": true,
      "52225": true,
      "52226": true,
      "52227": true,
      "52228": true,
      "52229": true,
      "52230": true,
      "52231": true,
      "52232": true,
      "52233": true,
      "52234": true,
      "52235": true,
      "52236": true,
      "52237": true,
      "52238": true,
      "52239": true
    },
    "CAPULHUAC": {
      "52700": true,
      "52701": true,
      "52702": true,
      "52703": true,
      "52704": true,
      "52705": true,
      "52706": true,
      "52707": true,
      "52708": true,
      "52709": true,
      "52710": true,
      "52711": true,
      "52712": true,
      "52713": true,
      "52714": true,
      "52715": true,
      "52716": true,
      "52717": true,
      "52718": true,
      "52719": true,
      "52720": true,
      "52721": true,
      "52722": true,
      "52723": true,
      "52724": true,
      "52725": true,
      "52726": true,
      "52727": true,
      "52728": true,
      "52729": true,
      "52730": true,
      "52731": true,
      "52732": true,
      "52733": true,
      "52734": true,
      "52735": true,
      "52736": true,
      "52737": true,
      "52738": true,
      "52739": true
    },
    "CHALCO": {
      "56600": true,
      "56601": true,
      "56602": true,
      "56603": true,
      "56604": true,
      "56605": true,
      "56606": true,
      "56607": true,
      "56608": true,
      "56609": true,
      "56620": true,
      "56621": true,
      "56622": true,
      "56623": true,
      "56624": true,
      "56625": true,
      "56626": true,
      "56627": true,
      "56628": true,
      "56629": true,
      "56630": true,
      "56631": true,
      "56632": true,
      "56633": true,
      "56634": true,
      "56635": true,
      "56636": true,
      "56637": true,
      "56638": true,
      "56639": true,
      "56640": true,
      "56641": true,
      "56642": true,
      "56643": true,
      "56644": true,
      "56645": true,
      "56646": true,
      "56647": true,
      "56648": true,
      "56649": true
    },
    "CHAPA DE MOTA": {
      "54350": true,
      "54351": true,
      "54352": true,
      "54353": true,
      "54354": true,
      "54355": true,
      "54356": true,
      "54357": true,
      "54358": true,
      "54359": true,
      "54360": true,
      "54361": true,
      "54362": true,
      "54363": true,
      "54364": true,
      "54365": true,
      "54366": true,
      "54367": true,
      "54368": true,
      "54369": true,
      "54370": true,
      "54371": true,
      "54372": true,
      "54373": true,
      "54374": true,
      "54375": true,
      "54376": true,
      "54377": true,
      "54378": true,
      "54379": true,
      "54380": true,
      "54381": true,
      "54382": true,
      "54383": true,
      "54384": true,
      "54385": true,
      "54386": true,
      "54387": true,
      "54388": true,
      "54389": true,
      "54390": true,
      "54391": true,
      "54392": true,
      "54393": true,
      "54394": true,
      "54395": true,
      "54396": true,
      "54397": true,
      "54398": true,
      "54399": true
    },
    "CHAPULTEPEC": {
      "52240": true,
      "52241": true,
      "52242": true,
      "52243": true,
      "52244": true,
      "52245": true,
      "52246": true,
      "52247": true,
      "52248": true,
      "52249": true,
      "52250": true,
      "52251": true,
      "52252": true,
      "52253": true,
      "52254": true,
      "52255": true,
      "52256": true,
      "52257": true,
      "52258": true,
      "52259": true,
      "52260": true,
      "52261": true,
      "52262": true,
      "52263": true,
      "52264": true,
      "52265": true,
      "52266": true,
      "52267": true,
      "52268": true,
      "52269": true,
      "52270": true,
      "52271": true,
      "52272": true,
      "52273": true,
      "52274": true,
      "52275": true,
      "52276": true,
      "52277": true,
      "52278": true,
      "52279": true
    },
    "CHICOLOAPAN": {
      "56370": true,
      "56371": true,
      "56372": true,
      "56373": true,
      "56374": true,
      "56375": true,
      "56376": true,
      "56377": true,
      "56378": true,
      "56379": true,
      "56380": true,
      "56381": true,
      "56382": true,
      "56383": true,
      "56384": true,
      "56385": true,
      "56386": true,
      "56387": true,
      "56388": true,
      "56389": true,
      "56390": true,
      "56391": true,
      "56392": true,
      "56393": true,
      "56394": true,
      "56395": true,
      "56396": true,
      "56397": true,
      "56398": true,
      "56399": true
    },
    "CHICONCUAC": {
      "56270": true,
      "56271": true,
      "56272": true,
      "56273": true,
      "56274": true,
      "56275": true,
      "56276": true,
      "56277": true,
      "56278": true,
      "56279": true,
      "56280": true,
      "56281": true,
      "56282": true,
      "56283": true,
      "56284": true,
      "56285": true,
      "56286": true,
      "56287": true,
      "56288": true,
      "56289": true,
      "56290": true,
      "56291": true,
      "56292": true,
      "56293": true,
      "56294": true,
      "56295": true,
      "56296": true,
      "56297": true,
      "56298": true,
      "56299": true
    },
    "CHIMALHUACÁN": {
      "56330": true,
      "56331": true,
      "56332": true,
      "56333": true,
      "56334": true,
      "56335": true,
      "56336": true,
      "56337": true,
      "56338": true,
      "56339": true,
      "56340": true,
      "56341": true,
      "56342": true,
      "56343": true,
      "56344": true,
      "56345": true,
      "56346": true,
      "56347": true,
      "56348": true,
      "56349": true,
      "56350": true,
      "56351": true,
      "56352": true,
      "56353": true,
      "56354": true,
      "56355": true,
      "56356": true,
      "56357": true,
      "56358": true,
      "56359": true,
      "56360": true,
      "56361": true,
      "56362": true,
      "56363": true,
      "56364": true,
      "56365": true,
      "56366": true,
      "56367": true,
      "56368": true,
      "56369": true
    },
    "COACALCO DE BERRIOZÁBAL": {
      "55700": true,
      "55701": true,
      "55702": true,
      "55703": true,
      "55704": true,
      "55705": true,
      "55706": true,
      "55707": true,
      "55708": true,
      "55709": true,
      "55710": true,
      "55711": true,
      "55712": true,
      "55713": true,
      "55714": true,
      "55715": true,
      "55716": true,
      "55717": true,
      "55718": true,
      "55719": true,
      "55720": true,
      "55721": true,
      "55722": true,
      "55723": true,
      "55724": true,
      "55725": true,
      "55726": true,
      "55727": true,
      "55728": true,
      "55729": true,
      "55730": true,
      "55731": true,
      "55732": true,
      "55733": true,
      "55734": true,
      "55735": true,
      "55736": true,
      "55737": true,
      "55738": true,
      "55739": true
    },
    "COCOTITLAN": {
      "56680": true,
      "56681": true,
      "56682": true,
      "56683": true,
      "56684": true,
      "56685": true,
      "56686": true,
      "56687": true,
      "56688": true,
      "56689": true,
      "56690": true,
      "56691": true,
      "56692": true,
      "56693": true,
      "56694": true,
      "56695": true,
      "56696": true,
      "56697": true,
      "56698": true,
      "56699": true
    },
    "COYOTEPEC": {
      "54660": true,
      "54661": true,
      "54662": true,
      "54663": true,
      "54664": true,
      "54665": true,
      "54666": true,
      "54667": true,
      "54668": true,
      "54669": true,
      "54670": true,
      "54671": true,
      "54672": true,
      "54673": true,
      "54674": true,
      "54675": true,
      "54676": true,
      "54677": true,
      "54678": true,
      "54679": true
    },
    "CUAUTITLÁN": {
      "54800": true,
      "54801": true,
      "54802": true,
      "54803": true,
      "54804": true,
      "54805": true,
      "54806": true,
      "54807": true,
      "54808": true,
      "54809": true,
      "54810": true,
      "54811": true,
      "54812": true,
      "54813": true,
      "54814": true,
      "54815": true,
      "54816": true,
      "54817": true,
      "54818": true,
      "54819": true,
      "54830": true,
      "54831": true,
      "54832": true,
      "54833": true,
      "54834": true,
      "54835": true,
      "54836": true,
      "54837": true,
      "54838": true,
      "54839": true,
      "54840": true,
      "54841": true,
      "54842": true,
      "54843": true,
      "54844": true,
      "54845": true,
      "54846": true,
      "54847": true,
      "54848": true,
      "54849": true,
      "54850": true,
      "54851": true,
      "54852": true,
      "54853": true,
      "54854": true,
      "54855": true,
      "54856": true,
      "54857": true,
      "54858": true,
      "54859": true,
      "54860": true,
      "54861": true,
      "54862": true,
      "54863": true,
      "54864": true,
      "54865": true,
      "54866": true,
      "54867": true,
      "54868": true,
      "54869": true,
      "54870": true,
      "54871": true,
      "54872": true,
      "54873": true,
      "54874": true,
      "54875": true,
      "54876": true,
      "54877": true,
      "54878": true,
      "54879": true
    },
    "CUAUTITLÁN IZCALLI": {
      "54700": true,
      "54701": true,
      "54702": true,
      "54703": true,
      "54704": true,
      "54705": true,
      "54706": true,
      "54707": true,
      "54708": true,
      "54709": true,
      "54710": true,
      "54711": true,
      "54712": true,
      "54713": true,
      "54714": true,
      "54715": true,
      "54716": true,
      "54717": true,
      "54718": true,
      "54719": true,
      "54720": true,
      "54721": true,
      "54722": true,
      "54723": true,
      "54724": true,
      "54725": true,
      "54726": true,
      "54727": true,
      "54728": true,
      "54729": true,
      "54730": true,
      "54731": true,
      "54732": true,
      "54733": true,
      "54734": true,
      "54735": true,
      "54736": true,
      "54737": true,
      "54738": true,
      "54739": true,
      "54740": true,
      "54741": true,
      "54742": true,
      "54743": true,
      "54744": true,
      "54745": true,
      "54746": true,
      "54747": true,
      "54748": true,
      "54749": true,
      "54750": true,
      "54751": true,
      "54752": true,
      "54753": true,
      "54754": true,
      "54755": true,
      "54756": true,
      "54757": true,
      "54758": true,
      "54759": true,
      "54760": true,
      "54761": true,
      "54762": true,
      "54763": true,
      "54764": true,
      "54765": true,
      "54766": true,
      "54767": true,
      "54768": true,
      "54769": true
    },
    "ECATEPEC DE MORELOS": {
      "55000": true,
      "55001": true,
      "55002": true,
      "55003": true,
      "55004": true,
      "55005": true,
      "55006": true,
      "55007": true,
      "55008": true,
      "55009": true,
      "55010": true,
      "55011": true,
      "55012": true,
      "55013": true,
      "55014": true,
      "55015": true,
      "55016": true,
      "55017": true,
      "55018": true,
      "55019": true,
      "55020": true,
      "55021": true,
      "55022": true,
      "55023": true,
      "55024": true,
      "55025": true,
      "55026": true,
      "55027": true,
      "55028": true,
      "55029": true,
      "55030": true,
      "55031": true,
      "55032": true,
      "55033": true,
      "55034": true,
      "55035": true,
      "55036": true,
      "55037": true,
      "55038": true,
      "55039": true,
      "55040": true,
      "55041": true,
      "55042": true,
      "55043": true,
      "55044": true,
      "55045": true,
      "55046": true,
      "55047": true,
      "55048": true,
      "55049": true,
      "55050": true,
      "55051": true,
      "55052": true,
      "55053": true,
      "55054": true,
      "55055": true,
      "55056": true,
      "55057": true,
      "55058": true,
      "55059": true,
      "55060": true,
      "55061": true,
      "55062": true,
      "55063": true,
      "55064": true,
      "55065": true,
      "55066": true,
      "55067": true,
      "55068": true,
      "55069": true,
      "55070": true,
      "55071": true,
      "55072": true,
      "55073": true,
      "55074": true,
      "55075": true,
      "55076": true,
      "55077": true,
      "55078": true,
      "55079": true,
      "55080": true,
      "55081": true,
      "55082": true,
      "55083": true,
      "55084": true,
      "55085": true,
      "55086": true,
      "55087": true,
      "55088": true,
      "55089": true,
      "55090": true,
      "55091": true,
      "55092": true,
      "55093": true,
      "55094": true,
      "55095": true,
      "55096": true,
      "55097": true,
      "55098": true,
      "55099": true,
      "55100": true,
      "55101": true,
      "55102": true,
      "55103": true,
      "55104": true,
      "55105": true,
      "55106": true,
      "55107": true,
      "55108": true,
      "55109": true,
      "55110": true,
      "55111": true,
      "55112": true,
      "55113": true,
      "55114": true,
      "55115": true,
      "55116": true,
      "55117": true,
      "55118": true,
      "55119": true,
      "55120": true,
      "55121": true,
      "55122": true,
      "55123": true,
      "55124": true,
      "55125": true,
      "55126": true,
      "55127": true,
      "55128": true,
      "55129": true,
      "55130": true,
      "55131": true,
      "55132": true,
      "55133": true,
      "55134": true,
      "55135": true,
      "55136": true,
      "55137": true,
      "55138": true,
      "55139": true,
      "55140": true,
      "55141": true,
      "55142": true,
      "55143": true,
      "55144": true,
      "55145": true,
      "55146": true,
      "55147": true,
      "55148": true,
      "55149": true,
      "55150": true,
      "55151": true,
      "55152": true,
      "55153": true,
      "55154": true,
      "55155": true,
      "55156": true,
      "55157": true,
      "55158": true,
      "55159": true,
      "55160": true,
      "55161": true,
      "55162": true,
      "55163": true,
      "55164": true,
      "55165": true,
      "55166": true,
      "55167": true,
      "55168": true,
      "55169": true,
      "55170": true,
      "55171": true,
      "55172": true,
      "55173": true,
      "55174": true,
      "55175": true,
      "55176": true,
      "55177": true,
      "55178": true,
      "55179": true,
      "55180": true,
      "55181": true,
      "55182": true,
      "55183": true,
      "55184": true,
      "55185": true,
      "55186": true,
      "55187": true,
      "55188": true,
      "55189": true,
      "55190": true,
      "55191": true,
      "55192": true,
      "55193": true,
      "55194": true,
      "55195": true,
      "55196": true,
      "55197": true,
      "55198": true,
      "55199": true,
      "55200": true,
      "55201": true,
      "55202": true,
      "55203": true,
      "55204": true,
      "55205": true,
      "55206": true,
      "55207": true,
      "55208": true,
      "55209": true,
      "55210": true,
      "55211": true,
      "55212": true,
      "55213": true,
      "55214": true,
      "55215": true,
      "55216": true,
      "55217": true,
      "55218": true,
      "55219": true,
      "55220": true,
      "55221": true,
      "55222": true,
      "55223": true,
      "55224": true,
      "55225": true,
      "55226": true,
      "55227": true,
      "55228": true,
      "55229": true,
      "55230": true,
      "55231": true,
      "55232": true,
      "55233": true,
      "55234": true,
      "55235": true,
      "55236": true,
      "55237": true,
      "55238": true,
      "55239": true,
      "55240": true,
      "55241": true,
      "55242": true,
      "55243": true,
      "55244": true,
      "55245": true,
      "55246": true,
      "55247": true,
      "55248": true,
      "55249": true,
      "55250": true,
      "55251": true,
      "55252": true,
      "55253": true,
      "55254": true,
      "55255": true,
      "55256": true,
      "55257": true,
      "55258": true,
      "55259": true,
      "55260": true,
      "55261": true,
      "55262": true,
      "55263": true,
      "55264": true,
      "55265": true,
      "55266": true,
      "55267": true,
      "55268": true,
      "55269": true,
      "55270": true,
      "55271": true,
      "55272": true,
      "55273": true,
      "55274": true,
      "55275": true,
      "55276": true,
      "55277": true,
      "55278": true,
      "55279": true,
      "55280": true,
      "55281": true,
      "55282": true,
      "55283": true,
      "55284": true,
      "55285": true,
      "55286": true,
      "55287": true,
      "55288": true,
      "55289": true,
      "55290": true,
      "55291": true,
      "55292": true,
      "55293": true,
      "55294": true,
      "55295": true,
      "55296": true,
      "55297": true,
      "55298": true,
      "55299": true,
      "55300": true,
      "55301": true,
      "55302": true,
      "55303": true,
      "55304": true,
      "55305": true,
      "55306": true,
      "55307": true,
      "55308": true,
      "55309": true,
      "55310": true,
      "55311": true,
      "55312": true,
      "55313": true,
      "55314": true,
      "55315": true,
      "55316": true,
      "55317": true,
      "55318": true,
      "55319": true,
      "55320": true,
      "55321": true,
      "55322": true,
      "55323": true,
      "55324": true,
      "55325": true,
      "55326": true,
      "55327": true,
      "55328": true,
      "55329": true,
      "55330": true,
      "55331": true,
      "55332": true,
      "55333": true,
      "55334": true,
      "55335": true,
      "55336": true,
      "55337": true,
      "55338": true,
      "55339": true,
      "55340": true,
      "55341": true,
      "55342": true,
      "55343": true,
      "55344": true,
      "55345": true,
      "55346": true,
      "55347": true,
      "55348": true,
      "55349": true,
      "55350": true,
      "55351": true,
      "55352": true,
      "55353": true,
      "55354": true,
      "55355": true,
      "55356": true,
      "55357": true,
      "55358": true,
      "55359": true,
      "55360": true,
      "55361": true,
      "55362": true,
      "55363": true,
      "55364": true,
      "55365": true,
      "55366": true,
      "55367": true,
      "55368": true,
      "55369": true,
      "55370": true,
      "55371": true,
      "55372": true,
      "55373": true,
      "55374": true,
      "55375": true,
      "55376": true,
      "55377": true,
      "55378": true,
      "55379": true,
      "55380": true,
      "55381": true,
      "55382": true,
      "55383": true,
      "55384": true,
      "55385": true,
      "55386": true,
      "55387": true,
      "55388": true,
      "55389": true,
      "55390": true,
      "55391": true,
      "55392": true,
      "55393": true,
      "55394": true,
      "55395": true,
      "55396": true,
      "55397": true,
      "55398": true,
      "55399": true,
      "55400": true,
      "55401": true,
      "55402": true,
      "55403": true,
      "55404": true,
      "55405": true,
      "55406": true,
      "55407": true,
      "55408": true,
      "55409": true,
      "55410": true,
      "55411": true,
      "55412": true,
      "55413": true,
      "55414": true,
      "55415": true,
      "55416": true,
      "55417": true,
      "55418": true,
      "55419": true,
      "55420": true,
      "55421": true,
      "55422": true,
      "55423": true,
      "55424": true,
      "55425": true,
      "55426": true,
      "55427": true,
      "55428": true,
      "55429": true,
      "55430": true,
      "55431": true,
      "55432": true,
      "55433": true,
      "55434": true,
      "55435": true,
      "55436": true,
      "55437": true,
      "55438": true,
      "55439": true,
      "55440": true,
      "55441": true,
      "55442": true,
      "55443": true,
      "55444": true,
      "55445": true,
      "55446": true,
      "55447": true,
      "55448": true,
      "55449": true,
      "55450": true,
      "55451": true,
      "55452": true,
      "55453": true,
      "55454": true,
      "55455": true,
      "55456": true,
      "55457": true,
      "55458": true,
      "55459": true,
      "55460": true,
      "55461": true,
      "55462": true,
      "55463": true,
      "55464": true,
      "55465": true,
      "55466": true,
      "55467": true,
      "55468": true,
      "55469": true,
      "55470": true,
      "55471": true,
      "55472": true,
      "55473": true,
      "55474": true,
      "55475": true,
      "55476": true,
      "55477": true,
      "55478": true,
      "55479": true,
      "55480": true,
      "55481": true,
      "55482": true,
      "55483": true,
      "55484": true,
      "55485": true,
      "55486": true,
      "55487": true,
      "55488": true,
      "55489": true,
      "55490": true,
      "55491": true,
      "55492": true,
      "55493": true,
      "55494": true,
      "55495": true,
      "55496": true,
      "55497": true,
      "55498": true,
      "55499": true,
      "55500": true,
      "55501": true,
      "55502": true,
      "55503": true,
      "55504": true,
      "55505": true,
      "55506": true,
      "55507": true,
      "55508": true,
      "55509": true,
      "55510": true,
      "55511": true,
      "55512": true,
      "55513": true,
      "55514": true,
      "55515": true,
      "55516": true,
      "55517": true,
      "55518": true,
      "55519": true,
      "55520": true,
      "55521": true,
      "55522": true,
      "55523": true,
      "55524": true,
      "55525": true,
      "55526": true,
      "55527": true,
      "55528": true,
      "55529": true,
      "55530": true,
      "55531": true,
      "55532": true,
      "55533": true,
      "55534": true,
      "55535": true,
      "55536": true,
      "55537": true,
      "55538": true,
      "55539": true,
      "55540": true,
      "55541": true,
      "55542": true,
      "55543": true,
      "55544": true,
      "55545": true,
      "55546": true,
      "55547": true,
      "55548": true,
      "55549": true,
      "55550": true,
      "55551": true,
      "55552": true,
      "55553": true,
      "55554": true,
      "55555": true,
      "55556": true,
      "55557": true,
      "55558": true,
      "55559": true,
      "55560": true,
      "55561": true,
      "55562": true,
      "55563": true,
      "55564": true,
      "55565": true,
      "55566": true,
      "55567": true,
      "55568": true,
      "55569": true,
      "55570": true,
      "55571": true,
      "55572": true,
      "55573": true,
      "55574": true,
      "55575": true,
      "55576": true,
      "55577": true,
      "55578": true,
      "55579": true,
      "55580": true,
      "55581": true,
      "55582": true,
      "55583": true,
      "55584": true,
      "55585": true,
      "55586": true,
      "55587": true,
      "55588": true,
      "55589": true,
      "55590": true,
      "55591": true,
      "55592": true,
      "55593": true,
      "55594": true,
      "55595": true,
      "55596": true,
      "55597": true,
      "55598": true,
      "55599": true
    },
    "EL ORO": {
      "50600": true,
      "50601": true,
      "50602": true,
      "50603": true,
      "50604": true,
      "50605": true,
      "50606": true,
      "50607": true,
      "50608": true,
      "50609": true,
      "50610": true,
      "50611": true,
      "50612": true,
      "50613": true,
      "50614": true,
      "50615": true,
      "50616": true,
      "50617": true,
      "50618": true,
      "50619": true,
      "50620": true,
      "50621": true,
      "50622": true,
      "50623": true,
      "50624": true,
      "50625": true,
      "50626": true,
      "50627": true,
      "50628": true,
      "50629": true,
      "50630": true,
      "50631": true,
      "50632": true,
      "50633": true,
      "50634": true,
      "50635": true,
      "50636": true,
      "50637": true,
      "50638": true,
      "50639": true
    },
    "HUEHUETOCA": {
      "54680": true,
      "54681": true,
      "54682": true,
      "54683": true,
      "54684": true,
      "54685": true,
      "54686": true,
      "54687": true,
      "54688": true,
      "54689": true,
      "54693": true,
      "54694": true,
      "54695": true,
      "54696": true,
      "54697": true,
      "54698": true,
      "54699": true
    },
    "HUEYPOXTLA": {
      "55670": true,
      "55671": true,
      "55672": true,
      "55673": true,
      "55674": true,
      "55675": true,
      "55679": true,
      "55680": true,
      "55681": true,
      "55682": true,
      "55683": true,
      "55690": true,
      "55691": true,
      "55692": true,
      "55693": true,
      "55694": true,
      "55695": true,
      "55696": true,
      "55697": true,
      "55698": true,
      "55699": true
    },
    "HUIXQUILUCAN": {
      "52760": true,
      "52763": true,
      "52764": true,
      "52765": true,
      "52766": true,
      "52767": true,
      "52768": true,
      "52769": true,
      "52770": true,
      "52773": true,
      "52774": true,
      "52775": true,
      "52776": true,
      "52777": true,
      "52778": true,
      "52779": true,
      "52780": true,
      "52783": true,
      "52784": true,
      "52785": true,
      "52786": true,
      "52787": true,
      "52788": true,
      "52789": true,
      "52790": true,
      "52793": true,
      "52794": true,
      "52795": true,
      "52796": true,
      "52797": true,
      "52798": true,
      "52799": true
    },
    "ISIDRO FABELA": {
      "54480": true,
      "54481": true,
      "54482": true,
      "54483": true,
      "54484": true,
      "54485": true,
      "54486": true,
      "54487": true,
      "54488": true,
      "54489": true,
      "54490": true,
      "54491": true,
      "54492": true,
      "54493": true,
      "54494": true,
      "54495": true,
      "54496": true,
      "54497": true,
      "54498": true,
      "54499": true,
      "54500": true,
      "54501": true,
      "54502": true,
      "54503": true,
      "54504": true,
      "54505": true,
      "54506": true,
      "54507": true,
      "54508": true,
      "54509": true,
      "54510": true,
      "54511": true,
      "54512": true,
      "54513": true,
      "54514": true,
      "54515": true,
      "54516": true,
      "54517": true,
      "54518": true,
      "54519": true,
      "54520": true,
      "54521": true,
      "54522": true,
      "54523": true,
      "54524": true,
      "54525": true,
      "54526": true,
      "54527": true,
      "54528": true,
      "54529": true,
      "54530": true,
      "54531": true,
      "54532": true,
      "54533": true,
      "54534": true,
      "54535": true,
      "54536": true,
      "54537": true,
      "54538": true
    },
    "IXTAPALUCA": {
      "56530": true,
      "56531": true,
      "56532": true,
      "56533": true,
      "56534": true,
      "56535": true,
      "56536": true,
      "56537": true,
      "56538": true,
      "56539": true,
      "56540": true,
      "56541": true,
      "56542": true,
      "56543": true,
      "56544": true,
      "56545": true,
      "56546": true,
      "56547": true,
      "56548": true,
      "56549": true,
      "56550": true,
      "56551": true,
      "56552": true,
      "56553": true,
      "56554": true,
      "56555": true,
      "56556": true,
      "56557": true,
      "56558": true,
      "56559": true,
      "56560": true,
      "56561": true,
      "56562": true,
      "56563": true,
      "56564": true,
      "56565": true,
      "56566": true,
      "56567": true,
      "56568": true,
      "56569": true,
      "56570": true,
      "56571": true,
      "56572": true,
      "56573": true,
      "56574": true,
      "56575": true,
      "56576": true,
      "56577": true,
      "56578": true,
      "56579": true,
      "56580": true,
      "56581": true,
      "56582": true,
      "56583": true,
      "56584": true,
      "56585": true,
      "56586": true,
      "56587": true,
      "56588": true,
      "56589": true,
      "56599": true
    },
    "IXTAPAN DE LA SAL": {
      "51900": true,
      "51901": true,
      "51902": true,
      "51903": true,
      "51904": true,
      "51905": true,
      "51906": true,
      "51907": true,
      "51908": true,
      "51909": true,
      "51910": true,
      "51911": true,
      "51912": true,
      "51913": true,
      "51914": true,
      "51915": true,
      "51916": true,
      "51917": true,
      "51918": true,
      "51919": true,
      "51920": true,
      "51921": true,
      "51922": true,
      "51923": true,
      "51924": true,
      "51925": true,
      "51926": true,
      "51927": true,
      "51928": true,
      "51929": true,
      "51930": true,
      "51931": true,
      "51932": true,
      "51933": true,
      "51934": true,
      "51935": true,
      "51936": true,
      "51937": true,
      "51938": true,
      "51939": true,
      "51940": true,
      "51941": true,
      "51942": true,
      "51943": true,
      "51944": true,
      "51945": true,
      "51946": true,
      "51947": true,
      "51948": true,
      "51949": true
    },
    "IXTLAHUACA": {
      "50740": true,
      "50741": true,
      "50742": true,
      "50743": true,
      "50744": true,
      "50745": true,
      "50746": true,
      "50747": true,
      "50748": true,
      "50749": true,
      "50755": true,
      "50756": true,
      "50757": true,
      "50758": true,
      "50759": true,
      "50760": true,
      "50761": true,
      "50762": true,
      "50763": true,
      "50764": true,
      "50765": true,
      "50766": true,
      "50767": true,
      "50768": true,
      "50769": true,
      "50770": true,
      "50771": true,
      "50772": true,
      "50773": true,
      "50774": true,
      "50775": true,
      "50776": true,
      "50777": true,
      "50778": true,
      "50779": true,
      "50780": true,
      "50781": true,
      "50782": true,
      "50783": true,
      "50784": true,
      "50785": true,
      "50786": true,
      "50787": true,
      "50788": true,
      "50789": true,
      "50790": true,
      "50791": true,
      "50792": true,
      "50793": true,
      "50794": true,
      "50795": true,
      "50796": true,
      "50797": true,
      "50798": true,
      "50799": true
    },
    "JALTENCO": {
      "55780": true,
      "55781": true,
      "55782": true,
      "55783": true,
      "55784": true
    },
    "JILOTZINGO": {
      "54570": true,
      "54571": true,
      "54572": true,
      "54573": true,
      "54574": true,
      "54575": true,
      "54576": true,
      "54577": true,
      "54578": true,
      "54579": true,
      "54580": true,
      "54581": true,
      "54582": true,
      "54583": true,
      "54584": true,
      "54585": true,
      "54586": true,
      "54587": true,
      "54588": true,
      "54589": true,
      "54590": true,
      "54591": true,
      "54592": true,
      "54593": true,
      "54594": true,
      "54595": true,
      "54596": true,
      "54597": true,
      "54598": true,
      "54599": true
    },
    "JOCOTITLAN": {
      "50700": true,
      "50701": true,
      "50702": true,
      "50703": true,
      "50704": true,
      "50705": true,
      "50706": true,
      "50707": true,
      "50708": true,
      "50709": true,
      "50710": true,
      "50711": true,
      "50712": true,
      "50713": true,
      "50714": true,
      "50720": true,
      "50721": true,
      "50722": true,
      "50723": true,
      "50724": true,
      "50725": true,
      "50726": true,
      "50727": true,
      "50728": true,
      "50729": true,
      "50730": true,
      "50731": true,
      "50732": true,
      "50733": true,
      "50734": true,
      "50735": true,
      "50736": true,
      "50737": true,
      "50738": true,
      "50739": true
    },
    "JOQUICINGO": {
      "52370": true,
      "52371": true,
      "52372": true,
      "52373": true,
      "52374": true,
      "52375": true,
      "52376": true,
      "52377": true,
      "52378": true,
      "52379": true,
      "52380": true,
      "52381": true,
      "52382": true,
      "52383": true,
      "52384": true,
      "52385": true,
      "52386": true,
      "52387": true,
      "52388": true,
      "52389": true,
      "52390": true,
      "52391": true,
      "52392": true,
      "52393": true,
      "52394": true,
      "52395": true,
      "52396": true,
      "52397": true,
      "52398": true,
      "52399": true
    },
    "JUCHITEPEC": {
      "56860": true,
      "56861": true,
      "56862": true,
      "56863": true,
      "56864": true,
      "56865": true,
      "56866": true,
      "56867": true,
      "56868": true,
      "56869": true,
      "56870": true,
      "56871": true,
      "56872": true,
      "56873": true,
      "56874": true,
      "56875": true,
      "56876": true,
      "56877": true,
      "56878": true,
      "56879": true
    },
    "LA PAZ": {
      "56400": true,
      "56401": true,
      "56402": true,
      "56403": true,
      "56404": true,
      "56405": true,
      "56406": true,
      "56407": true,
      "56408": true,
      "56409": true,
      "56410": true,
      "56411": true,
      "56412": true,
      "56413": true,
      "56414": true,
      "56415": true,
      "56416": true,
      "56417": true,
      "56418": true,
      "56419": true,
      "56420": true,
      "56421": true,
      "56422": true,
      "56423": true,
      "56424": true,
      "56425": true,
      "56426": true,
      "56427": true,
      "56428": true,
      "56429": true,
      "56430": true,
      "56431": true,
      "56432": true,
      "56433": true,
      "56434": true,
      "56435": true,
      "56436": true,
      "56437": true,
      "56438": true,
      "56439": true,
      "56440": true,
      "56441": true,
      "56442": true,
      "56443": true,
      "56444": true,
      "56445": true,
      "56446": true,
      "56447": true,
      "56448": true,
      "56449": true,
      "56450": true,
      "56451": true,
      "56452": true,
      "56453": true,
      "56454": true,
      "56455": true,
      "56456": true,
      "56457": true,
      "56458": true,
      "56459": true,
      "56460": true,
      "56461": true,
      "56462": true,
      "56463": true,
      "56464": true,
      "56465": true,
      "56466": true,
      "56467": true,
      "56468": true,
      "56469": true,
      "56470": true,
      "56471": true,
      "56472": true,
      "56473": true,
      "56474": true,
      "56475": true,
      "56476": true,
      "56477": true,
      "56478": true,
      "56479": true,
      "56480": true,
      "56481": true,
      "56482": true,
      "56483": true,
      "56484": true,
      "56485": true,
      "56486": true,
      "56487": true,
      "56488": true,
      "56489": true,
      "56490": true,
      "56491": true,
      "56492": true,
      "56493": true,
      "56494": true,
      "56495": true,
      "56496": true,
      "56497": true,
      "56498": true,
      "56499": true,
      "56500": true,
      "56501": true,
      "56502": true,
      "56503": true,
      "56504": true,
      "56505": true,
      "56506": true,
      "56507": true,
      "56508": true,
      "56509": true,
      "56510": true,
      "56511": true,
      "56512": true,
      "56513": true,
      "56514": true,
      "56515": true,
      "56516": true,
      "56517": true,
      "56518": true,
      "56519": true,
      "56520": true,
      "56521": true,
      "56522": true,
      "56523": true,
      "56524": true,
      "56525": true,
      "56526": true,
      "56527": true,
      "56528": true,
      "56529": true
    },
    "LERMA": {
      "52000": true,
      "52001": true,
      "52002": true,
      "52003": true,
      "52004": true,
      "52005": true,
      "52006": true,
      "52007": true,
      "52008": true,
      "52009": true,
      "52010": true,
      "52011": true,
      "52012": true,
      "52013": true,
      "52014": true,
      "52015": true,
      "52016": true,
      "52017": true,
      "52018": true,
      "52019": true,
      "52020": true,
      "52021": true,
      "52022": true,
      "52023": true,
      "52024": true,
      "52025": true,
      "52026": true,
      "52027": true,
      "52028": true,
      "52029": true,
      "52030": true,
      "52031": true,
      "52032": true,
      "52033": true,
      "52034": true,
      "52035": true,
      "52036": true,
      "52037": true,
      "52038": true,
      "52039": true,
      "52040": true,
      "52041": true,
      "52042": true,
      "52043": true,
      "52044": true,
      "52046": true,
      "52047": true,
      "52048": true,
      "52049": true,
      "52050": true,
      "52051": true,
      "52052": true,
      "52053": true,
      "52054": true,
      "52055": true,
      "52056": true,
      "52057": true,
      "52058": true,
      "52106": true
    },
    "MELCHOR OCAMPO": {
      "54880": true,
      "54881": true,
      "54882": true,
      "54883": true,
      "54884": true,
      "54885": true,
      "54886": true,
      "54887": true,
      "54888": true,
      "54889": true,
      "54890": true,
      "54891": true,
      "54892": true,
      "54893": true,
      "54894": true,
      "54895": true,
      "54896": true,
      "54897": true,
      "54898": true,
      "54899": true
    },
    "METEPEC": {
      "52140": true,
      "52143": true,
      "52144": true,
      "52145": true,
      "52146": true,
      "52147": true,
      "52148": true,
      "52149": true,
      "52150": true,
      "52154": true,
      "52155": true,
      "52156": true,
      "52157": true,
      "52158": true,
      "52159": true,
      "52160": true,
      "52161": true,
      "52164": true,
      "52165": true,
      "52166": true,
      "52167": true,
      "52168": true,
      "52169": true,
      "52170": true,
      "52172": true,
      "52175": true,
      "52176": true,
      "52177": true,
      "52178": true,
      "52179": true
    },
    "MEXICALTZINGO": {
      "52180": true,
      "52181": true,
      "52182": true,
      "52183": true,
      "52184": true,
      "52185": true,
      "52186": true,
      "52187": true,
      "52188": true,
      "52189": true,
      "52190": true,
      "52191": true,
      "52192": true,
      "52193": true,
      "52194": true,
      "52195": true,
      "52196": true,
      "52197": true,
      "52198": true,
      "52199": true
    },
    "NAUCALPAN DE JUÁREZ": {
      "53000": true,
      "53001": true,
      "53002": true,
      "53003": true,
      "53004": true,
      "53005": true,
      "53006": true,
      "53007": true,
      "53008": true,
      "53009": true,
      "53010": true,
      "53011": true,
      "53012": true,
      "53013": true,
      "53014": true,
      "53015": true,
      "53016": true,
      "53017": true,
      "53018": true,
      "53019": true,
      "53020": true,
      "53021": true,
      "53022": true,
      "53023": true,
      "53024": true,
      "53025": true,
      "53026": true,
      "53027": true,
      "53028": true,
      "53029": true,
      "53030": true,
      "53031": true,
      "53032": true,
      "53033": true,
      "53034": true,
      "53035": true,
      "53036": true,
      "53037": true,
      "53038": true,
      "53039": true,
      "53040": true,
      "53041": true,
      "53042": true,
      "53043": true,
      "53044": true,
      "53045": true,
      "53046": true,
      "53047": true,
      "53048": true,
      "53049": true,
      "53050": true,
      "53051": true,
      "53052": true,
      "53053": true,
      "53054": true,
      "53055": true,
      "53056": true,
      "53057": true,
      "53058": true,
      "53059": true,
      "53060": true,
      "53061": true,
      "53062": true,
      "53063": true,
      "53064": true,
      "53065": true,
      "53066": true,
      "53067": true,
      "53068": true,
      "53069": true,
      "53070": true,
      "53071": true,
      "53072": true,
      "53073": true,
      "53074": true,
      "53075": true,
      "53076": true,
      "53077": true,
      "53078": true,
      "53079": true,
      "53080": true,
      "53081": true,
      "53082": true,
      "53083": true,
      "53084": true,
      "53085": true,
      "53086": true,
      "53087": true,
      "53088": true,
      "53089": true,
      "53090": true,
      "53091": true,
      "53092": true,
      "53093": true,
      "53094": true,
      "53095": true,
      "53096": true,
      "53097": true,
      "53098": true,
      "53099": true,
      "53100": true,
      "53101": true,
      "53102": true,
      "53103": true,
      "53104": true,
      "53105": true,
      "53106": true,
      "53107": true,
      "53108": true,
      "53109": true,
      "53110": true,
      "53111": true,
      "53112": true,
      "53113": true,
      "53114": true,
      "53115": true,
      "53116": true,
      "53117": true,
      "53118": true,
      "53119": true,
      "53120": true,
      "53121": true,
      "53122": true,
      "53123": true,
      "53124": true,
      "53125": true,
      "53126": true,
      "53127": true,
      "53128": true,
      "53129": true,
      "53130": true,
      "53131": true,
      "53132": true,
      "53133": true,
      "53134": true,
      "53135": true,
      "53136": true,
      "53137": true,
      "53138": true,
      "53139": true,
      "53140": true,
      "53141": true,
      "53142": true,
      "53143": true,
      "53144": true,
      "53145": true,
      "53146": true,
      "53147": true,
      "53148": true,
      "53149": true,
      "53150": true,
      "53151": true,
      "53152": true,
      "53153": true,
      "53154": true,
      "53155": true,
      "53156": true,
      "53157": true,
      "53158": true,
      "53159": true,
      "53160": true,
      "53161": true,
      "53162": true,
      "53163": true,
      "53164": true,
      "53165": true,
      "53166": true,
      "53167": true,
      "53168": true,
      "53169": true,
      "53170": true,
      "53171": true,
      "53172": true,
      "53173": true,
      "53174": true,
      "53175": true,
      "53176": true,
      "53177": true,
      "53178": true,
      "53179": true,
      "53180": true,
      "53181": true,
      "53182": true,
      "53183": true,
      "53184": true,
      "53185": true,
      "53186": true,
      "53187": true,
      "53188": true,
      "53189": true,
      "53190": true,
      "53191": true,
      "53192": true,
      "53193": true,
      "53194": true,
      "53195": true,
      "53196": true,
      "53197": true,
      "53198": true,
      "53199": true,
      "53200": true,
      "53201": true,
      "53202": true,
      "53203": true,
      "53204": true,
      "53205": true,
      "53206": true,
      "53207": true,
      "53208": true,
      "53209": true,
      "53210": true,
      "53211": true,
      "53212": true,
      "53213": true,
      "53214": true,
      "53215": true,
      "53216": true,
      "53217": true,
      "53218": true,
      "53219": true,
      "53220": true,
      "53221": true,
      "53222": true,
      "53223": true,
      "53224": true,
      "53225": true,
      "53226": true,
      "53227": true,
      "53228": true,
      "53229": true,
      "53230": true,
      "53231": true,
      "53232": true,
      "53233": true,
      "53234": true,
      "53235": true,
      "53236": true,
      "53237": true,
      "53238": true,
      "53239": true,
      "53240": true,
      "53241": true,
      "53242": true,
      "53243": true,
      "53244": true,
      "53245": true,
      "53246": true,
      "53247": true,
      "53248": true,
      "53249": true,
      "53250": true,
      "53251": true,
      "53252": true,
      "53253": true,
      "53254": true,
      "53255": true,
      "53256": true,
      "53257": true,
      "53258": true,
      "53259": true,
      "53260": true,
      "53261": true,
      "53262": true,
      "53263": true,
      "53264": true,
      "53265": true,
      "53266": true,
      "53267": true,
      "53268": true,
      "53269": true,
      "53270": true,
      "53271": true,
      "53272": true,
      "53273": true,
      "53274": true,
      "53275": true,
      "53276": true,
      "53277": true,
      "53278": true,
      "53279": true,
      "53280": true,
      "53281": true,
      "53282": true,
      "53283": true,
      "53284": true,
      "53285": true,
      "53286": true,
      "53287": true,
      "53288": true,
      "53289": true,
      "53290": true,
      "53291": true,
      "53292": true,
      "53293": true,
      "53294": true,
      "53295": true,
      "53296": true,
      "53297": true,
      "53298": true,
      "53299": true,
      "53300": true,
      "53301": true,
      "53302": true,
      "53303": true,
      "53304": true,
      "53305": true,
      "53306": true,
      "53307": true,
      "53308": true,
      "53309": true,
      "53310": true,
      "53311": true,
      "53312": true,
      "53313": true,
      "53314": true,
      "53315": true,
      "53316": true,
      "53317": true,
      "53318": true,
      "53319": true,
      "53320": true,
      "53321": true,
      "53322": true,
      "53323": true,
      "53324": true,
      "53325": true,
      "53326": true,
      "53327": true,
      "53328": true,
      "53329": true,
      "53330": true,
      "53331": true,
      "53332": true,
      "53333": true,
      "53334": true,
      "53335": true,
      "53336": true,
      "53337": true,
      "53338": true,
      "53339": true,
      "53340": true,
      "53341": true,
      "53342": true,
      "53343": true,
      "53344": true,
      "53345": true,
      "53346": true,
      "53347": true,
      "53348": true,
      "53349": true,
      "53350": true,
      "53351": true,
      "53352": true,
      "53353": true,
      "53354": true,
      "53355": true,
      "53356": true,
      "53357": true,
      "53358": true,
      "53359": true,
      "53360": true,
      "53361": true,
      "53362": true,
      "53363": true,
      "53364": true,
      "53365": true,
      "53366": true,
      "53367": true,
      "53368": true,
      "53369": true,
      "53370": true,
      "53371": true,
      "53372": true,
      "53373": true,
      "53374": true,
      "53375": true,
      "53376": true,
      "53377": true,
      "53378": true,
      "53379": true,
      "53380": true,
      "53381": true,
      "53382": true,
      "53383": true,
      "53384": true,
      "53385": true,
      "53386": true,
      "53387": true,
      "53388": true,
      "53389": true,
      "53390": true,
      "53391": true,
      "53392": true,
      "53393": true,
      "53394": true,
      "53395": true,
      "53396": true,
      "53397": true,
      "53398": true,
      "53399": true,
      "53400": true,
      "53401": true,
      "53402": true,
      "53403": true,
      "53404": true,
      "53405": true,
      "53406": true,
      "53407": true,
      "53408": true,
      "53409": true,
      "53410": true,
      "53411": true,
      "53412": true,
      "53413": true,
      "53414": true,
      "53415": true,
      "53416": true,
      "53417": true,
      "53418": true,
      "53419": true,
      "53420": true,
      "53421": true,
      "53422": true,
      "53423": true,
      "53424": true,
      "53425": true,
      "53426": true,
      "53427": true,
      "53428": true,
      "53429": true,
      "53430": true,
      "53431": true,
      "53432": true,
      "53433": true,
      "53434": true,
      "53435": true,
      "53436": true,
      "53437": true,
      "53438": true,
      "53439": true,
      "53440": true,
      "53441": true,
      "53442": true,
      "53443": true,
      "53444": true,
      "53445": true,
      "53446": true,
      "53447": true,
      "53448": true,
      "53449": true,
      "53450": true,
      "53451": true,
      "53452": true,
      "53453": true,
      "53454": true,
      "53455": true,
      "53456": true,
      "53457": true,
      "53458": true,
      "53459": true,
      "53460": true,
      "53461": true,
      "53462": true,
      "53463": true,
      "53464": true,
      "53465": true,
      "53466": true,
      "53467": true,
      "53468": true,
      "53469": true,
      "53470": true,
      "53471": true,
      "53472": true,
      "53473": true,
      "53474": true,
      "53475": true,
      "53476": true,
      "53477": true,
      "53478": true,
      "53479": true,
      "53480": true,
      "53481": true,
      "53482": true,
      "53483": true,
      "53484": true,
      "53485": true,
      "53486": true,
      "53487": true,
      "53488": true,
      "53489": true,
      "53490": true,
      "53491": true,
      "53492": true,
      "53493": true,
      "53494": true,
      "53495": true,
      "53496": true,
      "53497": true,
      "53498": true,
      "53499": true,
      "53500": true,
      "53501": true,
      "53502": true,
      "53503": true,
      "53504": true,
      "53505": true,
      "53506": true,
      "53507": true,
      "53508": true,
      "53509": true,
      "53510": true,
      "53511": true,
      "53512": true,
      "53513": true,
      "53514": true,
      "53515": true,
      "53516": true,
      "53517": true,
      "53518": true,
      "53519": true,
      "53520": true,
      "53521": true,
      "53522": true,
      "53523": true,
      "53524": true,
      "53525": true,
      "53526": true,
      "53527": true,
      "53528": true,
      "53529": true,
      "53530": true,
      "53531": true,
      "53532": true,
      "53533": true,
      "53534": true,
      "53535": true,
      "53536": true,
      "53537": true,
      "53538": true,
      "53539": true,
      "53540": true,
      "53541": true,
      "53542": true,
      "53543": true,
      "53544": true,
      "53545": true,
      "53546": true,
      "53547": true,
      "53548": true,
      "53549": true,
      "53550": true,
      "53551": true,
      "53552": true,
      "53553": true,
      "53554": true,
      "53555": true,
      "53556": true,
      "53557": true,
      "53558": true,
      "53559": true,
      "53560": true,
      "53561": true,
      "53562": true,
      "53563": true,
      "53564": true,
      "53565": true,
      "53566": true,
      "53567": true,
      "53568": true,
      "53569": true,
      "53570": true,
      "53571": true,
      "53572": true,
      "53573": true,
      "53574": true,
      "53575": true,
      "53576": true,
      "53577": true,
      "53578": true,
      "53579": true,
      "53580": true,
      "53581": true,
      "53582": true,
      "53583": true,
      "53584": true,
      "53585": true,
      "53586": true,
      "53587": true,
      "53588": true,
      "53589": true,
      "53590": true,
      "53591": true,
      "53592": true,
      "53593": true,
      "53594": true,
      "53595": true,
      "53596": true,
      "53597": true,
      "53598": true,
      "53599": true,
      "53600": true,
      "53601": true,
      "53602": true,
      "53603": true,
      "53604": true,
      "53605": true,
      "53606": true,
      "53607": true,
      "53608": true,
      "53609": true,
      "53610": true,
      "53611": true,
      "53612": true,
      "53613": true,
      "53614": true,
      "53615": true,
      "53616": true,
      "53617": true,
      "53618": true,
      "53619": true,
      "53620": true,
      "53621": true,
      "53622": true,
      "53623": true,
      "53624": true,
      "53625": true,
      "53626": true,
      "53627": true,
      "53628": true,
      "53629": true,
      "53630": true,
      "53631": true,
      "53632": true,
      "53633": true,
      "53634": true,
      "53635": true,
      "53636": true,
      "53637": true,
      "53638": true,
      "53639": true,
      "53640": true,
      "53641": true,
      "53642": true,
      "53643": true,
      "53644": true,
      "53645": true,
      "53646": true,
      "53647": true,
      "53648": true,
      "53649": true,
      "53650": true,
      "53651": true,
      "53652": true,
      "53653": true,
      "53654": true,
      "53655": true,
      "53656": true,
      "53657": true,
      "53658": true,
      "53659": true,
      "53660": true,
      "53661": true,
      "53662": true,
      "53663": true,
      "53664": true,
      "53665": true,
      "53666": true,
      "53667": true,
      "53668": true,
      "53669": true,
      "53670": true,
      "53671": true,
      "53672": true,
      "53673": true,
      "53674": true,
      "53675": true,
      "53676": true,
      "53677": true,
      "53678": true,
      "53679": true,
      "53680": true,
      "53681": true,
      "53682": true,
      "53683": true,
      "53684": true,
      "53685": true,
      "53686": true,
      "53687": true,
      "53688": true,
      "53689": true,
      "53690": true,
      "53691": true,
      "53692": true,
      "53693": true,
      "53694": true,
      "53695": true,
      "53696": true,
      "53697": true,
      "53698": true,
      "53699": true,
      "53700": true,
      "53701": true,
      "53702": true,
      "53703": true,
      "53704": true,
      "53705": true,
      "53706": true,
      "53707": true,
      "53708": true,
      "53709": true,
      "53710": true,
      "53711": true,
      "53712": true,
      "53713": true,
      "53714": true,
      "53715": true,
      "53716": true,
      "53717": true,
      "53718": true,
      "53719": true,
      "53720": true,
      "53721": true,
      "53722": true,
      "53723": true,
      "53724": true,
      "53725": true,
      "53726": true,
      "53727": true,
      "53728": true,
      "53729": true,
      "53730": true,
      "53731": true,
      "53732": true,
      "53733": true,
      "53734": true,
      "53735": true,
      "53736": true,
      "53737": true,
      "53738": true,
      "53739": true,
      "53740": true,
      "53741": true,
      "53742": true,
      "53743": true,
      "53744": true,
      "53745": true,
      "53746": true,
      "53747": true,
      "53748": true,
      "53749": true,
      "53750": true,
      "53751": true,
      "53752": true,
      "53753": true,
      "53754": true,
      "53755": true,
      "53756": true,
      "53757": true,
      "53758": true,
      "53759": true,
      "53760": true,
      "53761": true,
      "53762": true,
      "53763": true,
      "53764": true,
      "53765": true,
      "53766": true,
      "53767": true,
      "53768": true,
      "53769": true,
      "53770": true,
      "53771": true,
      "53772": true,
      "53773": true,
      "53774": true,
      "53775": true,
      "53776": true,
      "53777": true,
      "53778": true,
      "53779": true,
      "53780": true,
      "53781": true,
      "53782": true,
      "53783": true,
      "53784": true,
      "53785": true,
      "53786": true,
      "53787": true,
      "53788": true,
      "53789": true,
      "53790": true,
      "53791": true,
      "53792": true,
      "53793": true,
      "53794": true,
      "53795": true,
      "53796": true,
      "53797": true,
      "53798": true,
      "53799": true,
      "53800": true,
      "53801": true,
      "53802": true,
      "53803": true,
      "53804": true,
      "53805": true,
      "53806": true,
      "53807": true,
      "53808": true,
      "53809": true,
      "53810": true,
      "53811": true,
      "53812": true,
      "53813": true,
      "53814": true,
      "53815": true,
      "53816": true,
      "53817": true,
      "53818": true,
      "53819": true,
      "53820": true,
      "53821": true,
      "53822": true,
      "53823": true,
      "53824": true,
      "53825": true,
      "53826": true,
      "53827": true,
      "53828": true,
      "53829": true,
      "53830": true,
      "53831": true,
      "53832": true,
      "53833": true,
      "53834": true,
      "53835": true,
      "53836": true,
      "53837": true,
      "53838": true,
      "53839": true,
      "53840": true,
      "53841": true,
      "53842": true,
      "53843": true,
      "53844": true,
      "53845": true,
      "53846": true,
      "53847": true,
      "53848": true,
      "53849": true,
      "53850": true,
      "53851": true,
      "53852": true,
      "53853": true,
      "53854": true,
      "53855": true,
      "53856": true,
      "53857": true,
      "53858": true,
      "53859": true,
      "53860": true,
      "53861": true,
      "53862": true,
      "53863": true,
      "53864": true,
      "53865": true,
      "53866": true,
      "53867": true,
      "53868": true,
      "53869": true,
      "53870": true,
      "53871": true,
      "53872": true,
      "53873": true,
      "53874": true,
      "53875": true,
      "53876": true,
      "53877": true,
      "53878": true,
      "53879": true,
      "53880": true,
      "53881": true,
      "53882": true,
      "53883": true,
      "53884": true,
      "53885": true,
      "53886": true,
      "53887": true,
      "53888": true,
      "53889": true,
      "53890": true,
      "53891": true,
      "53892": true,
      "53893": true,
      "53894": true,
      "53895": true,
      "53896": true,
      "53897": true,
      "53898": true,
      "53899": true,
      "53900": true,
      "53901": true,
      "53902": true,
      "53903": true,
      "53904": true,
      "53905": true,
      "53906": true,
      "53907": true,
      "53908": true,
      "53909": true,
      "53910": true,
      "53911": true,
      "53912": true,
      "53913": true,
      "53914": true,
      "53915": true,
      "53916": true,
      "53917": true,
      "53918": true,
      "53919": true,
      "53920": true,
      "53921": true,
      "53922": true,
      "53923": true,
      "53924": true,
      "53925": true,
      "53926": true,
      "53927": true,
      "53928": true,
      "53929": true,
      "53930": true,
      "53931": true,
      "53932": true,
      "53933": true,
      "53934": true,
      "53935": true,
      "53936": true,
      "53937": true,
      "53938": true,
      "53939": true,
      "53940": true,
      "53941": true,
      "53942": true,
      "53943": true,
      "53944": true,
      "53945": true,
      "53946": true,
      "53947": true,
      "53948": true,
      "53949": true,
      "53950": true,
      "53951": true,
      "53952": true,
      "53953": true,
      "53954": true,
      "53955": true,
      "53956": true,
      "53957": true,
      "53958": true,
      "53959": true,
      "53960": true,
      "53961": true,
      "53962": true,
      "53963": true,
      "53964": true,
      "53965": true,
      "53966": true,
      "53967": true,
      "53968": true,
      "53969": true,
      "53970": true,
      "53971": true,
      "53972": true,
      "53973": true,
      "53974": true,
      "53975": true,
      "53976": true,
      "53977": true,
      "53978": true,
      "53979": true,
      "53980": true,
      "53981": true,
      "53982": true,
      "53983": true,
      "53984": true,
      "53985": true,
      "53986": true,
      "53987": true,
      "53988": true,
      "53989": true,
      "53990": true,
      "53991": true,
      "53992": true,
      "53993": true,
      "53994": true,
      "53995": true,
      "53996": true,
      "53997": true,
      "53998": true,
      "53999": true
    },
    "NEXTLALPAN": {
      "55790": true,
      "55791": true,
      "55792": true,
      "55793": true,
      "55794": true,
      "55795": true,
      "55796": true,
      "55797": true,
      "55798": true,
      "55799": true
    },
    "NEZAHUALCÓYOTL": {
      "57000": true,
      "57001": true,
      "57002": true,
      "57003": true,
      "57004": true,
      "57005": true,
      "57006": true,
      "57007": true,
      "57008": true,
      "57009": true,
      "57010": true,
      "57011": true,
      "57012": true,
      "57013": true,
      "57014": true,
      "57015": true,
      "57016": true,
      "57017": true,
      "57018": true,
      "57019": true,
      "57020": true,
      "57021": true,
      "57022": true,
      "57023": true,
      "57024": true,
      "57025": true,
      "57026": true,
      "57027": true,
      "57028": true,
      "57029": true,
      "57030": true,
      "57031": true,
      "57032": true,
      "57033": true,
      "57034": true,
      "57035": true,
      "57036": true,
      "57037": true,
      "57038": true,
      "57039": true,
      "57040": true,
      "57041": true,
      "57042": true,
      "57043": true,
      "57044": true,
      "57045": true,
      "57046": true,
      "57047": true,
      "57048": true,
      "57049": true,
      "57050": true,
      "57051": true,
      "57052": true,
      "57053": true,
      "57054": true,
      "57055": true,
      "57056": true,
      "57057": true,
      "57058": true,
      "57059": true,
      "57060": true,
      "57061": true,
      "57062": true,
      "57063": true,
      "57064": true,
      "57065": true,
      "57066": true,
      "57067": true,
      "57068": true,
      "57069": true,
      "57070": true,
      "57071": true,
      "57072": true,
      "57073": true,
      "57074": true,
      "57075": true,
      "57076": true,
      "57077": true,
      "57078": true,
      "57079": true,
      "57080": true,
      "57081": true,
      "57082": true,
      "57083": true,
      "57084": true,
      "57085": true,
      "57086": true,
      "57087": true,
      "57088": true,
      "57089": true,
      "57090": true,
      "57091": true,
      "57092": true,
      "57093": true,
      "57094": true,
      "57095": true,
      "57096": true,
      "57097": true,
      "57098": true,
      "57099": true,
      "57100": true,
      "57101": true,
      "57102": true,
      "57103": true,
      "57104": true,
      "57105": true,
      "57106": true,
      "57107": true,
      "57108": true,
      "57109": true,
      "57110": true,
      "57111": true,
      "57112": true,
      "57113": true,
      "57114": true,
      "57115": true,
      "57116": true,
      "57117": true,
      "57118": true,
      "57119": true,
      "57120": true,
      "57121": true,
      "57122": true,
      "57123": true,
      "57124": true,
      "57125": true,
      "57126": true,
      "57127": true,
      "57128": true,
      "57129": true,
      "57130": true,
      "57131": true,
      "57132": true,
      "57133": true,
      "57134": true,
      "57135": true,
      "57136": true,
      "57137": true,
      "57138": true,
      "57139": true,
      "57140": true,
      "57141": true,
      "57142": true,
      "57143": true,
      "57144": true,
      "57145": true,
      "57146": true,
      "57147": true,
      "57148": true,
      "57149": true,
      "57150": true,
      "57151": true,
      "57152": true,
      "57153": true,
      "57154": true,
      "57155": true,
      "57156": true,
      "57157": true,
      "57158": true,
      "57159": true,
      "57160": true,
      "57161": true,
      "57162": true,
      "57163": true,
      "57164": true,
      "57165": true,
      "57166": true,
      "57167": true,
      "57168": true,
      "57169": true,
      "57170": true,
      "57171": true,
      "57172": true,
      "57173": true,
      "57174": true,
      "57175": true,
      "57176": true,
      "57177": true,
      "57178": true,
      "57179": true,
      "57180": true,
      "57181": true,
      "57182": true,
      "57183": true,
      "57184": true,
      "57185": true,
      "57186": true,
      "57187": true,
      "57188": true,
      "57189": true,
      "57190": true,
      "57191": true,
      "57192": true,
      "57193": true,
      "57194": true,
      "57195": true,
      "57196": true,
      "57197": true,
      "57198": true,
      "57199": true,
      "57200": true,
      "57201": true,
      "57202": true,
      "57203": true,
      "57204": true,
      "57205": true,
      "57206": true,
      "57207": true,
      "57208": true,
      "57209": true,
      "57210": true,
      "57211": true,
      "57212": true,
      "57213": true,
      "57214": true,
      "57215": true,
      "57216": true,
      "57217": true,
      "57218": true,
      "57219": true,
      "57220": true,
      "57221": true,
      "57222": true,
      "57223": true,
      "57224": true,
      "57225": true,
      "57226": true,
      "57227": true,
      "57228": true,
      "57229": true,
      "57230": true,
      "57231": true,
      "57232": true,
      "57233": true,
      "57234": true,
      "57235": true,
      "57236": true,
      "57237": true,
      "57238": true,
      "57239": true,
      "57240": true,
      "57241": true,
      "57242": true,
      "57243": true,
      "57244": true,
      "57245": true,
      "57246": true,
      "57247": true,
      "57248": true,
      "57249": true,
      "57250": true,
      "57251": true,
      "57252": true,
      "57253": true,
      "57254": true,
      "57255": true,
      "57256": true,
      "57257": true,
      "57258": true,
      "57259": true,
      "57260": true,
      "57261": true,
      "57262": true,
      "57263": true,
      "57264": true,
      "57265": true,
      "57266": true,
      "57267": true,
      "57268": true,
      "57269": true,
      "57270": true,
      "57271": true,
      "57272": true,
      "57273": true,
      "57274": true,
      "57275": true,
      "57276": true,
      "57277": true,
      "57278": true,
      "57279": true,
      "57280": true,
      "57281": true,
      "57282": true,
      "57283": true,
      "57284": true,
      "57285": true,
      "57286": true,
      "57287": true,
      "57288": true,
      "57289": true,
      "57290": true,
      "57291": true,
      "57292": true,
      "57293": true,
      "57294": true,
      "57295": true,
      "57296": true,
      "57297": true,
      "57298": true,
      "57299": true,
      "57300": true,
      "57301": true,
      "57302": true,
      "57303": true,
      "57304": true,
      "57305": true,
      "57306": true,
      "57307": true,
      "57308": true,
      "57309": true,
      "57310": true,
      "57311": true,
      "57312": true,
      "57313": true,
      "57314": true,
      "57315": true,
      "57316": true,
      "57317": true,
      "57318": true,
      "57319": true,
      "57320": true,
      "57321": true,
      "57322": true,
      "57323": true,
      "57324": true,
      "57325": true,
      "57326": true,
      "57327": true,
      "57328": true,
      "57329": true,
      "57330": true,
      "57331": true,
      "57332": true,
      "57333": true,
      "57334": true,
      "57335": true,
      "57336": true,
      "57337": true,
      "57338": true,
      "57339": true,
      "57340": true,
      "57341": true,
      "57342": true,
      "57343": true,
      "57344": true,
      "57345": true,
      "57346": true,
      "57347": true,
      "57348": true,
      "57349": true,
      "57350": true,
      "57351": true,
      "57352": true,
      "57353": true,
      "57354": true,
      "57355": true,
      "57356": true,
      "57357": true,
      "57358": true,
      "57359": true,
      "57360": true,
      "57361": true,
      "57362": true,
      "57363": true,
      "57364": true,
      "57365": true,
      "57366": true,
      "57367": true,
      "57368": true,
      "57369": true,
      "57370": true,
      "57371": true,
      "57372": true,
      "57373": true,
      "57374": true,
      "57375": true,
      "57376": true,
      "57377": true,
      "57378": true,
      "57379": true,
      "57380": true,
      "57381": true,
      "57382": true,
      "57383": true,
      "57384": true,
      "57385": true,
      "57386": true,
      "57387": true,
      "57388": true,
      "57389": true,
      "57390": true,
      "57391": true,
      "57392": true,
      "57393": true,
      "57394": true,
      "57395": true,
      "57396": true,
      "57397": true,
      "57398": true,
      "57399": true,
      "57400": true,
      "57401": true,
      "57402": true,
      "57403": true,
      "57404": true,
      "57405": true,
      "57406": true,
      "57407": true,
      "57408": true,
      "57409": true,
      "57410": true,
      "57411": true,
      "57412": true,
      "57413": true,
      "57414": true,
      "57415": true,
      "57416": true,
      "57417": true,
      "57418": true,
      "57419": true,
      "57420": true,
      "57421": true,
      "57422": true,
      "57423": true,
      "57424": true,
      "57425": true,
      "57426": true,
      "57427": true,
      "57428": true,
      "57429": true,
      "57430": true,
      "57431": true,
      "57432": true,
      "57433": true,
      "57434": true,
      "57435": true,
      "57436": true,
      "57437": true,
      "57438": true,
      "57439": true,
      "57440": true,
      "57441": true,
      "57442": true,
      "57443": true,
      "57444": true,
      "57445": true,
      "57446": true,
      "57447": true,
      "57448": true,
      "57449": true,
      "57450": true,
      "57451": true,
      "57452": true,
      "57453": true,
      "57454": true,
      "57455": true,
      "57456": true,
      "57457": true,
      "57458": true,
      "57459": true,
      "57460": true,
      "57461": true,
      "57462": true,
      "57463": true,
      "57464": true,
      "57465": true,
      "57466": true,
      "57467": true,
      "57468": true,
      "57469": true,
      "57470": true,
      "57471": true,
      "57472": true,
      "57473": true,
      "57474": true,
      "57475": true,
      "57476": true,
      "57477": true,
      "57478": true,
      "57479": true,
      "57480": true,
      "57481": true,
      "57482": true,
      "57483": true,
      "57484": true,
      "57485": true,
      "57486": true,
      "57487": true,
      "57488": true,
      "57489": true,
      "57490": true,
      "57491": true,
      "57492": true,
      "57493": true,
      "57494": true,
      "57495": true,
      "57496": true,
      "57497": true,
      "57498": true,
      "57499": true,
      "57500": true,
      "57501": true,
      "57502": true,
      "57503": true,
      "57504": true,
      "57505": true,
      "57506": true,
      "57507": true,
      "57508": true,
      "57509": true,
      "57510": true,
      "57511": true,
      "57512": true,
      "57513": true,
      "57514": true,
      "57515": true,
      "57516": true,
      "57517": true,
      "57518": true,
      "57519": true,
      "57520": true,
      "57521": true,
      "57522": true,
      "57523": true,
      "57524": true,
      "57525": true,
      "57526": true,
      "57527": true,
      "57528": true,
      "57529": true,
      "57530": true,
      "57531": true,
      "57532": true,
      "57533": true,
      "57534": true,
      "57535": true,
      "57536": true,
      "57537": true,
      "57538": true,
      "57539": true,
      "57540": true,
      "57541": true,
      "57542": true,
      "57543": true,
      "57544": true,
      "57545": true,
      "57546": true,
      "57547": true,
      "57548": true,
      "57549": true,
      "57550": true,
      "57551": true,
      "57552": true,
      "57553": true,
      "57554": true,
      "57555": true,
      "57556": true,
      "57557": true,
      "57558": true,
      "57559": true,
      "57560": true,
      "57561": true,
      "57562": true,
      "57563": true,
      "57564": true,
      "57565": true,
      "57566": true,
      "57567": true,
      "57568": true,
      "57569": true,
      "57570": true,
      "57571": true,
      "57572": true,
      "57573": true,
      "57574": true,
      "57575": true,
      "57576": true,
      "57577": true,
      "57578": true,
      "57579": true,
      "57580": true,
      "57581": true,
      "57582": true,
      "57583": true,
      "57584": true,
      "57585": true,
      "57586": true,
      "57587": true,
      "57588": true,
      "57589": true,
      "57590": true,
      "57591": true,
      "57592": true,
      "57593": true,
      "57594": true,
      "57595": true,
      "57596": true,
      "57597": true,
      "57598": true,
      "57599": true,
      "57600": true,
      "57601": true,
      "57602": true,
      "57603": true,
      "57604": true,
      "57605": true,
      "57606": true,
      "57607": true,
      "57608": true,
      "57609": true,
      "57610": true,
      "57611": true,
      "57612": true,
      "57613": true,
      "57614": true,
      "57615": true,
      "57616": true,
      "57617": true,
      "57618": true,
      "57619": true,
      "57620": true,
      "57621": true,
      "57622": true,
      "57623": true,
      "57624": true,
      "57625": true,
      "57626": true,
      "57627": true,
      "57628": true,
      "57629": true,
      "57630": true,
      "57631": true,
      "57632": true,
      "57633": true,
      "57634": true,
      "57635": true,
      "57636": true,
      "57637": true,
      "57638": true,
      "57639": true,
      "57640": true,
      "57641": true,
      "57642": true,
      "57643": true,
      "57644": true,
      "57645": true,
      "57646": true,
      "57647": true,
      "57648": true,
      "57649": true,
      "57650": true,
      "57651": true,
      "57652": true,
      "57653": true,
      "57654": true,
      "57655": true,
      "57656": true,
      "57657": true,
      "57658": true,
      "57659": true,
      "57660": true,
      "57661": true,
      "57662": true,
      "57663": true,
      "57664": true,
      "57665": true,
      "57666": true,
      "57667": true,
      "57668": true,
      "57669": true,
      "57670": true,
      "57671": true,
      "57672": true,
      "57673": true,
      "57674": true,
      "57675": true,
      "57676": true,
      "57677": true,
      "57678": true,
      "57679": true,
      "57680": true,
      "57681": true,
      "57682": true,
      "57683": true,
      "57684": true,
      "57685": true,
      "57686": true,
      "57687": true,
      "57688": true,
      "57689": true,
      "57690": true,
      "57691": true,
      "57692": true,
      "57693": true,
      "57694": true,
      "57695": true,
      "57696": true,
      "57697": true,
      "57698": true,
      "57699": true,
      "57700": true,
      "57701": true,
      "57702": true,
      "57703": true,
      "57704": true,
      "57705": true,
      "57706": true,
      "57707": true,
      "57708": true,
      "57709": true,
      "57710": true,
      "57711": true,
      "57712": true,
      "57713": true,
      "57714": true,
      "57715": true,
      "57716": true,
      "57717": true,
      "57718": true,
      "57719": true,
      "57720": true,
      "57721": true,
      "57722": true,
      "57723": true,
      "57724": true,
      "57725": true,
      "57726": true,
      "57727": true,
      "57728": true,
      "57729": true,
      "57730": true,
      "57731": true,
      "57732": true,
      "57733": true,
      "57734": true,
      "57735": true,
      "57736": true,
      "57737": true,
      "57738": true,
      "57739": true,
      "57740": true,
      "57741": true,
      "57742": true,
      "57743": true,
      "57744": true,
      "57745": true,
      "57746": true,
      "57747": true,
      "57748": true,
      "57749": true,
      "57750": true,
      "57751": true,
      "57752": true,
      "57753": true,
      "57754": true,
      "57755": true,
      "57756": true,
      "57757": true,
      "57758": true,
      "57759": true,
      "57760": true,
      "57761": true,
      "57762": true,
      "57763": true,
      "57764": true,
      "57765": true,
      "57766": true,
      "57767": true,
      "57768": true,
      "57769": true,
      "57770": true,
      "57771": true,
      "57772": true,
      "57773": true,
      "57774": true,
      "57775": true,
      "57776": true,
      "57777": true,
      "57778": true,
      "57779": true,
      "57780": true,
      "57781": true,
      "57782": true,
      "57783": true,
      "57784": true,
      "57785": true,
      "57786": true,
      "57787": true,
      "57788": true,
      "57789": true,
      "57790": true,
      "57791": true,
      "57792": true,
      "57793": true,
      "57794": true,
      "57795": true,
      "57796": true,
      "57797": true,
      "57798": true,
      "57799": true,
      "57800": true,
      "57801": true,
      "57802": true,
      "57803": true,
      "57804": true,
      "57805": true,
      "57806": true,
      "57807": true,
      "57808": true,
      "57809": true,
      "57810": true,
      "57811": true,
      "57812": true,
      "57813": true,
      "57814": true,
      "57815": true,
      "57816": true,
      "57817": true,
      "57818": true,
      "57819": true,
      "57820": true,
      "57821": true,
      "57822": true,
      "57823": true,
      "57824": true,
      "57825": true,
      "57826": true,
      "57827": true,
      "57828": true,
      "57829": true,
      "57830": true,
      "57831": true,
      "57832": true,
      "57833": true,
      "57834": true,
      "57835": true,
      "57836": true,
      "57837": true,
      "57838": true,
      "57839": true,
      "57840": true,
      "57841": true,
      "57842": true,
      "57843": true,
      "57844": true,
      "57845": true,
      "57846": true,
      "57847": true,
      "57848": true,
      "57849": true,
      "57850": true,
      "57851": true,
      "57852": true,
      "57853": true,
      "57854": true,
      "57855": true,
      "57856": true,
      "57857": true,
      "57858": true,
      "57859": true,
      "57860": true,
      "57861": true,
      "57862": true,
      "57863": true,
      "57864": true,
      "57865": true,
      "57866": true,
      "57867": true,
      "57868": true,
      "57869": true,
      "57870": true,
      "57871": true,
      "57872": true,
      "57873": true,
      "57874": true,
      "57875": true,
      "57876": true,
      "57877": true,
      "57878": true,
      "57879": true,
      "57880": true,
      "57881": true,
      "57882": true,
      "57883": true,
      "57884": true,
      "57885": true,
      "57886": true,
      "57887": true,
      "57888": true,
      "57889": true,
      "57890": true,
      "57891": true,
      "57892": true,
      "57893": true,
      "57894": true,
      "57895": true,
      "57896": true,
      "57897": true,
      "57898": true,
      "57899": true,
      "57900": true,
      "57901": true,
      "57902": true,
      "57903": true,
      "57904": true,
      "57905": true,
      "57906": true,
      "57907": true,
      "57908": true,
      "57909": true,
      "57910": true,
      "57911": true,
      "57912": true,
      "57913": true,
      "57914": true,
      "57915": true,
      "57916": true,
      "57917": true,
      "57918": true,
      "57919": true,
      "57920": true,
      "57921": true,
      "57922": true,
      "57923": true,
      "57924": true,
      "57925": true,
      "57926": true,
      "57927": true,
      "57928": true,
      "57929": true,
      "57930": true,
      "57931": true,
      "57932": true,
      "57933": true,
      "57934": true,
      "57935": true,
      "57936": true,
      "57937": true,
      "57938": true,
      "57939": true,
      "57940": true,
      "57941": true,
      "57942": true,
      "57943": true,
      "57944": true,
      "57945": true,
      "57946": true,
      "57947": true,
      "57948": true,
      "57949": true,
      "57950": true,
      "57951": true,
      "57952": true,
      "57953": true,
      "57954": true,
      "57955": true,
      "57956": true,
      "57957": true,
      "57958": true,
      "57959": true,
      "57960": true,
      "57961": true,
      "57962": true,
      "57963": true,
      "57964": true,
      "57965": true,
      "57966": true,
      "57967": true,
      "57968": true,
      "57969": true,
      "57970": true,
      "57971": true,
      "57972": true,
      "57973": true,
      "57974": true,
      "57975": true,
      "57976": true,
      "57977": true,
      "57978": true,
      "57979": true,
      "57980": true,
      "57981": true,
      "57982": true,
      "57983": true,
      "57984": true,
      "57985": true,
      "57986": true,
      "57987": true,
      "57988": true,
      "57989": true,
      "57990": true,
      "57991": true,
      "57992": true,
      "57993": true,
      "57994": true,
      "57995": true,
      "57996": true,
      "57997": true,
      "57998": true,
      "57999": true
    },
    "NICOLÁS ROMERO": {
      "54400": true,
      "54401": true,
      "54402": true,
      "54403": true,
      "54404": true,
      "54405": true,
      "54406": true,
      "54407": true,
      "54408": true,
      "54409": true,
      "54410": true,
      "54411": true,
      "54412": true,
      "54413": true,
      "54414": true,
      "54415": true,
      "54416": true,
      "54417": true,
      "54418": true,
      "54419": true,
      "54420": true,
      "54421": true,
      "54422": true,
      "54423": true,
      "54424": true,
      "54425": true,
      "54426": true,
      "54427": true,
      "54428": true,
      "54429": true,
      "54430": true,
      "54431": true,
      "54432": true,
      "54433": true,
      "54434": true,
      "54435": true,
      "54436": true,
      "54437": true,
      "54438": true,
      "54439": true,
      "54440": true,
      "54441": true,
      "54442": true,
      "54443": true,
      "54444": true,
      "54445": true,
      "54446": true,
      "54447": true,
      "54448": true,
      "54449": true,
      "54450": true,
      "54451": true,
      "54452": true,
      "54453": true,
      "54454": true,
      "54455": true,
      "54456": true,
      "54457": true,
      "54458": true,
      "54459": true,
      "54460": true,
      "54461": true,
      "54462": true,
      "54463": true,
      "54464": true,
      "54465": true,
      "54466": true,
      "54467": true,
      "54468": true,
      "54469": true,
      "54470": true,
      "54471": true,
      "54472": true,
      "54473": true,
      "54474": true,
      "54475": true,
      "54476": true,
      "54477": true,
      "54478": true,
      "54479": true,
      "54539": true,
      "54540": true,
      "54541": true,
      "54542": true,
      "54543": true,
      "54544": true,
      "54545": true,
      "54546": true,
      "54547": true,
      "54548": true,
      "54549": true,
      "54550": true,
      "54551": true,
      "54552": true,
      "54553": true,
      "54554": true,
      "54555": true,
      "54556": true,
      "54557": true,
      "54558": true,
      "54559": true,
      "54560": true,
      "54561": true,
      "54562": true,
      "54563": true,
      "54564": true,
      "54565": true,
      "54566": true,
      "54567": true,
      "54568": true,
      "54569": true
    },
    "OCOYOACAC": {
      "52740": true,
      "52741": true,
      "52742": true,
      "52743": true,
      "52744": true,
      "52745": true,
      "52746": true,
      "52747": true,
      "52748": true,
      "52749": true,
      "52750": true,
      "52751": true,
      "52752": true,
      "52753": true,
      "52754": true,
      "52755": true,
      "52756": true,
      "52757": true,
      "52758": true,
      "52759": true
    },
    "OTUMBA": {
      "55900": true,
      "55901": true,
      "55902": true,
      "55903": true,
      "55904": true,
      "55905": true,
      "55906": true,
      "55907": true,
      "55908": true,
      "55909": true,
      "55910": true,
      "55911": true,
      "55912": true,
      "55913": true,
      "55914": true,
      "55915": true,
      "55916": true,
      "55917": true,
      "55918": true,
      "55919": true,
      "55920": true,
      "55921": true,
      "55922": true,
      "55923": true,
      "55924": true,
      "55925": true,
      "55926": true,
      "55927": true,
      "55928": true,
      "55929": true,
      "55930": true,
      "55931": true,
      "55932": true,
      "55933": true,
      "55934": true,
      "55935": true,
      "55936": true,
      "55937": true,
      "55938": true,
      "55939": true
    },
    "OTZOLOTEPEC": {
      "52080": true,
      "52081": true,
      "52082": true,
      "52083": true,
      "52084": true,
      "52085": true,
      "52086": true,
      "52087": true,
      "52088": true,
      "52089": true,
      "52090": true,
      "52091": true,
      "52092": true,
      "52093": true,
      "52094": true,
      "52095": true,
      "52096": true,
      "52097": true,
      "52098": true,
      "52099": true
    },
    "OZUMBA": {
      "56800": true,
      "56801": true,
      "56802": true,
      "56803": true,
      "56804": true,
      "56805": true,
      "56806": true,
      "56807": true,
      "56808": true,
      "56809": true,
      "56810": true,
      "56811": true,
      "56812": true,
      "56813": true,
      "56814": true,
      "56816": true,
      "56817": true,
      "56818": true,
      "56819": true,
      "56820": true,
      "56821": true,
      "56822": true,
      "56823": true,
      "56824": true,
      "56825": true,
      "56826": true,
      "56827": true,
      "56828": true,
      "56829": true,
      "56830": true,
      "56831": true,
      "56832": true,
      "56833": true,
      "56834": true,
      "56835": true,
      "56836": true,
      "56837": true,
      "56838": true,
      "56839": true,
      "56840": true,
      "56841": true,
      "56842": true,
      "56843": true,
      "56844": true,
      "56845": true,
      "56846": true,
      "56847": true,
      "56848": true,
      "56849": true,
      "56850": true,
      "56851": true,
      "56852": true,
      "56853": true,
      "56854": true,
      "56855": true,
      "56856": true,
      "56857": true,
      "56858": true,
      "56859": true
    },
    "RAYON": {
      "52360": true,
      "52361": true,
      "52362": true,
      "52363": true,
      "52364": true,
      "52365": true,
      "52366": true,
      "52367": true,
      "52368": true,
      "52369": true
    },
    "SAN ANTONIO LA ISLA": {
      "52280": true,
      "52281": true,
      "52282": true,
      "52283": true,
      "52284": true,
      "52285": true,
      "52286": true,
      "52287": true,
      "52288": true,
      "52289": true,
      "52290": true,
      "52291": true,
      "52292": true,
      "52293": true,
      "52294": true,
      "52295": true,
      "52296": true,
      "52297": true,
      "52298": true,
      "52299": true
    },
    "SAN FELIPE DEL PROGRESO": {
      "50640": true,
      "50641": true,
      "50642": true,
      "50643": true,
      "50644": true,
      "50645": true,
      "50646": true,
      "50647": true,
      "50648": true,
      "50649": true,
      "50650": true,
      "50651": true,
      "50652": true,
      "50653": true,
      "50654": true,
      "50655": true,
      "50656": true,
      "50657": true,
      "50658": true,
      "50659": true,
      "50680": true,
      "50681": true,
      "50682": true,
      "50683": true,
      "50684": true,
      "50686": true,
      "50687": true,
      "50688": true,
      "50689": true,
      "50690": true,
      "50691": true,
      "50692": true,
      "50693": true,
      "50694": true,
      "50695": true,
      "50696": true,
      "50697": true,
      "50698": true,
      "50699": true
    },
    "SAN MARTIN DE LAS PIRAMIDES": {
      "55850": true,
      "55851": true,
      "55852": true,
      "55853": true,
      "55854": true,
      "55855": true,
      "55856": true,
      "55857": true,
      "55858": true,
      "55859": true,
      "55860": true,
      "55861": true,
      "55862": true,
      "55863": true,
      "55864": true,
      "55865": true,
      "55866": true,
      "55867": true,
      "55868": true,
      "55869": true
    },
    "SAN MATEO ATENCO": {
      "52100": true,
      "52101": true,
      "52102": true,
      "52103": true,
      "52104": true,
      "52105": true,
      "52106": true,
      "52107": true,
      "52108": true,
      "52109": true,
      "52110": true,
      "52111": true,
      "52112": true,
      "52113": true,
      "52114": true,
      "52115": true,
      "52116": true,
      "52117": true,
      "52118": true,
      "52119": true,
      "52120": true,
      "52121": true,
      "52122": true,
      "52123": true,
      "52124": true,
      "52125": true,
      "52126": true,
      "52127": true,
      "52128": true,
      "52129": true,
      "52130": true,
      "52131": true,
      "52132": true,
      "52133": true,
      "52134": true,
      "52135": true,
      "52136": true,
      "52137": true,
      "52138": true,
      "52139": true
    },
    "SOYANIQUILPAN DE JUAREZ": {
      "54280": true,
      "54281": true,
      "54282": true,
      "54283": true,
      "54284": true,
      "54285": true,
      "54286": true,
      "54287": true,
      "54288": true,
      "54289": true,
      "54290": true,
      "54291": true,
      "54292": true,
      "54293": true,
      "54294": true,
      "54295": true,
      "54296": true,
      "54297": true,
      "54298": true,
      "54299": true
    },
    "TECÁMAC": {
      "55740": true,
      "55741": true,
      "55742": true,
      "55743": true,
      "55744": true,
      "55745": true,
      "55746": true,
      "55747": true,
      "55748": true,
      "55749": true,
      "55750": true,
      "55751": true,
      "55752": true,
      "55753": true,
      "55754": true,
      "55755": true,
      "55756": true,
      "55757": true,
      "55758": true,
      "55759": true,
      "55760": true,
      "55761": true,
      "55762": true,
      "55763": true,
      "55764": true,
      "55765": true,
      "55766": true,
      "55767": true,
      "55768": true,
      "55769": true,
      "55770": true,
      "55771": true,
      "55772": true,
      "55773": true,
      "55774": true,
      "55775": true,
      "55776": true,
      "55777": true,
      "55778": true,
      "55779": true
    },
    "TEMAMATLA": {
      "56650": true,
      "56651": true,
      "56652": true,
      "56653": true,
      "56654": true,
      "56655": true,
      "56656": true,
      "56657": true,
      "56658": true,
      "56659": true,
      "56660": true,
      "56661": true,
      "56662": true,
      "56663": true,
      "56664": true,
      "56665": true,
      "56666": true,
      "56667": true,
      "56668": true,
      "56669": true,
      "56670": true,
      "56671": true,
      "56672": true,
      "56673": true,
      "56674": true,
      "56675": true,
      "56676": true,
      "56677": true,
      "56678": true,
      "56679": true
    },
    "TEMASCALCINGO": {
      "50400": true,
      "50401": true,
      "50402": true,
      "50403": true,
      "50404": true,
      "50405": true,
      "50406": true,
      "50407": true,
      "50408": true,
      "50409": true,
      "50410": true,
      "50411": true,
      "50412": true,
      "50413": true,
      "50414": true,
      "50415": true,
      "50416": true,
      "50417": true,
      "50418": true,
      "50419": true,
      "50420": true,
      "50421": true,
      "50422": true,
      "50423": true,
      "50424": true,
      "50425": true,
      "50426": true,
      "50427": true,
      "50428": true,
      "50429": true,
      "50430": true,
      "50431": true,
      "50432": true,
      "50433": true,
      "50434": true,
      "50435": true,
      "50436": true,
      "50437": true,
      "50438": true,
      "50439": true,
      "50440": true,
      "50441": true,
      "50442": true,
      "50443": true,
      "50444": true,
      "50445": true,
      "50446": true
    },
    "TENANCINGO": {
      "52400": true,
      "52401": true,
      "52402": true,
      "52403": true,
      "52404": true,
      "52405": true,
      "52406": true,
      "52407": true,
      "52408": true,
      "52409": true,
      "52410": true,
      "52411": true,
      "52412": true,
      "52413": true,
      "52414": true,
      "52415": true,
      "52416": true,
      "52417": true,
      "52418": true,
      "52419": true,
      "52420": true,
      "52421": true,
      "52422": true,
      "52423": true,
      "52424": true,
      "52425": true,
      "52426": true,
      "52427": true,
      "52428": true,
      "52429": true,
      "52430": true,
      "52431": true,
      "52432": true,
      "52433": true,
      "52435": true,
      "52436": true,
      "52437": true,
      "52438": true,
      "52439": true
    },
    "TENANGO DEL AIRE": {
      "56780": true,
      "56781": true,
      "56782": true,
      "56783": true,
      "56784": true,
      "56785": true,
      "56786": true,
      "56787": true,
      "56788": true,
      "56789": true,
      "56790": true,
      "56791": true,
      "56792": true,
      "56793": true,
      "56794": true,
      "56795": true,
      "56796": true,
      "56797": true,
      "56798": true,
      "56799": true
    },
    "TENANGO DEL VALLE": {
      "52300": true,
      "52301": true,
      "52302": true,
      "52303": true,
      "52304": true,
      "52305": true,
      "52306": true,
      "52307": true,
      "52308": true,
      "52309": true,
      "52310": true,
      "52311": true,
      "52312": true,
      "52313": true,
      "52314": true,
      "52315": true,
      "52316": true,
      "52317": true,
      "52318": true,
      "52319": true,
      "52320": true,
      "52321": true,
      "52322": true,
      "52323": true,
      "52324": true,
      "52325": true,
      "52326": true,
      "52327": true,
      "52328": true,
      "52329": true,
      "52330": true,
      "52331": true,
      "52332": true,
      "52333": true,
      "52334": true,
      "52335": true,
      "52336": true,
      "52337": true,
      "52338": true,
      "52339": true,
      "52340": true,
      "52341": true,
      "52342": true,
      "52343": true,
      "52344": true,
      "52345": true,
      "52346": true,
      "52347": true,
      "52348": true,
      "52349": true,
      "52350": true,
      "52351": true,
      "52352": true,
      "52353": true,
      "52354": true,
      "52355": true,
      "52356": true,
      "52357": true,
      "52358": true,
      "52359": true
    },
    "TEOLOYUCAN": {
      "54770": true,
      "54771": true,
      "54772": true,
      "54773": true,
      "54774": true,
      "54775": true,
      "54776": true,
      "54777": true,
      "54778": true,
      "54779": true,
      "54780": true,
      "54781": true,
      "54782": true,
      "54783": true,
      "54784": true,
      "54785": true,
      "54786": true,
      "54787": true,
      "54788": true,
      "54789": true,
      "54790": true,
      "54791": true,
      "54792": true,
      "54793": true,
      "54794": true,
      "54795": true,
      "54796": true,
      "54797": true,
      "54798": true,
      "54799": true
    },
    "TEOTIHUACAN": {
      "55800": true,
      "55801": true,
      "55802": true,
      "55803": true,
      "55804": true,
      "55805": true,
      "55806": true,
      "55807": true,
      "55808": true,
      "55809": true,
      "55810": true,
      "55811": true,
      "55812": true,
      "55813": true,
      "55814": true,
      "55815": true,
      "55816": true,
      "55817": true,
      "55818": true,
      "55819": true,
      "55820": true,
      "55821": true,
      "55822": true,
      "55823": true,
      "55824": true,
      "55825": true,
      "55826": true,
      "55827": true,
      "55828": true,
      "55829": true,
      "55830": true,
      "55831": true,
      "55832": true,
      "55833": true,
      "55834": true,
      "55835": true,
      "55836": true,
      "55837": true,
      "55838": true,
      "55839": true,
      "55840": true,
      "55841": true,
      "55842": true,
      "55843": true,
      "55844": true,
      "55845": true,
      "55846": true,
      "55847": true,
      "55848": true,
      "55849": true
    },
    "TEPETLIXPA": {
      "56880": true,
      "56881": true,
      "56882": true,
      "56883": true,
      "56884": true,
      "56885": true,
      "56886": true,
      "56887": true,
      "56888": true,
      "56889": true,
      "56890": true,
      "56891": true,
      "56892": true,
      "56893": true,
      "56894": true,
      "56895": true,
      "56896": true,
      "56897": true,
      "56898": true,
      "56899": true
    },
    "TEPOTZOTLÁN": {
      "54600": true,
      "54601": true,
      "54602": true,
      "54603": true,
      "54604": true,
      "54605": true,
      "54606": true,
      "54607": true,
      "54608": true,
      "54609": true,
      "54610": true,
      "54611": true,
      "54612": true,
      "54613": true,
      "54614": true,
      "54615": true,
      "54616": true,
      "54617": true,
      "54618": true,
      "54619": true,
      "54620": true,
      "54621": true,
      "54622": true,
      "54623": true,
      "54624": true,
      "54625": true,
      "54626": true,
      "54627": true,
      "54628": true,
      "54629": true,
      "54630": true,
      "54631": true,
      "54632": true,
      "54633": true,
      "54634": true,
      "54635": true,
      "54636": true,
      "54637": true,
      "54638": true,
      "54639": true,
      "54640": true,
      "54645": true,
      "54650": true,
      "54651": true,
      "54652": true,
      "54653": true,
      "54654": true,
      "54655": true,
      "54656": true,
      "54657": true,
      "54658": true,
      "54659": true
    },
    "TEQUIXQUIAC": {
      "55650": true,
      "55651": true,
      "55652": true,
      "55653": true,
      "55654": true,
      "55655": true,
      "55656": true,
      "55657": true,
      "55658": true,
      "55659": true
    },
    "TEXCOCO": {
      "56100": true,
      "56101": true,
      "56102": true,
      "56103": true,
      "56104": true,
      "56105": true,
      "56106": true,
      "56107": true,
      "56108": true,
      "56109": true,
      "56110": true,
      "56111": true,
      "56112": true,
      "56113": true,
      "56114": true,
      "56115": true,
      "56116": true,
      "56117": true,
      "56118": true,
      "56119": true,
      "56120": true,
      "56121": true,
      "56122": true,
      "56123": true,
      "56124": true,
      "56125": true,
      "56126": true,
      "56127": true,
      "56128": true,
      "56129": true,
      "56130": true,
      "56131": true,
      "56132": true,
      "56133": true,
      "56134": true,
      "56135": true,
      "56136": true,
      "56137": true,
      "56138": true,
      "56139": true,
      "56140": true,
      "56141": true,
      "56142": true,
      "56143": true,
      "56144": true,
      "56145": true,
      "56146": true,
      "56147": true,
      "56148": true,
      "56149": true,
      "56150": true,
      "56151": true,
      "56152": true,
      "56153": true,
      "56154": true,
      "56155": true,
      "56156": true,
      "56157": true,
      "56158": true,
      "56159": true,
      "56160": true,
      "56161": true,
      "56162": true,
      "56163": true,
      "56164": true,
      "56165": true,
      "56166": true,
      "56167": true,
      "56168": true,
      "56169": true,
      "56170": true,
      "56171": true,
      "56172": true,
      "56173": true,
      "56174": true,
      "56175": true,
      "56176": true,
      "56177": true,
      "56178": true,
      "56179": true,
      "56180": true,
      "56181": true,
      "56182": true,
      "56183": true,
      "56184": true,
      "56185": true,
      "56186": true,
      "56187": true,
      "56188": true,
      "56189": true,
      "56190": true,
      "56191": true,
      "56192": true,
      "56193": true,
      "56194": true,
      "56195": true,
      "56196": true,
      "56197": true,
      "56198": true,
      "56199": true,
      "56200": true,
      "56201": true,
      "56202": true,
      "56203": true,
      "56204": true,
      "56205": true,
      "56206": true,
      "56207": true,
      "56208": true,
      "56209": true,
      "56210": true,
      "56211": true,
      "56212": true,
      "56213": true,
      "56214": true,
      "56215": true,
      "56216": true,
      "56217": true,
      "56218": true,
      "56219": true,
      "56220": true,
      "56221": true,
      "56222": true,
      "56223": true,
      "56224": true,
      "56225": true,
      "56226": true,
      "56227": true,
      "56228": true,
      "56229": true,
      "56230": true,
      "56231": true,
      "56232": true,
      "56233": true,
      "56234": true,
      "56235": true,
      "56236": true,
      "56237": true,
      "56238": true,
      "56239": true,
      "56240": true,
      "56241": true,
      "56242": true,
      "56243": true,
      "56244": true,
      "56245": true,
      "56246": true,
      "56247": true,
      "56248": true,
      "56249": true,
      "56250": true,
      "56251": true,
      "56252": true,
      "56253": true,
      "56254": true,
      "56255": true,
      "56256": true,
      "56257": true,
      "56258": true,
      "56259": true,
      "56260": true,
      "56261": true,
      "56262": true,
      "56263": true,
      "56264": true,
      "56265": true,
      "56266": true,
      "56267": true,
      "56268": true,
      "56269": true
    },
    "TEZOYUCA": {
      "56000": true,
      "56001": true,
      "56002": true,
      "56003": true,
      "56004": true,
      "56005": true,
      "56006": true,
      "56007": true,
      "56008": true,
      "56009": true,
      "56010": true,
      "56011": true,
      "56012": true,
      "56013": true,
      "56014": true,
      "56015": true,
      "56016": true,
      "56017": true,
      "56018": true,
      "56019": true,
      "56020": true,
      "56021": true,
      "56022": true,
      "56023": true,
      "56024": true,
      "56025": true,
      "56026": true,
      "56027": true,
      "56028": true,
      "56029": true
    },
    "TIANGUISTENCO": {
      "52600": true,
      "52601": true,
      "52602": true,
      "52603": true,
      "52604": true,
      "52605": true,
      "52606": true,
      "52607": true,
      "52608": true,
      "52609": true,
      "52610": true,
      "52611": true,
      "52612": true,
      "52613": true,
      "52614": true,
      "52615": true,
      "52616": true,
      "52617": true,
      "52618": true,
      "52619": true,
      "52620": true,
      "52621": true,
      "52622": true,
      "52623": true,
      "52624": true,
      "52625": true,
      "52626": true,
      "52627": true,
      "52628": true,
      "52629": true,
      "52630": true,
      "52631": true,
      "52632": true,
      "52633": true,
      "52634": true,
      "52635": true,
      "52636": true,
      "52637": true,
      "52638": true,
      "52639": true,
      "52640": true,
      "52641": true,
      "52642": true,
      "52643": true,
      "52644": true,
      "52645": true,
      "52646": true,
      "52647": true,
      "52648": true,
      "52649": true,
      "52650": true,
      "52651": true,
      "52652": true,
      "52653": true,
      "52654": true,
      "52655": true,
      "52656": true,
      "52657": true,
      "52658": true,
      "52659": true,
      "52660": true,
      "52661": true,
      "52662": true,
      "52663": true,
      "52664": true,
      "52665": true,
      "52666": true,
      "52667": true,
      "52668": true,
      "52669": true,
      "52670": true,
      "52671": true,
      "52672": true,
      "52673": true,
      "52674": true,
      "52675": true,
      "52676": true,
      "52677": true,
      "52678": true,
      "52679": true
    },
    "TLALMANALCO": {
      "56700": true,
      "56701": true,
      "56702": true,
      "56703": true,
      "56704": true,
      "56705": true,
      "56706": true,
      "56707": true,
      "56708": true,
      "56709": true,
      "56710": true,
      "56711": true,
      "56712": true,
      "56713": true,
      "56714": true,
      "56715": true,
      "56716": true,
      "56717": true,
      "56718": true,
      "56719": true,
      "56720": true,
      "56721": true,
      "56722": true,
      "56723": true,
      "56724": true,
      "56725": true,
      "56730": true,
      "56735": true,
      "56736": true,
      "56737": true,
      "56738": true,
      "56739": true,
      "56740": true,
      "56741": true,
      "56742": true,
      "56743": true,
      "56744": true,
      "56745": true,
      "56746": true,
      "56747": true,
      "56748": true,
      "56749": true,
      "56750": true,
      "56751": true,
      "56752": true,
      "56753": true,
      "56754": true,
      "56755": true,
      "56756": true,
      "56757": true,
      "56758": true,
      "56759": true
    },
    "TLALNEPANTLA DE BAZ": {
      "54000": true,
      "54001": true,
      "54002": true,
      "54003": true,
      "54004": true,
      "54005": true,
      "54006": true,
      "54007": true,
      "54008": true,
      "54009": true,
      "54010": true,
      "54011": true,
      "54012": true,
      "54013": true,
      "54014": true,
      "54015": true,
      "54016": true,
      "54017": true,
      "54018": true,
      "54019": true,
      "54020": true,
      "54021": true,
      "54022": true,
      "54023": true,
      "54024": true,
      "54025": true,
      "54026": true,
      "54027": true,
      "54028": true,
      "54029": true,
      "54030": true,
      "54031": true,
      "54032": true,
      "54033": true,
      "54034": true,
      "54035": true,
      "54036": true,
      "54037": true,
      "54038": true,
      "54039": true,
      "54040": true,
      "54041": true,
      "54042": true,
      "54043": true,
      "54044": true,
      "54045": true,
      "54046": true,
      "54047": true,
      "54048": true,
      "54049": true,
      "54050": true,
      "54051": true,
      "54052": true,
      "54053": true,
      "54054": true,
      "54055": true,
      "54056": true,
      "54057": true,
      "54058": true,
      "54059": true,
      "54060": true,
      "54061": true,
      "54062": true,
      "54063": true,
      "54064": true,
      "54065": true,
      "54066": true,
      "54067": true,
      "54068": true,
      "54069": true,
      "54070": true,
      "54071": true,
      "54072": true,
      "54073": true,
      "54074": true,
      "54075": true,
      "54076": true,
      "54077": true,
      "54078": true,
      "54079": true,
      "54080": true,
      "54081": true,
      "54082": true,
      "54083": true,
      "54084": true,
      "54085": true,
      "54086": true,
      "54087": true,
      "54088": true,
      "54089": true,
      "54090": true,
      "54091": true,
      "54092": true,
      "54093": true,
      "54094": true,
      "54095": true,
      "54096": true,
      "54097": true,
      "54098": true,
      "54099": true,
      "54100": true,
      "54101": true,
      "54102": true,
      "54103": true,
      "54104": true,
      "54105": true,
      "54106": true,
      "54107": true,
      "54108": true,
      "54109": true,
      "54110": true,
      "54111": true,
      "54112": true,
      "54113": true,
      "54114": true,
      "54115": true,
      "54116": true,
      "54117": true,
      "54118": true,
      "54119": true,
      "54120": true,
      "54121": true,
      "54122": true,
      "54123": true,
      "54124": true,
      "54125": true,
      "54126": true,
      "54127": true,
      "54128": true,
      "54129": true,
      "54130": true,
      "54131": true,
      "54132": true,
      "54133": true,
      "54134": true,
      "54135": true,
      "54136": true,
      "54137": true,
      "54138": true,
      "54139": true,
      "54140": true,
      "54141": true,
      "54142": true,
      "54143": true,
      "54144": true,
      "54145": true,
      "54146": true,
      "54147": true,
      "54148": true,
      "54149": true,
      "54150": true,
      "54151": true,
      "54152": true,
      "54153": true,
      "54154": true,
      "54155": true,
      "54156": true,
      "54157": true,
      "54158": true,
      "54159": true,
      "54160": true,
      "54161": true,
      "54162": true,
      "54163": true,
      "54164": true,
      "54165": true,
      "54166": true,
      "54167": true,
      "54168": true,
      "54169": true,
      "54170": true,
      "54171": true,
      "54172": true,
      "54173": true,
      "54174": true,
      "54175": true,
      "54176": true,
      "54177": true,
      "54178": true,
      "54179": true,
      "54180": true,
      "54181": true,
      "54182": true,
      "54183": true,
      "54184": true,
      "54185": true,
      "54186": true,
      "54187": true,
      "54188": true,
      "54189": true,
      "54190": true,
      "54191": true,
      "54192": true,
      "54193": true,
      "54194": true,
      "54195": true,
      "54196": true,
      "54197": true,
      "54198": true,
      "54199": true
    },
    "TOLUCA": {
      "50000": true,
      "50001": true,
      "50002": true,
      "50003": true,
      "50004": true,
      "50005": true,
      "50006": true,
      "50007": true,
      "50008": true,
      "50009": true,
      "50010": true,
      "50011": true,
      "50012": true,
      "50013": true,
      "50014": true,
      "50015": true,
      "50016": true,
      "50017": true,
      "50018": true,
      "50019": true,
      "50020": true,
      "50021": true,
      "50022": true,
      "50023": true,
      "50024": true,
      "50025": true,
      "50026": true,
      "50027": true,
      "50028": true,
      "50029": true,
      "50030": true,
      "50031": true,
      "50032": true,
      "50033": true,
      "50034": true,
      "50035": true,
      "50036": true,
      "50037": true,
      "50038": true,
      "50039": true,
      "50040": true,
      "50041": true,
      "50042": true,
      "50043": true,
      "50044": true,
      "50045": true,
      "50046": true,
      "50047": true,
      "50048": true,
      "50049": true,
      "50050": true,
      "50051": true,
      "50052": true,
      "50053": true,
      "50054": true,
      "50055": true,
      "50056": true,
      "50057": true,
      "50058": true,
      "50059": true,
      "50060": true,
      "50061": true,
      "50062": true,
      "50063": true,
      "50064": true,
      "50065": true,
      "50066": true,
      "50067": true,
      "50068": true,
      "50069": true,
      "50070": true,
      "50071": true,
      "50072": true,
      "50073": true,
      "50074": true,
      "50075": true,
      "50076": true,
      "50077": true,
      "50078": true,
      "50079": true,
      "50080": true,
      "50081": true,
      "50082": true,
      "50083": true,
      "50084": true,
      "50085": true,
      "50086": true,
      "50087": true,
      "50088": true,
      "50089": true,
      "50090": true,
      "50091": true,
      "50092": true,
      "50093": true,
      "50094": true,
      "50095": true,
      "50096": true,
      "50097": true,
      "50098": true,
      "50099": true,
      "50100": true,
      "50101": true,
      "50102": true,
      "50103": true,
      "50104": true,
      "50105": true,
      "50106": true,
      "50107": true,
      "50108": true,
      "50109": true,
      "50110": true,
      "50111": true,
      "50112": true,
      "50113": true,
      "50114": true,
      "50115": true,
      "50116": true,
      "50117": true,
      "50118": true,
      "50119": true,
      "50120": true,
      "50121": true,
      "50122": true,
      "50123": true,
      "50124": true,
      "50125": true,
      "50126": true,
      "50127": true,
      "50128": true,
      "50129": true,
      "50130": true,
      "50131": true,
      "50132": true,
      "50133": true,
      "50134": true,
      "50135": true,
      "50136": true,
      "50137": true,
      "50138": true,
      "50139": true,
      "50140": true,
      "50141": true,
      "50142": true,
      "50143": true,
      "50144": true,
      "50145": true,
      "50146": true,
      "50147": true,
      "50148": true,
      "50149": true,
      "50150": true,
      "50151": true,
      "50152": true,
      "50153": true,
      "50154": true,
      "50155": true,
      "50156": true,
      "50157": true,
      "50158": true,
      "50159": true,
      "50160": true,
      "50161": true,
      "50162": true,
      "50163": true,
      "50164": true,
      "50165": true,
      "50166": true,
      "50167": true,
      "50168": true,
      "50169": true,
      "50170": true,
      "50171": true,
      "50172": true,
      "50173": true,
      "50174": true,
      "50175": true,
      "50176": true,
      "50177": true,
      "50178": true,
      "50179": true,
      "50180": true,
      "50181": true,
      "50182": true,
      "50183": true,
      "50184": true,
      "50185": true,
      "50186": true,
      "50187": true,
      "50188": true,
      "50189": true,
      "50190": true,
      "50191": true,
      "50192": true,
      "50193": true,
      "50194": true,
      "50195": true,
      "50196": true,
      "50197": true,
      "50198": true,
      "50199": true,
      "50200": true,
      "50201": true,
      "50202": true,
      "50203": true,
      "50204": true,
      "50205": true,
      "50206": true,
      "50207": true,
      "50208": true,
      "50209": true,
      "50210": true,
      "50211": true,
      "50212": true,
      "50213": true,
      "50214": true,
      "50215": true,
      "50216": true,
      "50217": true,
      "50218": true,
      "50219": true,
      "50220": true,
      "50221": true,
      "50222": true,
      "50223": true,
      "50224": true,
      "50225": true,
      "50226": true,
      "50227": true,
      "50228": true,
      "50229": true,
      "50230": true,
      "50231": true,
      "50232": true,
      "50233": true,
      "50234": true,
      "50235": true,
      "50236": true,
      "50237": true,
      "50238": true,
      "50239": true,
      "50240": true,
      "50241": true,
      "50242": true,
      "50243": true,
      "50244": true,
      "50245": true,
      "50246": true,
      "50247": true,
      "50248": true,
      "50249": true,
      "50250": true,
      "50251": true,
      "50252": true,
      "50253": true,
      "50254": true,
      "50255": true,
      "50256": true,
      "50257": true,
      "50258": true,
      "50259": true,
      "50260": true,
      "50261": true,
      "50262": true,
      "50263": true,
      "50264": true,
      "50265": true,
      "50266": true,
      "50267": true,
      "50268": true,
      "50269": true,
      "50270": true,
      "50271": true,
      "50272": true,
      "50273": true,
      "50274": true,
      "50275": true,
      "50276": true,
      "50277": true,
      "50278": true,
      "50279": true,
      "50280": true,
      "50281": true,
      "50282": true,
      "50283": true,
      "50284": true,
      "50285": true,
      "50286": true,
      "50287": true,
      "50288": true,
      "50289": true,
      "50290": true,
      "50291": true,
      "50292": true,
      "50293": true,
      "50294": true,
      "50295": true,
      "50296": true,
      "50297": true,
      "50298": true,
      "50299": true
    },
    "TONANITLA": {
      "55785": true,
      "55786": true,
      "55787": true,
      "55788": true,
      "55789": true
    },
    "TONATICO": {
      "51950": true,
      "51951": true,
      "51952": true,
      "51953": true,
      "51954": true,
      "51955": true,
      "51956": true,
      "51957": true,
      "51958": true,
      "51959": true,
      "51960": true,
      "51961": true,
      "51962": true,
      "51963": true,
      "51964": true,
      "51965": true,
      "51966": true,
      "51967": true,
      "51968": true,
      "51969": true,
      "51970": true,
      "51971": true,
      "51972": true,
      "51973": true,
      "51974": true,
      "51975": true,
      "51976": true,
      "51977": true,
      "51978": true,
      "51979": true
    },
    "TULTEPEC": {
      "54960": true,
      "54961": true,
      "54962": true,
      "54963": true,
      "54964": true,
      "54965": true,
      "54966": true,
      "54967": true,
      "54968": true,
      "54969": true,
      "54970": true,
      "54971": true,
      "54972": true,
      "54973": true,
      "54974": true,
      "54975": true,
      "54976": true,
      "54977": true,
      "54978": true,
      "54979": true,
      "54980": true,
      "54981": true,
      "54982": true,
      "54983": true,
      "54984": true,
      "54985": true,
      "54986": true,
      "54987": true,
      "54988": true,
      "54989": true,
      "54990": true,
      "54991": true,
      "54992": true,
      "54993": true,
      "54994": true,
      "54995": true,
      "54996": true,
      "54997": true,
      "54998": true,
      "54999": true
    },
    "TULTITLÁN": {
      "54900": true,
      "54901": true,
      "54902": true,
      "54903": true,
      "54904": true,
      "54905": true,
      "54906": true,
      "54907": true,
      "54908": true,
      "54909": true,
      "54910": true,
      "54911": true,
      "54912": true,
      "54913": true,
      "54914": true,
      "54915": true,
      "54916": true,
      "54917": true,
      "54918": true,
      "54919": true,
      "54920": true,
      "54921": true,
      "54922": true,
      "54923": true,
      "54924": true,
      "54925": true,
      "54926": true,
      "54927": true,
      "54928": true,
      "54929": true,
      "54930": true,
      "54931": true,
      "54932": true,
      "54933": true,
      "54934": true,
      "54935": true,
      "54936": true,
      "54937": true,
      "54938": true,
      "54939": true,
      "54940": true,
      "54941": true,
      "54942": true,
      "54943": true,
      "54944": true,
      "54945": true,
      "54946": true,
      "54947": true,
      "54948": true,
      "54949": true,
      "54950": true,
      "54951": true,
      "54952": true,
      "54953": true,
      "54954": true,
      "54955": true,
      "54956": true,
      "54957": true,
      "54958": true,
      "54959": true
    },
    "VALLE DE CHALCO SOLIDARIDAD": {
      "56610": true,
      "56611": true,
      "56612": true,
      "56613": true,
      "56614": true,
      "56615": true,
      "56616": true,
      "56617": true,
      "56618": true,
      "56619": true
    },
    "VILLA DE ALLENDE": {
      "51000": true,
      "51001": true,
      "51002": true,
      "51003": true,
      "51004": true,
      "51005": true,
      "51006": true,
      "51007": true,
      "51008": true,
      "51009": true,
      "51010": true,
      "51011": true,
      "51012": true,
      "51013": true,
      "51014": true,
      "51015": true,
      "51016": true,
      "51017": true,
      "51018": true,
      "51019": true,
      "51020": true,
      "51021": true,
      "51022": true,
      "51023": true,
      "51024": true,
      "51025": true,
      "51026": true,
      "51027": true,
      "51028": true,
      "51029": true
    },
    "VILLA DEL CARBON": {
      "54300": true,
      "54301": true,
      "54302": true,
      "54303": true,
      "54304": true,
      "54305": true,
      "54306": true,
      "54307": true,
      "54308": true,
      "54309": true,
      "54310": true,
      "54311": true,
      "54312": true,
      "54313": true,
      "54314": true,
      "54315": true,
      "54316": true,
      "54317": true,
      "54318": true,
      "54319": true,
      "54320": true,
      "54321": true,
      "54322": true,
      "54323": true,
      "54324": true,
      "54325": true,
      "54326": true,
      "54327": true,
      "54328": true,
      "54329": true,
      "54330": true,
      "54331": true,
      "54332": true,
      "54333": true,
      "54334": true,
      "54335": true,
      "54337": true,
      "54338": true,
      "54339": true,
      "54345": true,
      "54346": true,
      "54347": true,
      "54348": true,
      "54349": true
    },
    "XALATLACO": {
      "52680": true,
      "52681": true,
      "52682": true,
      "52683": true,
      "52684": true,
      "52685": true,
      "52686": true,
      "52687": true,
      "52688": true,
      "52689": true,
      "52693": true,
      "52694": true,
      "52695": true,
      "52696": true,
      "52697": true,
      "52698": true,
      "52699": true
    },
    "XONACATLAN": {
      "52060": true,
      "52061": true,
      "52062": true,
      "52063": true,
      "52064": true,
      "52065": true,
      "52066": true,
      "52067": true,
      "52068": true,
      "52069": true,
      "52070": true,
      "52071": true,
      "52072": true,
      "52073": true,
      "52074": true,
      "52075": true,
      "52076": true
    },
    "ZINACANTEPEC": {
      "51350": true,
      "51351": true,
      "51352": true,
      "51353": true,
      "51354": true,
      "51355": true,
      "51356": true,
      "51357": true,
      "51358": true,
      "51359": true,
      "51360": true,
      "51361": true,
      "51362": true,
      "51363": true,
      "51364": true,
      "51365": true,
      "51366": true,
      "51367": true,
      "51368": true,
      "51369": true,
      "51370": true,
      "51371": true,
      "51372": true,
      "51373": true,
      "51374": true,
      "51375": true,
      "51376": true,
      "51377": true,
      "51378": true,
      "51379": true,
      "51380": true,
      "51381": true,
      "51382": true,
      "51383": true,
      "51384": true,
      "51385": true,
      "51386": true,
      "51387": true,
      "51388": true,
      "51389": true,
      "51390": true,
      "51391": true,
      "51392": true,
      "51393": true,
      "51394": true,
      "51395": true,
      "51396": true,
      "51397": true,
      "51398": true,
      "51399": true
    },
    "ZUMPANGO": {
      "55600": true,
      "55601": true,
      "55602": true,
      "55603": true,
      "55604": true,
      "55605": true,
      "55606": true,
      "55607": true,
      "55608": true,
      "55609": true,
      "55610": true,
      "55611": true,
      "55612": true,
      "55613": true,
      "55614": true,
      "55615": true,
      "55616": true,
      "55617": true,
      "55618": true,
      "55619": true,
      "55620": true,
      "55621": true,
      "55622": true,
      "55623": true,
      "55624": true,
      "55625": true,
      "55626": true,
      "55627": true,
      "55628": true,
      "55629": true,
      "55630": true,
      "55631": true,
      "55632": true,
      "55633": true,
      "55634": true,
      "55635": true,
      "55636": true,
      "55637": true,
      "55638": true,
      "55639": true,
      "55640": true,
      "55641": true,
      "55642": true,
      "55643": true,
      "55644": true,
      "55645": true,
      "55646": true,
      "55647": true,
      "55648": true,
      "55649": true
    }
  },
  "GUANAJUATO": {
    "ACAMBARO": {
      "38600": true,
      "38601": true,
      "38602": true,
      "38603": true,
      "38604": true,
      "38605": true,
      "38606": true,
      "38607": true,
      "38608": true,
      "38609": true,
      "38610": true,
      "38611": true,
      "38612": true,
      "38613": true,
      "38614": true,
      "38615": true,
      "38616": true,
      "38617": true,
      "38618": true,
      "38619": true,
      "38620": true,
      "38621": true,
      "38622": true,
      "38623": true,
      "38624": true,
      "38625": true,
      "38626": true,
      "38627": true,
      "38628": true,
      "38629": true,
      "38630": true,
      "38631": true,
      "38632": true,
      "38633": true,
      "38634": true,
      "38635": true,
      "38636": true,
      "38637": true,
      "38638": true,
      "38639": true,
      "38640": true,
      "38641": true,
      "38642": true,
      "38643": true,
      "38644": true,
      "38645": true,
      "38646": true,
      "38647": true,
      "38648": true,
      "38649": true,
      "38650": true,
      "38651": true,
      "38652": true,
      "38653": true,
      "38654": true,
      "38655": true,
      "38656": true,
      "38657": true,
      "38658": true,
      "38659": true,
      "38660": true,
      "38661": true,
      "38662": true,
      "38663": true,
      "38664": true,
      "38665": true,
      "38666": true,
      "38667": true,
      "38668": true,
      "38669": true,
      "38670": true,
      "38671": true,
      "38672": true,
      "38673": true,
      "38674": true,
      "38675": true,
      "38676": true,
      "38677": true,
      "38678": true,
      "38679": true,
      "38680": true,
      "38681": true,
      "38682": true,
      "38683": true,
      "38684": true,
      "38685": true,
      "38686": true,
      "38687": true,
      "38688": true,
      "38689": true,
      "38690": true,
      "38691": true,
      "38692": true,
      "38693": true,
      "38694": true,
      "38695": true,
      "38696": true,
      "38697": true,
      "38698": true,
      "38699": true,
      "38730": true,
      "38731": true,
      "38732": true,
      "38733": true,
      "38734": true,
      "38735": true,
      "38736": true,
      "38737": true,
      "38738": true,
      "38739": true,
      "38740": true,
      "38741": true,
      "38742": true,
      "38743": true,
      "38744": true,
      "38747": true,
      "38748": true,
      "38749": true,
      "38750": true,
      "38751": true,
      "38752": true,
      "38753": true,
      "38754": true,
      "38755": true,
      "38756": true,
      "38757": true,
      "38758": true,
      "38759": true,
      "38760": true,
      "38761": true,
      "38762": true,
      "38763": true,
      "38764": true,
      "38765": true,
      "38766": true,
      "38770": true,
      "38771": true,
      "38772": true,
      "38776": true,
      "38777": true,
      "38778": true,
      "38779": true,
      "38780": true,
      "38781": true,
      "38782": true,
      "38783": true,
      "38784": true,
      "38785": true,
      "38786": true,
      "38787": true,
      "38788": true,
      "38789": true
    },
    "APASEO EL ALTO": {
      "38500": true,
      "38501": true,
      "38502": true,
      "38503": true,
      "38504": true,
      "38505": true,
      "38506": true,
      "38507": true,
      "38508": true,
      "38509": true,
      "38510": true,
      "38511": true,
      "38512": true,
      "38513": true,
      "38514": true,
      "38515": true,
      "38517": true,
      "38518": true,
      "38519": true,
      "38520": true,
      "38521": true,
      "38522": true,
      "38523": true,
      "38524": true,
      "38525": true,
      "38526": true,
      "38527": true,
      "38528": true,
      "38529": true,
      "38530": true,
      "38531": true,
      "38532": true,
      "38534": true,
      "38535": true
    },
    "APASEO EL GRANDE": {
      "38160": true,
      "38161": true,
      "38162": true,
      "38163": true,
      "38164": true,
      "38165": true,
      "38166": true,
      "38167": true,
      "38168": true,
      "38169": true,
      "38173": true,
      "38174": true,
      "38176": true,
      "38177": true,
      "38178": true,
      "38179": true,
      "38180": true,
      "38181": true,
      "38182": true,
      "38185": true,
      "38186": true,
      "38187": true,
      "38190": true,
      "38191": true,
      "38192": true,
      "38193": true,
      "38194": true,
      "38195": true,
      "38196": true,
      "38197": true,
      "38198": true,
      "38199": true
    },
    "CELAYA": {
      "38000": true,
      "38001": true,
      "38002": true,
      "38003": true,
      "38004": true,
      "38005": true,
      "38006": true,
      "38007": true,
      "38008": true,
      "38009": true,
      "38010": true,
      "38011": true,
      "38012": true,
      "38013": true,
      "38014": true,
      "38015": true,
      "38016": true,
      "38017": true,
      "38018": true,
      "38019": true,
      "38020": true,
      "38021": true,
      "38022": true,
      "38023": true,
      "38024": true,
      "38025": true,
      "38026": true,
      "38027": true,
      "38028": true,
      "38029": true,
      "38030": true,
      "38031": true,
      "38032": true,
      "38033": true,
      "38034": true,
      "38035": true,
      "38036": true,
      "38037": true,
      "38038": true,
      "38039": true,
      "38040": true,
      "38041": true,
      "38042": true,
      "38043": true,
      "38044": true,
      "38045": true,
      "38046": true,
      "38047": true,
      "38048": true,
      "38049": true,
      "38050": true,
      "38051": true,
      "38052": true,
      "38053": true,
      "38054": true,
      "38055": true,
      "38056": true,
      "38057": true,
      "38058": true,
      "38059": true,
      "38060": true,
      "38061": true,
      "38062": true,
      "38063": true,
      "38064": true,
      "38065": true,
      "38066": true,
      "38067": true,
      "38068": true,
      "38069": true,
      "38070": true,
      "38071": true,
      "38072": true,
      "38073": true,
      "38074": true,
      "38075": true,
      "38076": true,
      "38077": true,
      "38078": true,
      "38079": true,
      "38080": true,
      "38081": true,
      "38082": true,
      "38083": true,
      "38084": true,
      "38085": true,
      "38086": true,
      "38087": true,
      "38088": true,
      "38089": true,
      "38090": true,
      "38091": true,
      "38092": true,
      "38093": true,
      "38094": true,
      "38095": true,
      "38096": true,
      "38097": true,
      "38098": true,
      "38099": true,
      "38100": true,
      "38101": true,
      "38102": true,
      "38103": true,
      "38104": true,
      "38105": true,
      "38106": true,
      "38107": true,
      "38108": true,
      "38109": true,
      "38110": true,
      "38111": true,
      "38112": true,
      "38113": true,
      "38114": true,
      "38115": true,
      "38116": true,
      "38117": true,
      "38118": true,
      "38119": true,
      "38120": true,
      "38121": true,
      "38122": true,
      "38123": true,
      "38124": true,
      "38125": true,
      "38126": true,
      "38127": true,
      "38128": true,
      "38129": true,
      "38130": true,
      "38131": true,
      "38132": true,
      "38133": true,
      "38134": true,
      "38135": true,
      "38136": true,
      "38137": true,
      "38138": true,
      "38139": true,
      "38140": true,
      "38141": true,
      "38142": true,
      "38143": true,
      "38144": true,
      "38145": true,
      "38146": true,
      "38147": true,
      "38148": true,
      "38149": true,
      "38150": true,
      "38151": true,
      "38152": true,
      "38153": true,
      "38154": true,
      "38155": true,
      "38156": true,
      "38157": true,
      "38158": true,
      "38159": true
    },
    "COMONFORT": {
      "38200": true,
      "38201": true,
      "38202": true,
      "38203": true,
      "38204": true,
      "38205": true,
      "38206": true,
      "38207": true,
      "38208": true,
      "38209": true,
      "38210": true,
      "38211": true,
      "38212": true,
      "38213": true,
      "38214": true,
      "38215": true,
      "38216": true,
      "38217": true,
      "38218": true,
      "38219": true,
      "38220": true,
      "38221": true,
      "38222": true,
      "38223": true,
      "38224": true,
      "38225": true,
      "38227": true,
      "38228": true,
      "38229": true,
      "38230": true,
      "38231": true,
      "38232": true,
      "38233": true,
      "38234": true,
      "38235": true,
      "38236": true,
      "38237": true,
      "38238": true,
      "38239": true
    },
    "CORTAZAR": {
      "38300": true,
      "38301": true,
      "38302": true,
      "38303": true,
      "38304": true,
      "38305": true,
      "38306": true,
      "38307": true,
      "38308": true,
      "38309": true,
      "38310": true,
      "38311": true,
      "38312": true,
      "38313": true,
      "38314": true,
      "38315": true,
      "38316": true,
      "38317": true,
      "38318": true,
      "38319": true,
      "38320": true,
      "38321": true,
      "38322": true,
      "38323": true,
      "38324": true,
      "38329": true,
      "38330": true,
      "38331": true,
      "38332": true,
      "38333": true,
      "38334": true,
      "38335": true,
      "38336": true,
      "38337": true,
      "38338": true,
      "38339": true,
      "38340": true,
      "38341": true,
      "38342": true,
      "38343": true,
      "38344": true,
      "38345": true,
      "38346": true,
      "38347": true,
      "38348": true,
      "38349": true,
      "38350": true,
      "38351": true,
      "38352": true,
      "38353": true,
      "38354": true,
      "38355": true,
      "38356": true,
      "38357": true,
      "38358": true,
      "38359": true,
      "38360": true,
      "38361": true,
      "38362": true,
      "38363": true,
      "38364": true,
      "38365": true,
      "38366": true,
      "38367": true,
      "38368": true,
      "38369": true,
      "38370": true,
      "38371": true,
      "38372": true,
      "38373": true,
      "38374": true,
      "38375": true,
      "38376": true,
      "38377": true,
      "38378": true,
      "38379": true,
      "38380": true,
      "38381": true,
      "38382": true,
      "38490": true,
      "38491": true,
      "38492": true,
      "38493": true,
      "38494": true,
      "38495": true,
      "38496": true,
      "38497": true,
      "38499": true
    },
    "CUERAMARO": {
      "36960": true,
      "36961": true,
      "36962": true,
      "36963": true,
      "36964": true,
      "36965": true,
      "36966": true,
      "36967": true,
      "36968": true,
      "36969": true
    },
    "DOLORES HIDALGO CUNA DE LA INDEPENDENCIA NACIONAL": {
      "37800": true,
      "37801": true,
      "37802": true,
      "37803": true,
      "37804": true,
      "37805": true,
      "37806": true,
      "37807": true,
      "37808": true,
      "37809": true,
      "37810": true,
      "37811": true,
      "37812": true,
      "37814": true,
      "37815": true,
      "37816": true,
      "37817": true,
      "37818": true,
      "37821": true,
      "37822": true,
      "37825": true,
      "37828": true,
      "37829": true,
      "37830": true,
      "37831": true,
      "37832": true,
      "37833": true,
      "37834": true,
      "37835": true,
      "37836": true,
      "37837": true,
      "37840": true,
      "37841": true,
      "37842": true,
      "37843": true,
      "37844": true,
      "37845": true,
      "37846": true,
      "37847": true,
      "37848": true,
      "37849": true
    },
    "GUANAJUATO": {
      "36000": true,
      "36001": true,
      "36002": true,
      "36003": true,
      "36004": true,
      "36005": true,
      "36006": true,
      "36007": true,
      "36008": true,
      "36009": true,
      "36010": true,
      "36011": true,
      "36012": true,
      "36013": true,
      "36014": true,
      "36015": true,
      "36016": true,
      "36017": true,
      "36018": true,
      "36019": true,
      "36020": true,
      "36021": true,
      "36022": true,
      "36023": true,
      "36024": true,
      "36025": true,
      "36026": true,
      "36027": true,
      "36028": true,
      "36029": true,
      "36030": true,
      "36031": true,
      "36032": true,
      "36033": true,
      "36034": true,
      "36035": true,
      "36036": true,
      "36037": true,
      "36038": true,
      "36039": true,
      "36040": true,
      "36041": true,
      "36042": true,
      "36043": true,
      "36044": true,
      "36045": true,
      "36046": true,
      "36047": true,
      "36048": true,
      "36049": true,
      "36050": true,
      "36051": true,
      "36052": true,
      "36053": true,
      "36054": true,
      "36055": true,
      "36056": true,
      "36057": true,
      "36058": true,
      "36059": true,
      "36060": true,
      "36061": true,
      "36062": true,
      "36063": true,
      "36064": true,
      "36065": true,
      "36066": true,
      "36067": true,
      "36068": true,
      "36069": true,
      "36070": true,
      "36071": true,
      "36072": true,
      "36073": true,
      "36074": true,
      "36075": true,
      "36076": true,
      "36077": true,
      "36078": true,
      "36079": true,
      "36080": true,
      "36081": true,
      "36082": true,
      "36083": true,
      "36084": true,
      "36085": true,
      "36086": true,
      "36087": true,
      "36088": true,
      "36089": true,
      "36090": true,
      "36091": true,
      "36092": true,
      "36093": true,
      "36094": true,
      "36095": true,
      "36096": true,
      "36097": true,
      "36098": true,
      "36099": true,
      "36220": true,
      "36221": true,
      "36222": true,
      "36223": true,
      "36224": true,
      "36225": true,
      "36226": true,
      "36227": true,
      "36228": true,
      "36229": true,
      "36230": true,
      "36231": true,
      "36232": true,
      "36235": true,
      "36236": true,
      "36237": true,
      "36238": true,
      "36239": true,
      "36240": true,
      "36241": true,
      "36242": true,
      "36243": true,
      "36244": true,
      "36246": true,
      "36247": true,
      "36248": true,
      "36249": true,
      "36250": true,
      "36251": true,
      "36252": true,
      "36253": true,
      "36254": true,
      "36255": true,
      "36256": true,
      "36257": true,
      "36258": true,
      "36259": true,
      "36260": true,
      "36261": true,
      "36262": true,
      "36263": true,
      "36264": true,
      "36265": true,
      "36266": true,
      "36267": true,
      "36268": true,
      "36269": true
    },
    "IRAPUATO": {
      "36500": true,
      "36501": true,
      "36502": true,
      "36503": true,
      "36504": true,
      "36505": true,
      "36506": true,
      "36507": true,
      "36508": true,
      "36509": true,
      "36510": true,
      "36511": true,
      "36512": true,
      "36513": true,
      "36514": true,
      "36515": true,
      "36516": true,
      "36517": true,
      "36518": true,
      "36519": true,
      "36520": true,
      "36521": true,
      "36522": true,
      "36523": true,
      "36524": true,
      "36525": true,
      "36526": true,
      "36527": true,
      "36528": true,
      "36529": true,
      "36530": true,
      "36531": true,
      "36532": true,
      "36533": true,
      "36534": true,
      "36535": true,
      "36536": true,
      "36537": true,
      "36538": true,
      "36539": true,
      "36540": true,
      "36541": true,
      "36542": true,
      "36543": true,
      "36544": true,
      "36545": true,
      "36546": true,
      "36547": true,
      "36548": true,
      "36549": true,
      "36550": true,
      "36551": true,
      "36552": true,
      "36553": true,
      "36554": true,
      "36555": true,
      "36556": true,
      "36557": true,
      "36558": true,
      "36559": true,
      "36560": true,
      "36561": true,
      "36562": true,
      "36563": true,
      "36564": true,
      "36565": true,
      "36566": true,
      "36567": true,
      "36568": true,
      "36569": true,
      "36570": true,
      "36571": true,
      "36572": true,
      "36573": true,
      "36574": true,
      "36575": true,
      "36576": true,
      "36577": true,
      "36578": true,
      "36579": true,
      "36580": true,
      "36581": true,
      "36582": true,
      "36583": true,
      "36584": true,
      "36585": true,
      "36586": true,
      "36587": true,
      "36588": true,
      "36589": true,
      "36590": true,
      "36591": true,
      "36592": true,
      "36593": true,
      "36594": true,
      "36595": true,
      "36596": true,
      "36597": true,
      "36598": true,
      "36599": true,
      "36600": true,
      "36601": true,
      "36602": true,
      "36603": true,
      "36604": true,
      "36605": true,
      "36606": true,
      "36607": true,
      "36608": true,
      "36609": true,
      "36610": true,
      "36611": true,
      "36612": true,
      "36613": true,
      "36614": true,
      "36615": true,
      "36616": true,
      "36617": true,
      "36618": true,
      "36619": true,
      "36620": true,
      "36621": true,
      "36622": true,
      "36623": true,
      "36624": true,
      "36625": true,
      "36626": true,
      "36627": true,
      "36628": true,
      "36629": true,
      "36630": true,
      "36631": true,
      "36632": true,
      "36633": true,
      "36634": true,
      "36635": true,
      "36636": true,
      "36637": true,
      "36638": true,
      "36639": true,
      "36640": true,
      "36641": true,
      "36642": true,
      "36643": true,
      "36644": true,
      "36645": true,
      "36646": true,
      "36647": true,
      "36648": true,
      "36649": true,
      "36650": true,
      "36651": true,
      "36652": true,
      "36653": true,
      "36654": true,
      "36655": true,
      "36656": true,
      "36657": true,
      "36658": true,
      "36659": true,
      "36660": true,
      "36661": true,
      "36662": true,
      "36663": true,
      "36664": true,
      "36665": true,
      "36666": true,
      "36667": true,
      "36668": true,
      "36669": true,
      "36670": true,
      "36671": true,
      "36672": true,
      "36673": true,
      "36674": true,
      "36675": true,
      "36676": true,
      "36677": true,
      "36678": true,
      "36679": true,
      "36680": true,
      "36681": true,
      "36682": true,
      "36683": true,
      "36684": true,
      "36685": true,
      "36686": true,
      "36687": true,
      "36688": true,
      "36689": true,
      "36690": true,
      "36691": true,
      "36692": true,
      "36693": true,
      "36694": true,
      "36695": true,
      "36696": true,
      "36697": true,
      "36698": true,
      "36699": true,
      "36800": true,
      "36801": true,
      "36802": true,
      "36803": true,
      "36804": true,
      "36805": true,
      "36806": true,
      "36807": true,
      "36808": true,
      "36809": true,
      "36810": true,
      "36811": true,
      "36812": true,
      "36813": true,
      "36814": true,
      "36815": true,
      "36817": true,
      "36821": true,
      "36822": true,
      "36823": true,
      "36824": true,
      "36825": true,
      "36826": true,
      "36827": true,
      "36828": true,
      "36829": true,
      "36830": true,
      "36831": true,
      "36832": true,
      "36833": true,
      "36834": true,
      "36835": true,
      "36836": true,
      "36837": true,
      "36838": true,
      "36839": true,
      "36840": true,
      "36841": true,
      "36842": true,
      "36843": true,
      "36844": true,
      "36845": true,
      "36846": true,
      "36847": true,
      "36848": true,
      "36849": true
    },
    "JARAL DEL PROGRESO": {
      "38470": true,
      "38471": true,
      "38472": true,
      "38473": true,
      "38474": true,
      "38475": true,
      "38476": true,
      "38477": true,
      "38478": true,
      "38479": true,
      "38480": true,
      "38481": true,
      "38482": true,
      "38483": true,
      "38484": true,
      "38485": true,
      "38486": true,
      "38487": true,
      "38488": true,
      "38489": true
    },
    "JERECUARO": {
      "38540": true,
      "38541": true,
      "38542": true,
      "38543": true,
      "38544": true,
      "38545": true,
      "38546": true,
      "38547": true,
      "38548": true,
      "38549": true,
      "38550": true,
      "38551": true,
      "38552": true,
      "38553": true,
      "38554": true,
      "38555": true,
      "38556": true,
      "38557": true,
      "38558": true,
      "38559": true,
      "38560": true,
      "38561": true,
      "38562": true,
      "38563": true,
      "38564": true,
      "38565": true,
      "38566": true,
      "38567": true,
      "38568": true,
      "38569": true,
      "38570": true,
      "38571": true,
      "38572": true,
      "38573": true,
      "38574": true,
      "38575": true,
      "38576": true,
      "38577": true,
      "38578": true,
      "38579": true,
      "38584": true,
      "38586": true,
      "38587": true,
      "38588": true,
      "38589": true
    },
    "LEÓN": {
      "37000": true,
      "37001": true,
      "37002": true,
      "37003": true,
      "37004": true,
      "37005": true,
      "37006": true,
      "37007": true,
      "37008": true,
      "37009": true,
      "37010": true,
      "37011": true,
      "37012": true,
      "37013": true,
      "37014": true,
      "37015": true,
      "37016": true,
      "37017": true,
      "37018": true,
      "37019": true,
      "37020": true,
      "37021": true,
      "37022": true,
      "37023": true,
      "37024": true,
      "37025": true,
      "37026": true,
      "37027": true,
      "37028": true,
      "37029": true,
      "37030": true,
      "37031": true,
      "37032": true,
      "37033": true,
      "37034": true,
      "37035": true,
      "37036": true,
      "37037": true,
      "37038": true,
      "37039": true,
      "37040": true,
      "37041": true,
      "37042": true,
      "37043": true,
      "37044": true,
      "37045": true,
      "37046": true,
      "37047": true,
      "37048": true,
      "37049": true,
      "37050": true,
      "37051": true,
      "37052": true,
      "37053": true,
      "37054": true,
      "37055": true,
      "37056": true,
      "37057": true,
      "37058": true,
      "37059": true,
      "37060": true,
      "37061": true,
      "37062": true,
      "37063": true,
      "37064": true,
      "37065": true,
      "37066": true,
      "37067": true,
      "37068": true,
      "37069": true,
      "37070": true,
      "37071": true,
      "37072": true,
      "37073": true,
      "37074": true,
      "37075": true,
      "37076": true,
      "37077": true,
      "37078": true,
      "37079": true,
      "37080": true,
      "37081": true,
      "37082": true,
      "37083": true,
      "37084": true,
      "37085": true,
      "37086": true,
      "37087": true,
      "37088": true,
      "37089": true,
      "37090": true,
      "37091": true,
      "37092": true,
      "37093": true,
      "37094": true,
      "37095": true,
      "37096": true,
      "37097": true,
      "37098": true,
      "37099": true,
      "37100": true,
      "37101": true,
      "37102": true,
      "37103": true,
      "37104": true,
      "37105": true,
      "37106": true,
      "37107": true,
      "37108": true,
      "37109": true,
      "37110": true,
      "37111": true,
      "37112": true,
      "37113": true,
      "37114": true,
      "37115": true,
      "37116": true,
      "37117": true,
      "37118": true,
      "37119": true,
      "37120": true,
      "37121": true,
      "37122": true,
      "37123": true,
      "37124": true,
      "37125": true,
      "37126": true,
      "37127": true,
      "37128": true,
      "37129": true,
      "37130": true,
      "37131": true,
      "37132": true,
      "37133": true,
      "37134": true,
      "37135": true,
      "37136": true,
      "37137": true,
      "37138": true,
      "37139": true,
      "37140": true,
      "37141": true,
      "37142": true,
      "37143": true,
      "37144": true,
      "37145": true,
      "37146": true,
      "37147": true,
      "37148": true,
      "37149": true,
      "37150": true,
      "37151": true,
      "37152": true,
      "37153": true,
      "37154": true,
      "37155": true,
      "37156": true,
      "37157": true,
      "37158": true,
      "37159": true,
      "37160": true,
      "37161": true,
      "37162": true,
      "37163": true,
      "37164": true,
      "37165": true,
      "37166": true,
      "37167": true,
      "37168": true,
      "37169": true,
      "37170": true,
      "37171": true,
      "37172": true,
      "37173": true,
      "37174": true,
      "37175": true,
      "37176": true,
      "37177": true,
      "37178": true,
      "37179": true,
      "37180": true,
      "37181": true,
      "37182": true,
      "37183": true,
      "37184": true,
      "37185": true,
      "37186": true,
      "37187": true,
      "37188": true,
      "37189": true,
      "37190": true,
      "37191": true,
      "37192": true,
      "37193": true,
      "37194": true,
      "37195": true,
      "37196": true,
      "37197": true,
      "37198": true,
      "37199": true,
      "37200": true,
      "37201": true,
      "37202": true,
      "37203": true,
      "37204": true,
      "37205": true,
      "37206": true,
      "37207": true,
      "37208": true,
      "37209": true,
      "37210": true,
      "37211": true,
      "37212": true,
      "37213": true,
      "37214": true,
      "37215": true,
      "37216": true,
      "37217": true,
      "37218": true,
      "37219": true,
      "37220": true,
      "37221": true,
      "37222": true,
      "37223": true,
      "37224": true,
      "37225": true,
      "37226": true,
      "37227": true,
      "37228": true,
      "37229": true,
      "37230": true,
      "37231": true,
      "37232": true,
      "37233": true,
      "37234": true,
      "37235": true,
      "37236": true,
      "37237": true,
      "37238": true,
      "37239": true,
      "37240": true,
      "37241": true,
      "37242": true,
      "37243": true,
      "37244": true,
      "37245": true,
      "37246": true,
      "37247": true,
      "37248": true,
      "37249": true,
      "37250": true,
      "37251": true,
      "37252": true,
      "37253": true,
      "37254": true,
      "37255": true,
      "37256": true,
      "37257": true,
      "37258": true,
      "37259": true,
      "37260": true,
      "37261": true,
      "37262": true,
      "37263": true,
      "37264": true,
      "37265": true,
      "37266": true,
      "37267": true,
      "37268": true,
      "37269": true,
      "37270": true,
      "37271": true,
      "37272": true,
      "37273": true,
      "37274": true,
      "37275": true,
      "37276": true,
      "37277": true,
      "37278": true,
      "37279": true,
      "37280": true,
      "37281": true,
      "37282": true,
      "37283": true,
      "37284": true,
      "37285": true,
      "37286": true,
      "37287": true,
      "37288": true,
      "37289": true,
      "37290": true,
      "37291": true,
      "37292": true,
      "37293": true,
      "37294": true,
      "37295": true,
      "37296": true,
      "37297": true,
      "37298": true,
      "37299": true,
      "37300": true,
      "37301": true,
      "37302": true,
      "37303": true,
      "37304": true,
      "37305": true,
      "37306": true,
      "37307": true,
      "37308": true,
      "37309": true,
      "37310": true,
      "37311": true,
      "37312": true,
      "37313": true,
      "37314": true,
      "37315": true,
      "37316": true,
      "37317": true,
      "37318": true,
      "37319": true,
      "37320": true,
      "37321": true,
      "37322": true,
      "37323": true,
      "37324": true,
      "37325": true,
      "37326": true,
      "37327": true,
      "37328": true,
      "37329": true,
      "37330": true,
      "37331": true,
      "37332": true,
      "37333": true,
      "37334": true,
      "37335": true,
      "37336": true,
      "37337": true,
      "37338": true,
      "37339": true,
      "37340": true,
      "37341": true,
      "37342": true,
      "37343": true,
      "37344": true,
      "37345": true,
      "37346": true,
      "37347": true,
      "37348": true,
      "37349": true,
      "37350": true,
      "37351": true,
      "37352": true,
      "37353": true,
      "37354": true,
      "37355": true,
      "37356": true,
      "37357": true,
      "37358": true,
      "37359": true,
      "37360": true,
      "37361": true,
      "37362": true,
      "37363": true,
      "37364": true,
      "37365": true,
      "37366": true,
      "37367": true,
      "37368": true,
      "37369": true,
      "37370": true,
      "37371": true,
      "37372": true,
      "37373": true,
      "37374": true,
      "37375": true,
      "37376": true,
      "37377": true,
      "37378": true,
      "37379": true,
      "37380": true,
      "37381": true,
      "37382": true,
      "37383": true,
      "37384": true,
      "37385": true,
      "37386": true,
      "37387": true,
      "37388": true,
      "37389": true,
      "37390": true,
      "37391": true,
      "37392": true,
      "37393": true,
      "37394": true,
      "37395": true,
      "37396": true,
      "37397": true,
      "37398": true,
      "37399": true,
      "37400": true,
      "37401": true,
      "37402": true,
      "37403": true,
      "37404": true,
      "37405": true,
      "37406": true,
      "37407": true,
      "37408": true,
      "37409": true,
      "37410": true,
      "37411": true,
      "37412": true,
      "37413": true,
      "37414": true,
      "37415": true,
      "37416": true,
      "37417": true,
      "37418": true,
      "37419": true,
      "37420": true,
      "37421": true,
      "37422": true,
      "37423": true,
      "37424": true,
      "37425": true,
      "37426": true,
      "37427": true,
      "37428": true,
      "37429": true,
      "37430": true,
      "37431": true,
      "37432": true,
      "37433": true,
      "37434": true,
      "37435": true,
      "37436": true,
      "37437": true,
      "37438": true,
      "37439": true,
      "37440": true,
      "37441": true,
      "37442": true,
      "37443": true,
      "37444": true,
      "37445": true,
      "37446": true,
      "37447": true,
      "37448": true,
      "37449": true,
      "37450": true,
      "37451": true,
      "37452": true,
      "37453": true,
      "37454": true,
      "37455": true,
      "37456": true,
      "37457": true,
      "37458": true,
      "37459": true,
      "37460": true,
      "37461": true,
      "37462": true,
      "37463": true,
      "37464": true,
      "37465": true,
      "37466": true,
      "37467": true,
      "37468": true,
      "37469": true,
      "37470": true,
      "37471": true,
      "37472": true,
      "37473": true,
      "37474": true,
      "37475": true,
      "37476": true,
      "37477": true,
      "37478": true,
      "37479": true,
      "37480": true,
      "37481": true,
      "37482": true,
      "37483": true,
      "37484": true,
      "37485": true,
      "37486": true,
      "37487": true,
      "37488": true,
      "37489": true,
      "37490": true,
      "37491": true,
      "37492": true,
      "37493": true,
      "37494": true,
      "37495": true,
      "37496": true,
      "37497": true,
      "37498": true,
      "37499": true,
      "37500": true,
      "37501": true,
      "37502": true,
      "37503": true,
      "37504": true,
      "37505": true,
      "37506": true,
      "37507": true,
      "37508": true,
      "37509": true,
      "37510": true,
      "37511": true,
      "37512": true,
      "37513": true,
      "37514": true,
      "37515": true,
      "37516": true,
      "37517": true,
      "37518": true,
      "37519": true,
      "37520": true,
      "37521": true,
      "37522": true,
      "37523": true,
      "37524": true,
      "37525": true,
      "37526": true,
      "37527": true,
      "37528": true,
      "37529": true,
      "37530": true,
      "37531": true,
      "37532": true,
      "37533": true,
      "37534": true,
      "37535": true,
      "37536": true,
      "37537": true,
      "37538": true,
      "37539": true,
      "37540": true,
      "37541": true,
      "37542": true,
      "37543": true,
      "37544": true,
      "37545": true,
      "37546": true,
      "37547": true,
      "37548": true,
      "37549": true,
      "37550": true,
      "37551": true,
      "37552": true,
      "37553": true,
      "37554": true,
      "37555": true,
      "37556": true,
      "37557": true,
      "37558": true,
      "37559": true,
      "37560": true,
      "37561": true,
      "37562": true,
      "37563": true,
      "37564": true,
      "37565": true,
      "37566": true,
      "37567": true,
      "37568": true,
      "37569": true,
      "37570": true,
      "37571": true,
      "37572": true,
      "37573": true,
      "37574": true,
      "37575": true,
      "37576": true,
      "37577": true,
      "37578": true,
      "37579": true,
      "37580": true,
      "37581": true,
      "37582": true,
      "37583": true,
      "37584": true,
      "37585": true,
      "37586": true,
      "37587": true,
      "37588": true,
      "37589": true,
      "37590": true,
      "37591": true,
      "37592": true,
      "37593": true,
      "37594": true,
      "37595": true,
      "37596": true,
      "37597": true,
      "37598": true,
      "37599": true,
      "37650": true,
      "37651": true,
      "37652": true,
      "37653": true,
      "37654": true,
      "37655": true,
      "37656": true,
      "37657": true,
      "37658": true,
      "37659": true,
      "37660": true,
      "37661": true,
      "37662": true,
      "37663": true,
      "37664": true,
      "37665": true,
      "37666": true,
      "37667": true,
      "37668": true,
      "37669": true,
      "37670": true,
      "37671": true,
      "37672": true,
      "37673": true,
      "37674": true,
      "37675": true,
      "37676": true,
      "37677": true,
      "37678": true,
      "37679": true,
      "37680": true,
      "37681": true,
      "37682": true,
      "37683": true,
      "37684": true,
      "37685": true,
      "37686": true,
      "37687": true,
      "37688": true,
      "37689": true,
      "37690": true,
      "37691": true,
      "37692": true,
      "37693": true,
      "37694": true,
      "37695": true,
      "37696": true,
      "37697": true,
      "37698": true,
      "37699": true
    },
    "MANUEL DOBLADO": {
      "36470": true,
      "36471": true,
      "36472": true,
      "36473": true,
      "36474": true,
      "36475": true,
      "36476": true,
      "36477": true,
      "36478": true,
      "36479": true,
      "36480": true,
      "36481": true,
      "36482": true,
      "36483": true,
      "36484": true,
      "36485": true,
      "36486": true,
      "36487": true,
      "36488": true,
      "36489": true,
      "36490": true,
      "36491": true,
      "36492": true,
      "36493": true,
      "36494": true,
      "36496": true,
      "36497": true,
      "36498": true,
      "36499": true
    },
    "MOROLEON": {
      "38800": true,
      "38801": true,
      "38802": true,
      "38803": true,
      "38804": true,
      "38805": true,
      "38806": true,
      "38807": true,
      "38808": true,
      "38809": true,
      "38810": true,
      "38811": true,
      "38812": true,
      "38813": true,
      "38814": true,
      "38815": true,
      "38816": true,
      "38817": true,
      "38818": true,
      "38819": true,
      "38820": true,
      "38821": true,
      "38822": true,
      "38823": true,
      "38824": true,
      "38825": true,
      "38826": true,
      "38827": true,
      "38828": true,
      "38829": true,
      "38830": true,
      "38831": true,
      "38832": true,
      "38833": true,
      "38834": true,
      "38835": true,
      "38836": true,
      "38837": true,
      "38838": true,
      "38839": true,
      "38840": true,
      "38841": true,
      "38842": true,
      "38843": true,
      "38844": true,
      "38845": true,
      "38846": true,
      "38847": true,
      "38848": true,
      "38849": true,
      "38850": true,
      "38851": true,
      "38852": true,
      "38853": true,
      "38854": true,
      "38855": true,
      "38856": true,
      "38857": true,
      "38858": true,
      "38859": true,
      "38860": true,
      "38861": true,
      "38862": true,
      "38863": true,
      "38864": true,
      "38865": true,
      "38866": true,
      "38867": true,
      "38868": true,
      "38869": true,
      "38870": true,
      "38871": true,
      "38872": true,
      "38873": true,
      "38874": true,
      "38875": true,
      "38876": true,
      "38877": true,
      "38878": true,
      "38879": true,
      "38880": true,
      "38881": true,
      "38882": true,
      "38883": true,
      "38884": true,
      "38885": true,
      "38886": true,
      "38887": true,
      "38888": true,
      "38889": true,
      "38890": true,
      "38891": true,
      "38892": true,
      "38893": true,
      "38894": true,
      "38895": true,
      "38896": true,
      "38897": true,
      "38898": true,
      "38899": true,
      "38990": true,
      "38991": true,
      "38992": true,
      "38993": true,
      "38994": true,
      "38995": true,
      "38996": true,
      "38997": true,
      "38998": true,
      "38999": true
    },
    "PENJAMO": {
      "36900": true,
      "36901": true,
      "36902": true,
      "36903": true,
      "36904": true,
      "36905": true,
      "36906": true,
      "36907": true,
      "36908": true,
      "36909": true,
      "36910": true,
      "36911": true,
      "36912": true,
      "36923": true,
      "36924": true,
      "36925": true,
      "36926": true,
      "36927": true,
      "36928": true,
      "36929": true,
      "36930": true,
      "36931": true,
      "36932": true,
      "36933": true,
      "36935": true,
      "36936": true,
      "36937": true,
      "36938": true,
      "36939": true,
      "36943": true,
      "36946": true,
      "36947": true,
      "36948": true,
      "36949": true,
      "36950": true,
      "36951": true,
      "36952": true,
      "36953": true,
      "36954": true,
      "36955": true,
      "36956": true,
      "36957": true,
      "36958": true,
      "36959": true
    },
    "PUEBLO NUEVO": {
      "36890": true,
      "36891": true,
      "36892": true,
      "36893": true,
      "36894": true,
      "36895": true,
      "36896": true,
      "36897": true,
      "36898": true,
      "36899": true
    },
    "PURISIMA DEL RINCON": {
      "36400": true,
      "36401": true,
      "36402": true,
      "36403": true,
      "36404": true,
      "36405": true,
      "36406": true,
      "36407": true,
      "36408": true,
      "36409": true,
      "36410": true,
      "36411": true,
      "36412": true,
      "36413": true,
      "36414": true,
      "36415": true,
      "36416": true,
      "36417": true,
      "36418": true,
      "36419": true,
      "36420": true,
      "36421": true,
      "36422": true,
      "36423": true,
      "36424": true,
      "36425": true,
      "36426": true,
      "36427": true,
      "36428": true,
      "36429": true,
      "36433": true,
      "36436": true
    },
    "ROMITA": {
      "36200": true,
      "36201": true,
      "36202": true,
      "36203": true,
      "36204": true,
      "36205": true,
      "36206": true,
      "36207": true,
      "36208": true,
      "36209": true,
      "36210": true,
      "36211": true,
      "36212": true,
      "36213": true,
      "36214": true,
      "36215": true,
      "36216": true,
      "36217": true,
      "36218": true,
      "36219": true
    },
    "SALAMANCA": {
      "36700": true,
      "36701": true,
      "36702": true,
      "36703": true,
      "36704": true,
      "36705": true,
      "36706": true,
      "36707": true,
      "36708": true,
      "36709": true,
      "36710": true,
      "36711": true,
      "36712": true,
      "36713": true,
      "36714": true,
      "36715": true,
      "36716": true,
      "36717": true,
      "36718": true,
      "36719": true,
      "36720": true,
      "36721": true,
      "36722": true,
      "36723": true,
      "36724": true,
      "36725": true,
      "36726": true,
      "36727": true,
      "36728": true,
      "36729": true,
      "36730": true,
      "36731": true,
      "36732": true,
      "36733": true,
      "36734": true,
      "36735": true,
      "36736": true,
      "36737": true,
      "36738": true,
      "36739": true,
      "36740": true,
      "36741": true,
      "36742": true,
      "36743": true,
      "36744": true,
      "36745": true,
      "36746": true,
      "36747": true,
      "36748": true,
      "36749": true,
      "36750": true,
      "36751": true,
      "36752": true,
      "36753": true,
      "36754": true,
      "36755": true,
      "36756": true,
      "36757": true,
      "36758": true,
      "36759": true,
      "36760": true,
      "36761": true,
      "36762": true,
      "36763": true,
      "36764": true,
      "36765": true,
      "36766": true,
      "36767": true,
      "36768": true,
      "36769": true,
      "36770": true,
      "36771": true,
      "36772": true,
      "36773": true,
      "36774": true,
      "36775": true,
      "36776": true,
      "36777": true,
      "36778": true,
      "36779": true,
      "36780": true,
      "36781": true,
      "36782": true,
      "36783": true,
      "36784": true,
      "36785": true,
      "36786": true,
      "36787": true,
      "36788": true,
      "36789": true,
      "36790": true,
      "36791": true,
      "36792": true,
      "36793": true,
      "36794": true,
      "36795": true,
      "36796": true,
      "36797": true,
      "36798": true,
      "36799": true,
      "36850": true,
      "36851": true,
      "36852": true,
      "36853": true,
      "36854": true,
      "36855": true,
      "36856": true,
      "36857": true,
      "36860": true,
      "36861": true,
      "36862": true,
      "36863": true,
      "36864": true,
      "36865": true,
      "36866": true,
      "36867": true,
      "36868": true,
      "36869": true,
      "36870": true,
      "36871": true,
      "36872": true,
      "36873": true,
      "36874": true,
      "36875": true,
      "36876": true,
      "36877": true,
      "36878": true,
      "36879": true,
      "36880": true,
      "36881": true,
      "36882": true,
      "36883": true,
      "36884": true,
      "36885": true,
      "36886": true,
      "36887": true,
      "36888": true,
      "36889": true
    },
    "SALVATIERRA": {
      "38900": true,
      "38901": true,
      "38902": true,
      "38903": true,
      "38904": true,
      "38905": true,
      "38906": true,
      "38907": true,
      "38908": true,
      "38910": true,
      "38911": true,
      "38912": true,
      "38913": true,
      "38914": true,
      "38915": true,
      "38916": true,
      "38917": true,
      "38918": true,
      "38919": true,
      "38920": true,
      "38921": true,
      "38922": true,
      "38923": true,
      "38924": true,
      "38925": true,
      "38926": true,
      "38930": true,
      "38931": true,
      "38932": true,
      "38933": true,
      "38934": true,
      "38935": true,
      "38936": true,
      "38937": true,
      "38938": true,
      "38939": true
    },
    "SAN FELIPE": {
      "37600": true,
      "37601": true,
      "37602": true,
      "37603": true,
      "37604": true,
      "37605": true,
      "37606": true,
      "37607": true,
      "37608": true,
      "37609": true,
      "37610": true,
      "37611": true,
      "37612": true,
      "37614": true,
      "37615": true,
      "37616": true,
      "37617": true,
      "37618": true,
      "37619": true
    },
    "SAN FRANCISCO DEL RINCON": {
      "36300": true,
      "36301": true,
      "36302": true,
      "36303": true,
      "36304": true,
      "36305": true,
      "36306": true,
      "36307": true,
      "36308": true,
      "36309": true,
      "36310": true,
      "36311": true,
      "36312": true,
      "36313": true,
      "36314": true,
      "36315": true,
      "36316": true,
      "36317": true,
      "36318": true,
      "36319": true,
      "36320": true,
      "36321": true,
      "36322": true,
      "36323": true,
      "36324": true,
      "36325": true,
      "36326": true,
      "36327": true,
      "36328": true,
      "36329": true,
      "36330": true,
      "36331": true,
      "36332": true,
      "36333": true,
      "36334": true,
      "36335": true,
      "36336": true,
      "36337": true,
      "36338": true,
      "36339": true,
      "36340": true,
      "36341": true,
      "36342": true,
      "36343": true,
      "36344": true,
      "36345": true,
      "36346": true,
      "36347": true,
      "36348": true,
      "36349": true,
      "36350": true,
      "36351": true,
      "36352": true,
      "36353": true,
      "36354": true,
      "36355": true,
      "36356": true,
      "36357": true,
      "36358": true,
      "36359": true,
      "36360": true,
      "36361": true,
      "36362": true,
      "36363": true,
      "36364": true,
      "36365": true,
      "36366": true,
      "36367": true,
      "36368": true,
      "36369": true,
      "36370": true,
      "36371": true,
      "36372": true,
      "36373": true,
      "36374": true,
      "36375": true,
      "36376": true,
      "36377": true,
      "36378": true,
      "36379": true,
      "36380": true,
      "36381": true,
      "36382": true,
      "36383": true,
      "36384": true,
      "36385": true,
      "36386": true,
      "36387": true,
      "36388": true,
      "36389": true,
      "36390": true,
      "36391": true,
      "36392": true,
      "36393": true,
      "36394": true,
      "36395": true,
      "36396": true,
      "36397": true,
      "36398": true,
      "36399": true,
      "36440": true,
      "36441": true,
      "36442": true,
      "36443": true,
      "36444": true,
      "36445": true,
      "36446": true,
      "36447": true,
      "36448": true,
      "36449": true,
      "36450": true,
      "36451": true,
      "36452": true,
      "36453": true,
      "36456": true,
      "36460": true,
      "36461": true,
      "36462": true,
      "36463": true,
      "36464": true,
      "36465": true,
      "36466": true,
      "36467": true,
      "36468": true,
      "36469": true
    },
    "SAN JOSE ITURBIDE": {
      "37980": true,
      "37981": true,
      "37982": true,
      "37983": true,
      "37984": true,
      "37985": true,
      "37986": true,
      "37987": true,
      "37988": true,
      "37989": true,
      "37990": true,
      "37991": true,
      "37992": true,
      "37993": true,
      "37994": true,
      "37995": true,
      "37996": true,
      "37997": true,
      "37998": true,
      "37999": true
    },
    "SAN LUIS DE LA PAZ": {
      "37900": true,
      "37901": true,
      "37902": true,
      "37903": true,
      "37904": true,
      "37905": true,
      "37906": true,
      "37907": true,
      "37908": true,
      "37909": true,
      "37910": true,
      "37911": true,
      "37912": true,
      "37914": true,
      "37915": true,
      "37917": true
    },
    "SAN MIGUEL DE ALLENDE": {
      "37700": true,
      "37701": true,
      "37702": true,
      "37703": true,
      "37704": true,
      "37705": true,
      "37706": true,
      "37707": true,
      "37708": true,
      "37709": true,
      "37710": true,
      "37711": true,
      "37712": true,
      "37713": true,
      "37714": true,
      "37715": true,
      "37716": true,
      "37717": true,
      "37718": true,
      "37719": true,
      "37720": true,
      "37721": true,
      "37722": true,
      "37723": true,
      "37724": true,
      "37725": true,
      "37726": true,
      "37727": true,
      "37728": true,
      "37729": true,
      "37730": true,
      "37731": true,
      "37732": true,
      "37733": true,
      "37734": true,
      "37735": true,
      "37736": true,
      "37737": true,
      "37738": true,
      "37739": true,
      "37740": true,
      "37741": true,
      "37742": true,
      "37743": true,
      "37744": true,
      "37745": true,
      "37746": true,
      "37747": true,
      "37748": true,
      "37749": true,
      "37750": true,
      "37751": true,
      "37752": true,
      "37753": true,
      "37754": true,
      "37755": true,
      "37756": true,
      "37757": true,
      "37758": true,
      "37759": true,
      "37760": true,
      "37761": true,
      "37762": true,
      "37763": true,
      "37764": true,
      "37765": true,
      "37766": true,
      "37767": true,
      "37768": true,
      "37769": true,
      "37770": true,
      "37771": true,
      "37772": true,
      "37773": true,
      "37774": true,
      "37775": true,
      "37776": true,
      "37777": true,
      "37778": true,
      "37779": true,
      "37780": true,
      "37781": true,
      "37782": true,
      "37783": true,
      "37784": true,
      "37785": true,
      "37786": true,
      "37787": true,
      "37788": true,
      "37789": true,
      "37790": true,
      "37791": true,
      "37792": true,
      "37793": true,
      "37794": true,
      "37795": true,
      "37796": true,
      "37797": true,
      "37798": true,
      "37799": true,
      "37880": true,
      "37881": true,
      "37882": true,
      "37883": true,
      "37884": true,
      "37885": true,
      "37886": true,
      "37887": true,
      "37888": true,
      "37889": true,
      "37890": true,
      "37891": true,
      "37892": true,
      "37893": true,
      "37894": true,
      "37896": true,
      "37897": true,
      "37898": true,
      "37899": true
    },
    "SANTA CRUZ DE JUVENTINO ROSAS": {
      "38240": true,
      "38241": true,
      "38242": true,
      "38243": true,
      "38244": true,
      "38245": true,
      "38246": true,
      "38247": true,
      "38248": true,
      "38249": true,
      "38250": true,
      "38251": true,
      "38252": true,
      "38253": true,
      "38254": true,
      "38255": true,
      "38256": true
    },
    "SILAO DE LA VICTORIA": {
      "36100": true,
      "36101": true,
      "36102": true,
      "36103": true,
      "36104": true,
      "36105": true,
      "36106": true,
      "36107": true,
      "36108": true,
      "36109": true,
      "36110": true,
      "36111": true,
      "36112": true,
      "36113": true,
      "36114": true,
      "36115": true,
      "36116": true,
      "36117": true,
      "36118": true,
      "36119": true,
      "36120": true,
      "36121": true,
      "36122": true,
      "36123": true,
      "36124": true,
      "36125": true,
      "36126": true,
      "36127": true,
      "36128": true,
      "36129": true,
      "36130": true,
      "36131": true,
      "36132": true,
      "36133": true,
      "36134": true,
      "36135": true,
      "36136": true,
      "36137": true,
      "36138": true,
      "36139": true,
      "36140": true,
      "36141": true,
      "36142": true,
      "36143": true,
      "36144": true,
      "36145": true,
      "36146": true,
      "36147": true,
      "36148": true,
      "36149": true,
      "36150": true,
      "36151": true,
      "36152": true,
      "36153": true,
      "36154": true,
      "36155": true,
      "36156": true,
      "36157": true,
      "36158": true,
      "36159": true,
      "36160": true,
      "36161": true,
      "36162": true,
      "36163": true,
      "36164": true,
      "36165": true,
      "36166": true,
      "36167": true,
      "36168": true,
      "36169": true,
      "36170": true,
      "36171": true,
      "36172": true,
      "36173": true,
      "36174": true,
      "36175": true,
      "36176": true,
      "36177": true,
      "36178": true,
      "36179": true,
      "36180": true,
      "36181": true,
      "36182": true,
      "36183": true,
      "36184": true,
      "36185": true,
      "36186": true,
      "36187": true,
      "36188": true,
      "36189": true,
      "36190": true,
      "36191": true,
      "36192": true,
      "36193": true,
      "36194": true,
      "36195": true,
      "36196": true,
      "36197": true,
      "36198": true,
      "36199": true,
      "36270": true,
      "36271": true,
      "36272": true,
      "36273": true,
      "36274": true,
      "36275": true,
      "36276": true,
      "36277": true,
      "36278": true,
      "36279": true,
      "36280": true,
      "36281": true,
      "36282": true,
      "36283": true,
      "36284": true,
      "36285": true,
      "36286": true,
      "36287": true,
      "36288": true,
      "36289": true,
      "36290": true,
      "36291": true,
      "36292": true,
      "36293": true,
      "36294": true,
      "36295": true,
      "36296": true,
      "36297": true,
      "36298": true,
      "36299": true
    },
    "TARANDACUAO": {
      "38790": true,
      "38791": true,
      "38792": true,
      "38793": true,
      "38794": true,
      "38795": true,
      "38796": true,
      "38797": true,
      "38798": true,
      "38799": true
    },
    "URIANGATO": {
      "38980": true,
      "38981": true,
      "38982": true,
      "38983": true,
      "38984": true,
      "38985": true,
      "38986": true,
      "38987": true,
      "38988": true,
      "38989": true
    },
    "VALLE DE SANTIAGO": {
      "38400": true,
      "38401": true,
      "38402": true,
      "38403": true,
      "38404": true,
      "38405": true,
      "38406": true,
      "38407": true,
      "38408": true,
      "38409": true,
      "38410": true,
      "38411": true,
      "38412": true,
      "38413": true,
      "38414": true,
      "38415": true,
      "38416": true,
      "38417": true,
      "38418": true,
      "38419": true,
      "38420": true,
      "38421": true,
      "38422": true,
      "38423": true,
      "38424": true,
      "38425": true,
      "38426": true,
      "38427": true,
      "38428": true,
      "38429": true,
      "38430": true,
      "38431": true,
      "38432": true,
      "38434": true,
      "38435": true,
      "38440": true,
      "38441": true,
      "38442": true,
      "38443": true,
      "38444": true,
      "38446": true,
      "38447": true,
      "38448": true,
      "38449": true,
      "38450": true,
      "38451": true,
      "38452": true,
      "38453": true,
      "38455": true,
      "38456": true,
      "38457": true,
      "38458": true,
      "38459": true,
      "38460": true,
      "38461": true,
      "38462": true,
      "38464": true
    },
    "VILLAGRAN": {
      "38260": true,
      "38261": true,
      "38262": true,
      "38263": true,
      "38264": true,
      "38265": true,
      "38266": true,
      "38267": true,
      "38268": true,
      "38269": true,
      "38270": true,
      "38271": true,
      "38272": true,
      "38273": true,
      "38274": true,
      "38275": true,
      "38276": true,
      "38277": true,
      "38278": true,
      "38279": true,
      "38280": true,
      "38281": true,
      "38282": true,
      "38283": true,
      "38284": true,
      "38285": true,
      "38286": true,
      "38287": true,
      "38288": true,
      "38289": true,
      "38290": true,
      "38291": true,
      "38292": true,
      "38293": true,
      "38294": true,
      "38295": true,
      "38296": true,
      "38297": true,
      "38298": true,
      "38299": true
    },
    "YURIRIA": {
      "38940": true,
      "38941": true,
      "38942": true,
      "38943": true,
      "38944": true,
      "38945": true,
      "38946": true,
      "38947": true,
      "38948": true,
      "38949": true,
      "38950": true,
      "38951": true,
      "38952": true,
      "38953": true,
      "38954": true,
      "38955": true,
      "38956": true,
      "38957": true,
      "38960": true,
      "38961": true,
      "38962": true,
      "38963": true,
      "38964": true,
      "38965": true,
      "38966": true,
      "38967": true,
      "38968": true,
      "38969": true
    }
  },
  "GUERRERO": {
    "ACAPULCO DE JUAREZ": {
      "39300": true,
      "39301": true,
      "39302": true,
      "39303": true,
      "39304": true,
      "39305": true,
      "39306": true,
      "39307": true,
      "39308": true,
      "39309": true,
      "39310": true,
      "39311": true,
      "39312": true,
      "39313": true,
      "39314": true,
      "39315": true,
      "39316": true,
      "39317": true,
      "39318": true,
      "39319": true,
      "39320": true,
      "39321": true,
      "39322": true,
      "39323": true,
      "39324": true,
      "39325": true,
      "39326": true,
      "39327": true,
      "39328": true,
      "39329": true,
      "39330": true,
      "39331": true,
      "39332": true,
      "39333": true,
      "39334": true,
      "39335": true,
      "39336": true,
      "39337": true,
      "39338": true,
      "39339": true,
      "39340": true,
      "39341": true,
      "39342": true,
      "39343": true,
      "39344": true,
      "39345": true,
      "39346": true,
      "39347": true,
      "39348": true,
      "39349": true,
      "39350": true,
      "39351": true,
      "39352": true,
      "39353": true,
      "39354": true,
      "39355": true,
      "39356": true,
      "39357": true,
      "39358": true,
      "39359": true,
      "39360": true,
      "39361": true,
      "39362": true,
      "39363": true,
      "39364": true,
      "39365": true,
      "39366": true,
      "39367": true,
      "39368": true,
      "39369": true,
      "39370": true,
      "39371": true,
      "39372": true,
      "39373": true,
      "39374": true,
      "39375": true,
      "39376": true,
      "39377": true,
      "39378": true,
      "39379": true,
      "39380": true,
      "39381": true,
      "39382": true,
      "39383": true,
      "39384": true,
      "39385": true,
      "39386": true,
      "39387": true,
      "39388": true,
      "39389": true,
      "39390": true,
      "39391": true,
      "39392": true,
      "39393": true,
      "39394": true,
      "39395": true,
      "39396": true,
      "39397": true,
      "39398": true,
      "39399": true,
      "39400": true,
      "39401": true,
      "39402": true,
      "39403": true,
      "39404": true,
      "39405": true,
      "39406": true,
      "39407": true,
      "39408": true,
      "39409": true,
      "39410": true,
      "39411": true,
      "39412": true,
      "39413": true,
      "39414": true,
      "39415": true,
      "39416": true,
      "39417": true,
      "39418": true,
      "39419": true,
      "39420": true,
      "39421": true,
      "39422": true,
      "39423": true,
      "39424": true,
      "39425": true,
      "39426": true,
      "39427": true,
      "39428": true,
      "39429": true,
      "39430": true,
      "39431": true,
      "39432": true,
      "39433": true,
      "39434": true,
      "39435": true,
      "39436": true,
      "39437": true,
      "39438": true,
      "39439": true,
      "39440": true,
      "39441": true,
      "39442": true,
      "39443": true,
      "39444": true,
      "39445": true,
      "39446": true,
      "39447": true,
      "39448": true,
      "39449": true,
      "39450": true,
      "39451": true,
      "39452": true,
      "39453": true,
      "39454": true,
      "39455": true,
      "39456": true,
      "39457": true,
      "39458": true,
      "39459": true,
      "39460": true,
      "39461": true,
      "39462": true,
      "39463": true,
      "39464": true,
      "39465": true,
      "39466": true,
      "39467": true,
      "39468": true,
      "39469": true,
      "39470": true,
      "39471": true,
      "39472": true,
      "39473": true,
      "39474": true,
      "39475": true,
      "39476": true,
      "39477": true,
      "39478": true,
      "39479": true,
      "39480": true,
      "39481": true,
      "39482": true,
      "39483": true,
      "39484": true,
      "39485": true,
      "39486": true,
      "39487": true,
      "39488": true,
      "39489": true,
      "39490": true,
      "39491": true,
      "39492": true,
      "39493": true,
      "39494": true,
      "39495": true,
      "39496": true,
      "39497": true,
      "39498": true,
      "39499": true,
      "39500": true,
      "39501": true,
      "39502": true,
      "39503": true,
      "39504": true,
      "39505": true,
      "39506": true,
      "39507": true,
      "39508": true,
      "39509": true,
      "39510": true,
      "39528": true,
      "39529": true,
      "39530": true,
      "39531": true,
      "39532": true,
      "39533": true,
      "39534": true,
      "39535": true,
      "39536": true,
      "39537": true,
      "39538": true,
      "39539": true,
      "39540": true,
      "39541": true,
      "39542": true,
      "39543": true,
      "39544": true,
      "39545": true,
      "39546": true,
      "39547": true,
      "39548": true,
      "39549": true,
      "39550": true,
      "39551": true,
      "39552": true,
      "39553": true,
      "39554": true,
      "39555": true,
      "39556": true,
      "39557": true,
      "39558": true,
      "39559": true,
      "39560": true,
      "39561": true,
      "39562": true,
      "39563": true,
      "39564": true,
      "39565": true,
      "39566": true,
      "39567": true,
      "39568": true,
      "39569": true,
      "39570": true,
      "39571": true,
      "39572": true,
      "39573": true,
      "39574": true,
      "39575": true,
      "39576": true,
      "39577": true,
      "39578": true,
      "39579": true,
      "39580": true,
      "39581": true,
      "39582": true,
      "39583": true,
      "39584": true,
      "39585": true,
      "39586": true,
      "39587": true,
      "39588": true,
      "39589": true,
      "39590": true,
      "39591": true,
      "39592": true,
      "39593": true,
      "39594": true,
      "39595": true,
      "39596": true,
      "39597": true,
      "39598": true,
      "39599": true,
      "39600": true,
      "39601": true,
      "39602": true,
      "39603": true,
      "39604": true,
      "39605": true,
      "39606": true,
      "39607": true,
      "39608": true,
      "39609": true,
      "39610": true,
      "39611": true,
      "39612": true,
      "39613": true,
      "39614": true,
      "39615": true,
      "39616": true,
      "39617": true,
      "39618": true,
      "39619": true,
      "39620": true,
      "39621": true,
      "39622": true,
      "39623": true,
      "39624": true,
      "39625": true,
      "39626": true,
      "39627": true,
      "39628": true,
      "39629": true,
      "39630": true,
      "39631": true,
      "39632": true,
      "39633": true,
      "39634": true,
      "39635": true,
      "39636": true,
      "39637": true,
      "39638": true,
      "39639": true,
      "39640": true,
      "39641": true,
      "39642": true,
      "39643": true,
      "39644": true,
      "39645": true,
      "39646": true,
      "39647": true,
      "39648": true,
      "39649": true,
      "39650": true,
      "39651": true,
      "39652": true,
      "39653": true,
      "39654": true,
      "39655": true,
      "39656": true,
      "39657": true,
      "39658": true,
      "39659": true,
      "39660": true,
      "39661": true,
      "39662": true,
      "39663": true,
      "39664": true,
      "39665": true,
      "39666": true,
      "39667": true,
      "39668": true,
      "39669": true,
      "39670": true,
      "39671": true,
      "39672": true,
      "39673": true,
      "39674": true,
      "39675": true,
      "39676": true,
      "39677": true,
      "39678": true,
      "39679": true,
      "39680": true,
      "39681": true,
      "39682": true,
      "39683": true,
      "39684": true,
      "39685": true,
      "39686": true,
      "39687": true,
      "39688": true,
      "39689": true,
      "39690": true,
      "39691": true,
      "39692": true,
      "39693": true,
      "39694": true,
      "39695": true,
      "39696": true,
      "39697": true,
      "39698": true,
      "39699": true,
      "39700": true,
      "39701": true,
      "39702": true,
      "39703": true,
      "39704": true,
      "39705": true,
      "39706": true,
      "39707": true,
      "39708": true,
      "39709": true,
      "39710": true,
      "39711": true,
      "39712": true,
      "39713": true,
      "39714": true,
      "39715": true,
      "39716": true,
      "39717": true,
      "39718": true,
      "39719": true,
      "39720": true,
      "39721": true,
      "39722": true,
      "39723": true,
      "39724": true,
      "39725": true,
      "39726": true,
      "39727": true,
      "39728": true,
      "39729": true,
      "39730": true,
      "39731": true,
      "39732": true,
      "39733": true,
      "39734": true,
      "39735": true,
      "39736": true,
      "39737": true,
      "39738": true,
      "39739": true,
      "39740": true,
      "39741": true,
      "39742": true,
      "39743": true,
      "39744": true,
      "39745": true,
      "39746": true,
      "39747": true,
      "39748": true,
      "39749": true,
      "39750": true,
      "39751": true,
      "39752": true,
      "39753": true,
      "39754": true,
      "39755": true,
      "39756": true,
      "39757": true,
      "39758": true,
      "39759": true,
      "39760": true,
      "39761": true,
      "39762": true,
      "39763": true,
      "39764": true,
      "39765": true,
      "39766": true,
      "39767": true,
      "39768": true,
      "39769": true,
      "39770": true,
      "39771": true,
      "39772": true,
      "39773": true,
      "39774": true,
      "39775": true,
      "39776": true,
      "39777": true,
      "39778": true,
      "39779": true,
      "39780": true,
      "39781": true,
      "39782": true,
      "39783": true,
      "39784": true,
      "39785": true,
      "39786": true,
      "39787": true,
      "39788": true,
      "39789": true,
      "39790": true,
      "39791": true,
      "39792": true,
      "39793": true,
      "39794": true,
      "39795": true,
      "39796": true,
      "39797": true,
      "39798": true,
      "39799": true,
      "39800": true,
      "39801": true,
      "39802": true,
      "39803": true,
      "39804": true,
      "39805": true,
      "39806": true,
      "39807": true,
      "39808": true,
      "39809": true,
      "39810": true,
      "39811": true,
      "39812": true,
      "39813": true,
      "39814": true,
      "39815": true,
      "39816": true,
      "39817": true,
      "39818": true,
      "39819": true,
      "39820": true,
      "39821": true,
      "39822": true,
      "39823": true,
      "39824": true,
      "39825": true,
      "39826": true,
      "39827": true,
      "39828": true,
      "39829": true,
      "39830": true,
      "39831": true,
      "39832": true,
      "39833": true,
      "39834": true,
      "39835": true,
      "39836": true,
      "39837": true,
      "39838": true,
      "39839": true,
      "39840": true,
      "39841": true,
      "39842": true,
      "39843": true,
      "39844": true,
      "39845": true,
      "39846": true,
      "39847": true,
      "39848": true,
      "39849": true,
      "39850": true,
      "39851": true,
      "39852": true,
      "39853": true,
      "39854": true,
      "39855": true,
      "39856": true,
      "39857": true,
      "39858": true,
      "39859": true,
      "39860": true,
      "39861": true,
      "39862": true,
      "39863": true,
      "39864": true,
      "39865": true,
      "39866": true,
      "39867": true,
      "39868": true,
      "39869": true,
      "39870": true,
      "39871": true,
      "39872": true,
      "39873": true,
      "39874": true,
      "39875": true,
      "39876": true,
      "39877": true,
      "39878": true,
      "39879": true,
      "39880": true,
      "39881": true,
      "39882": true,
      "39883": true,
      "39884": true,
      "39885": true,
      "39886": true,
      "39887": true,
      "39888": true,
      "39889": true,
      "39890": true,
      "39891": true,
      "39892": true,
      "39893": true,
      "39894": true,
      "39895": true,
      "39896": true,
      "39897": true,
      "39898": true,
      "39899": true,
      "39900": true,
      "39901": true,
      "39902": true,
      "39903": true,
      "39904": true,
      "39905": true,
      "39906": true,
      "39907": true,
      "39908": true,
      "39909": true,
      "39910": true,
      "39911": true,
      "39912": true,
      "39913": true,
      "39914": true,
      "39915": true,
      "39916": true,
      "39917": true,
      "39918": true,
      "39919": true,
      "39920": true,
      "39921": true,
      "39922": true,
      "39923": true,
      "39924": true,
      "39925": true,
      "39926": true,
      "39927": true,
      "39928": true,
      "39929": true,
      "39930": true,
      "39931": true,
      "39932": true,
      "39933": true,
      "39934": true,
      "39935": true,
      "39936": true,
      "39937": true,
      "39938": true,
      "39939": true
    },
    "ATOYAC DE ALVAREZ": {
      "40930": true,
      "40931": true,
      "40932": true,
      "40933": true,
      "40934": true,
      "40935": true,
      "40936": true,
      "40937": true,
      "40938": true,
      "40939": true,
      "40941": true,
      "40942": true,
      "40947": true,
      "40948": true,
      "40949": true,
      "40952": true,
      "40955": true
    },
    "AYUTLA DE LOS LIBRES": {
      "39200": true,
      "39201": true,
      "39202": true,
      "39203": true,
      "39204": true,
      "39205": true,
      "39207": true,
      "39208": true,
      "39212": true,
      "39213": true,
      "39215": true,
      "39217": true,
      "39220": true,
      "39221": true,
      "39222": true,
      "39223": true,
      "39225": true
    },
    "BENITO JUÁREZ": {
      "40960": true,
      "40961": true,
      "40962": true,
      "40963": true,
      "40964": true,
      "40965": true,
      "40966": true,
      "40967": true,
      "40968": true,
      "40969": true
    },
    "BUENAVISTA DE CUELLAR": {
      "40330": true,
      "40331": true,
      "40332": true,
      "40333": true,
      "40334": true,
      "40335": true,
      "40336": true,
      "40337": true,
      "40338": true,
      "40339": true,
      "40341": true,
      "40342": true,
      "40343": true,
      "40344": true,
      "40345": true,
      "40346": true,
      "40348": true,
      "40349": true,
      "40350": true,
      "40351": true,
      "40352": true,
      "40353": true,
      "40354": true,
      "40355": true,
      "40356": true,
      "40357": true,
      "40358": true,
      "40359": true
    },
    "CHILAPA DE ALVAREZ": {
      "41100": true,
      "41101": true,
      "41102": true,
      "41103": true,
      "41104": true,
      "41105": true,
      "41106": true,
      "41107": true,
      "41108": true,
      "41109": true,
      "41110": true,
      "41111": true,
      "41112": true,
      "41113": true,
      "41114": true,
      "41115": true,
      "41118": true,
      "41119": true
    },
    "CHILPANCINGO DE LOS BRAVO": {
      "39000": true,
      "39001": true,
      "39002": true,
      "39003": true,
      "39004": true,
      "39005": true,
      "39006": true,
      "39007": true,
      "39008": true,
      "39009": true,
      "39010": true,
      "39011": true,
      "39012": true,
      "39013": true,
      "39014": true,
      "39015": true,
      "39016": true,
      "39017": true,
      "39018": true,
      "39019": true,
      "39020": true,
      "39021": true,
      "39022": true,
      "39023": true,
      "39024": true,
      "39025": true,
      "39026": true,
      "39027": true,
      "39028": true,
      "39029": true,
      "39030": true,
      "39031": true,
      "39032": true,
      "39033": true,
      "39034": true,
      "39035": true,
      "39036": true,
      "39037": true,
      "39038": true,
      "39039": true,
      "39040": true,
      "39041": true,
      "39042": true,
      "39043": true,
      "39044": true,
      "39045": true,
      "39046": true,
      "39047": true,
      "39048": true,
      "39049": true,
      "39050": true,
      "39051": true,
      "39052": true,
      "39053": true,
      "39054": true,
      "39055": true,
      "39056": true,
      "39057": true,
      "39058": true,
      "39059": true,
      "39060": true,
      "39061": true,
      "39062": true,
      "39063": true,
      "39064": true,
      "39065": true,
      "39066": true,
      "39067": true,
      "39068": true,
      "39069": true,
      "39070": true,
      "39071": true,
      "39072": true,
      "39073": true,
      "39074": true,
      "39075": true,
      "39076": true,
      "39077": true,
      "39078": true,
      "39079": true,
      "39080": true,
      "39081": true,
      "39082": true,
      "39083": true,
      "39084": true,
      "39085": true,
      "39086": true,
      "39087": true,
      "39088": true,
      "39089": true,
      "39090": true,
      "39091": true,
      "39092": true,
      "39093": true,
      "39094": true,
      "39095": true,
      "39096": true,
      "39097": true,
      "39098": true,
      "39099": true,
      "39100": true,
      "39101": true,
      "39102": true,
      "39103": true,
      "39104": true,
      "39105": true,
      "39106": true,
      "39107": true,
      "39108": true,
      "39109": true,
      "39110": true,
      "39111": true,
      "39112": true,
      "39113": true,
      "39114": true,
      "39115": true,
      "39116": true,
      "39117": true,
      "39118": true,
      "39119": true,
      "39120": true,
      "39121": true,
      "39122": true,
      "39123": true,
      "39124": true,
      "39125": true,
      "39126": true,
      "39127": true,
      "39128": true,
      "39129": true
    },
    "COCULA": {
      "40580": true,
      "40582": true,
      "40583": true,
      "40584": true,
      "40585": true,
      "40586": true,
      "40587": true,
      "40588": true,
      "40589": true,
      "40590": true,
      "40598": true,
      "40599": true
    },
    "COYUCA DE BENITEZ": {
      "40970": true,
      "40971": true,
      "40972": true,
      "40973": true,
      "40974": true,
      "40975": true,
      "40976": true,
      "40977": true,
      "40978": true,
      "40979": true,
      "40980": true,
      "40982": true,
      "40983": true,
      "40984": true,
      "40985": true,
      "40986": true,
      "40987": true,
      "40988": true,
      "40989": true
    },
    "EDUARDO NERI": {
      "40180": true,
      "40181": true,
      "40182": true,
      "40183": true,
      "40184": true,
      "40185": true,
      "40186": true,
      "40187": true,
      "40188": true,
      "40189": true,
      "40190": true,
      "40191": true,
      "40192": true,
      "40193": true,
      "40194": true,
      "40195": true,
      "40196": true,
      "40197": true,
      "40198": true,
      "40199": true
    },
    "HUITZUCO DE LOS FIGUEROA": {
      "40130": true,
      "40131": true,
      "40132": true,
      "40133": true,
      "40134": true,
      "40135": true,
      "40136": true,
      "40141": true,
      "40142": true
    },
    "IGUALA DE LA INDEPENDENCIA": {
      "40000": true,
      "40001": true,
      "40002": true,
      "40003": true,
      "40004": true,
      "40005": true,
      "40006": true,
      "40007": true,
      "40008": true,
      "40009": true,
      "40010": true,
      "40011": true,
      "40012": true,
      "40013": true,
      "40014": true,
      "40015": true,
      "40016": true,
      "40017": true,
      "40018": true,
      "40019": true,
      "40020": true,
      "40021": true,
      "40022": true,
      "40023": true,
      "40024": true,
      "40025": true,
      "40026": true,
      "40027": true,
      "40028": true,
      "40029": true,
      "40030": true,
      "40031": true,
      "40032": true,
      "40033": true,
      "40034": true,
      "40035": true,
      "40036": true,
      "40037": true,
      "40038": true,
      "40039": true,
      "40040": true,
      "40041": true,
      "40042": true,
      "40043": true,
      "40044": true,
      "40045": true,
      "40046": true,
      "40047": true,
      "40048": true,
      "40049": true,
      "40050": true,
      "40051": true,
      "40052": true,
      "40053": true,
      "40054": true,
      "40055": true,
      "40056": true,
      "40057": true,
      "40058": true,
      "40059": true,
      "40060": true,
      "40061": true,
      "40062": true,
      "40063": true,
      "40064": true,
      "40065": true,
      "40066": true,
      "40067": true,
      "40068": true,
      "40069": true,
      "40070": true,
      "40071": true,
      "40072": true,
      "40073": true,
      "40074": true,
      "40075": true,
      "40076": true,
      "40077": true,
      "40078": true,
      "40079": true,
      "40080": true,
      "40081": true,
      "40082": true,
      "40083": true,
      "40084": true,
      "40085": true,
      "40086": true,
      "40087": true,
      "40088": true,
      "40089": true,
      "40090": true,
      "40091": true,
      "40092": true,
      "40093": true,
      "40094": true,
      "40095": true,
      "40096": true,
      "40097": true,
      "40098": true,
      "40099": true,
      "40100": true,
      "40101": true,
      "40102": true,
      "40103": true,
      "40104": true,
      "40105": true,
      "40106": true,
      "40107": true,
      "40108": true,
      "40109": true,
      "40110": true,
      "40111": true,
      "40112": true,
      "40113": true,
      "40114": true,
      "40115": true,
      "40116": true,
      "40117": true
    },
    "JUAN R. ESCUDERO": {
      "39940": true,
      "39941": true,
      "39942": true,
      "39943": true,
      "39944": true,
      "39945": true,
      "39946": true,
      "39947": true,
      "39956": true,
      "39957": true,
      "39958": true,
      "39959": true
    },
    "MARTIR DE CUILAPAN": {
      "41180": true,
      "41181": true,
      "41182": true,
      "41183": true,
      "41184": true,
      "41185": true,
      "41186": true,
      "41187": true,
      "41188": true,
      "41189": true,
      "41191": true,
      "41192": true,
      "41193": true,
      "41194": true,
      "41195": true,
      "41196": true,
      "41197": true
    },
    "MOCHITLAN": {
      "39230": true,
      "39231": true,
      "39232": true,
      "39233": true,
      "39234": true,
      "39235": true,
      "39241": true,
      "39242": true,
      "39243": true,
      "39244": true,
      "39245": true,
      "39246": true,
      "39247": true,
      "39248": true
    },
    "OMETEPEC": {
      "41700": true,
      "41701": true,
      "41702": true,
      "41703": true,
      "41704": true,
      "41705": true,
      "41706": true,
      "41707": true,
      "41708": true,
      "41709": true,
      "41710": true,
      "41711": true,
      "41712": true,
      "41713": true,
      "41714": true,
      "41715": true,
      "41716": true,
      "41717": true,
      "41718": true,
      "41719": true,
      "41725": true,
      "41730": true,
      "41731": true,
      "41732": true,
      "41733": true,
      "41734": true,
      "41735": true
    },
    "PETATLAN": {
      "40830": true,
      "40831": true,
      "40832": true,
      "40833": true,
      "40837": true,
      "40838": true,
      "40839": true,
      "40840": true,
      "40841": true,
      "40842": true,
      "40847": true,
      "40848": true,
      "40849": true,
      "40850": true,
      "40851": true,
      "40852": true,
      "40853": true,
      "40854": true,
      "40855": true,
      "40856": true
    },
    "QUECHULTENANGO": {
      "39250": true,
      "39251": true,
      "39252": true,
      "39253": true,
      "39254": true,
      "39255": true,
      "39256": true,
      "39260": true,
      "39261": true,
      "39262": true,
      "39263": true
    },
    "SAN MARCOS": {
      "39960": true,
      "39961": true,
      "39964": true,
      "39965": true,
      "39966": true,
      "39968": true,
      "39969": true,
      "39970": true,
      "39971": true,
      "39972": true,
      "39973": true,
      "39974": true,
      "39975": true,
      "39976": true,
      "39977": true,
      "39978": true,
      "39979": true,
      "39980": true,
      "39981": true,
      "39982": true,
      "39983": true,
      "39985": true,
      "39989": true,
      "39990": true,
      "39991": true,
      "39992": true,
      "39993": true,
      "39994": true,
      "39995": true,
      "39996": true
    },
    "TAXCO DE ALARCON": {
      "40200": true,
      "40201": true,
      "40202": true,
      "40203": true,
      "40204": true,
      "40205": true,
      "40206": true,
      "40207": true,
      "40208": true,
      "40209": true,
      "40210": true,
      "40212": true,
      "40213": true,
      "40214": true,
      "40215": true,
      "40216": true,
      "40217": true,
      "40218": true,
      "40219": true,
      "40220": true,
      "40221": true,
      "40222": true,
      "40223": true,
      "40224": true,
      "40225": true,
      "40226": true,
      "40227": true,
      "40228": true,
      "40229": true,
      "40230": true,
      "40231": true,
      "40232": true,
      "40233": true,
      "40234": true,
      "40235": true,
      "40236": true,
      "40237": true,
      "40238": true,
      "40239": true,
      "40240": true,
      "40241": true,
      "40242": true,
      "40243": true,
      "40244": true,
      "40245": true,
      "40246": true,
      "40247": true,
      "40248": true,
      "40249": true,
      "40250": true,
      "40251": true,
      "40252": true,
      "40253": true,
      "40254": true,
      "40255": true,
      "40256": true,
      "40257": true,
      "40258": true,
      "40259": true,
      "40260": true,
      "40261": true,
      "40262": true,
      "40263": true,
      "40264": true,
      "40265": true,
      "40266": true,
      "40267": true,
      "40268": true,
      "40269": true,
      "40270": true,
      "40271": true,
      "40272": true,
      "40273": true,
      "40274": true,
      "40275": true,
      "40276": true,
      "40277": true,
      "40278": true,
      "40279": true,
      "40280": true,
      "40281": true,
      "40282": true,
      "40283": true,
      "40284": true,
      "40285": true,
      "40286": true,
      "40287": true,
      "40288": true,
      "40289": true,
      "40290": true,
      "40291": true,
      "40292": true,
      "40293": true,
      "40294": true,
      "40295": true,
      "40296": true,
      "40297": true,
      "40298": true,
      "40299": true,
      "40300": true,
      "40301": true,
      "40305": true,
      "40306": true,
      "40307": true,
      "40308": true,
      "40309": true,
      "40310": true,
      "40311": true,
      "40312": true,
      "40313": true,
      "40314": true,
      "40315": true,
      "40316": true,
      "40320": true,
      "40321": true,
      "40322": true,
      "40323": true,
      "40324": true,
      "40325": true,
      "40327": true,
      "40328": true,
      "40329": true
    },
    "TECOANAPA": {
      "39270": true,
      "39271": true,
      "39272": true,
      "39273": true,
      "39274": true,
      "39275": true,
      "39276": true,
      "39277": true,
      "39278": true,
      "39279": true,
      "39280": true,
      "39281": true,
      "39282": true,
      "39283": true,
      "39286": true,
      "39287": true,
      "39294": true,
      "39295": true,
      "39296": true,
      "39297": true,
      "39298": true,
      "39299": true
    },
    "TECPAN DE GALEANA": {
      "40900": true,
      "40901": true,
      "40902": true,
      "40903": true,
      "40904": true,
      "40905": true,
      "40906": true,
      "40907": true,
      "40908": true,
      "40913": true,
      "40914": true,
      "40922": true,
      "40923": true,
      "40924": true,
      "40925": true,
      "40926": true,
      "40927": true,
      "40928": true,
      "40929": true
    },
    "TELOLOAPAN": {
      "40400": true,
      "40401": true,
      "40402": true,
      "40406": true,
      "40410": true,
      "40411": true,
      "40413": true,
      "40418": true,
      "40419": true,
      "40420": true,
      "40421": true,
      "40422": true,
      "40425": true,
      "40428": true
    },
    "TEPECOACUILCO DE TRUJANO": {
      "40160": true,
      "40161": true,
      "40162": true,
      "40164": true,
      "40165": true,
      "40166": true,
      "40167": true,
      "40168": true,
      "40169": true,
      "40174": true,
      "40175": true,
      "40176": true,
      "40177": true,
      "40178": true,
      "40179": true
    },
    "TIXTLA DE GUERRERO": {
      "39170": true,
      "39171": true,
      "39172": true,
      "39173": true,
      "39174": true,
      "39175": true,
      "39176": true,
      "39177": true,
      "39179": true,
      "39180": true,
      "39181": true,
      "39182": true,
      "39183": true,
      "39184": true,
      "39185": true,
      "39186": true,
      "39187": true,
      "39188": true,
      "39189": true,
      "39193": true,
      "39194": true,
      "39195": true,
      "39196": true
    },
    "TLAPA DE COMONFORT": {
      "41300": true,
      "41301": true,
      "41302": true,
      "41303": true,
      "41304": true,
      "41305": true,
      "41306": true,
      "41307": true,
      "41308": true,
      "41309": true,
      "41320": true,
      "41321": true,
      "41322": true,
      "41323": true,
      "41324": true,
      "41325": true,
      "41326": true,
      "41327": true,
      "41328": true,
      "41329": true,
      "41330": true,
      "41347": true,
      "41349": true
    },
    "ZIHUATANEJO DE AZUETA": {
      "40880": true,
      "40881": true,
      "40882": true,
      "40883": true,
      "40884": true,
      "40886": true,
      "40887": true,
      "40888": true,
      "40889": true,
      "40890": true,
      "40891": true,
      "40893": true,
      "40894": true,
      "40895": true,
      "40896": true,
      "40897": true,
      "40898": true,
      "40899": true
    }
  },
  "HIDALGO": {
    "ALMOLOYA": {
      "43940": true,
      "43943": true,
      "43944": true,
      "43945": true,
      "43946": true,
      "43947": true,
      "43950": true,
      "43951": true,
      "43952": true,
      "43953": true,
      "43954": true,
      "43955": true,
      "43956": true,
      "43957": true,
      "43958": true,
      "43959": true
    },
    "APAN": {
      "43900": true,
      "43901": true,
      "43902": true,
      "43903": true,
      "43904": true,
      "43905": true,
      "43906": true,
      "43907": true,
      "43908": true,
      "43909": true,
      "43910": true,
      "43911": true,
      "43912": true,
      "43913": true,
      "43914": true,
      "43915": true,
      "43916": true,
      "43917": true,
      "43918": true,
      "43920": true,
      "43921": true,
      "43922": true,
      "43923": true,
      "43924": true,
      "43925": true,
      "43926": true,
      "43927": true,
      "43928": true,
      "43929": true
    },
    "ATOTONILCO DE TULA": {
      "42980": true,
      "42981": true,
      "42982": true,
      "42983": true,
      "42984": true,
      "42985": true,
      "42986": true,
      "42987": true,
      "42988": true,
      "42989": true,
      "42990": true,
      "42991": true,
      "42992": true,
      "42993": true,
      "42994": true,
      "42995": true,
      "42996": true,
      "42997": true,
      "42998": true,
      "42999": true
    },
    "ATOTONILCO EL GRANDE": {
      "43300": true,
      "43301": true,
      "43302": true,
      "43303": true,
      "43304": true,
      "43305": true,
      "43306": true,
      "43307": true,
      "43308": true,
      "43309": true,
      "43310": true,
      "43313": true,
      "43314": true,
      "43315": true,
      "43316": true,
      "43317": true,
      "43318": true,
      "43319": true,
      "43320": true,
      "43321": true,
      "43322": true,
      "43324": true,
      "43325": true,
      "43328": true
    },
    "EL ARENAL": {
      "42680": true,
      "42681": true,
      "42682": true,
      "42683": true,
      "42684": true,
      "42685": true,
      "42686": true,
      "42687": true,
      "42688": true,
      "42689": true,
      "42690": true,
      "42691": true,
      "42692": true,
      "42693": true,
      "42694": true,
      "42695": true,
      "42696": true,
      "42697": true,
      "42698": true,
      "42699": true
    },
    "EMILIANO ZAPATA": {
      "43960": true,
      "43961": true,
      "43962": true,
      "43963": true,
      "43964": true,
      "43965": true,
      "43966": true,
      "43967": true,
      "43968": true,
      "43969": true
    },
    "FRANCISCO I. MADERO": {
      "42660": true,
      "42661": true,
      "42662": true,
      "42663": true,
      "42664": true,
      "42665": true,
      "42666": true,
      "42667": true,
      "42668": true,
      "42669": true,
      "42670": true,
      "42671": true,
      "42672": true,
      "42673": true,
      "42674": true,
      "42675": true,
      "42676": true,
      "42677": true,
      "42678": true,
      "42679": true
    },
    "HUASCA DE OCAMPO": {
      "43500": true,
      "43501": true,
      "43503": true,
      "43504": true,
      "43510": true,
      "43511": true,
      "43512": true,
      "43513": true,
      "43514": true,
      "43515": true,
      "43516": true,
      "43517": true,
      "43518": true,
      "43519": true,
      "43520": true,
      "43521": true,
      "43522": true,
      "43525": true,
      "43526": true
    },
    "HUEJUTLA DE REYES": {
      "43000": true,
      "43001": true,
      "43002": true,
      "43004": true,
      "43005": true,
      "43006": true,
      "43007": true,
      "43008": true,
      "43009": true,
      "43011": true,
      "43012": true,
      "43013": true,
      "43014": true,
      "43015": true,
      "43016": true,
      "43018": true,
      "43019": true
    },
    "IXMIQUILPAN": {
      "42300": true,
      "42301": true,
      "42302": true,
      "42303": true,
      "42304": true,
      "42305": true,
      "42306": true,
      "42307": true,
      "42308": true,
      "42309": true,
      "42310": true,
      "42311": true,
      "42312": true,
      "42313": true,
      "42314": true,
      "42315": true,
      "42320": true,
      "42321": true,
      "42322": true,
      "42323": true,
      "42324": true,
      "42325": true,
      "42326": true,
      "42327": true,
      "42328": true,
      "42329": true
    },
    "METZTITLAN": {
      "43350": true,
      "43351": true,
      "43352": true,
      "43353": true,
      "43354": true,
      "43355": true,
      "43356": true,
      "43357": true,
      "43358": true,
      "43360": true,
      "43361": true,
      "43362": true,
      "43363": true,
      "43370": true,
      "43371": true,
      "43372": true,
      "43374": true
    },
    "MINERAL DE LA REFORMA": {
      "42180": true,
      "42181": true,
      "42182": true,
      "42183": true,
      "42184": true,
      "42185": true,
      "42186": true,
      "42187": true,
      "42188": true,
      "42189": true
    },
    "MINERAL DEL MONTE": {
      "42130": true,
      "42131": true,
      "42132": true,
      "42133": true,
      "42134": true,
      "42135": true,
      "42136": true,
      "42137": true,
      "42138": true,
      "42139": true,
      "42140": true,
      "42141": true,
      "42142": true,
      "42143": true,
      "42144": true,
      "42145": true,
      "42146": true,
      "42147": true,
      "42148": true,
      "42149": true
    },
    "MIXQUIAHUALA DE JUAREZ": {
      "42700": true,
      "42701": true,
      "42702": true,
      "42703": true,
      "42704": true,
      "42705": true,
      "42706": true,
      "42707": true,
      "42708": true,
      "42709": true,
      "42710": true,
      "42711": true,
      "42712": true,
      "42713": true,
      "42714": true,
      "42715": true,
      "42716": true,
      "42717": true,
      "42718": true,
      "42719": true,
      "42720": true,
      "42721": true,
      "42722": true,
      "42723": true,
      "42724": true,
      "42725": true,
      "42726": true,
      "42727": true,
      "42728": true,
      "42729": true
    },
    "OMITLAN DE JUAREZ": {
      "43560": true,
      "43561": true,
      "43562": true,
      "43563": true,
      "43564": true,
      "43565": true,
      "43566": true,
      "43567": true,
      "43568": true,
      "43569": true,
      "43570": true,
      "43571": true,
      "43572": true,
      "43573": true,
      "43574": true,
      "43575": true,
      "43576": true,
      "43577": true,
      "43578": true,
      "43579": true
    },
    "PACHUCA DE SOTO": {
      "42000": true,
      "42001": true,
      "42002": true,
      "42003": true,
      "42004": true,
      "42005": true,
      "42006": true,
      "42007": true,
      "42008": true,
      "42009": true,
      "42010": true,
      "42011": true,
      "42012": true,
      "42013": true,
      "42014": true,
      "42015": true,
      "42016": true,
      "42017": true,
      "42018": true,
      "42019": true,
      "42020": true,
      "42021": true,
      "42022": true,
      "42023": true,
      "42024": true,
      "42025": true,
      "42026": true,
      "42027": true,
      "42028": true,
      "42029": true,
      "42030": true,
      "42031": true,
      "42032": true,
      "42033": true,
      "42034": true,
      "42035": true,
      "42036": true,
      "42037": true,
      "42038": true,
      "42039": true,
      "42040": true,
      "42041": true,
      "42042": true,
      "42043": true,
      "42044": true,
      "42045": true,
      "42046": true,
      "42047": true,
      "42048": true,
      "42049": true,
      "42050": true,
      "42051": true,
      "42052": true,
      "42053": true,
      "42054": true,
      "42055": true,
      "42056": true,
      "42057": true,
      "42058": true,
      "42059": true,
      "42060": true,
      "42061": true,
      "42062": true,
      "42063": true,
      "42064": true,
      "42065": true,
      "42066": true,
      "42067": true,
      "42068": true,
      "42069": true,
      "42070": true,
      "42071": true,
      "42072": true,
      "42073": true,
      "42074": true,
      "42075": true,
      "42076": true,
      "42077": true,
      "42078": true,
      "42079": true,
      "42080": true,
      "42081": true,
      "42082": true,
      "42083": true,
      "42084": true,
      "42085": true,
      "42086": true,
      "42087": true,
      "42088": true,
      "42089": true,
      "42090": true,
      "42091": true,
      "42092": true,
      "42093": true,
      "42094": true,
      "42095": true,
      "42096": true,
      "42097": true,
      "42098": true,
      "42099": true,
      "42100": true,
      "42101": true,
      "42102": true,
      "42103": true,
      "42104": true,
      "42105": true,
      "42106": true,
      "42107": true,
      "42108": true,
      "42109": true,
      "42110": true,
      "42111": true,
      "42112": true,
      "42113": true,
      "42114": true,
      "42115": true,
      "42116": true,
      "42117": true,
      "42118": true,
      "42119": true,
      "42180": true,
      "42181": true,
      "42182": true,
      "42184": true,
      "42185": true,
      "42186": true,
      "42187": true
    },
    "PROGRESO DE OBREGON": {
      "42730": true,
      "42731": true,
      "42732": true,
      "42733": true,
      "42734": true,
      "42735": true,
      "42736": true,
      "42737": true,
      "42738": true,
      "42739": true,
      "42740": true,
      "42741": true,
      "42742": true,
      "42743": true,
      "42744": true,
      "42745": true,
      "42746": true,
      "42747": true,
      "42748": true,
      "42749": true
    },
    "SAN AGUSTIN METZQUITITLAN": {
      "43380": true,
      "43381": true,
      "43382": true,
      "43383": true,
      "43384": true,
      "43385": true,
      "43386": true,
      "43387": true,
      "43388": true,
      "43389": true,
      "43391": true
    },
    "SAN AGUSTIN TLAXIACA": {
      "42160": true,
      "42161": true,
      "42162": true,
      "42163": true,
      "42164": true,
      "42165": true,
      "42166": true,
      "42167": true,
      "42168": true,
      "42169": true,
      "42170": true,
      "42171": true,
      "42172": true,
      "42173": true,
      "42174": true,
      "42175": true,
      "42176": true,
      "42177": true,
      "42178": true,
      "42179": true
    },
    "SINGUILUCAN": {
      "43780": true,
      "43781": true,
      "43782": true,
      "43783": true,
      "43784": true,
      "43785": true,
      "43786": true,
      "43787": true,
      "43788": true,
      "43789": true,
      "43790": true,
      "43791": true,
      "43792": true,
      "43793": true,
      "43794": true,
      "43795": true,
      "43796": true,
      "43797": true,
      "43798": true,
      "43799": true
    },
    "TEPEAPULCO": {
      "43970": true,
      "43971": true,
      "43972": true,
      "43973": true,
      "43974": true,
      "43975": true,
      "43976": true,
      "43977": true,
      "43978": true,
      "43979": true,
      "43980": true,
      "43981": true,
      "43982": true,
      "43983": true,
      "43985": true,
      "43986": true,
      "43987": true,
      "43988": true,
      "43989": true,
      "43990": true,
      "43991": true,
      "43992": true,
      "43993": true,
      "43994": true,
      "43995": true,
      "43996": true,
      "43997": true,
      "43998": true,
      "43999": true
    },
    "TEPEJI DEL RIO DE OCAMPO": {
      "42852": true,
      "42853": true,
      "42854": true,
      "42855": true,
      "42856": true,
      "42857": true,
      "42858": true,
      "42859": true,
      "42860": true,
      "42861": true,
      "42862": true,
      "42863": true,
      "42864": true,
      "42865": true,
      "42866": true,
      "42867": true,
      "42868": true,
      "42869": true,
      "42870": true,
      "42871": true,
      "42872": true,
      "42873": true,
      "42874": true,
      "42875": true,
      "42876": true,
      "42877": true,
      "42878": true,
      "42879": true,
      "42880": true,
      "42881": true,
      "42882": true,
      "42883": true,
      "42884": true,
      "42885": true,
      "42886": true,
      "42887": true,
      "42888": true,
      "42889": true,
      "42890": true,
      "42891": true,
      "42892": true,
      "42893": true,
      "42894": true,
      "42895": true,
      "42896": true,
      "42897": true,
      "42898": true,
      "42899": true
    },
    "TETEPANGO": {
      "42940": true,
      "42941": true,
      "42942": true,
      "42943": true,
      "42944": true,
      "42945": true,
      "42946": true,
      "42947": true,
      "42948": true,
      "42949": true
    },
    "TLANALAPA": {
      "43930": true,
      "43931": true,
      "43932": true,
      "43933": true,
      "43934": true,
      "43935": true,
      "43936": true,
      "43937": true,
      "43938": true,
      "43939": true
    },
    "TULA DE ALLENDE": {
      "42800": true,
      "42801": true,
      "42802": true,
      "42803": true,
      "42804": true,
      "42805": true,
      "42806": true,
      "42807": true,
      "42808": true,
      "42809": true,
      "42810": true,
      "42811": true,
      "42812": true,
      "42813": true,
      "42814": true,
      "42815": true,
      "42816": true,
      "42817": true,
      "42818": true,
      "42819": true,
      "42820": true,
      "42821": true,
      "42822": true,
      "42823": true,
      "42824": true,
      "42825": true,
      "42826": true,
      "42827": true,
      "42828": true,
      "42829": true,
      "42830": true,
      "42831": true,
      "42832": true,
      "42833": true,
      "42834": true,
      "42835": true,
      "42836": true,
      "42837": true,
      "42838": true,
      "42839": true,
      "42840": true,
      "42841": true,
      "42842": true,
      "42843": true,
      "42844": true,
      "42845": true,
      "42846": true,
      "42847": true,
      "42848": true,
      "42849": true,
      "42850": true,
      "42851": true
    },
    "TULANCINGO DE BRAVO": {
      "43600": true,
      "43601": true,
      "43602": true,
      "43603": true,
      "43604": true,
      "43605": true,
      "43606": true,
      "43607": true,
      "43608": true,
      "43609": true,
      "43610": true,
      "43611": true,
      "43612": true,
      "43613": true,
      "43614": true,
      "43615": true,
      "43616": true,
      "43617": true,
      "43618": true,
      "43619": true,
      "43620": true,
      "43621": true,
      "43622": true,
      "43623": true,
      "43624": true,
      "43625": true,
      "43626": true,
      "43627": true,
      "43628": true,
      "43629": true,
      "43630": true,
      "43631": true,
      "43632": true,
      "43633": true,
      "43634": true,
      "43635": true,
      "43636": true,
      "43637": true,
      "43638": true,
      "43639": true,
      "43640": true,
      "43641": true,
      "43642": true,
      "43643": true,
      "43644": true,
      "43645": true,
      "43646": true,
      "43647": true,
      "43648": true,
      "43649": true,
      "43650": true,
      "43651": true,
      "43652": true,
      "43653": true,
      "43654": true,
      "43655": true,
      "43656": true,
      "43657": true,
      "43658": true,
      "43659": true,
      "43660": true,
      "43661": true,
      "43662": true,
      "43663": true,
      "43664": true,
      "43665": true,
      "43666": true,
      "43667": true,
      "43668": true,
      "43669": true,
      "43670": true,
      "43671": true,
      "43672": true,
      "43673": true,
      "43674": true,
      "43675": true,
      "43676": true,
      "43677": true,
      "43678": true,
      "43679": true,
      "43680": true,
      "43681": true,
      "43682": true,
      "43683": true,
      "43684": true,
      "43685": true,
      "43686": true,
      "43687": true,
      "43688": true,
      "43689": true,
      "43690": true,
      "43691": true,
      "43692": true,
      "43693": true,
      "43694": true,
      "43695": true,
      "43696": true,
      "43697": true,
      "43698": true,
      "43699": true,
      "43700": true,
      "43701": true,
      "43702": true,
      "43703": true,
      "43704": true,
      "43705": true,
      "43706": true,
      "43707": true,
      "43708": true,
      "43709": true,
      "43710": true,
      "43711": true,
      "43712": true,
      "43715": true,
      "43716": true,
      "43717": true,
      "43718": true,
      "43719": true
    },
    "ZAPOTLAN DE JUAREZ": {
      "42190": true,
      "42191": true,
      "42192": true,
      "42193": true,
      "42194": true,
      "42195": true,
      "42196": true,
      "42197": true,
      "42198": true,
      "42199": true
    }
  },
  "JALISCO": {
    "ACATIC": {
      "45470": true,
      "45471": true,
      "45472": true,
      "45473": true,
      "45474": true,
      "45475": true,
      "45476": true,
      "45477": true,
      "45478": true,
      "45479": true
    },
    "ACATLAN DE JUAREZ": {
      "45700": true,
      "45701": true,
      "45702": true,
      "45703": true,
      "45704": true,
      "45705": true,
      "45706": true,
      "45707": true,
      "45708": true,
      "45709": true,
      "45710": true,
      "45711": true,
      "45712": true,
      "45713": true,
      "45714": true,
      "45715": true,
      "45716": true,
      "45717": true,
      "45718": true,
      "45719": true,
      "45720": true,
      "45721": true,
      "45722": true,
      "45723": true,
      "45724": true,
      "45725": true,
      "45726": true,
      "45727": true,
      "45728": true,
      "45729": true
    },
    "AHUALULCO DE MERCADO": {
      "46730": true,
      "46731": true,
      "46732": true,
      "46733": true,
      "46734": true,
      "46735": true,
      "46736": true,
      "46737": true,
      "46738": true,
      "46739": true,
      "46740": true,
      "46741": true,
      "46742": true,
      "46743": true,
      "46744": true,
      "46745": true,
      "46746": true,
      "46747": true,
      "46748": true,
      "46749": true,
      "46750": true,
      "46751": true,
      "46752": true,
      "46753": true,
      "46754": true,
      "46755": true,
      "46756": true,
      "46757": true,
      "46758": true,
      "46759": true
    },
    "AMATITAN": {
      "45380": true,
      "45381": true,
      "45382": true,
      "45383": true,
      "45384": true,
      "45385": true,
      "45386": true,
      "45387": true,
      "45388": true,
      "45389": true,
      "45390": true,
      "45391": true,
      "45392": true,
      "45393": true,
      "45394": true,
      "45395": true,
      "45396": true,
      "45397": true,
      "45398": true,
      "45399": true
    },
    "AMECA": {
      "46600": true,
      "46601": true,
      "46602": true,
      "46603": true,
      "46604": true,
      "46605": true,
      "46606": true,
      "46607": true,
      "46608": true,
      "46609": true,
      "46610": true,
      "46611": true,
      "46612": true,
      "46613": true,
      "46614": true,
      "46615": true,
      "46616": true,
      "46617": true,
      "46618": true,
      "46619": true,
      "46620": true,
      "46621": true,
      "46622": true,
      "46623": true,
      "46624": true,
      "46625": true,
      "46626": true,
      "46627": true,
      "46628": true,
      "46629": true,
      "46630": true,
      "46631": true,
      "46632": true,
      "46633": true,
      "46634": true,
      "46635": true,
      "46636": true,
      "46637": true,
      "46638": true,
      "46639": true,
      "46640": true,
      "46641": true,
      "46642": true,
      "46643": true,
      "46644": true,
      "46645": true,
      "46646": true,
      "46647": true,
      "46648": true,
      "46649": true,
      "46650": true,
      "46651": true,
      "46652": true,
      "46653": true,
      "46654": true,
      "46655": true,
      "46656": true,
      "46657": true,
      "46658": true,
      "46659": true,
      "46660": true,
      "46661": true,
      "46662": true,
      "46663": true,
      "46664": true,
      "46665": true,
      "46666": true,
      "46667": true,
      "46668": true,
      "46669": true,
      "46670": true,
      "46671": true,
      "46672": true,
      "46673": true,
      "46674": true,
      "46675": true,
      "46676": true,
      "46677": true,
      "46678": true,
      "46679": true,
      "46680": true,
      "46681": true,
      "46682": true,
      "46683": true,
      "46684": true,
      "46685": true,
      "46686": true,
      "46687": true,
      "46688": true,
      "46689": true,
      "46690": true,
      "46691": true,
      "46692": true,
      "46693": true,
      "46694": true,
      "46695": true,
      "46696": true,
      "46697": true,
      "46698": true,
      "46699": true,
      "46700": true,
      "46701": true,
      "46702": true,
      "46703": true,
      "46704": true,
      "46705": true,
      "46706": true,
      "46707": true,
      "46708": true,
      "46709": true,
      "46710": true,
      "46711": true,
      "46712": true,
      "46713": true,
      "46714": true,
      "46715": true,
      "46716": true,
      "46718": true,
      "46720": true,
      "46721": true,
      "46722": true,
      "46723": true,
      "46724": true,
      "46725": true,
      "46726": true,
      "46727": true,
      "46728": true,
      "46729": true
    },
    "ARANDAS": {
      "47180": true,
      "47181": true,
      "47182": true,
      "47183": true,
      "47184": true,
      "47185": true,
      "47186": true,
      "47187": true,
      "47188": true,
      "47189": true,
      "47196": true,
      "47197": true,
      "47198": true,
      "47199": true
    },
    "ATOTONILCO EL ALTO": {
      "47750": true,
      "47751": true,
      "47752": true,
      "47753": true,
      "47754": true,
      "47755": true,
      "47756": true,
      "47757": true,
      "47758": true,
      "47759": true,
      "47760": true,
      "47761": true,
      "47762": true,
      "47763": true,
      "47764": true,
      "47765": true,
      "47766": true,
      "47767": true,
      "47768": true,
      "47769": true,
      "47770": true,
      "47771": true,
      "47772": true,
      "47773": true,
      "47774": true,
      "47775": true,
      "47776": true,
      "47777": true,
      "47778": true,
      "47779": true
    },
    "AUTLAN DE NAVARRO": {
      "48900": true,
      "48901": true,
      "48902": true,
      "48903": true,
      "48904": true,
      "48905": true,
      "48906": true,
      "48907": true,
      "48908": true,
      "48909": true,
      "48910": true,
      "48911": true,
      "48912": true,
      "48913": true,
      "48914": true,
      "48915": true,
      "48916": true,
      "48917": true,
      "48918": true,
      "48919": true,
      "48920": true,
      "48921": true,
      "48922": true,
      "48923": true,
      "48924": true,
      "48925": true,
      "48926": true,
      "48927": true,
      "48928": true,
      "48929": true
    },
    "AYOTLAN": {
      "47930": true,
      "47931": true,
      "47932": true,
      "47933": true,
      "47934": true,
      "47935": true,
      "47936": true,
      "47938": true,
      "47940": true,
      "47941": true,
      "47942": true,
      "47943": true,
      "47944": true,
      "47945": true,
      "47947": true,
      "47948": true
    },
    "CABO CORRIENTES": {
      "48400": true,
      "48401": true,
      "48402": true,
      "48403": true,
      "48404": true,
      "48405": true,
      "48406": true,
      "48407": true,
      "48408": true,
      "48409": true,
      "48413": true,
      "48424": true,
      "48426": true,
      "48428": true,
      "48429": true,
      "48430": true,
      "48431": true,
      "48432": true,
      "48445": true,
      "48446": true,
      "48447": true,
      "48448": true,
      "48449": true
    },
    "CANADAS DE OBREGON": {
      "47360": true,
      "47361": true,
      "47362": true,
      "47363": true,
      "47364": true,
      "47365": true,
      "47366": true,
      "47367": true,
      "47369": true,
      "47370": true,
      "47371": true,
      "47372": true,
      "47373": true,
      "47374": true,
      "47375": true,
      "47376": true,
      "47377": true,
      "47378": true,
      "47379": true
    },
    "CASIMIRO CASTILLO": {
      "48930": true,
      "48931": true,
      "48932": true,
      "48933": true,
      "48934": true,
      "48935": true,
      "48936": true,
      "48937": true,
      "48938": true,
      "48939": true,
      "48940": true,
      "48941": true,
      "48942": true,
      "48943": true,
      "48944": true,
      "48945": true,
      "48946": true,
      "48947": true,
      "48948": true,
      "48949": true
    },
    "CHAPALA": {
      "45900": true,
      "45901": true,
      "45902": true,
      "45903": true,
      "45904": true,
      "45905": true,
      "45906": true,
      "45907": true,
      "45908": true,
      "45909": true,
      "45910": true,
      "45911": true,
      "45912": true,
      "45913": true,
      "45914": true,
      "45915": true,
      "45916": true,
      "45917": true,
      "45918": true,
      "45919": true,
      "45920": true,
      "45921": true,
      "45922": true,
      "45923": true,
      "45924": true,
      "45925": true,
      "45926": true,
      "45927": true,
      "45928": true,
      "45929": true,
      "45930": true,
      "45931": true,
      "45932": true,
      "45933": true,
      "45934": true,
      "45935": true,
      "45936": true,
      "45937": true,
      "45938": true,
      "45939": true,
      "45940": true,
      "45941": true,
      "45942": true,
      "45943": true,
      "45944": true,
      "45945": true,
      "45946": true,
      "45947": true,
      "45948": true,
      "45949": true
    },
    "CIHUATLAN": {
      "48970": true,
      "48971": true,
      "48972": true,
      "48973": true,
      "48974": true,
      "48975": true,
      "48976": true,
      "48977": true,
      "48978": true,
      "48979": true,
      "48980": true,
      "48981": true,
      "48982": true,
      "48983": true,
      "48984": true,
      "48985": true,
      "48987": true,
      "48988": true,
      "48990": true,
      "48991": true,
      "48992": true,
      "48993": true,
      "48994": true,
      "48995": true,
      "48996": true,
      "48997": true,
      "48998": true,
      "48999": true
    },
    "COCULA": {
      "48500": true,
      "48501": true,
      "48502": true,
      "48503": true,
      "48504": true,
      "48505": true,
      "48506": true,
      "48507": true,
      "48508": true,
      "48509": true,
      "48510": true,
      "48511": true,
      "48512": true,
      "48513": true,
      "48514": true,
      "48515": true,
      "48516": true,
      "48517": true,
      "48518": true,
      "48519": true,
      "48520": true,
      "48521": true,
      "48522": true,
      "48523": true,
      "48524": true,
      "48525": true,
      "48526": true,
      "48527": true,
      "48528": true,
      "48529": true,
      "48530": true,
      "48531": true,
      "48532": true,
      "48533": true,
      "48534": true,
      "48535": true,
      "48536": true,
      "48537": true,
      "48538": true,
      "48539": true
    },
    "COLOTLAN": {
      "46200": true,
      "46201": true,
      "46202": true,
      "46203": true,
      "46204": true,
      "46205": true,
      "46206": true,
      "46207": true,
      "46208": true,
      "46209": true,
      "46225": true,
      "46226": true,
      "46227": true,
      "46228": true,
      "46229": true,
      "46230": true,
      "46231": true,
      "46232": true,
      "46233": true,
      "46235": true,
      "46236": true,
      "46237": true,
      "46238": true,
      "46239": true
    },
    "CUQUIO": {
      "45480": true,
      "45481": true,
      "45482": true,
      "45483": true,
      "45484": true,
      "45485": true,
      "45486": true,
      "45487": true,
      "45492": true,
      "45493": true,
      "45494": true,
      "45495": true,
      "45496": true,
      "45497": true,
      "45498": true,
      "45499": true
    },
    "DEGOLLADO": {
      "47980": true,
      "47981": true,
      "47982": true,
      "47983": true,
      "47984": true,
      "47985": true,
      "47986": true,
      "47987": true,
      "47988": true,
      "47989": true,
      "47990": true,
      "47991": true,
      "47992": true,
      "47993": true,
      "47995": true,
      "47996": true,
      "47997": true,
      "47998": true,
      "47999": true
    },
    "EL ARENAL": {
      "45350": true,
      "45351": true,
      "45352": true,
      "45353": true,
      "45354": true,
      "45355": true,
      "45356": true,
      "45357": true,
      "45358": true,
      "45359": true,
      "45360": true,
      "45361": true,
      "45362": true,
      "45363": true,
      "45364": true,
      "45365": true,
      "45366": true,
      "45367": true,
      "45368": true,
      "45369": true,
      "45370": true,
      "45371": true,
      "45372": true,
      "45373": true,
      "45374": true,
      "45375": true,
      "45376": true,
      "45377": true,
      "45378": true,
      "45379": true
    },
    "EL GRULLO": {
      "48740": true,
      "48741": true,
      "48742": true,
      "48743": true,
      "48744": true,
      "48745": true,
      "48746": true,
      "48747": true,
      "48748": true,
      "48749": true,
      "48750": true,
      "48751": true,
      "48752": true,
      "48753": true,
      "48754": true,
      "48755": true,
      "48756": true,
      "48757": true,
      "48758": true,
      "48759": true
    },
    "EL SALTO": {
      "45680": true,
      "45681": true,
      "45682": true,
      "45683": true,
      "45684": true,
      "45685": true,
      "45686": true,
      "45687": true,
      "45688": true,
      "45689": true,
      "45690": true,
      "45691": true,
      "45692": true,
      "45693": true,
      "45694": true,
      "45695": true,
      "45696": true,
      "45697": true,
      "45698": true,
      "45699": true
    },
    "ENCARNACION DE DIAZ": {
      "47270": true,
      "47271": true,
      "47272": true,
      "47273": true,
      "47276": true,
      "47277": true,
      "47278": true,
      "47279": true,
      "47280": true,
      "47281": true,
      "47282": true,
      "47285": true,
      "47286": true,
      "47287": true,
      "47290": true,
      "47291": true,
      "47292": true,
      "47293": true,
      "47294": true,
      "47295": true,
      "47296": true,
      "47297": true,
      "47298": true,
      "47299": true
    },
    "ETZATLAN": {
      "46500": true,
      "46501": true,
      "46502": true,
      "46503": true,
      "46504": true,
      "46505": true,
      "46506": true,
      "46507": true,
      "46508": true,
      "46509": true,
      "46510": true,
      "46511": true,
      "46512": true,
      "46513": true,
      "46514": true,
      "46515": true,
      "46516": true,
      "46517": true,
      "46518": true,
      "46519": true,
      "46520": true,
      "46521": true,
      "46522": true,
      "46523": true,
      "46524": true,
      "46525": true,
      "46526": true,
      "46527": true,
      "46528": true,
      "46529": true,
      "46530": true,
      "46531": true,
      "46532": true,
      "46533": true,
      "46534": true,
      "46535": true,
      "46536": true,
      "46537": true,
      "46538": true,
      "46539": true
    },
    "GOMEZ FARIAS": {
      "49120": true,
      "49121": true,
      "49122": true,
      "49123": true,
      "49124": true,
      "49125": true,
      "49126": true,
      "49127": true,
      "49128": true,
      "49129": true,
      "49130": true,
      "49131": true,
      "49132": true,
      "49133": true,
      "49134": true,
      "49135": true,
      "49136": true,
      "49137": true,
      "49138": true,
      "49139": true,
      "49140": true,
      "49141": true,
      "49142": true,
      "49143": true,
      "49144": true,
      "49145": true,
      "49146": true,
      "49147": true,
      "49148": true,
      "49149": true,
      "49150": true,
      "49151": true,
      "49152": true,
      "49153": true,
      "49154": true,
      "49155": true,
      "49156": true,
      "49157": true,
      "49158": true,
      "49159": true,
      "49160": true,
      "49161": true,
      "49162": true,
      "49163": true,
      "49164": true,
      "49165": true,
      "49166": true,
      "49167": true,
      "49168": true,
      "49169": true
    },
    "GUADALAJARA": {
      "44000": true,
      "44001": true,
      "44002": true,
      "44003": true,
      "44004": true,
      "44005": true,
      "44006": true,
      "44007": true,
      "44008": true,
      "44009": true,
      "44010": true,
      "44011": true,
      "44012": true,
      "44013": true,
      "44014": true,
      "44015": true,
      "44016": true,
      "44017": true,
      "44018": true,
      "44019": true,
      "44020": true,
      "44021": true,
      "44022": true,
      "44023": true,
      "44024": true,
      "44025": true,
      "44026": true,
      "44027": true,
      "44028": true,
      "44029": true,
      "44030": true,
      "44031": true,
      "44032": true,
      "44033": true,
      "44034": true,
      "44035": true,
      "44036": true,
      "44037": true,
      "44038": true,
      "44039": true,
      "44040": true,
      "44041": true,
      "44042": true,
      "44043": true,
      "44044": true,
      "44045": true,
      "44046": true,
      "44047": true,
      "44048": true,
      "44049": true,
      "44050": true,
      "44051": true,
      "44052": true,
      "44053": true,
      "44054": true,
      "44055": true,
      "44056": true,
      "44057": true,
      "44058": true,
      "44059": true,
      "44060": true,
      "44061": true,
      "44062": true,
      "44063": true,
      "44064": true,
      "44065": true,
      "44066": true,
      "44067": true,
      "44068": true,
      "44069": true,
      "44070": true,
      "44071": true,
      "44072": true,
      "44073": true,
      "44074": true,
      "44075": true,
      "44076": true,
      "44077": true,
      "44078": true,
      "44079": true,
      "44080": true,
      "44081": true,
      "44082": true,
      "44083": true,
      "44084": true,
      "44085": true,
      "44086": true,
      "44087": true,
      "44088": true,
      "44089": true,
      "44090": true,
      "44091": true,
      "44092": true,
      "44093": true,
      "44094": true,
      "44095": true,
      "44096": true,
      "44097": true,
      "44098": true,
      "44099": true,
      "44100": true,
      "44101": true,
      "44102": true,
      "44103": true,
      "44104": true,
      "44105": true,
      "44106": true,
      "44107": true,
      "44108": true,
      "44109": true,
      "44110": true,
      "44111": true,
      "44112": true,
      "44113": true,
      "44114": true,
      "44115": true,
      "44116": true,
      "44117": true,
      "44118": true,
      "44119": true,
      "44120": true,
      "44121": true,
      "44122": true,
      "44123": true,
      "44124": true,
      "44125": true,
      "44126": true,
      "44127": true,
      "44128": true,
      "44129": true,
      "44130": true,
      "44131": true,
      "44132": true,
      "44133": true,
      "44134": true,
      "44135": true,
      "44136": true,
      "44137": true,
      "44138": true,
      "44139": true,
      "44140": true,
      "44141": true,
      "44142": true,
      "44143": true,
      "44144": true,
      "44145": true,
      "44146": true,
      "44147": true,
      "44148": true,
      "44149": true,
      "44150": true,
      "44151": true,
      "44152": true,
      "44153": true,
      "44154": true,
      "44155": true,
      "44156": true,
      "44157": true,
      "44158": true,
      "44159": true,
      "44160": true,
      "44161": true,
      "44162": true,
      "44163": true,
      "44164": true,
      "44165": true,
      "44166": true,
      "44167": true,
      "44168": true,
      "44169": true,
      "44170": true,
      "44171": true,
      "44172": true,
      "44173": true,
      "44174": true,
      "44175": true,
      "44176": true,
      "44177": true,
      "44178": true,
      "44179": true,
      "44180": true,
      "44181": true,
      "44182": true,
      "44183": true,
      "44184": true,
      "44185": true,
      "44186": true,
      "44187": true,
      "44188": true,
      "44189": true,
      "44190": true,
      "44191": true,
      "44192": true,
      "44193": true,
      "44194": true,
      "44195": true,
      "44196": true,
      "44197": true,
      "44198": true,
      "44199": true,
      "44200": true,
      "44201": true,
      "44202": true,
      "44203": true,
      "44204": true,
      "44205": true,
      "44206": true,
      "44207": true,
      "44208": true,
      "44209": true,
      "44210": true,
      "44211": true,
      "44212": true,
      "44213": true,
      "44214": true,
      "44215": true,
      "44216": true,
      "44217": true,
      "44218": true,
      "44219": true,
      "44220": true,
      "44221": true,
      "44222": true,
      "44223": true,
      "44224": true,
      "44225": true,
      "44226": true,
      "44227": true,
      "44228": true,
      "44229": true,
      "44230": true,
      "44231": true,
      "44232": true,
      "44233": true,
      "44234": true,
      "44235": true,
      "44236": true,
      "44237": true,
      "44238": true,
      "44239": true,
      "44240": true,
      "44241": true,
      "44242": true,
      "44243": true,
      "44244": true,
      "44245": true,
      "44246": true,
      "44247": true,
      "44248": true,
      "44249": true,
      "44250": true,
      "44251": true,
      "44252": true,
      "44253": true,
      "44254": true,
      "44255": true,
      "44256": true,
      "44257": true,
      "44258": true,
      "44259": true,
      "44260": true,
      "44261": true,
      "44262": true,
      "44263": true,
      "44264": true,
      "44265": true,
      "44266": true,
      "44267": true,
      "44268": true,
      "44269": true,
      "44270": true,
      "44271": true,
      "44272": true,
      "44273": true,
      "44274": true,
      "44275": true,
      "44276": true,
      "44277": true,
      "44278": true,
      "44279": true,
      "44280": true,
      "44281": true,
      "44282": true,
      "44283": true,
      "44284": true,
      "44285": true,
      "44286": true,
      "44287": true,
      "44288": true,
      "44289": true,
      "44290": true,
      "44291": true,
      "44292": true,
      "44293": true,
      "44294": true,
      "44295": true,
      "44296": true,
      "44297": true,
      "44298": true,
      "44299": true,
      "44300": true,
      "44301": true,
      "44302": true,
      "44303": true,
      "44304": true,
      "44305": true,
      "44306": true,
      "44307": true,
      "44308": true,
      "44309": true,
      "44310": true,
      "44311": true,
      "44312": true,
      "44313": true,
      "44314": true,
      "44315": true,
      "44316": true,
      "44317": true,
      "44318": true,
      "44319": true,
      "44320": true,
      "44321": true,
      "44322": true,
      "44323": true,
      "44324": true,
      "44325": true,
      "44326": true,
      "44327": true,
      "44328": true,
      "44329": true,
      "44330": true,
      "44331": true,
      "44332": true,
      "44333": true,
      "44334": true,
      "44335": true,
      "44336": true,
      "44337": true,
      "44338": true,
      "44339": true,
      "44340": true,
      "44341": true,
      "44342": true,
      "44343": true,
      "44344": true,
      "44345": true,
      "44346": true,
      "44347": true,
      "44348": true,
      "44350": true,
      "44351": true,
      "44352": true,
      "44353": true,
      "44354": true,
      "44355": true,
      "44356": true,
      "44357": true,
      "44358": true,
      "44359": true,
      "44360": true,
      "44361": true,
      "44362": true,
      "44363": true,
      "44364": true,
      "44365": true,
      "44366": true,
      "44367": true,
      "44368": true,
      "44369": true,
      "44370": true,
      "44371": true,
      "44372": true,
      "44373": true,
      "44374": true,
      "44375": true,
      "44376": true,
      "44377": true,
      "44378": true,
      "44379": true,
      "44380": true,
      "44381": true,
      "44382": true,
      "44383": true,
      "44384": true,
      "44385": true,
      "44386": true,
      "44387": true,
      "44388": true,
      "44389": true,
      "44390": true,
      "44391": true,
      "44392": true,
      "44393": true,
      "44394": true,
      "44395": true,
      "44396": true,
      "44397": true,
      "44398": true,
      "44399": true,
      "44400": true,
      "44401": true,
      "44402": true,
      "44403": true,
      "44404": true,
      "44405": true,
      "44406": true,
      "44407": true,
      "44408": true,
      "44409": true,
      "44410": true,
      "44411": true,
      "44412": true,
      "44413": true,
      "44414": true,
      "44415": true,
      "44416": true,
      "44417": true,
      "44418": true,
      "44419": true,
      "44420": true,
      "44421": true,
      "44422": true,
      "44423": true,
      "44424": true,
      "44425": true,
      "44426": true,
      "44427": true,
      "44428": true,
      "44429": true,
      "44430": true,
      "44431": true,
      "44432": true,
      "44433": true,
      "44434": true,
      "44435": true,
      "44436": true,
      "44437": true,
      "44438": true,
      "44439": true,
      "44440": true,
      "44441": true,
      "44442": true,
      "44443": true,
      "44444": true,
      "44445": true,
      "44446": true,
      "44447": true,
      "44448": true,
      "44449": true,
      "44450": true,
      "44451": true,
      "44452": true,
      "44453": true,
      "44454": true,
      "44455": true,
      "44456": true,
      "44457": true,
      "44458": true,
      "44459": true,
      "44460": true,
      "44461": true,
      "44462": true,
      "44463": true,
      "44464": true,
      "44465": true,
      "44466": true,
      "44467": true,
      "44468": true,
      "44469": true,
      "44470": true,
      "44471": true,
      "44472": true,
      "44473": true,
      "44474": true,
      "44475": true,
      "44476": true,
      "44477": true,
      "44478": true,
      "44479": true,
      "44480": true,
      "44481": true,
      "44482": true,
      "44483": true,
      "44484": true,
      "44485": true,
      "44486": true,
      "44487": true,
      "44488": true,
      "44489": true,
      "44490": true,
      "44491": true,
      "44492": true,
      "44493": true,
      "44494": true,
      "44495": true,
      "44496": true,
      "44497": true,
      "44498": true,
      "44499": true,
      "44500": true,
      "44501": true,
      "44502": true,
      "44503": true,
      "44504": true,
      "44505": true,
      "44506": true,
      "44507": true,
      "44508": true,
      "44509": true,
      "44510": true,
      "44511": true,
      "44512": true,
      "44513": true,
      "44514": true,
      "44515": true,
      "44516": true,
      "44517": true,
      "44518": true,
      "44519": true,
      "44520": true,
      "44521": true,
      "44522": true,
      "44523": true,
      "44524": true,
      "44525": true,
      "44526": true,
      "44527": true,
      "44528": true,
      "44529": true,
      "44530": true,
      "44531": true,
      "44532": true,
      "44533": true,
      "44534": true,
      "44535": true,
      "44536": true,
      "44537": true,
      "44538": true,
      "44539": true,
      "44540": true,
      "44541": true,
      "44542": true,
      "44543": true,
      "44544": true,
      "44545": true,
      "44546": true,
      "44547": true,
      "44548": true,
      "44549": true,
      "44550": true,
      "44551": true,
      "44552": true,
      "44553": true,
      "44554": true,
      "44555": true,
      "44556": true,
      "44557": true,
      "44558": true,
      "44559": true,
      "44560": true,
      "44561": true,
      "44562": true,
      "44563": true,
      "44564": true,
      "44565": true,
      "44566": true,
      "44567": true,
      "44568": true,
      "44569": true,
      "44570": true,
      "44571": true,
      "44572": true,
      "44573": true,
      "44574": true,
      "44575": true,
      "44576": true,
      "44577": true,
      "44578": true,
      "44579": true,
      "44580": true,
      "44581": true,
      "44582": true,
      "44583": true,
      "44584": true,
      "44585": true,
      "44586": true,
      "44587": true,
      "44588": true,
      "44589": true,
      "44590": true,
      "44591": true,
      "44592": true,
      "44593": true,
      "44594": true,
      "44595": true,
      "44596": true,
      "44597": true,
      "44598": true,
      "44599": true,
      "44600": true,
      "44601": true,
      "44602": true,
      "44603": true,
      "44604": true,
      "44605": true,
      "44606": true,
      "44607": true,
      "44608": true,
      "44609": true,
      "44610": true,
      "44611": true,
      "44612": true,
      "44613": true,
      "44614": true,
      "44615": true,
      "44616": true,
      "44617": true,
      "44618": true,
      "44619": true,
      "44620": true,
      "44621": true,
      "44622": true,
      "44623": true,
      "44624": true,
      "44625": true,
      "44626": true,
      "44627": true,
      "44628": true,
      "44629": true,
      "44630": true,
      "44631": true,
      "44632": true,
      "44633": true,
      "44634": true,
      "44635": true,
      "44636": true,
      "44637": true,
      "44638": true,
      "44639": true,
      "44640": true,
      "44641": true,
      "44642": true,
      "44643": true,
      "44644": true,
      "44645": true,
      "44646": true,
      "44647": true,
      "44648": true,
      "44649": true,
      "44650": true,
      "44651": true,
      "44652": true,
      "44653": true,
      "44654": true,
      "44655": true,
      "44656": true,
      "44657": true,
      "44658": true,
      "44659": true,
      "44660": true,
      "44661": true,
      "44662": true,
      "44663": true,
      "44664": true,
      "44665": true,
      "44666": true,
      "44667": true,
      "44668": true,
      "44669": true,
      "44670": true,
      "44671": true,
      "44672": true,
      "44673": true,
      "44674": true,
      "44675": true,
      "44676": true,
      "44677": true,
      "44678": true,
      "44679": true,
      "44680": true,
      "44681": true,
      "44682": true,
      "44683": true,
      "44684": true,
      "44685": true,
      "44686": true,
      "44687": true,
      "44688": true,
      "44689": true,
      "44690": true,
      "44691": true,
      "44692": true,
      "44693": true,
      "44694": true,
      "44695": true,
      "44696": true,
      "44697": true,
      "44698": true,
      "44699": true,
      "44700": true,
      "44701": true,
      "44702": true,
      "44703": true,
      "44704": true,
      "44705": true,
      "44706": true,
      "44707": true,
      "44708": true,
      "44709": true,
      "44710": true,
      "44711": true,
      "44712": true,
      "44713": true,
      "44714": true,
      "44715": true,
      "44716": true,
      "44717": true,
      "44718": true,
      "44719": true,
      "44720": true,
      "44721": true,
      "44722": true,
      "44723": true,
      "44724": true,
      "44725": true,
      "44726": true,
      "44727": true,
      "44728": true,
      "44729": true,
      "44730": true,
      "44731": true,
      "44732": true,
      "44733": true,
      "44734": true,
      "44735": true,
      "44736": true,
      "44737": true,
      "44738": true,
      "44739": true,
      "44740": true,
      "44741": true,
      "44742": true,
      "44743": true,
      "44744": true,
      "44745": true,
      "44746": true,
      "44747": true,
      "44748": true,
      "44749": true,
      "44750": true,
      "44751": true,
      "44752": true,
      "44753": true,
      "44754": true,
      "44755": true,
      "44756": true,
      "44757": true,
      "44758": true,
      "44759": true,
      "44760": true,
      "44761": true,
      "44762": true,
      "44763": true,
      "44764": true,
      "44765": true,
      "44766": true,
      "44767": true,
      "44768": true,
      "44769": true,
      "44770": true,
      "44771": true,
      "44772": true,
      "44773": true,
      "44774": true,
      "44775": true,
      "44776": true,
      "44777": true,
      "44778": true,
      "44779": true,
      "44780": true,
      "44781": true,
      "44782": true,
      "44783": true,
      "44784": true,
      "44785": true,
      "44786": true,
      "44787": true,
      "44788": true,
      "44789": true,
      "44790": true,
      "44791": true,
      "44792": true,
      "44793": true,
      "44794": true,
      "44795": true,
      "44796": true,
      "44797": true,
      "44798": true,
      "44799": true,
      "44800": true,
      "44801": true,
      "44802": true,
      "44803": true,
      "44804": true,
      "44805": true,
      "44806": true,
      "44807": true,
      "44808": true,
      "44809": true,
      "44810": true,
      "44811": true,
      "44812": true,
      "44813": true,
      "44814": true,
      "44815": true,
      "44816": true,
      "44817": true,
      "44818": true,
      "44819": true,
      "44820": true,
      "44821": true,
      "44822": true,
      "44823": true,
      "44824": true,
      "44825": true,
      "44826": true,
      "44827": true,
      "44828": true,
      "44829": true,
      "44830": true,
      "44831": true,
      "44832": true,
      "44833": true,
      "44834": true,
      "44835": true,
      "44836": true,
      "44837": true,
      "44838": true,
      "44839": true,
      "44840": true,
      "44841": true,
      "44842": true,
      "44843": true,
      "44844": true,
      "44845": true,
      "44846": true,
      "44847": true,
      "44848": true,
      "44849": true,
      "44850": true,
      "44851": true,
      "44852": true,
      "44853": true,
      "44854": true,
      "44855": true,
      "44856": true,
      "44857": true,
      "44858": true,
      "44859": true,
      "44860": true,
      "44861": true,
      "44862": true,
      "44863": true,
      "44864": true,
      "44865": true,
      "44866": true,
      "44867": true,
      "44868": true,
      "44869": true,
      "44870": true,
      "44871": true,
      "44872": true,
      "44873": true,
      "44874": true,
      "44875": true,
      "44876": true,
      "44877": true,
      "44878": true,
      "44879": true,
      "44880": true,
      "44881": true,
      "44882": true,
      "44883": true,
      "44884": true,
      "44885": true,
      "44886": true,
      "44887": true,
      "44888": true,
      "44889": true,
      "44890": true,
      "44891": true,
      "44892": true,
      "44893": true,
      "44894": true,
      "44895": true,
      "44896": true,
      "44897": true,
      "44898": true,
      "44899": true,
      "44900": true,
      "44901": true,
      "44902": true,
      "44903": true,
      "44904": true,
      "44905": true,
      "44906": true,
      "44907": true,
      "44908": true,
      "44909": true,
      "44910": true,
      "44911": true,
      "44912": true,
      "44913": true,
      "44914": true,
      "44915": true,
      "44916": true,
      "44917": true,
      "44918": true,
      "44919": true,
      "44920": true,
      "44921": true,
      "44922": true,
      "44923": true,
      "44924": true,
      "44925": true,
      "44926": true,
      "44927": true,
      "44928": true,
      "44929": true,
      "44930": true,
      "44931": true,
      "44932": true,
      "44933": true,
      "44934": true,
      "44935": true,
      "44936": true,
      "44937": true,
      "44938": true,
      "44939": true,
      "44940": true,
      "44941": true,
      "44942": true,
      "44943": true,
      "44944": true,
      "44945": true,
      "44946": true,
      "44947": true,
      "44948": true,
      "44949": true,
      "44950": true,
      "44951": true,
      "44952": true,
      "44953": true,
      "44954": true,
      "44955": true,
      "44956": true,
      "44957": true,
      "44958": true,
      "44959": true,
      "44960": true,
      "44961": true,
      "44962": true,
      "44963": true,
      "44964": true,
      "44965": true,
      "44966": true,
      "44967": true,
      "44968": true,
      "44969": true,
      "44970": true,
      "44971": true,
      "44972": true,
      "44973": true,
      "44974": true,
      "44975": true,
      "44976": true,
      "44977": true,
      "44978": true,
      "44979": true,
      "44980": true,
      "44981": true,
      "44982": true,
      "44983": true,
      "44984": true,
      "44985": true,
      "44986": true,
      "44987": true,
      "44988": true,
      "44989": true,
      "44990": true,
      "44991": true,
      "44992": true,
      "44993": true,
      "44994": true,
      "44995": true,
      "44996": true,
      "44997": true,
      "44998": true,
      "44999": true,
      "45000": true,
      "45001": true,
      "45002": true,
      "45003": true,
      "45004": true,
      "45005": true,
      "45006": true,
      "45007": true,
      "45008": true,
      "45009": true
    },
    "IXTLAHUACAN DE LOS MEMBRILLOS": {
      "45850": true,
      "45851": true,
      "45852": true,
      "45853": true,
      "45854": true,
      "45855": true,
      "45856": true,
      "45857": true,
      "45858": true,
      "45859": true,
      "45860": true,
      "45861": true,
      "45862": true,
      "45863": true,
      "45864": true,
      "45865": true,
      "45866": true,
      "45867": true,
      "45868": true,
      "45869": true,
      "45870": true,
      "45871": true,
      "45872": true,
      "45873": true,
      "45874": true,
      "45875": true,
      "45876": true,
      "45877": true,
      "45878": true,
      "45879": true
    },
    "IXTLAHUACAN DEL RIO": {
      "45260": true,
      "45261": true,
      "45262": true,
      "45263": true,
      "45264": true,
      "45265": true,
      "45266": true,
      "45267": true,
      "45268": true,
      "45269": true,
      "45270": true,
      "45271": true,
      "45272": true,
      "45273": true,
      "45274": true,
      "45275": true,
      "45276": true,
      "45277": true,
      "45278": true,
      "45280": true,
      "45281": true,
      "45282": true,
      "45283": true,
      "45284": true,
      "45285": true,
      "45286": true,
      "45287": true,
      "45288": true,
      "45289": true,
      "45290": true,
      "45291": true,
      "45292": true,
      "45293": true,
      "45294": true,
      "45295": true,
      "45296": true,
      "45297": true,
      "45298": true,
      "45299": true
    },
    "JALOSTOTITLAN": {
      "47120": true,
      "47121": true,
      "47122": true,
      "47123": true,
      "47124": true,
      "47125": true,
      "47126": true,
      "47127": true,
      "47128": true,
      "47129": true,
      "47130": true,
      "47131": true,
      "47132": true,
      "47133": true,
      "47134": true,
      "47135": true,
      "47136": true,
      "47137": true,
      "47138": true,
      "47139": true
    },
    "JESÚS MARÍA": {
      "47950": true,
      "47951": true,
      "47952": true,
      "47953": true,
      "47954": true,
      "47955": true,
      "47956": true,
      "47957": true,
      "47958": true,
      "47959": true,
      "47960": true,
      "47961": true,
      "47962": true,
      "47963": true,
      "47964": true,
      "47965": true,
      "47966": true,
      "47967": true,
      "47968": true,
      "47969": true,
      "47974": true,
      "47975": true,
      "47977": true,
      "47978": true,
      "47979": true
    },
    "JOCOTEPEC": {
      "45800": true,
      "45801": true,
      "45802": true,
      "45803": true,
      "45804": true,
      "45805": true,
      "45806": true,
      "45807": true,
      "45808": true,
      "45809": true,
      "45810": true,
      "45811": true,
      "45812": true,
      "45813": true,
      "45814": true,
      "45815": true,
      "45816": true,
      "45817": true,
      "45818": true,
      "45819": true,
      "45820": true,
      "45821": true,
      "45822": true,
      "45823": true,
      "45824": true,
      "45825": true,
      "45826": true,
      "45827": true,
      "45828": true,
      "45829": true,
      "45830": true,
      "45831": true,
      "45832": true,
      "45833": true,
      "45834": true,
      "45835": true,
      "45836": true,
      "45837": true,
      "45838": true,
      "45839": true,
      "45840": true,
      "45841": true,
      "45842": true,
      "45843": true,
      "45844": true,
      "45845": true,
      "45846": true,
      "45847": true,
      "45848": true,
      "45849": true
    },
    "JUANACATLAN": {
      "45880": true,
      "45881": true,
      "45882": true,
      "45883": true,
      "45884": true,
      "45885": true,
      "45886": true,
      "45887": true,
      "45888": true,
      "45889": true,
      "45899": true
    },
    "LA BARCA": {
      "47910": true,
      "47911": true,
      "47912": true,
      "47913": true,
      "47914": true,
      "47915": true,
      "47916": true,
      "47917": true,
      "47918": true,
      "47919": true,
      "47920": true,
      "47921": true,
      "47922": true,
      "47923": true,
      "47924": true,
      "47925": true,
      "47926": true,
      "47927": true,
      "47928": true,
      "47929": true
    },
    "LAGOS DE MORENO": {
      "47400": true,
      "47401": true,
      "47402": true,
      "47403": true,
      "47404": true,
      "47405": true,
      "47406": true,
      "47407": true,
      "47408": true,
      "47409": true,
      "47410": true,
      "47411": true,
      "47412": true,
      "47413": true,
      "47414": true,
      "47415": true,
      "47416": true,
      "47417": true,
      "47418": true,
      "47419": true,
      "47420": true,
      "47421": true,
      "47422": true,
      "47423": true,
      "47424": true,
      "47425": true,
      "47426": true,
      "47427": true,
      "47428": true,
      "47429": true,
      "47430": true,
      "47431": true,
      "47432": true,
      "47433": true,
      "47434": true,
      "47435": true,
      "47436": true,
      "47437": true,
      "47438": true,
      "47439": true,
      "47440": true,
      "47441": true,
      "47442": true,
      "47443": true,
      "47444": true,
      "47445": true,
      "47446": true,
      "47447": true,
      "47448": true,
      "47449": true,
      "47450": true,
      "47451": true,
      "47452": true,
      "47453": true,
      "47454": true,
      "47455": true,
      "47456": true,
      "47457": true,
      "47458": true,
      "47459": true,
      "47460": true,
      "47461": true,
      "47462": true,
      "47463": true,
      "47464": true,
      "47465": true,
      "47466": true,
      "47467": true,
      "47468": true,
      "47469": true,
      "47470": true,
      "47471": true,
      "47472": true,
      "47473": true,
      "47474": true,
      "47475": true,
      "47476": true,
      "47477": true,
      "47478": true,
      "47479": true,
      "47480": true,
      "47481": true,
      "47482": true,
      "47483": true,
      "47484": true,
      "47485": true,
      "47486": true,
      "47487": true,
      "47488": true,
      "47489": true,
      "47490": true,
      "47491": true,
      "47492": true,
      "47493": true,
      "47494": true,
      "47495": true,
      "47496": true,
      "47497": true,
      "47498": true,
      "47499": true,
      "47504": true,
      "47513": true,
      "47514": true,
      "47515": true,
      "47520": true,
      "47521": true,
      "47523": true,
      "47525": true,
      "47528": true,
      "47529": true,
      "47530": true,
      "47531": true,
      "47532": true,
      "47533": true,
      "47534": true,
      "47535": true,
      "47536": true,
      "47537": true,
      "47538": true
    },
    "MAGDALENA": {
      "46470": true,
      "46471": true,
      "46472": true,
      "46473": true,
      "46474": true,
      "46475": true,
      "46476": true,
      "46477": true,
      "46478": true,
      "46479": true,
      "46480": true,
      "46481": true,
      "46482": true,
      "46483": true,
      "46484": true,
      "46485": true,
      "46486": true,
      "46487": true,
      "46488": true,
      "46489": true,
      "46490": true,
      "46491": true,
      "46492": true,
      "46493": true,
      "46494": true,
      "46495": true,
      "46496": true,
      "46497": true,
      "46498": true,
      "46499": true
    },
    "MASCOTA": {
      "46900": true,
      "46901": true,
      "46902": true,
      "46903": true,
      "46904": true,
      "46905": true,
      "46906": true,
      "46907": true,
      "46908": true,
      "46909": true,
      "46910": true,
      "46911": true,
      "46912": true,
      "46913": true,
      "46914": true,
      "46915": true,
      "46916": true,
      "46917": true,
      "46918": true,
      "46919": true,
      "46930": true,
      "46931": true,
      "46932": true,
      "46933": true,
      "46934": true,
      "46940": true,
      "46941": true,
      "46942": true,
      "46943": true,
      "46944": true
    },
    "MEXTICACAN": {
      "47340": true,
      "47341": true,
      "47342": true,
      "47343": true,
      "47344": true,
      "47345": true,
      "47346": true,
      "47347": true,
      "47348": true,
      "47349": true,
      "47350": true,
      "47351": true,
      "47352": true,
      "47353": true,
      "47354": true,
      "47355": true,
      "47356": true,
      "47357": true,
      "47358": true,
      "47359": true
    },
    "OCOTLAN": {
      "47780": true,
      "47781": true,
      "47782": true,
      "47783": true,
      "47784": true,
      "47785": true,
      "47786": true,
      "47787": true,
      "47788": true,
      "47789": true,
      "47790": true,
      "47791": true,
      "47792": true,
      "47793": true,
      "47794": true,
      "47795": true,
      "47796": true,
      "47797": true,
      "47798": true,
      "47799": true,
      "47800": true,
      "47801": true,
      "47802": true,
      "47803": true,
      "47804": true,
      "47805": true,
      "47806": true,
      "47807": true,
      "47808": true,
      "47809": true,
      "47810": true,
      "47811": true,
      "47812": true,
      "47813": true,
      "47814": true,
      "47815": true,
      "47816": true,
      "47817": true,
      "47818": true,
      "47819": true,
      "47820": true,
      "47821": true,
      "47822": true,
      "47823": true,
      "47824": true,
      "47825": true,
      "47826": true,
      "47827": true,
      "47828": true,
      "47829": true,
      "47830": true,
      "47831": true,
      "47832": true,
      "47833": true,
      "47834": true,
      "47835": true,
      "47836": true,
      "47837": true,
      "47838": true,
      "47839": true,
      "47840": true,
      "47841": true,
      "47842": true,
      "47843": true,
      "47844": true,
      "47845": true,
      "47846": true,
      "47847": true,
      "47848": true,
      "47849": true,
      "47850": true,
      "47851": true,
      "47852": true,
      "47853": true,
      "47854": true,
      "47855": true,
      "47856": true,
      "47857": true,
      "47858": true,
      "47859": true,
      "47860": true,
      "47861": true,
      "47862": true,
      "47863": true,
      "47864": true,
      "47865": true,
      "47866": true,
      "47867": true,
      "47868": true,
      "47869": true,
      "47870": true,
      "47871": true,
      "47872": true,
      "47873": true,
      "47874": true,
      "47875": true,
      "47876": true,
      "47877": true,
      "47878": true,
      "47879": true,
      "47880": true,
      "47881": true,
      "47882": true,
      "47883": true,
      "47884": true,
      "47885": true,
      "47886": true,
      "47887": true,
      "47888": true,
      "47889": true,
      "47890": true,
      "47891": true,
      "47892": true,
      "47893": true,
      "47894": true,
      "47895": true,
      "47896": true,
      "47897": true,
      "47898": true,
      "47899": true
    },
    "OJUELOS DE JALISCO": {
      "47540": true,
      "47541": true,
      "47542": true,
      "47543": true,
      "47544": true,
      "47547": true,
      "47548": true,
      "47549": true,
      "47550": true,
      "47551": true,
      "47552": true,
      "47553": true,
      "47554": true,
      "47555": true,
      "47556": true,
      "47557": true,
      "47558": true,
      "47559": true,
      "47560": true,
      "47561": true,
      "47562": true,
      "47563": true,
      "47564": true,
      "47566": true,
      "47567": true,
      "47568": true,
      "47569": true
    },
    "PONCITLAN": {
      "45950": true,
      "45951": true,
      "45952": true,
      "45953": true,
      "45954": true,
      "45955": true,
      "45956": true,
      "45957": true,
      "45958": true,
      "45959": true,
      "45960": true,
      "45961": true,
      "45962": true,
      "45965": true,
      "45966": true,
      "45967": true,
      "45968": true,
      "45969": true,
      "45970": true,
      "45971": true,
      "45972": true,
      "45973": true,
      "45974": true,
      "45975": true,
      "45976": true,
      "45977": true,
      "45978": true,
      "45979": true
    },
    "PUERTO VALLARTA": {
      "48260": true,
      "48261": true,
      "48262": true,
      "48263": true,
      "48264": true,
      "48265": true,
      "48266": true,
      "48267": true,
      "48268": true,
      "48269": true,
      "48270": true,
      "48271": true,
      "48272": true,
      "48273": true,
      "48274": true,
      "48275": true,
      "48276": true,
      "48277": true,
      "48278": true,
      "48279": true,
      "48280": true,
      "48281": true,
      "48282": true,
      "48283": true,
      "48284": true,
      "48285": true,
      "48286": true,
      "48287": true,
      "48288": true,
      "48289": true,
      "48290": true,
      "48291": true,
      "48292": true,
      "48293": true,
      "48294": true,
      "48295": true,
      "48296": true,
      "48297": true,
      "48298": true,
      "48299": true,
      "48300": true,
      "48301": true,
      "48302": true,
      "48303": true,
      "48304": true,
      "48305": true,
      "48306": true,
      "48307": true,
      "48308": true,
      "48309": true,
      "48310": true,
      "48311": true,
      "48312": true,
      "48313": true,
      "48314": true,
      "48315": true,
      "48316": true,
      "48317": true,
      "48318": true,
      "48319": true,
      "48320": true,
      "48321": true,
      "48322": true,
      "48323": true,
      "48324": true,
      "48325": true,
      "48326": true,
      "48327": true,
      "48328": true,
      "48329": true,
      "48330": true,
      "48331": true,
      "48332": true,
      "48333": true,
      "48334": true,
      "48335": true,
      "48336": true,
      "48337": true,
      "48338": true,
      "48339": true,
      "48340": true,
      "48341": true,
      "48342": true,
      "48343": true,
      "48344": true,
      "48345": true,
      "48346": true,
      "48347": true,
      "48348": true,
      "48349": true,
      "48350": true,
      "48351": true,
      "48352": true,
      "48353": true,
      "48354": true,
      "48355": true,
      "48356": true,
      "48357": true,
      "48358": true,
      "48359": true,
      "48360": true,
      "48361": true,
      "48362": true,
      "48363": true,
      "48364": true,
      "48365": true,
      "48366": true,
      "48367": true,
      "48368": true,
      "48369": true,
      "48370": true,
      "48371": true,
      "48372": true,
      "48373": true,
      "48374": true,
      "48375": true,
      "48376": true,
      "48377": true,
      "48378": true,
      "48379": true,
      "48380": true,
      "48381": true,
      "48382": true,
      "48383": true,
      "48384": true,
      "48385": true,
      "48386": true,
      "48387": true,
      "48388": true,
      "48389": true,
      "48390": true,
      "48391": true,
      "48392": true,
      "48393": true,
      "48394": true,
      "48395": true,
      "48396": true,
      "48397": true,
      "48398": true,
      "48399": true
    },
    "SAN DIEGO DE ALEJANDRIA": {
      "47590": true,
      "47591": true,
      "47592": true,
      "47593": true,
      "47594": true,
      "47595": true,
      "47596": true,
      "47597": true,
      "47598": true,
      "47599": true
    },
    "SAN JUAN DE LOS LAGOS": {
      "47000": true,
      "47001": true,
      "47002": true,
      "47003": true,
      "47004": true,
      "47005": true,
      "47006": true,
      "47007": true,
      "47008": true,
      "47009": true,
      "47010": true,
      "47011": true,
      "47012": true,
      "47013": true,
      "47014": true,
      "47015": true,
      "47016": true,
      "47017": true,
      "47018": true,
      "47019": true,
      "47020": true,
      "47021": true,
      "47022": true,
      "47023": true,
      "47024": true,
      "47025": true,
      "47026": true,
      "47027": true,
      "47028": true,
      "47029": true,
      "47030": true,
      "47031": true,
      "47032": true,
      "47033": true,
      "47034": true,
      "47035": true,
      "47036": true,
      "47037": true,
      "47038": true,
      "47039": true,
      "47040": true,
      "47041": true,
      "47042": true,
      "47043": true,
      "47044": true,
      "47045": true,
      "47046": true,
      "47047": true,
      "47048": true,
      "47049": true,
      "47050": true,
      "47051": true,
      "47052": true,
      "47053": true,
      "47054": true,
      "47055": true,
      "47056": true,
      "47057": true,
      "47058": true,
      "47059": true,
      "47060": true,
      "47061": true,
      "47062": true,
      "47063": true,
      "47064": true,
      "47065": true,
      "47066": true,
      "47067": true,
      "47068": true,
      "47069": true,
      "47070": true,
      "47071": true,
      "47072": true,
      "47073": true,
      "47074": true,
      "47075": true,
      "47076": true,
      "47077": true,
      "47078": true,
      "47079": true,
      "47080": true,
      "47081": true,
      "47082": true,
      "47083": true,
      "47084": true,
      "47085": true,
      "47086": true,
      "47087": true,
      "47088": true,
      "47089": true,
      "47090": true,
      "47091": true,
      "47092": true,
      "47093": true,
      "47094": true,
      "47095": true,
      "47096": true,
      "47097": true,
      "47098": true,
      "47099": true,
      "47100": true,
      "47101": true,
      "47102": true,
      "47103": true,
      "47104": true,
      "47106": true,
      "47107": true,
      "47108": true,
      "47109": true,
      "47116": true,
      "47117": true,
      "47118": true
    },
    "SAN JUANITO DE ESCOBEDO": {
      "46560": true,
      "46561": true,
      "46562": true,
      "46563": true,
      "46564": true,
      "46565": true,
      "46566": true,
      "46567": true,
      "46568": true,
      "46569": true,
      "46570": true,
      "46571": true,
      "46572": true,
      "46573": true,
      "46574": true,
      "46575": true,
      "46576": true,
      "46577": true,
      "46578": true,
      "46579": true,
      "46580": true,
      "46581": true,
      "46582": true,
      "46583": true,
      "46584": true,
      "46585": true,
      "46586": true,
      "46587": true,
      "46588": true,
      "46589": true,
      "46590": true,
      "46591": true,
      "46592": true,
      "46593": true,
      "46594": true,
      "46595": true,
      "46596": true,
      "46597": true,
      "46598": true,
      "46599": true
    },
    "SAN JULIAN": {
      "47170": true,
      "47171": true,
      "47172": true,
      "47173": true,
      "47174": true,
      "47175": true,
      "47176": true,
      "47177": true,
      "47178": true,
      "47179": true
    },
    "SAN MARTIN HIDALGO": {
      "46770": true,
      "46771": true,
      "46772": true,
      "46773": true,
      "46774": true,
      "46775": true,
      "46776": true,
      "46777": true,
      "46778": true,
      "46779": true,
      "46780": true,
      "46781": true,
      "46782": true,
      "46783": true,
      "46784": true,
      "46785": true,
      "46786": true,
      "46787": true,
      "46788": true,
      "46789": true,
      "46790": true,
      "46791": true,
      "46792": true,
      "46793": true,
      "46794": true,
      "46795": true,
      "46796": true,
      "46797": true,
      "46798": true,
      "46799": true
    },
    "SAN MIGUEL EL ALTO": {
      "47140": true,
      "47141": true,
      "47142": true,
      "47143": true,
      "47144": true,
      "47145": true,
      "47146": true,
      "47147": true,
      "47148": true,
      "47149": true,
      "47150": true,
      "47151": true,
      "47152": true,
      "47153": true,
      "47154": true,
      "47155": true,
      "47156": true,
      "47157": true,
      "47158": true,
      "47159": true,
      "47160": true,
      "47161": true,
      "47162": true,
      "47163": true,
      "47164": true,
      "47165": true,
      "47166": true,
      "47167": true,
      "47168": true,
      "47169": true
    },
    "SAN PEDRO TLAQUEPAQUE": {
      "45500": true,
      "45501": true,
      "45502": true,
      "45503": true,
      "45504": true,
      "45505": true,
      "45506": true,
      "45507": true,
      "45508": true,
      "45509": true,
      "45510": true,
      "45511": true,
      "45512": true,
      "45513": true,
      "45514": true,
      "45515": true,
      "45516": true,
      "45517": true,
      "45518": true,
      "45519": true,
      "45520": true,
      "45521": true,
      "45522": true,
      "45523": true,
      "45524": true,
      "45525": true,
      "45526": true,
      "45527": true,
      "45528": true,
      "45529": true,
      "45530": true,
      "45531": true,
      "45532": true,
      "45533": true,
      "45534": true,
      "45535": true,
      "45536": true,
      "45537": true,
      "45538": true,
      "45539": true,
      "45540": true,
      "45541": true,
      "45542": true,
      "45543": true,
      "45544": true,
      "45545": true,
      "45546": true,
      "45547": true,
      "45548": true,
      "45549": true,
      "45550": true,
      "45551": true,
      "45552": true,
      "45553": true,
      "45554": true,
      "45555": true,
      "45556": true,
      "45557": true,
      "45558": true,
      "45559": true,
      "45560": true,
      "45561": true,
      "45562": true,
      "45563": true,
      "45564": true,
      "45565": true,
      "45566": true,
      "45567": true,
      "45568": true,
      "45569": true,
      "45570": true,
      "45571": true,
      "45572": true,
      "45573": true,
      "45574": true,
      "45575": true,
      "45576": true,
      "45577": true,
      "45578": true,
      "45579": true,
      "45580": true,
      "45581": true,
      "45582": true,
      "45583": true,
      "45584": true,
      "45585": true,
      "45586": true,
      "45587": true,
      "45588": true,
      "45589": true,
      "45590": true,
      "45591": true,
      "45592": true,
      "45593": true,
      "45594": true,
      "45595": true,
      "45596": true,
      "45597": true,
      "45598": true,
      "45599": true,
      "45600": true,
      "45601": true,
      "45602": true,
      "45603": true,
      "45604": true,
      "45605": true,
      "45606": true,
      "45607": true,
      "45608": true,
      "45609": true,
      "45610": true,
      "45611": true,
      "45612": true,
      "45613": true,
      "45614": true,
      "45615": true,
      "45616": true,
      "45617": true,
      "45618": true,
      "45619": true,
      "45620": true,
      "45621": true,
      "45622": true,
      "45623": true,
      "45624": true,
      "45625": true,
      "45626": true,
      "45627": true,
      "45628": true,
      "45629": true,
      "45630": true,
      "45631": true,
      "45632": true,
      "45633": true,
      "45634": true,
      "45635": true,
      "45636": true,
      "45637": true,
      "45638": true,
      "45639": true
    },
    "SAYULA": {
      "49300": true,
      "49301": true,
      "49302": true,
      "49303": true,
      "49304": true,
      "49305": true,
      "49306": true,
      "49307": true,
      "49308": true,
      "49309": true,
      "49310": true,
      "49311": true,
      "49312": true,
      "49313": true,
      "49314": true,
      "49315": true,
      "49316": true,
      "49317": true,
      "49318": true,
      "49319": true,
      "49320": true,
      "49321": true,
      "49322": true,
      "49323": true,
      "49324": true,
      "49325": true,
      "49326": true,
      "49327": true,
      "49328": true,
      "49329": true,
      "49330": true,
      "49331": true,
      "49332": true,
      "49333": true,
      "49334": true,
      "49335": true,
      "49336": true,
      "49337": true,
      "49338": true,
      "49339": true
    },
    "TALA": {
      "45300": true,
      "45301": true,
      "45302": true,
      "45303": true,
      "45304": true,
      "45305": true,
      "45306": true,
      "45307": true,
      "45308": true,
      "45309": true,
      "45310": true,
      "45311": true,
      "45312": true,
      "45313": true,
      "45314": true,
      "45315": true,
      "45316": true,
      "45317": true,
      "45318": true,
      "45319": true,
      "45320": true,
      "45321": true,
      "45322": true,
      "45323": true,
      "45324": true,
      "45325": true,
      "45326": true,
      "45327": true,
      "45328": true,
      "45329": true,
      "45330": true,
      "45331": true,
      "45332": true,
      "45333": true,
      "45334": true,
      "45335": true,
      "45336": true,
      "45337": true,
      "45338": true,
      "45339": true,
      "45340": true,
      "45341": true,
      "45342": true,
      "45343": true,
      "45344": true,
      "45345": true,
      "45346": true,
      "45347": true,
      "45348": true,
      "45349": true
    },
    "TAPALPA": {
      "49340": true,
      "49341": true,
      "49342": true,
      "49343": true,
      "49344": true,
      "49345": true,
      "49346": true,
      "49347": true,
      "49348": true,
      "49349": true,
      "49350": true,
      "49351": true,
      "49352": true,
      "49353": true,
      "49354": true,
      "49355": true,
      "49356": true,
      "49357": true,
      "49358": true,
      "49359": true,
      "49360": true,
      "49361": true,
      "49362": true,
      "49363": true,
      "49364": true,
      "49365": true,
      "49366": true,
      "49367": true,
      "49368": true
    },
    "TECALITLAN": {
      "49900": true,
      "49901": true,
      "49902": true,
      "49903": true,
      "49904": true,
      "49905": true,
      "49906": true,
      "49907": true,
      "49908": true,
      "49909": true,
      "49910": true,
      "49911": true,
      "49912": true,
      "49913": true,
      "49914": true,
      "49915": true,
      "49916": true,
      "49917": true,
      "49918": true,
      "49919": true,
      "49920": true,
      "49921": true,
      "49922": true,
      "49923": true,
      "49924": true,
      "49925": true,
      "49926": true,
      "49927": true,
      "49928": true,
      "49929": true,
      "49930": true,
      "49931": true,
      "49932": true,
      "49933": true,
      "49934": true,
      "49935": true,
      "49936": true,
      "49937": true,
      "49938": true,
      "49939": true
    },
    "TECOLOTLAN": {
      "48540": true,
      "48541": true,
      "48542": true,
      "48543": true,
      "48544": true,
      "48545": true,
      "48546": true,
      "48547": true,
      "48548": true,
      "48549": true,
      "48553": true,
      "48554": true,
      "48555": true,
      "48556": true,
      "48557": true,
      "48558": true,
      "48560": true,
      "48561": true,
      "48562": true,
      "48563": true,
      "48564": true,
      "48565": true,
      "48566": true,
      "48567": true,
      "48568": true,
      "48569": true
    },
    "TEOCALTICHE": {
      "47200": true,
      "47201": true,
      "47202": true,
      "47203": true,
      "47204": true,
      "47205": true,
      "47206": true,
      "47207": true,
      "47208": true,
      "47209": true,
      "47210": true,
      "47211": true,
      "47214": true,
      "47215": true,
      "47216": true,
      "47220": true,
      "47221": true,
      "47222": true,
      "47223": true,
      "47227": true,
      "47228": true,
      "47229": true,
      "47232": true,
      "47233": true,
      "47234": true,
      "47235": true,
      "47236": true,
      "47237": true,
      "47238": true,
      "47239": true,
      "47244": true,
      "47245": true,
      "47246": true,
      "47247": true,
      "47249": true
    },
    "TEPATITLAN DE MORELOS": {
      "47600": true,
      "47601": true,
      "47602": true,
      "47603": true,
      "47604": true,
      "47605": true,
      "47606": true,
      "47607": true,
      "47608": true,
      "47609": true,
      "47610": true,
      "47611": true,
      "47612": true,
      "47613": true,
      "47614": true,
      "47615": true,
      "47616": true,
      "47617": true,
      "47618": true,
      "47619": true,
      "47620": true,
      "47621": true,
      "47622": true,
      "47623": true,
      "47624": true,
      "47625": true,
      "47626": true,
      "47627": true,
      "47628": true,
      "47629": true,
      "47630": true,
      "47631": true,
      "47632": true,
      "47633": true,
      "47634": true,
      "47635": true,
      "47636": true,
      "47637": true,
      "47638": true,
      "47639": true,
      "47640": true,
      "47641": true,
      "47642": true,
      "47643": true,
      "47644": true,
      "47645": true,
      "47646": true,
      "47647": true,
      "47648": true,
      "47649": true,
      "47650": true,
      "47651": true,
      "47652": true,
      "47653": true,
      "47654": true,
      "47655": true,
      "47656": true,
      "47657": true,
      "47658": true,
      "47659": true,
      "47660": true,
      "47661": true,
      "47662": true,
      "47663": true,
      "47664": true,
      "47665": true,
      "47666": true,
      "47667": true,
      "47668": true,
      "47669": true,
      "47670": true,
      "47671": true,
      "47672": true,
      "47673": true,
      "47674": true,
      "47675": true,
      "47676": true,
      "47677": true,
      "47678": true,
      "47679": true,
      "47680": true,
      "47681": true,
      "47682": true,
      "47683": true,
      "47684": true,
      "47685": true,
      "47686": true,
      "47687": true,
      "47688": true,
      "47689": true,
      "47690": true,
      "47691": true,
      "47692": true,
      "47693": true,
      "47694": true,
      "47695": true,
      "47696": true,
      "47697": true,
      "47698": true,
      "47699": true,
      "47700": true,
      "47701": true,
      "47702": true,
      "47703": true,
      "47704": true,
      "47705": true,
      "47706": true,
      "47707": true,
      "47708": true,
      "47709": true,
      "47714": true,
      "47715": true,
      "47716": true,
      "47717": true,
      "47718": true,
      "47719": true,
      "47720": true,
      "47721": true,
      "47722": true,
      "47723": true,
      "47724": true,
      "47727": true,
      "47728": true,
      "47729": true
    },
    "TEQUILA": {
      "46400": true,
      "46401": true,
      "46402": true,
      "46403": true,
      "46404": true,
      "46405": true,
      "46406": true,
      "46407": true,
      "46409": true,
      "46410": true,
      "46411": true,
      "46412": true,
      "46413": true,
      "46414": true,
      "46415": true,
      "46416": true,
      "46417": true,
      "46418": true,
      "46419": true
    },
    "TEUCHITLAN": {
      "46760": true,
      "46761": true,
      "46762": true,
      "46763": true,
      "46764": true,
      "46765": true,
      "46766": true,
      "46767": true,
      "46768": true,
      "46769": true
    },
    "TIZAPAN EL ALTO": {
      "49400": true,
      "49401": true,
      "49402": true,
      "49403": true,
      "49404": true,
      "49405": true,
      "49406": true,
      "49407": true,
      "49408": true,
      "49409": true,
      "49410": true,
      "49411": true,
      "49412": true,
      "49413": true,
      "49414": true,
      "49415": true,
      "49416": true,
      "49417": true,
      "49418": true,
      "49419": true,
      "49420": true,
      "49421": true,
      "49422": true,
      "49423": true,
      "49424": true,
      "49425": true,
      "49426": true,
      "49427": true,
      "49428": true,
      "49429": true
    },
    "TLAJOMULCO": {
      "45640": true
    },
    "TLAJOMULCO DE ZUÑIGA": {
      "45640": true,
      "45641": true,
      "45642": true,
      "45643": true,
      "45644": true,
      "45645": true,
      "45646": true,
      "45647": true,
      "45648": true,
      "45649": true,
      "45650": true,
      "45651": true,
      "45652": true,
      "45653": true,
      "45654": true,
      "45655": true,
      "45656": true,
      "45657": true,
      "45658": true,
      "45659": true,
      "45660": true,
      "45661": true,
      "45662": true,
      "45663": true,
      "45664": true,
      "45665": true,
      "45666": true,
      "45667": true,
      "45668": true,
      "45669": true,
      "45670": true,
      "45671": true,
      "45672": true,
      "45673": true,
      "45674": true,
      "45675": true,
      "45676": true,
      "45677": true,
      "45678": true,
      "45679": true
    },
    "TLAQUEPAQUE": {
      "45629": true
    },
    "TONALÁ": {
      "45400": true,
      "45401": true,
      "45402": true,
      "45403": true,
      "45404": true,
      "45405": true,
      "45406": true,
      "45407": true,
      "45408": true,
      "45409": true,
      "45410": true,
      "45411": true,
      "45412": true,
      "45413": true,
      "45414": true,
      "45415": true,
      "45416": true,
      "45417": true,
      "45418": true,
      "45419": true,
      "45420": true,
      "45421": true,
      "45422": true,
      "45423": true,
      "45424": true,
      "45425": true,
      "45426": true,
      "45427": true,
      "45428": true,
      "45429": true
    },
    "TONILA": {
      "49840": true,
      "49841": true,
      "49842": true,
      "49843": true,
      "49844": true,
      "49845": true,
      "49846": true,
      "49847": true,
      "49848": true,
      "49849": true,
      "49850": true,
      "49851": true,
      "49852": true,
      "49853": true,
      "49854": true,
      "49855": true,
      "49856": true,
      "49857": true,
      "49858": true,
      "49859": true,
      "49860": true,
      "49861": true,
      "49862": true,
      "49863": true,
      "49864": true,
      "49865": true,
      "49866": true,
      "49867": true,
      "49868": true,
      "49869": true
    },
    "TOTOTLAN": {
      "47730": true,
      "47731": true,
      "47732": true,
      "47733": true,
      "47734": true,
      "47735": true,
      "47736": true,
      "47737": true,
      "47738": true,
      "47739": true,
      "47740": true,
      "47741": true,
      "47742": true,
      "47743": true,
      "47746": true,
      "47748": true,
      "47749": true
    },
    "TUXCUECA": {
      "49430": true,
      "49431": true,
      "49432": true,
      "49433": true,
      "49434": true,
      "49435": true,
      "49436": true,
      "49437": true,
      "49438": true,
      "49439": true,
      "49440": true,
      "49441": true,
      "49442": true,
      "49443": true,
      "49444": true,
      "49445": true,
      "49446": true,
      "49447": true,
      "49448": true,
      "49449": true
    },
    "UNION DE SAN ANTONIO": {
      "47570": true,
      "47571": true,
      "47572": true,
      "47573": true,
      "47574": true,
      "47576": true,
      "47577": true,
      "47578": true,
      "47579": true,
      "47580": true,
      "47581": true,
      "47582": true,
      "47583": true,
      "47584": true,
      "47585": true,
      "47586": true,
      "47587": true
    },
    "VALLE DE GUADALUPE": {
      "47380": true,
      "47381": true,
      "47382": true,
      "47383": true,
      "47384": true,
      "47385": true,
      "47386": true,
      "47387": true,
      "47388": true,
      "47389": true,
      "47390": true,
      "47391": true,
      "47392": true,
      "47393": true,
      "47394": true,
      "47395": true,
      "47396": true,
      "47397": true,
      "47398": true,
      "47399": true
    },
    "VALLE DE JUAREZ": {
      "49540": true,
      "49541": true,
      "49542": true,
      "49543": true,
      "49544": true,
      "49545": true,
      "49546": true,
      "49547": true,
      "49548": true,
      "49549": true,
      "49550": true,
      "49551": true,
      "49552": true,
      "49553": true,
      "49554": true,
      "49555": true,
      "49556": true,
      "49557": true,
      "49558": true,
      "49559": true,
      "49560": true,
      "49561": true,
      "49562": true,
      "49563": true,
      "49564": true,
      "49565": true,
      "49566": true,
      "49567": true,
      "49568": true,
      "49569": true
    },
    "VILLA HIDALGO": {
      "47250": true,
      "47251": true,
      "47252": true,
      "47253": true,
      "47254": true,
      "47255": true,
      "47256": true,
      "47257": true,
      "47258": true,
      "47259": true,
      "47260": true,
      "47261": true,
      "47262": true,
      "47263": true,
      "47264": true,
      "47265": true,
      "47266": true,
      "47267": true,
      "47268": true,
      "47269": true
    },
    "VILLA PURIFICACION": {
      "48800": true,
      "48801": true,
      "48802": true,
      "48803": true,
      "48804": true,
      "48805": true,
      "48806": true,
      "48807": true,
      "48808": true,
      "48809": true,
      "48810": true,
      "48811": true,
      "48812": true,
      "48813": true,
      "48814": true,
      "48815": true,
      "48816": true,
      "48817": true,
      "48818": true,
      "48819": true,
      "48823": true
    },
    "YAHUALICA DE GONZALEZ GALLO": {
      "47300": true,
      "47301": true,
      "47302": true,
      "47303": true,
      "47304": true,
      "47305": true,
      "47306": true,
      "47307": true,
      "47308": true,
      "47309": true,
      "47310": true,
      "47311": true,
      "47312": true,
      "47314": true,
      "47315": true,
      "47316": true,
      "47317": true,
      "47318": true,
      "47319": true,
      "47320": true,
      "47321": true,
      "47322": true,
      "47323": true,
      "47324": true,
      "47325": true,
      "47326": true,
      "47327": true,
      "47328": true,
      "47329": true,
      "47330": true,
      "47331": true,
      "47332": true,
      "47333": true,
      "47335": true,
      "47336": true,
      "47337": true,
      "47338": true,
      "47339": true
    },
    "ZACOALCO DE TORRES": {
      "45750": true,
      "45751": true,
      "45752": true,
      "45753": true,
      "45754": true,
      "45755": true,
      "45756": true,
      "45757": true,
      "45758": true,
      "45759": true,
      "45760": true,
      "45761": true,
      "45762": true,
      "45763": true,
      "45764": true,
      "45765": true,
      "45766": true,
      "45767": true,
      "45768": true,
      "45769": true,
      "45770": true,
      "45771": true,
      "45772": true,
      "45773": true,
      "45774": true,
      "45775": true,
      "45776": true,
      "45777": true,
      "45778": true,
      "45779": true,
      "45780": true,
      "45781": true,
      "45782": true,
      "45783": true,
      "45784": true,
      "45785": true,
      "45786": true,
      "45787": true,
      "45788": true,
      "45789": true
    },
    "ZAPOPAN": {
      "45010": true,
      "45011": true,
      "45012": true,
      "45013": true,
      "45014": true,
      "45015": true,
      "45016": true,
      "45017": true,
      "45018": true,
      "45019": true,
      "45020": true,
      "45021": true,
      "45022": true,
      "45023": true,
      "45024": true,
      "45025": true,
      "45026": true,
      "45027": true,
      "45028": true,
      "45029": true,
      "45030": true,
      "45031": true,
      "45032": true,
      "45033": true,
      "45034": true,
      "45035": true,
      "45036": true,
      "45037": true,
      "45038": true,
      "45039": true,
      "45040": true,
      "45041": true,
      "45042": true,
      "45043": true,
      "45044": true,
      "45045": true,
      "45046": true,
      "45047": true,
      "45048": true,
      "45049": true,
      "45050": true,
      "45051": true,
      "45052": true,
      "45053": true,
      "45054": true,
      "45055": true,
      "45056": true,
      "45057": true,
      "45058": true,
      "45059": true,
      "45060": true,
      "45061": true,
      "45062": true,
      "45063": true,
      "45064": true,
      "45065": true,
      "45066": true,
      "45067": true,
      "45068": true,
      "45069": true,
      "45070": true,
      "45071": true,
      "45072": true,
      "45073": true,
      "45074": true,
      "45075": true,
      "45076": true,
      "45077": true,
      "45078": true,
      "45079": true,
      "45080": true,
      "45081": true,
      "45082": true,
      "45083": true,
      "45084": true,
      "45085": true,
      "45086": true,
      "45087": true,
      "45088": true,
      "45089": true,
      "45090": true,
      "45091": true,
      "45092": true,
      "45093": true,
      "45094": true,
      "45095": true,
      "45096": true,
      "45097": true,
      "45098": true,
      "45099": true,
      "45100": true,
      "45101": true,
      "45102": true,
      "45103": true,
      "45104": true,
      "45105": true,
      "45106": true,
      "45107": true,
      "45108": true,
      "45109": true,
      "45110": true,
      "45111": true,
      "45112": true,
      "45113": true,
      "45114": true,
      "45115": true,
      "45116": true,
      "45117": true,
      "45118": true,
      "45119": true,
      "45120": true,
      "45121": true,
      "45122": true,
      "45123": true,
      "45124": true,
      "45125": true,
      "45126": true,
      "45127": true,
      "45128": true,
      "45129": true,
      "45130": true,
      "45131": true,
      "45132": true,
      "45133": true,
      "45134": true,
      "45135": true,
      "45136": true,
      "45137": true,
      "45138": true,
      "45139": true,
      "45140": true,
      "45141": true,
      "45142": true,
      "45143": true,
      "45144": true,
      "45145": true,
      "45146": true,
      "45147": true,
      "45148": true,
      "45149": true,
      "45150": true,
      "45151": true,
      "45152": true,
      "45153": true,
      "45154": true,
      "45155": true,
      "45156": true,
      "45157": true,
      "45158": true,
      "45159": true,
      "45160": true,
      "45161": true,
      "45162": true,
      "45163": true,
      "45164": true,
      "45165": true,
      "45166": true,
      "45167": true,
      "45168": true,
      "45169": true,
      "45170": true,
      "45171": true,
      "45172": true,
      "45173": true,
      "45174": true,
      "45175": true,
      "45176": true,
      "45177": true,
      "45178": true,
      "45179": true,
      "45180": true,
      "45181": true,
      "45182": true,
      "45183": true,
      "45184": true,
      "45185": true,
      "45186": true,
      "45187": true,
      "45188": true,
      "45189": true,
      "45190": true,
      "45191": true,
      "45192": true,
      "45193": true,
      "45194": true,
      "45195": true,
      "45196": true,
      "45197": true,
      "45198": true,
      "45199": true,
      "45200": true,
      "45201": true,
      "45202": true,
      "45203": true,
      "45204": true,
      "45205": true,
      "45206": true,
      "45207": true,
      "45208": true,
      "45209": true,
      "45210": true,
      "45211": true,
      "45212": true,
      "45213": true,
      "45214": true,
      "45215": true,
      "45216": true,
      "45217": true,
      "45218": true,
      "45219": true,
      "45220": true,
      "45221": true,
      "45222": true,
      "45223": true,
      "45224": true,
      "45225": true,
      "45226": true,
      "45227": true,
      "45228": true,
      "45229": true,
      "45230": true,
      "45231": true,
      "45232": true,
      "45233": true,
      "45234": true,
      "45235": true,
      "45236": true,
      "45237": true,
      "45238": true,
      "45239": true,
      "45240": true,
      "45241": true,
      "45242": true,
      "45243": true,
      "45244": true,
      "45245": true,
      "45246": true,
      "45247": true,
      "45248": true,
      "45249": true
    },
    "ZAPOTILTIC": {
      "49600": true,
      "49601": true,
      "49602": true,
      "49603": true,
      "49604": true,
      "49605": true,
      "49606": true,
      "49608": true,
      "49609": true,
      "49610": true,
      "49611": true,
      "49612": true,
      "49613": true,
      "49614": true,
      "49615": true,
      "49616": true,
      "49617": true,
      "49618": true,
      "49619": true,
      "49620": true,
      "49621": true,
      "49622": true,
      "49623": true,
      "49624": true,
      "49625": true,
      "49626": true,
      "49627": true,
      "49628": true,
      "49629": true,
      "49630": true,
      "49631": true,
      "49632": true,
      "49633": true,
      "49634": true,
      "49635": true,
      "49636": true,
      "49637": true,
      "49638": true,
      "49639": true,
      "49640": true,
      "49641": true,
      "49642": true,
      "49643": true,
      "49644": true,
      "49645": true,
      "49646": true,
      "49647": true,
      "49648": true,
      "49649": true
    },
    "ZAPOTITLAN DE VADILLO": {
      "49770": true,
      "49771": true,
      "49772": true,
      "49773": true,
      "49774": true,
      "49775": true,
      "49776": true,
      "49777": true,
      "49778": true,
      "49779": true,
      "49783": true,
      "49784": true,
      "49785": true,
      "49786": true,
      "49787": true,
      "49788": true,
      "49789": true,
      "49790": true,
      "49791": true,
      "49792": true,
      "49793": true,
      "49794": true,
      "49795": true,
      "49796": true,
      "49797": true,
      "49798": true,
      "49799": true
    },
    "ZAPOTLAN DEL REY": {
      "45980": true,
      "45981": true,
      "45982": true,
      "45983": true,
      "45986": true,
      "45987": true,
      "45988": true,
      "45989": true,
      "45990": true,
      "45991": true,
      "45992": true,
      "45993": true,
      "45994": true,
      "45995": true,
      "45996": true,
      "45997": true,
      "45998": true,
      "45999": true
    },
    "ZAPOTLAN EL GRANDE": {
      "49000": true,
      "49001": true,
      "49002": true,
      "49003": true,
      "49004": true,
      "49005": true,
      "49006": true,
      "49007": true,
      "49008": true,
      "49009": true,
      "49010": true,
      "49011": true,
      "49012": true,
      "49013": true,
      "49014": true,
      "49015": true,
      "49016": true,
      "49017": true,
      "49018": true,
      "49019": true,
      "49020": true,
      "49021": true,
      "49022": true,
      "49023": true,
      "49024": true,
      "49025": true,
      "49026": true,
      "49027": true,
      "49028": true,
      "49029": true,
      "49030": true,
      "49031": true,
      "49032": true,
      "49033": true,
      "49034": true,
      "49035": true,
      "49036": true,
      "49037": true,
      "49038": true,
      "49039": true,
      "49040": true,
      "49041": true,
      "49042": true,
      "49043": true,
      "49044": true,
      "49045": true,
      "49046": true,
      "49047": true,
      "49048": true,
      "49049": true,
      "49050": true,
      "49051": true,
      "49052": true,
      "49053": true,
      "49054": true,
      "49055": true,
      "49056": true,
      "49057": true,
      "49058": true,
      "49059": true,
      "49060": true,
      "49061": true,
      "49062": true,
      "49063": true,
      "49064": true,
      "49065": true,
      "49066": true,
      "49067": true,
      "49068": true,
      "49069": true,
      "49070": true,
      "49071": true,
      "49072": true,
      "49073": true,
      "49074": true,
      "49075": true,
      "49076": true,
      "49077": true,
      "49078": true,
      "49079": true,
      "49080": true,
      "49081": true,
      "49082": true,
      "49083": true,
      "49084": true,
      "49085": true,
      "49086": true,
      "49087": true,
      "49088": true,
      "49089": true,
      "49090": true,
      "49091": true,
      "49092": true,
      "49093": true,
      "49094": true,
      "49095": true,
      "49096": true,
      "49097": true,
      "49098": true,
      "49099": true,
      "49100": true,
      "49101": true,
      "49102": true,
      "49103": true,
      "49104": true,
      "49105": true,
      "49106": true,
      "49107": true,
      "49108": true,
      "49109": true,
      "49110": true,
      "49111": true,
      "49112": true,
      "49113": true,
      "49114": true,
      "49115": true,
      "49116": true,
      "49117": true,
      "49118": true,
      "49119": true
    },
    "ZAPOTLANEJO": {
      "45430": true,
      "45431": true,
      "45432": true,
      "45433": true,
      "45434": true,
      "45435": true,
      "45437": true,
      "45438": true,
      "45440": true,
      "45441": true,
      "45442": true,
      "45443": true,
      "45444": true,
      "45445": true,
      "45446": true,
      "45447": true,
      "45448": true,
      "45449": true,
      "45450": true,
      "45451": true,
      "45453": true,
      "45454": true,
      "45455": true,
      "45456": true,
      "45457": true,
      "45458": true,
      "45459": true,
      "45460": true,
      "45461": true,
      "45462": true,
      "45463": true,
      "45464": true,
      "45465": true,
      "45466": true,
      "45467": true,
      "45468": true,
      "45469": true
    }
  },
  "MICHOACÁN": {
    "ACUITZIO": {
      "58460": true,
      "58461": true,
      "58462": true,
      "58463": true,
      "58464": true,
      "58465": true,
      "58466": true,
      "58467": true,
      "58468": true,
      "58469": true,
      "58470": true,
      "58471": true,
      "58472": true,
      "58473": true,
      "58474": true,
      "58475": true,
      "58476": true,
      "58477": true,
      "58478": true,
      "58479": true
    },
    "ALVARO OBREGÓN": {
      "58920": true,
      "58921": true,
      "58922": true,
      "58923": true,
      "58924": true,
      "58925": true,
      "58926": true,
      "58927": true,
      "58928": true,
      "58929": true
    },
    "ANGANGUEO": {
      "61410": true,
      "61411": true,
      "61412": true,
      "61413": true,
      "61414": true,
      "61415": true,
      "61416": true,
      "61417": true,
      "61418": true,
      "61419": true
    },
    "APATZINGAN": {
      "60600": true,
      "60601": true,
      "60602": true,
      "60603": true,
      "60604": true,
      "60605": true,
      "60606": true,
      "60607": true,
      "60608": true,
      "60609": true,
      "60610": true,
      "60611": true,
      "60612": true,
      "60613": true,
      "60614": true,
      "60615": true,
      "60616": true,
      "60617": true,
      "60618": true,
      "60619": true,
      "60620": true,
      "60621": true,
      "60622": true,
      "60623": true,
      "60624": true,
      "60625": true,
      "60626": true,
      "60627": true,
      "60628": true,
      "60629": true,
      "60630": true,
      "60631": true,
      "60632": true,
      "60633": true,
      "60634": true,
      "60635": true,
      "60636": true,
      "60637": true,
      "60638": true,
      "60639": true,
      "60640": true,
      "60641": true,
      "60642": true,
      "60643": true,
      "60644": true,
      "60645": true,
      "60646": true,
      "60647": true,
      "60648": true,
      "60649": true,
      "60650": true,
      "60651": true,
      "60652": true,
      "60653": true,
      "60654": true,
      "60656": true,
      "60657": true,
      "60658": true,
      "60659": true,
      "60660": true,
      "60661": true,
      "60662": true,
      "60663": true,
      "60664": true,
      "60665": true,
      "60666": true,
      "60667": true,
      "60668": true,
      "60669": true,
      "60670": true,
      "60671": true,
      "60672": true,
      "60673": true,
      "60674": true,
      "60675": true,
      "60676": true,
      "60677": true,
      "60678": true,
      "60679": true,
      "60680": true,
      "60681": true,
      "60682": true,
      "60683": true,
      "60684": true,
      "60685": true,
      "60686": true,
      "60687": true,
      "60688": true,
      "60689": true,
      "60690": true,
      "60691": true,
      "60692": true,
      "60693": true,
      "60694": true,
      "60695": true,
      "60696": true,
      "60697": true,
      "60698": true,
      "60699": true,
      "60700": true,
      "60701": true,
      "60702": true,
      "60703": true,
      "60704": true,
      "60705": true,
      "60706": true,
      "60707": true,
      "60708": true,
      "60709": true,
      "60710": true,
      "60711": true,
      "60712": true,
      "60713": true,
      "60714": true,
      "60715": true,
      "60716": true,
      "60717": true,
      "60718": true,
      "60719": true,
      "60720": true,
      "60721": true,
      "60722": true,
      "60723": true,
      "60725": true,
      "60730": true,
      "60731": true,
      "60732": true,
      "60733": true,
      "60740": true,
      "60741": true,
      "60742": true,
      "60743": true,
      "60744": true,
      "60745": true,
      "60746": true,
      "60747": true,
      "60748": true,
      "60749": true,
      "60753": true,
      "60754": true,
      "60755": true
    },
    "ARIO": {
      "61830": true,
      "61831": true,
      "61832": true,
      "61834": true,
      "61836": true,
      "61837": true,
      "61838": true,
      "61845": true,
      "61846": true,
      "61847": true,
      "61848": true,
      "61849": true
    },
    "ARTEAGA": {
      "60920": true,
      "60921": true,
      "60922": true,
      "60923": true,
      "60926": true,
      "60929": true,
      "60932": true,
      "60934": true,
      "60940": true,
      "60941": true,
      "60942": true,
      "60943": true,
      "60944": true,
      "60945": true,
      "60946": true,
      "60947": true
    },
    "BRISENAS": {
      "59120": true,
      "59124": true,
      "59125": true
    },
    "BUENAVISTA": {
      "60500": true,
      "60501": true,
      "60502": true,
      "60503": true,
      "60504": true,
      "60505": true,
      "60506": true,
      "60507": true,
      "60508": true,
      "60509": true,
      "60510": true,
      "60511": true,
      "60512": true,
      "60513": true,
      "60514": true,
      "60515": true,
      "60516": true,
      "60517": true,
      "60518": true,
      "60519": true,
      "60520": true,
      "60521": true,
      "60522": true,
      "60525": true,
      "60526": true,
      "60527": true,
      "60528": true,
      "60529": true,
      "60530": true,
      "60531": true,
      "60532": true,
      "60533": true,
      "60534": true,
      "60535": true,
      "60536": true
    },
    "CHARO": {
      "61300": true,
      "61301": true,
      "61302": true,
      "61303": true,
      "61304": true,
      "61305": true,
      "61306": true,
      "61307": true,
      "61308": true,
      "61309": true,
      "61310": true,
      "61311": true,
      "61312": true,
      "61313": true,
      "61314": true,
      "61315": true,
      "61316": true,
      "61317": true,
      "61318": true,
      "61319": true,
      "61320": true,
      "61321": true,
      "61322": true,
      "61323": true,
      "61324": true,
      "61325": true,
      "61326": true,
      "61327": true
    },
    "CHAVINDA": {
      "59580": true,
      "59581": true,
      "59582": true,
      "59583": true,
      "59584": true,
      "59585": true,
      "59586": true,
      "59587": true,
      "59588": true,
      "59589": true,
      "59590": true,
      "59591": true,
      "59592": true,
      "59593": true,
      "59594": true,
      "59595": true,
      "59596": true,
      "59597": true,
      "59598": true,
      "59599": true
    },
    "CHERAN": {
      "60270": true,
      "60271": true,
      "60272": true,
      "60273": true,
      "60274": true,
      "60275": true,
      "60276": true,
      "60277": true,
      "60278": true,
      "60279": true
    },
    "CHILCHOTA": {
      "59780": true,
      "59781": true,
      "59782": true,
      "59783": true,
      "59784": true,
      "59785": true,
      "59786": true,
      "59787": true,
      "59788": true,
      "59789": true,
      "59790": true,
      "59791": true,
      "59792": true,
      "59793": true,
      "59794": true,
      "59795": true,
      "59796": true,
      "59797": true,
      "59798": true,
      "59799": true
    },
    "CHUCANDIRO": {
      "58860": true,
      "58861": true,
      "58862": true,
      "58863": true,
      "58864": true,
      "58866": true,
      "58867": true,
      "58868": true,
      "58869": true
    },
    "CHURINTZIO": {
      "59440": true,
      "59441": true,
      "59442": true,
      "59443": true,
      "59444": true,
      "59445": true,
      "59446": true,
      "59447": true,
      "59448": true,
      "59449": true,
      "59450": true,
      "59451": true,
      "59452": true,
      "59453": true,
      "59454": true,
      "59455": true,
      "59456": true,
      "59457": true,
      "59458": true,
      "59459": true
    },
    "COENEO": {
      "58400": true,
      "58401": true,
      "58402": true,
      "58406": true,
      "58407": true,
      "58408": true,
      "58409": true
    },
    "COJUMATLAN DE REGULES": {
      "59140": true,
      "59141": true,
      "59142": true,
      "59143": true,
      "59144": true,
      "59145": true,
      "59146": true,
      "59147": true,
      "59148": true,
      "59149": true,
      "59150": true,
      "59151": true,
      "59152": true,
      "59153": true,
      "59154": true,
      "59155": true,
      "59156": true,
      "59157": true,
      "59158": true,
      "59159": true
    },
    "CONTEPEC": {
      "61020": true,
      "61021": true,
      "61022": true,
      "61023": true,
      "61024": true,
      "61025": true,
      "61026": true,
      "61027": true,
      "61028": true,
      "61029": true,
      "61030": true,
      "61031": true,
      "61032": true,
      "61033": true,
      "61034": true,
      "61035": true,
      "61036": true,
      "61037": true,
      "61038": true,
      "61039": true,
      "61040": true,
      "61041": true,
      "61042": true,
      "61043": true,
      "61044": true,
      "61045": true,
      "61046": true,
      "61047": true,
      "61048": true,
      "61049": true,
      "61050": true,
      "61051": true,
      "61052": true,
      "61053": true,
      "61054": true,
      "61055": true,
      "61056": true,
      "61057": true,
      "61058": true,
      "61059": true
    },
    "COPANDARO": {
      "58870": true,
      "58871": true,
      "58873": true,
      "58874": true,
      "58875": true,
      "58876": true,
      "58877": true,
      "58878": true,
      "58879": true
    },
    "COTIJA": {
      "59940": true,
      "59941": true,
      "59942": true,
      "59943": true,
      "59944": true,
      "59945": true,
      "59946": true,
      "59947": true,
      "59948": true,
      "59949": true,
      "59950": true,
      "59951": true,
      "59952": true,
      "59953": true,
      "59954": true
    },
    "CUITZEO": {
      "58840": true,
      "58841": true,
      "58842": true,
      "58843": true,
      "58844": true,
      "58845": true,
      "58846": true,
      "58847": true,
      "58848": true,
      "58849": true,
      "58850": true,
      "58851": true,
      "58852": true,
      "58853": true,
      "58854": true,
      "58855": true,
      "58856": true,
      "58857": true,
      "58858": true,
      "58859": true
    },
    "ECUANDUREO": {
      "59730": true,
      "59731": true,
      "59732": true,
      "59733": true,
      "59734": true,
      "59735": true,
      "59736": true,
      "59737": true,
      "59738": true,
      "59739": true,
      "59740": true,
      "59741": true,
      "59742": true,
      "59743": true,
      "59744": true,
      "59745": true,
      "59746": true,
      "59747": true,
      "59748": true,
      "59749": true
    },
    "ERONGARICUARO": {
      "61630": true,
      "61631": true,
      "61632": true,
      "61633": true,
      "61634": true,
      "61635": true,
      "61636": true,
      "61637": true,
      "61638": true,
      "61639": true
    },
    "GABRIEL ZAMORA": {
      "61730": true,
      "61731": true,
      "61732": true,
      "61733": true,
      "61734": true,
      "61735": true,
      "61736": true,
      "61737": true,
      "61738": true,
      "61739": true,
      "61740": true,
      "61741": true,
      "61742": true,
      "61743": true,
      "61744": true,
      "61745": true,
      "61746": true,
      "61747": true,
      "61748": true,
      "61749": true
    },
    "HIDALGO": {
      "61100": true,
      "61101": true,
      "61102": true,
      "61103": true,
      "61104": true,
      "61105": true,
      "61106": true,
      "61107": true,
      "61108": true,
      "61109": true,
      "61110": true,
      "61111": true,
      "61112": true,
      "61113": true,
      "61114": true,
      "61115": true,
      "61116": true,
      "61117": true,
      "61118": true,
      "61119": true,
      "61120": true,
      "61121": true,
      "61122": true,
      "61123": true,
      "61124": true,
      "61125": true,
      "61126": true,
      "61127": true,
      "61128": true,
      "61129": true,
      "61130": true,
      "61131": true,
      "61132": true,
      "61133": true,
      "61134": true,
      "61135": true,
      "61136": true,
      "61137": true,
      "61138": true,
      "61139": true,
      "61140": true,
      "61141": true,
      "61142": true,
      "61143": true,
      "61144": true,
      "61145": true,
      "61146": true,
      "61147": true,
      "61148": true,
      "61149": true,
      "61150": true,
      "61151": true,
      "61152": true,
      "61153": true,
      "61154": true,
      "61155": true,
      "61156": true,
      "61157": true,
      "61158": true,
      "61159": true,
      "61160": true,
      "61161": true,
      "61162": true,
      "61163": true,
      "61164": true,
      "61165": true,
      "61166": true,
      "61167": true,
      "61168": true,
      "61169": true,
      "61170": true,
      "61171": true,
      "61172": true,
      "61173": true,
      "61174": true,
      "61175": true,
      "61176": true,
      "61177": true,
      "61178": true,
      "61179": true,
      "61180": true,
      "61181": true,
      "61182": true,
      "61183": true,
      "61184": true,
      "61185": true,
      "61186": true,
      "61187": true,
      "61188": true,
      "61189": true,
      "61190": true,
      "61191": true,
      "61192": true,
      "61193": true,
      "61194": true,
      "61196": true,
      "61197": true,
      "61198": true,
      "61199": true,
      "61200": true,
      "61201": true,
      "61202": true,
      "61203": true,
      "61205": true,
      "61206": true,
      "61207": true,
      "61208": true,
      "61209": true,
      "61210": true,
      "61211": true,
      "61212": true,
      "61213": true,
      "61214": true,
      "61215": true,
      "61216": true,
      "61217": true,
      "61218": true,
      "61219": true,
      "61223": true,
      "61224": true,
      "61225": true,
      "61226": true,
      "61228": true,
      "61229": true,
      "61230": true,
      "61231": true,
      "61232": true,
      "61233": true,
      "61234": true,
      "61235": true,
      "61236": true,
      "61237": true,
      "61238": true,
      "61239": true,
      "61240": true,
      "61241": true,
      "61243": true,
      "61244": true,
      "61245": true,
      "61247": true,
      "61248": true,
      "61249": true
    },
    "HUANDACAREO": {
      "58820": true,
      "58821": true,
      "58822": true,
      "58823": true,
      "58824": true,
      "58825": true,
      "58826": true,
      "58827": true,
      "58828": true,
      "58829": true,
      "58830": true,
      "58831": true,
      "58832": true,
      "58833": true,
      "58834": true,
      "58835": true,
      "58836": true,
      "58837": true,
      "58838": true,
      "58839": true
    },
    "HUANIQUEO": {
      "58360": true,
      "58361": true,
      "58362": true,
      "58363": true,
      "58364": true,
      "58365": true,
      "58366": true,
      "58367": true,
      "58368": true,
      "58369": true,
      "58370": true,
      "58371": true,
      "58372": true,
      "58373": true,
      "58374": true,
      "58375": true,
      "58376": true,
      "58377": true,
      "58378": true,
      "58379": true,
      "58380": true,
      "58381": true,
      "58382": true,
      "58383": true,
      "58384": true,
      "58385": true,
      "58386": true,
      "58387": true,
      "58388": true,
      "58389": true,
      "58390": true,
      "58391": true,
      "58392": true,
      "58393": true,
      "58394": true,
      "58395": true,
      "58396": true,
      "58397": true,
      "58398": true,
      "58399": true
    },
    "HUETAMO": {
      "61940": true,
      "61941": true,
      "61942": true,
      "61943": true,
      "61944": true,
      "61945": true,
      "61946": true,
      "61947": true,
      "61948": true,
      "61949": true,
      "61950": true,
      "61951": true,
      "61956": true,
      "61957": true,
      "61958": true,
      "61959": true,
      "61960": true,
      "61961": true,
      "61962": true,
      "61969": true,
      "61970": true,
      "61971": true,
      "61972": true,
      "61973": true,
      "61974": true,
      "61975": true,
      "61976": true,
      "61977": true,
      "61978": true,
      "61979": true
    },
    "HUIRAMBA": {
      "61640": true,
      "61641": true,
      "61642": true,
      "61643": true,
      "61644": true,
      "61645": true,
      "61646": true,
      "61647": true,
      "61648": true,
      "61649": true
    },
    "INDAPARAPEO": {
      "58970": true,
      "58971": true,
      "58972": true,
      "58973": true,
      "58974": true,
      "58975": true,
      "58976": true,
      "58977": true,
      "58978": true,
      "58979": true
    },
    "IRIMBO": {
      "61280": true,
      "61281": true,
      "61282": true,
      "61283": true,
      "61284": true,
      "61285": true,
      "61286": true,
      "61287": true,
      "61288": true,
      "61289": true
    },
    "IXTLAN": {
      "59280": true,
      "59281": true,
      "59282": true,
      "59283": true,
      "59284": true,
      "59285": true,
      "59286": true,
      "59287": true,
      "59288": true,
      "59289": true,
      "59290": true,
      "59291": true,
      "59292": true,
      "59293": true,
      "59294": true,
      "59295": true,
      "59296": true,
      "59297": true,
      "59298": true,
      "59299": true
    },
    "JACONA": {
      "59800": true,
      "59801": true,
      "59802": true,
      "59803": true,
      "59804": true,
      "59805": true,
      "59806": true,
      "59807": true,
      "59808": true,
      "59809": true,
      "59810": true,
      "59811": true,
      "59812": true,
      "59813": true,
      "59814": true,
      "59815": true,
      "59816": true,
      "59817": true,
      "59818": true,
      "59819": true,
      "59820": true,
      "59821": true,
      "59822": true,
      "59823": true,
      "59824": true,
      "59825": true,
      "59826": true,
      "59827": true,
      "59828": true,
      "59829": true,
      "59830": true,
      "59831": true,
      "59832": true,
      "59833": true,
      "59834": true,
      "59835": true,
      "59836": true,
      "59837": true,
      "59838": true,
      "59839": true,
      "59840": true,
      "59841": true,
      "59842": true,
      "59843": true,
      "59844": true,
      "59845": true,
      "59846": true,
      "59847": true,
      "59848": true,
      "59849": true,
      "59850": true,
      "59851": true,
      "59852": true,
      "59853": true,
      "59854": true,
      "59855": true,
      "59856": true,
      "59857": true,
      "59858": true,
      "59859": true,
      "59860": true,
      "59861": true,
      "59862": true,
      "59863": true,
      "59864": true,
      "59865": true,
      "59866": true,
      "59867": true,
      "59868": true,
      "59869": true,
      "59870": true,
      "59871": true,
      "59872": true,
      "59873": true,
      "59874": true,
      "59875": true,
      "59876": true,
      "59877": true,
      "59878": true,
      "59879": true,
      "59880": true,
      "59881": true,
      "59882": true,
      "59883": true,
      "59884": true,
      "59885": true,
      "59886": true,
      "59887": true,
      "59888": true,
      "59889": true,
      "59890": true,
      "59891": true,
      "59892": true,
      "59893": true,
      "59894": true,
      "59895": true,
      "59896": true,
      "59897": true,
      "59898": true,
      "59899": true,
      "59900": true,
      "59901": true,
      "59902": true,
      "59903": true,
      "59904": true,
      "59905": true,
      "59906": true,
      "59907": true,
      "59908": true,
      "59909": true,
      "59910": true,
      "59911": true,
      "59912": true,
      "59913": true,
      "59914": true,
      "59915": true,
      "59916": true,
      "59917": true,
      "59918": true,
      "59919": true
    },
    "JIMENEZ": {
      "58780": true,
      "58781": true,
      "58782": true,
      "58783": true,
      "58784": true,
      "58785": true,
      "58786": true,
      "58787": true,
      "58790": true,
      "58791": true,
      "58792": true,
      "58794": true,
      "58795": true,
      "58796": true,
      "58797": true,
      "58798": true,
      "58799": true
    },
    "JIQUILPAN": {
      "59510": true,
      "59511": true,
      "59512": true,
      "59513": true,
      "59514": true,
      "59515": true,
      "59516": true,
      "59517": true,
      "59518": true,
      "59519": true,
      "59520": true,
      "59521": true,
      "59522": true,
      "59523": true,
      "59524": true,
      "59525": true,
      "59526": true,
      "59527": true,
      "59528": true,
      "59529": true,
      "59530": true,
      "59531": true,
      "59532": true,
      "59533": true,
      "59534": true,
      "59535": true,
      "59536": true,
      "59537": true,
      "59538": true,
      "59539": true,
      "59540": true,
      "59541": true,
      "59542": true,
      "59543": true,
      "59544": true,
      "59546": true,
      "59547": true,
      "59548": true,
      "59549": true
    },
    "JUNGAPEO": {
      "61470": true,
      "61471": true,
      "61472": true,
      "61473": true,
      "61474": true,
      "61475": true,
      "61476": true,
      "61477": true,
      "61478": true,
      "61479": true,
      "61480": true,
      "61481": true,
      "61482": true,
      "61483": true,
      "61484": true,
      "61485": true,
      "61486": true,
      "61487": true,
      "61488": true,
      "61489": true,
      "61493": true,
      "61494": true,
      "61495": true,
      "61496": true,
      "61497": true,
      "61498": true,
      "61499": true
    },
    "LA HUACANA": {
      "61850": true,
      "61851": true,
      "61852": true,
      "61853": true,
      "61854": true,
      "61855": true,
      "61856": true,
      "61863": true,
      "61865": true,
      "61866": true,
      "61867": true,
      "61870": true,
      "61871": true,
      "61872": true,
      "61874": true,
      "61877": true,
      "61878": true,
      "61879": true
    },
    "LA PIEDAD": {
      "59300": true,
      "59301": true,
      "59302": true,
      "59303": true,
      "59304": true,
      "59305": true,
      "59306": true,
      "59307": true,
      "59308": true,
      "59309": true,
      "59310": true,
      "59311": true,
      "59312": true,
      "59313": true,
      "59314": true,
      "59315": true,
      "59316": true,
      "59317": true,
      "59318": true,
      "59319": true,
      "59320": true,
      "59321": true,
      "59322": true,
      "59323": true,
      "59324": true,
      "59325": true,
      "59326": true,
      "59327": true,
      "59328": true,
      "59329": true,
      "59330": true,
      "59331": true,
      "59332": true,
      "59333": true,
      "59334": true,
      "59335": true,
      "59336": true,
      "59337": true,
      "59338": true,
      "59339": true,
      "59340": true,
      "59341": true,
      "59342": true,
      "59343": true,
      "59344": true,
      "59345": true,
      "59346": true,
      "59347": true,
      "59348": true,
      "59349": true,
      "59350": true,
      "59351": true,
      "59352": true,
      "59353": true,
      "59354": true,
      "59355": true,
      "59356": true,
      "59357": true,
      "59358": true,
      "59359": true,
      "59360": true,
      "59361": true,
      "59362": true,
      "59363": true,
      "59364": true,
      "59365": true,
      "59366": true,
      "59367": true,
      "59368": true,
      "59369": true,
      "59370": true,
      "59371": true,
      "59372": true,
      "59373": true,
      "59374": true,
      "59375": true,
      "59376": true,
      "59377": true,
      "59378": true,
      "59379": true,
      "59380": true,
      "59381": true,
      "59382": true,
      "59383": true,
      "59384": true,
      "59385": true,
      "59386": true,
      "59387": true,
      "59388": true,
      "59389": true,
      "59390": true,
      "59391": true,
      "59392": true,
      "59393": true,
      "59394": true,
      "59395": true,
      "59396": true,
      "59397": true,
      "59398": true,
      "59399": true,
      "59400": true,
      "59401": true,
      "59402": true,
      "59403": true,
      "59404": true,
      "59405": true,
      "59406": true,
      "59407": true,
      "59408": true,
      "59409": true,
      "59410": true,
      "59411": true,
      "59412": true,
      "59413": true,
      "59414": true,
      "59415": true,
      "59416": true,
      "59417": true,
      "59418": true,
      "59419": true,
      "59420": true,
      "59421": true,
      "59422": true,
      "59423": true,
      "59424": true,
      "59425": true,
      "59426": true,
      "59427": true,
      "59428": true,
      "59429": true
    },
    "LAGUNILLAS": {
      "58450": true,
      "58451": true,
      "58452": true,
      "58453": true,
      "58454": true,
      "58455": true,
      "58456": true,
      "58457": true,
      "58458": true,
      "58459": true
    },
    "LAZARO CARDENAS": {
      "60950": true,
      "60951": true,
      "60952": true,
      "60953": true,
      "60954": true,
      "60955": true,
      "60956": true,
      "60957": true,
      "60958": true,
      "60959": true,
      "60967": true,
      "60970": true,
      "60971": true,
      "60972": true,
      "60980": true,
      "60981": true,
      "60982": true,
      "60983": true,
      "60984": true,
      "60985": true,
      "60986": true,
      "60987": true,
      "60990": true,
      "60991": true,
      "60992": true,
      "60993": true,
      "60994": true,
      "60995": true,
      "60996": true,
      "60997": true,
      "60998": true,
      "60999": true
    },
    "LOS REYES": {
      "60300": true,
      "60301": true,
      "60302": true,
      "60303": true,
      "60304": true,
      "60305": true,
      "60306": true,
      "60307": true,
      "60308": true,
      "60309": true,
      "60310": true,
      "60311": true,
      "60312": true,
      "60313": true,
      "60314": true,
      "60315": true,
      "60316": true,
      "60317": true,
      "60318": true,
      "60319": true,
      "60320": true,
      "60321": true,
      "60322": true,
      "60323": true,
      "60324": true,
      "60325": true,
      "60326": true,
      "60327": true,
      "60328": true,
      "60329": true,
      "60330": true,
      "60331": true,
      "60332": true,
      "60333": true,
      "60334": true,
      "60335": true,
      "60336": true,
      "60337": true,
      "60338": true,
      "60339": true,
      "60340": true,
      "60341": true,
      "60342": true,
      "60343": true,
      "60344": true,
      "60345": true,
      "60346": true,
      "60347": true,
      "60348": true,
      "60349": true,
      "60350": true,
      "60351": true,
      "60352": true,
      "60353": true,
      "60354": true,
      "60355": true,
      "60356": true,
      "60357": true,
      "60358": true,
      "60359": true,
      "60360": true,
      "60361": true,
      "60362": true,
      "60363": true,
      "60364": true,
      "60365": true,
      "60366": true,
      "60367": true,
      "60368": true,
      "60369": true,
      "60370": true,
      "60371": true,
      "60372": true,
      "60373": true,
      "60374": true,
      "60375": true,
      "60376": true,
      "60377": true,
      "60378": true,
      "60379": true,
      "60380": true,
      "60381": true,
      "60382": true,
      "60383": true,
      "60384": true,
      "60385": true,
      "60386": true,
      "60387": true,
      "60388": true,
      "60389": true,
      "60390": true,
      "60391": true,
      "60392": true,
      "60393": true,
      "60394": true,
      "60395": true,
      "60396": true,
      "60397": true,
      "60398": true,
      "60399": true,
      "60400": true,
      "60401": true,
      "60402": true,
      "60403": true,
      "60404": true,
      "60405": true,
      "60406": true,
      "60407": true,
      "60408": true,
      "60409": true,
      "60413": true,
      "60414": true,
      "60415": true,
      "60416": true,
      "60417": true,
      "60418": true,
      "60419": true,
      "60420": true,
      "60421": true,
      "60422": true,
      "60423": true,
      "60424": true,
      "60425": true,
      "60426": true,
      "60427": true,
      "60428": true,
      "60429": true,
      "60430": true,
      "60431": true,
      "60432": true,
      "60433": true
    },
    "MADERO": {
      "58480": true,
      "58481": true,
      "58482": true,
      "58483": true,
      "58486": true,
      "58487": true,
      "58488": true,
      "58489": true,
      "58497": true,
      "58498": true,
      "58499": true
    },
    "MARAVATIO": {
      "61250": true,
      "61251": true,
      "61252": true,
      "61253": true,
      "61254": true,
      "61255": true,
      "61256": true,
      "61257": true,
      "61258": true,
      "61259": true,
      "61260": true,
      "61261": true,
      "61262": true,
      "61263": true,
      "61264": true,
      "61265": true,
      "61266": true,
      "61267": true,
      "61268": true,
      "61269": true,
      "61274": true,
      "61276": true,
      "61277": true,
      "61278": true
    },
    "MORELIA": {
      "58000": true,
      "58001": true,
      "58002": true,
      "58003": true,
      "58004": true,
      "58005": true,
      "58006": true,
      "58007": true,
      "58008": true,
      "58009": true,
      "58010": true,
      "58011": true,
      "58012": true,
      "58013": true,
      "58014": true,
      "58015": true,
      "58016": true,
      "58017": true,
      "58018": true,
      "58019": true,
      "58020": true,
      "58021": true,
      "58022": true,
      "58023": true,
      "58024": true,
      "58025": true,
      "58026": true,
      "58027": true,
      "58028": true,
      "58029": true,
      "58030": true,
      "58031": true,
      "58032": true,
      "58033": true,
      "58034": true,
      "58035": true,
      "58036": true,
      "58037": true,
      "58038": true,
      "58039": true,
      "58040": true,
      "58041": true,
      "58042": true,
      "58043": true,
      "58044": true,
      "58045": true,
      "58046": true,
      "58047": true,
      "58048": true,
      "58049": true,
      "58050": true,
      "58051": true,
      "58052": true,
      "58053": true,
      "58054": true,
      "58055": true,
      "58056": true,
      "58057": true,
      "58058": true,
      "58059": true,
      "58060": true,
      "58061": true,
      "58062": true,
      "58063": true,
      "58064": true,
      "58065": true,
      "58066": true,
      "58067": true,
      "58068": true,
      "58069": true,
      "58070": true,
      "58071": true,
      "58072": true,
      "58073": true,
      "58074": true,
      "58075": true,
      "58076": true,
      "58077": true,
      "58078": true,
      "58079": true,
      "58080": true,
      "58081": true,
      "58082": true,
      "58083": true,
      "58084": true,
      "58085": true,
      "58086": true,
      "58087": true,
      "58088": true,
      "58089": true,
      "58090": true,
      "58091": true,
      "58092": true,
      "58093": true,
      "58094": true,
      "58095": true,
      "58096": true,
      "58097": true,
      "58098": true,
      "58099": true,
      "58100": true,
      "58101": true,
      "58102": true,
      "58103": true,
      "58104": true,
      "58105": true,
      "58106": true,
      "58107": true,
      "58108": true,
      "58109": true,
      "58110": true,
      "58111": true,
      "58112": true,
      "58113": true,
      "58114": true,
      "58115": true,
      "58116": true,
      "58117": true,
      "58118": true,
      "58119": true,
      "58120": true,
      "58121": true,
      "58122": true,
      "58123": true,
      "58124": true,
      "58125": true,
      "58126": true,
      "58127": true,
      "58128": true,
      "58129": true,
      "58130": true,
      "58131": true,
      "58132": true,
      "58133": true,
      "58134": true,
      "58135": true,
      "58136": true,
      "58137": true,
      "58138": true,
      "58139": true,
      "58140": true,
      "58141": true,
      "58142": true,
      "58143": true,
      "58144": true,
      "58145": true,
      "58146": true,
      "58147": true,
      "58148": true,
      "58149": true,
      "58150": true,
      "58151": true,
      "58152": true,
      "58153": true,
      "58154": true,
      "58155": true,
      "58156": true,
      "58157": true,
      "58158": true,
      "58159": true,
      "58160": true,
      "58161": true,
      "58162": true,
      "58163": true,
      "58164": true,
      "58165": true,
      "58166": true,
      "58167": true,
      "58168": true,
      "58169": true,
      "58170": true,
      "58171": true,
      "58172": true,
      "58173": true,
      "58174": true,
      "58175": true,
      "58176": true,
      "58177": true,
      "58178": true,
      "58179": true,
      "58180": true,
      "58181": true,
      "58182": true,
      "58183": true,
      "58184": true,
      "58185": true,
      "58186": true,
      "58187": true,
      "58188": true,
      "58189": true,
      "58190": true,
      "58191": true,
      "58192": true,
      "58193": true,
      "58194": true,
      "58195": true,
      "58196": true,
      "58197": true,
      "58198": true,
      "58199": true,
      "58200": true,
      "58201": true,
      "58202": true,
      "58203": true,
      "58204": true,
      "58205": true,
      "58206": true,
      "58207": true,
      "58208": true,
      "58209": true,
      "58210": true,
      "58211": true,
      "58212": true,
      "58213": true,
      "58214": true,
      "58215": true,
      "58216": true,
      "58217": true,
      "58218": true,
      "58219": true,
      "58220": true,
      "58221": true,
      "58222": true,
      "58223": true,
      "58224": true,
      "58225": true,
      "58226": true,
      "58227": true,
      "58228": true,
      "58229": true,
      "58230": true,
      "58231": true,
      "58232": true,
      "58233": true,
      "58234": true,
      "58235": true,
      "58236": true,
      "58237": true,
      "58238": true,
      "58239": true,
      "58240": true,
      "58241": true,
      "58242": true,
      "58243": true,
      "58244": true,
      "58245": true,
      "58246": true,
      "58247": true,
      "58248": true,
      "58249": true,
      "58250": true,
      "58251": true,
      "58252": true,
      "58253": true,
      "58254": true,
      "58255": true,
      "58256": true,
      "58257": true,
      "58258": true,
      "58259": true,
      "58260": true,
      "58261": true,
      "58262": true,
      "58263": true,
      "58264": true,
      "58265": true,
      "58266": true,
      "58267": true,
      "58268": true,
      "58269": true,
      "58270": true,
      "58271": true,
      "58272": true,
      "58273": true,
      "58274": true,
      "58275": true,
      "58276": true,
      "58277": true,
      "58278": true,
      "58279": true,
      "58280": true,
      "58281": true,
      "58282": true,
      "58283": true,
      "58284": true,
      "58285": true,
      "58286": true,
      "58287": true,
      "58288": true,
      "58289": true,
      "58290": true,
      "58291": true,
      "58292": true,
      "58293": true,
      "58294": true,
      "58295": true,
      "58296": true,
      "58297": true,
      "58298": true,
      "58299": true,
      "58300": true,
      "58301": true,
      "58302": true,
      "58303": true,
      "58304": true,
      "58305": true,
      "58306": true,
      "58307": true,
      "58308": true,
      "58309": true,
      "58310": true,
      "58311": true,
      "58312": true,
      "58313": true,
      "58314": true,
      "58315": true,
      "58316": true,
      "58317": true,
      "58318": true,
      "58319": true,
      "58320": true,
      "58321": true,
      "58322": true,
      "58323": true,
      "58324": true,
      "58325": true,
      "58326": true,
      "58327": true,
      "58328": true,
      "58329": true,
      "58330": true,
      "58331": true,
      "58332": true,
      "58333": true,
      "58334": true,
      "58335": true,
      "58336": true,
      "58337": true,
      "58338": true,
      "58339": true,
      "58340": true,
      "58341": true,
      "58342": true,
      "58343": true,
      "58344": true,
      "58345": true,
      "58346": true,
      "58347": true,
      "58348": true,
      "58349": true,
      "58350": true,
      "58351": true,
      "58352": true,
      "58353": true,
      "58354": true,
      "58355": true,
      "58356": true,
      "58357": true,
      "58358": true,
      "58359": true
    },
    "MUGICA": {
      "61760": true,
      "61761": true,
      "61762": true,
      "61763": true,
      "61770": true,
      "61771": true,
      "61772": true,
      "61790": true,
      "61791": true,
      "61792": true
    },
    "NAHUATZEN": {
      "60280": true,
      "60281": true,
      "60282": true,
      "60285": true,
      "60286": true,
      "60287": true,
      "60288": true,
      "60289": true
    },
    "NUEVO PARANGARICUTIRO": {
      "60490": true,
      "60491": true,
      "60492": true,
      "60493": true,
      "60494": true,
      "60495": true
    },
    "NUEVO URECHO": {
      "61750": true,
      "61751": true,
      "61752": true,
      "61753": true,
      "61754": true,
      "61755": true,
      "61756": true,
      "61757": true,
      "61758": true,
      "61759": true
    },
    "NUMARAN": {
      "59430": true,
      "59431": true,
      "59432": true,
      "59433": true,
      "59434": true,
      "59435": true,
      "59436": true,
      "59437": true,
      "59438": true,
      "59439": true
    },
    "PAJACUARAN": {
      "59180": true,
      "59181": true,
      "59182": true,
      "59184": true,
      "59185": true,
      "59186": true,
      "59187": true,
      "59188": true,
      "59189": true,
      "59190": true,
      "59191": true,
      "59192": true,
      "59193": true,
      "59194": true,
      "59195": true,
      "59196": true,
      "59197": true,
      "59198": true,
      "59199": true
    },
    "PANINDICUARO": {
      "58570": true,
      "58571": true,
      "58572": true,
      "58573": true,
      "58574": true,
      "58575": true,
      "58576": true,
      "58577": true,
      "58578": true,
      "58579": true,
      "58580": true,
      "58581": true,
      "58582": true,
      "58583": true,
      "58584": true,
      "58585": true,
      "58586": true,
      "58587": true,
      "58588": true,
      "58589": true,
      "58590": true,
      "58591": true,
      "58592": true,
      "58593": true,
      "58594": true,
      "58595": true,
      "58596": true,
      "58597": true,
      "58598": true,
      "58599": true
    },
    "PARACHO": {
      "60250": true,
      "60251": true,
      "60252": true,
      "60253": true,
      "60254": true,
      "60255": true,
      "60256": true,
      "60257": true,
      "60258": true,
      "60259": true,
      "60260": true,
      "60261": true,
      "60262": true,
      "60263": true,
      "60264": true,
      "60265": true,
      "60266": true,
      "60267": true,
      "60268": true,
      "60269": true
    },
    "PATZCUARO": {
      "61600": true,
      "61601": true,
      "61602": true,
      "61603": true,
      "61604": true,
      "61605": true,
      "61606": true,
      "61607": true,
      "61608": true,
      "61609": true,
      "61610": true,
      "61611": true,
      "61612": true,
      "61613": true,
      "61614": true,
      "61615": true,
      "61616": true,
      "61617": true,
      "61618": true,
      "61619": true,
      "61620": true,
      "61621": true,
      "61622": true,
      "61623": true,
      "61624": true,
      "61625": true,
      "61626": true
    },
    "PENJAMILLO": {
      "59470": true,
      "59471": true,
      "59472": true,
      "59473": true,
      "59474": true,
      "59475": true,
      "59476": true,
      "59477": true,
      "59482": true,
      "59483": true,
      "59484": true,
      "59485": true,
      "59486": true,
      "59487": true,
      "59488": true,
      "59489": true,
      "59490": true,
      "59491": true,
      "59492": true,
      "59493": true,
      "59494": true,
      "59495": true,
      "59496": true,
      "59497": true,
      "59498": true,
      "59499": true
    },
    "PERIBAN": {
      "60440": true,
      "60441": true,
      "60442": true,
      "60443": true,
      "60444": true,
      "60445": true,
      "60446": true,
      "60447": true,
      "60448": true,
      "60449": true,
      "60450": true,
      "60451": true,
      "60452": true,
      "60453": true,
      "60454": true,
      "60455": true,
      "60456": true,
      "60457": true,
      "60458": true,
      "60459": true
    },
    "PUREPERO": {
      "58760": true,
      "58761": true,
      "58762": true,
      "58763": true,
      "58764": true,
      "58765": true,
      "58766": true,
      "58767": true,
      "58768": true,
      "58769": true,
      "58770": true,
      "58771": true,
      "58772": true,
      "58773": true,
      "58774": true,
      "58775": true,
      "58776": true,
      "58777": true,
      "58778": true,
      "58779": true
    },
    "PURUANDIRO": {
      "58500": true,
      "58501": true,
      "58502": true,
      "58503": true,
      "58504": true,
      "58505": true,
      "58506": true,
      "58507": true,
      "58508": true,
      "58509": true,
      "58510": true,
      "58511": true,
      "58512": true,
      "58513": true,
      "58514": true,
      "58515": true,
      "58516": true,
      "58517": true,
      "58518": true,
      "58519": true,
      "58520": true,
      "58521": true,
      "58522": true,
      "58523": true,
      "58524": true,
      "58525": true,
      "58526": true,
      "58527": true,
      "58528": true,
      "58529": true,
      "58530": true,
      "58531": true,
      "58532": true,
      "58533": true,
      "58534": true,
      "58535": true,
      "58536": true,
      "58537": true,
      "58538": true,
      "58539": true
    },
    "QUIROGA": {
      "58420": true,
      "58421": true,
      "58422": true,
      "58423": true,
      "58424": true,
      "58425": true,
      "58426": true,
      "58427": true,
      "58428": true,
      "58429": true,
      "58430": true,
      "58431": true,
      "58432": true,
      "58433": true,
      "58434": true,
      "58435": true
    },
    "SAHUAYO": {
      "59000": true,
      "59001": true,
      "59002": true,
      "59003": true,
      "59004": true,
      "59005": true,
      "59006": true,
      "59007": true,
      "59008": true,
      "59009": true,
      "59010": true,
      "59011": true,
      "59012": true,
      "59013": true,
      "59014": true,
      "59015": true,
      "59016": true,
      "59017": true,
      "59018": true,
      "59019": true,
      "59020": true,
      "59021": true,
      "59022": true,
      "59023": true,
      "59024": true,
      "59025": true,
      "59026": true,
      "59027": true,
      "59028": true,
      "59029": true,
      "59030": true,
      "59031": true,
      "59032": true,
      "59033": true,
      "59034": true,
      "59035": true,
      "59036": true,
      "59037": true,
      "59038": true,
      "59039": true,
      "59040": true,
      "59041": true,
      "59042": true,
      "59043": true,
      "59044": true,
      "59045": true,
      "59046": true,
      "59047": true,
      "59048": true,
      "59049": true,
      "59050": true,
      "59051": true,
      "59052": true,
      "59053": true,
      "59054": true,
      "59055": true,
      "59056": true,
      "59057": true,
      "59058": true,
      "59059": true,
      "59060": true,
      "59061": true,
      "59062": true,
      "59063": true,
      "59064": true,
      "59065": true,
      "59066": true,
      "59067": true,
      "59068": true,
      "59069": true,
      "59070": true,
      "59071": true,
      "59072": true,
      "59073": true,
      "59074": true,
      "59075": true,
      "59076": true,
      "59077": true,
      "59078": true,
      "59079": true,
      "59080": true,
      "59081": true,
      "59082": true,
      "59083": true,
      "59084": true,
      "59085": true,
      "59086": true,
      "59087": true,
      "59088": true,
      "59089": true,
      "59090": true,
      "59091": true,
      "59092": true,
      "59093": true,
      "59094": true,
      "59095": true,
      "59096": true,
      "59097": true,
      "59098": true,
      "59099": true,
      "59100": true,
      "59101": true,
      "59102": true,
      "59103": true,
      "59104": true,
      "59105": true,
      "59106": true,
      "59107": true,
      "59108": true,
      "59109": true,
      "59110": true,
      "59111": true,
      "59112": true,
      "59113": true,
      "59114": true,
      "59115": true,
      "59116": true,
      "59117": true,
      "59118": true,
      "59119": true
    },
    "SALVADOR ESCALANTE": {
      "61800": true,
      "61801": true,
      "61802": true,
      "61803": true,
      "61804": true,
      "61805": true,
      "61806": true,
      "61807": true,
      "61808": true,
      "61809": true,
      "61810": true,
      "61811": true,
      "61812": true,
      "61815": true,
      "61816": true,
      "61820": true,
      "61821": true,
      "61822": true,
      "61823": true,
      "61824": true,
      "61825": true,
      "61826": true,
      "61827": true,
      "61828": true,
      "61829": true
    },
    "SANTA ANA MAYA": {
      "58900": true,
      "58901": true,
      "58902": true,
      "58903": true,
      "58904": true,
      "58905": true,
      "58906": true,
      "58907": true,
      "58908": true,
      "58909": true,
      "58910": true,
      "58911": true,
      "58912": true,
      "58913": true,
      "58914": true,
      "58915": true,
      "58916": true,
      "58917": true,
      "58918": true,
      "58919": true
    },
    "SENGUIO": {
      "61290": true,
      "61291": true,
      "61292": true,
      "61293": true,
      "61295": true,
      "61296": true,
      "61297": true,
      "61298": true,
      "61299": true
    },
    "TACAMBARO": {
      "61650": true,
      "61651": true,
      "61652": true,
      "61653": true,
      "61654": true,
      "61655": true,
      "61656": true,
      "61657": true,
      "61658": true,
      "61659": true,
      "61660": true,
      "61661": true,
      "61662": true,
      "61663": true,
      "61664": true,
      "61665": true,
      "61670": true,
      "61671": true,
      "61672": true,
      "61673": true,
      "61674": true,
      "61677": true,
      "61678": true,
      "61679": true
    },
    "TANCITARO": {
      "60460": true,
      "60461": true,
      "60462": true,
      "60463": true,
      "60464": true,
      "60465": true,
      "60466": true,
      "60467": true,
      "60468": true,
      "60469": true,
      "60473": true,
      "60474": true,
      "60476": true,
      "60477": true,
      "60478": true,
      "60479": true,
      "60480": true,
      "60481": true,
      "60482": true,
      "60483": true,
      "60484": true,
      "60485": true,
      "60486": true,
      "60487": true,
      "60488": true,
      "60489": true
    },
    "TANGANCICUARO": {
      "59750": true,
      "59751": true,
      "59752": true,
      "59753": true,
      "59754": true,
      "59755": true,
      "59756": true,
      "59757": true,
      "59758": true,
      "59759": true,
      "59760": true,
      "59761": true,
      "59762": true,
      "59763": true,
      "59764": true,
      "59765": true,
      "59766": true,
      "59767": true,
      "59768": true,
      "59769": true,
      "59770": true,
      "59771": true,
      "59772": true,
      "59773": true,
      "59774": true,
      "59775": true
    },
    "TANHUATO": {
      "59230": true,
      "59231": true,
      "59232": true,
      "59235": true,
      "59236": true,
      "59237": true,
      "59238": true,
      "59239": true,
      "59240": true,
      "59241": true,
      "59242": true,
      "59243": true,
      "59244": true,
      "59245": true,
      "59246": true,
      "59247": true,
      "59248": true,
      "59249": true
    },
    "TARETAN": {
      "61710": true,
      "61711": true,
      "61712": true,
      "61713": true,
      "61714": true,
      "61715": true,
      "61716": true,
      "61717": true,
      "61718": true,
      "61719": true,
      "61720": true,
      "61721": true,
      "61722": true,
      "61723": true,
      "61724": true,
      "61725": true,
      "61726": true,
      "61727": true,
      "61728": true,
      "61729": true
    },
    "TARIMBARO": {
      "58880": true,
      "58881": true,
      "58882": true,
      "58883": true,
      "58884": true,
      "58885": true,
      "58886": true,
      "58887": true,
      "58888": true,
      "58889": true,
      "58890": true,
      "58891": true,
      "58892": true,
      "58893": true,
      "58894": true,
      "58895": true,
      "58896": true,
      "58897": true,
      "58898": true,
      "58899": true
    },
    "TEPALCATEPEC": {
      "60540": true,
      "60541": true,
      "60542": true,
      "60543": true,
      "60544": true,
      "60545": true,
      "60546": true,
      "60547": true,
      "60548": true,
      "60549": true,
      "60550": true,
      "60551": true,
      "60552": true,
      "60553": true,
      "60555": true,
      "60560": true,
      "60561": true,
      "60562": true,
      "60564": true,
      "60565": true,
      "60566": true,
      "60567": true,
      "60568": true,
      "60569": true
    },
    "TINGAMBATO": {
      "60290": true,
      "60291": true,
      "60292": true,
      "60293": true,
      "60294": true,
      "60295": true,
      "60296": true
    },
    "TINGUINDIN": {
      "59980": true,
      "59981": true,
      "59982": true,
      "59983": true,
      "59984": true,
      "59985": true,
      "59986": true,
      "59987": true,
      "59988": true,
      "59989": true,
      "59990": true,
      "59991": true,
      "59992": true,
      "59993": true,
      "59994": true,
      "59995": true,
      "59996": true,
      "59997": true,
      "59998": true,
      "59999": true
    },
    "TLALPUJAHUA": {
      "61060": true,
      "61061": true,
      "61062": true,
      "61063": true,
      "61064": true,
      "61065": true,
      "61066": true,
      "61067": true,
      "61068": true,
      "61069": true,
      "61070": true,
      "61071": true,
      "61072": true,
      "61073": true,
      "61074": true,
      "61075": true,
      "61076": true,
      "61077": true,
      "61078": true,
      "61079": true,
      "61080": true,
      "61081": true,
      "61082": true,
      "61083": true,
      "61084": true,
      "61085": true,
      "61086": true,
      "61087": true,
      "61088": true,
      "61089": true,
      "61090": true,
      "61091": true,
      "61092": true,
      "61093": true,
      "61094": true,
      "61095": true,
      "61096": true,
      "61097": true,
      "61098": true,
      "61099": true
    },
    "TLAZAZALCA": {
      "58740": true,
      "58741": true,
      "58742": true,
      "58743": true,
      "58744": true,
      "58745": true,
      "58746": true,
      "58747": true,
      "58748": true,
      "58749": true,
      "58750": true,
      "58751": true,
      "58752": true,
      "58754": true,
      "58755": true,
      "58756": true,
      "58757": true,
      "58758": true,
      "58759": true
    },
    "TOCUMBO": {
      "59960": true,
      "59961": true,
      "59962": true,
      "59963": true,
      "59964": true,
      "59965": true,
      "59970": true,
      "59971": true,
      "59972": true,
      "59973": true
    },
    "TZINTZUNTZAN": {
      "58440": true,
      "58441": true,
      "58443": true,
      "58444": true,
      "58445": true,
      "58446": true,
      "58448": true,
      "58449": true
    },
    "URUAPAN": {
      "60000": true,
      "60001": true,
      "60002": true,
      "60003": true,
      "60004": true,
      "60005": true,
      "60006": true,
      "60007": true,
      "60008": true,
      "60009": true,
      "60010": true,
      "60011": true,
      "60012": true,
      "60013": true,
      "60014": true,
      "60015": true,
      "60016": true,
      "60017": true,
      "60018": true,
      "60019": true,
      "60020": true,
      "60021": true,
      "60022": true,
      "60023": true,
      "60024": true,
      "60025": true,
      "60026": true,
      "60027": true,
      "60028": true,
      "60029": true,
      "60030": true,
      "60031": true,
      "60032": true,
      "60033": true,
      "60034": true,
      "60035": true,
      "60036": true,
      "60037": true,
      "60038": true,
      "60039": true,
      "60040": true,
      "60041": true,
      "60042": true,
      "60043": true,
      "60044": true,
      "60045": true,
      "60046": true,
      "60047": true,
      "60048": true,
      "60049": true,
      "60050": true,
      "60051": true,
      "60052": true,
      "60053": true,
      "60054": true,
      "60055": true,
      "60056": true,
      "60057": true,
      "60058": true,
      "60059": true,
      "60060": true,
      "60061": true,
      "60062": true,
      "60063": true,
      "60064": true,
      "60065": true,
      "60066": true,
      "60067": true,
      "60068": true,
      "60069": true,
      "60070": true,
      "60071": true,
      "60072": true,
      "60073": true,
      "60074": true,
      "60075": true,
      "60076": true,
      "60077": true,
      "60078": true,
      "60079": true,
      "60080": true,
      "60081": true,
      "60082": true,
      "60083": true,
      "60084": true,
      "60085": true,
      "60086": true,
      "60087": true,
      "60088": true,
      "60089": true,
      "60090": true,
      "60091": true,
      "60092": true,
      "60093": true,
      "60094": true,
      "60095": true,
      "60096": true,
      "60097": true,
      "60098": true,
      "60099": true,
      "60100": true,
      "60101": true,
      "60102": true,
      "60103": true,
      "60104": true,
      "60105": true,
      "60106": true,
      "60107": true,
      "60108": true,
      "60109": true,
      "60110": true,
      "60111": true,
      "60112": true,
      "60113": true,
      "60114": true,
      "60115": true,
      "60116": true,
      "60117": true,
      "60118": true,
      "60119": true,
      "60120": true,
      "60121": true,
      "60122": true,
      "60123": true,
      "60124": true,
      "60125": true,
      "60126": true,
      "60127": true,
      "60128": true,
      "60129": true,
      "60130": true,
      "60131": true,
      "60132": true,
      "60133": true,
      "60134": true,
      "60135": true,
      "60136": true,
      "60137": true,
      "60138": true,
      "60139": true,
      "60140": true,
      "60141": true,
      "60142": true,
      "60143": true,
      "60144": true,
      "60145": true,
      "60146": true,
      "60147": true,
      "60148": true,
      "60149": true,
      "60150": true,
      "60151": true,
      "60152": true,
      "60153": true,
      "60154": true,
      "60155": true,
      "60156": true,
      "60157": true,
      "60158": true,
      "60159": true,
      "60160": true,
      "60161": true,
      "60162": true,
      "60163": true,
      "60164": true,
      "60165": true,
      "60166": true,
      "60167": true,
      "60168": true,
      "60169": true,
      "60170": true,
      "60171": true,
      "60172": true,
      "60173": true,
      "60174": true,
      "60175": true,
      "60176": true,
      "60177": true,
      "60178": true,
      "60179": true,
      "60180": true,
      "60181": true,
      "60182": true,
      "60183": true,
      "60184": true,
      "60185": true,
      "60186": true,
      "60187": true,
      "60188": true,
      "60189": true,
      "60190": true,
      "60191": true,
      "60192": true,
      "60193": true,
      "60194": true,
      "60195": true,
      "60196": true,
      "60197": true,
      "60198": true,
      "60199": true,
      "60200": true,
      "60201": true,
      "60202": true,
      "60203": true,
      "60204": true,
      "60205": true,
      "60206": true,
      "60207": true,
      "60208": true,
      "60209": true,
      "60210": true,
      "60211": true,
      "60212": true,
      "60213": true,
      "60214": true,
      "60215": true,
      "60216": true,
      "60217": true,
      "60218": true,
      "60219": true,
      "60220": true,
      "60221": true,
      "60222": true,
      "60223": true,
      "60224": true,
      "60225": true,
      "60226": true,
      "60227": true,
      "60228": true,
      "60229": true,
      "60230": true,
      "60231": true,
      "60232": true,
      "60233": true,
      "60234": true,
      "60235": true,
      "60236": true,
      "60237": true,
      "60238": true,
      "60239": true
    },
    "VENUSTIANO CARRANZA": {
      "59160": true,
      "59161": true,
      "59162": true,
      "59163": true,
      "59164": true,
      "59165": true,
      "59166": true,
      "59167": true,
      "59168": true,
      "59169": true
    },
    "VILLAMAR": {
      "59550": true,
      "59551": true,
      "59552": true,
      "59553": true,
      "59554": true,
      "59555": true,
      "59556": true,
      "59557": true,
      "59558": true,
      "59559": true,
      "59560": true,
      "59561": true,
      "59562": true,
      "59563": true,
      "59564": true,
      "59565": true,
      "59566": true,
      "59567": true,
      "59568": true,
      "59569": true,
      "59570": true,
      "59571": true,
      "59572": true,
      "59573": true,
      "59574": true,
      "59575": true,
      "59576": true,
      "59577": true,
      "59578": true,
      "59579": true
    },
    "VISTA HERMOSA": {
      "59200": true,
      "59201": true,
      "59202": true,
      "59203": true,
      "59204": true,
      "59205": true,
      "59206": true,
      "59207": true,
      "59208": true,
      "59209": true,
      "59210": true,
      "59211": true,
      "59212": true,
      "59213": true,
      "59214": true,
      "59215": true,
      "59216": true,
      "59217": true,
      "59218": true,
      "59219": true,
      "59220": true,
      "59221": true,
      "59222": true,
      "59223": true,
      "59224": true,
      "59225": true,
      "59226": true,
      "59227": true,
      "59228": true,
      "59229": true
    },
    "YURECUARO": {
      "59250": true,
      "59251": true,
      "59252": true,
      "59253": true,
      "59254": true,
      "59255": true,
      "59256": true,
      "59257": true,
      "59258": true,
      "59259": true,
      "59260": true,
      "59261": true,
      "59265": true,
      "59266": true
    },
    "ZACAPU": {
      "58600": true,
      "58601": true,
      "58602": true,
      "58603": true,
      "58604": true,
      "58605": true,
      "58606": true,
      "58607": true,
      "58608": true,
      "58609": true,
      "58610": true,
      "58611": true,
      "58612": true,
      "58613": true,
      "58614": true,
      "58615": true,
      "58616": true,
      "58617": true,
      "58618": true,
      "58619": true,
      "58620": true,
      "58621": true,
      "58622": true,
      "58623": true,
      "58624": true,
      "58625": true,
      "58626": true,
      "58627": true,
      "58628": true,
      "58629": true,
      "58630": true,
      "58631": true,
      "58632": true,
      "58633": true,
      "58634": true,
      "58635": true,
      "58636": true,
      "58637": true,
      "58638": true,
      "58639": true,
      "58640": true,
      "58641": true,
      "58642": true,
      "58643": true,
      "58644": true,
      "58645": true,
      "58646": true,
      "58647": true,
      "58648": true,
      "58649": true,
      "58650": true,
      "58651": true,
      "58652": true,
      "58653": true,
      "58654": true,
      "58655": true,
      "58656": true,
      "58657": true,
      "58658": true,
      "58659": true,
      "58660": true,
      "58661": true,
      "58662": true,
      "58663": true,
      "58664": true,
      "58665": true,
      "58666": true,
      "58667": true,
      "58668": true,
      "58669": true,
      "58670": true,
      "58671": true,
      "58672": true,
      "58673": true,
      "58674": true,
      "58675": true,
      "58676": true,
      "58677": true,
      "58678": true,
      "58679": true,
      "58680": true,
      "58681": true,
      "58682": true,
      "58683": true,
      "58684": true,
      "58685": true,
      "58686": true,
      "58687": true,
      "58688": true,
      "58689": true,
      "58690": true,
      "58691": true,
      "58692": true,
      "58693": true,
      "58694": true,
      "58695": true,
      "58696": true,
      "58697": true,
      "58698": true,
      "58699": true,
      "58700": true,
      "58701": true,
      "58702": true,
      "58703": true,
      "58704": true,
      "58705": true,
      "58706": true,
      "58707": true,
      "58708": true,
      "58709": true,
      "58710": true,
      "58716": true,
      "58717": true,
      "58718": true,
      "58719": true,
      "58720": true,
      "58721": true,
      "58722": true,
      "58723": true,
      "58724": true,
      "58725": true,
      "58726": true,
      "58728": true,
      "58729": true,
      "58730": true,
      "58731": true,
      "58732": true,
      "58733": true,
      "58734": true,
      "58735": true,
      "58736": true,
      "58737": true,
      "58738": true,
      "58739": true
    },
    "ZAMORA": {
      "59600": true,
      "59601": true,
      "59602": true,
      "59603": true,
      "59604": true,
      "59605": true,
      "59606": true,
      "59607": true,
      "59608": true,
      "59609": true,
      "59610": true,
      "59611": true,
      "59612": true,
      "59613": true,
      "59614": true,
      "59615": true,
      "59616": true,
      "59617": true,
      "59618": true,
      "59619": true,
      "59620": true,
      "59621": true,
      "59622": true,
      "59623": true,
      "59624": true,
      "59625": true,
      "59626": true,
      "59627": true,
      "59628": true,
      "59629": true,
      "59630": true,
      "59631": true,
      "59632": true,
      "59633": true,
      "59634": true,
      "59635": true,
      "59636": true,
      "59637": true,
      "59638": true,
      "59639": true,
      "59640": true,
      "59641": true,
      "59642": true,
      "59643": true,
      "59644": true,
      "59645": true,
      "59646": true,
      "59647": true,
      "59648": true,
      "59649": true,
      "59650": true,
      "59651": true,
      "59652": true,
      "59653": true,
      "59654": true,
      "59655": true,
      "59656": true,
      "59657": true,
      "59658": true,
      "59659": true,
      "59660": true,
      "59661": true,
      "59662": true,
      "59663": true,
      "59664": true,
      "59665": true,
      "59666": true,
      "59667": true,
      "59668": true,
      "59669": true,
      "59670": true,
      "59671": true,
      "59672": true,
      "59673": true,
      "59674": true,
      "59675": true,
      "59676": true,
      "59677": true,
      "59678": true,
      "59679": true,
      "59680": true,
      "59681": true,
      "59682": true,
      "59683": true,
      "59684": true,
      "59685": true,
      "59686": true,
      "59687": true,
      "59688": true,
      "59689": true,
      "59690": true,
      "59691": true,
      "59692": true,
      "59693": true,
      "59694": true,
      "59695": true,
      "59696": true,
      "59697": true,
      "59698": true,
      "59699": true,
      "59700": true,
      "59701": true,
      "59702": true,
      "59703": true,
      "59704": true,
      "59705": true,
      "59706": true,
      "59707": true,
      "59708": true,
      "59709": true,
      "59710": true,
      "59711": true,
      "59712": true,
      "59713": true,
      "59714": true,
      "59715": true,
      "59716": true,
      "59717": true,
      "59718": true,
      "59719": true,
      "59720": true,
      "59721": true,
      "59722": true,
      "59723": true,
      "59724": true,
      "59725": true,
      "59726": true,
      "59727": true,
      "59728": true,
      "59729": true
    },
    "ZINAPARO": {
      "59460": true,
      "59461": true,
      "59462": true,
      "59463": true,
      "59464": true,
      "59465": true,
      "59466": true,
      "59467": true,
      "59468": true,
      "59469": true
    },
    "ZINAPECUARO": {
      "58930": true,
      "58931": true,
      "58932": true,
      "58933": true,
      "58934": true,
      "58935": true,
      "58936": true,
      "58937": true,
      "58938": true,
      "58939": true,
      "58940": true,
      "58941": true,
      "58942": true,
      "58943": true,
      "58944": true,
      "58945": true,
      "58946": true,
      "58947": true,
      "58948": true,
      "58949": true,
      "58950": true,
      "58951": true,
      "58952": true,
      "58953": true,
      "58954": true,
      "58955": true,
      "58956": true,
      "58957": true,
      "58958": true,
      "58959": true,
      "58962": true,
      "58963": true
    },
    "ZIRACUARETIRO": {
      "61700": true,
      "61701": true,
      "61702": true,
      "61703": true,
      "61704": true,
      "61705": true,
      "61706": true,
      "61707": true,
      "61708": true,
      "61709": true
    },
    "ZITACUARO": {
      "61500": true,
      "61501": true,
      "61502": true,
      "61503": true,
      "61504": true,
      "61505": true,
      "61506": true,
      "61507": true,
      "61508": true,
      "61509": true,
      "61510": true,
      "61511": true,
      "61512": true,
      "61513": true,
      "61514": true,
      "61515": true,
      "61516": true,
      "61517": true,
      "61518": true,
      "61519": true,
      "61520": true,
      "61521": true,
      "61522": true,
      "61523": true,
      "61524": true,
      "61525": true,
      "61526": true,
      "61527": true,
      "61528": true,
      "61529": true,
      "61530": true,
      "61531": true,
      "61532": true,
      "61533": true,
      "61534": true,
      "61535": true,
      "61536": true,
      "61537": true,
      "61538": true,
      "61539": true
    }
  },
  "MORELOS": {
    "AMACUZAC": {
      "62640": true,
      "62641": true,
      "62642": true,
      "62643": true,
      "62644": true,
      "62645": true,
      "62646": true,
      "62647": true,
      "62648": true,
      "62649": true,
      "62650": true,
      "62651": true,
      "62652": true,
      "62653": true,
      "62654": true,
      "62655": true,
      "62656": true,
      "62657": true,
      "62658": true,
      "62659": true
    },
    "ATLATLAHUCAN": {
      "62840": true,
      "62841": true,
      "62842": true,
      "62845": true,
      "62846": true,
      "62847": true,
      "62848": true,
      "62849": true
    },
    "AXOCHIAPAN": {
      "62950": true,
      "62951": true,
      "62952": true,
      "62953": true,
      "62954": true,
      "62955": true,
      "62956": true,
      "62957": true,
      "62958": true,
      "62959": true,
      "62960": true,
      "62961": true,
      "62962": true,
      "62963": true,
      "62964": true,
      "62965": true,
      "62966": true,
      "62967": true,
      "62968": true,
      "62969": true
    },
    "AYALA": {
      "62700": true,
      "62701": true,
      "62702": true,
      "62703": true,
      "62704": true,
      "62705": true,
      "62706": true,
      "62707": true,
      "62708": true,
      "62709": true,
      "62710": true,
      "62711": true,
      "62712": true,
      "62713": true,
      "62714": true,
      "62715": true,
      "62716": true,
      "62717": true,
      "62718": true,
      "62719": true,
      "62720": true,
      "62721": true,
      "62722": true,
      "62723": true,
      "62724": true,
      "62725": true,
      "62726": true,
      "62727": true,
      "62728": true,
      "62729": true
    },
    "COATETELCO": {
      "62606": true
    },
    "CUAUTLA": {
      "62740": true,
      "62741": true,
      "62742": true,
      "62743": true,
      "62744": true,
      "62745": true,
      "62746": true,
      "62747": true,
      "62748": true,
      "62749": true,
      "62750": true,
      "62751": true,
      "62752": true,
      "62753": true,
      "62754": true,
      "62755": true,
      "62756": true,
      "62757": true,
      "62758": true,
      "62759": true
    },
    "CUERNAVACA": {
      "62000": true,
      "62001": true,
      "62002": true,
      "62003": true,
      "62004": true,
      "62005": true,
      "62006": true,
      "62007": true,
      "62008": true,
      "62009": true,
      "62010": true,
      "62011": true,
      "62012": true,
      "62013": true,
      "62014": true,
      "62015": true,
      "62016": true,
      "62017": true,
      "62018": true,
      "62019": true,
      "62020": true,
      "62021": true,
      "62022": true,
      "62023": true,
      "62024": true,
      "62025": true,
      "62026": true,
      "62027": true,
      "62028": true,
      "62029": true,
      "62030": true,
      "62031": true,
      "62032": true,
      "62033": true,
      "62034": true,
      "62035": true,
      "62036": true,
      "62037": true,
      "62038": true,
      "62039": true,
      "62040": true,
      "62041": true,
      "62042": true,
      "62043": true,
      "62044": true,
      "62045": true,
      "62046": true,
      "62047": true,
      "62048": true,
      "62049": true,
      "62050": true,
      "62051": true,
      "62052": true,
      "62053": true,
      "62054": true,
      "62055": true,
      "62056": true,
      "62057": true,
      "62058": true,
      "62059": true,
      "62060": true,
      "62061": true,
      "62062": true,
      "62063": true,
      "62064": true,
      "62065": true,
      "62066": true,
      "62067": true,
      "62068": true,
      "62069": true,
      "62070": true,
      "62071": true,
      "62072": true,
      "62073": true,
      "62074": true,
      "62075": true,
      "62076": true,
      "62077": true,
      "62078": true,
      "62079": true,
      "62080": true,
      "62081": true,
      "62082": true,
      "62083": true,
      "62084": true,
      "62085": true,
      "62086": true,
      "62087": true,
      "62088": true,
      "62089": true,
      "62090": true,
      "62091": true,
      "62092": true,
      "62093": true,
      "62094": true,
      "62095": true,
      "62096": true,
      "62097": true,
      "62098": true,
      "62099": true,
      "62100": true,
      "62101": true,
      "62102": true,
      "62103": true,
      "62104": true,
      "62105": true,
      "62106": true,
      "62107": true,
      "62108": true,
      "62109": true,
      "62110": true,
      "62111": true,
      "62112": true,
      "62113": true,
      "62114": true,
      "62115": true,
      "62116": true,
      "62117": true,
      "62118": true,
      "62119": true,
      "62120": true,
      "62121": true,
      "62122": true,
      "62123": true,
      "62124": true,
      "62125": true,
      "62126": true,
      "62127": true,
      "62128": true,
      "62129": true,
      "62130": true,
      "62131": true,
      "62132": true,
      "62133": true,
      "62134": true,
      "62135": true,
      "62136": true,
      "62137": true,
      "62138": true,
      "62139": true,
      "62140": true,
      "62141": true,
      "62142": true,
      "62143": true,
      "62144": true,
      "62145": true,
      "62146": true,
      "62147": true,
      "62148": true,
      "62149": true,
      "62150": true,
      "62151": true,
      "62152": true,
      "62153": true,
      "62154": true,
      "62155": true,
      "62156": true,
      "62157": true,
      "62158": true,
      "62159": true,
      "62160": true,
      "62161": true,
      "62162": true,
      "62163": true,
      "62164": true,
      "62165": true,
      "62166": true,
      "62167": true,
      "62168": true,
      "62169": true,
      "62170": true,
      "62171": true,
      "62172": true,
      "62173": true,
      "62174": true,
      "62175": true,
      "62176": true,
      "62177": true,
      "62178": true,
      "62179": true,
      "62180": true,
      "62181": true,
      "62182": true,
      "62183": true,
      "62184": true,
      "62185": true,
      "62186": true,
      "62187": true,
      "62188": true,
      "62189": true,
      "62190": true,
      "62191": true,
      "62192": true,
      "62193": true,
      "62194": true,
      "62195": true,
      "62196": true,
      "62197": true,
      "62198": true,
      "62199": true,
      "62200": true,
      "62201": true,
      "62202": true,
      "62203": true,
      "62204": true,
      "62205": true,
      "62206": true,
      "62207": true,
      "62208": true,
      "62209": true,
      "62210": true,
      "62211": true,
      "62212": true,
      "62213": true,
      "62214": true,
      "62215": true,
      "62216": true,
      "62217": true,
      "62218": true,
      "62219": true,
      "62220": true,
      "62221": true,
      "62222": true,
      "62223": true,
      "62224": true,
      "62225": true,
      "62226": true,
      "62227": true,
      "62228": true,
      "62229": true,
      "62230": true,
      "62231": true,
      "62232": true,
      "62233": true,
      "62234": true,
      "62235": true,
      "62236": true,
      "62237": true,
      "62238": true,
      "62239": true,
      "62240": true,
      "62241": true,
      "62242": true,
      "62243": true,
      "62244": true,
      "62245": true,
      "62246": true,
      "62247": true,
      "62248": true,
      "62249": true,
      "62250": true,
      "62251": true,
      "62252": true,
      "62253": true,
      "62254": true,
      "62255": true,
      "62256": true,
      "62257": true,
      "62258": true,
      "62259": true,
      "62260": true,
      "62261": true,
      "62262": true,
      "62263": true,
      "62264": true,
      "62265": true,
      "62266": true,
      "62267": true,
      "62268": true,
      "62269": true,
      "62270": true,
      "62271": true,
      "62272": true,
      "62273": true,
      "62274": true,
      "62275": true,
      "62276": true,
      "62277": true,
      "62278": true,
      "62279": true,
      "62280": true,
      "62281": true,
      "62282": true,
      "62283": true,
      "62284": true,
      "62285": true,
      "62286": true,
      "62287": true,
      "62288": true,
      "62289": true,
      "62290": true,
      "62291": true,
      "62292": true,
      "62293": true,
      "62294": true,
      "62295": true,
      "62296": true,
      "62297": true,
      "62298": true,
      "62299": true,
      "62300": true,
      "62301": true,
      "62302": true,
      "62303": true,
      "62304": true,
      "62305": true,
      "62306": true,
      "62307": true,
      "62308": true,
      "62309": true,
      "62310": true,
      "62311": true,
      "62312": true,
      "62313": true,
      "62314": true,
      "62315": true,
      "62316": true,
      "62317": true,
      "62318": true,
      "62319": true,
      "62320": true,
      "62321": true,
      "62322": true,
      "62323": true,
      "62324": true,
      "62325": true,
      "62326": true,
      "62327": true,
      "62328": true,
      "62329": true,
      "62330": true,
      "62331": true,
      "62332": true,
      "62333": true,
      "62334": true,
      "62335": true,
      "62336": true,
      "62337": true,
      "62338": true,
      "62339": true,
      "62340": true,
      "62341": true,
      "62342": true,
      "62343": true,
      "62344": true,
      "62345": true,
      "62346": true,
      "62347": true,
      "62348": true,
      "62349": true,
      "62350": true,
      "62351": true,
      "62352": true,
      "62353": true,
      "62354": true,
      "62355": true,
      "62356": true,
      "62357": true,
      "62358": true,
      "62359": true,
      "62360": true,
      "62361": true,
      "62362": true,
      "62363": true,
      "62364": true,
      "62365": true,
      "62366": true,
      "62367": true,
      "62368": true,
      "62369": true,
      "62370": true,
      "62371": true,
      "62372": true,
      "62373": true,
      "62374": true,
      "62375": true,
      "62376": true,
      "62377": true,
      "62378": true,
      "62379": true,
      "62380": true,
      "62381": true,
      "62382": true,
      "62383": true,
      "62384": true,
      "62385": true,
      "62386": true,
      "62387": true,
      "62388": true,
      "62389": true,
      "62390": true,
      "62391": true,
      "62392": true,
      "62393": true,
      "62394": true,
      "62395": true,
      "62396": true,
      "62397": true,
      "62398": true,
      "62399": true,
      "62400": true,
      "62401": true,
      "62402": true,
      "62403": true,
      "62404": true,
      "62405": true,
      "62406": true,
      "62407": true,
      "62408": true,
      "62409": true,
      "62410": true,
      "62411": true,
      "62412": true,
      "62413": true,
      "62414": true,
      "62415": true,
      "62416": true,
      "62417": true,
      "62418": true,
      "62419": true,
      "62420": true,
      "62421": true,
      "62422": true,
      "62423": true,
      "62424": true,
      "62425": true,
      "62426": true,
      "62427": true,
      "62428": true,
      "62429": true,
      "62430": true,
      "62431": true,
      "62432": true,
      "62433": true,
      "62434": true,
      "62435": true,
      "62436": true,
      "62437": true,
      "62438": true,
      "62439": true,
      "62440": true,
      "62441": true,
      "62442": true,
      "62443": true,
      "62444": true,
      "62445": true,
      "62446": true,
      "62447": true,
      "62448": true,
      "62449": true,
      "62450": true,
      "62451": true,
      "62452": true,
      "62453": true,
      "62454": true,
      "62455": true,
      "62456": true,
      "62457": true,
      "62458": true,
      "62459": true,
      "62460": true,
      "62461": true,
      "62462": true,
      "62463": true,
      "62464": true,
      "62465": true,
      "62466": true,
      "62467": true,
      "62468": true,
      "62469": true,
      "62470": true,
      "62471": true,
      "62472": true,
      "62473": true,
      "62474": true,
      "62475": true,
      "62476": true,
      "62477": true,
      "62478": true,
      "62479": true,
      "62480": true,
      "62481": true,
      "62482": true,
      "62483": true,
      "62484": true,
      "62485": true,
      "62486": true,
      "62487": true,
      "62488": true,
      "62489": true,
      "62490": true,
      "62491": true,
      "62492": true,
      "62493": true,
      "62494": true,
      "62495": true,
      "62496": true,
      "62497": true,
      "62498": true,
      "62499": true,
      "62500": true,
      "62501": true,
      "62502": true,
      "62503": true,
      "62504": true,
      "62505": true,
      "62506": true,
      "62507": true,
      "62508": true,
      "62509": true
    },
    "EMILIANO ZAPATA": {
      "62760": true,
      "62761": true,
      "62762": true,
      "62763": true,
      "62764": true,
      "62765": true,
      "62766": true,
      "62767": true,
      "62768": true,
      "62769": true
    },
    "HUEYAPAN": {
      "62810": true,
      "62811": true,
      "62812": true,
      "62813": true,
      "62814": true,
      "62815": true,
      "62816": true,
      "62817": true,
      "62818": true,
      "62819": true
    },
    "JANTETELCO": {
      "62970": true,
      "62971": true,
      "62972": true,
      "62973": true,
      "62974": true,
      "62975": true,
      "62976": true,
      "62977": true,
      "62978": true,
      "62979": true
    },
    "JIUTEPEC": {
      "62550": true,
      "62551": true,
      "62552": true,
      "62553": true,
      "62554": true,
      "62555": true,
      "62556": true,
      "62557": true,
      "62558": true,
      "62559": true,
      "62560": true,
      "62561": true,
      "62562": true,
      "62563": true,
      "62564": true,
      "62565": true,
      "62566": true,
      "62567": true,
      "62568": true,
      "62569": true,
      "62570": true,
      "62571": true,
      "62572": true,
      "62573": true,
      "62574": true,
      "62575": true,
      "62576": true,
      "62577": true,
      "62578": true,
      "62579": true
    },
    "JOJUTLA": {
      "62900": true,
      "62901": true,
      "62902": true,
      "62903": true,
      "62904": true,
      "62905": true,
      "62906": true,
      "62907": true,
      "62908": true,
      "62909": true,
      "62910": true,
      "62911": true,
      "62912": true,
      "62913": true,
      "62914": true,
      "62915": true,
      "62917": true,
      "62918": true,
      "62919": true
    },
    "JONACATEPEC": {
      "62930": true,
      "62931": true,
      "62932": true,
      "62933": true,
      "62934": true,
      "62935": true,
      "62936": true,
      "62937": true,
      "62938": true,
      "62939": true,
      "62940": true,
      "62941": true,
      "62942": true,
      "62943": true,
      "62944": true,
      "62945": true,
      "62946": true,
      "62947": true,
      "62948": true,
      "62949": true
    },
    "MAZATEPEC": {
      "62630": true,
      "62631": true,
      "62632": true,
      "62633": true,
      "62634": true,
      "62635": true,
      "62636": true,
      "62637": true,
      "62638": true,
      "62639": true
    },
    "MIACATLAN": {
      "62600": true,
      "62601": true,
      "62602": true,
      "62603": true,
      "62604": true,
      "62605": true,
      "62607": true,
      "62608": true,
      "62609": true
    },
    "OCUITUCO": {
      "62850": true,
      "62851": true,
      "62852": true,
      "62853": true,
      "62854": true,
      "62855": true,
      "62856": true,
      "62857": true,
      "62858": true,
      "62859": true,
      "62860": true,
      "62861": true,
      "62862": true,
      "62863": true,
      "62864": true,
      "62865": true,
      "62866": true,
      "62867": true,
      "62868": true,
      "62869": true
    },
    "PUENTE DE IXTLA": {
      "62660": true,
      "62661": true,
      "62662": true,
      "62663": true,
      "62664": true,
      "62665": true,
      "62666": true,
      "62667": true,
      "62668": true,
      "62669": true,
      "62670": true,
      "62671": true,
      "62672": true,
      "62673": true,
      "62674": true,
      "62675": true,
      "62676": true,
      "62677": true,
      "62678": true,
      "62679": true,
      "62690": true,
      "62691": true,
      "62692": true,
      "62693": true,
      "62695": true,
      "62697": true,
      "62698": true,
      "62699": true
    },
    "TEMIXCO": {
      "62580": true,
      "62581": true,
      "62582": true,
      "62583": true,
      "62584": true,
      "62585": true,
      "62586": true,
      "62587": true,
      "62588": true,
      "62589": true,
      "62590": true,
      "62591": true,
      "62592": true,
      "62593": true,
      "62594": true,
      "62595": true,
      "62596": true,
      "62597": true,
      "62598": true,
      "62599": true
    },
    "TEMOAC": {
      "62870": true,
      "62871": true,
      "62872": true,
      "62873": true,
      "62874": true,
      "62875": true,
      "62876": true,
      "62877": true,
      "62878": true,
      "62879": true,
      "62880": true,
      "62881": true,
      "62882": true,
      "62883": true,
      "62884": true,
      "62885": true,
      "62886": true,
      "62887": true,
      "62888": true,
      "62889": true
    },
    "TEPALCINGO": {
      "62920": true,
      "62921": true,
      "62922": true,
      "62923": true,
      "62924": true,
      "62925": true,
      "62926": true,
      "62927": true,
      "62928": true,
      "62929": true
    },
    "TEPOZTLAN": {
      "62520": true,
      "62521": true,
      "62522": true,
      "62523": true,
      "62524": true,
      "62525": true,
      "62526": true,
      "62527": true,
      "62528": true,
      "62529": true
    },
    "TETECALA": {
      "62620": true,
      "62621": true,
      "62622": true,
      "62623": true,
      "62624": true,
      "62625": true,
      "62626": true,
      "62627": true,
      "62628": true,
      "62629": true
    },
    "TETELA DEL VOLCAN": {
      "62800": true,
      "62801": true,
      "62802": true,
      "62803": true,
      "62804": true,
      "62805": true,
      "62806": true,
      "62807": true,
      "62808": true,
      "62809": true
    },
    "TLALNEPANTLA": {
      "62530": true,
      "62531": true,
      "62532": true,
      "62533": true,
      "62534": true,
      "62535": true,
      "62536": true,
      "62537": true,
      "62538": true,
      "62539": true
    },
    "TLALTIZAPAN DE ZAPATA": {
      "62770": true,
      "62771": true,
      "62772": true,
      "62773": true,
      "62774": true,
      "62776": true,
      "62777": true,
      "62778": true,
      "62779": true
    },
    "TLAQUILTENANGO": {
      "62980": true,
      "62981": true,
      "62982": true,
      "62983": true,
      "62984": true,
      "62985": true,
      "62986": true,
      "62987": true,
      "62988": true,
      "62989": true
    },
    "TLAYACAPAN": {
      "62540": true,
      "62541": true,
      "62542": true,
      "62543": true,
      "62544": true,
      "62545": true,
      "62546": true,
      "62547": true,
      "62548": true,
      "62549": true
    },
    "XOCHITEPEC": {
      "62790": true,
      "62791": true,
      "62792": true,
      "62793": true,
      "62794": true,
      "62795": true,
      "62796": true,
      "62797": true,
      "62798": true,
      "62799": true
    },
    "XOXOCOTLA": {
      "62680": true,
      "62681": true,
      "62682": true,
      "62683": true,
      "62684": true,
      "62685": true,
      "62686": true,
      "62687": true,
      "62688": true,
      "62689": true
    },
    "YAUTEPEC": {
      "62730": true,
      "62731": true,
      "62732": true,
      "62733": true,
      "62734": true,
      "62735": true,
      "62736": true,
      "62737": true,
      "62738": true,
      "62739": true
    },
    "YECAPIXTLA": {
      "62820": true,
      "62821": true,
      "62822": true,
      "62823": true,
      "62824": true,
      "62825": true,
      "62826": true,
      "62827": true,
      "62828": true,
      "62829": true
    },
    "ZACATEPEC": {
      "62780": true,
      "62781": true,
      "62782": true,
      "62783": true,
      "62784": true,
      "62785": true,
      "62786": true,
      "62787": true,
      "62788": true,
      "62789": true
    },
    "ZACUALPAN": {
      "62890": true,
      "62891": true,
      "62892": true,
      "62893": true,
      "62894": true,
      "62895": true,
      "62896": true,
      "62897": true,
      "62898": true,
      "62899": true
    }
  },
  "NAYARIT": {
    "ACAPONETA": {
      "63400": true,
      "63401": true,
      "63402": true,
      "63403": true,
      "63405": true,
      "63406": true,
      "63408": true,
      "63409": true,
      "63410": true,
      "63411": true,
      "63412": true,
      "63413": true,
      "63414": true,
      "63416": true,
      "63417": true,
      "63418": true,
      "63419": true,
      "63420": true,
      "63421": true,
      "63422": true,
      "63423": true,
      "63425": true,
      "63429": true,
      "63430": true,
      "63431": true,
      "63432": true,
      "63433": true,
      "63434": true,
      "63435": true,
      "63436": true,
      "63437": true,
      "63438": true,
      "63439": true
    },
    "AHUACATLAN": {
      "63900": true,
      "63901": true,
      "63902": true,
      "63903": true,
      "63904": true,
      "63905": true,
      "63906": true,
      "63907": true,
      "63908": true,
      "63909": true,
      "63910": true,
      "63911": true,
      "63912": true,
      "63913": true,
      "63914": true,
      "63915": true,
      "63916": true,
      "63917": true,
      "63918": true,
      "63919": true,
      "63920": true,
      "63921": true,
      "63922": true,
      "63923": true,
      "63924": true,
      "63925": true,
      "63926": true,
      "63927": true,
      "63928": true,
      "63929": true,
      "63938": true,
      "63939": true
    },
    "AMATLAN DE CANAS": {
      "63960": true,
      "63961": true,
      "63962": true,
      "63963": true,
      "63964": true,
      "63965": true,
      "63966": true,
      "63967": true,
      "63970": true,
      "63971": true,
      "63972": true,
      "63973": true,
      "63974": true,
      "63975": true,
      "63976": true,
      "63977": true,
      "63978": true,
      "63979": true,
      "63980": true,
      "63981": true,
      "63982": true,
      "63983": true,
      "63984": true,
      "63985": true,
      "63986": true,
      "63987": true,
      "63988": true,
      "63989": true,
      "63990": true,
      "63991": true,
      "63992": true,
      "63993": true,
      "63994": true,
      "63995": true,
      "63996": true,
      "63997": true,
      "63998": true,
      "63999": true
    },
    "COMPOSTELA": {
      "63700": true,
      "63701": true,
      "63702": true,
      "63703": true,
      "63704": true,
      "63705": true,
      "63708": true,
      "63709": true,
      "63710": true,
      "63711": true,
      "63712": true,
      "63713": true,
      "63714": true,
      "63715": true,
      "63716": true,
      "63717": true,
      "63718": true,
      "63719": true,
      "63720": true,
      "63721": true,
      "63722": true,
      "63723": true,
      "63724": true,
      "63725": true
    },
    "IXTLAN DEL RIO": {
      "63940": true,
      "63941": true,
      "63942": true,
      "63943": true,
      "63944": true,
      "63946": true,
      "63950": true,
      "63951": true,
      "63952": true,
      "63953": true,
      "63954": true,
      "63955": true,
      "63956": true,
      "63957": true,
      "63958": true,
      "63959": true
    },
    "JALA": {
      "63880": true,
      "63881": true,
      "63882": true,
      "63883": true,
      "63884": true,
      "63885": true,
      "63890": true,
      "63891": true,
      "63892": true,
      "63893": true,
      "63894": true,
      "63895": true,
      "63896": true,
      "63897": true,
      "63898": true,
      "63899": true
    },
    "RUIZ": {
      "63600": true,
      "63601": true,
      "63602": true,
      "63603": true,
      "63604": true,
      "63605": true,
      "63606": true,
      "63607": true,
      "63608": true,
      "63609": true,
      "63610": true,
      "63611": true,
      "63612": true,
      "63613": true,
      "63616": true,
      "63617": true,
      "63620": true,
      "63621": true,
      "63622": true,
      "63623": true,
      "63624": true,
      "63625": true,
      "63626": true,
      "63627": true,
      "63628": true,
      "63629": true
    },
    "SAN PEDRO LAGUNILLAS": {
      "63800": true,
      "63801": true,
      "63802": true,
      "63803": true,
      "63804": true,
      "63805": true,
      "63806": true,
      "63807": true,
      "63808": true,
      "63810": true,
      "63811": true,
      "63812": true,
      "63813": true,
      "63814": true,
      "63815": true,
      "63816": true,
      "63817": true,
      "63818": true,
      "63819": true,
      "63820": true,
      "63821": true,
      "63822": true,
      "63823": true,
      "63824": true,
      "63825": true,
      "63826": true,
      "63827": true,
      "63828": true,
      "63829": true
    },
    "SANTIAGO IXCUINTLA": {
      "63300": true,
      "63301": true,
      "63302": true,
      "63303": true,
      "63304": true,
      "63305": true,
      "63306": true,
      "63307": true,
      "63308": true,
      "63309": true,
      "63310": true,
      "63311": true,
      "63312": true,
      "63313": true,
      "63314": true,
      "63315": true,
      "63316": true,
      "63317": true,
      "63318": true,
      "63319": true,
      "63320": true,
      "63321": true,
      "63322": true,
      "63323": true,
      "63324": true,
      "63325": true,
      "63326": true,
      "63327": true,
      "63328": true,
      "63329": true,
      "63330": true,
      "63331": true,
      "63332": true,
      "63333": true,
      "63334": true,
      "63335": true,
      "63336": true,
      "63337": true,
      "63338": true,
      "63339": true,
      "63340": true,
      "63341": true,
      "63342": true,
      "63343": true,
      "63344": true,
      "63345": true,
      "63346": true,
      "63347": true,
      "63348": true,
      "63349": true,
      "63350": true,
      "63351": true,
      "63352": true,
      "63353": true,
      "63354": true,
      "63355": true,
      "63356": true,
      "63357": true,
      "63358": true,
      "63359": true,
      "63360": true,
      "63361": true,
      "63362": true,
      "63363": true,
      "63364": true,
      "63365": true,
      "63366": true,
      "63367": true,
      "63368": true,
      "63369": true,
      "63370": true,
      "63371": true,
      "63372": true,
      "63373": true,
      "63374": true,
      "63375": true,
      "63376": true,
      "63377": true,
      "63378": true,
      "63379": true,
      "63380": true,
      "63381": true,
      "63382": true,
      "63383": true,
      "63384": true,
      "63385": true,
      "63386": true,
      "63387": true,
      "63388": true,
      "63389": true,
      "63390": true,
      "63391": true,
      "63392": true,
      "63393": true,
      "63394": true,
      "63395": true,
      "63396": true,
      "63397": true,
      "63398": true,
      "63399": true,
      "63550": true,
      "63551": true,
      "63552": true,
      "63553": true,
      "63554": true,
      "63555": true,
      "63556": true,
      "63557": true,
      "63558": true,
      "63559": true,
      "63565": true,
      "63566": true,
      "63567": true,
      "63570": true,
      "63571": true,
      "63572": true,
      "63575": true,
      "63576": true,
      "63577": true,
      "63579": true
    },
    "TEPIC": {
      "63000": true,
      "63001": true,
      "63002": true,
      "63003": true,
      "63004": true,
      "63005": true,
      "63006": true,
      "63007": true,
      "63008": true,
      "63009": true,
      "63010": true,
      "63011": true,
      "63012": true,
      "63013": true,
      "63014": true,
      "63015": true,
      "63016": true,
      "63017": true,
      "63018": true,
      "63019": true,
      "63020": true,
      "63021": true,
      "63022": true,
      "63023": true,
      "63024": true,
      "63025": true,
      "63026": true,
      "63027": true,
      "63028": true,
      "63029": true,
      "63030": true,
      "63031": true,
      "63032": true,
      "63033": true,
      "63034": true,
      "63035": true,
      "63036": true,
      "63037": true,
      "63038": true,
      "63039": true,
      "63040": true,
      "63041": true,
      "63042": true,
      "63043": true,
      "63044": true,
      "63045": true,
      "63046": true,
      "63047": true,
      "63048": true,
      "63049": true,
      "63050": true,
      "63051": true,
      "63052": true,
      "63053": true,
      "63054": true,
      "63055": true,
      "63056": true,
      "63057": true,
      "63058": true,
      "63059": true,
      "63060": true,
      "63061": true,
      "63062": true,
      "63063": true,
      "63064": true,
      "63065": true,
      "63066": true,
      "63067": true,
      "63068": true,
      "63069": true,
      "63070": true,
      "63071": true,
      "63072": true,
      "63073": true,
      "63074": true,
      "63075": true,
      "63076": true,
      "63077": true,
      "63078": true,
      "63079": true,
      "63080": true,
      "63081": true,
      "63082": true,
      "63083": true,
      "63084": true,
      "63085": true,
      "63086": true,
      "63087": true,
      "63088": true,
      "63089": true,
      "63090": true,
      "63091": true,
      "63092": true,
      "63093": true,
      "63094": true,
      "63095": true,
      "63096": true,
      "63097": true,
      "63098": true,
      "63099": true,
      "63100": true,
      "63101": true,
      "63102": true,
      "63103": true,
      "63104": true,
      "63105": true,
      "63106": true,
      "63107": true,
      "63108": true,
      "63109": true,
      "63110": true,
      "63111": true,
      "63112": true,
      "63113": true,
      "63114": true,
      "63115": true,
      "63116": true,
      "63117": true,
      "63118": true,
      "63119": true,
      "63120": true,
      "63121": true,
      "63122": true,
      "63123": true,
      "63124": true,
      "63125": true,
      "63126": true,
      "63127": true,
      "63128": true,
      "63129": true,
      "63130": true,
      "63131": true,
      "63132": true,
      "63133": true,
      "63134": true,
      "63135": true,
      "63136": true,
      "63137": true,
      "63138": true,
      "63139": true,
      "63140": true,
      "63141": true,
      "63142": true,
      "63143": true,
      "63144": true,
      "63145": true,
      "63146": true,
      "63147": true,
      "63148": true,
      "63149": true,
      "63150": true,
      "63151": true,
      "63152": true,
      "63153": true,
      "63154": true,
      "63155": true,
      "63156": true,
      "63157": true,
      "63158": true,
      "63159": true,
      "63160": true,
      "63161": true,
      "63162": true,
      "63163": true,
      "63164": true,
      "63165": true,
      "63166": true,
      "63167": true,
      "63168": true,
      "63169": true,
      "63170": true,
      "63171": true,
      "63172": true,
      "63173": true,
      "63174": true,
      "63175": true,
      "63176": true,
      "63177": true,
      "63178": true,
      "63179": true,
      "63180": true,
      "63181": true,
      "63182": true,
      "63183": true,
      "63184": true,
      "63185": true,
      "63186": true,
      "63187": true,
      "63188": true,
      "63189": true,
      "63190": true,
      "63191": true,
      "63192": true,
      "63193": true,
      "63194": true,
      "63195": true,
      "63196": true,
      "63197": true,
      "63198": true,
      "63199": true,
      "63500": true,
      "63501": true,
      "63502": true,
      "63503": true,
      "63504": true,
      "63505": true,
      "63506": true,
      "63507": true,
      "63508": true,
      "63509": true,
      "63510": true,
      "63511": true,
      "63512": true,
      "63513": true,
      "63514": true,
      "63515": true,
      "63516": true,
      "63517": true,
      "63518": true,
      "63519": true,
      "63520": true,
      "63521": true,
      "63522": true,
      "63523": true,
      "63524": true,
      "63525": true,
      "63526": true,
      "63527": true,
      "63528": true,
      "63529": true
    },
    "XALISCO": {
      "63780": true,
      "63781": true,
      "63782": true,
      "63783": true,
      "63784": true,
      "63785": true,
      "63786": true,
      "63787": true,
      "63788": true,
      "63789": true,
      "63790": true,
      "63791": true,
      "63792": true,
      "63793": true,
      "63794": true,
      "63795": true,
      "63796": true,
      "63797": true,
      "63798": true,
      "63799": true
    }
  },
  "NUEVO LEÓN": {
    "ALLENDE": {
      "67350": true,
      "67351": true,
      "67352": true,
      "67353": true,
      "67354": true,
      "67355": true,
      "67356": true,
      "67357": true,
      "67358": true,
      "67359": true,
      "67360": true,
      "67361": true,
      "67362": true,
      "67363": true,
      "67364": true,
      "67365": true,
      "67366": true,
      "67367": true,
      "67368": true,
      "67369": true,
      "67370": true,
      "67371": true,
      "67372": true,
      "67373": true,
      "67374": true,
      "67375": true,
      "67376": true,
      "67377": true,
      "67378": true,
      "67379": true,
      "67380": true,
      "67381": true,
      "67382": true,
      "67383": true,
      "67384": true,
      "67385": true,
      "67386": true,
      "67387": true,
      "67388": true,
      "67389": true,
      "67390": true,
      "67391": true,
      "67392": true,
      "67393": true,
      "67394": true,
      "67395": true,
      "67396": true,
      "67397": true,
      "67398": true,
      "67399": true
    },
    "APODACA": {
      "66600": true,
      "66601": true,
      "66602": true,
      "66603": true,
      "66604": true,
      "66605": true,
      "66606": true,
      "66607": true,
      "66608": true,
      "66609": true,
      "66610": true,
      "66611": true,
      "66612": true,
      "66613": true,
      "66614": true,
      "66615": true,
      "66616": true,
      "66617": true,
      "66618": true,
      "66619": true,
      "66620": true,
      "66621": true,
      "66622": true,
      "66623": true,
      "66624": true,
      "66625": true,
      "66626": true,
      "66627": true,
      "66628": true,
      "66629": true,
      "66630": true,
      "66631": true,
      "66632": true,
      "66633": true,
      "66634": true,
      "66635": true,
      "66636": true,
      "66637": true,
      "66638": true,
      "66639": true,
      "66640": true,
      "66641": true,
      "66642": true,
      "66643": true,
      "66644": true,
      "66645": true,
      "66646": true,
      "66647": true,
      "66648": true,
      "66649": true
    },
    "CADEREYTA JIMENEZ": {
      "67451": true,
      "67452": true,
      "67453": true,
      "67454": true,
      "67455": true,
      "67456": true,
      "67457": true,
      "67458": true,
      "67459": true,
      "67462": true,
      "67463": true,
      "67464": true,
      "67467": true,
      "67468": true,
      "67469": true,
      "67470": true,
      "67471": true,
      "67472": true,
      "67473": true,
      "67474": true,
      "67475": true,
      "67476": true,
      "67477": true,
      "67478": true,
      "67479": true,
      "67480": true,
      "67481": true,
      "67482": true,
      "67483": true,
      "67484": true,
      "67485": true,
      "67486": true,
      "67487": true,
      "67488": true,
      "67489": true,
      "67492": true,
      "67499": true
    },
    "CERRALVO": {
      "65900": true,
      "65901": true,
      "65902": true,
      "65903": true,
      "65904": true,
      "65905": true,
      "65906": true,
      "65907": true,
      "65908": true,
      "65909": true,
      "65910": true,
      "65911": true,
      "65912": true,
      "65913": true,
      "65914": true,
      "65915": true,
      "65916": true,
      "65917": true,
      "65918": true,
      "65919": true,
      "65920": true,
      "65921": true,
      "65922": true,
      "65923": true,
      "65924": true,
      "65925": true,
      "65926": true,
      "65927": true,
      "65928": true,
      "65929": true,
      "65930": true,
      "65931": true,
      "65932": true,
      "65933": true,
      "65934": true,
      "65935": true,
      "65936": true,
      "65937": true,
      "65938": true,
      "65939": true,
      "65940": true,
      "65941": true,
      "65942": true,
      "65943": true,
      "65944": true,
      "65945": true,
      "65946": true,
      "65947": true,
      "65948": true,
      "65949": true
    },
    "CIENEGA DE FLORES": {
      "65550": true,
      "65551": true,
      "65552": true,
      "65553": true,
      "65554": true,
      "65555": true,
      "65556": true,
      "65557": true,
      "65558": true,
      "65559": true,
      "65560": true,
      "65561": true,
      "65562": true,
      "65563": true,
      "65564": true,
      "65565": true,
      "65566": true,
      "65567": true,
      "65568": true,
      "65569": true,
      "65570": true,
      "65571": true,
      "65572": true,
      "65573": true,
      "65574": true,
      "65575": true,
      "65576": true,
      "65577": true,
      "65578": true,
      "65579": true,
      "65580": true,
      "65581": true,
      "65582": true,
      "65583": true,
      "65584": true,
      "65585": true,
      "65586": true,
      "65587": true,
      "65588": true,
      "65589": true,
      "65590": true,
      "65591": true,
      "65592": true,
      "65593": true,
      "65594": true,
      "65595": true,
      "65596": true,
      "65597": true,
      "65598": true,
      "65599": true
    },
    "DOCTOR GONZALEZ": {
      "66750": true,
      "66751": true,
      "66752": true,
      "66753": true,
      "66754": true,
      "66755": true,
      "66756": true,
      "66757": true,
      "66758": true,
      "66759": true,
      "66765": true,
      "66766": true,
      "66767": true,
      "66768": true,
      "66769": true,
      "66770": true,
      "66771": true,
      "66772": true,
      "66773": true,
      "66774": true,
      "66775": true,
      "66776": true,
      "66777": true,
      "66778": true,
      "66779": true,
      "66780": true,
      "66781": true,
      "66782": true
    },
    "GARCÍA": {
      "66005": true
    },
    "GARCIA": {
      "66023": true,
      "66024": true,
      "66027": true,
      "66033": true,
      "66035": true,
      "66036": true
    },
    "GENERAL BRAVO": {
      "67000": true,
      "67001": true,
      "67002": true,
      "67003": true,
      "67004": true,
      "67005": true,
      "67006": true,
      "67007": true,
      "67008": true,
      "67009": true,
      "67012": true,
      "67013": true,
      "67014": true,
      "67015": true,
      "67016": true,
      "67017": true,
      "67018": true,
      "67019": true,
      "67020": true,
      "67021": true,
      "67022": true,
      "67023": true,
      "67024": true,
      "67025": true,
      "67026": true,
      "67027": true,
      "67028": true,
      "67029": true
    },
    "GENERAL ESCOBEDO": {
      "66050": true,
      "66051": true,
      "66052": true,
      "66053": true,
      "66054": true,
      "66055": true,
      "66056": true,
      "66057": true,
      "66058": true,
      "66059": true,
      "66060": true,
      "66061": true,
      "66062": true,
      "66063": true,
      "66064": true,
      "66065": true,
      "66066": true,
      "66067": true,
      "66068": true,
      "66069": true,
      "66070": true,
      "66071": true,
      "66072": true,
      "66073": true,
      "66074": true,
      "66075": true,
      "66076": true,
      "66077": true,
      "66078": true,
      "66079": true,
      "66080": true,
      "66081": true,
      "66082": true,
      "66083": true,
      "66084": true,
      "66085": true,
      "66086": true,
      "66087": true,
      "66088": true,
      "66089": true,
      "66090": true,
      "66091": true,
      "66092": true,
      "66093": true,
      "66094": true,
      "66095": true,
      "66096": true,
      "66097": true,
      "66098": true,
      "66099": true
    },
    "GENERAL ZUAZUA": {
      "65750": true,
      "65751": true,
      "65752": true,
      "65753": true,
      "65754": true,
      "65755": true,
      "65756": true,
      "65757": true,
      "65758": true,
      "65759": true,
      "65760": true,
      "65761": true,
      "65762": true,
      "65763": true,
      "65764": true,
      "65765": true,
      "65766": true,
      "65767": true,
      "65768": true,
      "65769": true,
      "65770": true,
      "65771": true,
      "65772": true,
      "65773": true,
      "65774": true,
      "65775": true,
      "65776": true,
      "65777": true,
      "65778": true,
      "65779": true,
      "65780": true,
      "65781": true,
      "65782": true,
      "65783": true,
      "65784": true,
      "65785": true,
      "65786": true,
      "65787": true,
      "65788": true,
      "65789": true,
      "65790": true,
      "65791": true,
      "65792": true,
      "65793": true,
      "65794": true,
      "65795": true,
      "65796": true,
      "65797": true,
      "65798": true,
      "65799": true
    },
    "GUADALUPE": {
      "67100": true,
      "67102": true,
      "67110": true,
      "67112": true,
      "67113": true,
      "67114": true,
      "67115": true,
      "67116": true,
      "67117": true,
      "67118": true,
      "67119": true,
      "67120": true,
      "67123": true,
      "67124": true,
      "67125": true,
      "67126": true,
      "67128": true,
      "67129": true,
      "67130": true,
      "67132": true,
      "67133": true,
      "67134": true,
      "67140": true,
      "67144": true,
      "67150": true,
      "67153": true,
      "67154": true,
      "67155": true,
      "67160": true,
      "67163": true,
      "67164": true,
      "67165": true,
      "67166": true,
      "67167": true,
      "67168": true,
      "67169": true,
      "67170": true,
      "67173": true,
      "67174": true,
      "67175": true,
      "67176": true,
      "67177": true,
      "67178": true,
      "67179": true,
      "67180": true,
      "67182": true,
      "67183": true,
      "67184": true,
      "67185": true,
      "67186": true,
      "67188": true,
      "67189": true,
      "67190": true,
      "67192": true,
      "67193": true,
      "67194": true,
      "67195": true,
      "67196": true,
      "67197": true,
      "67198": true,
      "67199": true,
      "67200": true,
      "67202": true,
      "67203": true,
      "67204": true,
      "67205": true
    },
    "HUALAHUISES": {
      "67880": true,
      "67881": true,
      "67882": true,
      "67883": true,
      "67884": true,
      "67885": true,
      "67886": true,
      "67887": true,
      "67888": true,
      "67889": true,
      "67890": true,
      "67891": true,
      "67892": true,
      "67893": true,
      "67894": true,
      "67895": true,
      "67896": true,
      "67897": true,
      "67898": true,
      "67899": true
    },
    "JUAREZ": {
      "67265": true,
      "67266": true
    },
    "JUÁREZ": {
      "67275": true
    },
    "LINARES": {
      "67700": true,
      "67701": true,
      "67702": true,
      "67703": true,
      "67704": true,
      "67705": true,
      "67706": true,
      "67707": true,
      "67708": true,
      "67709": true,
      "67710": true,
      "67711": true,
      "67712": true,
      "67713": true,
      "67714": true,
      "67715": true,
      "67716": true,
      "67717": true,
      "67718": true,
      "67719": true,
      "67720": true,
      "67721": true,
      "67722": true,
      "67723": true,
      "67724": true,
      "67725": true,
      "67726": true,
      "67727": true,
      "67728": true,
      "67729": true,
      "67730": true,
      "67731": true,
      "67732": true,
      "67733": true,
      "67734": true,
      "67735": true,
      "67736": true,
      "67737": true,
      "67738": true,
      "67739": true,
      "67740": true,
      "67741": true,
      "67742": true,
      "67743": true,
      "67744": true,
      "67745": true,
      "67746": true,
      "67747": true,
      "67748": true,
      "67749": true,
      "67750": true,
      "67751": true,
      "67752": true,
      "67753": true,
      "67754": true,
      "67755": true,
      "67756": true,
      "67757": true,
      "67758": true,
      "67759": true,
      "67760": true,
      "67761": true,
      "67762": true,
      "67763": true,
      "67764": true,
      "67765": true,
      "67766": true,
      "67767": true,
      "67768": true,
      "67769": true,
      "67770": true,
      "67771": true,
      "67772": true,
      "67773": true,
      "67774": true,
      "67775": true,
      "67776": true,
      "67777": true,
      "67778": true,
      "67779": true,
      "67780": true,
      "67781": true,
      "67782": true,
      "67783": true,
      "67784": true,
      "67785": true,
      "67786": true,
      "67787": true,
      "67788": true,
      "67789": true,
      "67790": true,
      "67791": true,
      "67792": true,
      "67793": true,
      "67794": true,
      "67795": true,
      "67796": true,
      "67797": true,
      "67798": true,
      "67799": true,
      "67802": true,
      "67803": true,
      "67804": true,
      "67805": true,
      "67806": true,
      "67807": true,
      "67808": true,
      "67824": true,
      "67825": true,
      "67826": true,
      "67827": true
    },
    "MARIN": {
      "66700": true,
      "66701": true,
      "66702": true,
      "66703": true,
      "66704": true,
      "66705": true,
      "66706": true,
      "66707": true,
      "66708": true,
      "66709": true,
      "66710": true,
      "66711": true,
      "66712": true,
      "66713": true,
      "66714": true,
      "66715": true,
      "66716": true,
      "66717": true,
      "66718": true,
      "66719": true,
      "66720": true,
      "66721": true,
      "66722": true,
      "66723": true,
      "66724": true,
      "66725": true,
      "66726": true,
      "66727": true,
      "66728": true,
      "66729": true,
      "66730": true,
      "66731": true,
      "66732": true,
      "66733": true,
      "66734": true,
      "66735": true,
      "66736": true,
      "66737": true,
      "66738": true,
      "66739": true,
      "66740": true,
      "66741": true,
      "66742": true,
      "66743": true,
      "66744": true,
      "66745": true,
      "66746": true,
      "66747": true,
      "66748": true,
      "66749": true
    },
    "MINA": {
      "65100": true,
      "65101": true,
      "65102": true,
      "65103": true,
      "65104": true,
      "65105": true,
      "65106": true,
      "65107": true,
      "65108": true,
      "65109": true,
      "65116": true,
      "65117": true
    },
    "MONTEMORELOS": {
      "67500": true,
      "67501": true,
      "67502": true,
      "67503": true,
      "67504": true,
      "67505": true,
      "67506": true,
      "67507": true,
      "67508": true,
      "67509": true,
      "67510": true,
      "67511": true,
      "67512": true,
      "67513": true,
      "67514": true,
      "67515": true,
      "67516": true,
      "67517": true,
      "67518": true,
      "67519": true,
      "67520": true,
      "67521": true,
      "67522": true,
      "67523": true,
      "67524": true,
      "67525": true,
      "67526": true,
      "67527": true,
      "67528": true,
      "67529": true,
      "67530": true,
      "67531": true,
      "67532": true,
      "67533": true,
      "67534": true,
      "67535": true,
      "67536": true,
      "67537": true,
      "67538": true,
      "67539": true,
      "67540": true,
      "67541": true,
      "67542": true,
      "67543": true,
      "67544": true,
      "67545": true,
      "67546": true,
      "67547": true,
      "67548": true,
      "67549": true,
      "67550": true,
      "67551": true,
      "67552": true,
      "67553": true,
      "67554": true,
      "67555": true,
      "67556": true,
      "67557": true,
      "67558": true,
      "67559": true,
      "67560": true,
      "67561": true,
      "67562": true,
      "67563": true,
      "67564": true,
      "67565": true,
      "67566": true,
      "67567": true,
      "67568": true,
      "67569": true,
      "67570": true,
      "67571": true,
      "67572": true,
      "67573": true,
      "67574": true,
      "67575": true,
      "67576": true,
      "67577": true,
      "67578": true,
      "67579": true,
      "67580": true,
      "67581": true,
      "67582": true,
      "67583": true,
      "67584": true,
      "67585": true,
      "67586": true,
      "67587": true,
      "67588": true,
      "67589": true,
      "67590": true,
      "67591": true,
      "67592": true,
      "67593": true,
      "67594": true,
      "67595": true,
      "67596": true,
      "67597": true,
      "67598": true,
      "67599": true,
      "67600": true,
      "67601": true,
      "67602": true,
      "67603": true,
      "67604": true,
      "67605": true,
      "67606": true,
      "67607": true,
      "67608": true,
      "67609": true,
      "67610": true,
      "67611": true,
      "67612": true,
      "67613": true,
      "67614": true,
      "67615": true,
      "67616": true,
      "67617": true,
      "67618": true,
      "67619": true,
      "67620": true,
      "67621": true,
      "67622": true,
      "67623": true,
      "67624": true,
      "67625": true,
      "67626": true,
      "67627": true,
      "67628": true,
      "67629": true,
      "67630": true,
      "67631": true,
      "67632": true,
      "67633": true,
      "67634": true,
      "67635": true,
      "67636": true,
      "67640": true,
      "67641": true,
      "67642": true,
      "67643": true,
      "67644": true,
      "67645": true,
      "67646": true,
      "67647": true,
      "67648": true,
      "67649": true
    },
    "MONTERREY": {
      "64000": true,
      "64001": true,
      "64002": true,
      "64003": true,
      "64004": true,
      "64005": true,
      "64006": true,
      "64007": true,
      "64008": true,
      "64009": true,
      "64010": true,
      "64011": true,
      "64012": true,
      "64013": true,
      "64014": true,
      "64015": true,
      "64016": true,
      "64017": true,
      "64018": true,
      "64019": true,
      "64020": true,
      "64021": true,
      "64022": true,
      "64023": true,
      "64024": true,
      "64025": true,
      "64026": true,
      "64027": true,
      "64028": true,
      "64029": true,
      "64030": true,
      "64031": true,
      "64032": true,
      "64033": true,
      "64034": true,
      "64035": true,
      "64036": true,
      "64037": true,
      "64038": true,
      "64039": true,
      "64040": true,
      "64041": true,
      "64042": true,
      "64043": true,
      "64044": true,
      "64045": true,
      "64046": true,
      "64047": true,
      "64048": true,
      "64049": true,
      "64050": true,
      "64051": true,
      "64052": true,
      "64053": true,
      "64054": true,
      "64055": true,
      "64056": true,
      "64057": true,
      "64058": true,
      "64059": true,
      "64060": true,
      "64061": true,
      "64062": true,
      "64063": true,
      "64064": true,
      "64065": true,
      "64066": true,
      "64067": true,
      "64068": true,
      "64069": true,
      "64070": true,
      "64071": true,
      "64072": true,
      "64073": true,
      "64074": true,
      "64075": true,
      "64076": true,
      "64077": true,
      "64078": true,
      "64079": true,
      "64080": true,
      "64081": true,
      "64082": true,
      "64083": true,
      "64084": true,
      "64085": true,
      "64086": true,
      "64087": true,
      "64088": true,
      "64089": true,
      "64090": true,
      "64091": true,
      "64092": true,
      "64093": true,
      "64094": true,
      "64095": true,
      "64096": true,
      "64097": true,
      "64098": true,
      "64099": true,
      "64100": true,
      "64101": true,
      "64102": true,
      "64103": true,
      "64104": true,
      "64105": true,
      "64106": true,
      "64107": true,
      "64108": true,
      "64109": true,
      "64110": true,
      "64111": true,
      "64112": true,
      "64113": true,
      "64114": true,
      "64115": true,
      "64116": true,
      "64117": true,
      "64118": true,
      "64119": true,
      "64120": true,
      "64121": true,
      "64122": true,
      "64123": true,
      "64124": true,
      "64125": true,
      "64126": true,
      "64127": true,
      "64128": true,
      "64129": true,
      "64130": true,
      "64131": true,
      "64132": true,
      "64133": true,
      "64134": true,
      "64135": true,
      "64136": true,
      "64137": true,
      "64138": true,
      "64139": true,
      "64140": true,
      "64141": true,
      "64142": true,
      "64143": true,
      "64144": true,
      "64145": true,
      "64146": true,
      "64147": true,
      "64148": true,
      "64149": true,
      "64150": true,
      "64151": true,
      "64152": true,
      "64153": true,
      "64154": true,
      "64155": true,
      "64156": true,
      "64157": true,
      "64158": true,
      "64159": true,
      "64160": true,
      "64161": true,
      "64162": true,
      "64163": true,
      "64164": true,
      "64165": true,
      "64166": true,
      "64167": true,
      "64168": true,
      "64169": true,
      "64170": true,
      "64171": true,
      "64172": true,
      "64173": true,
      "64174": true,
      "64175": true,
      "64176": true,
      "64177": true,
      "64178": true,
      "64179": true,
      "64180": true,
      "64181": true,
      "64182": true,
      "64183": true,
      "64184": true,
      "64185": true,
      "64186": true,
      "64187": true,
      "64188": true,
      "64189": true,
      "64190": true,
      "64191": true,
      "64192": true,
      "64193": true,
      "64194": true,
      "64195": true,
      "64196": true,
      "64197": true,
      "64198": true,
      "64199": true,
      "64200": true,
      "64201": true,
      "64202": true,
      "64203": true,
      "64204": true,
      "64205": true,
      "64206": true,
      "64207": true,
      "64208": true,
      "64209": true,
      "64210": true,
      "64211": true,
      "64212": true,
      "64213": true,
      "64214": true,
      "64215": true,
      "64216": true,
      "64217": true,
      "64218": true,
      "64219": true,
      "64220": true,
      "64221": true,
      "64222": true,
      "64223": true,
      "64224": true,
      "64225": true,
      "64226": true,
      "64227": true,
      "64228": true,
      "64229": true,
      "64230": true,
      "64231": true,
      "64232": true,
      "64233": true,
      "64234": true,
      "64235": true,
      "64236": true,
      "64237": true,
      "64238": true,
      "64239": true,
      "64240": true,
      "64241": true,
      "64242": true,
      "64243": true,
      "64244": true,
      "64245": true,
      "64246": true,
      "64247": true,
      "64248": true,
      "64249": true,
      "64250": true,
      "64251": true,
      "64252": true,
      "64253": true,
      "64254": true,
      "64255": true,
      "64256": true,
      "64257": true,
      "64258": true,
      "64259": true,
      "64260": true,
      "64261": true,
      "64262": true,
      "64263": true,
      "64264": true,
      "64265": true,
      "64266": true,
      "64267": true,
      "64268": true,
      "64269": true,
      "64270": true,
      "64271": true,
      "64272": true,
      "64273": true,
      "64274": true,
      "64275": true,
      "64276": true,
      "64277": true,
      "64278": true,
      "64279": true,
      "64280": true,
      "64281": true,
      "64282": true,
      "64283": true,
      "64284": true,
      "64285": true,
      "64286": true,
      "64287": true,
      "64288": true,
      "64289": true,
      "64290": true,
      "64291": true,
      "64292": true,
      "64293": true,
      "64294": true,
      "64295": true,
      "64296": true,
      "64297": true,
      "64298": true,
      "64299": true,
      "64300": true,
      "64301": true,
      "64302": true,
      "64303": true,
      "64304": true,
      "64305": true,
      "64306": true,
      "64307": true,
      "64308": true,
      "64309": true,
      "64310": true,
      "64311": true,
      "64312": true,
      "64313": true,
      "64314": true,
      "64315": true,
      "64316": true,
      "64317": true,
      "64318": true,
      "64319": true,
      "64320": true,
      "64321": true,
      "64322": true,
      "64323": true,
      "64324": true,
      "64325": true,
      "64326": true,
      "64327": true,
      "64328": true,
      "64329": true,
      "64330": true,
      "64331": true,
      "64332": true,
      "64333": true,
      "64334": true,
      "64335": true,
      "64336": true,
      "64337": true,
      "64338": true,
      "64339": true,
      "64340": true,
      "64341": true,
      "64342": true,
      "64343": true,
      "64344": true,
      "64345": true,
      "64346": true,
      "64347": true,
      "64348": true,
      "64349": true,
      "64350": true,
      "64351": true,
      "64352": true,
      "64353": true,
      "64354": true,
      "64355": true,
      "64356": true,
      "64357": true,
      "64358": true,
      "64359": true,
      "64360": true,
      "64361": true,
      "64362": true,
      "64363": true,
      "64364": true,
      "64365": true,
      "64366": true,
      "64367": true,
      "64368": true,
      "64369": true,
      "64370": true,
      "64371": true,
      "64372": true,
      "64373": true,
      "64374": true,
      "64375": true,
      "64376": true,
      "64377": true,
      "64378": true,
      "64379": true,
      "64380": true,
      "64381": true,
      "64382": true,
      "64383": true,
      "64384": true,
      "64385": true,
      "64386": true,
      "64387": true,
      "64388": true,
      "64389": true,
      "64390": true,
      "64391": true,
      "64392": true,
      "64393": true,
      "64394": true,
      "64395": true,
      "64396": true,
      "64397": true,
      "64398": true,
      "64399": true,
      "64400": true,
      "64401": true,
      "64402": true,
      "64403": true,
      "64404": true,
      "64405": true,
      "64406": true,
      "64407": true,
      "64408": true,
      "64409": true,
      "64410": true,
      "64411": true,
      "64412": true,
      "64413": true,
      "64414": true,
      "64415": true,
      "64416": true,
      "64417": true,
      "64418": true,
      "64419": true,
      "64420": true,
      "64421": true,
      "64422": true,
      "64423": true,
      "64424": true,
      "64425": true,
      "64426": true,
      "64427": true,
      "64428": true,
      "64429": true,
      "64430": true,
      "64431": true,
      "64432": true,
      "64433": true,
      "64434": true,
      "64435": true,
      "64436": true,
      "64437": true,
      "64438": true,
      "64439": true,
      "64440": true,
      "64441": true,
      "64442": true,
      "64443": true,
      "64444": true,
      "64445": true,
      "64446": true,
      "64447": true,
      "64448": true,
      "64449": true,
      "64450": true,
      "64451": true,
      "64452": true,
      "64453": true,
      "64454": true,
      "64455": true,
      "64456": true,
      "64457": true,
      "64458": true,
      "64459": true,
      "64460": true,
      "64461": true,
      "64462": true,
      "64463": true,
      "64464": true,
      "64465": true,
      "64466": true,
      "64467": true,
      "64468": true,
      "64469": true,
      "64470": true,
      "64471": true,
      "64472": true,
      "64473": true,
      "64474": true,
      "64475": true,
      "64476": true,
      "64477": true,
      "64478": true,
      "64479": true,
      "64480": true,
      "64481": true,
      "64482": true,
      "64483": true,
      "64484": true,
      "64485": true,
      "64486": true,
      "64487": true,
      "64488": true,
      "64489": true,
      "64490": true,
      "64491": true,
      "64492": true,
      "64493": true,
      "64494": true,
      "64495": true,
      "64496": true,
      "64497": true,
      "64498": true,
      "64499": true,
      "64500": true,
      "64501": true,
      "64502": true,
      "64503": true,
      "64504": true,
      "64505": true,
      "64506": true,
      "64507": true,
      "64508": true,
      "64509": true,
      "64510": true,
      "64511": true,
      "64512": true,
      "64513": true,
      "64514": true,
      "64515": true,
      "64516": true,
      "64517": true,
      "64518": true,
      "64519": true,
      "64520": true,
      "64521": true,
      "64522": true,
      "64523": true,
      "64524": true,
      "64525": true,
      "64526": true,
      "64527": true,
      "64528": true,
      "64529": true,
      "64530": true,
      "64531": true,
      "64532": true,
      "64533": true,
      "64534": true,
      "64535": true,
      "64536": true,
      "64537": true,
      "64538": true,
      "64539": true,
      "64540": true,
      "64541": true,
      "64542": true,
      "64543": true,
      "64544": true,
      "64545": true,
      "64546": true,
      "64547": true,
      "64548": true,
      "64549": true,
      "64550": true,
      "64551": true,
      "64552": true,
      "64553": true,
      "64554": true,
      "64555": true,
      "64556": true,
      "64557": true,
      "64558": true,
      "64559": true,
      "64560": true,
      "64561": true,
      "64562": true,
      "64563": true,
      "64564": true,
      "64565": true,
      "64566": true,
      "64567": true,
      "64568": true,
      "64569": true,
      "64570": true,
      "64571": true,
      "64572": true,
      "64573": true,
      "64574": true,
      "64575": true,
      "64576": true,
      "64577": true,
      "64578": true,
      "64579": true,
      "64580": true,
      "64581": true,
      "64582": true,
      "64583": true,
      "64584": true,
      "64585": true,
      "64586": true,
      "64587": true,
      "64588": true,
      "64589": true,
      "64590": true,
      "64591": true,
      "64592": true,
      "64593": true,
      "64594": true,
      "64595": true,
      "64596": true,
      "64597": true,
      "64598": true,
      "64599": true,
      "64600": true,
      "64601": true,
      "64602": true,
      "64603": true,
      "64604": true,
      "64605": true,
      "64606": true,
      "64607": true,
      "64608": true,
      "64609": true,
      "64610": true,
      "64611": true,
      "64612": true,
      "64613": true,
      "64614": true,
      "64615": true,
      "64616": true,
      "64617": true,
      "64618": true,
      "64619": true,
      "64620": true,
      "64621": true,
      "64622": true,
      "64623": true,
      "64624": true,
      "64625": true,
      "64626": true,
      "64627": true,
      "64628": true,
      "64629": true,
      "64630": true,
      "64631": true,
      "64632": true,
      "64633": true,
      "64634": true,
      "64635": true,
      "64636": true,
      "64637": true,
      "64638": true,
      "64639": true,
      "64640": true,
      "64641": true,
      "64642": true,
      "64643": true,
      "64644": true,
      "64645": true,
      "64646": true,
      "64647": true,
      "64648": true,
      "64649": true,
      "64650": true,
      "64651": true,
      "64652": true,
      "64653": true,
      "64654": true,
      "64655": true,
      "64656": true,
      "64657": true,
      "64658": true,
      "64659": true,
      "64660": true,
      "64661": true,
      "64662": true,
      "64663": true,
      "64664": true,
      "64665": true,
      "64666": true,
      "64667": true,
      "64668": true,
      "64669": true,
      "64670": true,
      "64671": true,
      "64672": true,
      "64673": true,
      "64674": true,
      "64675": true,
      "64676": true,
      "64677": true,
      "64678": true,
      "64679": true,
      "64680": true,
      "64681": true,
      "64682": true,
      "64683": true,
      "64684": true,
      "64685": true,
      "64686": true,
      "64687": true,
      "64688": true,
      "64689": true,
      "64690": true,
      "64691": true,
      "64692": true,
      "64693": true,
      "64694": true,
      "64695": true,
      "64696": true,
      "64697": true,
      "64698": true,
      "64699": true,
      "64700": true,
      "64701": true,
      "64702": true,
      "64703": true,
      "64704": true,
      "64705": true,
      "64706": true,
      "64707": true,
      "64708": true,
      "64709": true,
      "64710": true,
      "64711": true,
      "64712": true,
      "64713": true,
      "64714": true,
      "64715": true,
      "64716": true,
      "64717": true,
      "64718": true,
      "64719": true,
      "64720": true,
      "64721": true,
      "64722": true,
      "64723": true,
      "64724": true,
      "64725": true,
      "64726": true,
      "64727": true,
      "64728": true,
      "64729": true,
      "64730": true,
      "64731": true,
      "64732": true,
      "64733": true,
      "64734": true,
      "64735": true,
      "64736": true,
      "64737": true,
      "64738": true,
      "64739": true,
      "64740": true,
      "64741": true,
      "64742": true,
      "64743": true,
      "64744": true,
      "64745": true,
      "64746": true,
      "64747": true,
      "64748": true,
      "64749": true,
      "64750": true,
      "64751": true,
      "64752": true,
      "64753": true,
      "64754": true,
      "64755": true,
      "64756": true,
      "64757": true,
      "64758": true,
      "64759": true,
      "64760": true,
      "64761": true,
      "64762": true,
      "64763": true,
      "64764": true,
      "64765": true,
      "64766": true,
      "64767": true,
      "64768": true,
      "64769": true,
      "64770": true,
      "64771": true,
      "64772": true,
      "64773": true,
      "64774": true,
      "64775": true,
      "64776": true,
      "64777": true,
      "64778": true,
      "64779": true,
      "64780": true,
      "64781": true,
      "64782": true,
      "64783": true,
      "64784": true,
      "64785": true,
      "64786": true,
      "64787": true,
      "64788": true,
      "64789": true,
      "64790": true,
      "64791": true,
      "64792": true,
      "64793": true,
      "64794": true,
      "64795": true,
      "64796": true,
      "64797": true,
      "64798": true,
      "64799": true,
      "64800": true,
      "64801": true,
      "64802": true,
      "64803": true,
      "64804": true,
      "64805": true,
      "64806": true,
      "64807": true,
      "64808": true,
      "64809": true,
      "64810": true,
      "64811": true,
      "64812": true,
      "64813": true,
      "64814": true,
      "64815": true,
      "64816": true,
      "64817": true,
      "64818": true,
      "64819": true,
      "64820": true,
      "64821": true,
      "64822": true,
      "64823": true,
      "64824": true,
      "64825": true,
      "64826": true,
      "64827": true,
      "64828": true,
      "64829": true,
      "64830": true,
      "64831": true,
      "64832": true,
      "64833": true,
      "64834": true,
      "64835": true,
      "64836": true,
      "64837": true,
      "64838": true,
      "64839": true,
      "64840": true,
      "64841": true,
      "64842": true,
      "64843": true,
      "64844": true,
      "64845": true,
      "64846": true,
      "64847": true,
      "64848": true,
      "64849": true,
      "64850": true,
      "64851": true,
      "64852": true,
      "64853": true,
      "64854": true,
      "64855": true,
      "64856": true,
      "64857": true,
      "64858": true,
      "64859": true,
      "64860": true,
      "64861": true,
      "64862": true,
      "64863": true,
      "64864": true,
      "64865": true,
      "64866": true,
      "64867": true,
      "64868": true,
      "64869": true,
      "64870": true,
      "64871": true,
      "64872": true,
      "64873": true,
      "64874": true,
      "64875": true,
      "64876": true,
      "64877": true,
      "64878": true,
      "64879": true,
      "64880": true,
      "64881": true,
      "64882": true,
      "64883": true,
      "64884": true,
      "64885": true,
      "64886": true,
      "64887": true,
      "64888": true,
      "64889": true,
      "64890": true,
      "64891": true,
      "64892": true,
      "64893": true,
      "64894": true,
      "64895": true,
      "64896": true,
      "64897": true,
      "64898": true,
      "64899": true,
      "64900": true,
      "64901": true,
      "64902": true,
      "64903": true,
      "64904": true,
      "64905": true,
      "64906": true,
      "64907": true,
      "64908": true,
      "64909": true,
      "64910": true,
      "64911": true,
      "64912": true,
      "64913": true,
      "64914": true,
      "64915": true,
      "64916": true,
      "64917": true,
      "64918": true,
      "64919": true,
      "64920": true,
      "64921": true,
      "64922": true,
      "64923": true,
      "64924": true,
      "64925": true,
      "64926": true,
      "64927": true,
      "64928": true,
      "64929": true,
      "64930": true,
      "64931": true,
      "64932": true,
      "64933": true,
      "64934": true,
      "64935": true,
      "64936": true,
      "64937": true,
      "64938": true,
      "64939": true,
      "64940": true,
      "64941": true,
      "64942": true,
      "64943": true,
      "64944": true,
      "64945": true,
      "64946": true,
      "64947": true,
      "64948": true,
      "64949": true,
      "64950": true,
      "64951": true,
      "64952": true,
      "64953": true,
      "64954": true,
      "64955": true,
      "64956": true,
      "64957": true,
      "64958": true,
      "64959": true,
      "64960": true,
      "64961": true,
      "64962": true,
      "64963": true,
      "64964": true,
      "64965": true,
      "64966": true,
      "64967": true,
      "64968": true,
      "64969": true,
      "64970": true,
      "64971": true,
      "64972": true,
      "64973": true,
      "64974": true,
      "64975": true,
      "64976": true,
      "64977": true,
      "64978": true,
      "64979": true,
      "64980": true,
      "64981": true,
      "64982": true,
      "64983": true,
      "64984": true,
      "64985": true,
      "64986": true,
      "64987": true,
      "64988": true,
      "64989": true,
      "64990": true,
      "64991": true,
      "64992": true,
      "64993": true,
      "64994": true,
      "64995": true,
      "64996": true,
      "64997": true,
      "64998": true,
      "64999": true
    },
    "PESQUERIA": {
      "66650": true,
      "66651": true,
      "66652": true,
      "66653": true,
      "66654": true,
      "66655": true,
      "66656": true,
      "66657": true,
      "66658": true,
      "66659": true,
      "66660": true,
      "66661": true,
      "66662": true,
      "66663": true,
      "66664": true,
      "66665": true,
      "66666": true,
      "66667": true,
      "66668": true,
      "66669": true,
      "66670": true,
      "66671": true,
      "66672": true,
      "66673": true,
      "66674": true,
      "66675": true,
      "66676": true,
      "66677": true,
      "66678": true
    },
    "SABINAS HIDALGO": {
      "65200": true,
      "65201": true,
      "65202": true,
      "65203": true,
      "65204": true,
      "65205": true,
      "65206": true,
      "65207": true,
      "65208": true,
      "65209": true,
      "65210": true,
      "65211": true,
      "65212": true,
      "65213": true,
      "65214": true,
      "65215": true,
      "65216": true,
      "65217": true,
      "65218": true,
      "65219": true,
      "65220": true,
      "65221": true,
      "65222": true,
      "65223": true,
      "65224": true,
      "65225": true,
      "65226": true,
      "65227": true,
      "65228": true,
      "65229": true,
      "65230": true,
      "65231": true,
      "65232": true,
      "65233": true,
      "65234": true,
      "65235": true,
      "65236": true,
      "65237": true,
      "65238": true,
      "65239": true,
      "65240": true,
      "65241": true,
      "65242": true,
      "65243": true,
      "65244": true,
      "65245": true,
      "65246": true,
      "65247": true,
      "65248": true,
      "65249": true,
      "65250": true,
      "65251": true,
      "65252": true,
      "65253": true,
      "65254": true,
      "65255": true,
      "65256": true,
      "65257": true,
      "65258": true,
      "65259": true,
      "65260": true,
      "65261": true,
      "65262": true,
      "65263": true,
      "65264": true,
      "65265": true,
      "65266": true,
      "65267": true,
      "65268": true,
      "65269": true,
      "65270": true,
      "65271": true,
      "65272": true,
      "65273": true,
      "65274": true,
      "65275": true,
      "65276": true,
      "65277": true,
      "65278": true,
      "65279": true,
      "65280": true,
      "65281": true,
      "65282": true,
      "65283": true,
      "65284": true,
      "65285": true,
      "65286": true,
      "65287": true,
      "65288": true,
      "65289": true,
      "65290": true,
      "65291": true,
      "65292": true,
      "65293": true,
      "65294": true,
      "65295": true,
      "65296": true,
      "65297": true,
      "65298": true,
      "65299": true,
      "65300": true,
      "65301": true,
      "65302": true,
      "65303": true,
      "65304": true,
      "65305": true,
      "65306": true,
      "65307": true,
      "65308": true,
      "65309": true,
      "65310": true,
      "65311": true,
      "65312": true,
      "65313": true,
      "65314": true,
      "65315": true,
      "65316": true,
      "65317": true,
      "65318": true,
      "65319": true,
      "65320": true,
      "65321": true,
      "65322": true,
      "65323": true,
      "65324": true,
      "65325": true,
      "65326": true,
      "65327": true,
      "65328": true,
      "65329": true,
      "65330": true,
      "65331": true,
      "65332": true,
      "65333": true,
      "65334": true,
      "65335": true,
      "65336": true,
      "65337": true,
      "65338": true,
      "65339": true,
      "65340": true,
      "65341": true,
      "65342": true,
      "65343": true,
      "65344": true,
      "65345": true,
      "65346": true,
      "65347": true,
      "65348": true,
      "65349": true
    },
    "SALINAS VICTORIA": {
      "65500": true,
      "65501": true,
      "65502": true,
      "65503": true,
      "65504": true,
      "65505": true,
      "65506": true,
      "65507": true,
      "65508": true,
      "65509": true,
      "65510": true,
      "65511": true,
      "65512": true,
      "65513": true,
      "65514": true,
      "65515": true,
      "65516": true,
      "65517": true,
      "65518": true,
      "65519": true,
      "65526": true,
      "65527": true,
      "65537": true,
      "65538": true,
      "65539": true,
      "65540": true,
      "65541": true,
      "65542": true,
      "65546": true,
      "65548": true,
      "65549": true
    },
    "SAN NICOLÁS DE LOS GARZA": {
      "66400": true,
      "66401": true,
      "66402": true,
      "66403": true,
      "66404": true,
      "66405": true,
      "66406": true,
      "66407": true,
      "66408": true,
      "66409": true,
      "66410": true,
      "66411": true,
      "66412": true,
      "66413": true,
      "66414": true,
      "66415": true,
      "66416": true,
      "66417": true,
      "66418": true,
      "66419": true,
      "66420": true,
      "66421": true,
      "66422": true,
      "66423": true,
      "66424": true,
      "66425": true,
      "66426": true,
      "66427": true,
      "66428": true,
      "66429": true,
      "66430": true,
      "66431": true,
      "66432": true,
      "66433": true,
      "66434": true,
      "66435": true,
      "66436": true,
      "66437": true,
      "66438": true,
      "66439": true,
      "66440": true,
      "66441": true,
      "66442": true,
      "66443": true,
      "66444": true,
      "66445": true,
      "66446": true,
      "66447": true,
      "66448": true,
      "66449": true,
      "66450": true,
      "66451": true,
      "66452": true,
      "66453": true,
      "66454": true,
      "66455": true,
      "66456": true,
      "66457": true,
      "66458": true,
      "66459": true,
      "66460": true,
      "66461": true,
      "66462": true,
      "66463": true,
      "66464": true,
      "66465": true,
      "66466": true,
      "66467": true,
      "66468": true,
      "66469": true,
      "66470": true,
      "66471": true,
      "66472": true,
      "66473": true,
      "66474": true,
      "66475": true,
      "66476": true,
      "66477": true,
      "66478": true,
      "66479": true,
      "66480": true,
      "66481": true,
      "66482": true,
      "66483": true,
      "66484": true,
      "66485": true,
      "66486": true,
      "66487": true,
      "66488": true,
      "66489": true,
      "66490": true,
      "66491": true,
      "66492": true,
      "66493": true,
      "66494": true,
      "66495": true,
      "66496": true,
      "66497": true,
      "66498": true,
      "66499": true,
      "66500": true,
      "66501": true,
      "66502": true,
      "66503": true,
      "66504": true,
      "66505": true,
      "66506": true,
      "66507": true,
      "66508": true,
      "66509": true,
      "66510": true,
      "66511": true,
      "66512": true,
      "66513": true,
      "66514": true,
      "66515": true,
      "66516": true,
      "66517": true,
      "66518": true,
      "66519": true,
      "66520": true,
      "66521": true,
      "66522": true,
      "66523": true,
      "66524": true,
      "66525": true,
      "66526": true,
      "66527": true,
      "66528": true,
      "66529": true,
      "66530": true,
      "66531": true,
      "66532": true,
      "66533": true,
      "66534": true,
      "66535": true,
      "66536": true,
      "66537": true,
      "66538": true,
      "66539": true,
      "66540": true,
      "66541": true,
      "66542": true,
      "66543": true,
      "66544": true,
      "66545": true,
      "66546": true,
      "66547": true,
      "66548": true,
      "66549": true
    },
    "SAN PEDRO GARZA GARCÍA": {
      "66200": true,
      "66201": true,
      "66202": true,
      "66203": true,
      "66204": true,
      "66205": true,
      "66206": true,
      "66207": true,
      "66208": true,
      "66209": true,
      "66210": true,
      "66211": true,
      "66212": true,
      "66213": true,
      "66214": true,
      "66215": true,
      "66216": true,
      "66217": true,
      "66218": true,
      "66219": true,
      "66220": true,
      "66221": true,
      "66222": true,
      "66223": true,
      "66224": true,
      "66225": true,
      "66226": true,
      "66227": true,
      "66228": true,
      "66229": true,
      "66230": true,
      "66231": true,
      "66232": true,
      "66233": true,
      "66234": true,
      "66235": true,
      "66236": true,
      "66237": true,
      "66238": true,
      "66239": true,
      "66240": true,
      "66241": true,
      "66242": true,
      "66243": true,
      "66244": true,
      "66245": true,
      "66246": true,
      "66247": true,
      "66248": true,
      "66249": true,
      "66250": true,
      "66251": true,
      "66252": true,
      "66253": true,
      "66254": true,
      "66255": true,
      "66256": true,
      "66257": true,
      "66258": true,
      "66259": true,
      "66260": true,
      "66261": true,
      "66262": true,
      "66263": true,
      "66264": true,
      "66265": true,
      "66266": true,
      "66267": true,
      "66268": true,
      "66269": true,
      "66270": true,
      "66271": true,
      "66272": true,
      "66273": true,
      "66274": true,
      "66275": true,
      "66276": true,
      "66277": true,
      "66278": true,
      "66279": true,
      "66280": true,
      "66281": true,
      "66282": true,
      "66283": true,
      "66284": true,
      "66285": true,
      "66286": true,
      "66287": true,
      "66288": true,
      "66289": true,
      "66290": true,
      "66291": true,
      "66292": true,
      "66293": true,
      "66294": true,
      "66295": true,
      "66296": true,
      "66297": true,
      "66298": true,
      "66299": true,
      "66300": true,
      "66301": true,
      "66302": true,
      "66303": true,
      "66304": true,
      "66305": true,
      "66306": true,
      "66307": true,
      "66308": true,
      "66309": true,
      "66310": true,
      "66311": true,
      "66312": true,
      "66313": true,
      "66314": true,
      "66315": true,
      "66316": true,
      "66317": true,
      "66318": true,
      "66319": true,
      "66320": true,
      "66321": true,
      "66322": true,
      "66323": true,
      "66324": true,
      "66325": true,
      "66326": true,
      "66327": true,
      "66328": true,
      "66329": true,
      "66330": true,
      "66331": true,
      "66332": true,
      "66333": true,
      "66334": true,
      "66335": true,
      "66336": true,
      "66337": true,
      "66338": true,
      "66339": true,
      "66340": true,
      "66341": true,
      "66342": true,
      "66343": true,
      "66344": true,
      "66345": true,
      "66346": true,
      "66347": true,
      "66348": true,
      "66349": true
    },
    "SANTA CATARINA": {
      "66100": true,
      "66101": true,
      "66102": true,
      "66103": true,
      "66104": true,
      "66105": true,
      "66106": true,
      "66107": true,
      "66108": true,
      "66109": true,
      "66110": true,
      "66111": true,
      "66112": true,
      "66113": true,
      "66114": true,
      "66115": true,
      "66116": true,
      "66117": true,
      "66118": true,
      "66119": true,
      "66120": true,
      "66121": true,
      "66122": true,
      "66123": true,
      "66124": true,
      "66125": true,
      "66126": true,
      "66127": true,
      "66128": true,
      "66129": true,
      "66130": true,
      "66131": true,
      "66132": true,
      "66133": true,
      "66134": true,
      "66135": true,
      "66136": true,
      "66137": true,
      "66138": true,
      "66139": true,
      "66140": true,
      "66141": true,
      "66142": true,
      "66143": true,
      "66144": true,
      "66145": true,
      "66146": true,
      "66147": true,
      "66148": true,
      "66149": true,
      "66150": true,
      "66151": true,
      "66152": true,
      "66153": true,
      "66154": true,
      "66155": true,
      "66156": true,
      "66157": true,
      "66158": true,
      "66159": true,
      "66160": true,
      "66161": true,
      "66162": true,
      "66163": true,
      "66164": true,
      "66165": true,
      "66166": true,
      "66167": true,
      "66168": true,
      "66169": true,
      "66170": true,
      "66171": true,
      "66172": true,
      "66173": true,
      "66174": true,
      "66175": true,
      "66176": true,
      "66177": true,
      "66178": true,
      "66179": true,
      "66180": true,
      "66181": true,
      "66182": true,
      "66183": true,
      "66184": true,
      "66185": true,
      "66186": true,
      "66187": true,
      "66188": true,
      "66189": true,
      "66190": true,
      "66191": true,
      "66192": true,
      "66193": true,
      "66194": true,
      "66195": true,
      "66196": true,
      "66197": true,
      "66198": true,
      "66199": true,
      "66350": true,
      "66351": true,
      "66352": true,
      "66353": true,
      "66354": true,
      "66355": true,
      "66356": true,
      "66357": true,
      "66358": true,
      "66359": true,
      "66360": true,
      "66361": true,
      "66362": true,
      "66363": true,
      "66364": true,
      "66365": true,
      "66366": true,
      "66367": true,
      "66368": true,
      "66369": true,
      "66370": true,
      "66371": true,
      "66372": true,
      "66373": true,
      "66374": true,
      "66375": true,
      "66376": true,
      "66377": true,
      "66378": true,
      "66379": true,
      "66380": true,
      "66381": true,
      "66382": true,
      "66383": true,
      "66384": true,
      "66385": true,
      "66386": true,
      "66387": true,
      "66388": true,
      "66389": true,
      "66390": true,
      "66391": true,
      "66392": true,
      "66393": true,
      "66394": true,
      "66395": true,
      "66396": true,
      "66397": true,
      "66398": true,
      "66399": true
    },
    "SANTIAGO": {
      "67300": true,
      "67301": true,
      "67302": true,
      "67303": true,
      "67307": true,
      "67308": true,
      "67309": true,
      "67310": true,
      "67311": true,
      "67312": true,
      "67313": true,
      "67314": true,
      "67315": true,
      "67316": true,
      "67317": true,
      "67318": true,
      "67319": true,
      "67320": true,
      "67321": true,
      "67322": true,
      "67323": true,
      "67324": true,
      "67325": true,
      "67326": true,
      "67327": true,
      "67328": true,
      "67329": true,
      "67330": true,
      "67331": true,
      "67332": true,
      "67333": true,
      "67340": true,
      "67341": true,
      "67342": true,
      "67343": true,
      "67344": true,
      "67345": true,
      "67346": true,
      "67347": true,
      "67348": true,
      "67349": true
    },
    "VILLALDAMA": {
      "65350": true,
      "65351": true,
      "65352": true,
      "65353": true,
      "65354": true,
      "65355": true,
      "65356": true,
      "65357": true,
      "65358": true,
      "65359": true,
      "65360": true,
      "65361": true,
      "65362": true,
      "65363": true,
      "65364": true,
      "65365": true,
      "65366": true,
      "65367": true,
      "65368": true,
      "65369": true,
      "65370": true,
      "65371": true,
      "65372": true,
      "65373": true,
      "65374": true,
      "65375": true,
      "65376": true,
      "65377": true,
      "65378": true,
      "65379": true,
      "65380": true,
      "65381": true,
      "65382": true,
      "65383": true,
      "65384": true,
      "65385": true,
      "65386": true,
      "65387": true,
      "65388": true,
      "65389": true,
      "65390": true,
      "65391": true,
      "65392": true,
      "65393": true,
      "65394": true,
      "65395": true,
      "65396": true,
      "65397": true,
      "65398": true,
      "65399": true
    }
  },
  "OAXACA": {
    "OAXACA DE JUÁREZ": {
      "68000": true,
      "68001": true,
      "68002": true,
      "68003": true,
      "68004": true,
      "68005": true,
      "68006": true,
      "68007": true,
      "68008": true,
      "68009": true,
      "68010": true,
      "68011": true,
      "68012": true,
      "68013": true,
      "68014": true,
      "68015": true,
      "68016": true,
      "68017": true,
      "68018": true,
      "68019": true,
      "68020": true,
      "68021": true,
      "68022": true,
      "68023": true,
      "68024": true,
      "68025": true,
      "68026": true,
      "68027": true,
      "68028": true,
      "68029": true,
      "68030": true,
      "68031": true,
      "68032": true,
      "68033": true,
      "68034": true,
      "68035": true,
      "68036": true,
      "68037": true,
      "68038": true,
      "68039": true,
      "68040": true,
      "68041": true,
      "68042": true,
      "68043": true,
      "68044": true,
      "68045": true,
      "68046": true,
      "68047": true,
      "68048": true,
      "68049": true,
      "68050": true,
      "68051": true,
      "68052": true,
      "68053": true,
      "68054": true,
      "68055": true,
      "68056": true,
      "68057": true,
      "68058": true,
      "68059": true,
      "68060": true,
      "68061": true,
      "68062": true,
      "68063": true,
      "68064": true,
      "68065": true,
      "68066": true,
      "68067": true,
      "68068": true,
      "68069": true,
      "68070": true,
      "68071": true,
      "68072": true,
      "68073": true,
      "68074": true,
      "68075": true,
      "68076": true,
      "68077": true,
      "68078": true,
      "68079": true,
      "68080": true,
      "68081": true,
      "68082": true,
      "68083": true,
      "68084": true,
      "68085": true,
      "68086": true,
      "68087": true,
      "68088": true,
      "68089": true,
      "68090": true,
      "68091": true,
      "68092": true,
      "68093": true,
      "68094": true,
      "68095": true,
      "68096": true,
      "68097": true,
      "68098": true,
      "68099": true,
      "68100": true,
      "68101": true,
      "68102": true,
      "68103": true,
      "68104": true,
      "68105": true,
      "68106": true,
      "68107": true,
      "68108": true,
      "68109": true,
      "68110": true,
      "68111": true,
      "68112": true,
      "68113": true,
      "68114": true,
      "68115": true,
      "68116": true,
      "68117": true,
      "68118": true,
      "68119": true,
      "68120": true,
      "68121": true,
      "68122": true,
      "68123": true,
      "68124": true,
      "68125": true,
      "68126": true,
      "68127": true,
      "68128": true,
      "68129": true,
      "68130": true,
      "68131": true,
      "68132": true,
      "68133": true,
      "68134": true,
      "68135": true,
      "68136": true,
      "68137": true,
      "68138": true,
      "68139": true,
      "68140": true,
      "68141": true,
      "68142": true,
      "68143": true,
      "68144": true,
      "68145": true,
      "68146": true,
      "68147": true,
      "68148": true,
      "68149": true,
      "68150": true,
      "68151": true,
      "68152": true,
      "68153": true,
      "68154": true,
      "68155": true,
      "68156": true,
      "68157": true,
      "68158": true,
      "68159": true,
      "68160": true,
      "68161": true,
      "68162": true,
      "68163": true,
      "68164": true,
      "68165": true,
      "68166": true,
      "68167": true,
      "68168": true,
      "68169": true,
      "68170": true,
      "68171": true,
      "68172": true,
      "68173": true,
      "68174": true,
      "68175": true,
      "68176": true,
      "68177": true,
      "68178": true,
      "68179": true,
      "68180": true,
      "68181": true,
      "68182": true,
      "68183": true,
      "68184": true,
      "68185": true,
      "68186": true,
      "68187": true,
      "68188": true,
      "68189": true,
      "68190": true,
      "68191": true,
      "68192": true,
      "68193": true,
      "68194": true,
      "68195": true,
      "68196": true,
      "68197": true,
      "68198": true,
      "68199": true,
      "68274": true,
      "68275": true,
      "68276": true,
      "68277": true,
      "68278": true,
      "68279": true,
      "68280": true,
      "68281": true,
      "68282": true,
      "68283": true,
      "68284": true
    },
    "SAN AGUSTIN YATARENI": {
      "68290": true,
      "68291": true,
      "68292": true
    },
    "SAN ANDRES HUAYAPAM": {
      "68287": true,
      "68288": true,
      "68289": true
    },
    "SAN ANTONIO DE LA CAL": {
      "71256": true
    },
    "SAN JACINTO AMILPAS": {
      "68285": true,
      "68286": true
    },
    "SAN JUAN BAUTISTA TUXTEPEC": {
      "68300": true,
      "68310": true,
      "68313": true,
      "68314": true,
      "68320": true,
      "68322": true,
      "68323": true,
      "68324": true,
      "68325": true,
      "68326": true,
      "68330": true,
      "68333": true,
      "68334": true,
      "68335": true,
      "68336": true,
      "68340": true,
      "68345": true,
      "68347": true,
      "68350": true,
      "68353": true,
      "68360": true,
      "68363": true,
      "68364": true,
      "68365": true,
      "68370": true,
      "68373": true,
      "68374": true,
      "68375": true,
      "68376": true,
      "68440": true,
      "68442": true,
      "68443": true,
      "68444": true,
      "68446": true,
      "68447": true,
      "68448": true
    },
    "SAN PEDRO MIXTEPEC -DTO. 22 -": {
      "71980": true,
      "71982": true,
      "71983": true,
      "71984": true,
      "71985": true,
      "71989": true,
      "71990": true,
      "71992": true,
      "71993": true,
      "71994": true,
      "71996": true,
      "71997": true,
      "71998": true
    },
    "SAN SEBASTIAN TUTLA": {
      "71320": true,
      "71321": true,
      "71322": true,
      "71323": true,
      "71324": true,
      "71325": true
    },
    "SANTA CRUZ AMILPAS": {
      "71226": true,
      "71227": true,
      "71228": true,
      "71229": true
    },
    "SANTA CRUZ XOXOCOTLAN": {
      "71230": true,
      "71231": true,
      "71232": true,
      "71233": true,
      "71234": true,
      "71235": true,
      "71236": true,
      "71237": true,
      "71238": true,
      "71239": true
    },
    "SANTA LUCIA DEL CAMINO": {
      "71240": true,
      "71241": true,
      "71242": true,
      "71243": true,
      "71244": true,
      "71245": true
    },
    "SANTA MARIA ATZOMPA": {
      "71220": true,
      "71221": true,
      "71222": true,
      "71223": true
    },
    "SANTA MARIA DEL TULE": {
      "68297": true,
      "68298": true,
      "68299": true
    },
    "TLALIXTAC DE CABRERA": {
      "68270": true,
      "68271": true,
      "68272": true
    }
  },
  "PUEBLA": {
    "ACATZINGO": {
      "75150": true,
      "75151": true,
      "75152": true,
      "75153": true,
      "75154": true,
      "75155": true,
      "75156": true,
      "75157": true,
      "75158": true,
      "75159": true
    },
    "CHALCHICOMULA DE SESMA": {
      "75520": true,
      "75521": true,
      "75522": true,
      "75523": true,
      "75524": true,
      "75525": true,
      "75526": true,
      "75527": true,
      "75528": true,
      "75529": true,
      "75530": true,
      "75531": true,
      "75532": true,
      "75533": true,
      "75534": true,
      "75535": true,
      "75536": true,
      "75537": true,
      "75538": true,
      "75539": true
    },
    "CORONANGO": {
      "72670": true,
      "72680": true,
      "72683": true,
      "72685": true
    },
    "CUAPIAXTLA DE MADERO": {
      "75420": true,
      "75421": true,
      "75422": true,
      "75423": true,
      "75424": true,
      "75425": true,
      "75426": true,
      "75427": true,
      "75428": true,
      "75429": true,
      "75430": true,
      "75431": true,
      "75432": true,
      "75433": true,
      "75434": true,
      "75435": true,
      "75436": true,
      "75437": true,
      "75438": true,
      "75439": true
    },
    "CUAUTLANCINGO": {
      "72700": true,
      "72702": true,
      "72703": true,
      "72704": true,
      "72705": true,
      "72706": true,
      "72707": true,
      "72720": true,
      "72723": true,
      "72724": true,
      "72730": true,
      "72733": true,
      "72735": true
    },
    "EPATLAN": {
      "74630": true,
      "74631": true,
      "74632": true,
      "74633": true,
      "74634": true,
      "74635": true,
      "74636": true,
      "74637": true,
      "74638": true,
      "74639": true
    },
    "HUAUCHINANGO": {
      "73160": true,
      "73161": true,
      "73163": true,
      "73164": true,
      "73165": true,
      "73166": true,
      "73167": true,
      "73168": true,
      "73169": true,
      "73170": true,
      "73171": true,
      "73172": true,
      "73173": true,
      "73174": true,
      "73175": true,
      "73176": true,
      "73177": true,
      "73178": true,
      "73179": true
    },
    "IZUCAR DE MATAMOROS": {
      "74400": true,
      "74401": true,
      "74402": true,
      "74403": true,
      "74404": true,
      "74405": true,
      "74406": true,
      "74407": true,
      "74408": true,
      "74409": true,
      "74410": true,
      "74411": true,
      "74412": true,
      "74413": true,
      "74414": true,
      "74415": true,
      "74416": true,
      "74417": true,
      "74418": true,
      "74419": true,
      "74420": true,
      "74421": true,
      "74422": true,
      "74423": true,
      "74424": true,
      "74425": true,
      "74426": true,
      "74427": true,
      "74428": true,
      "74429": true,
      "74430": true,
      "74431": true,
      "74432": true,
      "74433": true,
      "74434": true,
      "74435": true,
      "74436": true,
      "74437": true,
      "74438": true,
      "74439": true,
      "74440": true,
      "74441": true,
      "74442": true,
      "74443": true,
      "74444": true,
      "74445": true,
      "74446": true,
      "74447": true,
      "74448": true,
      "74449": true,
      "74450": true,
      "74451": true,
      "74452": true,
      "74453": true,
      "74454": true,
      "74455": true,
      "74456": true,
      "74457": true,
      "74458": true,
      "74459": true,
      "74460": true,
      "74461": true,
      "74462": true,
      "74463": true,
      "74464": true,
      "74465": true,
      "74466": true,
      "74467": true,
      "74468": true,
      "74469": true,
      "74470": true,
      "74471": true,
      "74472": true,
      "74473": true,
      "74474": true,
      "74475": true,
      "74476": true,
      "74477": true,
      "74478": true,
      "74479": true,
      "74480": true,
      "74481": true,
      "74482": true,
      "74483": true,
      "74484": true,
      "74485": true,
      "74486": true,
      "74487": true,
      "74488": true,
      "74489": true,
      "74490": true,
      "74491": true,
      "74492": true,
      "74493": true,
      "74494": true,
      "74495": true,
      "74496": true,
      "74497": true,
      "74498": true,
      "74499": true,
      "74570": true,
      "74571": true,
      "74572": true,
      "74573": true,
      "74574": true,
      "74575": true,
      "74577": true
    },
    "JUAN C. BONILLA": {
      "72640": true,
      "72669": true
    },
    "LOS REYES DE JUAREZ": {
      "75400": true,
      "75401": true,
      "75402": true,
      "75403": true,
      "75404": true,
      "75405": true,
      "75406": true,
      "75407": true,
      "75408": true,
      "75409": true,
      "75410": true,
      "75411": true,
      "75412": true,
      "75413": true,
      "75414": true,
      "75415": true,
      "75416": true,
      "75417": true,
      "75418": true,
      "75419": true
    },
    "NEALTICAN": {
      "74300": true,
      "74301": true,
      "74302": true,
      "74303": true,
      "74304": true,
      "74305": true,
      "74306": true,
      "74307": true,
      "74308": true,
      "74309": true
    },
    "PUEBLA": {
      "72000": true,
      "72001": true,
      "72002": true,
      "72003": true,
      "72004": true,
      "72005": true,
      "72006": true,
      "72007": true,
      "72008": true,
      "72009": true,
      "72010": true,
      "72011": true,
      "72012": true,
      "72013": true,
      "72014": true,
      "72015": true,
      "72016": true,
      "72017": true,
      "72018": true,
      "72019": true,
      "72020": true,
      "72021": true,
      "72022": true,
      "72023": true,
      "72024": true,
      "72025": true,
      "72026": true,
      "72027": true,
      "72028": true,
      "72029": true,
      "72030": true,
      "72031": true,
      "72032": true,
      "72033": true,
      "72034": true,
      "72035": true,
      "72036": true,
      "72037": true,
      "72038": true,
      "72039": true,
      "72040": true,
      "72041": true,
      "72042": true,
      "72043": true,
      "72044": true,
      "72045": true,
      "72046": true,
      "72047": true,
      "72048": true,
      "72049": true,
      "72050": true,
      "72051": true,
      "72052": true,
      "72053": true,
      "72054": true,
      "72055": true,
      "72056": true,
      "72057": true,
      "72058": true,
      "72059": true,
      "72060": true,
      "72061": true,
      "72062": true,
      "72063": true,
      "72064": true,
      "72065": true,
      "72066": true,
      "72067": true,
      "72068": true,
      "72069": true,
      "72070": true,
      "72071": true,
      "72072": true,
      "72073": true,
      "72074": true,
      "72075": true,
      "72076": true,
      "72077": true,
      "72078": true,
      "72079": true,
      "72080": true,
      "72081": true,
      "72082": true,
      "72083": true,
      "72084": true,
      "72085": true,
      "72086": true,
      "72087": true,
      "72088": true,
      "72089": true,
      "72090": true,
      "72091": true,
      "72092": true,
      "72093": true,
      "72094": true,
      "72095": true,
      "72096": true,
      "72097": true,
      "72098": true,
      "72099": true,
      "72100": true,
      "72101": true,
      "72102": true,
      "72103": true,
      "72104": true,
      "72105": true,
      "72106": true,
      "72107": true,
      "72108": true,
      "72109": true,
      "72110": true,
      "72111": true,
      "72112": true,
      "72113": true,
      "72114": true,
      "72115": true,
      "72116": true,
      "72117": true,
      "72118": true,
      "72119": true,
      "72120": true,
      "72121": true,
      "72122": true,
      "72123": true,
      "72124": true,
      "72125": true,
      "72126": true,
      "72127": true,
      "72128": true,
      "72129": true,
      "72130": true,
      "72131": true,
      "72132": true,
      "72133": true,
      "72134": true,
      "72135": true,
      "72136": true,
      "72137": true,
      "72138": true,
      "72139": true,
      "72140": true,
      "72141": true,
      "72142": true,
      "72143": true,
      "72144": true,
      "72145": true,
      "72146": true,
      "72147": true,
      "72148": true,
      "72149": true,
      "72150": true,
      "72151": true,
      "72152": true,
      "72153": true,
      "72154": true,
      "72155": true,
      "72156": true,
      "72157": true,
      "72158": true,
      "72159": true,
      "72160": true,
      "72161": true,
      "72162": true,
      "72163": true,
      "72164": true,
      "72165": true,
      "72166": true,
      "72167": true,
      "72168": true,
      "72169": true,
      "72170": true,
      "72171": true,
      "72172": true,
      "72173": true,
      "72174": true,
      "72175": true,
      "72176": true,
      "72177": true,
      "72178": true,
      "72179": true,
      "72180": true,
      "72181": true,
      "72182": true,
      "72183": true,
      "72184": true,
      "72185": true,
      "72186": true,
      "72187": true,
      "72188": true,
      "72189": true,
      "72190": true,
      "72191": true,
      "72192": true,
      "72193": true,
      "72194": true,
      "72195": true,
      "72196": true,
      "72197": true,
      "72198": true,
      "72199": true,
      "72200": true,
      "72201": true,
      "72202": true,
      "72203": true,
      "72204": true,
      "72205": true,
      "72206": true,
      "72207": true,
      "72208": true,
      "72209": true,
      "72210": true,
      "72211": true,
      "72212": true,
      "72213": true,
      "72214": true,
      "72215": true,
      "72216": true,
      "72217": true,
      "72218": true,
      "72219": true,
      "72220": true,
      "72221": true,
      "72222": true,
      "72223": true,
      "72224": true,
      "72225": true,
      "72226": true,
      "72227": true,
      "72228": true,
      "72229": true,
      "72230": true,
      "72231": true,
      "72232": true,
      "72233": true,
      "72234": true,
      "72235": true,
      "72236": true,
      "72237": true,
      "72238": true,
      "72239": true,
      "72240": true,
      "72241": true,
      "72242": true,
      "72243": true,
      "72244": true,
      "72245": true,
      "72246": true,
      "72247": true,
      "72248": true,
      "72249": true,
      "72250": true,
      "72251": true,
      "72252": true,
      "72253": true,
      "72254": true,
      "72255": true,
      "72256": true,
      "72257": true,
      "72258": true,
      "72259": true,
      "72260": true,
      "72261": true,
      "72262": true,
      "72263": true,
      "72264": true,
      "72265": true,
      "72266": true,
      "72267": true,
      "72268": true,
      "72269": true,
      "72270": true,
      "72271": true,
      "72272": true,
      "72273": true,
      "72274": true,
      "72275": true,
      "72276": true,
      "72277": true,
      "72278": true,
      "72279": true,
      "72280": true,
      "72281": true,
      "72282": true,
      "72283": true,
      "72284": true,
      "72285": true,
      "72286": true,
      "72287": true,
      "72288": true,
      "72289": true,
      "72290": true,
      "72291": true,
      "72292": true,
      "72293": true,
      "72294": true,
      "72295": true,
      "72296": true,
      "72297": true,
      "72298": true,
      "72299": true,
      "72300": true,
      "72301": true,
      "72302": true,
      "72303": true,
      "72304": true,
      "72305": true,
      "72306": true,
      "72307": true,
      "72308": true,
      "72309": true,
      "72310": true,
      "72311": true,
      "72312": true,
      "72313": true,
      "72314": true,
      "72315": true,
      "72316": true,
      "72317": true,
      "72318": true,
      "72319": true,
      "72320": true,
      "72321": true,
      "72322": true,
      "72323": true,
      "72324": true,
      "72325": true,
      "72326": true,
      "72327": true,
      "72328": true,
      "72329": true,
      "72330": true,
      "72331": true,
      "72332": true,
      "72333": true,
      "72334": true,
      "72335": true,
      "72336": true,
      "72337": true,
      "72338": true,
      "72339": true,
      "72340": true,
      "72341": true,
      "72342": true,
      "72343": true,
      "72344": true,
      "72345": true,
      "72346": true,
      "72347": true,
      "72348": true,
      "72349": true,
      "72350": true,
      "72351": true,
      "72352": true,
      "72353": true,
      "72354": true,
      "72355": true,
      "72356": true,
      "72357": true,
      "72358": true,
      "72359": true,
      "72360": true,
      "72361": true,
      "72362": true,
      "72363": true,
      "72364": true,
      "72365": true,
      "72366": true,
      "72367": true,
      "72368": true,
      "72369": true,
      "72370": true,
      "72371": true,
      "72372": true,
      "72373": true,
      "72374": true,
      "72375": true,
      "72376": true,
      "72377": true,
      "72378": true,
      "72379": true,
      "72380": true,
      "72381": true,
      "72382": true,
      "72383": true,
      "72384": true,
      "72385": true,
      "72386": true,
      "72387": true,
      "72388": true,
      "72389": true,
      "72390": true,
      "72391": true,
      "72392": true,
      "72393": true,
      "72394": true,
      "72395": true,
      "72396": true,
      "72397": true,
      "72398": true,
      "72399": true,
      "72400": true,
      "72401": true,
      "72402": true,
      "72403": true,
      "72404": true,
      "72405": true,
      "72406": true,
      "72407": true,
      "72408": true,
      "72409": true,
      "72410": true,
      "72411": true,
      "72412": true,
      "72413": true,
      "72414": true,
      "72415": true,
      "72416": true,
      "72417": true,
      "72418": true,
      "72419": true,
      "72420": true,
      "72421": true,
      "72422": true,
      "72423": true,
      "72424": true,
      "72425": true,
      "72426": true,
      "72427": true,
      "72428": true,
      "72429": true,
      "72430": true,
      "72431": true,
      "72432": true,
      "72433": true,
      "72434": true,
      "72435": true,
      "72436": true,
      "72437": true,
      "72438": true,
      "72439": true,
      "72440": true,
      "72441": true,
      "72442": true,
      "72443": true,
      "72444": true,
      "72445": true,
      "72446": true,
      "72447": true,
      "72448": true,
      "72449": true,
      "72450": true,
      "72451": true,
      "72452": true,
      "72453": true,
      "72454": true,
      "72455": true,
      "72456": true,
      "72457": true,
      "72458": true,
      "72459": true,
      "72460": true,
      "72461": true,
      "72462": true,
      "72463": true,
      "72464": true,
      "72465": true,
      "72466": true,
      "72467": true,
      "72468": true,
      "72469": true,
      "72470": true,
      "72471": true,
      "72472": true,
      "72473": true,
      "72474": true,
      "72475": true,
      "72476": true,
      "72477": true,
      "72478": true,
      "72479": true,
      "72480": true,
      "72481": true,
      "72482": true,
      "72483": true,
      "72484": true,
      "72485": true,
      "72486": true,
      "72487": true,
      "72488": true,
      "72489": true,
      "72490": true,
      "72491": true,
      "72492": true,
      "72493": true,
      "72494": true,
      "72495": true,
      "72496": true,
      "72497": true,
      "72498": true,
      "72499": true,
      "72500": true,
      "72501": true,
      "72502": true,
      "72503": true,
      "72504": true,
      "72505": true,
      "72506": true,
      "72507": true,
      "72508": true,
      "72509": true,
      "72510": true,
      "72511": true,
      "72512": true,
      "72513": true,
      "72514": true,
      "72515": true,
      "72516": true,
      "72517": true,
      "72518": true,
      "72519": true,
      "72520": true,
      "72521": true,
      "72522": true,
      "72523": true,
      "72524": true,
      "72525": true,
      "72526": true,
      "72527": true,
      "72528": true,
      "72529": true,
      "72530": true,
      "72531": true,
      "72532": true,
      "72533": true,
      "72534": true,
      "72535": true,
      "72536": true,
      "72537": true,
      "72538": true,
      "72539": true,
      "72540": true,
      "72541": true,
      "72542": true,
      "72543": true,
      "72544": true,
      "72545": true,
      "72546": true,
      "72547": true,
      "72548": true,
      "72549": true,
      "72550": true,
      "72551": true,
      "72552": true,
      "72553": true,
      "72554": true,
      "72555": true,
      "72556": true,
      "72557": true,
      "72558": true,
      "72559": true,
      "72560": true,
      "72561": true,
      "72562": true,
      "72563": true,
      "72564": true,
      "72565": true,
      "72566": true,
      "72567": true,
      "72568": true,
      "72569": true,
      "72570": true,
      "72571": true,
      "72572": true,
      "72573": true,
      "72574": true,
      "72575": true,
      "72576": true,
      "72577": true,
      "72578": true,
      "72579": true,
      "72580": true,
      "72581": true,
      "72582": true,
      "72583": true,
      "72584": true,
      "72585": true,
      "72586": true,
      "72587": true,
      "72588": true,
      "72589": true,
      "72590": true,
      "72591": true,
      "72592": true,
      "72593": true,
      "72594": true,
      "72595": true,
      "72596": true,
      "72597": true,
      "72598": true,
      "72599": true,
      "72900": true,
      "72901": true,
      "72902": true,
      "72903": true,
      "72904": true,
      "72905": true,
      "72906": true,
      "72907": true,
      "72908": true,
      "72909": true,
      "72910": true,
      "72911": true,
      "72912": true,
      "72913": true,
      "72914": true,
      "72915": true,
      "72916": true,
      "72917": true,
      "72918": true,
      "72919": true,
      "72920": true,
      "72921": true,
      "72922": true,
      "72923": true,
      "72924": true,
      "72925": true,
      "72926": true,
      "72927": true,
      "72928": true,
      "72929": true,
      "72930": true,
      "72931": true,
      "72932": true,
      "72933": true,
      "72934": true,
      "72935": true,
      "72936": true,
      "72937": true,
      "72938": true,
      "72939": true,
      "72940": true,
      "72941": true,
      "72942": true,
      "72943": true,
      "72944": true,
      "72945": true,
      "72946": true,
      "72947": true,
      "72948": true,
      "72949": true,
      "72950": true,
      "72951": true,
      "72952": true,
      "72953": true,
      "72954": true,
      "72955": true,
      "72956": true,
      "72957": true,
      "72958": true,
      "72959": true,
      "72960": true,
      "72961": true,
      "72962": true,
      "72963": true,
      "72964": true,
      "72965": true,
      "72966": true,
      "72967": true,
      "72968": true,
      "72969": true,
      "72970": true,
      "72971": true,
      "72972": true,
      "72973": true,
      "72974": true,
      "72975": true,
      "72976": true,
      "72977": true,
      "72978": true,
      "72979": true
    },
    "SAN ANDRÉS CHOLULA": {
      "72803": true,
      "72804": true,
      "72805": true,
      "72806": true,
      "72807": true,
      "72808": true,
      "72809": true,
      "72810": true,
      "72811": true,
      "72812": true,
      "72813": true,
      "72814": true,
      "72815": true,
      "72816": true,
      "72817": true,
      "72818": true,
      "72819": true,
      "72820": true,
      "72821": true,
      "72822": true,
      "72823": true,
      "72824": true,
      "72825": true,
      "72826": true,
      "72827": true,
      "72828": true,
      "72829": true,
      "72830": true,
      "72831": true,
      "72832": true,
      "72833": true,
      "72834": true,
      "72835": true,
      "72836": true,
      "72837": true,
      "72838": true,
      "72839": true,
      "72840": true,
      "72841": true,
      "72842": true,
      "72843": true,
      "72844": true,
      "72845": true,
      "72846": true,
      "72847": true,
      "72848": true,
      "72849": true
    },
    "SAN MARTIN TOTOLTEPEC": {
      "74610": true,
      "74611": true,
      "74612": true,
      "74613": true,
      "74614": true,
      "74615": true,
      "74616": true,
      "74617": true,
      "74618": true,
      "74619": true
    },
    "SAN PEDRO CHOLULA": {
      "72750": true,
      "72754": true,
      "72755": true,
      "72757": true,
      "72760": true,
      "72762": true,
      "72764": true,
      "72765": true,
      "72766": true,
      "72767": true,
      "72768": true,
      "72770": true,
      "72772": true,
      "72774": true,
      "72775": true,
      "72776": true,
      "72777": true,
      "72778": true
    },
    "SAN SALVADOR HUIXCOLOTLA": {
      "75440": true,
      "75441": true,
      "75442": true,
      "75443": true,
      "75444": true,
      "75445": true,
      "75446": true,
      "75447": true,
      "75448": true,
      "75449": true,
      "75450": true,
      "75451": true,
      "75452": true,
      "75453": true,
      "75454": true,
      "75455": true,
      "75456": true,
      "75457": true,
      "75458": true,
      "75459": true
    },
    "SANTIAGO MIAHUATLAN": {
      "75820": true,
      "75821": true,
      "75822": true,
      "75823": true,
      "75824": true,
      "75825": true,
      "75826": true,
      "75827": true,
      "75828": true,
      "75829": true
    },
    "TECAMACHALCO": {
      "75480": true,
      "75481": true,
      "75482": true,
      "75483": true,
      "75484": true,
      "75485": true,
      "75486": true,
      "75487": true,
      "75488": true,
      "75489": true,
      "75490": true,
      "75491": true,
      "75492": true,
      "75493": true,
      "75494": true,
      "75495": true,
      "75496": true,
      "75497": true,
      "75498": true,
      "75499": true
    },
    "TEHUACAN": {
      "75700": true,
      "75701": true,
      "75702": true,
      "75703": true,
      "75704": true,
      "75705": true,
      "75706": true,
      "75707": true,
      "75708": true,
      "75709": true,
      "75710": true,
      "75711": true,
      "75712": true,
      "75713": true,
      "75714": true,
      "75715": true,
      "75716": true,
      "75717": true,
      "75718": true,
      "75719": true,
      "75720": true,
      "75721": true,
      "75722": true,
      "75723": true,
      "75724": true,
      "75725": true,
      "75726": true,
      "75727": true,
      "75728": true,
      "75729": true,
      "75730": true,
      "75731": true,
      "75732": true,
      "75733": true,
      "75734": true,
      "75735": true,
      "75736": true,
      "75737": true,
      "75738": true,
      "75739": true,
      "75740": true,
      "75741": true,
      "75742": true,
      "75743": true,
      "75744": true,
      "75745": true,
      "75746": true,
      "75747": true,
      "75748": true,
      "75749": true,
      "75750": true,
      "75751": true,
      "75752": true,
      "75753": true,
      "75754": true,
      "75755": true,
      "75756": true,
      "75757": true,
      "75758": true,
      "75759": true,
      "75760": true,
      "75761": true,
      "75762": true,
      "75763": true,
      "75764": true,
      "75765": true,
      "75766": true,
      "75767": true,
      "75768": true,
      "75769": true,
      "75770": true,
      "75771": true,
      "75772": true,
      "75773": true,
      "75774": true,
      "75775": true,
      "75776": true,
      "75777": true,
      "75778": true,
      "75779": true,
      "75780": true,
      "75781": true,
      "75782": true,
      "75783": true,
      "75784": true,
      "75785": true,
      "75786": true,
      "75787": true,
      "75788": true,
      "75789": true,
      "75790": true,
      "75791": true,
      "75792": true,
      "75793": true,
      "75794": true,
      "75795": true,
      "75796": true,
      "75797": true,
      "75798": true,
      "75799": true,
      "75853": true,
      "75854": true,
      "75855": true,
      "75857": true,
      "75858": true,
      "75859": true
    },
    "TEPANCO DE LOPEZ": {
      "75800": true,
      "75801": true,
      "75802": true,
      "75803": true,
      "75804": true,
      "75805": true,
      "75806": true,
      "75807": true,
      "75808": true,
      "75809": true
    },
    "TEPEOJUMA": {
      "74390": true,
      "74391": true,
      "74392": true,
      "74393": true,
      "74394": true,
      "74395": true,
      "74396": true,
      "74397": true,
      "74398": true,
      "74399": true
    },
    "TEZIUTLAN": {
      "73800": true,
      "73801": true,
      "73802": true,
      "73803": true,
      "73804": true,
      "73805": true,
      "73806": true,
      "73807": true,
      "73808": true,
      "73809": true,
      "73810": true,
      "73811": true,
      "73812": true,
      "73813": true,
      "73814": true,
      "73815": true,
      "73816": true,
      "73817": true,
      "73818": true,
      "73819": true,
      "73820": true,
      "73821": true,
      "73822": true,
      "73823": true,
      "73824": true,
      "73825": true,
      "73826": true,
      "73827": true,
      "73828": true,
      "73829": true,
      "73830": true,
      "73831": true,
      "73832": true,
      "73833": true,
      "73834": true,
      "73835": true,
      "73836": true,
      "73837": true,
      "73838": true,
      "73839": true,
      "73840": true,
      "73841": true,
      "73842": true,
      "73843": true,
      "73844": true,
      "73845": true,
      "73846": true,
      "73847": true,
      "73848": true,
      "73849": true,
      "73850": true,
      "73851": true,
      "73852": true,
      "73853": true,
      "73854": true,
      "73855": true,
      "73856": true,
      "73857": true,
      "73858": true,
      "73859": true,
      "73860": true,
      "73861": true,
      "73862": true,
      "73863": true,
      "73864": true,
      "73865": true,
      "73866": true,
      "73867": true,
      "73868": true,
      "73869": true,
      "73870": true,
      "73871": true,
      "73872": true,
      "73873": true,
      "73874": true,
      "73875": true,
      "73876": true,
      "73877": true,
      "73878": true,
      "73879": true,
      "73880": true,
      "73881": true,
      "73882": true,
      "73883": true,
      "73884": true,
      "73885": true,
      "73886": true,
      "73887": true,
      "73888": true,
      "73889": true,
      "73890": true,
      "73891": true,
      "73892": true,
      "73893": true,
      "73894": true,
      "73895": true,
      "73896": true,
      "73897": true,
      "73898": true,
      "73899": true,
      "73960": true,
      "73961": true,
      "73962": true,
      "73963": true,
      "73964": true,
      "73965": true,
      "73966": true,
      "73967": true,
      "73968": true,
      "73969": true
    },
    "TLAPANALA": {
      "74540": true,
      "74541": true,
      "74542": true,
      "74543": true,
      "74544": true,
      "74545": true,
      "74546": true,
      "74547": true,
      "74548": true,
      "74549": true
    },
    "TLATLAUQUITEPEC": {
      "73900": true,
      "73901": true,
      "73903": true,
      "73904": true,
      "73905": true,
      "73906": true,
      "73907": true,
      "73908": true,
      "73909": true
    },
    "TOCHTEPEC": {
      "75610": true,
      "75611": true,
      "75612": true,
      "75613": true,
      "75614": true,
      "75615": true,
      "75616": true,
      "75617": true,
      "75618": true,
      "75619": true
    },
    "VENUSTIANO CARRANZA": {
      "73030": true,
      "73049": true
    },
    "XICOTEPEC": {
      "73080": true,
      "73081": true,
      "73082": true,
      "73083": true,
      "73084": true,
      "73085": true,
      "73086": true,
      "73087": true,
      "73089": true,
      "73090": true,
      "73098": true,
      "73099": true
    },
    "YEHUALTEPEC": {
      "75670": true,
      "75671": true,
      "75672": true,
      "75673": true,
      "75674": true,
      "75675": true,
      "75676": true,
      "75677": true,
      "75678": true,
      "75679": true
    }
  },
  "QUERÉTARO": {
    "AMEALCO DE BONFIL": {
      "76850": true,
      "76851": true,
      "76852": true,
      "76853": true,
      "76854": true,
      "76855": true,
      "76856": true,
      "76857": true,
      "76858": true,
      "76859": true,
      "76860": true,
      "76862": true,
      "76863": true,
      "76864": true,
      "76865": true,
      "76866": true,
      "76867": true,
      "76868": true,
      "76869": true,
      "76870": true,
      "76871": true,
      "76872": true,
      "76873": true,
      "76874": true,
      "76875": true,
      "76876": true,
      "76877": true,
      "76878": true,
      "76880": true,
      "76881": true,
      "76882": true,
      "76883": true,
      "76884": true,
      "76885": true,
      "76886": true,
      "76887": true,
      "76888": true,
      "76889": true,
      "76894": true,
      "76895": true,
      "76896": true
    },
    "CADEREYTA DE MONTES": {
      "76500": true,
      "76501": true,
      "76502": true,
      "76503": true,
      "76504": true,
      "76505": true,
      "76506": true,
      "76507": true,
      "76508": true,
      "76509": true,
      "76510": true,
      "76511": true,
      "76512": true,
      "76513": true,
      "76514": true,
      "76515": true,
      "76516": true,
      "76517": true,
      "76518": true,
      "76519": true,
      "76525": true,
      "76540": true,
      "76541": true,
      "76542": true,
      "76543": true,
      "76548": true,
      "76549": true
    },
    "COLON": {
      "76270": true,
      "76271": true,
      "76274": true,
      "76275": true,
      "76276": true,
      "76277": true,
      "76279": true,
      "76280": true,
      "76281": true,
      "76282": true,
      "76283": true,
      "76284": true,
      "76285": true,
      "76286": true,
      "76287": true,
      "76288": true,
      "76289": true,
      "76290": true,
      "76291": true,
      "76292": true,
      "76293": true,
      "76295": true,
      "76296": true,
      "76297": true,
      "76298": true,
      "76299": true
    },
    "CORREGIDORA": {
      "76900": true,
      "76901": true,
      "76902": true,
      "76903": true,
      "76904": true,
      "76905": true,
      "76906": true,
      "76907": true,
      "76908": true,
      "76909": true,
      "76910": true,
      "76911": true,
      "76912": true,
      "76913": true,
      "76914": true,
      "76915": true,
      "76916": true,
      "76917": true,
      "76918": true,
      "76919": true,
      "76920": true,
      "76921": true,
      "76922": true,
      "76923": true,
      "76924": true,
      "76925": true,
      "76926": true,
      "76927": true,
      "76928": true,
      "76929": true,
      "76930": true,
      "76931": true,
      "76932": true,
      "76933": true,
      "76934": true,
      "76935": true,
      "76936": true,
      "76937": true,
      "76938": true,
      "76939": true,
      "76940": true,
      "76941": true,
      "76942": true,
      "76943": true,
      "76944": true,
      "76945": true,
      "76946": true,
      "76947": true,
      "76948": true,
      "76949": true
    },
    "EL MARQUÉS": {
      "76240": true,
      "76244": true,
      "76246": true
    },
    "EZEQUIEL MONTES": {
      "76650": true,
      "76651": true,
      "76652": true,
      "76653": true,
      "76654": true,
      "76655": true,
      "76656": true,
      "76657": true,
      "76658": true,
      "76659": true,
      "76660": true,
      "76661": true,
      "76662": true,
      "76663": true,
      "76664": true,
      "76665": true,
      "76666": true,
      "76667": true,
      "76668": true,
      "76669": true,
      "76670": true,
      "76671": true,
      "76672": true,
      "76673": true,
      "76674": true,
      "76675": true,
      "76676": true,
      "76677": true,
      "76678": true,
      "76679": true,
      "76680": true,
      "76681": true,
      "76682": true,
      "76685": true,
      "76686": true,
      "76687": true,
      "76690": true,
      "76691": true,
      "76692": true,
      "76693": true,
      "76694": true,
      "76695": true,
      "76696": true,
      "76697": true,
      "76698": true,
      "76699": true
    },
    "HUIMILPAN": {
      "76950": true,
      "76951": true,
      "76952": true,
      "76956": true,
      "76957": true,
      "76958": true,
      "76959": true,
      "76960": true,
      "76961": true,
      "76962": true,
      "76963": true,
      "76964": true,
      "76965": true,
      "76966": true,
      "76967": true,
      "76968": true,
      "76969": true,
      "76970": true,
      "76971": true,
      "76972": true,
      "76973": true,
      "76974": true,
      "76975": true,
      "76976": true,
      "76977": true,
      "76978": true,
      "76979": true,
      "76980": true,
      "76981": true,
      "76982": true,
      "76983": true,
      "76984": true,
      "76985": true,
      "76986": true,
      "76987": true,
      "76988": true,
      "76989": true
    },
    "JALPAN DE SERRA": {
      "76340": true,
      "76341": true,
      "76342": true,
      "76343": true,
      "76344": true,
      "76345": true,
      "76346": true,
      "76347": true,
      "76348": true,
      "76349": true,
      "76353": true,
      "76355": true,
      "76359": true
    },
    "PEDRO ESCOBEDO": {
      "76700": true,
      "76701": true,
      "76702": true,
      "76703": true,
      "76705": true,
      "76706": true,
      "76707": true,
      "76708": true,
      "76709": true,
      "76710": true,
      "76711": true,
      "76712": true,
      "76713": true,
      "76714": true,
      "76715": true,
      "76716": true,
      "76717": true,
      "76718": true,
      "76719": true,
      "76720": true,
      "76721": true,
      "76722": true,
      "76723": true,
      "76724": true,
      "76725": true,
      "76726": true,
      "76727": true,
      "76728": true,
      "76729": true,
      "76730": true,
      "76731": true,
      "76732": true,
      "76733": true,
      "76734": true,
      "76735": true,
      "76736": true,
      "76737": true,
      "76738": true,
      "76739": true,
      "76740": true,
      "76741": true,
      "76742": true,
      "76743": true,
      "76744": true,
      "76745": true,
      "76746": true,
      "76747": true,
      "76748": true,
      "76749": true
    },
    "QUERÉTARO": {
      "76000": true,
      "76001": true,
      "76002": true,
      "76003": true,
      "76004": true,
      "76005": true,
      "76006": true,
      "76007": true,
      "76008": true,
      "76009": true,
      "76010": true,
      "76011": true,
      "76012": true,
      "76013": true,
      "76014": true,
      "76015": true,
      "76016": true,
      "76017": true,
      "76018": true,
      "76019": true,
      "76020": true,
      "76021": true,
      "76022": true,
      "76023": true,
      "76024": true,
      "76025": true,
      "76026": true,
      "76027": true,
      "76028": true,
      "76029": true,
      "76030": true,
      "76031": true,
      "76032": true,
      "76033": true,
      "76034": true,
      "76035": true,
      "76036": true,
      "76037": true,
      "76038": true,
      "76039": true,
      "76040": true,
      "76041": true,
      "76042": true,
      "76043": true,
      "76044": true,
      "76045": true,
      "76046": true,
      "76047": true,
      "76048": true,
      "76049": true,
      "76050": true,
      "76051": true,
      "76052": true,
      "76053": true,
      "76054": true,
      "76055": true,
      "76056": true,
      "76057": true,
      "76058": true,
      "76059": true,
      "76060": true,
      "76061": true,
      "76062": true,
      "76063": true,
      "76064": true,
      "76065": true,
      "76066": true,
      "76067": true,
      "76068": true,
      "76069": true,
      "76070": true,
      "76071": true,
      "76072": true,
      "76073": true,
      "76074": true,
      "76075": true,
      "76076": true,
      "76077": true,
      "76078": true,
      "76079": true,
      "76080": true,
      "76081": true,
      "76082": true,
      "76083": true,
      "76084": true,
      "76085": true,
      "76086": true,
      "76087": true,
      "76088": true,
      "76089": true,
      "76090": true,
      "76091": true,
      "76092": true,
      "76093": true,
      "76094": true,
      "76095": true,
      "76096": true,
      "76097": true,
      "76098": true,
      "76099": true,
      "76100": true,
      "76101": true,
      "76102": true,
      "76103": true,
      "76104": true,
      "76105": true,
      "76106": true,
      "76107": true,
      "76108": true,
      "76109": true,
      "76110": true,
      "76111": true,
      "76112": true,
      "76113": true,
      "76114": true,
      "76115": true,
      "76116": true,
      "76117": true,
      "76118": true,
      "76119": true,
      "76120": true,
      "76121": true,
      "76122": true,
      "76123": true,
      "76124": true,
      "76125": true,
      "76126": true,
      "76127": true,
      "76128": true,
      "76129": true,
      "76130": true,
      "76131": true,
      "76132": true,
      "76133": true,
      "76134": true,
      "76135": true,
      "76136": true,
      "76137": true,
      "76138": true,
      "76139": true,
      "76140": true,
      "76141": true,
      "76142": true,
      "76143": true,
      "76144": true,
      "76145": true,
      "76146": true,
      "76147": true,
      "76148": true,
      "76149": true,
      "76150": true,
      "76151": true,
      "76152": true,
      "76153": true,
      "76154": true,
      "76155": true,
      "76156": true,
      "76157": true,
      "76158": true,
      "76159": true,
      "76160": true,
      "76161": true,
      "76162": true,
      "76163": true,
      "76164": true,
      "76165": true,
      "76166": true,
      "76167": true,
      "76168": true,
      "76169": true,
      "76170": true,
      "76171": true,
      "76172": true,
      "76173": true,
      "76174": true,
      "76175": true,
      "76176": true,
      "76177": true,
      "76178": true,
      "76179": true,
      "76180": true,
      "76181": true,
      "76182": true,
      "76183": true,
      "76184": true,
      "76185": true,
      "76186": true,
      "76187": true,
      "76188": true,
      "76189": true,
      "76190": true,
      "76191": true,
      "76192": true,
      "76193": true,
      "76194": true,
      "76195": true,
      "76196": true,
      "76197": true,
      "76198": true,
      "76199": true,
      "76200": true,
      "76201": true,
      "76202": true,
      "76203": true,
      "76204": true,
      "76205": true,
      "76206": true,
      "76207": true,
      "76208": true,
      "76209": true,
      "76210": true,
      "76215": true,
      "76220": true,
      "76223": true,
      "76224": true,
      "76225": true,
      "76226": true,
      "76228": true,
      "76229": true,
      "76230": true,
      "76231": true,
      "76232": true,
      "76233": true,
      "76234": true,
      "76235": true,
      "76236": true,
      "76237": true,
      "76238": true,
      "76239": true
    },
    "SAN JOAQUIN": {
      "76550": true,
      "76551": true,
      "76552": true,
      "76553": true,
      "76554": true,
      "76555": true,
      "76556": true,
      "76557": true,
      "76558": true,
      "76559": true,
      "76560": true,
      "76561": true,
      "76562": true,
      "76564": true,
      "76565": true,
      "76566": true,
      "76568": true,
      "76569": true
    },
    "SAN JUAN DEL RIO": {
      "76800": true,
      "76801": true,
      "76802": true,
      "76803": true,
      "76804": true,
      "76805": true,
      "76806": true,
      "76807": true,
      "76808": true,
      "76809": true,
      "76810": true,
      "76811": true,
      "76812": true,
      "76813": true,
      "76814": true,
      "76815": true,
      "76816": true,
      "76817": true,
      "76818": true,
      "76819": true,
      "76820": true,
      "76821": true,
      "76822": true,
      "76823": true,
      "76824": true,
      "76825": true,
      "76826": true,
      "76827": true,
      "76828": true,
      "76829": true,
      "76830": true,
      "76831": true,
      "76832": true,
      "76833": true,
      "76834": true,
      "76835": true,
      "76836": true,
      "76837": true,
      "76838": true,
      "76839": true,
      "76840": true,
      "76841": true,
      "76842": true,
      "76843": true,
      "76844": true,
      "76845": true,
      "76846": true,
      "76847": true,
      "76848": true,
      "76849": true
    },
    "TEQUISQUIAPAN": {
      "76750": true,
      "76751": true,
      "76752": true,
      "76753": true,
      "76754": true,
      "76755": true,
      "76756": true,
      "76757": true,
      "76758": true,
      "76759": true,
      "76760": true,
      "76761": true,
      "76762": true,
      "76763": true,
      "76764": true,
      "76765": true,
      "76766": true,
      "76767": true,
      "76768": true,
      "76769": true,
      "76770": true,
      "76771": true,
      "76772": true,
      "76773": true,
      "76774": true,
      "76775": true,
      "76776": true,
      "76777": true,
      "76778": true,
      "76779": true,
      "76780": true,
      "76781": true,
      "76782": true,
      "76783": true,
      "76784": true,
      "76785": true,
      "76786": true,
      "76787": true,
      "76788": true,
      "76789": true,
      "76790": true,
      "76791": true,
      "76792": true,
      "76793": true,
      "76794": true,
      "76795": true,
      "76796": true,
      "76797": true,
      "76798": true,
      "76799": true
    },
    "TOLIMAN": {
      "76600": true,
      "76601": true,
      "76602": true,
      "76603": true,
      "76604": true,
      "76605": true,
      "76606": true,
      "76607": true,
      "76608": true,
      "76609": true,
      "76610": true,
      "76611": true,
      "76612": true,
      "76613": true,
      "76614": true,
      "76615": true,
      "76617": true,
      "76618": true,
      "76619": true,
      "76620": true,
      "76621": true,
      "76622": true,
      "76623": true,
      "76624": true,
      "76625": true,
      "76626": true,
      "76628": true,
      "76629": true,
      "76630": true,
      "76631": true,
      "76632": true,
      "76633": true,
      "76634": true,
      "76635": true,
      "76636": true,
      "76637": true,
      "76638": true,
      "76639": true,
      "76640": true,
      "76641": true,
      "76642": true,
      "76643": true,
      "76644": true,
      "76645": true,
      "76646": true,
      "76647": true,
      "76648": true,
      "76649": true
    }
  },
  "QUINTANA ROO": {
    "BACALAR": {
      "77900": true,
      "77904": true,
      "77905": true,
      "77906": true,
      "77907": true,
      "77910": true,
      "77913": true,
      "77914": true,
      "77915": true,
      "77916": true,
      "77917": true,
      "77920": true,
      "77923": true,
      "77924": true,
      "77925": true,
      "77926": true,
      "77927": true,
      "77930": true,
      "77933": true,
      "77934": true,
      "77935": true,
      "77936": true,
      "77937": true,
      "77940": true,
      "77943": true,
      "77944": true,
      "77945": true,
      "77946": true,
      "77947": true
    },
    "BENITO JUÁREZ": {
      "77500": true,
      "77501": true,
      "77502": true,
      "77503": true,
      "77504": true,
      "77505": true,
      "77506": true,
      "77507": true,
      "77508": true,
      "77509": true,
      "77510": true,
      "77511": true,
      "77512": true,
      "77513": true,
      "77514": true,
      "77515": true,
      "77516": true,
      "77517": true,
      "77518": true,
      "77519": true,
      "77520": true,
      "77521": true,
      "77522": true,
      "77523": true,
      "77524": true,
      "77525": true,
      "77526": true,
      "77527": true,
      "77528": true,
      "77529": true,
      "77530": true,
      "77531": true,
      "77532": true,
      "77533": true,
      "77534": true,
      "77535": true,
      "77536": true,
      "77537": true,
      "77538": true,
      "77539": true,
      "77540": true,
      "77541": true,
      "77542": true,
      "77543": true,
      "77544": true,
      "77545": true,
      "77546": true,
      "77547": true,
      "77548": true,
      "77549": true,
      "77550": true,
      "77551": true,
      "77552": true,
      "77553": true,
      "77554": true,
      "77555": true,
      "77556": true,
      "77557": true,
      "77558": true,
      "77559": true,
      "77560": true,
      "77561": true,
      "77562": true,
      "77563": true,
      "77564": true,
      "77565": true,
      "77566": true,
      "77567": true,
      "77568": true,
      "77569": true,
      "77570": true,
      "77571": true,
      "77572": true,
      "77573": true,
      "77574": true,
      "77575": true,
      "77576": true,
      "77577": true,
      "77578": true,
      "77579": true
    },
    "COZUMEL": {
      "77600": true,
      "77601": true,
      "77602": true,
      "77603": true,
      "77604": true,
      "77605": true,
      "77606": true,
      "77607": true,
      "77608": true,
      "77609": true,
      "77610": true,
      "77611": true,
      "77612": true,
      "77613": true,
      "77614": true,
      "77615": true,
      "77616": true,
      "77617": true,
      "77618": true,
      "77619": true,
      "77620": true,
      "77621": true,
      "77622": true,
      "77623": true,
      "77624": true,
      "77625": true,
      "77626": true,
      "77627": true,
      "77628": true,
      "77629": true,
      "77630": true,
      "77631": true,
      "77632": true,
      "77633": true,
      "77634": true,
      "77635": true,
      "77636": true,
      "77637": true,
      "77638": true,
      "77639": true,
      "77640": true,
      "77641": true,
      "77642": true,
      "77643": true,
      "77644": true,
      "77645": true,
      "77646": true,
      "77647": true,
      "77648": true,
      "77649": true,
      "77650": true,
      "77651": true,
      "77652": true,
      "77653": true,
      "77654": true,
      "77655": true,
      "77656": true,
      "77657": true,
      "77658": true,
      "77659": true,
      "77660": true,
      "77661": true,
      "77662": true,
      "77663": true,
      "77664": true,
      "77665": true,
      "77666": true,
      "77667": true,
      "77668": true,
      "77669": true,
      "77670": true,
      "77671": true,
      "77672": true,
      "77673": true,
      "77674": true,
      "77675": true,
      "77676": true,
      "77677": true,
      "77678": true,
      "77679": true,
      "77680": true,
      "77681": true,
      "77682": true,
      "77683": true,
      "77684": true,
      "77685": true,
      "77686": true,
      "77687": true,
      "77688": true,
      "77689": true,
      "77690": true,
      "77691": true,
      "77692": true,
      "77693": true,
      "77694": true,
      "77695": true,
      "77696": true,
      "77697": true,
      "77698": true,
      "77699": true,
      "77700": true,
      "77701": true,
      "77702": true,
      "77703": true,
      "77704": true,
      "77705": true,
      "77706": true,
      "77707": true,
      "77708": true,
      "77709": true
    },
    "FELIPE CARRILLO PUERTO": {
      "77100": true,
      "77104": true,
      "77105": true,
      "77106": true,
      "77107": true,
      "77108": true,
      "77110": true,
      "77114": true,
      "77115": true,
      "77116": true,
      "77117": true,
      "77118": true,
      "77120": true,
      "77121": true,
      "77123": true,
      "77125": true,
      "77130": true,
      "77133": true,
      "77135": true,
      "77140": true,
      "77144": true,
      "77148": true,
      "77150": true,
      "77160": true,
      "77163": true,
      "77169": true,
      "77170": true,
      "77174": true,
      "77175": true,
      "77176": true,
      "77177": true,
      "77178": true,
      "77180": true,
      "77185": true,
      "77188": true,
      "77190": true,
      "77196": true,
      "77197": true,
      "77200": true,
      "77210": true,
      "77214": true,
      "77215": true,
      "77216": true,
      "77217": true,
      "77220": true,
      "77229": true,
      "77230": true,
      "77238": true,
      "77239": true,
      "77240": true,
      "77249": true,
      "77250": true,
      "77259": true
    },
    "OTHON P. BLANCO": {
      "77000": true,
      "77001": true,
      "77002": true,
      "77003": true,
      "77004": true,
      "77005": true,
      "77006": true,
      "77007": true,
      "77008": true,
      "77009": true,
      "77010": true,
      "77011": true,
      "77012": true,
      "77013": true,
      "77014": true,
      "77015": true,
      "77016": true,
      "77017": true,
      "77018": true,
      "77019": true,
      "77020": true,
      "77021": true,
      "77022": true,
      "77023": true,
      "77024": true,
      "77025": true,
      "77026": true,
      "77027": true,
      "77028": true,
      "77029": true,
      "77030": true,
      "77031": true,
      "77032": true,
      "77033": true,
      "77034": true,
      "77035": true,
      "77036": true,
      "77037": true,
      "77038": true,
      "77039": true,
      "77040": true,
      "77041": true,
      "77042": true,
      "77043": true,
      "77044": true,
      "77045": true,
      "77046": true,
      "77047": true,
      "77048": true,
      "77049": true,
      "77050": true,
      "77051": true,
      "77052": true,
      "77053": true,
      "77054": true,
      "77055": true,
      "77056": true,
      "77057": true,
      "77058": true,
      "77059": true,
      "77060": true,
      "77061": true,
      "77062": true,
      "77063": true,
      "77064": true,
      "77065": true,
      "77066": true,
      "77067": true,
      "77068": true,
      "77069": true,
      "77070": true,
      "77071": true,
      "77072": true,
      "77073": true,
      "77074": true,
      "77075": true,
      "77076": true,
      "77077": true,
      "77078": true,
      "77079": true,
      "77080": true,
      "77081": true,
      "77082": true,
      "77083": true,
      "77084": true,
      "77085": true,
      "77086": true,
      "77087": true,
      "77088": true,
      "77089": true,
      "77090": true,
      "77091": true,
      "77092": true,
      "77093": true,
      "77094": true,
      "77095": true,
      "77096": true,
      "77097": true,
      "77098": true,
      "77099": true,
      "77950": true,
      "77951": true,
      "77952": true,
      "77953": true,
      "77954": true,
      "77955": true,
      "77956": true,
      "77957": true,
      "77958": true,
      "77959": true,
      "77960": true,
      "77961": true,
      "77962": true,
      "77963": true,
      "77964": true,
      "77965": true,
      "77966": true,
      "77967": true,
      "77968": true,
      "77969": true,
      "77970": true,
      "77971": true,
      "77972": true,
      "77973": true,
      "77974": true,
      "77975": true,
      "77976": true,
      "77977": true,
      "77978": true,
      "77979": true,
      "77980": true,
      "77981": true,
      "77982": true,
      "77983": true,
      "77984": true,
      "77985": true,
      "77986": true,
      "77987": true,
      "77988": true,
      "77989": true,
      "77990": true,
      "77991": true,
      "77992": true,
      "77993": true,
      "77994": true,
      "77995": true,
      "77996": true,
      "77997": true,
      "77998": true,
      "77999": true
    },
    "PUERTO MORELOS": {
      "77580": true,
      "77581": true,
      "77582": true,
      "77583": true,
      "77584": true,
      "77585": true,
      "77586": true,
      "77587": true,
      "77588": true,
      "77589": true,
      "77590": true,
      "77591": true,
      "77592": true,
      "77593": true,
      "77594": true,
      "77595": true,
      "77596": true,
      "77597": true,
      "77598": true,
      "77599": true
    },
    "SOLIDARIDAD": {
      "77710": true,
      "77711": true,
      "77712": true,
      "77713": true,
      "77714": true,
      "77715": true,
      "77716": true,
      "77717": true,
      "77718": true,
      "77719": true,
      "77720": true,
      "77721": true,
      "77722": true,
      "77723": true,
      "77724": true,
      "77725": true,
      "77726": true,
      "77727": true,
      "77728": true,
      "77729": true,
      "77730": true,
      "77731": true,
      "77732": true,
      "77733": true,
      "77734": true,
      "77735": true,
      "77736": true,
      "77737": true,
      "77738": true,
      "77739": true,
      "77740": true,
      "77741": true,
      "77742": true,
      "77743": true,
      "77744": true,
      "77745": true,
      "77746": true,
      "77747": true,
      "77748": true,
      "77749": true,
      "77750": true,
      "77751": true,
      "77752": true,
      "77753": true,
      "77754": true,
      "77755": true,
      "77756": true,
      "77757": true,
      "77758": true,
      "77759": true
    },
    "TULUM": {
      "77760": true,
      "77762": true,
      "77763": true,
      "77764": true,
      "77766": true,
      "77768": true,
      "77772": true,
      "77774": true,
      "77776": true,
      "77785": true,
      "77786": true,
      "77793": true,
      "77794": true,
      "77795": true,
      "77796": true
    }
  },
  "SAN LUIS POTOSÍ": {
    "AHUALULCO": {
      "78450": true,
      "78451": true,
      "78452": true,
      "78455": true,
      "78456": true,
      "78457": true,
      "78458": true,
      "78459": true
    },
    "CARDENAS": {
      "79380": true,
      "79381": true,
      "79382": true,
      "79383": true,
      "79384": true,
      "79385": true,
      "79386": true,
      "79387": true,
      "79388": true,
      "79389": true,
      "79390": true,
      "79391": true,
      "79392": true,
      "79393": true,
      "79394": true,
      "79395": true,
      "79397": true,
      "79398": true,
      "79399": true
    },
    "CEDRAL": {
      "78520": true,
      "78521": true,
      "78522": true,
      "78523": true,
      "78524": true,
      "78525": true,
      "78526": true,
      "78527": true,
      "78528": true,
      "78529": true,
      "78530": true,
      "78531": true,
      "78532": true,
      "78536": true,
      "78537": true,
      "78538": true,
      "78539": true
    },
    "CERRITOS": {
      "79400": true,
      "79406": true,
      "79407": true,
      "79408": true,
      "79409": true,
      "79420": true,
      "79421": true,
      "79422": true,
      "79423": true,
      "79424": true,
      "79425": true,
      "79426": true,
      "79427": true,
      "79428": true,
      "79430": true,
      "79431": true,
      "79433": true,
      "79435": true,
      "79436": true,
      "79440": true,
      "79441": true,
      "79442": true,
      "79443": true,
      "79444": true,
      "79445": true,
      "79446": true,
      "79447": true,
      "79448": true,
      "79449": true
    },
    "CERRO DE SAN PEDRO": {
      "78440": true,
      "78441": true,
      "78442": true,
      "78443": true,
      "78444": true,
      "78445": true,
      "78446": true,
      "78447": true,
      "78448": true,
      "78449": true
    },
    "CHARCAS": {
      "78570": true,
      "78571": true,
      "78572": true,
      "78573": true,
      "78574": true,
      "78575": true,
      "78576": true,
      "78577": true,
      "78583": true,
      "78584": true,
      "78586": true,
      "78590": true,
      "78591": true,
      "78592": true,
      "78593": true,
      "78594": true,
      "78595": true,
      "78596": true,
      "78597": true,
      "78598": true,
      "78599": true
    },
    "CIUDAD FERNANDEZ": {
      "79650": true,
      "79651": true,
      "79652": true,
      "79653": true,
      "79654": true,
      "79655": true,
      "79657": true,
      "79658": true,
      "79659": true,
      "79660": true,
      "79661": true,
      "79662": true,
      "79676": true
    },
    "CIUDAD VALLES": {
      "79000": true,
      "79001": true,
      "79002": true,
      "79003": true,
      "79004": true,
      "79005": true,
      "79006": true,
      "79007": true,
      "79008": true,
      "79009": true,
      "79010": true,
      "79011": true,
      "79012": true,
      "79013": true,
      "79014": true,
      "79015": true,
      "79016": true,
      "79017": true,
      "79018": true,
      "79019": true,
      "79020": true,
      "79021": true,
      "79022": true,
      "79023": true,
      "79024": true,
      "79025": true,
      "79026": true,
      "79027": true,
      "79028": true,
      "79029": true,
      "79030": true,
      "79031": true,
      "79032": true,
      "79033": true,
      "79034": true,
      "79035": true,
      "79036": true,
      "79037": true,
      "79038": true,
      "79039": true,
      "79040": true,
      "79041": true,
      "79042": true,
      "79043": true,
      "79044": true,
      "79045": true,
      "79046": true,
      "79047": true,
      "79048": true,
      "79049": true,
      "79050": true,
      "79051": true,
      "79052": true,
      "79053": true,
      "79054": true,
      "79055": true,
      "79056": true,
      "79057": true,
      "79058": true,
      "79059": true,
      "79060": true,
      "79061": true,
      "79062": true,
      "79063": true,
      "79064": true,
      "79065": true,
      "79066": true,
      "79067": true,
      "79068": true,
      "79069": true,
      "79070": true,
      "79071": true,
      "79072": true,
      "79073": true,
      "79074": true,
      "79075": true,
      "79076": true,
      "79077": true,
      "79078": true,
      "79079": true,
      "79080": true,
      "79081": true,
      "79082": true,
      "79083": true,
      "79084": true,
      "79085": true,
      "79086": true,
      "79087": true,
      "79088": true,
      "79089": true,
      "79090": true,
      "79091": true,
      "79092": true,
      "79093": true,
      "79094": true,
      "79095": true,
      "79096": true,
      "79097": true,
      "79098": true,
      "79099": true,
      "79246": true,
      "79247": true,
      "79248": true,
      "79249": true,
      "79250": true,
      "79251": true,
      "79252": true,
      "79253": true,
      "79254": true,
      "79255": true,
      "79256": true,
      "79257": true,
      "79258": true,
      "79259": true,
      "79260": true,
      "79261": true,
      "79262": true,
      "79263": true,
      "79264": true,
      "79265": true,
      "79266": true,
      "79267": true,
      "79268": true,
      "79269": true,
      "79270": true,
      "79271": true,
      "79272": true,
      "79273": true,
      "79274": true,
      "79275": true,
      "79276": true,
      "79277": true,
      "79278": true,
      "79279": true,
      "79286": true,
      "79287": true,
      "79288": true,
      "79289": true
    },
    "EBANO": {
      "79100": true,
      "79101": true,
      "79102": true,
      "79103": true,
      "79104": true,
      "79105": true,
      "79106": true,
      "79107": true,
      "79108": true,
      "79109": true,
      "79110": true,
      "79111": true,
      "79112": true,
      "79113": true,
      "79114": true,
      "79115": true,
      "79116": true,
      "79117": true,
      "79118": true,
      "79119": true,
      "79120": true,
      "79121": true,
      "79122": true,
      "79123": true,
      "79124": true,
      "79125": true,
      "79126": true,
      "79127": true,
      "79128": true,
      "79129": true,
      "79130": true,
      "79131": true,
      "79132": true,
      "79133": true,
      "79134": true,
      "79135": true,
      "79136": true,
      "79137": true,
      "79138": true,
      "79139": true,
      "79140": true,
      "79141": true,
      "79142": true,
      "79143": true,
      "79144": true,
      "79145": true,
      "79146": true,
      "79147": true,
      "79148": true,
      "79149": true,
      "79150": true,
      "79151": true,
      "79152": true,
      "79153": true,
      "79154": true,
      "79155": true,
      "79156": true,
      "79157": true,
      "79158": true,
      "79159": true,
      "79160": true,
      "79161": true,
      "79162": true,
      "79163": true,
      "79164": true,
      "79165": true,
      "79166": true,
      "79167": true,
      "79168": true,
      "79169": true,
      "79170": true,
      "79171": true,
      "79172": true,
      "79173": true,
      "79174": true,
      "79175": true,
      "79176": true,
      "79177": true,
      "79178": true,
      "79179": true,
      "79180": true,
      "79181": true,
      "79182": true,
      "79183": true,
      "79184": true,
      "79185": true,
      "79186": true,
      "79187": true,
      "79188": true,
      "79189": true,
      "79190": true,
      "79191": true,
      "79192": true,
      "79193": true,
      "79194": true,
      "79195": true,
      "79196": true,
      "79197": true,
      "79198": true,
      "79199": true,
      "79293": true,
      "79296": true
    },
    "MATEHUALA": {
      "78700": true,
      "78701": true,
      "78702": true,
      "78703": true,
      "78704": true,
      "78705": true,
      "78706": true,
      "78707": true,
      "78708": true,
      "78709": true,
      "78710": true,
      "78711": true,
      "78712": true,
      "78713": true,
      "78714": true,
      "78715": true,
      "78716": true,
      "78717": true,
      "78718": true,
      "78719": true,
      "78720": true,
      "78721": true,
      "78722": true,
      "78723": true,
      "78724": true,
      "78725": true,
      "78726": true,
      "78727": true,
      "78728": true,
      "78729": true,
      "78730": true,
      "78731": true,
      "78732": true,
      "78733": true,
      "78734": true,
      "78735": true,
      "78736": true,
      "78737": true,
      "78738": true,
      "78739": true,
      "78740": true,
      "78741": true,
      "78742": true,
      "78743": true,
      "78744": true,
      "78745": true,
      "78746": true,
      "78747": true,
      "78748": true,
      "78749": true,
      "78750": true,
      "78751": true,
      "78752": true,
      "78753": true,
      "78754": true,
      "78755": true,
      "78756": true,
      "78757": true,
      "78758": true,
      "78759": true,
      "78760": true,
      "78761": true,
      "78762": true,
      "78763": true,
      "78764": true,
      "78765": true,
      "78766": true,
      "78767": true,
      "78768": true,
      "78769": true,
      "78770": true,
      "78771": true,
      "78772": true,
      "78773": true,
      "78774": true,
      "78775": true,
      "78776": true,
      "78777": true,
      "78778": true,
      "78779": true,
      "78780": true,
      "78781": true,
      "78782": true,
      "78783": true,
      "78784": true,
      "78785": true,
      "78786": true,
      "78787": true,
      "78788": true,
      "78789": true,
      "78790": true,
      "78791": true,
      "78792": true,
      "78796": true,
      "78797": true,
      "78798": true,
      "78799": true,
      "78800": true,
      "78801": true,
      "78802": true,
      "78803": true,
      "78804": true,
      "78805": true,
      "78806": true,
      "78807": true,
      "78810": true,
      "78811": true,
      "78812": true,
      "78813": true,
      "78814": true,
      "78815": true,
      "78816": true,
      "78817": true,
      "78818": true,
      "78819": true,
      "78821": true
    },
    "MEXQUITIC DE CARMONA": {
      "78463": true,
      "78464": true,
      "78465": true,
      "78466": true,
      "78467": true,
      "78468": true,
      "78469": true,
      "78470": true,
      "78471": true,
      "78472": true,
      "78473": true,
      "78476": true,
      "78480": true,
      "78481": true,
      "78482": true,
      "78483": true,
      "78484": true,
      "78485": true,
      "78486": true,
      "78487": true,
      "78488": true,
      "78489": true
    },
    "MOCTEZUMA": {
      "78900": true,
      "78901": true,
      "78902": true,
      "78903": true,
      "78904": true,
      "78905": true,
      "78906": true,
      "78907": true,
      "78908": true,
      "78910": true,
      "78914": true,
      "78915": true,
      "78916": true,
      "78917": true,
      "78919": true
    },
    "RIOVERDE": {
      "79600": true,
      "79601": true,
      "79602": true,
      "79604": true,
      "79610": true,
      "79611": true,
      "79612": true,
      "79613": true,
      "79614": true,
      "79615": true,
      "79616": true,
      "79617": true,
      "79618": true,
      "79619": true,
      "79620": true,
      "79621": true,
      "79622": true,
      "79623": true,
      "79624": true,
      "79625": true,
      "79626": true,
      "79627": true,
      "79628": true,
      "79629": true,
      "79630": true,
      "79631": true,
      "79632": true,
      "79633": true,
      "79636": true,
      "79640": true,
      "79641": true,
      "79642": true,
      "79645": true
    },
    "SALINAS": {
      "78600": true,
      "78601": true,
      "78604": true,
      "78605": true,
      "78606": true,
      "78607": true,
      "78608": true,
      "78609": true,
      "78610": true,
      "78611": true,
      "78620": true,
      "78621": true,
      "78622": true,
      "78623": true,
      "78624": true,
      "78625": true,
      "78626": true,
      "78627": true,
      "78628": true,
      "78629": true
    },
    "SAN LUIS POTOSI": {
      "78000": true,
      "78001": true,
      "78002": true,
      "78003": true,
      "78004": true,
      "78005": true,
      "78006": true,
      "78007": true,
      "78008": true,
      "78009": true,
      "78010": true,
      "78011": true,
      "78012": true,
      "78013": true,
      "78014": true,
      "78015": true,
      "78016": true,
      "78017": true,
      "78018": true,
      "78019": true,
      "78020": true,
      "78021": true,
      "78022": true,
      "78023": true,
      "78024": true,
      "78025": true,
      "78026": true,
      "78027": true,
      "78028": true,
      "78029": true,
      "78030": true,
      "78031": true,
      "78032": true,
      "78033": true,
      "78034": true,
      "78035": true,
      "78036": true,
      "78037": true,
      "78038": true,
      "78039": true,
      "78040": true,
      "78041": true,
      "78042": true,
      "78043": true,
      "78044": true,
      "78045": true,
      "78046": true,
      "78047": true,
      "78048": true,
      "78049": true,
      "78050": true,
      "78051": true,
      "78052": true,
      "78053": true,
      "78054": true,
      "78055": true,
      "78056": true,
      "78057": true,
      "78058": true,
      "78059": true,
      "78060": true,
      "78061": true,
      "78062": true,
      "78063": true,
      "78064": true,
      "78065": true,
      "78066": true,
      "78067": true,
      "78068": true,
      "78069": true,
      "78070": true,
      "78071": true,
      "78072": true,
      "78073": true,
      "78074": true,
      "78075": true,
      "78076": true,
      "78077": true,
      "78078": true,
      "78079": true,
      "78080": true,
      "78081": true,
      "78082": true,
      "78083": true,
      "78084": true,
      "78085": true,
      "78086": true,
      "78087": true,
      "78088": true,
      "78089": true,
      "78090": true,
      "78091": true,
      "78092": true,
      "78093": true,
      "78094": true,
      "78095": true,
      "78096": true,
      "78097": true,
      "78098": true,
      "78099": true,
      "78100": true,
      "78101": true,
      "78102": true,
      "78103": true,
      "78104": true,
      "78105": true,
      "78106": true,
      "78107": true,
      "78108": true,
      "78109": true,
      "78110": true,
      "78111": true,
      "78112": true,
      "78113": true,
      "78114": true,
      "78115": true,
      "78116": true,
      "78117": true,
      "78118": true,
      "78119": true,
      "78120": true,
      "78121": true,
      "78122": true,
      "78123": true,
      "78124": true,
      "78125": true,
      "78126": true,
      "78127": true,
      "78128": true,
      "78129": true,
      "78130": true,
      "78131": true,
      "78132": true,
      "78133": true,
      "78134": true,
      "78135": true,
      "78136": true,
      "78137": true,
      "78138": true,
      "78139": true,
      "78140": true,
      "78141": true,
      "78142": true,
      "78143": true,
      "78144": true,
      "78145": true,
      "78146": true,
      "78147": true,
      "78148": true,
      "78149": true,
      "78150": true,
      "78151": true,
      "78152": true,
      "78153": true,
      "78154": true,
      "78155": true,
      "78156": true,
      "78157": true,
      "78158": true,
      "78159": true,
      "78160": true,
      "78161": true,
      "78162": true,
      "78163": true,
      "78164": true,
      "78165": true,
      "78166": true,
      "78167": true,
      "78168": true,
      "78169": true,
      "78170": true,
      "78171": true,
      "78172": true,
      "78173": true,
      "78174": true,
      "78175": true,
      "78176": true,
      "78177": true,
      "78178": true,
      "78179": true,
      "78180": true,
      "78181": true,
      "78182": true,
      "78183": true,
      "78184": true,
      "78185": true,
      "78186": true,
      "78187": true,
      "78188": true,
      "78189": true,
      "78190": true,
      "78191": true,
      "78192": true,
      "78193": true,
      "78194": true,
      "78195": true,
      "78196": true,
      "78197": true,
      "78198": true,
      "78199": true,
      "78200": true,
      "78201": true,
      "78202": true,
      "78203": true,
      "78204": true,
      "78205": true,
      "78206": true,
      "78207": true,
      "78208": true,
      "78209": true,
      "78210": true,
      "78211": true,
      "78212": true,
      "78213": true,
      "78214": true,
      "78215": true,
      "78216": true,
      "78217": true,
      "78218": true,
      "78219": true,
      "78220": true,
      "78221": true,
      "78222": true,
      "78223": true,
      "78224": true,
      "78225": true,
      "78226": true,
      "78227": true,
      "78228": true,
      "78229": true,
      "78230": true,
      "78231": true,
      "78232": true,
      "78233": true,
      "78234": true,
      "78235": true,
      "78236": true,
      "78237": true,
      "78238": true,
      "78239": true,
      "78240": true,
      "78241": true,
      "78242": true,
      "78243": true,
      "78244": true,
      "78245": true,
      "78246": true,
      "78247": true,
      "78248": true,
      "78249": true,
      "78250": true,
      "78251": true,
      "78252": true,
      "78253": true,
      "78254": true,
      "78255": true,
      "78256": true,
      "78257": true,
      "78258": true,
      "78259": true,
      "78260": true,
      "78261": true,
      "78262": true,
      "78263": true,
      "78264": true,
      "78265": true,
      "78266": true,
      "78267": true,
      "78268": true,
      "78269": true,
      "78270": true,
      "78271": true,
      "78272": true,
      "78273": true,
      "78274": true,
      "78275": true,
      "78276": true,
      "78277": true,
      "78278": true,
      "78279": true,
      "78280": true,
      "78281": true,
      "78282": true,
      "78283": true,
      "78284": true,
      "78285": true,
      "78286": true,
      "78287": true,
      "78288": true,
      "78289": true,
      "78290": true,
      "78291": true,
      "78292": true,
      "78293": true,
      "78294": true,
      "78295": true,
      "78296": true,
      "78297": true,
      "78298": true,
      "78299": true,
      "78300": true,
      "78301": true,
      "78302": true,
      "78303": true,
      "78304": true,
      "78305": true,
      "78306": true,
      "78307": true,
      "78308": true,
      "78309": true,
      "78310": true,
      "78311": true,
      "78312": true,
      "78313": true,
      "78314": true,
      "78315": true,
      "78316": true,
      "78317": true,
      "78318": true,
      "78319": true,
      "78320": true,
      "78321": true,
      "78322": true,
      "78323": true,
      "78324": true,
      "78325": true,
      "78326": true,
      "78327": true,
      "78328": true,
      "78329": true,
      "78330": true,
      "78331": true,
      "78332": true,
      "78333": true,
      "78334": true,
      "78335": true,
      "78336": true,
      "78337": true,
      "78338": true,
      "78339": true,
      "78340": true,
      "78341": true,
      "78342": true,
      "78343": true,
      "78344": true,
      "78345": true,
      "78346": true,
      "78347": true,
      "78348": true,
      "78349": true,
      "78350": true,
      "78351": true,
      "78352": true,
      "78353": true,
      "78354": true,
      "78355": true,
      "78356": true,
      "78357": true,
      "78358": true,
      "78359": true,
      "78360": true,
      "78361": true,
      "78362": true,
      "78363": true,
      "78364": true,
      "78365": true,
      "78366": true,
      "78367": true,
      "78368": true,
      "78369": true,
      "78370": true,
      "78371": true,
      "78372": true,
      "78373": true,
      "78374": true,
      "78375": true,
      "78376": true,
      "78377": true,
      "78378": true,
      "78379": true,
      "78380": true,
      "78381": true,
      "78382": true,
      "78383": true,
      "78384": true,
      "78385": true,
      "78386": true,
      "78387": true,
      "78388": true,
      "78389": true,
      "78390": true,
      "78391": true,
      "78392": true,
      "78393": true,
      "78394": true,
      "78395": true,
      "78396": true,
      "78397": true,
      "78398": true,
      "78399": true,
      "78400": true,
      "78401": true,
      "78402": true,
      "78406": true,
      "78413": true,
      "78414": true,
      "78415": true,
      "78418": true,
      "78419": true,
      "78420": true,
      "78421": true,
      "78422": true,
      "78423": true,
      "78424": true,
      "78425": true,
      "78426": true,
      "78427": true,
      "78428": true,
      "78429": true
    },
    "SAN VICENTE TANCUAYALAB": {
      "79820": true,
      "79821": true,
      "79823": true,
      "79824": true,
      "79825": true
    },
    "SANTA MARIA DEL RIO": {
      "79560": true,
      "79561": true,
      "79562": true,
      "79563": true,
      "79564": true,
      "79565": true,
      "79566": true,
      "79567": true,
      "79568": true,
      "79581": true,
      "79582": true,
      "79583": true
    },
    "SOLEDAD DE GRACIANO SÁNCHEZ": {
      "78430": true,
      "78431": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true,
      "78439": true
    },
    "TAMAZUNCHALE": {
      "79960": true,
      "79961": true,
      "79980": true,
      "79981": true,
      "79982": true,
      "79983": true,
      "79985": true,
      "79986": true,
      "79987": true,
      "79988": true,
      "79989": true,
      "79991": true,
      "79992": true,
      "79993": true,
      "79994": true,
      "79995": true,
      "79996": true,
      "79997": true,
      "79998": true,
      "79999": true
    },
    "TAMUIN": {
      "79200": true,
      "79201": true,
      "79202": true,
      "79203": true,
      "79204": true,
      "79205": true,
      "79206": true,
      "79207": true,
      "79208": true,
      "79209": true,
      "79210": true,
      "79211": true,
      "79212": true,
      "79213": true,
      "79214": true,
      "79217": true,
      "79219": true,
      "79220": true,
      "79221": true,
      "79222": true,
      "79223": true,
      "79224": true,
      "79225": true,
      "79226": true,
      "79227": true,
      "79228": true,
      "79229": true
    },
    "TANQUIAN DE ESCOBEDO": {
      "79840": true,
      "79841": true,
      "79842": true,
      "79843": true,
      "79844": true,
      "79845": true,
      "79846": true,
      "79847": true,
      "79848": true,
      "79849": true
    },
    "TIERRA NUEVA": {
      "79590": true,
      "79591": true,
      "79592": true,
      "79593": true,
      "79594": true,
      "79595": true,
      "79596": true
    },
    "VENADO": {
      "78920": true,
      "78921": true,
      "78922": true,
      "78923": true,
      "78924": true,
      "78925": true,
      "78926": true,
      "78927": true,
      "78928": true,
      "78929": true,
      "78933": true,
      "78934": true,
      "78935": true,
      "78936": true,
      "78937": true,
      "78938": true,
      "78939": true
    },
    "VILLA DE ARISTA": {
      "78940": true,
      "78941": true,
      "78942": true,
      "78943": true,
      "78944": true,
      "78945": true,
      "78946": true,
      "78947": true,
      "78948": true,
      "78949": true,
      "78950": true,
      "78951": true,
      "78952": true,
      "78953": true,
      "78954": true,
      "78955": true,
      "78956": true,
      "78957": true
    },
    "VILLA DE ARRIAGA": {
      "78490": true,
      "78491": true,
      "78492": true,
      "78493": true,
      "78495": true,
      "78496": true,
      "78497": true,
      "78498": true,
      "78499": true
    },
    "VILLA DE REYES": {
      "79500": true,
      "79501": true,
      "79502": true,
      "79503": true,
      "79504": true,
      "79505": true,
      "79506": true,
      "79507": true,
      "79510": true,
      "79513": true,
      "79514": true,
      "79515": true,
      "79516": true,
      "79517": true,
      "79518": true,
      "79519": true,
      "79521": true,
      "79522": true,
      "79523": true,
      "79524": true,
      "79525": true,
      "79526": true,
      "79527": true,
      "79528": true,
      "79529": true,
      "79530": true,
      "79531": true,
      "79532": true,
      "79533": true,
      "79534": true,
      "79535": true,
      "79536": true,
      "79537": true,
      "79538": true,
      "79539": true
    },
    "XILITLA": {
      "79900": true,
      "79901": true,
      "79902": true,
      "79903": true,
      "79904": true,
      "79905": true,
      "79906": true,
      "79907": true,
      "79908": true,
      "79909": true,
      "79910": true,
      "79911": true,
      "79912": true,
      "79913": true,
      "79914": true,
      "79915": true,
      "79916": true,
      "79917": true,
      "79918": true,
      "79919": true,
      "79920": true,
      "79921": true,
      "79922": true,
      "79923": true,
      "79924": true,
      "79925": true,
      "79926": true,
      "79927": true,
      "79928": true,
      "79929": true
    }
  },
  "SINALOA": {
    "AHOME": {
      "81200": true,
      "81201": true,
      "81202": true,
      "81203": true,
      "81204": true,
      "81205": true,
      "81206": true,
      "81207": true,
      "81208": true,
      "81209": true,
      "81210": true,
      "81211": true,
      "81212": true,
      "81213": true,
      "81214": true,
      "81215": true,
      "81216": true,
      "81217": true,
      "81218": true,
      "81219": true,
      "81220": true,
      "81221": true,
      "81222": true,
      "81223": true,
      "81224": true,
      "81225": true,
      "81226": true,
      "81227": true,
      "81228": true,
      "81229": true,
      "81230": true,
      "81231": true,
      "81232": true,
      "81233": true,
      "81234": true,
      "81235": true,
      "81236": true,
      "81237": true,
      "81238": true,
      "81239": true,
      "81240": true,
      "81241": true,
      "81242": true,
      "81243": true,
      "81244": true,
      "81245": true,
      "81246": true,
      "81247": true,
      "81248": true,
      "81249": true,
      "81250": true,
      "81251": true,
      "81252": true,
      "81253": true,
      "81254": true,
      "81255": true,
      "81256": true,
      "81257": true,
      "81258": true,
      "81259": true,
      "81260": true,
      "81261": true,
      "81262": true,
      "81263": true,
      "81264": true,
      "81265": true,
      "81266": true,
      "81267": true,
      "81268": true,
      "81269": true,
      "81270": true,
      "81271": true,
      "81272": true,
      "81273": true,
      "81274": true,
      "81275": true,
      "81276": true,
      "81277": true,
      "81278": true,
      "81279": true,
      "81280": true,
      "81281": true,
      "81282": true,
      "81283": true,
      "81284": true,
      "81285": true,
      "81286": true,
      "81287": true,
      "81288": true,
      "81289": true,
      "81290": true,
      "81291": true,
      "81292": true,
      "81293": true,
      "81294": true,
      "81295": true,
      "81296": true,
      "81297": true,
      "81298": true,
      "81299": true,
      "81303": true,
      "81304": true,
      "81305": true,
      "81307": true,
      "81310": true,
      "81311": true,
      "81315": true,
      "81316": true,
      "81317": true,
      "81318": true,
      "81319": true,
      "81320": true,
      "81321": true,
      "81322": true,
      "81323": true,
      "81324": true,
      "81325": true,
      "81330": true,
      "81331": true,
      "81332": true,
      "81336": true,
      "81340": true,
      "81341": true,
      "81342": true,
      "81343": true,
      "81346": true,
      "81347": true,
      "81348": true,
      "81350": true,
      "81360": true,
      "81361": true,
      "81362": true,
      "81363": true,
      "81364": true,
      "81365": true,
      "81366": true,
      "81367": true,
      "81368": true,
      "81369": true,
      "81370": true,
      "81371": true,
      "81372": true,
      "81373": true,
      "81374": true,
      "81375": true,
      "81376": true,
      "81379": true,
      "81384": true,
      "81385": true,
      "81386": true,
      "81387": true,
      "81388": true,
      "81389": true
    },
    "ANGOSTURA": {
      "81600": true,
      "81601": true,
      "81602": true,
      "81603": true,
      "81604": true,
      "81605": true,
      "81606": true,
      "81607": true,
      "81608": true,
      "81609": true,
      "81610": true,
      "81611": true,
      "81612": true,
      "81613": true,
      "81614": true,
      "81615": true,
      "81616": true,
      "81617": true,
      "81618": true,
      "81619": true,
      "81620": true,
      "81621": true,
      "81622": true,
      "81623": true,
      "81624": true,
      "81625": true,
      "81626": true,
      "81627": true,
      "81628": true,
      "81629": true,
      "81630": true,
      "81631": true,
      "81632": true,
      "81633": true,
      "81634": true,
      "81635": true,
      "81636": true,
      "81637": true,
      "81638": true,
      "81639": true,
      "81640": true,
      "81641": true,
      "81642": true,
      "81643": true,
      "81649": true,
      "81650": true,
      "81651": true,
      "81652": true,
      "81653": true,
      "81654": true,
      "81655": true,
      "81656": true,
      "81657": true,
      "81658": true,
      "81659": true,
      "81660": true,
      "81663": true,
      "81664": true,
      "81665": true,
      "81666": true,
      "81667": true,
      "81668": true,
      "81669": true,
      "81670": true,
      "81671": true,
      "81672": true,
      "81673": true,
      "81674": true,
      "81680": true,
      "81681": true,
      "81682": true,
      "81683": true,
      "81684": true,
      "81685": true,
      "81686": true,
      "81687": true,
      "81688": true,
      "81689": true,
      "81690": true,
      "81691": true,
      "81692": true,
      "81693": true,
      "81694": true,
      "81695": true,
      "81696": true,
      "81697": true,
      "81698": true,
      "81699": true
    },
    "CHOIX": {
      "81700": true,
      "81701": true,
      "81702": true,
      "81703": true,
      "81704": true,
      "81705": true,
      "81706": true,
      "81707": true,
      "81708": true,
      "81709": true,
      "81710": true,
      "81711": true,
      "81713": true,
      "81714": true,
      "81715": true,
      "81716": true,
      "81717": true,
      "81737": true,
      "81738": true,
      "81739": true,
      "81743": true,
      "81744": true,
      "81745": true,
      "81746": true,
      "81747": true,
      "81748": true,
      "81749": true,
      "81756": true,
      "81757": true,
      "81758": true,
      "81759": true,
      "81760": true,
      "81761": true,
      "81762": true,
      "81763": true,
      "81764": true,
      "81765": true,
      "81777": true,
      "81778": true,
      "81779": true,
      "81780": true,
      "81781": true,
      "81782": true,
      "81783": true,
      "81784": true,
      "81785": true,
      "81786": true,
      "81787": true,
      "81788": true,
      "81789": true,
      "81790": true,
      "81791": true,
      "81792": true,
      "81793": true,
      "81794": true,
      "81795": true,
      "81796": true,
      "81797": true,
      "81798": true,
      "81799": true
    },
    "CONCORDIA": {
      "82600": true,
      "82601": true,
      "82602": true,
      "82603": true,
      "82604": true,
      "82605": true,
      "82606": true,
      "82607": true,
      "82608": true,
      "82609": true,
      "82613": true,
      "82614": true,
      "82615": true,
      "82620": true,
      "82621": true,
      "82622": true,
      "82623": true,
      "82624": true,
      "82625": true,
      "82626": true,
      "82627": true,
      "82628": true,
      "82629": true,
      "82640": true,
      "82641": true,
      "82646": true,
      "82648": true,
      "82649": true,
      "82658": true,
      "82659": true,
      "82675": true,
      "82676": true,
      "82680": true,
      "82681": true,
      "82682": true,
      "82683": true,
      "82684": true,
      "82685": true,
      "82686": true,
      "82687": true,
      "82688": true,
      "82689": true,
      "82690": true,
      "82691": true,
      "82692": true,
      "82693": true,
      "82694": true,
      "82695": true,
      "82696": true,
      "82697": true,
      "82698": true,
      "82699": true
    },
    "CULIACÁN": {
      "80000": true,
      "80001": true,
      "80002": true,
      "80003": true,
      "80004": true,
      "80005": true,
      "80006": true,
      "80007": true,
      "80008": true,
      "80009": true,
      "80010": true,
      "80011": true,
      "80012": true,
      "80013": true,
      "80014": true,
      "80015": true,
      "80016": true,
      "80017": true,
      "80018": true,
      "80019": true,
      "80020": true,
      "80021": true,
      "80022": true,
      "80023": true,
      "80024": true,
      "80025": true,
      "80026": true,
      "80027": true,
      "80028": true,
      "80029": true,
      "80030": true,
      "80031": true,
      "80032": true,
      "80033": true,
      "80034": true,
      "80035": true,
      "80036": true,
      "80037": true,
      "80038": true,
      "80039": true,
      "80040": true,
      "80041": true,
      "80042": true,
      "80043": true,
      "80044": true,
      "80045": true,
      "80046": true,
      "80047": true,
      "80048": true,
      "80049": true,
      "80050": true,
      "80051": true,
      "80052": true,
      "80053": true,
      "80054": true,
      "80055": true,
      "80056": true,
      "80057": true,
      "80058": true,
      "80059": true,
      "80060": true,
      "80061": true,
      "80062": true,
      "80063": true,
      "80064": true,
      "80065": true,
      "80066": true,
      "80067": true,
      "80068": true,
      "80069": true,
      "80070": true,
      "80071": true,
      "80072": true,
      "80073": true,
      "80074": true,
      "80075": true,
      "80076": true,
      "80077": true,
      "80078": true,
      "80079": true,
      "80080": true,
      "80081": true,
      "80082": true,
      "80083": true,
      "80084": true,
      "80085": true,
      "80086": true,
      "80087": true,
      "80088": true,
      "80089": true,
      "80090": true,
      "80091": true,
      "80092": true,
      "80093": true,
      "80094": true,
      "80095": true,
      "80096": true,
      "80097": true,
      "80098": true,
      "80099": true,
      "80100": true,
      "80101": true,
      "80102": true,
      "80103": true,
      "80104": true,
      "80105": true,
      "80106": true,
      "80107": true,
      "80108": true,
      "80109": true,
      "80110": true,
      "80111": true,
      "80112": true,
      "80113": true,
      "80114": true,
      "80115": true,
      "80116": true,
      "80117": true,
      "80118": true,
      "80119": true,
      "80120": true,
      "80121": true,
      "80122": true,
      "80123": true,
      "80124": true,
      "80125": true,
      "80126": true,
      "80127": true,
      "80128": true,
      "80129": true,
      "80130": true,
      "80131": true,
      "80132": true,
      "80133": true,
      "80134": true,
      "80135": true,
      "80136": true,
      "80137": true,
      "80138": true,
      "80139": true,
      "80140": true,
      "80141": true,
      "80142": true,
      "80143": true,
      "80144": true,
      "80145": true,
      "80146": true,
      "80147": true,
      "80148": true,
      "80149": true,
      "80150": true,
      "80151": true,
      "80152": true,
      "80153": true,
      "80154": true,
      "80155": true,
      "80156": true,
      "80157": true,
      "80158": true,
      "80159": true,
      "80160": true,
      "80161": true,
      "80162": true,
      "80163": true,
      "80164": true,
      "80165": true,
      "80166": true,
      "80167": true,
      "80168": true,
      "80169": true,
      "80170": true,
      "80171": true,
      "80172": true,
      "80173": true,
      "80174": true,
      "80175": true,
      "80176": true,
      "80177": true,
      "80178": true,
      "80179": true,
      "80180": true,
      "80181": true,
      "80182": true,
      "80183": true,
      "80184": true,
      "80185": true,
      "80186": true,
      "80187": true,
      "80188": true,
      "80189": true,
      "80190": true,
      "80191": true,
      "80192": true,
      "80193": true,
      "80194": true,
      "80195": true,
      "80196": true,
      "80197": true,
      "80198": true,
      "80199": true,
      "80200": true,
      "80201": true,
      "80202": true,
      "80203": true,
      "80204": true,
      "80205": true,
      "80206": true,
      "80207": true,
      "80208": true,
      "80209": true,
      "80210": true,
      "80211": true,
      "80212": true,
      "80213": true,
      "80214": true,
      "80215": true,
      "80216": true,
      "80217": true,
      "80218": true,
      "80219": true,
      "80220": true,
      "80221": true,
      "80222": true,
      "80223": true,
      "80224": true,
      "80225": true,
      "80226": true,
      "80227": true,
      "80228": true,
      "80229": true,
      "80230": true,
      "80231": true,
      "80232": true,
      "80233": true,
      "80234": true,
      "80235": true,
      "80236": true,
      "80237": true,
      "80238": true,
      "80239": true,
      "80240": true,
      "80241": true,
      "80242": true,
      "80243": true,
      "80244": true,
      "80245": true,
      "80246": true,
      "80247": true,
      "80248": true,
      "80249": true,
      "80250": true,
      "80251": true,
      "80252": true,
      "80253": true,
      "80254": true,
      "80255": true,
      "80256": true,
      "80257": true,
      "80258": true,
      "80259": true,
      "80260": true,
      "80261": true,
      "80262": true,
      "80263": true,
      "80264": true,
      "80265": true,
      "80266": true,
      "80267": true,
      "80268": true,
      "80269": true,
      "80270": true,
      "80271": true,
      "80272": true,
      "80273": true,
      "80274": true,
      "80275": true,
      "80276": true,
      "80277": true,
      "80278": true,
      "80279": true,
      "80280": true,
      "80281": true,
      "80282": true,
      "80283": true,
      "80284": true,
      "80285": true,
      "80286": true,
      "80287": true,
      "80288": true,
      "80289": true,
      "80290": true,
      "80291": true,
      "80292": true,
      "80293": true,
      "80294": true,
      "80295": true,
      "80296": true,
      "80297": true,
      "80298": true,
      "80299": true,
      "80300": true,
      "80301": true,
      "80302": true,
      "80303": true,
      "80304": true,
      "80305": true,
      "80306": true,
      "80307": true,
      "80308": true,
      "80309": true,
      "80310": true,
      "80311": true,
      "80312": true,
      "80313": true,
      "80314": true,
      "80315": true,
      "80316": true,
      "80317": true,
      "80318": true,
      "80319": true,
      "80380": true,
      "80381": true,
      "80382": true,
      "80383": true,
      "80384": true,
      "80385": true,
      "80386": true,
      "80387": true,
      "80388": true,
      "80389": true,
      "80390": true,
      "80391": true,
      "80392": true,
      "80393": true,
      "80394": true,
      "80395": true,
      "80396": true,
      "80397": true,
      "80398": true,
      "80399": true,
      "80400": true,
      "80401": true,
      "80402": true,
      "80403": true,
      "80404": true,
      "80405": true,
      "80406": true,
      "80407": true,
      "80408": true,
      "80409": true,
      "80410": true,
      "80411": true,
      "80412": true,
      "80413": true,
      "80414": true,
      "80415": true,
      "80416": true,
      "80417": true,
      "80418": true,
      "80419": true,
      "80420": true,
      "80421": true,
      "80422": true,
      "80423": true,
      "80424": true,
      "80425": true,
      "80426": true,
      "80427": true,
      "80428": true,
      "80429": true,
      "80430": true,
      "80431": true,
      "80432": true,
      "80433": true,
      "80434": true,
      "80435": true,
      "80436": true,
      "80437": true,
      "80438": true,
      "80439": true,
      "80440": true,
      "80441": true,
      "80442": true,
      "80443": true,
      "80444": true,
      "80445": true,
      "80446": true,
      "80447": true,
      "80448": true,
      "80449": true,
      "80450": true,
      "80451": true,
      "80452": true,
      "80453": true,
      "80454": true,
      "80455": true,
      "80456": true,
      "80457": true,
      "80458": true,
      "80459": true,
      "80460": true,
      "80461": true,
      "80462": true,
      "80463": true,
      "80464": true,
      "80465": true,
      "80466": true,
      "80467": true,
      "80468": true,
      "80469": true,
      "80470": true,
      "80471": true,
      "80472": true,
      "80473": true,
      "80474": true,
      "80475": true,
      "80476": true,
      "80477": true,
      "80478": true,
      "80479": true,
      "80480": true,
      "80481": true,
      "80482": true,
      "80483": true,
      "80484": true,
      "80485": true,
      "80486": true,
      "80487": true,
      "80488": true,
      "80489": true,
      "80490": true,
      "80491": true,
      "80492": true,
      "80493": true,
      "80494": true,
      "80495": true,
      "80496": true,
      "80497": true,
      "80498": true,
      "80499": true
    },
    "EL FUERTE": {
      "81800": true,
      "81801": true,
      "81802": true,
      "81803": true,
      "81804": true,
      "81805": true,
      "81810": true,
      "81812": true,
      "81813": true,
      "81814": true,
      "81820": true,
      "81821": true,
      "81822": true,
      "81823": true,
      "81824": true,
      "81825": true,
      "81826": true,
      "81827": true,
      "81828": true,
      "81829": true,
      "81830": true,
      "81831": true,
      "81832": true,
      "81833": true,
      "81834": true,
      "81835": true,
      "81836": true,
      "81837": true,
      "81838": true,
      "81839": true,
      "81847": true,
      "81848": true,
      "81849": true,
      "81850": true,
      "81851": true,
      "81852": true,
      "81853": true,
      "81854": true,
      "81856": true,
      "81857": true,
      "81858": true,
      "81859": true,
      "81860": true,
      "81861": true,
      "81862": true,
      "81863": true,
      "81864": true,
      "81865": true,
      "81866": true,
      "81867": true,
      "81868": true,
      "81869": true,
      "81871": true,
      "81872": true,
      "81873": true,
      "81880": true,
      "81881": true,
      "81882": true,
      "81883": true,
      "81884": true,
      "81885": true,
      "81886": true,
      "81887": true,
      "81890": true,
      "81891": true,
      "81892": true,
      "81893": true,
      "81894": true
    },
    "GUASAVE": {
      "81000": true,
      "81001": true,
      "81002": true,
      "81003": true,
      "81004": true,
      "81005": true,
      "81006": true,
      "81007": true,
      "81008": true,
      "81009": true,
      "81010": true,
      "81011": true,
      "81012": true,
      "81013": true,
      "81014": true,
      "81015": true,
      "81016": true,
      "81017": true,
      "81018": true,
      "81019": true,
      "81020": true,
      "81021": true,
      "81022": true,
      "81023": true,
      "81024": true,
      "81025": true,
      "81026": true,
      "81027": true,
      "81028": true,
      "81029": true,
      "81030": true,
      "81031": true,
      "81032": true,
      "81033": true,
      "81034": true,
      "81035": true,
      "81036": true,
      "81037": true,
      "81038": true,
      "81039": true,
      "81040": true,
      "81041": true,
      "81042": true,
      "81043": true,
      "81044": true,
      "81045": true,
      "81046": true,
      "81047": true,
      "81048": true,
      "81049": true,
      "81050": true,
      "81051": true,
      "81052": true,
      "81053": true,
      "81054": true,
      "81055": true,
      "81056": true,
      "81057": true,
      "81058": true,
      "81059": true,
      "81060": true,
      "81061": true,
      "81062": true,
      "81063": true,
      "81064": true,
      "81065": true,
      "81066": true,
      "81067": true,
      "81068": true,
      "81069": true,
      "81070": true,
      "81071": true,
      "81072": true,
      "81073": true,
      "81074": true,
      "81075": true,
      "81076": true,
      "81077": true,
      "81078": true,
      "81079": true,
      "81080": true,
      "81081": true,
      "81082": true,
      "81083": true,
      "81084": true,
      "81085": true,
      "81086": true,
      "81087": true,
      "81088": true,
      "81089": true,
      "81090": true,
      "81091": true,
      "81092": true,
      "81093": true,
      "81094": true,
      "81095": true,
      "81096": true,
      "81097": true,
      "81098": true,
      "81099": true,
      "81100": true,
      "81101": true,
      "81102": true,
      "81103": true,
      "81104": true,
      "81105": true,
      "81106": true,
      "81107": true,
      "81108": true,
      "81109": true,
      "81110": true,
      "81111": true,
      "81112": true,
      "81118": true,
      "81120": true,
      "81121": true,
      "81122": true,
      "81124": true,
      "81125": true,
      "81126": true,
      "81127": true,
      "81128": true,
      "81129": true,
      "81130": true,
      "81131": true,
      "81132": true,
      "81133": true,
      "81134": true,
      "81135": true,
      "81136": true,
      "81137": true,
      "81138": true,
      "81139": true,
      "81140": true,
      "81141": true,
      "81142": true,
      "81143": true,
      "81144": true,
      "81145": true,
      "81146": true,
      "81147": true,
      "81148": true,
      "81149": true,
      "81150": true,
      "81151": true,
      "81152": true,
      "81153": true,
      "81154": true,
      "81155": true,
      "81156": true,
      "81157": true,
      "81158": true,
      "81159": true,
      "81160": true,
      "81161": true,
      "81162": true,
      "81163": true,
      "81164": true,
      "81165": true,
      "81166": true,
      "81167": true,
      "81168": true,
      "81169": true,
      "81170": true,
      "81171": true,
      "81172": true,
      "81173": true,
      "81174": true,
      "81175": true,
      "81176": true,
      "81177": true,
      "81178": true,
      "81179": true,
      "81180": true,
      "81181": true,
      "81182": true,
      "81183": true,
      "81184": true,
      "81185": true,
      "81186": true,
      "81187": true,
      "81188": true,
      "81189": true,
      "81190": true,
      "81191": true,
      "81192": true,
      "81193": true,
      "81194": true,
      "81195": true,
      "81196": true,
      "81197": true,
      "81198": true,
      "81199": true
    },
    "MAZATLÁN": {
      "82000": true,
      "82001": true,
      "82002": true,
      "82003": true,
      "82004": true,
      "82005": true,
      "82006": true,
      "82007": true,
      "82008": true,
      "82009": true,
      "82010": true,
      "82011": true,
      "82012": true,
      "82013": true,
      "82014": true,
      "82015": true,
      "82016": true,
      "82017": true,
      "82018": true,
      "82019": true,
      "82020": true,
      "82021": true,
      "82022": true,
      "82023": true,
      "82024": true,
      "82025": true,
      "82026": true,
      "82027": true,
      "82028": true,
      "82029": true,
      "82030": true,
      "82031": true,
      "82032": true,
      "82033": true,
      "82034": true,
      "82035": true,
      "82036": true,
      "82037": true,
      "82038": true,
      "82039": true,
      "82040": true,
      "82041": true,
      "82042": true,
      "82047": true,
      "82048": true,
      "82049": true,
      "82050": true,
      "82051": true,
      "82052": true,
      "82053": true,
      "82054": true,
      "82055": true,
      "82056": true,
      "82057": true,
      "82058": true,
      "82059": true,
      "82060": true,
      "82061": true,
      "82062": true,
      "82063": true,
      "82064": true,
      "82065": true,
      "82066": true,
      "82067": true,
      "82068": true,
      "82069": true,
      "82070": true,
      "82071": true,
      "82072": true,
      "82073": true,
      "82074": true,
      "82075": true,
      "82076": true,
      "82077": true,
      "82078": true,
      "82079": true,
      "82080": true,
      "82081": true,
      "82082": true,
      "82083": true,
      "82084": true,
      "82085": true,
      "82086": true,
      "82087": true,
      "82088": true,
      "82089": true,
      "82090": true,
      "82091": true,
      "82092": true,
      "82093": true,
      "82094": true,
      "82095": true,
      "82096": true,
      "82097": true,
      "82098": true,
      "82099": true,
      "82100": true,
      "82101": true,
      "82102": true,
      "82103": true,
      "82104": true,
      "82105": true,
      "82106": true,
      "82107": true,
      "82108": true,
      "82109": true,
      "82110": true,
      "82111": true,
      "82112": true,
      "82113": true,
      "82114": true,
      "82115": true,
      "82116": true,
      "82117": true,
      "82118": true,
      "82119": true,
      "82120": true,
      "82121": true,
      "82122": true,
      "82123": true,
      "82124": true,
      "82125": true,
      "82126": true,
      "82127": true,
      "82128": true,
      "82129": true,
      "82130": true,
      "82131": true,
      "82132": true,
      "82133": true,
      "82134": true,
      "82135": true,
      "82136": true,
      "82137": true,
      "82138": true,
      "82139": true,
      "82140": true,
      "82141": true,
      "82142": true,
      "82143": true,
      "82144": true,
      "82145": true,
      "82146": true,
      "82147": true,
      "82148": true,
      "82149": true,
      "82150": true,
      "82151": true,
      "82152": true,
      "82153": true,
      "82154": true,
      "82155": true,
      "82156": true,
      "82157": true,
      "82158": true,
      "82159": true,
      "82160": true,
      "82161": true,
      "82162": true,
      "82163": true,
      "82164": true,
      "82165": true,
      "82166": true,
      "82167": true,
      "82168": true,
      "82169": true,
      "82170": true,
      "82171": true,
      "82172": true,
      "82173": true,
      "82174": true,
      "82175": true,
      "82176": true,
      "82177": true,
      "82178": true,
      "82179": true,
      "82180": true,
      "82181": true,
      "82182": true,
      "82183": true,
      "82184": true,
      "82185": true,
      "82186": true,
      "82187": true,
      "82188": true,
      "82189": true,
      "82190": true,
      "82191": true,
      "82192": true,
      "82193": true,
      "82194": true,
      "82195": true,
      "82196": true,
      "82197": true,
      "82198": true,
      "82199": true,
      "82200": true,
      "82201": true,
      "82202": true,
      "82203": true,
      "82204": true,
      "82206": true,
      "82207": true,
      "82208": true,
      "82209": true,
      "82210": true,
      "82211": true,
      "82212": true,
      "82213": true,
      "82214": true,
      "82215": true,
      "82216": true,
      "82217": true,
      "82218": true,
      "82219": true,
      "82220": true,
      "82221": true,
      "82222": true,
      "82223": true,
      "82224": true,
      "82225": true,
      "82226": true,
      "82227": true,
      "82228": true,
      "82229": true,
      "82230": true,
      "82231": true,
      "82232": true,
      "82235": true,
      "82238": true,
      "82239": true,
      "82243": true,
      "82244": true,
      "82245": true,
      "82248": true,
      "82264": true,
      "82265": true,
      "82267": true,
      "82268": true,
      "82269": true,
      "82270": true,
      "82271": true,
      "82272": true,
      "82273": true,
      "82274": true,
      "82275": true,
      "82276": true,
      "82277": true,
      "82278": true,
      "82279": true,
      "82280": true,
      "82281": true,
      "82282": true,
      "82283": true,
      "82284": true,
      "82285": true,
      "82286": true,
      "82287": true,
      "82288": true,
      "82289": true,
      "82290": true,
      "82291": true,
      "82292": true,
      "82293": true,
      "82294": true,
      "82295": true,
      "82296": true,
      "82297": true,
      "82298": true,
      "82299": true,
      "82303": true,
      "82305": true,
      "82310": true,
      "82311": true,
      "82312": true,
      "82334": true,
      "82335": true,
      "82336": true,
      "82337": true,
      "82338": true,
      "82339": true,
      "82340": true,
      "82341": true,
      "82342": true,
      "82343": true,
      "82344": true,
      "82345": true,
      "82346": true,
      "82347": true,
      "82348": true,
      "82349": true,
      "82355": true,
      "82356": true,
      "82357": true,
      "82358": true,
      "82359": true,
      "82360": true,
      "82361": true,
      "82362": true,
      "82366": true,
      "82367": true,
      "82368": true,
      "82369": true
    },
    "MOCORITO": {
      "80800": true,
      "80801": true,
      "80802": true,
      "80803": true,
      "80804": true,
      "80805": true,
      "80806": true,
      "80807": true,
      "80808": true,
      "80809": true,
      "80810": true,
      "80811": true,
      "80812": true,
      "80813": true,
      "80814": true,
      "80815": true,
      "80816": true,
      "80817": true,
      "80818": true,
      "80819": true,
      "80820": true,
      "80821": true,
      "80822": true,
      "80823": true,
      "80824": true,
      "80825": true,
      "80826": true,
      "80827": true,
      "80828": true,
      "80829": true,
      "80830": true,
      "80831": true,
      "80832": true,
      "80833": true,
      "80834": true,
      "80835": true,
      "80850": true,
      "80851": true,
      "80852": true,
      "80855": true,
      "80870": true,
      "80871": true,
      "80872": true,
      "80875": true,
      "80880": true,
      "80881": true,
      "80882": true,
      "80883": true,
      "80885": true,
      "80890": true,
      "80891": true,
      "80892": true,
      "80893": true,
      "80894": true,
      "80895": true,
      "80896": true,
      "80897": true,
      "80898": true,
      "80899": true,
      "80900": true,
      "80901": true,
      "80902": true,
      "80903": true,
      "80904": true,
      "80905": true,
      "80906": true,
      "80907": true,
      "80908": true,
      "80909": true,
      "80910": true,
      "80911": true,
      "80912": true,
      "80913": true,
      "80914": true,
      "80915": true,
      "80916": true,
      "80917": true,
      "80918": true,
      "80919": true,
      "80950": true,
      "80951": true,
      "80952": true,
      "80956": true
    },
    "NAVOLATO": {
      "80320": true,
      "80321": true,
      "80322": true,
      "80323": true,
      "80324": true,
      "80325": true,
      "80326": true,
      "80327": true,
      "80328": true,
      "80329": true,
      "80333": true,
      "80334": true,
      "80335": true,
      "80336": true,
      "80337": true,
      "80338": true,
      "80339": true,
      "80340": true,
      "80341": true,
      "80342": true,
      "80343": true,
      "80344": true,
      "80345": true,
      "80346": true,
      "80347": true,
      "80348": true,
      "80349": true,
      "80350": true,
      "80351": true,
      "80352": true,
      "80353": true,
      "80354": true,
      "80355": true,
      "80356": true,
      "80357": true,
      "80358": true,
      "80359": true,
      "80367": true,
      "80370": true,
      "80371": true,
      "80372": true,
      "80373": true,
      "80374": true,
      "80375": true,
      "80376": true,
      "80377": true,
      "80378": true,
      "80379": true
    },
    "SALVADOR ALVARADO": {
      "81400": true,
      "81401": true,
      "81402": true,
      "81403": true,
      "81404": true,
      "81405": true,
      "81406": true,
      "81407": true,
      "81408": true,
      "81409": true,
      "81410": true,
      "81411": true,
      "81412": true,
      "81413": true,
      "81414": true,
      "81415": true,
      "81416": true,
      "81417": true,
      "81418": true,
      "81419": true,
      "81420": true,
      "81421": true,
      "81422": true,
      "81423": true,
      "81424": true,
      "81425": true,
      "81426": true,
      "81427": true,
      "81428": true,
      "81429": true,
      "81430": true,
      "81431": true,
      "81432": true,
      "81433": true,
      "81434": true,
      "81435": true,
      "81436": true,
      "81437": true,
      "81438": true,
      "81439": true,
      "81440": true,
      "81441": true,
      "81442": true,
      "81443": true,
      "81444": true,
      "81445": true,
      "81446": true,
      "81447": true,
      "81448": true,
      "81449": true,
      "81450": true,
      "81451": true,
      "81452": true,
      "81453": true,
      "81454": true,
      "81455": true,
      "81456": true,
      "81457": true,
      "81458": true,
      "81459": true,
      "81460": true,
      "81461": true,
      "81462": true,
      "81463": true,
      "81464": true,
      "81465": true,
      "81466": true,
      "81467": true,
      "81468": true,
      "81469": true,
      "81470": true,
      "81471": true,
      "81472": true,
      "81473": true,
      "81474": true,
      "81475": true,
      "81476": true,
      "81477": true,
      "81478": true,
      "81479": true,
      "81480": true,
      "81481": true,
      "81482": true,
      "81483": true,
      "81484": true,
      "81485": true,
      "81486": true,
      "81487": true,
      "81488": true,
      "81489": true,
      "81490": true,
      "81491": true,
      "81492": true,
      "81493": true,
      "81494": true,
      "81495": true,
      "81496": true,
      "81497": true,
      "81498": true,
      "81499": true,
      "81500": true,
      "81501": true,
      "81502": true,
      "81503": true,
      "81520": true,
      "81521": true,
      "81522": true,
      "81530": true,
      "81531": true,
      "81532": true,
      "81533": true,
      "81534": true,
      "81535": true,
      "81536": true,
      "81537": true,
      "81538": true,
      "81539": true,
      "81540": true,
      "81541": true,
      "81542": true,
      "81545": true,
      "81546": true,
      "81547": true,
      "81548": true,
      "81549": true,
      "81550": true,
      "81551": true,
      "81552": true,
      "81553": true,
      "81554": true,
      "81555": true,
      "81556": true,
      "81557": true,
      "81558": true,
      "81559": true,
      "81560": true,
      "81561": true,
      "81562": true,
      "81563": true,
      "81564": true,
      "81565": true,
      "81566": true,
      "81567": true,
      "81568": true,
      "81569": true,
      "81570": true,
      "81571": true,
      "81572": true,
      "81573": true,
      "81574": true,
      "81575": true,
      "81576": true,
      "81577": true,
      "81578": true,
      "81579": true,
      "81580": true,
      "81581": true,
      "81582": true,
      "81583": true,
      "81584": true,
      "81585": true,
      "81586": true,
      "81587": true,
      "81588": true,
      "81589": true,
      "81590": true,
      "81591": true,
      "81592": true,
      "81593": true,
      "81594": true,
      "81595": true,
      "81596": true,
      "81597": true,
      "81598": true,
      "81599": true
    }
  },
  "SONORA": {
    "BACUM": {
      "85260": true,
      "85261": true,
      "85262": true,
      "85263": true,
      "85264": true,
      "85265": true,
      "85266": true,
      "85267": true,
      "85268": true,
      "85269": true,
      "85270": true,
      "85271": true,
      "85272": true,
      "85273": true,
      "85274": true,
      "85275": true,
      "85276": true
    },
    "CABORCA": {
      "83600": true,
      "83601": true,
      "83602": true,
      "83603": true,
      "83604": true,
      "83605": true,
      "83606": true,
      "83607": true,
      "83608": true,
      "83609": true,
      "83610": true,
      "83611": true,
      "83612": true,
      "83613": true,
      "83614": true,
      "83615": true,
      "83616": true,
      "83617": true,
      "83618": true,
      "83619": true,
      "83620": true,
      "83621": true,
      "83622": true,
      "83623": true,
      "83624": true,
      "83625": true,
      "83626": true,
      "83627": true,
      "83628": true,
      "83629": true,
      "83630": true,
      "83631": true,
      "83632": true,
      "83633": true,
      "83634": true,
      "83635": true,
      "83636": true,
      "83637": true,
      "83638": true,
      "83639": true,
      "83640": true,
      "83641": true,
      "83642": true,
      "83643": true,
      "83644": true,
      "83645": true,
      "83646": true,
      "83647": true,
      "83648": true,
      "83649": true,
      "83650": true,
      "83651": true,
      "83652": true,
      "83653": true,
      "83654": true,
      "83655": true,
      "83656": true,
      "83657": true,
      "83658": true,
      "83659": true,
      "83660": true,
      "83661": true,
      "83662": true,
      "83663": true,
      "83664": true,
      "83665": true,
      "83666": true,
      "83667": true,
      "83668": true,
      "83669": true,
      "83670": true,
      "83671": true,
      "83672": true,
      "83673": true,
      "83674": true,
      "83675": true,
      "83676": true,
      "83677": true,
      "83678": true,
      "83679": true,
      "83680": true,
      "83681": true,
      "83682": true,
      "83683": true,
      "83684": true,
      "83685": true,
      "83686": true,
      "83687": true,
      "83688": true,
      "83689": true,
      "83690": true,
      "83691": true,
      "83692": true,
      "83693": true,
      "83694": true,
      "83695": true,
      "83696": true,
      "83697": true,
      "83698": true,
      "83699": true,
      "83700": true,
      "83701": true,
      "83702": true,
      "83703": true,
      "83704": true,
      "83705": true,
      "83723": true,
      "83727": true,
      "83728": true,
      "83729": true
    },
    "CAJEME": {
      "85000": true,
      "85001": true,
      "85002": true,
      "85003": true,
      "85004": true,
      "85005": true,
      "85006": true,
      "85007": true,
      "85008": true,
      "85009": true,
      "85010": true,
      "85011": true,
      "85012": true,
      "85013": true,
      "85014": true,
      "85015": true,
      "85016": true,
      "85017": true,
      "85018": true,
      "85019": true,
      "85020": true,
      "85021": true,
      "85022": true,
      "85023": true,
      "85024": true,
      "85025": true,
      "85026": true,
      "85027": true,
      "85028": true,
      "85029": true,
      "85030": true,
      "85031": true,
      "85032": true,
      "85033": true,
      "85034": true,
      "85035": true,
      "85036": true,
      "85037": true,
      "85038": true,
      "85039": true,
      "85040": true,
      "85041": true,
      "85042": true,
      "85043": true,
      "85044": true,
      "85045": true,
      "85046": true,
      "85047": true,
      "85048": true,
      "85049": true,
      "85050": true,
      "85051": true,
      "85052": true,
      "85053": true,
      "85054": true,
      "85055": true,
      "85056": true,
      "85057": true,
      "85058": true,
      "85059": true,
      "85060": true,
      "85061": true,
      "85062": true,
      "85063": true,
      "85064": true,
      "85065": true,
      "85066": true,
      "85067": true,
      "85068": true,
      "85069": true,
      "85070": true,
      "85071": true,
      "85072": true,
      "85073": true,
      "85074": true,
      "85075": true,
      "85076": true,
      "85077": true,
      "85078": true,
      "85079": true,
      "85080": true,
      "85081": true,
      "85082": true,
      "85083": true,
      "85084": true,
      "85085": true,
      "85086": true,
      "85087": true,
      "85088": true,
      "85089": true,
      "85090": true,
      "85091": true,
      "85092": true,
      "85093": true,
      "85094": true,
      "85095": true,
      "85096": true,
      "85097": true,
      "85098": true,
      "85099": true,
      "85100": true,
      "85101": true,
      "85102": true,
      "85103": true,
      "85104": true,
      "85105": true,
      "85106": true,
      "85107": true,
      "85108": true,
      "85109": true,
      "85110": true,
      "85111": true,
      "85112": true,
      "85113": true,
      "85114": true,
      "85115": true,
      "85116": true,
      "85117": true,
      "85118": true,
      "85119": true,
      "85120": true,
      "85121": true,
      "85122": true,
      "85123": true,
      "85124": true,
      "85125": true,
      "85126": true,
      "85127": true,
      "85128": true,
      "85129": true,
      "85130": true,
      "85131": true,
      "85132": true,
      "85133": true,
      "85134": true,
      "85135": true,
      "85136": true,
      "85137": true,
      "85138": true,
      "85139": true,
      "85140": true,
      "85141": true,
      "85142": true,
      "85143": true,
      "85144": true,
      "85145": true,
      "85146": true,
      "85147": true,
      "85148": true,
      "85149": true,
      "85150": true,
      "85151": true,
      "85152": true,
      "85153": true,
      "85154": true,
      "85155": true,
      "85156": true,
      "85157": true,
      "85158": true,
      "85159": true,
      "85160": true,
      "85161": true,
      "85162": true,
      "85163": true,
      "85164": true,
      "85165": true,
      "85166": true,
      "85167": true,
      "85168": true,
      "85169": true,
      "85170": true,
      "85171": true,
      "85172": true,
      "85173": true,
      "85174": true,
      "85175": true,
      "85176": true,
      "85177": true,
      "85178": true,
      "85179": true,
      "85180": true,
      "85181": true,
      "85182": true,
      "85183": true,
      "85184": true,
      "85185": true,
      "85186": true,
      "85187": true,
      "85188": true,
      "85189": true,
      "85190": true,
      "85191": true,
      "85192": true,
      "85193": true,
      "85194": true,
      "85195": true,
      "85196": true,
      "85197": true,
      "85198": true,
      "85199": true,
      "85200": true,
      "85201": true,
      "85202": true,
      "85203": true,
      "85204": true,
      "85210": true,
      "85211": true,
      "85215": true,
      "85216": true,
      "85218": true,
      "85219": true
    },
    "CANANEA": {
      "84620": true,
      "84621": true,
      "84622": true,
      "84623": true,
      "84624": true,
      "84625": true,
      "84626": true,
      "84627": true,
      "84628": true,
      "84629": true,
      "84630": true,
      "84631": true,
      "84632": true,
      "84633": true,
      "84635": true,
      "84636": true
    },
    "EMPALME": {
      "85300": true,
      "85301": true,
      "85302": true,
      "85303": true,
      "85304": true,
      "85305": true,
      "85306": true,
      "85307": true,
      "85308": true,
      "85309": true,
      "85310": true,
      "85311": true,
      "85312": true,
      "85313": true,
      "85314": true,
      "85315": true,
      "85316": true,
      "85317": true,
      "85318": true,
      "85319": true,
      "85320": true,
      "85321": true,
      "85322": true,
      "85323": true,
      "85324": true,
      "85325": true,
      "85326": true,
      "85327": true,
      "85328": true,
      "85329": true,
      "85330": true,
      "85331": true,
      "85332": true,
      "85333": true,
      "85334": true,
      "85335": true,
      "85336": true,
      "85337": true,
      "85338": true,
      "85339": true,
      "85340": true,
      "85341": true,
      "85342": true,
      "85343": true,
      "85344": true,
      "85345": true,
      "85346": true,
      "85347": true,
      "85348": true,
      "85349": true,
      "85350": true,
      "85351": true,
      "85352": true,
      "85353": true,
      "85354": true,
      "85355": true,
      "85356": true,
      "85357": true,
      "85358": true,
      "85359": true,
      "85360": true,
      "85361": true,
      "85362": true,
      "85363": true,
      "85364": true,
      "85365": true,
      "85366": true,
      "85367": true,
      "85368": true,
      "85369": true,
      "85370": true,
      "85371": true,
      "85372": true,
      "85373": true,
      "85374": true,
      "85375": true,
      "85376": true,
      "85377": true,
      "85378": true,
      "85379": true,
      "85380": true,
      "85381": true,
      "85382": true,
      "85383": true,
      "85384": true,
      "85385": true,
      "85386": true,
      "85387": true,
      "85388": true,
      "85389": true,
      "85390": true,
      "85391": true,
      "85392": true,
      "85393": true,
      "85394": true,
      "85395": true,
      "85396": true,
      "85397": true,
      "85398": true,
      "85399": true,
      "85520": true,
      "85521": true,
      "85522": true,
      "85523": true,
      "85524": true,
      "85526": true,
      "85527": true,
      "85528": true,
      "85529": true,
      "85530": true,
      "85531": true,
      "85532": true,
      "85533": true,
      "85534": true,
      "85535": true,
      "85536": true
    },
    "ETCHOJOA": {
      "85280": true,
      "85281": true,
      "85282": true,
      "85285": true,
      "85286": true,
      "85287": true
    },
    "GUAYMAS": {
      "85400": true,
      "85401": true,
      "85402": true,
      "85403": true,
      "85404": true,
      "85405": true,
      "85406": true,
      "85407": true,
      "85408": true,
      "85409": true,
      "85410": true,
      "85411": true,
      "85412": true,
      "85413": true,
      "85414": true,
      "85415": true,
      "85416": true,
      "85417": true,
      "85418": true,
      "85419": true,
      "85420": true,
      "85421": true,
      "85422": true,
      "85423": true,
      "85424": true,
      "85425": true,
      "85426": true,
      "85427": true,
      "85428": true,
      "85429": true,
      "85430": true,
      "85431": true,
      "85432": true,
      "85433": true,
      "85434": true,
      "85435": true,
      "85436": true,
      "85437": true,
      "85438": true,
      "85439": true,
      "85440": true,
      "85441": true,
      "85442": true,
      "85443": true,
      "85444": true,
      "85445": true,
      "85446": true,
      "85447": true,
      "85448": true,
      "85449": true,
      "85450": true,
      "85451": true,
      "85452": true,
      "85453": true,
      "85454": true,
      "85455": true,
      "85456": true,
      "85457": true,
      "85458": true,
      "85459": true,
      "85460": true,
      "85461": true,
      "85462": true,
      "85463": true,
      "85464": true,
      "85465": true,
      "85466": true,
      "85467": true,
      "85468": true,
      "85469": true,
      "85470": true,
      "85471": true,
      "85472": true,
      "85473": true,
      "85474": true,
      "85475": true,
      "85476": true,
      "85477": true,
      "85478": true,
      "85479": true,
      "85480": true,
      "85481": true,
      "85482": true,
      "85483": true,
      "85484": true,
      "85485": true,
      "85486": true,
      "85487": true,
      "85488": true,
      "85489": true,
      "85490": true,
      "85491": true,
      "85492": true,
      "85493": true,
      "85494": true,
      "85495": true,
      "85496": true,
      "85497": true,
      "85498": true,
      "85499": true,
      "85500": true,
      "85501": true,
      "85502": true,
      "85503": true,
      "85504": true,
      "85505": true,
      "85506": true,
      "85510": true,
      "85511": true,
      "85512": true
    },
    "HERMOSILLO": {
      "83000": true,
      "83001": true,
      "83002": true,
      "83003": true,
      "83004": true,
      "83005": true,
      "83006": true,
      "83007": true,
      "83008": true,
      "83009": true,
      "83010": true,
      "83011": true,
      "83012": true,
      "83013": true,
      "83014": true,
      "83015": true,
      "83016": true,
      "83017": true,
      "83018": true,
      "83019": true,
      "83020": true,
      "83021": true,
      "83022": true,
      "83023": true,
      "83024": true,
      "83025": true,
      "83026": true,
      "83027": true,
      "83028": true,
      "83029": true,
      "83030": true,
      "83031": true,
      "83032": true,
      "83033": true,
      "83034": true,
      "83035": true,
      "83036": true,
      "83037": true,
      "83038": true,
      "83039": true,
      "83040": true,
      "83041": true,
      "83042": true,
      "83043": true,
      "83044": true,
      "83045": true,
      "83046": true,
      "83047": true,
      "83048": true,
      "83049": true,
      "83050": true,
      "83051": true,
      "83052": true,
      "83053": true,
      "83054": true,
      "83055": true,
      "83056": true,
      "83057": true,
      "83058": true,
      "83059": true,
      "83060": true,
      "83061": true,
      "83062": true,
      "83063": true,
      "83064": true,
      "83065": true,
      "83066": true,
      "83067": true,
      "83068": true,
      "83069": true,
      "83070": true,
      "83071": true,
      "83072": true,
      "83073": true,
      "83074": true,
      "83075": true,
      "83076": true,
      "83077": true,
      "83078": true,
      "83079": true,
      "83080": true,
      "83081": true,
      "83082": true,
      "83083": true,
      "83084": true,
      "83085": true,
      "83086": true,
      "83087": true,
      "83088": true,
      "83089": true,
      "83090": true,
      "83091": true,
      "83092": true,
      "83093": true,
      "83094": true,
      "83095": true,
      "83096": true,
      "83097": true,
      "83098": true,
      "83099": true,
      "83100": true,
      "83101": true,
      "83102": true,
      "83103": true,
      "83104": true,
      "83105": true,
      "83106": true,
      "83107": true,
      "83108": true,
      "83109": true,
      "83110": true,
      "83111": true,
      "83112": true,
      "83113": true,
      "83114": true,
      "83115": true,
      "83116": true,
      "83117": true,
      "83118": true,
      "83119": true,
      "83120": true,
      "83121": true,
      "83122": true,
      "83123": true,
      "83124": true,
      "83125": true,
      "83126": true,
      "83127": true,
      "83128": true,
      "83129": true,
      "83130": true,
      "83131": true,
      "83132": true,
      "83133": true,
      "83134": true,
      "83135": true,
      "83136": true,
      "83137": true,
      "83138": true,
      "83139": true,
      "83140": true,
      "83141": true,
      "83142": true,
      "83143": true,
      "83144": true,
      "83145": true,
      "83146": true,
      "83147": true,
      "83148": true,
      "83149": true,
      "83150": true,
      "83151": true,
      "83152": true,
      "83153": true,
      "83154": true,
      "83155": true,
      "83156": true,
      "83157": true,
      "83158": true,
      "83159": true,
      "83160": true,
      "83161": true,
      "83162": true,
      "83163": true,
      "83164": true,
      "83165": true,
      "83166": true,
      "83167": true,
      "83168": true,
      "83169": true,
      "83170": true,
      "83171": true,
      "83172": true,
      "83173": true,
      "83174": true,
      "83175": true,
      "83176": true,
      "83177": true,
      "83178": true,
      "83179": true,
      "83180": true,
      "83181": true,
      "83182": true,
      "83183": true,
      "83184": true,
      "83185": true,
      "83186": true,
      "83187": true,
      "83188": true,
      "83189": true,
      "83190": true,
      "83191": true,
      "83192": true,
      "83193": true,
      "83194": true,
      "83195": true,
      "83196": true,
      "83197": true,
      "83198": true,
      "83199": true,
      "83200": true,
      "83201": true,
      "83202": true,
      "83203": true,
      "83204": true,
      "83205": true,
      "83206": true,
      "83207": true,
      "83208": true,
      "83209": true,
      "83210": true,
      "83211": true,
      "83212": true,
      "83213": true,
      "83214": true,
      "83215": true,
      "83216": true,
      "83217": true,
      "83218": true,
      "83219": true,
      "83220": true,
      "83221": true,
      "83222": true,
      "83223": true,
      "83224": true,
      "83225": true,
      "83226": true,
      "83227": true,
      "83228": true,
      "83229": true,
      "83230": true,
      "83231": true,
      "83232": true,
      "83233": true,
      "83234": true,
      "83235": true,
      "83236": true,
      "83237": true,
      "83238": true,
      "83239": true,
      "83240": true,
      "83241": true,
      "83242": true,
      "83243": true,
      "83244": true,
      "83245": true,
      "83246": true,
      "83247": true,
      "83248": true,
      "83249": true,
      "83250": true,
      "83251": true,
      "83252": true,
      "83253": true,
      "83254": true,
      "83255": true,
      "83256": true,
      "83257": true,
      "83258": true,
      "83259": true,
      "83260": true,
      "83261": true,
      "83262": true,
      "83263": true,
      "83264": true,
      "83265": true,
      "83266": true,
      "83267": true,
      "83268": true,
      "83269": true,
      "83270": true,
      "83271": true,
      "83272": true,
      "83273": true,
      "83274": true,
      "83275": true,
      "83276": true,
      "83277": true,
      "83278": true,
      "83279": true,
      "83280": true,
      "83281": true,
      "83282": true,
      "83283": true,
      "83284": true,
      "83285": true,
      "83286": true,
      "83287": true,
      "83288": true,
      "83289": true,
      "83290": true,
      "83291": true,
      "83292": true,
      "83293": true,
      "83294": true,
      "83295": true,
      "83296": true,
      "83297": true,
      "83298": true,
      "83299": true,
      "83300": true,
      "83301": true,
      "83302": true,
      "83303": true,
      "83304": true,
      "83305": true,
      "83306": true,
      "83307": true,
      "83308": true,
      "83309": true,
      "83310": true,
      "83311": true,
      "83312": true,
      "83313": true,
      "83314": true,
      "83315": true,
      "83316": true,
      "83317": true,
      "83318": true,
      "83319": true,
      "83320": true,
      "83321": true,
      "83322": true,
      "83323": true,
      "83324": true,
      "83325": true,
      "83326": true,
      "83327": true,
      "83328": true,
      "83329": true,
      "83330": true,
      "83331": true,
      "83332": true,
      "83333": true,
      "83334": true,
      "83335": true,
      "83336": true,
      "83337": true,
      "83338": true,
      "83339": true,
      "83340": true,
      "83341": true,
      "83342": true,
      "83343": true,
      "83344": true,
      "83345": true,
      "83346": true,
      "83347": true,
      "83348": true,
      "83349": true,
      "83350": true,
      "83351": true,
      "83352": true,
      "83353": true,
      "83354": true,
      "83355": true,
      "83356": true,
      "83357": true,
      "83358": true,
      "83359": true
    },
    "HUATABAMPO": {
      "85240": true,
      "85241": true,
      "85242": true,
      "85243": true,
      "85244": true,
      "85245": true,
      "85246": true,
      "85247": true,
      "85248": true,
      "85249": true,
      "85251": true,
      "85900": true,
      "85901": true,
      "85902": true,
      "85903": true,
      "85904": true,
      "85905": true,
      "85906": true,
      "85907": true,
      "85908": true,
      "85909": true,
      "85910": true,
      "85911": true,
      "85912": true,
      "85913": true,
      "85914": true,
      "85915": true,
      "85916": true,
      "85917": true,
      "85918": true,
      "85919": true,
      "85920": true,
      "85921": true,
      "85922": true,
      "85923": true,
      "85924": true,
      "85925": true,
      "85926": true,
      "85927": true,
      "85928": true,
      "85929": true,
      "85930": true,
      "85931": true,
      "85932": true,
      "85933": true,
      "85934": true,
      "85935": true,
      "85936": true,
      "85937": true,
      "85938": true,
      "85939": true,
      "85940": true,
      "85941": true,
      "85942": true,
      "85943": true,
      "85944": true,
      "85945": true,
      "85946": true,
      "85947": true,
      "85948": true,
      "85949": true,
      "85950": true,
      "85951": true,
      "85952": true,
      "85953": true,
      "85954": true,
      "85955": true,
      "85956": true,
      "85957": true,
      "85958": true,
      "85959": true,
      "85960": true,
      "85961": true,
      "85962": true,
      "85963": true,
      "85964": true,
      "85965": true,
      "85966": true,
      "85967": true,
      "85968": true,
      "85969": true,
      "85970": true,
      "85971": true,
      "85972": true,
      "85973": true,
      "85974": true,
      "85975": true,
      "85976": true,
      "85977": true,
      "85978": true,
      "85979": true,
      "85980": true,
      "85981": true,
      "85982": true,
      "85983": true,
      "85984": true,
      "85985": true,
      "85986": true,
      "85987": true,
      "85988": true,
      "85989": true,
      "85990": true,
      "85991": true,
      "85992": true,
      "85993": true,
      "85994": true,
      "85995": true,
      "85996": true,
      "85997": true,
      "85998": true,
      "85999": true
    },
    "MAGDALENA": {
      "84160": true,
      "84161": true,
      "84162": true,
      "84163": true,
      "84164": true,
      "84165": true,
      "84166": true,
      "84167": true,
      "84168": true,
      "84169": true,
      "84170": true,
      "84171": true,
      "84172": true,
      "84173": true,
      "84175": true
    },
    "NAVOJOA": {
      "85224": true,
      "85225": true,
      "85226": true,
      "85228": true,
      "85229": true,
      "85230": true,
      "85231": true,
      "85235": true,
      "85238": true,
      "85239": true,
      "85800": true,
      "85801": true,
      "85802": true,
      "85803": true,
      "85804": true,
      "85805": true,
      "85806": true,
      "85807": true,
      "85808": true,
      "85809": true,
      "85810": true,
      "85811": true,
      "85812": true,
      "85813": true,
      "85814": true,
      "85815": true,
      "85816": true,
      "85817": true,
      "85818": true,
      "85819": true,
      "85820": true,
      "85821": true,
      "85822": true,
      "85823": true,
      "85824": true,
      "85825": true,
      "85826": true,
      "85827": true,
      "85828": true,
      "85829": true,
      "85830": true,
      "85831": true,
      "85832": true,
      "85833": true,
      "85834": true,
      "85835": true,
      "85836": true,
      "85837": true,
      "85838": true,
      "85839": true,
      "85840": true,
      "85841": true,
      "85842": true,
      "85843": true,
      "85844": true,
      "85845": true,
      "85846": true,
      "85847": true,
      "85848": true,
      "85849": true,
      "85850": true,
      "85851": true,
      "85852": true,
      "85853": true,
      "85854": true,
      "85855": true,
      "85856": true,
      "85857": true,
      "85858": true,
      "85859": true,
      "85860": true,
      "85861": true,
      "85862": true,
      "85863": true,
      "85864": true,
      "85865": true,
      "85866": true,
      "85867": true,
      "85868": true,
      "85869": true,
      "85870": true,
      "85871": true,
      "85872": true,
      "85873": true,
      "85874": true,
      "85875": true,
      "85876": true,
      "85877": true,
      "85878": true,
      "85879": true,
      "85880": true,
      "85881": true,
      "85882": true,
      "85883": true,
      "85884": true,
      "85885": true,
      "85886": true,
      "85887": true,
      "85888": true,
      "85889": true,
      "85890": true,
      "85891": true,
      "85892": true,
      "85893": true,
      "85894": true,
      "85895": true,
      "85896": true,
      "85897": true,
      "85898": true,
      "85899": true
    },
    "NOGALES": {
      "84000": true,
      "84001": true,
      "84002": true,
      "84003": true,
      "84004": true,
      "84005": true,
      "84006": true,
      "84007": true,
      "84008": true,
      "84009": true,
      "84010": true,
      "84011": true,
      "84012": true,
      "84013": true,
      "84014": true,
      "84015": true,
      "84016": true,
      "84017": true,
      "84018": true,
      "84019": true,
      "84020": true,
      "84021": true,
      "84022": true,
      "84023": true,
      "84024": true,
      "84025": true,
      "84026": true,
      "84027": true,
      "84028": true,
      "84029": true,
      "84030": true,
      "84031": true,
      "84032": true,
      "84033": true,
      "84034": true,
      "84035": true,
      "84036": true,
      "84037": true,
      "84038": true,
      "84039": true,
      "84040": true,
      "84041": true,
      "84042": true,
      "84043": true,
      "84044": true,
      "84045": true,
      "84046": true,
      "84047": true,
      "84048": true,
      "84049": true,
      "84050": true,
      "84051": true,
      "84052": true,
      "84053": true,
      "84054": true,
      "84055": true,
      "84056": true,
      "84057": true,
      "84058": true,
      "84059": true,
      "84060": true,
      "84061": true,
      "84062": true,
      "84063": true,
      "84064": true,
      "84065": true,
      "84066": true,
      "84067": true,
      "84068": true,
      "84069": true,
      "84070": true,
      "84071": true,
      "84072": true,
      "84073": true,
      "84074": true,
      "84075": true,
      "84076": true,
      "84077": true,
      "84078": true,
      "84079": true,
      "84080": true,
      "84081": true,
      "84082": true,
      "84083": true,
      "84084": true,
      "84085": true,
      "84086": true,
      "84087": true,
      "84088": true,
      "84089": true,
      "84090": true,
      "84091": true,
      "84092": true,
      "84093": true,
      "84094": true,
      "84095": true,
      "84096": true,
      "84097": true,
      "84098": true,
      "84099": true,
      "84100": true,
      "84101": true,
      "84102": true,
      "84103": true,
      "84105": true,
      "84107": true,
      "84113": true,
      "84114": true,
      "84115": true
    },
    "PUERTO PENASCO": {
      "83550": true,
      "83551": true,
      "83552": true,
      "83553": true,
      "83554": true,
      "83555": true,
      "83556": true,
      "83557": true,
      "83558": true,
      "83559": true,
      "83564": true,
      "83565": true
    },
    "SAN IGNACIO RIO MUERTO": {
      "85514": true,
      "85515": true,
      "85516": true,
      "85517": true
    },
    "SAN LUIS RIO COLORADO": {
      "83400": true,
      "83401": true,
      "83402": true,
      "83403": true,
      "83404": true,
      "83405": true,
      "83406": true,
      "83407": true,
      "83408": true,
      "83409": true,
      "83410": true,
      "83411": true,
      "83412": true,
      "83413": true,
      "83414": true,
      "83415": true,
      "83416": true,
      "83417": true,
      "83418": true,
      "83419": true,
      "83420": true,
      "83421": true,
      "83422": true,
      "83423": true,
      "83424": true,
      "83425": true,
      "83426": true,
      "83427": true,
      "83428": true,
      "83429": true,
      "83430": true,
      "83431": true,
      "83432": true,
      "83433": true,
      "83434": true,
      "83435": true,
      "83436": true,
      "83437": true,
      "83438": true,
      "83439": true,
      "83440": true,
      "83441": true,
      "83442": true,
      "83443": true,
      "83444": true,
      "83445": true,
      "83446": true,
      "83447": true,
      "83448": true,
      "83449": true,
      "83450": true,
      "83451": true,
      "83452": true,
      "83453": true,
      "83454": true,
      "83455": true,
      "83456": true,
      "83457": true,
      "83458": true,
      "83459": true,
      "83460": true,
      "83461": true,
      "83462": true,
      "83463": true,
      "83464": true,
      "83465": true,
      "83466": true,
      "83467": true,
      "83468": true,
      "83469": true,
      "83470": true,
      "83471": true,
      "83472": true,
      "83473": true,
      "83474": true,
      "83475": true,
      "83476": true,
      "83477": true,
      "83478": true,
      "83479": true,
      "83480": true,
      "83481": true,
      "83482": true,
      "83483": true,
      "83484": true,
      "83485": true,
      "83486": true,
      "83487": true,
      "83488": true,
      "83489": true,
      "83490": true,
      "83491": true,
      "83492": true,
      "83493": true,
      "83494": true,
      "83495": true,
      "83496": true,
      "83497": true,
      "83498": true,
      "83499": true,
      "83500": true,
      "83501": true,
      "83502": true,
      "83503": true,
      "83504": true,
      "83505": true,
      "83506": true,
      "83507": true,
      "83508": true,
      "83509": true,
      "83513": true,
      "83515": true,
      "83516": true,
      "83517": true,
      "83518": true,
      "83519": true
    }
  },
  "TABASCO": {
    "BALANCAN": {
      "86930": true,
      "86931": true,
      "86932": true,
      "86933": true,
      "86934": true,
      "86935": true,
      "86936": true,
      "86937": true,
      "86938": true,
      "86939": true,
      "86940": true,
      "86941": true,
      "86942": true,
      "86948": true,
      "86949": true,
      "86951": true,
      "86952": true,
      "86958": true,
      "86959": true,
      "86961": true,
      "86962": true,
      "86968": true,
      "86969": true,
      "86971": true,
      "86972": true,
      "86978": true,
      "86979": true
    },
    "CARDENAS": {
      "86460": true,
      "86461": true,
      "86462": true,
      "86463": true,
      "86464": true,
      "86465": true,
      "86466": true,
      "86467": true,
      "86468": true,
      "86469": true,
      "86470": true,
      "86471": true,
      "86472": true,
      "86473": true,
      "86474": true,
      "86475": true,
      "86476": true,
      "86477": true,
      "86478": true,
      "86479": true,
      "86480": true,
      "86481": true,
      "86482": true,
      "86483": true,
      "86484": true,
      "86485": true,
      "86486": true,
      "86487": true,
      "86488": true,
      "86489": true,
      "86490": true,
      "86491": true,
      "86492": true,
      "86493": true,
      "86494": true,
      "86495": true,
      "86496": true,
      "86497": true,
      "86498": true,
      "86499": true,
      "86500": true,
      "86501": true,
      "86502": true,
      "86503": true,
      "86504": true,
      "86505": true,
      "86506": true,
      "86507": true,
      "86508": true,
      "86509": true,
      "86510": true,
      "86511": true,
      "86512": true,
      "86513": true,
      "86514": true,
      "86515": true,
      "86516": true,
      "86517": true,
      "86518": true,
      "86519": true,
      "86520": true,
      "86521": true,
      "86522": true,
      "86523": true,
      "86524": true,
      "86525": true,
      "86526": true,
      "86527": true,
      "86528": true,
      "86529": true,
      "86530": true,
      "86531": true,
      "86532": true,
      "86533": true,
      "86534": true,
      "86535": true,
      "86536": true,
      "86537": true,
      "86538": true,
      "86539": true,
      "86540": true,
      "86541": true,
      "86542": true,
      "86543": true,
      "86544": true,
      "86545": true,
      "86546": true,
      "86547": true,
      "86548": true,
      "86549": true,
      "86550": true,
      "86551": true,
      "86552": true,
      "86553": true,
      "86554": true,
      "86555": true,
      "86556": true,
      "86557": true,
      "86558": true,
      "86559": true,
      "86560": true,
      "86561": true,
      "86562": true,
      "86563": true,
      "86564": true,
      "86565": true,
      "86566": true,
      "86567": true,
      "86568": true,
      "86569": true,
      "86570": true,
      "86571": true,
      "86572": true,
      "86573": true,
      "86574": true,
      "86575": true,
      "86576": true,
      "86577": true,
      "86578": true,
      "86579": true,
      "86580": true,
      "86581": true,
      "86582": true,
      "86583": true,
      "86584": true,
      "86585": true,
      "86586": true,
      "86587": true,
      "86588": true,
      "86589": true,
      "86590": true,
      "86591": true,
      "86592": true,
      "86593": true,
      "86594": true,
      "86595": true,
      "86596": true,
      "86597": true,
      "86598": true,
      "86599": true
    },
    "CENTRO": {
      "86000": true,
      "86001": true,
      "86002": true,
      "86003": true,
      "86004": true,
      "86005": true,
      "86006": true,
      "86007": true,
      "86008": true,
      "86009": true,
      "86010": true,
      "86011": true,
      "86012": true,
      "86013": true,
      "86014": true,
      "86015": true,
      "86016": true,
      "86017": true,
      "86018": true,
      "86019": true,
      "86020": true,
      "86021": true,
      "86022": true,
      "86023": true,
      "86024": true,
      "86025": true,
      "86026": true,
      "86027": true,
      "86028": true,
      "86029": true,
      "86030": true,
      "86031": true,
      "86032": true,
      "86033": true,
      "86034": true,
      "86035": true,
      "86036": true,
      "86037": true,
      "86038": true,
      "86039": true,
      "86040": true,
      "86041": true,
      "86042": true,
      "86043": true,
      "86044": true,
      "86045": true,
      "86046": true,
      "86047": true,
      "86048": true,
      "86050": true,
      "86051": true,
      "86052": true,
      "86053": true,
      "86054": true,
      "86055": true,
      "86056": true,
      "86057": true,
      "86058": true,
      "86059": true,
      "86060": true,
      "86061": true,
      "86062": true,
      "86063": true,
      "86064": true,
      "86065": true,
      "86066": true,
      "86067": true,
      "86068": true,
      "86069": true,
      "86070": true,
      "86071": true,
      "86072": true,
      "86073": true,
      "86074": true,
      "86075": true,
      "86076": true,
      "86077": true,
      "86078": true,
      "86079": true,
      "86080": true,
      "86081": true,
      "86082": true,
      "86083": true,
      "86084": true,
      "86085": true,
      "86086": true,
      "86087": true,
      "86088": true,
      "86089": true,
      "86090": true,
      "86091": true,
      "86092": true,
      "86093": true,
      "86094": true,
      "86095": true,
      "86096": true,
      "86097": true,
      "86098": true,
      "86099": true,
      "86100": true,
      "86101": true,
      "86102": true,
      "86103": true,
      "86104": true,
      "86105": true,
      "86106": true,
      "86107": true,
      "86108": true,
      "86109": true,
      "86110": true,
      "86111": true,
      "86112": true,
      "86113": true,
      "86114": true,
      "86115": true,
      "86116": true,
      "86117": true,
      "86118": true,
      "86119": true,
      "86120": true,
      "86121": true,
      "86122": true,
      "86123": true,
      "86124": true,
      "86125": true,
      "86129": true,
      "86130": true,
      "86131": true,
      "86132": true,
      "86133": true,
      "86134": true,
      "86135": true,
      "86136": true,
      "86137": true,
      "86138": true,
      "86139": true,
      "86140": true,
      "86141": true,
      "86142": true,
      "86149": true,
      "86150": true,
      "86151": true,
      "86152": true,
      "86160": true,
      "86161": true,
      "86162": true,
      "86163": true,
      "86164": true,
      "86165": true,
      "86166": true,
      "86167": true,
      "86168": true,
      "86169": true,
      "86170": true,
      "86171": true,
      "86172": true,
      "86179": true,
      "86180": true,
      "86181": true,
      "86182": true,
      "86183": true,
      "86184": true,
      "86185": true,
      "86186": true,
      "86187": true,
      "86188": true,
      "86189": true,
      "86190": true,
      "86191": true,
      "86192": true
    },
    "COMALCALCO": {
      "86300": true,
      "86301": true,
      "86302": true,
      "86303": true,
      "86304": true,
      "86305": true,
      "86306": true,
      "86307": true,
      "86308": true,
      "86309": true,
      "86310": true,
      "86311": true,
      "86312": true,
      "86313": true,
      "86314": true,
      "86315": true,
      "86316": true,
      "86317": true,
      "86318": true,
      "86319": true,
      "86320": true,
      "86321": true,
      "86322": true,
      "86323": true,
      "86324": true,
      "86325": true,
      "86326": true,
      "86327": true,
      "86328": true,
      "86329": true,
      "86330": true,
      "86331": true,
      "86332": true,
      "86333": true,
      "86334": true,
      "86335": true,
      "86336": true,
      "86337": true,
      "86338": true,
      "86339": true,
      "86340": true,
      "86341": true,
      "86342": true,
      "86343": true,
      "86344": true,
      "86345": true,
      "86346": true,
      "86347": true,
      "86348": true,
      "86349": true,
      "86350": true,
      "86351": true,
      "86352": true,
      "86353": true,
      "86354": true,
      "86355": true,
      "86356": true,
      "86357": true,
      "86358": true,
      "86359": true,
      "86360": true,
      "86361": true,
      "86362": true,
      "86363": true,
      "86364": true,
      "86365": true,
      "86366": true,
      "86367": true,
      "86368": true,
      "86369": true,
      "86370": true,
      "86371": true,
      "86372": true,
      "86373": true,
      "86374": true,
      "86375": true,
      "86376": true,
      "86377": true,
      "86378": true,
      "86379": true,
      "86380": true,
      "86381": true,
      "86382": true,
      "86383": true,
      "86384": true,
      "86385": true,
      "86386": true,
      "86387": true,
      "86388": true,
      "86389": true,
      "86390": true,
      "86391": true,
      "86392": true,
      "86393": true,
      "86394": true,
      "86395": true,
      "86396": true,
      "86397": true,
      "86398": true,
      "86399": true,
      "86630": true,
      "86631": true,
      "86632": true,
      "86633": true,
      "86634": true,
      "86635": true,
      "86636": true,
      "86637": true,
      "86638": true,
      "86639": true,
      "86640": true,
      "86641": true,
      "86642": true,
      "86643": true,
      "86644": true,
      "86645": true,
      "86646": true,
      "86647": true,
      "86648": true,
      "86649": true,
      "86650": true,
      "86651": true,
      "86652": true,
      "86653": true,
      "86654": true,
      "86655": true,
      "86656": true,
      "86657": true,
      "86658": true,
      "86659": true,
      "86660": true,
      "86661": true,
      "86662": true,
      "86663": true,
      "86664": true,
      "86665": true,
      "86666": true,
      "86667": true,
      "86668": true,
      "86669": true,
      "86670": true,
      "86671": true,
      "86672": true,
      "86673": true,
      "86674": true,
      "86675": true,
      "86676": true,
      "86677": true,
      "86678": true,
      "86679": true
    },
    "CUNDUACAN": {
      "86680": true,
      "86681": true,
      "86682": true,
      "86683": true,
      "86684": true,
      "86685": true,
      "86686": true,
      "86687": true,
      "86688": true,
      "86689": true,
      "86690": true,
      "86691": true,
      "86693": true,
      "86694": true,
      "86695": true,
      "86697": true,
      "86698": true,
      "86699": true
    },
    "EMILIANO ZAPATA": {
      "86980": true,
      "86981": true,
      "86982": true,
      "86984": true,
      "86985": true,
      "86987": true,
      "86990": true,
      "86991": true,
      "86992": true,
      "86993": true,
      "86994": true,
      "86995": true,
      "86996": true,
      "86997": true,
      "86998": true,
      "86999": true
    },
    "HUIMANGUILLO": {
      "86400": true,
      "86401": true,
      "86402": true,
      "86403": true,
      "86404": true,
      "86405": true,
      "86406": true,
      "86407": true,
      "86408": true,
      "86409": true,
      "86410": true,
      "86411": true,
      "86412": true,
      "86414": true,
      "86415": true,
      "86418": true,
      "86419": true,
      "86434": true,
      "86435": true,
      "86440": true,
      "86441": true
    },
    "JALAPA": {
      "86830": true,
      "86831": true,
      "86832": true,
      "86833": true,
      "86834": true,
      "86835": true,
      "86836": true,
      "86837": true,
      "86838": true,
      "86839": true,
      "86840": true,
      "86841": true,
      "86842": true,
      "86843": true,
      "86844": true,
      "86845": true,
      "86846": true,
      "86847": true,
      "86848": true,
      "86849": true,
      "86850": true,
      "86851": true,
      "86852": true,
      "86853": true,
      "86854": true,
      "86855": true,
      "86856": true,
      "86857": true,
      "86858": true,
      "86859": true,
      "86860": true,
      "86861": true,
      "86862": true,
      "86863": true,
      "86864": true,
      "86865": true,
      "86866": true,
      "86867": true,
      "86868": true,
      "86869": true
    },
    "JALPA DE MENDEZ": {
      "86200": true,
      "86201": true,
      "86202": true,
      "86203": true,
      "86204": true,
      "86205": true,
      "86206": true,
      "86207": true,
      "86208": true,
      "86209": true,
      "86210": true,
      "86211": true,
      "86212": true,
      "86213": true,
      "86214": true,
      "86215": true,
      "86216": true,
      "86217": true,
      "86218": true,
      "86219": true
    },
    "JONUTA": {
      "86770": true,
      "86771": true,
      "86772": true,
      "86773": true,
      "86774": true,
      "86775": true,
      "86776": true,
      "86777": true,
      "86778": true,
      "86779": true,
      "86780": true,
      "86781": true,
      "86782": true,
      "86783": true,
      "86784": true,
      "86788": true,
      "86789": true,
      "86790": true,
      "86791": true,
      "86792": true,
      "86794": true,
      "86795": true,
      "86797": true,
      "86798": true,
      "86799": true
    },
    "NACAJUCA": {
      "86220": true,
      "86221": true,
      "86222": true,
      "86223": true,
      "86224": true,
      "86225": true,
      "86226": true,
      "86227": true,
      "86228": true,
      "86229": true,
      "86230": true,
      "86231": true,
      "86232": true,
      "86233": true,
      "86234": true,
      "86235": true,
      "86236": true,
      "86237": true,
      "86238": true,
      "86239": true,
      "86240": true,
      "86241": true,
      "86242": true,
      "86243": true,
      "86245": true,
      "86246": true,
      "86247": true,
      "86248": true,
      "86249": true
    },
    "PARAISO": {
      "86600": true,
      "86601": true,
      "86602": true,
      "86603": true,
      "86604": true,
      "86605": true,
      "86606": true,
      "86607": true,
      "86608": true,
      "86609": true,
      "86610": true,
      "86611": true,
      "86612": true,
      "86613": true,
      "86614": true,
      "86615": true,
      "86616": true,
      "86617": true,
      "86621": true,
      "86622": true,
      "86623": true,
      "86624": true,
      "86625": true,
      "86626": true,
      "86627": true,
      "86628": true,
      "86629": true
    },
    "TACOTALPA": {
      "86870": true,
      "86871": true,
      "86872": true,
      "86873": true,
      "86874": true,
      "86875": true,
      "86876": true,
      "86877": true,
      "86878": true,
      "86879": true,
      "86882": true,
      "86883": true,
      "86884": true,
      "86887": true,
      "86888": true,
      "86889": true,
      "86890": true,
      "86891": true
    },
    "TEAPA": {
      "86800": true,
      "86801": true,
      "86802": true,
      "86803": true,
      "86804": true,
      "86805": true,
      "86806": true,
      "86807": true,
      "86808": true,
      "86809": true,
      "86810": true,
      "86811": true,
      "86812": true,
      "86813": true,
      "86814": true,
      "86815": true,
      "86816": true,
      "86817": true,
      "86818": true,
      "86819": true,
      "86820": true,
      "86821": true,
      "86822": true,
      "86823": true,
      "86824": true,
      "86826": true,
      "86827": true,
      "86828": true,
      "86829": true
    },
    "TENOSIQUE": {
      "86900": true,
      "86901": true,
      "86902": true,
      "86903": true,
      "86904": true,
      "86905": true,
      "86907": true,
      "86908": true,
      "86910": true,
      "86911": true,
      "86913": true,
      "86914": true,
      "86917": true,
      "86918": true,
      "86919": true,
      "86921": true,
      "86922": true,
      "86923": true,
      "86929": true
    }
  },
  "TAMAULIPAS": {
    "ALDAMA": {
      "89670": true,
      "89671": true,
      "89672": true,
      "89673": true,
      "89674": true,
      "89675": true,
      "89676": true
    },
    "ALTAMIRA": {
      "89600": true,
      "89601": true,
      "89602": true,
      "89603": true,
      "89604": true,
      "89605": true,
      "89606": true,
      "89607": true,
      "89608": true,
      "89609": true,
      "89610": true,
      "89611": true,
      "89612": true,
      "89613": true,
      "89614": true,
      "89615": true,
      "89616": true,
      "89617": true,
      "89618": true,
      "89619": true,
      "89620": true,
      "89621": true,
      "89622": true,
      "89623": true,
      "89624": true,
      "89625": true,
      "89626": true,
      "89627": true,
      "89628": true,
      "89629": true,
      "89630": true,
      "89631": true,
      "89632": true,
      "89633": true,
      "89634": true,
      "89635": true,
      "89636": true,
      "89637": true,
      "89638": true,
      "89639": true,
      "89640": true,
      "89641": true,
      "89642": true,
      "89643": true,
      "89644": true,
      "89645": true,
      "89646": true,
      "89647": true,
      "89648": true,
      "89649": true,
      "89650": true,
      "89651": true,
      "89652": true,
      "89653": true,
      "89654": true,
      "89655": true,
      "89656": true,
      "89657": true,
      "89658": true,
      "89659": true,
      "89660": true,
      "89661": true,
      "89662": true,
      "89663": true,
      "89664": true,
      "89665": true,
      "89666": true,
      "89667": true,
      "89668": true,
      "89669": true
    },
    "CIUDAD MADERO": {
      "89400": true,
      "89401": true,
      "89402": true,
      "89403": true,
      "89404": true,
      "89405": true,
      "89406": true,
      "89407": true,
      "89408": true,
      "89409": true,
      "89410": true,
      "89411": true,
      "89412": true,
      "89413": true,
      "89414": true,
      "89415": true,
      "89416": true,
      "89417": true,
      "89418": true,
      "89419": true,
      "89420": true,
      "89421": true,
      "89422": true,
      "89423": true,
      "89424": true,
      "89425": true,
      "89426": true,
      "89427": true,
      "89428": true,
      "89429": true,
      "89430": true,
      "89431": true,
      "89432": true,
      "89433": true,
      "89434": true,
      "89435": true,
      "89436": true,
      "89437": true,
      "89438": true,
      "89439": true,
      "89440": true,
      "89441": true,
      "89442": true,
      "89443": true,
      "89444": true,
      "89445": true,
      "89446": true,
      "89447": true,
      "89448": true,
      "89449": true,
      "89450": true,
      "89451": true,
      "89452": true,
      "89453": true,
      "89454": true,
      "89455": true,
      "89456": true,
      "89457": true,
      "89458": true,
      "89459": true,
      "89460": true,
      "89461": true,
      "89462": true,
      "89463": true,
      "89464": true,
      "89465": true,
      "89466": true,
      "89467": true,
      "89468": true,
      "89469": true,
      "89470": true,
      "89471": true,
      "89472": true,
      "89473": true,
      "89474": true,
      "89475": true,
      "89476": true,
      "89477": true,
      "89478": true,
      "89479": true,
      "89480": true,
      "89481": true,
      "89482": true,
      "89483": true,
      "89484": true,
      "89485": true,
      "89486": true,
      "89487": true,
      "89488": true,
      "89489": true,
      "89490": true,
      "89491": true,
      "89492": true,
      "89493": true,
      "89494": true,
      "89495": true,
      "89496": true,
      "89497": true,
      "89498": true,
      "89499": true,
      "89500": true,
      "89501": true,
      "89502": true,
      "89503": true,
      "89504": true,
      "89505": true,
      "89506": true,
      "89507": true,
      "89508": true,
      "89509": true,
      "89510": true,
      "89511": true,
      "89512": true,
      "89513": true,
      "89514": true,
      "89515": true,
      "89516": true,
      "89517": true,
      "89518": true,
      "89519": true,
      "89520": true,
      "89521": true,
      "89522": true,
      "89523": true,
      "89524": true,
      "89525": true,
      "89526": true,
      "89527": true,
      "89528": true,
      "89529": true,
      "89530": true,
      "89531": true,
      "89532": true,
      "89533": true,
      "89534": true,
      "89535": true,
      "89536": true,
      "89537": true,
      "89538": true,
      "89539": true,
      "89540": true,
      "89541": true,
      "89542": true,
      "89543": true,
      "89544": true,
      "89545": true,
      "89546": true,
      "89547": true,
      "89548": true,
      "89549": true,
      "89550": true,
      "89551": true,
      "89552": true,
      "89553": true,
      "89554": true,
      "89555": true,
      "89556": true,
      "89557": true,
      "89558": true,
      "89559": true,
      "89560": true,
      "89561": true,
      "89562": true,
      "89563": true,
      "89564": true,
      "89565": true,
      "89566": true,
      "89567": true,
      "89568": true,
      "89569": true,
      "89570": true,
      "89571": true,
      "89572": true,
      "89573": true,
      "89574": true,
      "89575": true,
      "89576": true,
      "89577": true,
      "89578": true,
      "89579": true,
      "89580": true,
      "89581": true,
      "89582": true,
      "89583": true,
      "89584": true,
      "89585": true,
      "89586": true,
      "89587": true,
      "89588": true,
      "89589": true,
      "89590": true,
      "89591": true,
      "89592": true,
      "89593": true,
      "89594": true,
      "89595": true,
      "89596": true,
      "89597": true,
      "89598": true,
      "89599": true
    },
    "CIUDAD MANTE": {
      "89800": true
    },
    "EL MANTE": {
      "89800": true,
      "89801": true,
      "89802": true,
      "89803": true,
      "89804": true,
      "89805": true,
      "89806": true,
      "89807": true,
      "89808": true,
      "89809": true,
      "89810": true,
      "89811": true,
      "89812": true,
      "89813": true,
      "89814": true,
      "89815": true,
      "89816": true,
      "89817": true,
      "89818": true,
      "89819": true,
      "89820": true,
      "89821": true,
      "89822": true,
      "89823": true,
      "89824": true,
      "89825": true,
      "89826": true,
      "89827": true,
      "89828": true,
      "89829": true,
      "89830": true,
      "89831": true,
      "89832": true,
      "89833": true,
      "89834": true,
      "89835": true,
      "89836": true,
      "89837": true,
      "89838": true,
      "89839": true,
      "89840": true,
      "89841": true,
      "89842": true,
      "89843": true,
      "89844": true,
      "89845": true,
      "89846": true,
      "89847": true,
      "89848": true,
      "89849": true,
      "89850": true,
      "89851": true,
      "89852": true,
      "89853": true,
      "89854": true,
      "89855": true,
      "89856": true,
      "89857": true,
      "89858": true,
      "89859": true,
      "89860": true,
      "89861": true,
      "89862": true,
      "89863": true,
      "89864": true,
      "89865": true,
      "89866": true,
      "89867": true,
      "89868": true,
      "89869": true,
      "89870": true,
      "89871": true,
      "89872": true,
      "89873": true,
      "89874": true,
      "89875": true,
      "89876": true,
      "89877": true,
      "89878": true,
      "89879": true,
      "89880": true,
      "89881": true,
      "89882": true,
      "89883": true,
      "89884": true,
      "89885": true,
      "89886": true,
      "89887": true,
      "89888": true,
      "89889": true,
      "89890": true,
      "89891": true,
      "89892": true,
      "89893": true,
      "89894": true,
      "89895": true,
      "89896": true,
      "89897": true,
      "89898": true,
      "89899": true,
      "89900": true,
      "89901": true,
      "89902": true,
      "89903": true,
      "89904": true,
      "89905": true,
      "89906": true,
      "89907": true,
      "89908": true,
      "89909": true,
      "89910": true,
      "89911": true,
      "89912": true,
      "89913": true,
      "89914": true,
      "89915": true,
      "89916": true,
      "89918": true,
      "89919": true,
      "89920": true,
      "89921": true,
      "89922": true,
      "89923": true,
      "89924": true,
      "89925": true,
      "89926": true,
      "89927": true,
      "89929": true,
      "89930": true,
      "89931": true,
      "89932": true,
      "89933": true,
      "89934": true,
      "89935": true,
      "89936": true,
      "89937": true,
      "89938": true,
      "89939": true,
      "89940": true,
      "89941": true,
      "89942": true,
      "89943": true,
      "89944": true,
      "89950": true,
      "89951": true,
      "89952": true,
      "89953": true,
      "89954": true,
      "89955": true
    },
    "GONZALEZ": {
      "89700": true,
      "89701": true,
      "89702": true,
      "89703": true,
      "89705": true,
      "89706": true,
      "89707": true,
      "89708": true,
      "89709": true,
      "89710": true,
      "89711": true,
      "89712": true,
      "89713": true,
      "89714": true,
      "89715": true,
      "89716": true,
      "89717": true,
      "89718": true,
      "89719": true,
      "89730": true,
      "89731": true,
      "89732": true,
      "89733": true,
      "89734": true,
      "89736": true,
      "89737": true,
      "89738": true,
      "89739": true,
      "89744": true,
      "89745": true,
      "89746": true,
      "89747": true,
      "89748": true,
      "89749": true
    },
    "GUEMEZ": {
      "87230": true,
      "87231": true,
      "87232": true,
      "87233": true,
      "87234": true,
      "87235": true,
      "87236": true,
      "87237": true,
      "87238": true,
      "87239": true,
      "87240": true,
      "87241": true,
      "87242": true,
      "87243": true,
      "87244": true,
      "87245": true,
      "87246": true,
      "87247": true,
      "87248": true,
      "87249": true
    },
    "GUSTAVO DIAZ ORDAZ": {
      "88400": true,
      "88401": true,
      "88402": true,
      "88403": true,
      "88404": true,
      "88405": true,
      "88406": true,
      "88407": true,
      "88408": true,
      "88409": true,
      "88410": true,
      "88411": true,
      "88412": true,
      "88413": true,
      "88414": true,
      "88415": true,
      "88416": true,
      "88417": true,
      "88418": true,
      "88419": true,
      "88425": true,
      "88426": true,
      "88427": true,
      "88428": true,
      "88429": true,
      "88430": true,
      "88431": true,
      "88432": true,
      "88433": true,
      "88434": true,
      "88435": true,
      "88436": true,
      "88437": true,
      "88438": true,
      "88439": true
    },
    "HIDALGO": {
      "87800": true,
      "87801": true,
      "87802": true,
      "87803": true,
      "87804": true,
      "87805": true,
      "87806": true,
      "87807": true,
      "87808": true,
      "87809": true,
      "87810": true,
      "87811": true,
      "87812": true,
      "87816": true,
      "87817": true,
      "87818": true,
      "87819": true,
      "87822": true,
      "87823": true,
      "87824": true,
      "87825": true,
      "87826": true,
      "87827": true,
      "87828": true,
      "87829": true,
      "87830": true,
      "87834": true,
      "87835": true,
      "87836": true,
      "87837": true,
      "87838": true,
      "87839": true,
      "87843": true
    },
    "JAUMAVE": {
      "87930": true,
      "87931": true,
      "87932": true,
      "87933": true,
      "87934": true,
      "87936": true,
      "87937": true,
      "87939": true,
      "87940": true,
      "87941": true,
      "87942": true,
      "87943": true,
      "87944": true,
      "87945": true,
      "87946": true,
      "87947": true,
      "87948": true,
      "87949": true
    },
    "JIMENEZ": {
      "87700": true,
      "87701": true,
      "87702": true,
      "87703": true,
      "87704": true,
      "87705": true,
      "87706": true,
      "87707": true,
      "87708": true,
      "87710": true,
      "87711": true,
      "87712": true,
      "87720": true,
      "87721": true,
      "87722": true,
      "87723": true,
      "87724": true,
      "87725": true,
      "87726": true,
      "87727": true,
      "87728": true,
      "87729": true
    },
    "MATAMOROS": {
      "87300": true,
      "87301": true,
      "87302": true,
      "87303": true,
      "87304": true,
      "87305": true,
      "87306": true,
      "87307": true,
      "87308": true,
      "87309": true,
      "87310": true,
      "87311": true,
      "87312": true,
      "87313": true,
      "87314": true,
      "87315": true,
      "87316": true,
      "87317": true,
      "87318": true,
      "87319": true,
      "87320": true,
      "87321": true,
      "87322": true,
      "87323": true,
      "87324": true,
      "87325": true,
      "87326": true,
      "87327": true,
      "87328": true,
      "87329": true,
      "87330": true,
      "87331": true,
      "87332": true,
      "87333": true,
      "87334": true,
      "87335": true,
      "87336": true,
      "87337": true,
      "87338": true,
      "87339": true,
      "87340": true,
      "87341": true,
      "87342": true,
      "87343": true,
      "87344": true,
      "87345": true,
      "87346": true,
      "87347": true,
      "87348": true,
      "87349": true,
      "87350": true,
      "87351": true,
      "87352": true,
      "87353": true,
      "87354": true,
      "87355": true,
      "87356": true,
      "87357": true,
      "87358": true,
      "87359": true,
      "87360": true,
      "87361": true,
      "87362": true,
      "87363": true,
      "87364": true,
      "87365": true,
      "87366": true,
      "87367": true,
      "87368": true,
      "87369": true,
      "87370": true,
      "87371": true,
      "87372": true,
      "87373": true,
      "87374": true,
      "87375": true,
      "87376": true,
      "87377": true,
      "87378": true,
      "87379": true,
      "87380": true,
      "87381": true,
      "87382": true,
      "87383": true,
      "87384": true,
      "87385": true,
      "87386": true,
      "87387": true,
      "87388": true,
      "87389": true,
      "87390": true,
      "87391": true,
      "87392": true,
      "87393": true,
      "87394": true,
      "87395": true,
      "87396": true,
      "87397": true,
      "87398": true,
      "87399": true,
      "87400": true,
      "87401": true,
      "87402": true,
      "87403": true,
      "87404": true,
      "87405": true,
      "87406": true,
      "87407": true,
      "87408": true,
      "87409": true,
      "87410": true,
      "87411": true,
      "87412": true,
      "87413": true,
      "87414": true,
      "87415": true,
      "87416": true,
      "87417": true,
      "87418": true,
      "87419": true,
      "87420": true,
      "87421": true,
      "87422": true,
      "87423": true,
      "87424": true,
      "87425": true,
      "87426": true,
      "87427": true,
      "87428": true,
      "87429": true,
      "87430": true,
      "87431": true,
      "87432": true,
      "87433": true,
      "87434": true,
      "87435": true,
      "87436": true,
      "87437": true,
      "87438": true,
      "87439": true,
      "87440": true,
      "87441": true,
      "87442": true,
      "87443": true,
      "87444": true,
      "87445": true,
      "87446": true,
      "87447": true,
      "87448": true,
      "87449": true,
      "87450": true,
      "87451": true,
      "87452": true,
      "87453": true,
      "87454": true,
      "87455": true,
      "87456": true,
      "87457": true,
      "87458": true,
      "87459": true,
      "87460": true,
      "87461": true,
      "87462": true,
      "87463": true,
      "87464": true,
      "87465": true,
      "87466": true,
      "87467": true,
      "87468": true,
      "87469": true,
      "87470": true,
      "87471": true,
      "87472": true,
      "87473": true,
      "87474": true,
      "87475": true,
      "87476": true,
      "87477": true,
      "87478": true,
      "87479": true,
      "87480": true,
      "87481": true,
      "87482": true,
      "87483": true,
      "87484": true,
      "87485": true,
      "87486": true,
      "87487": true,
      "87488": true,
      "87489": true,
      "87490": true,
      "87491": true,
      "87492": true,
      "87493": true,
      "87494": true,
      "87495": true,
      "87496": true,
      "87497": true,
      "87498": true,
      "87499": true,
      "87540": true,
      "87541": true,
      "87542": true,
      "87543": true,
      "87544": true,
      "87545": true,
      "87546": true,
      "87547": true,
      "87548": true,
      "87549": true,
      "87550": true,
      "87551": true,
      "87552": true,
      "87553": true,
      "87554": true,
      "87555": true,
      "87556": true,
      "87557": true,
      "87558": true,
      "87559": true,
      "87560": true,
      "87561": true,
      "87562": true,
      "87563": true,
      "87564": true,
      "87565": true,
      "87566": true,
      "87567": true,
      "87568": true,
      "87569": true,
      "87570": true,
      "87571": true,
      "87572": true,
      "87573": true,
      "87574": true,
      "87575": true,
      "87576": true,
      "87577": true,
      "87578": true,
      "87579": true,
      "87580": true,
      "87581": true,
      "87582": true,
      "87583": true,
      "87584": true,
      "87585": true,
      "87586": true,
      "87587": true,
      "87588": true,
      "87589": true,
      "87590": true,
      "87591": true,
      "87592": true,
      "87593": true,
      "87594": true,
      "87595": true,
      "87596": true,
      "87597": true,
      "87598": true,
      "87599": true
    },
    "MIGUEL ALEMAN": {
      "88300": true,
      "88301": true,
      "88302": true,
      "88303": true,
      "88304": true,
      "88305": true,
      "88306": true,
      "88307": true,
      "88308": true,
      "88309": true,
      "88310": true,
      "88311": true,
      "88312": true,
      "88313": true,
      "88314": true,
      "88315": true,
      "88316": true,
      "88317": true,
      "88318": true,
      "88319": true,
      "88320": true,
      "88321": true,
      "88322": true,
      "88323": true,
      "88324": true,
      "88325": true,
      "88326": true,
      "88327": true,
      "88328": true,
      "88329": true,
      "88338": true,
      "88339": true
    },
    "NUEVO LAREDO": {
      "88000": true,
      "88001": true,
      "88002": true,
      "88003": true,
      "88004": true,
      "88005": true,
      "88006": true,
      "88007": true,
      "88008": true,
      "88009": true,
      "88010": true,
      "88011": true,
      "88012": true,
      "88013": true,
      "88014": true,
      "88015": true,
      "88016": true,
      "88017": true,
      "88018": true,
      "88019": true,
      "88020": true,
      "88021": true,
      "88022": true,
      "88023": true,
      "88024": true,
      "88025": true,
      "88026": true,
      "88027": true,
      "88028": true,
      "88029": true,
      "88030": true,
      "88031": true,
      "88032": true,
      "88033": true,
      "88034": true,
      "88035": true,
      "88036": true,
      "88037": true,
      "88038": true,
      "88039": true,
      "88040": true,
      "88041": true,
      "88042": true,
      "88043": true,
      "88044": true,
      "88045": true,
      "88046": true,
      "88047": true,
      "88048": true,
      "88049": true,
      "88050": true,
      "88051": true,
      "88052": true,
      "88053": true,
      "88054": true,
      "88055": true,
      "88056": true,
      "88057": true,
      "88058": true,
      "88059": true,
      "88060": true,
      "88061": true,
      "88062": true,
      "88063": true,
      "88064": true,
      "88065": true,
      "88066": true,
      "88067": true,
      "88068": true,
      "88069": true,
      "88070": true,
      "88071": true,
      "88072": true,
      "88073": true,
      "88074": true,
      "88075": true,
      "88076": true,
      "88077": true,
      "88078": true,
      "88079": true,
      "88080": true,
      "88081": true,
      "88082": true,
      "88083": true,
      "88084": true,
      "88085": true,
      "88086": true,
      "88087": true,
      "88088": true,
      "88089": true,
      "88090": true,
      "88091": true,
      "88092": true,
      "88093": true,
      "88094": true,
      "88095": true,
      "88096": true,
      "88097": true,
      "88098": true,
      "88099": true,
      "88100": true,
      "88101": true,
      "88102": true,
      "88103": true,
      "88104": true,
      "88105": true,
      "88106": true,
      "88107": true,
      "88108": true,
      "88109": true,
      "88110": true,
      "88111": true,
      "88112": true,
      "88113": true,
      "88114": true,
      "88115": true,
      "88116": true,
      "88117": true,
      "88118": true,
      "88119": true,
      "88120": true,
      "88121": true,
      "88122": true,
      "88123": true,
      "88124": true,
      "88125": true,
      "88126": true,
      "88127": true,
      "88128": true,
      "88129": true,
      "88130": true,
      "88131": true,
      "88132": true,
      "88133": true,
      "88134": true,
      "88135": true,
      "88136": true,
      "88137": true,
      "88138": true,
      "88139": true,
      "88140": true,
      "88141": true,
      "88142": true,
      "88143": true,
      "88144": true,
      "88145": true,
      "88146": true,
      "88147": true,
      "88148": true,
      "88149": true,
      "88150": true,
      "88151": true,
      "88152": true,
      "88153": true,
      "88154": true,
      "88155": true,
      "88156": true,
      "88157": true,
      "88158": true,
      "88159": true,
      "88160": true,
      "88161": true,
      "88162": true,
      "88163": true,
      "88164": true,
      "88165": true,
      "88166": true,
      "88167": true,
      "88168": true,
      "88169": true,
      "88170": true,
      "88171": true,
      "88172": true,
      "88173": true,
      "88174": true,
      "88175": true,
      "88176": true,
      "88177": true,
      "88178": true,
      "88179": true,
      "88180": true,
      "88181": true,
      "88182": true,
      "88183": true,
      "88184": true,
      "88185": true,
      "88186": true,
      "88187": true,
      "88188": true,
      "88189": true,
      "88190": true,
      "88191": true,
      "88192": true,
      "88193": true,
      "88194": true,
      "88195": true,
      "88196": true,
      "88197": true,
      "88198": true,
      "88199": true,
      "88200": true,
      "88201": true,
      "88202": true,
      "88203": true,
      "88204": true,
      "88205": true,
      "88206": true,
      "88207": true,
      "88208": true,
      "88209": true,
      "88210": true,
      "88211": true,
      "88212": true,
      "88213": true,
      "88214": true,
      "88215": true,
      "88216": true,
      "88217": true,
      "88218": true,
      "88219": true,
      "88220": true,
      "88221": true,
      "88222": true,
      "88223": true,
      "88224": true,
      "88225": true,
      "88226": true,
      "88227": true,
      "88228": true,
      "88229": true,
      "88230": true,
      "88231": true,
      "88232": true,
      "88233": true,
      "88234": true,
      "88235": true,
      "88236": true,
      "88237": true,
      "88238": true,
      "88239": true,
      "88240": true,
      "88241": true,
      "88242": true,
      "88243": true,
      "88244": true,
      "88245": true,
      "88246": true,
      "88247": true,
      "88248": true,
      "88249": true,
      "88250": true,
      "88251": true,
      "88252": true,
      "88253": true,
      "88254": true,
      "88255": true,
      "88256": true,
      "88257": true,
      "88258": true,
      "88259": true,
      "88260": true,
      "88261": true,
      "88262": true,
      "88263": true,
      "88264": true,
      "88265": true,
      "88266": true,
      "88267": true,
      "88268": true,
      "88269": true,
      "88270": true,
      "88271": true,
      "88272": true,
      "88273": true,
      "88274": true,
      "88275": true,
      "88276": true,
      "88277": true,
      "88278": true,
      "88279": true,
      "88280": true,
      "88281": true,
      "88282": true,
      "88283": true,
      "88284": true,
      "88285": true,
      "88286": true,
      "88287": true,
      "88288": true,
      "88289": true,
      "88290": true,
      "88291": true,
      "88292": true,
      "88293": true,
      "88294": true,
      "88295": true,
      "88296": true,
      "88297": true,
      "88298": true,
      "88299": true,
      "88350": true,
      "88351": true,
      "88352": true,
      "88353": true,
      "88354": true,
      "88355": true,
      "88356": true,
      "88357": true,
      "88358": true,
      "88359": true,
      "88360": true,
      "88361": true,
      "88362": true,
      "88363": true,
      "88364": true,
      "88365": true,
      "88366": true,
      "88367": true,
      "88368": true,
      "88369": true
    },
    "PADILLA": {
      "87780": true,
      "87781": true,
      "87782": true,
      "87783": true,
      "87784": true,
      "87785": true,
      "87786": true,
      "87787": true,
      "87788": true,
      "87789": true,
      "87790": true,
      "87791": true,
      "87792": true,
      "87794": true,
      "87795": true,
      "87796": true,
      "87797": true,
      "87798": true,
      "87799": true
    },
    "PALMILLAS": {
      "87970": true,
      "87971": true,
      "87972": true,
      "87973": true,
      "87974": true,
      "87975": true,
      "87976": true,
      "87977": true,
      "87978": true,
      "87979": true
    },
    "REYNOSA": {
      "88500": true,
      "88501": true,
      "88502": true,
      "88503": true,
      "88504": true,
      "88505": true,
      "88506": true,
      "88507": true,
      "88508": true,
      "88509": true,
      "88510": true,
      "88511": true,
      "88512": true,
      "88513": true,
      "88514": true,
      "88515": true,
      "88516": true,
      "88517": true,
      "88518": true,
      "88519": true,
      "88520": true,
      "88521": true,
      "88522": true,
      "88523": true,
      "88524": true,
      "88525": true,
      "88526": true,
      "88527": true,
      "88528": true,
      "88529": true,
      "88530": true,
      "88531": true,
      "88532": true,
      "88533": true,
      "88534": true,
      "88535": true,
      "88536": true,
      "88537": true,
      "88538": true,
      "88539": true,
      "88540": true,
      "88541": true,
      "88542": true,
      "88543": true,
      "88544": true,
      "88545": true,
      "88546": true,
      "88547": true,
      "88548": true,
      "88549": true,
      "88550": true,
      "88551": true,
      "88552": true,
      "88553": true,
      "88554": true,
      "88555": true,
      "88556": true,
      "88557": true,
      "88558": true,
      "88559": true,
      "88560": true,
      "88561": true,
      "88562": true,
      "88563": true,
      "88564": true,
      "88565": true,
      "88566": true,
      "88567": true,
      "88568": true,
      "88569": true,
      "88570": true,
      "88571": true,
      "88572": true,
      "88573": true,
      "88574": true,
      "88575": true,
      "88576": true,
      "88577": true,
      "88578": true,
      "88579": true,
      "88580": true,
      "88581": true,
      "88582": true,
      "88583": true,
      "88584": true,
      "88585": true,
      "88586": true,
      "88587": true,
      "88588": true,
      "88589": true,
      "88590": true,
      "88591": true,
      "88592": true,
      "88593": true,
      "88594": true,
      "88595": true,
      "88596": true,
      "88597": true,
      "88598": true,
      "88599": true,
      "88600": true,
      "88601": true,
      "88602": true,
      "88603": true,
      "88604": true,
      "88605": true,
      "88606": true,
      "88607": true,
      "88608": true,
      "88609": true,
      "88610": true,
      "88611": true,
      "88612": true,
      "88613": true,
      "88614": true,
      "88615": true,
      "88616": true,
      "88617": true,
      "88618": true,
      "88619": true,
      "88620": true,
      "88621": true,
      "88622": true,
      "88623": true,
      "88624": true,
      "88625": true,
      "88626": true,
      "88627": true,
      "88628": true,
      "88629": true,
      "88630": true,
      "88631": true,
      "88632": true,
      "88633": true,
      "88634": true,
      "88635": true,
      "88636": true,
      "88637": true,
      "88638": true,
      "88639": true,
      "88640": true,
      "88641": true,
      "88642": true,
      "88643": true,
      "88644": true,
      "88645": true,
      "88646": true,
      "88647": true,
      "88648": true,
      "88649": true,
      "88650": true,
      "88651": true,
      "88652": true,
      "88653": true,
      "88654": true,
      "88655": true,
      "88656": true,
      "88657": true,
      "88658": true,
      "88659": true,
      "88660": true,
      "88661": true,
      "88662": true,
      "88663": true,
      "88664": true,
      "88665": true,
      "88666": true,
      "88667": true,
      "88668": true,
      "88669": true,
      "88670": true,
      "88671": true,
      "88672": true,
      "88673": true,
      "88674": true,
      "88675": true,
      "88676": true,
      "88677": true,
      "88678": true,
      "88679": true,
      "88680": true,
      "88681": true,
      "88682": true,
      "88683": true,
      "88684": true,
      "88685": true,
      "88686": true,
      "88687": true,
      "88688": true,
      "88689": true,
      "88690": true,
      "88691": true,
      "88692": true,
      "88693": true,
      "88694": true,
      "88695": true,
      "88696": true,
      "88697": true,
      "88698": true,
      "88699": true,
      "88700": true,
      "88701": true,
      "88702": true,
      "88703": true,
      "88704": true,
      "88705": true,
      "88706": true,
      "88707": true,
      "88708": true,
      "88709": true,
      "88710": true,
      "88711": true,
      "88712": true,
      "88713": true,
      "88714": true,
      "88715": true,
      "88716": true,
      "88717": true,
      "88718": true,
      "88719": true,
      "88720": true,
      "88721": true,
      "88722": true,
      "88723": true,
      "88724": true,
      "88725": true,
      "88726": true,
      "88727": true,
      "88728": true,
      "88729": true,
      "88730": true,
      "88731": true,
      "88732": true,
      "88733": true,
      "88734": true,
      "88735": true,
      "88736": true,
      "88737": true,
      "88738": true,
      "88739": true,
      "88740": true,
      "88741": true,
      "88742": true,
      "88743": true,
      "88744": true,
      "88745": true,
      "88746": true,
      "88747": true,
      "88748": true,
      "88749": true,
      "88750": true,
      "88751": true,
      "88752": true,
      "88753": true,
      "88754": true,
      "88755": true,
      "88756": true,
      "88757": true,
      "88758": true,
      "88759": true,
      "88760": true,
      "88761": true,
      "88762": true,
      "88763": true,
      "88764": true,
      "88765": true,
      "88766": true,
      "88767": true,
      "88768": true,
      "88769": true,
      "88770": true,
      "88771": true,
      "88772": true,
      "88773": true,
      "88774": true,
      "88775": true,
      "88776": true,
      "88777": true,
      "88778": true,
      "88779": true,
      "88780": true,
      "88781": true,
      "88782": true,
      "88783": true,
      "88784": true,
      "88785": true,
      "88786": true,
      "88787": true,
      "88788": true,
      "88789": true,
      "88790": true,
      "88791": true,
      "88792": true,
      "88793": true,
      "88794": true,
      "88795": true,
      "88796": true,
      "88797": true,
      "88798": true,
      "88799": true,
      "88850": true,
      "88851": true,
      "88852": true,
      "88853": true,
      "88854": true,
      "88855": true,
      "88856": true,
      "88857": true,
      "88858": true,
      "88859": true,
      "88860": true,
      "88861": true,
      "88862": true,
      "88863": true,
      "88864": true,
      "88865": true,
      "88866": true,
      "88867": true,
      "88868": true,
      "88869": true,
      "88870": true,
      "88871": true,
      "88872": true,
      "88873": true,
      "88874": true,
      "88875": true,
      "88876": true,
      "88877": true,
      "88878": true,
      "88879": true
    },
    "RIO BRAVO": {
      "88800": true,
      "88801": true,
      "88802": true,
      "88803": true,
      "88804": true,
      "88805": true,
      "88806": true,
      "88807": true,
      "88809": true,
      "88810": true,
      "88811": true,
      "88812": true,
      "88813": true,
      "88814": true,
      "88815": true,
      "88816": true,
      "88817": true,
      "88818": true,
      "88900": true,
      "88901": true,
      "88902": true,
      "88903": true,
      "88904": true,
      "88905": true,
      "88906": true,
      "88907": true,
      "88908": true,
      "88909": true,
      "88910": true,
      "88911": true,
      "88912": true,
      "88913": true,
      "88914": true,
      "88915": true,
      "88916": true,
      "88917": true,
      "88918": true,
      "88919": true,
      "88920": true,
      "88921": true,
      "88922": true,
      "88923": true,
      "88924": true,
      "88925": true,
      "88926": true,
      "88927": true,
      "88928": true,
      "88929": true,
      "88930": true,
      "88931": true,
      "88932": true,
      "88933": true,
      "88934": true,
      "88935": true,
      "88936": true,
      "88937": true,
      "88938": true,
      "88939": true,
      "88940": true,
      "88941": true,
      "88942": true,
      "88943": true,
      "88944": true,
      "88945": true,
      "88946": true,
      "88947": true,
      "88948": true,
      "88949": true,
      "88950": true,
      "88951": true,
      "88952": true,
      "88953": true,
      "88954": true,
      "88955": true,
      "88956": true,
      "88957": true,
      "88958": true,
      "88959": true,
      "88960": true,
      "88961": true,
      "88962": true,
      "88963": true,
      "88964": true,
      "88965": true,
      "88966": true,
      "88967": true,
      "88968": true,
      "88969": true,
      "88970": true,
      "88971": true,
      "88972": true,
      "88973": true,
      "88974": true,
      "88975": true,
      "88976": true,
      "88977": true,
      "88978": true,
      "88979": true,
      "88980": true,
      "88981": true,
      "88982": true,
      "88983": true,
      "88984": true,
      "88985": true,
      "88986": true,
      "88987": true,
      "88988": true,
      "88989": true,
      "88990": true,
      "88991": true,
      "88992": true,
      "88993": true,
      "88994": true,
      "88995": true,
      "88996": true,
      "88997": true,
      "88998": true,
      "88999": true
    },
    "SAN FERNANDO": {
      "87600": true,
      "87601": true,
      "87602": true,
      "87603": true,
      "87604": true,
      "87605": true,
      "87606": true,
      "87607": true,
      "87608": true,
      "87609": true,
      "87610": true,
      "87611": true,
      "87616": true,
      "87619": true,
      "87620": true,
      "87621": true,
      "87625": true,
      "87628": true,
      "87629": true,
      "87630": true,
      "87631": true,
      "87632": true,
      "87633": true,
      "87634": true,
      "87635": true
    },
    "SOTO LA MARINA": {
      "87670": true,
      "87671": true,
      "87672": true,
      "87675": true,
      "87678": true,
      "87690": true,
      "87691": true,
      "87692": true,
      "87693": true
    },
    "TAMPICO": {
      "89000": true,
      "89001": true,
      "89002": true,
      "89003": true,
      "89004": true,
      "89005": true,
      "89006": true,
      "89007": true,
      "89008": true,
      "89009": true,
      "89010": true,
      "89011": true,
      "89012": true,
      "89013": true,
      "89014": true,
      "89015": true,
      "89016": true,
      "89017": true,
      "89018": true,
      "89019": true,
      "89020": true,
      "89021": true,
      "89022": true,
      "89023": true,
      "89024": true,
      "89025": true,
      "89026": true,
      "89027": true,
      "89028": true,
      "89029": true,
      "89030": true,
      "89031": true,
      "89032": true,
      "89033": true,
      "89034": true,
      "89035": true,
      "89036": true,
      "89037": true,
      "89038": true,
      "89039": true,
      "89040": true,
      "89041": true,
      "89042": true,
      "89043": true,
      "89044": true,
      "89045": true,
      "89046": true,
      "89047": true,
      "89048": true,
      "89049": true,
      "89050": true,
      "89051": true,
      "89052": true,
      "89053": true,
      "89054": true,
      "89055": true,
      "89056": true,
      "89057": true,
      "89058": true,
      "89059": true,
      "89060": true,
      "89061": true,
      "89062": true,
      "89063": true,
      "89064": true,
      "89065": true,
      "89066": true,
      "89067": true,
      "89068": true,
      "89069": true,
      "89070": true,
      "89071": true,
      "89072": true,
      "89073": true,
      "89074": true,
      "89075": true,
      "89076": true,
      "89077": true,
      "89078": true,
      "89079": true,
      "89080": true,
      "89081": true,
      "89082": true,
      "89083": true,
      "89084": true,
      "89085": true,
      "89086": true,
      "89087": true,
      "89088": true,
      "89089": true,
      "89090": true,
      "89091": true,
      "89092": true,
      "89093": true,
      "89094": true,
      "89095": true,
      "89096": true,
      "89097": true,
      "89098": true,
      "89099": true,
      "89100": true,
      "89101": true,
      "89102": true,
      "89103": true,
      "89104": true,
      "89105": true,
      "89106": true,
      "89107": true,
      "89108": true,
      "89109": true,
      "89110": true,
      "89111": true,
      "89112": true,
      "89113": true,
      "89114": true,
      "89115": true,
      "89116": true,
      "89117": true,
      "89118": true,
      "89119": true,
      "89120": true,
      "89121": true,
      "89122": true,
      "89123": true,
      "89124": true,
      "89125": true,
      "89126": true,
      "89127": true,
      "89128": true,
      "89129": true,
      "89130": true,
      "89131": true,
      "89132": true,
      "89133": true,
      "89134": true,
      "89135": true,
      "89136": true,
      "89137": true,
      "89138": true,
      "89139": true,
      "89140": true,
      "89141": true,
      "89142": true,
      "89143": true,
      "89144": true,
      "89145": true,
      "89146": true,
      "89147": true,
      "89148": true,
      "89149": true,
      "89150": true,
      "89151": true,
      "89152": true,
      "89153": true,
      "89154": true,
      "89155": true,
      "89156": true,
      "89157": true,
      "89158": true,
      "89159": true,
      "89160": true,
      "89161": true,
      "89162": true,
      "89163": true,
      "89164": true,
      "89165": true,
      "89166": true,
      "89167": true,
      "89168": true,
      "89169": true,
      "89170": true,
      "89171": true,
      "89172": true,
      "89173": true,
      "89174": true,
      "89175": true,
      "89176": true,
      "89177": true,
      "89178": true,
      "89179": true,
      "89180": true,
      "89181": true,
      "89182": true,
      "89183": true,
      "89184": true,
      "89185": true,
      "89186": true,
      "89187": true,
      "89188": true,
      "89189": true,
      "89190": true,
      "89191": true,
      "89192": true,
      "89193": true,
      "89194": true,
      "89195": true,
      "89196": true,
      "89197": true,
      "89198": true,
      "89199": true,
      "89200": true,
      "89201": true,
      "89202": true,
      "89203": true,
      "89204": true,
      "89205": true,
      "89206": true,
      "89207": true,
      "89208": true,
      "89209": true,
      "89210": true,
      "89211": true,
      "89212": true,
      "89213": true,
      "89214": true,
      "89215": true,
      "89216": true,
      "89217": true,
      "89218": true,
      "89219": true,
      "89220": true,
      "89221": true,
      "89222": true,
      "89223": true,
      "89224": true,
      "89225": true,
      "89226": true,
      "89227": true,
      "89228": true,
      "89229": true,
      "89230": true,
      "89231": true,
      "89232": true,
      "89233": true,
      "89234": true,
      "89235": true,
      "89236": true,
      "89237": true,
      "89238": true,
      "89239": true,
      "89240": true,
      "89241": true,
      "89242": true,
      "89243": true,
      "89244": true,
      "89245": true,
      "89246": true,
      "89247": true,
      "89248": true,
      "89249": true,
      "89250": true,
      "89251": true,
      "89252": true,
      "89253": true,
      "89254": true,
      "89255": true,
      "89256": true,
      "89257": true,
      "89258": true,
      "89259": true,
      "89260": true,
      "89261": true,
      "89262": true,
      "89263": true,
      "89264": true,
      "89265": true,
      "89266": true,
      "89267": true,
      "89268": true,
      "89269": true,
      "89270": true,
      "89271": true,
      "89272": true,
      "89273": true,
      "89274": true,
      "89275": true,
      "89276": true,
      "89277": true,
      "89278": true,
      "89279": true,
      "89280": true,
      "89281": true,
      "89282": true,
      "89283": true,
      "89284": true,
      "89285": true,
      "89286": true,
      "89287": true,
      "89288": true,
      "89289": true,
      "89290": true,
      "89291": true,
      "89292": true,
      "89293": true,
      "89294": true,
      "89295": true,
      "89296": true,
      "89297": true,
      "89298": true,
      "89299": true,
      "89300": true,
      "89301": true,
      "89302": true,
      "89303": true,
      "89304": true,
      "89305": true,
      "89306": true,
      "89307": true,
      "89308": true,
      "89309": true,
      "89310": true,
      "89311": true,
      "89312": true,
      "89313": true,
      "89314": true,
      "89315": true,
      "89316": true,
      "89317": true,
      "89318": true,
      "89319": true,
      "89320": true,
      "89321": true,
      "89322": true,
      "89323": true,
      "89324": true,
      "89325": true,
      "89326": true,
      "89327": true,
      "89328": true,
      "89329": true,
      "89330": true,
      "89331": true,
      "89332": true,
      "89333": true,
      "89334": true,
      "89335": true,
      "89336": true,
      "89337": true,
      "89338": true,
      "89339": true,
      "89340": true,
      "89341": true,
      "89342": true,
      "89343": true,
      "89344": true,
      "89345": true,
      "89346": true,
      "89347": true,
      "89348": true,
      "89349": true,
      "89350": true,
      "89351": true,
      "89352": true,
      "89353": true,
      "89354": true,
      "89355": true,
      "89356": true,
      "89357": true,
      "89358": true,
      "89359": true,
      "89360": true,
      "89361": true,
      "89362": true,
      "89363": true,
      "89364": true,
      "89365": true,
      "89366": true,
      "89367": true,
      "89368": true,
      "89369": true,
      "89370": true,
      "89371": true,
      "89372": true,
      "89373": true,
      "89374": true,
      "89375": true,
      "89376": true,
      "89377": true,
      "89378": true,
      "89379": true,
      "89380": true,
      "89381": true,
      "89382": true,
      "89383": true,
      "89384": true,
      "89385": true,
      "89386": true,
      "89387": true,
      "89388": true,
      "89389": true,
      "89390": true,
      "89391": true,
      "89392": true,
      "89393": true,
      "89394": true,
      "89395": true,
      "89396": true,
      "89397": true,
      "89398": true,
      "89399": true
    },
    "TULA": {
      "87900": true,
      "87901": true,
      "87902": true,
      "87904": true,
      "87906": true,
      "87907": true,
      "87908": true,
      "87909": true,
      "87911": true,
      "87912": true,
      "87913": true,
      "87914": true,
      "87915": true,
      "87916": true,
      "87917": true,
      "87918": true,
      "87919": true,
      "87920": true,
      "87921": true,
      "87928": true,
      "87929": true
    },
    "VALLE HERMOSO": {
      "87500": true
    },
    "VICTORIA": {
      "87000": true,
      "87001": true,
      "87002": true,
      "87003": true,
      "87004": true,
      "87005": true,
      "87006": true,
      "87007": true,
      "87008": true,
      "87009": true,
      "87010": true,
      "87011": true,
      "87012": true,
      "87013": true,
      "87014": true,
      "87015": true,
      "87016": true,
      "87017": true,
      "87018": true,
      "87019": true,
      "87020": true,
      "87021": true,
      "87022": true,
      "87023": true,
      "87024": true,
      "87025": true,
      "87026": true,
      "87027": true,
      "87028": true,
      "87029": true,
      "87030": true,
      "87031": true,
      "87032": true,
      "87033": true,
      "87034": true,
      "87035": true,
      "87036": true,
      "87037": true,
      "87038": true,
      "87039": true,
      "87040": true,
      "87041": true,
      "87042": true,
      "87043": true,
      "87044": true,
      "87045": true,
      "87046": true,
      "87047": true,
      "87048": true,
      "87049": true,
      "87050": true,
      "87051": true,
      "87052": true,
      "87053": true,
      "87054": true,
      "87055": true,
      "87056": true,
      "87057": true,
      "87058": true,
      "87059": true,
      "87060": true,
      "87061": true,
      "87062": true,
      "87063": true,
      "87064": true,
      "87065": true,
      "87066": true,
      "87067": true,
      "87068": true,
      "87069": true,
      "87070": true,
      "87071": true,
      "87072": true,
      "87073": true,
      "87074": true,
      "87075": true,
      "87076": true,
      "87077": true,
      "87078": true,
      "87079": true,
      "87080": true,
      "87081": true,
      "87082": true,
      "87083": true,
      "87084": true,
      "87085": true,
      "87086": true,
      "87087": true,
      "87088": true,
      "87089": true,
      "87090": true,
      "87091": true,
      "87092": true,
      "87093": true,
      "87094": true,
      "87095": true,
      "87096": true,
      "87097": true,
      "87098": true,
      "87099": true,
      "87100": true,
      "87101": true,
      "87102": true,
      "87103": true,
      "87104": true,
      "87105": true,
      "87106": true,
      "87107": true,
      "87108": true,
      "87109": true,
      "87110": true,
      "87111": true,
      "87112": true,
      "87113": true,
      "87114": true,
      "87115": true,
      "87116": true,
      "87117": true,
      "87118": true,
      "87119": true,
      "87120": true,
      "87121": true,
      "87122": true,
      "87123": true,
      "87124": true,
      "87125": true,
      "87126": true,
      "87127": true,
      "87128": true,
      "87129": true,
      "87130": true,
      "87131": true,
      "87132": true,
      "87133": true,
      "87134": true,
      "87135": true,
      "87136": true,
      "87137": true,
      "87138": true,
      "87139": true,
      "87140": true,
      "87141": true,
      "87142": true,
      "87143": true,
      "87144": true,
      "87145": true,
      "87146": true,
      "87147": true,
      "87148": true,
      "87149": true,
      "87150": true,
      "87151": true,
      "87152": true,
      "87153": true,
      "87154": true,
      "87155": true,
      "87156": true,
      "87157": true,
      "87158": true,
      "87159": true,
      "87160": true,
      "87161": true,
      "87162": true,
      "87163": true,
      "87164": true,
      "87165": true,
      "87166": true,
      "87167": true,
      "87168": true,
      "87169": true,
      "87170": true,
      "87171": true,
      "87172": true,
      "87173": true,
      "87174": true,
      "87175": true,
      "87176": true,
      "87177": true,
      "87178": true,
      "87179": true,
      "87180": true,
      "87181": true,
      "87182": true,
      "87183": true,
      "87184": true,
      "87185": true,
      "87186": true,
      "87187": true,
      "87188": true,
      "87189": true,
      "87190": true,
      "87191": true,
      "87192": true,
      "87193": true,
      "87194": true,
      "87195": true,
      "87196": true,
      "87197": true,
      "87198": true,
      "87199": true,
      "87260": true,
      "87261": true,
      "87262": true,
      "87263": true,
      "87264": true,
      "87265": true,
      "87266": true,
      "87267": true,
      "87268": true,
      "87269": true,
      "87270": true,
      "87271": true,
      "87272": true,
      "87273": true,
      "87274": true,
      "87275": true,
      "87276": true,
      "87277": true,
      "87278": true,
      "87279": true,
      "87280": true,
      "87281": true,
      "87282": true,
      "87283": true,
      "87284": true,
      "87285": true,
      "87286": true,
      "87287": true,
      "87288": true,
      "87289": true,
      "87290": true,
      "87291": true,
      "87292": true,
      "87293": true,
      "87294": true,
      "87295": true,
      "87296": true,
      "87297": true,
      "87298": true,
      "87299": true
    },
    "XICOTENCATL": {
      "89750": true,
      "89751": true,
      "89752": true,
      "89753": true,
      "89754": true,
      "89755": true,
      "89756": true,
      "89757": true,
      "89758": true,
      "89759": true,
      "89760": true,
      "89761": true,
      "89762": true,
      "89763": true,
      "89764": true,
      "89765": true,
      "89766": true,
      "89774": true,
      "89775": true,
      "89776": true,
      "89777": true
    }
  },
  "TLAXCALA": {
    "ACUAMANALA DE MIGUEL HIDALGO": {
      "90860": true,
      "90861": true,
      "90862": true,
      "90863": true,
      "90864": true,
      "90865": true,
      "90866": true
    },
    "AMAXAC DE GUERRERO": {
      "90620": true,
      "90621": true,
      "90622": true,
      "90623": true,
      "90624": true,
      "90625": true,
      "90626": true,
      "90627": true,
      "90628": true,
      "90629": true,
      "90630": true,
      "90631": true,
      "90632": true,
      "90633": true,
      "90634": true,
      "90635": true,
      "90636": true,
      "90637": true,
      "90638": true,
      "90639": true
    },
    "APETATITLAN DE ANTONIO CARVAJAL": {
      "90600": true,
      "90601": true,
      "90602": true,
      "90603": true,
      "90604": true,
      "90605": true,
      "90606": true,
      "90607": true,
      "90608": true,
      "90609": true,
      "90610": true,
      "90611": true,
      "90612": true,
      "90613": true,
      "90614": true,
      "90615": true,
      "90616": true,
      "90617": true,
      "90618": true,
      "90619": true
    },
    "APIZACO": {
      "90300": true,
      "90301": true,
      "90302": true,
      "90303": true,
      "90304": true,
      "90305": true,
      "90306": true,
      "90307": true,
      "90308": true,
      "90309": true,
      "90310": true,
      "90311": true,
      "90312": true,
      "90313": true,
      "90314": true,
      "90315": true,
      "90316": true,
      "90317": true,
      "90318": true,
      "90319": true,
      "90320": true,
      "90321": true,
      "90322": true,
      "90323": true,
      "90324": true,
      "90325": true,
      "90326": true,
      "90327": true,
      "90328": true,
      "90329": true,
      "90330": true,
      "90331": true,
      "90332": true,
      "90333": true,
      "90334": true,
      "90335": true,
      "90336": true,
      "90337": true,
      "90338": true,
      "90339": true,
      "90340": true,
      "90341": true,
      "90342": true,
      "90343": true,
      "90344": true,
      "90345": true,
      "90346": true,
      "90347": true,
      "90348": true,
      "90349": true,
      "90350": true,
      "90351": true,
      "90352": true,
      "90353": true,
      "90354": true,
      "90355": true,
      "90356": true,
      "90357": true,
      "90358": true,
      "90359": true,
      "90360": true,
      "90361": true,
      "90362": true,
      "90363": true,
      "90364": true,
      "90365": true,
      "90366": true,
      "90367": true,
      "90368": true,
      "90369": true,
      "90370": true,
      "90371": true,
      "90372": true,
      "90373": true,
      "90374": true,
      "90375": true,
      "90376": true,
      "90377": true,
      "90378": true,
      "90379": true,
      "90380": true,
      "90381": true,
      "90382": true,
      "90383": true,
      "90384": true,
      "90385": true,
      "90386": true,
      "90387": true,
      "90388": true,
      "90389": true,
      "90390": true,
      "90391": true,
      "90392": true,
      "90393": true,
      "90394": true,
      "90395": true,
      "90396": true,
      "90397": true,
      "90398": true,
      "90399": true,
      "90400": true,
      "90401": true,
      "90402": true,
      "90403": true,
      "90404": true,
      "90405": true,
      "90406": true,
      "90407": true,
      "90408": true,
      "90409": true
    },
    "ATLTZAYANCA": {
      "90550": true,
      "90551": true,
      "90552": true,
      "90553": true,
      "90554": true,
      "90555": true,
      "90556": true,
      "90557": true,
      "90558": true,
      "90559": true
    },
    "CHIAUTEMPAN": {
      "90800": true,
      "90801": true,
      "90802": true,
      "90803": true,
      "90804": true,
      "90805": true,
      "90806": true,
      "90807": true,
      "90808": true,
      "90809": true,
      "90810": true,
      "90811": true,
      "90812": true,
      "90813": true,
      "90814": true,
      "90815": true,
      "90816": true,
      "90817": true,
      "90818": true,
      "90819": true,
      "90820": true,
      "90821": true,
      "90822": true,
      "90823": true,
      "90824": true,
      "90825": true,
      "90826": true,
      "90827": true,
      "90828": true,
      "90829": true
    },
    "CONTLA DE JUAN CUAMATZI": {
      "90670": true,
      "90671": true,
      "90672": true,
      "90673": true,
      "90674": true,
      "90675": true,
      "90676": true,
      "90677": true,
      "90678": true,
      "90679": true,
      "90680": true,
      "90681": true,
      "90682": true,
      "90683": true,
      "90684": true,
      "90685": true,
      "90686": true,
      "90687": true,
      "90688": true,
      "90689": true,
      "90690": true,
      "90691": true,
      "90692": true,
      "90693": true,
      "90694": true,
      "90695": true,
      "90696": true,
      "90697": true,
      "90698": true,
      "90699": true
    },
    "CUAPIAXTLA": {
      "90560": true,
      "90561": true,
      "90562": true,
      "90563": true,
      "90564": true,
      "90565": true,
      "90566": true,
      "90567": true,
      "90568": true,
      "90569": true
    },
    "EL CARMEN TEQUEXQUITLA": {
      "90570": true,
      "90571": true,
      "90572": true,
      "90573": true,
      "90574": true,
      "90575": true,
      "90576": true,
      "90577": true,
      "90578": true,
      "90579": true
    },
    "EMILIANO ZAPATA": {
      "90547": true,
      "90548": true,
      "90549": true
    },
    "ESPANITA": {
      "90290": true,
      "90291": true,
      "90292": true,
      "90293": true,
      "90294": true,
      "90295": true,
      "90296": true,
      "90297": true,
      "90298": true,
      "90299": true
    },
    "HUAMANTLA": {
      "90500": true,
      "90501": true,
      "90502": true,
      "90503": true,
      "90504": true,
      "90505": true,
      "90506": true,
      "90507": true,
      "90508": true,
      "90509": true,
      "90510": true,
      "90511": true,
      "90512": true,
      "90514": true,
      "90515": true,
      "90516": true,
      "90517": true,
      "90518": true,
      "90519": true,
      "90520": true,
      "90521": true,
      "90522": true,
      "90523": true,
      "90524": true,
      "90525": true,
      "90527": true,
      "90528": true,
      "90529": true,
      "90530": true,
      "90531": true,
      "90532": true,
      "90533": true,
      "90534": true,
      "90535": true,
      "90536": true,
      "90537": true,
      "90538": true,
      "90539": true
    },
    "IXTACUIXTLA DE MARIANO MATAMOROS": {
      "90120": true,
      "90121": true,
      "90122": true,
      "90123": true,
      "90124": true,
      "90125": true,
      "90126": true,
      "90127": true,
      "90128": true,
      "90129": true,
      "90130": true,
      "90131": true,
      "90132": true,
      "90133": true,
      "90134": true
    },
    "IXTENCO": {
      "90580": true,
      "90581": true,
      "90582": true,
      "90583": true,
      "90584": true,
      "90585": true,
      "90586": true,
      "90587": true,
      "90588": true,
      "90589": true
    },
    "LA MAGDALENA TLALTELULCO": {
      "90830": true,
      "90831": true,
      "90832": true,
      "90833": true,
      "90834": true,
      "90835": true,
      "90836": true,
      "90837": true,
      "90838": true,
      "90839": true,
      "90840": true,
      "90841": true,
      "90842": true
    },
    "LAZARO CARDENAS": {
      "90545": true,
      "90546": true
    },
    "MAZATECOCHCO DE JOSE MARIA MORELOS": {
      "90870": true,
      "90871": true,
      "90872": true,
      "90873": true,
      "90874": true,
      "90875": true,
      "90876": true,
      "90877": true,
      "90878": true,
      "90879": true
    },
    "MUNOZ DE DOMINGO ARENAS": {
      "90420": true,
      "90421": true,
      "90422": true,
      "90423": true,
      "90424": true,
      "90425": true,
      "90426": true,
      "90427": true,
      "90428": true,
      "90429": true
    },
    "NANACAMILPA DE MARIANO ARISTA": {
      "90280": true,
      "90281": true,
      "90282": true,
      "90283": true,
      "90284": true,
      "90285": true,
      "90286": true,
      "90287": true,
      "90288": true,
      "90289": true
    },
    "NATIVITAS": {
      "90710": true,
      "90711": true,
      "90712": true,
      "90713": true,
      "90714": true,
      "90715": true,
      "90716": true,
      "90717": true,
      "90718": true,
      "90719": true,
      "90720": true,
      "90721": true,
      "90722": true,
      "90723": true,
      "90724": true
    },
    "PANOTLA": {
      "90140": true,
      "90141": true,
      "90142": true,
      "90143": true,
      "90144": true,
      "90145": true,
      "90146": true,
      "90147": true,
      "90148": true,
      "90149": true,
      "90150": true,
      "90151": true,
      "90152": true,
      "90153": true,
      "90154": true,
      "90155": true,
      "90156": true,
      "90157": true,
      "90158": true,
      "90159": true
    },
    "PAPALOTLA DE XICOHTENCATL": {
      "90790": true,
      "90791": true,
      "90792": true,
      "90793": true,
      "90794": true,
      "90795": true,
      "90796": true,
      "90797": true,
      "90798": true,
      "90799": true
    },
    "SAN DAMIAN TEXOLOC": {
      "90735": true,
      "90736": true,
      "90737": true
    },
    "SAN FRANCISCO TETLANOHCAN": {
      "90843": true,
      "90844": true,
      "90845": true,
      "90846": true,
      "90847": true,
      "90848": true,
      "90849": true
    },
    "SAN JERONIMO ZACUALPAN": {
      "90738": true,
      "90739": true
    },
    "SAN JOSE TEACALCO": {
      "90495": true,
      "90496": true,
      "90497": true,
      "90498": true,
      "90499": true
    },
    "SAN JUAN HUACTZINCO": {
      "90195": true,
      "90196": true,
      "90197": true,
      "90198": true,
      "90199": true
    },
    "SAN LORENZO AXOCOMANITLA": {
      "90760": true,
      "90761": true,
      "90762": true,
      "90763": true,
      "90764": true,
      "90765": true,
      "90766": true,
      "90767": true,
      "90768": true,
      "90769": true
    },
    "SAN PABLO DEL MONTE": {
      "90890": true,
      "90891": true,
      "90892": true,
      "90893": true,
      "90894": true,
      "90895": true,
      "90896": true,
      "90897": true,
      "90898": true,
      "90899": true,
      "90900": true,
      "90901": true,
      "90902": true,
      "90903": true,
      "90904": true,
      "90905": true,
      "90906": true,
      "90907": true,
      "90908": true,
      "90909": true,
      "90910": true,
      "90911": true,
      "90912": true,
      "90913": true,
      "90914": true,
      "90915": true,
      "90916": true,
      "90917": true,
      "90918": true,
      "90919": true,
      "90920": true,
      "90921": true,
      "90922": true,
      "90923": true,
      "90924": true,
      "90925": true,
      "90926": true,
      "90927": true,
      "90928": true,
      "90929": true,
      "90930": true,
      "90931": true,
      "90932": true,
      "90933": true,
      "90934": true,
      "90935": true,
      "90936": true,
      "90937": true,
      "90938": true,
      "90939": true,
      "90940": true,
      "90941": true,
      "90942": true,
      "90943": true,
      "90944": true,
      "90945": true,
      "90946": true,
      "90947": true,
      "90948": true,
      "90949": true,
      "90950": true,
      "90951": true,
      "90952": true,
      "90953": true,
      "90954": true,
      "90955": true,
      "90956": true,
      "90957": true,
      "90958": true,
      "90959": true,
      "90960": true,
      "90961": true,
      "90962": true,
      "90963": true,
      "90964": true,
      "90965": true,
      "90966": true,
      "90967": true,
      "90968": true,
      "90969": true,
      "90970": true,
      "90971": true,
      "90972": true,
      "90973": true,
      "90974": true,
      "90975": true,
      "90976": true,
      "90977": true,
      "90978": true,
      "90979": true,
      "90980": true,
      "90981": true,
      "90982": true,
      "90983": true,
      "90984": true,
      "90985": true,
      "90986": true,
      "90987": true,
      "90988": true,
      "90989": true,
      "90990": true,
      "90991": true,
      "90992": true,
      "90993": true,
      "90994": true,
      "90995": true,
      "90996": true,
      "90997": true,
      "90998": true,
      "90999": true
    },
    "SANCTORUM DE LAZARO CARDENAS": {
      "90230": true,
      "90231": true,
      "90232": true,
      "90233": true,
      "90234": true
    },
    "SANTA ANA NOPALUCAN": {
      "90135": true,
      "90136": true,
      "90137": true,
      "90138": true,
      "90139": true
    },
    "SANTA APOLONIA TEACALCO": {
      "90725": true,
      "90726": true,
      "90727": true,
      "90728": true,
      "90729": true
    },
    "SANTA CRUZ QUILEHTLA": {
      "90867": true,
      "90868": true,
      "90869": true
    },
    "SANTA CRUZ TLAXCALA": {
      "90640": true,
      "90641": true,
      "90642": true,
      "90643": true,
      "90644": true,
      "90645": true,
      "90646": true,
      "90647": true,
      "90648": true,
      "90649": true,
      "90650": true,
      "90651": true,
      "90652": true,
      "90653": true,
      "90654": true,
      "90655": true,
      "90656": true,
      "90657": true,
      "90658": true,
      "90659": true
    },
    "SANTA ISABEL XILOXOXTLA": {
      "90193": true,
      "90194": true
    },
    "TENANCINGO": {
      "90880": true,
      "90881": true,
      "90882": true,
      "90883": true,
      "90884": true,
      "90885": true,
      "90886": true,
      "90887": true,
      "90888": true,
      "90889": true
    },
    "TEOLOCHOLCO": {
      "90850": true,
      "90851": true,
      "90852": true,
      "90853": true,
      "90854": true,
      "90855": true,
      "90856": true,
      "90857": true,
      "90858": true,
      "90859": true
    },
    "TEPETITLA DE LARDIZABAL": {
      "90700": true,
      "90701": true,
      "90702": true,
      "90703": true,
      "90704": true,
      "90705": true,
      "90706": true,
      "90707": true,
      "90708": true,
      "90709": true
    },
    "TEPEYANCO": {
      "90180": true,
      "90181": true,
      "90182": true,
      "90183": true,
      "90184": true,
      "90185": true,
      "90186": true,
      "90187": true,
      "90188": true,
      "90189": true,
      "90190": true,
      "90191": true,
      "90192": true
    },
    "TERRENATE": {
      "90540": true,
      "90541": true,
      "90542": true,
      "90543": true,
      "90544": true
    },
    "TETLA DE LA SOLIDARIDAD": {
      "90430": true,
      "90431": true,
      "90432": true,
      "90433": true,
      "90434": true,
      "90435": true,
      "90436": true,
      "90437": true,
      "90438": true,
      "90439": true
    },
    "TETLATLAHUCA": {
      "90730": true,
      "90731": true,
      "90732": true,
      "90733": true,
      "90734": true
    },
    "TLAXCALA": {
      "90000": true,
      "90001": true,
      "90002": true,
      "90003": true,
      "90004": true,
      "90005": true,
      "90006": true,
      "90007": true,
      "90008": true,
      "90009": true,
      "90010": true,
      "90011": true,
      "90012": true,
      "90013": true,
      "90014": true,
      "90015": true,
      "90016": true,
      "90017": true,
      "90018": true,
      "90019": true,
      "90020": true,
      "90021": true,
      "90022": true,
      "90023": true,
      "90024": true,
      "90025": true,
      "90026": true,
      "90027": true,
      "90028": true,
      "90029": true,
      "90030": true,
      "90031": true,
      "90032": true,
      "90033": true,
      "90034": true,
      "90035": true,
      "90036": true,
      "90037": true,
      "90038": true,
      "90039": true,
      "90040": true,
      "90041": true,
      "90042": true,
      "90043": true,
      "90044": true,
      "90045": true,
      "90046": true,
      "90047": true,
      "90048": true,
      "90049": true,
      "90050": true,
      "90051": true,
      "90052": true,
      "90053": true,
      "90054": true,
      "90055": true,
      "90056": true,
      "90057": true,
      "90058": true,
      "90059": true,
      "90060": true,
      "90061": true,
      "90062": true,
      "90063": true,
      "90064": true,
      "90065": true,
      "90066": true,
      "90067": true,
      "90068": true,
      "90069": true,
      "90070": true,
      "90071": true,
      "90072": true,
      "90073": true,
      "90074": true,
      "90075": true,
      "90076": true,
      "90077": true,
      "90078": true,
      "90079": true,
      "90080": true,
      "90081": true,
      "90082": true,
      "90083": true,
      "90084": true,
      "90085": true,
      "90086": true,
      "90087": true,
      "90088": true,
      "90089": true,
      "90090": true,
      "90091": true,
      "90092": true,
      "90093": true,
      "90094": true,
      "90095": true,
      "90096": true,
      "90097": true,
      "90098": true,
      "90099": true,
      "90100": true,
      "90101": true,
      "90102": true,
      "90103": true,
      "90104": true,
      "90105": true,
      "90106": true,
      "90107": true,
      "90108": true,
      "90109": true,
      "90110": true,
      "90111": true,
      "90112": true,
      "90113": true,
      "90114": true,
      "90115": true,
      "90116": true,
      "90117": true,
      "90118": true,
      "90119": true
    },
    "TOCATLAN": {
      "90480": true,
      "90481": true,
      "90482": true,
      "90483": true,
      "90484": true,
      "90485": true,
      "90486": true,
      "90487": true,
      "90488": true,
      "90489": true
    },
    "TOTOLAC": {
      "90160": true,
      "90161": true,
      "90162": true,
      "90163": true,
      "90164": true,
      "90165": true,
      "90166": true,
      "90167": true,
      "90168": true,
      "90169": true,
      "90170": true,
      "90171": true,
      "90172": true,
      "90173": true,
      "90174": true,
      "90175": true,
      "90176": true,
      "90177": true,
      "90178": true,
      "90179": true
    },
    "TZOMPANTEPEC": {
      "90490": true,
      "90491": true,
      "90492": true,
      "90493": true,
      "90494": true
    },
    "XALOZTOC": {
      "90460": true,
      "90461": true,
      "90462": true,
      "90463": true,
      "90464": true,
      "90465": true,
      "90466": true,
      "90467": true,
      "90468": true,
      "90469": true,
      "90470": true,
      "90471": true,
      "90472": true,
      "90473": true,
      "90474": true,
      "90475": true,
      "90476": true,
      "90477": true,
      "90478": true,
      "90479": true
    },
    "XALTOCAN": {
      "90440": true,
      "90441": true,
      "90442": true,
      "90443": true,
      "90444": true
    },
    "XICOHTZINCO": {
      "90780": true,
      "90781": true,
      "90782": true,
      "90783": true,
      "90784": true,
      "90785": true,
      "90786": true,
      "90787": true,
      "90788": true,
      "90789": true
    },
    "YAUHQUEMEHCAN": {
      "90450": true,
      "90451": true,
      "90452": true,
      "90453": true,
      "90454": true,
      "90455": true,
      "90456": true,
      "90457": true,
      "90458": true,
      "90459": true
    },
    "ZACATELCO": {
      "90740": true,
      "90741": true,
      "90742": true,
      "90743": true,
      "90744": true,
      "90745": true,
      "90746": true,
      "90747": true,
      "90748": true,
      "90749": true,
      "90750": true,
      "90751": true,
      "90752": true,
      "90753": true,
      "90754": true,
      "90755": true,
      "90756": true,
      "90757": true,
      "90758": true,
      "90759": true
    },
    "ZILTLALTEPEC DE TRINIDAD SANCHEZ SANTOS": {
      "90590": true,
      "90591": true,
      "90592": true,
      "90593": true,
      "90594": true,
      "90595": true,
      "90596": true,
      "90597": true,
      "90598": true,
      "90599": true
    }
  },
  "VERACRUZ": {
    "ACAYUCAN": {
      "96000": true,
      "96001": true,
      "96002": true,
      "96003": true,
      "96004": true,
      "96005": true,
      "96006": true,
      "96007": true,
      "96008": true,
      "96009": true,
      "96010": true,
      "96011": true,
      "96012": true,
      "96013": true,
      "96014": true,
      "96015": true,
      "96016": true,
      "96017": true,
      "96018": true,
      "96019": true,
      "96020": true,
      "96021": true,
      "96022": true,
      "96023": true,
      "96024": true,
      "96025": true,
      "96026": true,
      "96027": true,
      "96028": true,
      "96029": true,
      "96030": true,
      "96031": true,
      "96032": true,
      "96033": true,
      "96034": true,
      "96035": true,
      "96036": true,
      "96037": true,
      "96038": true,
      "96039": true,
      "96040": true,
      "96041": true,
      "96042": true,
      "96043": true,
      "96044": true,
      "96045": true,
      "96046": true,
      "96047": true,
      "96048": true,
      "96049": true,
      "96050": true,
      "96051": true,
      "96052": true,
      "96053": true,
      "96054": true,
      "96055": true,
      "96056": true,
      "96057": true,
      "96058": true,
      "96059": true,
      "96060": true,
      "96061": true,
      "96062": true,
      "96063": true,
      "96064": true,
      "96065": true,
      "96066": true,
      "96067": true,
      "96068": true,
      "96069": true,
      "96070": true,
      "96071": true,
      "96072": true,
      "96073": true,
      "96074": true,
      "96075": true,
      "96076": true,
      "96077": true,
      "96078": true,
      "96079": true,
      "96080": true,
      "96081": true,
      "96082": true,
      "96083": true,
      "96084": true,
      "96085": true,
      "96086": true,
      "96087": true,
      "96088": true,
      "96089": true,
      "96090": true,
      "96091": true,
      "96092": true,
      "96093": true,
      "96094": true,
      "96095": true,
      "96096": true,
      "96097": true,
      "96098": true,
      "96099": true,
      "96100": true,
      "96101": true,
      "96103": true,
      "96104": true,
      "96107": true,
      "96108": true,
      "96109": true,
      "96112": true,
      "96113": true
    },
    "AGUA DULCE": {
      "96390": true,
      "96391": true,
      "96392": true,
      "96393": true,
      "96394": true,
      "96395": true,
      "96396": true,
      "96397": true,
      "96398": true,
      "96399": true,
      "96600": true,
      "96601": true,
      "96602": true,
      "96603": true,
      "96604": true,
      "96605": true,
      "96606": true,
      "96607": true,
      "96608": true,
      "96609": true,
      "96610": true,
      "96611": true,
      "96612": true,
      "96613": true,
      "96614": true,
      "96615": true,
      "96616": true,
      "96617": true,
      "96618": true,
      "96619": true,
      "96620": true,
      "96621": true,
      "96622": true,
      "96623": true,
      "96624": true,
      "96625": true,
      "96626": true,
      "96627": true,
      "96628": true,
      "96629": true,
      "96630": true,
      "96631": true,
      "96632": true,
      "96633": true,
      "96634": true,
      "96635": true,
      "96636": true,
      "96637": true,
      "96638": true,
      "96639": true,
      "96640": true,
      "96641": true,
      "96642": true,
      "96643": true,
      "96644": true,
      "96645": true,
      "96646": true,
      "96647": true,
      "96648": true,
      "96649": true,
      "96650": true,
      "96651": true,
      "96652": true,
      "96653": true,
      "96654": true,
      "96655": true,
      "96656": true,
      "96657": true,
      "96658": true,
      "96659": true,
      "96660": true,
      "96661": true,
      "96662": true,
      "96663": true,
      "96664": true,
      "96665": true,
      "96666": true,
      "96667": true,
      "96668": true,
      "96669": true,
      "96670": true,
      "96671": true,
      "96672": true,
      "96673": true,
      "96674": true,
      "96675": true,
      "96676": true,
      "96677": true,
      "96678": true,
      "96679": true,
      "96680": true,
      "96681": true,
      "96682": true,
      "96683": true,
      "96684": true,
      "96685": true,
      "96686": true,
      "96687": true,
      "96688": true,
      "96689": true,
      "96690": true,
      "96691": true,
      "96692": true,
      "96693": true,
      "96694": true,
      "96695": true,
      "96696": true,
      "96697": true,
      "96698": true,
      "96699": true
    },
    "ALAMO TEMAPACHE": {
      "92730": true,
      "92731": true,
      "92732": true,
      "92733": true,
      "92734": true,
      "92735": true,
      "92736": true,
      "92737": true,
      "92738": true,
      "92739": true,
      "92740": true,
      "92741": true,
      "92742": true,
      "92743": true,
      "92744": true,
      "92745": true,
      "92750": true,
      "92751": true,
      "92755": true,
      "92760": true,
      "92761": true,
      "92762": true,
      "92763": true,
      "92764": true,
      "92765": true,
      "92766": true,
      "92767": true,
      "92768": true
    },
    "ALTOTONGA": {
      "93700": true,
      "93701": true,
      "93702": true,
      "93703": true,
      "93704": true,
      "93705": true,
      "93706": true,
      "93707": true,
      "93708": true,
      "93709": true,
      "93710": true,
      "93711": true,
      "93712": true,
      "93713": true,
      "93720": true,
      "93721": true,
      "93722": true,
      "93723": true,
      "93724": true,
      "93725": true,
      "93726": true,
      "93727": true,
      "93728": true,
      "93729": true,
      "93730": true,
      "93731": true,
      "93732": true,
      "93733": true,
      "93734": true,
      "93735": true,
      "93736": true,
      "93737": true,
      "93738": true,
      "93739": true
    },
    "ALVARADO": {
      "95259": true,
      "95260": true,
      "95261": true,
      "95262": true,
      "95263": true,
      "95264": true,
      "95266": true,
      "95267": true,
      "95269": true,
      "95270": true,
      "95271": true,
      "95272": true,
      "95273": true,
      "95275": true,
      "95276": true,
      "95277": true,
      "95278": true,
      "95279": true
    },
    "ATZALAN": {
      "93680": true
    },
    "BANDERILLA": {
      "91300": true,
      "91301": true,
      "91302": true,
      "91303": true,
      "91304": true,
      "91305": true,
      "91306": true,
      "91307": true,
      "91308": true,
      "91309": true,
      "91310": true,
      "91311": true,
      "91312": true,
      "91313": true,
      "91314": true
    },
    "BOCA DEL RÍO": {
      "94285": true,
      "94286": true,
      "94287": true,
      "94288": true,
      "94289": true,
      "94290": true,
      "94291": true,
      "94292": true,
      "94293": true,
      "94294": true,
      "94295": true,
      "94296": true,
      "94297": true,
      "94298": true,
      "94299": true
    },
    "CAMERINO Z. MENDOZA": {
      "94740": true,
      "94741": true,
      "94742": true,
      "94743": true,
      "94744": true,
      "94745": true,
      "94746": true,
      "94747": true,
      "94748": true,
      "94749": true
    },
    "CAZONES DE HERRERA": {
      "92970": true,
      "92971": true,
      "92972": true,
      "92973": true,
      "92974": true,
      "92975": true,
      "92976": true,
      "92977": true,
      "92978": true,
      "92979": true,
      "92980": true,
      "92981": true,
      "92982": true,
      "92983": true,
      "92984": true,
      "92985": true,
      "92986": true,
      "92987": true,
      "92988": true,
      "92989": true,
      "92990": true,
      "92991": true,
      "92992": true,
      "92993": true,
      "92994": true,
      "92995": true,
      "92996": true,
      "92997": true,
      "92998": true,
      "92999": true
    },
    "CERRO AZUL": {
      "92500": true,
      "92501": true,
      "92502": true,
      "92503": true,
      "92504": true,
      "92505": true,
      "92506": true,
      "92507": true,
      "92508": true,
      "92509": true,
      "92510": true,
      "92511": true,
      "92512": true,
      "92513": true,
      "92514": true,
      "92515": true,
      "92516": true,
      "92517": true,
      "92518": true,
      "92519": true,
      "92520": true,
      "92521": true,
      "92522": true,
      "92523": true,
      "92524": true,
      "92525": true,
      "92526": true,
      "92527": true,
      "92528": true,
      "92529": true
    },
    "CHICONTEPEC": {
      "92700": true
    },
    "CHINAMECA": {
      "95980": true,
      "95981": true,
      "95982": true,
      "95983": true,
      "95984": true,
      "95985": true,
      "95986": true,
      "95987": true,
      "95988": true,
      "95989": true,
      "95990": true,
      "95991": true,
      "95992": true,
      "95993": true,
      "95994": true,
      "95995": true,
      "95996": true,
      "95997": true,
      "95998": true,
      "95999": true
    },
    "CHONTLA": {
      "92210": true
    },
    "CHUMATLAN": {
      "93040": true,
      "93041": true,
      "93042": true,
      "93043": true,
      "93044": true,
      "93045": true,
      "93046": true,
      "93047": true,
      "93048": true,
      "93049": true,
      "93050": true,
      "93051": true,
      "93052": true,
      "93053": true,
      "93054": true,
      "93055": true,
      "93056": true,
      "93057": true,
      "93058": true,
      "93059": true
    },
    "COAHUITLAN": {
      "93120": true,
      "93121": true,
      "93122": true,
      "93123": true,
      "93124": true,
      "93125": true,
      "93126": true,
      "93127": true,
      "93128": true,
      "93129": true,
      "93130": true,
      "93131": true,
      "93132": true,
      "93133": true,
      "93134": true,
      "93135": true,
      "93136": true,
      "93137": true,
      "93138": true,
      "93139": true
    },
    "COATEPEC": {
      "91500": true,
      "91501": true,
      "91502": true,
      "91503": true,
      "91504": true,
      "91505": true,
      "91506": true,
      "91507": true,
      "91508": true,
      "91509": true,
      "91510": true,
      "91511": true,
      "91512": true,
      "91513": true,
      "91514": true,
      "91515": true,
      "91516": true,
      "91517": true,
      "91518": true,
      "91519": true,
      "91520": true,
      "91521": true,
      "91522": true,
      "91523": true,
      "91524": true,
      "91525": true,
      "91526": true,
      "91527": true,
      "91528": true,
      "91529": true,
      "91530": true,
      "91531": true,
      "91532": true,
      "91533": true,
      "91534": true,
      "91535": true,
      "91536": true,
      "91537": true,
      "91538": true,
      "91539": true,
      "91540": true,
      "91541": true,
      "91542": true,
      "91543": true,
      "91544": true,
      "91545": true,
      "91546": true,
      "91547": true,
      "91548": true,
      "91549": true,
      "91550": true,
      "91551": true,
      "91552": true,
      "91553": true,
      "91554": true,
      "91555": true,
      "91556": true,
      "91557": true,
      "91558": true,
      "91559": true,
      "91560": true,
      "91561": true,
      "91562": true,
      "91563": true,
      "91564": true,
      "91565": true,
      "91566": true,
      "91567": true,
      "91568": true,
      "91569": true,
      "91570": true,
      "91571": true,
      "91572": true,
      "91573": true,
      "91574": true,
      "91575": true,
      "91576": true,
      "91577": true,
      "91578": true,
      "91579": true,
      "91580": true,
      "91581": true,
      "91582": true,
      "91583": true,
      "91584": true,
      "91585": true,
      "91586": true,
      "91587": true,
      "91588": true,
      "91589": true,
      "91590": true,
      "91591": true,
      "91592": true,
      "91593": true,
      "91594": true,
      "91595": true,
      "91596": true,
      "91597": true,
      "91598": true,
      "91599": true,
      "91600": true,
      "91601": true,
      "91602": true,
      "91603": true,
      "91604": true,
      "91605": true,
      "91606": true,
      "91607": true,
      "91608": true,
      "91609": true,
      "91610": true,
      "91611": true,
      "91612": true,
      "91613": true,
      "91614": true
    },
    "COATZACOALCOS": {
      "96380": true,
      "96381": true,
      "96382": true,
      "96383": true,
      "96384": true,
      "96385": true,
      "96386": true,
      "96387": true,
      "96388": true,
      "96389": true,
      "96400": true,
      "96401": true,
      "96402": true,
      "96403": true,
      "96404": true,
      "96405": true,
      "96406": true,
      "96407": true,
      "96408": true,
      "96409": true,
      "96410": true,
      "96411": true,
      "96412": true,
      "96413": true,
      "96414": true,
      "96415": true,
      "96416": true,
      "96417": true,
      "96418": true,
      "96419": true,
      "96420": true,
      "96421": true,
      "96422": true,
      "96423": true,
      "96424": true,
      "96425": true,
      "96426": true,
      "96427": true,
      "96428": true,
      "96429": true,
      "96430": true,
      "96431": true,
      "96432": true,
      "96433": true,
      "96434": true,
      "96435": true,
      "96436": true,
      "96437": true,
      "96438": true,
      "96439": true,
      "96440": true,
      "96441": true,
      "96442": true,
      "96443": true,
      "96444": true,
      "96445": true,
      "96446": true,
      "96447": true,
      "96448": true,
      "96449": true,
      "96450": true,
      "96451": true,
      "96452": true,
      "96453": true,
      "96454": true,
      "96455": true,
      "96456": true,
      "96457": true,
      "96458": true,
      "96459": true,
      "96460": true,
      "96461": true,
      "96462": true,
      "96463": true,
      "96464": true,
      "96465": true,
      "96466": true,
      "96467": true,
      "96468": true,
      "96469": true,
      "96470": true,
      "96471": true,
      "96472": true,
      "96473": true,
      "96474": true,
      "96475": true,
      "96476": true,
      "96477": true,
      "96478": true,
      "96479": true,
      "96480": true,
      "96481": true,
      "96482": true,
      "96483": true,
      "96484": true,
      "96485": true,
      "96486": true,
      "96487": true,
      "96488": true,
      "96489": true,
      "96490": true,
      "96491": true,
      "96492": true,
      "96493": true,
      "96494": true,
      "96495": true,
      "96496": true,
      "96497": true,
      "96498": true,
      "96499": true,
      "96500": true,
      "96501": true,
      "96502": true,
      "96503": true,
      "96504": true,
      "96505": true,
      "96506": true,
      "96507": true,
      "96508": true,
      "96509": true,
      "96510": true,
      "96511": true,
      "96512": true,
      "96513": true,
      "96514": true,
      "96515": true,
      "96516": true,
      "96517": true,
      "96518": true,
      "96519": true,
      "96520": true,
      "96521": true,
      "96522": true,
      "96523": true,
      "96524": true,
      "96525": true,
      "96526": true,
      "96527": true,
      "96528": true,
      "96529": true,
      "96530": true,
      "96531": true,
      "96532": true,
      "96533": true,
      "96534": true,
      "96535": true,
      "96536": true,
      "96537": true,
      "96538": true,
      "96539": true,
      "96540": true,
      "96541": true,
      "96542": true,
      "96543": true,
      "96544": true,
      "96545": true,
      "96546": true,
      "96547": true,
      "96548": true,
      "96549": true,
      "96550": true,
      "96551": true,
      "96552": true,
      "96553": true,
      "96554": true,
      "96555": true,
      "96556": true,
      "96557": true,
      "96558": true,
      "96559": true,
      "96560": true,
      "96561": true,
      "96562": true,
      "96563": true,
      "96564": true,
      "96565": true,
      "96566": true,
      "96567": true,
      "96568": true,
      "96569": true,
      "96570": true,
      "96571": true,
      "96572": true,
      "96573": true,
      "96574": true,
      "96575": true,
      "96576": true,
      "96577": true,
      "96578": true,
      "96579": true,
      "96580": true,
      "96581": true,
      "96582": true,
      "96583": true,
      "96584": true,
      "96585": true,
      "96586": true,
      "96587": true,
      "96588": true,
      "96589": true,
      "96590": true,
      "96591": true,
      "96592": true,
      "96593": true,
      "96594": true,
      "96595": true,
      "96596": true,
      "96597": true,
      "96598": true,
      "96599": true
    },
    "COATZINTLA": {
      "93160": true,
      "93161": true,
      "93162": true,
      "93163": true,
      "93164": true,
      "93165": true,
      "93166": true,
      "93167": true,
      "93168": true,
      "93169": true,
      "93172": true,
      "93173": true,
      "93174": true,
      "93175": true,
      "93176": true,
      "93177": true,
      "93178": true,
      "93179": true
    },
    "CORDOBA": {
      "94480": true,
      "94481": true,
      "94482": true,
      "94483": true,
      "94484": true,
      "94485": true,
      "94486": true,
      "94487": true,
      "94488": true,
      "94489": true,
      "94490": true,
      "94491": true,
      "94492": true,
      "94493": true,
      "94494": true,
      "94495": true,
      "94496": true,
      "94497": true,
      "94498": true,
      "94499": true,
      "94500": true,
      "94501": true,
      "94502": true,
      "94503": true,
      "94504": true,
      "94505": true,
      "94506": true,
      "94507": true,
      "94508": true,
      "94509": true,
      "94510": true,
      "94511": true,
      "94512": true,
      "94513": true,
      "94514": true,
      "94515": true,
      "94516": true,
      "94517": true,
      "94518": true,
      "94519": true,
      "94520": true,
      "94521": true,
      "94522": true,
      "94523": true,
      "94524": true,
      "94525": true,
      "94526": true,
      "94527": true,
      "94528": true,
      "94529": true,
      "94530": true,
      "94531": true,
      "94532": true,
      "94533": true,
      "94534": true,
      "94535": true,
      "94536": true,
      "94537": true,
      "94538": true,
      "94539": true,
      "94540": true,
      "94541": true,
      "94542": true,
      "94543": true,
      "94544": true,
      "94545": true,
      "94546": true,
      "94547": true,
      "94548": true,
      "94549": true,
      "94550": true,
      "94551": true,
      "94552": true,
      "94553": true,
      "94554": true,
      "94555": true,
      "94556": true,
      "94557": true,
      "94558": true,
      "94559": true,
      "94560": true,
      "94561": true,
      "94562": true,
      "94563": true,
      "94564": true,
      "94565": true,
      "94566": true,
      "94567": true,
      "94568": true,
      "94569": true,
      "94570": true,
      "94571": true,
      "94572": true,
      "94573": true,
      "94574": true,
      "94575": true,
      "94576": true,
      "94577": true,
      "94578": true,
      "94579": true,
      "94580": true,
      "94581": true,
      "94582": true,
      "94583": true,
      "94584": true,
      "94585": true,
      "94586": true,
      "94587": true,
      "94588": true,
      "94589": true,
      "94590": true,
      "94591": true,
      "94592": true,
      "94593": true,
      "94594": true,
      "94595": true,
      "94596": true,
      "94597": true,
      "94598": true,
      "94599": true,
      "94600": true,
      "94601": true,
      "94602": true,
      "94603": true,
      "94604": true,
      "94605": true,
      "94606": true,
      "94607": true,
      "94608": true,
      "94609": true,
      "94610": true,
      "94611": true,
      "94612": true,
      "94613": true,
      "94614": true,
      "94615": true,
      "94616": true,
      "94617": true,
      "94618": true,
      "94619": true,
      "94620": true,
      "94621": true,
      "94622": true,
      "94623": true,
      "94624": true,
      "94625": true,
      "94626": true,
      "94627": true,
      "94628": true,
      "94629": true,
      "94630": true,
      "94631": true,
      "94632": true,
      "94633": true,
      "94634": true,
      "94635": true,
      "94636": true,
      "94637": true,
      "94638": true,
      "94639": true,
      "94640": true,
      "94641": true,
      "94642": true,
      "94643": true,
      "94644": true,
      "94645": true,
      "94646": true,
      "94647": true,
      "94648": true,
      "94649": true,
      "94650": true,
      "94651": true,
      "94652": true,
      "94653": true,
      "94654": true,
      "94655": true,
      "94656": true,
      "94657": true,
      "94658": true,
      "94659": true,
      "94660": true,
      "94661": true,
      "94662": true,
      "94663": true,
      "94664": true,
      "94665": true,
      "94666": true,
      "94667": true,
      "94668": true,
      "94669": true,
      "94670": true,
      "94671": true,
      "94672": true,
      "94673": true,
      "94674": true,
      "94675": true,
      "94676": true,
      "94677": true,
      "94678": true,
      "94679": true,
      "94680": true,
      "94681": true,
      "94682": true,
      "94683": true,
      "94684": true,
      "94685": true,
      "94686": true,
      "94687": true,
      "94688": true,
      "94689": true,
      "94690": true,
      "94691": true,
      "94692": true,
      "94693": true,
      "94694": true,
      "94695": true,
      "94696": true,
      "94697": true,
      "94698": true,
      "94699": true
    },
    "COSOLEACAQUE": {
      "96340": true,
      "96341": true,
      "96342": true,
      "96343": true,
      "96344": true,
      "96345": true,
      "96346": true,
      "96347": true,
      "96348": true,
      "96349": true,
      "96350": true,
      "96351": true,
      "96352": true,
      "96353": true,
      "96354": true,
      "96355": true,
      "96356": true,
      "96357": true,
      "96358": true,
      "96359": true
    },
    "COTAXTLA": {
      "94990": true,
      "94991": true,
      "94995": true,
      "94996": true,
      "94997": true,
      "94998": true,
      "94999": true
    },
    "COXQUIHUI": {
      "93060": true
    },
    "COYUTLA": {
      "93140": true
    },
    "CUITLAHUAC": {
      "94910": true,
      "94911": true,
      "94912": true,
      "94913": true,
      "94914": true,
      "94915": true,
      "94916": true,
      "94917": true,
      "94918": true,
      "94919": true
    },
    "EL HIGO": {
      "92400": true
    },
    "ESPINAL": {
      "93180": true
    },
    "FORTIN": {
      "94466": true,
      "94467": true,
      "94468": true,
      "94469": true,
      "94470": true,
      "94471": true,
      "94472": true,
      "94473": true,
      "94474": true,
      "94475": true,
      "94476": true,
      "94477": true,
      "94478": true,
      "94479": true
    },
    "GUTIERREZ ZAMORA": {
      "93550": true,
      "93551": true,
      "93552": true,
      "93553": true,
      "93554": true,
      "93555": true,
      "93556": true,
      "93557": true,
      "93558": true,
      "93559": true,
      "93560": true,
      "93561": true,
      "93562": true,
      "93563": true,
      "93564": true,
      "93565": true,
      "93566": true,
      "93567": true,
      "93568": true,
      "93569": true
    },
    "GUTIÉRREZ ZAMORA": {
      "93556": true
    },
    "HUATUSCO": {
      "94100": true,
      "94101": true,
      "94102": true,
      "94103": true,
      "94104": true,
      "94105": true,
      "94106": true,
      "94107": true,
      "94108": true,
      "94109": true,
      "94110": true,
      "94111": true,
      "94112": true,
      "94113": true,
      "94114": true,
      "94115": true,
      "94116": true,
      "94117": true,
      "94118": true,
      "94119": true
    },
    "HUAYACOCOTLA": {
      "92600": true,
      "92615": true
    },
    "ISLA": {
      "95640": true,
      "95641": true,
      "95642": true,
      "95643": true,
      "95644": true,
      "95645": true,
      "95646": true,
      "95647": true,
      "95648": true,
      "95649": true,
      "95650": true,
      "95651": true,
      "95652": true,
      "95653": true,
      "95654": true,
      "95655": true,
      "95656": true,
      "95658": true,
      "95659": true,
      "95660": true,
      "95661": true,
      "95662": true,
      "95663": true,
      "95664": true,
      "95665": true,
      "95666": true,
      "95667": true,
      "95668": true,
      "95669": true
    },
    "IXHUATLAN DEL SURESTE": {
      "96365": true,
      "96366": true,
      "96367": true,
      "96368": true,
      "96369": true
    },
    "IXTACZOQUITLAN": {
      "94450": true,
      "94451": true,
      "94452": true,
      "94453": true,
      "94454": true,
      "94455": true,
      "94456": true,
      "94457": true,
      "94458": true,
      "94459": true,
      "94460": true,
      "94461": true,
      "94462": true,
      "94463": true,
      "94464": true,
      "94465": true
    },
    "JALTIPAN": {
      "96200": true,
      "96201": true,
      "96202": true,
      "96203": true,
      "96204": true,
      "96205": true,
      "96206": true,
      "96207": true,
      "96208": true,
      "96209": true,
      "96210": true,
      "96211": true,
      "96212": true,
      "96213": true,
      "96214": true,
      "96215": true,
      "96216": true,
      "96217": true,
      "96218": true,
      "96219": true,
      "96220": true,
      "96221": true,
      "96222": true,
      "96223": true,
      "96224": true,
      "96225": true,
      "96226": true,
      "96227": true,
      "96228": true,
      "96229": true,
      "96230": true,
      "96231": true,
      "96232": true,
      "96233": true,
      "96234": true,
      "96235": true,
      "96236": true,
      "96237": true,
      "96238": true,
      "96239": true,
      "96240": true,
      "96241": true,
      "96242": true,
      "96243": true,
      "96244": true,
      "96245": true,
      "96246": true,
      "96247": true,
      "96248": true,
      "96249": true,
      "96250": true,
      "96251": true,
      "96252": true,
      "96253": true,
      "96254": true,
      "96255": true,
      "96256": true,
      "96257": true,
      "96258": true,
      "96259": true,
      "96260": true,
      "96261": true,
      "96262": true,
      "96263": true,
      "96264": true,
      "96265": true,
      "96266": true,
      "96267": true,
      "96268": true,
      "96269": true,
      "96270": true,
      "96271": true,
      "96272": true,
      "96273": true,
      "96274": true,
      "96275": true,
      "96276": true,
      "96277": true,
      "96278": true,
      "96279": true,
      "96280": true,
      "96281": true,
      "96282": true,
      "96283": true,
      "96284": true,
      "96285": true,
      "96286": true,
      "96287": true,
      "96288": true,
      "96289": true,
      "96290": true,
      "96291": true,
      "96292": true,
      "96293": true,
      "96294": true,
      "96295": true,
      "96296": true,
      "96297": true,
      "96298": true,
      "96299": true,
      "96300": true,
      "96301": true,
      "96302": true,
      "96303": true,
      "96304": true,
      "96305": true,
      "96306": true,
      "96307": true,
      "96308": true,
      "96309": true,
      "96316": true,
      "96317": true
    },
    "JAMAPA": {
      "94260": true,
      "94261": true,
      "94262": true,
      "94263": true,
      "94264": true,
      "94265": true,
      "94266": true,
      "94267": true,
      "94268": true,
      "94269": true
    },
    "JESUS CARRANZA": {
      "96950": true,
      "96951": true,
      "96952": true,
      "96953": true,
      "96954": true,
      "96955": true,
      "96956": true,
      "96957": true,
      "96958": true,
      "96959": true,
      "96960": true,
      "96961": true,
      "96962": true,
      "96963": true,
      "96965": true,
      "96966": true,
      "96970": true,
      "96971": true,
      "96972": true,
      "96974": true,
      "96978": true,
      "96979": true
    },
    "LA ANTIGUA": {
      "91680": true,
      "91681": true,
      "91682": true,
      "91683": true,
      "91684": true,
      "91685": true,
      "91686": true,
      "91687": true,
      "91688": true,
      "91689": true
    },
    "LAS CHOAPAS": {
      "96980": true,
      "96981": true,
      "96982": true,
      "96983": true,
      "96985": true,
      "96986": true
    },
    "LERDO DE TEJADA": {
      "95280": true,
      "95281": true,
      "95282": true,
      "95283": true,
      "95284": true,
      "95285": true,
      "95286": true,
      "95287": true,
      "95288": true,
      "95289": true,
      "95290": true,
      "95291": true,
      "95292": true,
      "95293": true,
      "95294": true,
      "95295": true,
      "95296": true,
      "95297": true,
      "95298": true,
      "95299": true
    },
    "MARIANO ESCOBEDO": {
      "94420": true,
      "94421": true,
      "94422": true,
      "94423": true,
      "94424": true,
      "94425": true,
      "94426": true,
      "94427": true
    },
    "MARTÍNEZ DE LA TORRE": {
      "93600": true,
      "93647": true
    },
    "MARTINEZ DE LA TORRE": {
      "93600": true,
      "93601": true,
      "93602": true,
      "93603": true,
      "93604": true,
      "93605": true,
      "93606": true,
      "93607": true,
      "93608": true,
      "93609": true,
      "93610": true,
      "93611": true,
      "93612": true,
      "93613": true,
      "93614": true,
      "93615": true,
      "93616": true,
      "93617": true,
      "93618": true,
      "93619": true,
      "93633": true,
      "93634": true,
      "93635": true,
      "93638": true,
      "93639": true,
      "93640": true,
      "93641": true,
      "93642": true,
      "93643": true,
      "93644": true,
      "93645": true,
      "93646": true,
      "93647": true,
      "93648": true,
      "93649": true
    },
    "MECAYAPAN": {
      "95930": true,
      "95931": true,
      "95932": true,
      "95933": true,
      "95934": true,
      "95935": true,
      "95936": true,
      "95937": true,
      "95938": true,
      "95939": true,
      "95940": true,
      "95941": true,
      "95942": true,
      "95943": true,
      "95944": true,
      "95945": true,
      "95946": true,
      "95947": true
    },
    "MEDELLIN": {
      "94270": true,
      "94271": true,
      "94272": true,
      "94273": true,
      "94274": true,
      "94275": true,
      "94276": true,
      "94277": true,
      "94278": true,
      "94279": true,
      "94280": true,
      "94281": true,
      "94282": true,
      "94283": true
    },
    "MIAHUATLAN": {
      "91410": true,
      "91411": true,
      "91412": true,
      "91413": true,
      "91414": true,
      "91415": true,
      "91416": true,
      "91417": true,
      "91418": true,
      "91419": true
    },
    "MISANTLA": {
      "93820": true,
      "93821": true,
      "93822": true,
      "93823": true,
      "93824": true,
      "93825": true,
      "93826": true,
      "93827": true,
      "93828": true,
      "93829": true,
      "93834": true,
      "93835": true,
      "93836": true,
      "93837": true,
      "93838": true,
      "93839": true,
      "93843": true,
      "93844": true,
      "93845": true,
      "93846": true,
      "93847": true,
      "93848": true,
      "93849": true,
      "93850": true,
      "93851": true,
      "93852": true,
      "93853": true,
      "93854": true,
      "93855": true,
      "93856": true,
      "93857": true,
      "93858": true,
      "93859": true
    },
    "MOLOACAN": {
      "96370": true,
      "96371": true,
      "96372": true,
      "96373": true,
      "96374": true,
      "96375": true,
      "96376": true
    },
    "NANCHITAL DE LAZARO CARDENAS DEL RIO": {
      "96360": true,
      "96361": true,
      "96362": true,
      "96363": true,
      "96364": true
    },
    "NARANJOS AMATLÁN": {
      "92300": true,
      "92330": true,
      "92340": true,
      "92419": true
    },
    "NARANJOS AMATLAN": {
      "92300": true,
      "92301": true,
      "92302": true,
      "92303": true,
      "92304": true,
      "92305": true,
      "92306": true,
      "92307": true,
      "92308": true,
      "92309": true,
      "92310": true,
      "92311": true,
      "92312": true,
      "92313": true,
      "92314": true,
      "92315": true,
      "92316": true,
      "92317": true,
      "92318": true,
      "92319": true,
      "92320": true,
      "92321": true,
      "92322": true,
      "92323": true,
      "92324": true,
      "92325": true,
      "92326": true,
      "92327": true,
      "92328": true,
      "92329": true,
      "92330": true,
      "92331": true,
      "92332": true,
      "92333": true,
      "92334": true,
      "92335": true,
      "92336": true,
      "92337": true,
      "92338": true,
      "92339": true,
      "92340": true,
      "92341": true,
      "92342": true,
      "92343": true,
      "92344": true,
      "92345": true,
      "92346": true,
      "92347": true,
      "92348": true,
      "92349": true,
      "92350": true,
      "92351": true,
      "92352": true,
      "92353": true,
      "92354": true,
      "92355": true,
      "92356": true,
      "92357": true,
      "92358": true,
      "92359": true,
      "92360": true,
      "92361": true,
      "92362": true,
      "92363": true,
      "92364": true,
      "92365": true,
      "92366": true,
      "92367": true,
      "92368": true,
      "92369": true,
      "92370": true,
      "92371": true,
      "92372": true,
      "92373": true,
      "92374": true,
      "92375": true,
      "92376": true,
      "92377": true,
      "92378": true,
      "92379": true,
      "92380": true,
      "92381": true,
      "92382": true,
      "92383": true,
      "92384": true,
      "92385": true,
      "92386": true,
      "92387": true,
      "92388": true,
      "92389": true,
      "92390": true,
      "92391": true,
      "92392": true,
      "92393": true,
      "92394": true,
      "92395": true,
      "92396": true,
      "92397": true,
      "92398": true,
      "92399": true,
      "92410": true,
      "92411": true,
      "92412": true,
      "92413": true,
      "92414": true,
      "92415": true,
      "92416": true,
      "92417": true,
      "92418": true,
      "92419": true
    },
    "NAUTLA": {
      "93800": true
    },
    "NOGALES": {
      "94720": true,
      "94721": true,
      "94722": true,
      "94723": true,
      "94724": true,
      "94725": true,
      "94726": true,
      "94727": true,
      "94728": true,
      "94729": true
    },
    "ORIZABA": {
      "94300": true,
      "94301": true,
      "94302": true,
      "94303": true,
      "94304": true,
      "94305": true,
      "94306": true,
      "94307": true,
      "94308": true,
      "94309": true,
      "94310": true,
      "94311": true,
      "94312": true,
      "94313": true,
      "94314": true,
      "94315": true,
      "94316": true,
      "94317": true,
      "94318": true,
      "94319": true,
      "94320": true,
      "94321": true,
      "94322": true,
      "94323": true,
      "94324": true,
      "94325": true,
      "94326": true,
      "94327": true,
      "94328": true,
      "94329": true,
      "94330": true,
      "94331": true,
      "94332": true,
      "94333": true,
      "94334": true,
      "94335": true,
      "94336": true,
      "94337": true,
      "94338": true,
      "94339": true,
      "94340": true,
      "94341": true,
      "94342": true,
      "94343": true,
      "94344": true,
      "94345": true,
      "94346": true,
      "94347": true,
      "94348": true,
      "94349": true,
      "94350": true,
      "94351": true,
      "94352": true,
      "94353": true,
      "94354": true,
      "94355": true,
      "94356": true,
      "94357": true,
      "94358": true,
      "94359": true,
      "94360": true,
      "94361": true,
      "94362": true,
      "94363": true,
      "94364": true,
      "94365": true,
      "94366": true,
      "94367": true,
      "94368": true,
      "94369": true,
      "94370": true,
      "94371": true,
      "94372": true,
      "94373": true,
      "94374": true,
      "94375": true,
      "94376": true,
      "94377": true,
      "94378": true,
      "94379": true,
      "94380": true,
      "94381": true,
      "94382": true,
      "94383": true,
      "94384": true,
      "94385": true,
      "94386": true,
      "94387": true,
      "94388": true,
      "94389": true,
      "94390": true,
      "94391": true,
      "94392": true,
      "94393": true,
      "94394": true,
      "94395": true,
      "94396": true,
      "94397": true,
      "94398": true,
      "94399": true,
      "94400": true,
      "94401": true,
      "94402": true,
      "94403": true,
      "94404": true,
      "94405": true,
      "94406": true,
      "94407": true,
      "94408": true,
      "94409": true
    },
    "OTEAPAN": {
      "96330": true,
      "96331": true,
      "96332": true,
      "96333": true,
      "96334": true,
      "96335": true,
      "96336": true,
      "96337": true,
      "96338": true,
      "96339": true
    },
    "OZULUAMA DE MASCAREÑAS": {
      "92080": true,
      "92096": true
    },
    "PAJAPAN": {
      "95960": true,
      "95961": true,
      "95962": true,
      "95963": true,
      "95964": true,
      "95965": true,
      "95966": true,
      "95967": true,
      "95968": true,
      "95969": true,
      "95970": true,
      "95971": true,
      "95972": true,
      "95973": true,
      "95974": true,
      "95975": true,
      "95976": true,
      "95977": true,
      "95978": true,
      "95979": true
    },
    "PÁNUCO": {
      "92000": true
    },
    "PANUCO": {
      "92000": true,
      "92001": true,
      "92002": true,
      "92003": true,
      "92004": true,
      "92005": true,
      "92009": true,
      "92010": true,
      "92011": true,
      "92012": true,
      "92015": true,
      "92017": true,
      "92018": true,
      "92020": true,
      "92021": true,
      "92023": true,
      "92025": true,
      "92026": true,
      "93990": true,
      "93991": true,
      "93992": true,
      "93993": true,
      "93994": true,
      "93995": true,
      "93996": true,
      "93997": true,
      "93998": true,
      "93999": true
    },
    "PAPANTLA": {
      "93400": true,
      "93401": true,
      "93402": true,
      "93403": true,
      "93404": true,
      "93405": true,
      "93406": true,
      "93407": true,
      "93408": true,
      "93409": true,
      "93410": true,
      "93411": true,
      "93412": true,
      "93413": true,
      "93414": true,
      "93415": true,
      "93416": true,
      "93417": true,
      "93418": true,
      "93419": true,
      "93420": true,
      "93421": true,
      "93422": true,
      "93423": true,
      "93424": true,
      "93425": true,
      "93426": true,
      "93427": true,
      "93428": true,
      "93429": true,
      "93430": true,
      "93431": true,
      "93432": true,
      "93433": true,
      "93434": true,
      "93435": true,
      "93436": true,
      "93437": true,
      "93438": true,
      "93439": true,
      "93440": true,
      "93441": true,
      "93442": true,
      "93443": true,
      "93444": true,
      "93445": true,
      "93446": true,
      "93447": true,
      "93448": true,
      "93449": true,
      "93450": true,
      "93451": true,
      "93452": true,
      "93453": true,
      "93454": true,
      "93455": true,
      "93456": true,
      "93457": true,
      "93458": true,
      "93459": true,
      "93460": true,
      "93461": true,
      "93462": true,
      "93463": true,
      "93464": true,
      "93465": true,
      "93466": true,
      "93467": true,
      "93468": true,
      "93469": true,
      "93470": true,
      "93471": true,
      "93472": true,
      "93473": true,
      "93474": true,
      "93475": true,
      "93476": true,
      "93477": true,
      "93478": true,
      "93479": true,
      "93480": true,
      "93481": true,
      "93482": true,
      "93483": true,
      "93484": true,
      "93485": true,
      "93486": true,
      "93487": true,
      "93488": true,
      "93489": true,
      "93490": true,
      "93491": true,
      "93492": true,
      "93493": true,
      "93494": true,
      "93495": true,
      "93496": true,
      "93497": true,
      "93498": true,
      "93499": true,
      "93500": true,
      "93501": true,
      "93502": true,
      "93503": true,
      "93504": true,
      "93505": true,
      "93506": true,
      "93507": true,
      "93508": true,
      "93509": true,
      "93510": true,
      "93511": true,
      "93512": true,
      "93513": true,
      "93514": true,
      "93515": true,
      "93516": true,
      "93517": true,
      "93518": true,
      "93519": true,
      "93520": true,
      "93521": true,
      "93522": true,
      "93523": true,
      "93524": true,
      "93525": true,
      "93526": true,
      "93527": true,
      "93528": true,
      "93529": true,
      "93530": true,
      "93531": true,
      "93532": true,
      "93533": true,
      "93534": true,
      "93535": true,
      "93537": true,
      "93542": true,
      "93543": true,
      "93544": true,
      "93549": true
    },
    "PASO DE OVEJAS": {
      "91670": true,
      "91671": true,
      "91672": true,
      "91673": true,
      "91674": true,
      "91675": true,
      "91676": true,
      "91677": true,
      "91678": true,
      "91679": true
    },
    "PASO DEL MACHO": {
      "94970": true,
      "94971": true,
      "94972": true,
      "94974": true,
      "94975": true,
      "94976": true,
      "94977": true,
      "94978": true,
      "94979": true
    },
    "PEROTE": {
      "91270": true,
      "91271": true,
      "91272": true,
      "91273": true,
      "91274": true,
      "91275": true,
      "91276": true,
      "91277": true,
      "91278": true,
      "91279": true,
      "91280": true,
      "91281": true,
      "91282": true,
      "91283": true,
      "91285": true,
      "91286": true,
      "91287": true,
      "91288": true,
      "91289": true
    },
    "PLATÓN SÁNCHEZ": {
      "92130": true
    },
    "POZA RICA DE HIDALGO": {
      "93210": true,
      "93211": true,
      "93212": true,
      "93213": true,
      "93214": true,
      "93215": true,
      "93216": true,
      "93217": true,
      "93218": true,
      "93219": true,
      "93220": true,
      "93221": true,
      "93222": true,
      "93223": true,
      "93224": true,
      "93225": true,
      "93226": true,
      "93227": true,
      "93228": true,
      "93229": true,
      "93230": true,
      "93231": true,
      "93232": true,
      "93233": true,
      "93234": true,
      "93235": true,
      "93236": true,
      "93237": true,
      "93238": true,
      "93239": true,
      "93240": true,
      "93241": true,
      "93242": true,
      "93243": true,
      "93244": true,
      "93245": true,
      "93246": true,
      "93247": true,
      "93248": true,
      "93249": true,
      "93250": true,
      "93251": true,
      "93252": true,
      "93253": true,
      "93254": true,
      "93255": true,
      "93256": true,
      "93257": true,
      "93258": true,
      "93259": true,
      "93260": true,
      "93261": true,
      "93262": true,
      "93263": true,
      "93264": true,
      "93265": true,
      "93266": true,
      "93267": true,
      "93268": true,
      "93269": true,
      "93270": true,
      "93271": true,
      "93272": true,
      "93273": true,
      "93274": true,
      "93275": true,
      "93276": true,
      "93277": true,
      "93278": true,
      "93279": true,
      "93280": true,
      "93281": true,
      "93282": true,
      "93283": true,
      "93284": true,
      "93285": true,
      "93286": true,
      "93287": true,
      "93288": true,
      "93289": true,
      "93290": true,
      "93291": true,
      "93292": true,
      "93293": true,
      "93294": true,
      "93295": true,
      "93296": true,
      "93297": true,
      "93298": true,
      "93299": true,
      "93300": true,
      "93301": true,
      "93302": true,
      "93303": true,
      "93304": true,
      "93305": true,
      "93306": true,
      "93307": true,
      "93308": true,
      "93309": true,
      "93310": true,
      "93311": true,
      "93312": true,
      "93313": true,
      "93314": true,
      "93315": true,
      "93316": true,
      "93317": true,
      "93318": true,
      "93319": true,
      "93320": true,
      "93321": true,
      "93322": true,
      "93323": true,
      "93324": true,
      "93325": true,
      "93326": true,
      "93327": true,
      "93328": true,
      "93329": true,
      "93330": true,
      "93331": true,
      "93332": true,
      "93333": true,
      "93334": true,
      "93335": true,
      "93336": true,
      "93337": true,
      "93338": true,
      "93339": true,
      "93340": true,
      "93341": true,
      "93342": true,
      "93343": true,
      "93344": true,
      "93345": true,
      "93346": true,
      "93347": true,
      "93348": true,
      "93349": true,
      "93350": true,
      "93351": true,
      "93352": true,
      "93353": true,
      "93354": true,
      "93355": true,
      "93356": true,
      "93357": true,
      "93358": true,
      "93359": true,
      "93360": true,
      "93361": true,
      "93362": true,
      "93363": true,
      "93364": true,
      "93365": true,
      "93366": true,
      "93367": true,
      "93368": true,
      "93369": true,
      "93370": true,
      "93371": true,
      "93372": true,
      "93373": true,
      "93374": true,
      "93375": true,
      "93376": true,
      "93377": true,
      "93378": true,
      "93379": true,
      "93380": true,
      "93381": true,
      "93382": true,
      "93383": true,
      "93384": true,
      "93385": true,
      "93386": true,
      "93387": true,
      "93388": true,
      "93389": true,
      "93390": true,
      "93391": true,
      "93392": true,
      "93393": true,
      "93394": true,
      "93395": true,
      "93396": true,
      "93397": true,
      "93398": true,
      "93399": true
    },
    "PUEBLO VIEJO": {
      "92030": true,
      "92031": true,
      "92032": true,
      "92033": true,
      "92034": true,
      "92035": true,
      "92036": true,
      "92037": true,
      "92038": true,
      "92039": true
    },
    "RIO BLANCO": {
      "94730": true,
      "94731": true,
      "94732": true,
      "94733": true,
      "94734": true,
      "94735": true,
      "94736": true,
      "94737": true,
      "94738": true,
      "94739": true
    },
    "SAN ANDRES TUXTLA": {
      "95700": true,
      "95701": true,
      "95702": true,
      "95703": true,
      "95704": true,
      "95705": true,
      "95706": true,
      "95707": true,
      "95708": true,
      "95709": true,
      "95710": true,
      "95711": true,
      "95712": true,
      "95713": true,
      "95714": true,
      "95715": true,
      "95716": true,
      "95717": true,
      "95718": true,
      "95719": true,
      "95720": true,
      "95721": true,
      "95722": true,
      "95723": true,
      "95724": true,
      "95725": true,
      "95726": true,
      "95727": true,
      "95728": true,
      "95729": true,
      "95730": true,
      "95731": true,
      "95732": true,
      "95733": true,
      "95734": true,
      "95735": true,
      "95736": true,
      "95737": true,
      "95738": true,
      "95739": true,
      "95740": true,
      "95741": true,
      "95742": true,
      "95743": true,
      "95744": true,
      "95745": true,
      "95746": true,
      "95747": true,
      "95748": true,
      "95749": true,
      "95750": true,
      "95751": true,
      "95752": true,
      "95753": true,
      "95754": true,
      "95755": true,
      "95756": true,
      "95757": true,
      "95758": true,
      "95759": true,
      "95760": true,
      "95761": true,
      "95762": true,
      "95763": true,
      "95764": true,
      "95765": true,
      "95766": true,
      "95767": true,
      "95768": true,
      "95769": true,
      "95770": true,
      "95771": true,
      "95772": true,
      "95773": true,
      "95774": true,
      "95775": true,
      "95776": true,
      "95777": true,
      "95778": true,
      "95779": true,
      "95780": true,
      "95781": true,
      "95782": true,
      "95783": true,
      "95784": true,
      "95785": true,
      "95786": true,
      "95787": true,
      "95788": true,
      "95789": true,
      "95790": true,
      "95791": true,
      "95792": true,
      "95793": true,
      "95794": true,
      "95795": true,
      "95796": true,
      "95797": true,
      "95798": true,
      "95799": true,
      "95800": true,
      "95801": true,
      "95802": true,
      "95803": true,
      "95804": true,
      "95805": true,
      "95806": true,
      "95807": true,
      "95808": true,
      "95809": true,
      "95810": true,
      "95811": true,
      "95812": true,
      "95813": true,
      "95814": true,
      "95816": true,
      "95821": true,
      "95822": true
    },
    "SAN RAFAEL": {
      "93620": true,
      "93621": true,
      "93622": true,
      "93623": true,
      "93624": true,
      "93625": true,
      "93626": true,
      "93627": true,
      "93628": true,
      "93629": true,
      "93630": true,
      "93631": true,
      "93632": true
    },
    "SANTIAGO TUXTLA": {
      "95830": true,
      "95831": true,
      "95832": true,
      "95833": true,
      "95834": true,
      "95835": true,
      "95839": true
    },
    "SAYULA DE ALEMAN": {
      "96150": true,
      "96151": true,
      "96152": true,
      "96153": true,
      "96154": true
    },
    "SOLEDAD DE DOBLADO": {
      "94240": true,
      "94241": true,
      "94242": true,
      "94243": true,
      "94244": true,
      "94245": true,
      "94246": true,
      "94247": true,
      "94248": true,
      "94249": true
    },
    "TAMIAHUA": {
      "92560": true,
      "92561": true,
      "92562": true,
      "92563": true,
      "92570": true,
      "92571": true,
      "92572": true,
      "92573": true,
      "92574": true,
      "92575": true,
      "92576": true,
      "92577": true,
      "92578": true,
      "92579": true,
      "92580": true,
      "92581": true,
      "92584": true,
      "92585": true,
      "92586": true,
      "92587": true,
      "92588": true,
      "92589": true,
      "92590": true,
      "92591": true,
      "92592": true,
      "92593": true,
      "92594": true,
      "92595": true,
      "92596": true,
      "92597": true,
      "92598": true,
      "92599": true
    },
    "TAMPICO ALTO": {
      "92040": true,
      "92041": true,
      "92042": true,
      "92044": true,
      "92045": true,
      "92046": true,
      "92050": true,
      "92051": true,
      "92052": true,
      "92053": true,
      "92054": true,
      "92055": true,
      "92056": true,
      "92057": true,
      "92058": true,
      "92059": true
    },
    "TANTOYUCA": {
      "92100": true,
      "92101": true,
      "92102": true,
      "92103": true,
      "92104": true,
      "92105": true,
      "92106": true,
      "92108": true,
      "92109": true,
      "92110": true,
      "92111": true,
      "92112": true,
      "92113": true,
      "92114": true,
      "92115": true,
      "92116": true,
      "92117": true,
      "92118": true,
      "92119": true,
      "92120": true,
      "92121": true,
      "92122": true,
      "92123": true,
      "92124": true,
      "92125": true,
      "92126": true,
      "92127": true,
      "92128": true,
      "92129": true
    },
    "TATAHUICAPAN DE JUAREZ": {
      "95950": true,
      "95951": true,
      "95952": true,
      "95953": true,
      "95954": true,
      "95955": true,
      "95956": true
    },
    "TECOLUTLA": {
      "93570": true,
      "93590": true
    },
    "TEMPOAL": {
      "92060": true
    },
    "TEOCELO": {
      "91615": true,
      "91616": true,
      "91617": true,
      "91618": true,
      "91619": true
    },
    "TEPETZINTLA": {
      "92530": true
    },
    "TIERRA BLANCA": {
      "95100": true,
      "95101": true,
      "95102": true,
      "95103": true,
      "95104": true,
      "95105": true,
      "95106": true,
      "95107": true,
      "95108": true,
      "95109": true,
      "95110": true,
      "95111": true,
      "95112": true,
      "95113": true,
      "95114": true,
      "95115": true,
      "95116": true,
      "95117": true,
      "95118": true,
      "95119": true,
      "95120": true,
      "95121": true,
      "95122": true,
      "95123": true,
      "95124": true,
      "95125": true,
      "95126": true,
      "95127": true,
      "95128": true,
      "95129": true,
      "95130": true,
      "95131": true,
      "95132": true,
      "95133": true,
      "95134": true,
      "95135": true,
      "95136": true,
      "95137": true,
      "95138": true,
      "95139": true,
      "95140": true,
      "95141": true,
      "95142": true,
      "95143": true,
      "95144": true,
      "95145": true,
      "95146": true,
      "95147": true,
      "95148": true,
      "95149": true,
      "95150": true,
      "95151": true,
      "95152": true,
      "95153": true,
      "95154": true,
      "95155": true,
      "95156": true,
      "95157": true,
      "95158": true,
      "95159": true,
      "95160": true,
      "95161": true,
      "95162": true,
      "95163": true,
      "95164": true,
      "95165": true,
      "95166": true,
      "95167": true,
      "95168": true,
      "95169": true,
      "95170": true,
      "95171": true,
      "95172": true,
      "95173": true,
      "95174": true,
      "95175": true,
      "95176": true,
      "95177": true,
      "95178": true,
      "95179": true,
      "95180": true,
      "95181": true,
      "95182": true,
      "95183": true,
      "95184": true,
      "95185": true,
      "95186": true,
      "95187": true,
      "95188": true,
      "95189": true,
      "95190": true,
      "95191": true,
      "95192": true,
      "95193": true,
      "95194": true,
      "95195": true,
      "95196": true,
      "95197": true,
      "95198": true,
      "95199": true,
      "95200": true,
      "95201": true,
      "95202": true,
      "95203": true,
      "95204": true,
      "95205": true,
      "95206": true,
      "95207": true,
      "95208": true,
      "95214": true,
      "95216": true,
      "95217": true,
      "95218": true,
      "95219": true
    },
    "TIHUATLAN": {
      "92900": true,
      "92901": true,
      "92902": true,
      "92903": true,
      "92904": true,
      "92905": true,
      "92906": true,
      "92907": true,
      "92908": true,
      "92909": true,
      "92910": true,
      "92911": true,
      "92912": true,
      "92914": true,
      "92916": true,
      "92917": true,
      "92918": true,
      "92919": true,
      "92920": true,
      "92921": true,
      "92922": true,
      "92925": true,
      "92928": true,
      "92929": true,
      "92930": true,
      "92931": true,
      "92932": true,
      "92933": true,
      "92934": true,
      "92935": true,
      "92936": true,
      "92937": true,
      "92938": true,
      "92939": true
    },
    "TLACOTALPAN": {
      "95460": true,
      "95461": true,
      "95462": true,
      "95463": true,
      "95464": true,
      "95465": true,
      "95466": true,
      "95467": true,
      "95468": true,
      "95469": true
    },
    "TLALIXCOYAN": {
      "95220": true,
      "95221": true,
      "95222": true,
      "95224": true,
      "95225": true,
      "95226": true,
      "95230": true,
      "95231": true,
      "95232": true,
      "95233": true,
      "95234": true,
      "95235": true,
      "95236": true,
      "95237": true,
      "95238": true,
      "95239": true
    },
    "TLAPACOYAN": {
      "93650": true
    },
    "TRES VALLES": {
      "95300": true,
      "95301": true,
      "95302": true,
      "95303": true,
      "95304": true,
      "95305": true,
      "95306": true,
      "95307": true,
      "95308": true,
      "95309": true,
      "95310": true,
      "95311": true,
      "95312": true,
      "95313": true,
      "95314": true,
      "95315": true,
      "95316": true,
      "95317": true,
      "95318": true,
      "95319": true,
      "95320": true,
      "95321": true,
      "95322": true,
      "95323": true,
      "95324": true,
      "95325": true,
      "95326": true,
      "95327": true,
      "95328": true,
      "95329": true,
      "95350": true,
      "95351": true,
      "95352": true,
      "95353": true,
      "95354": true,
      "95355": true,
      "95356": true,
      "95357": true,
      "95358": true,
      "95359": true,
      "95360": true,
      "95361": true,
      "95362": true,
      "95363": true,
      "95364": true,
      "95365": true,
      "95366": true,
      "95367": true,
      "95368": true,
      "95369": true,
      "95370": true,
      "95371": true,
      "95372": true,
      "95373": true,
      "95374": true,
      "95375": true,
      "95376": true,
      "95377": true,
      "95378": true,
      "95379": true,
      "95380": true,
      "95381": true,
      "95382": true,
      "95383": true,
      "95384": true,
      "95385": true,
      "95386": true,
      "95387": true,
      "95388": true,
      "95389": true
    },
    "TUXPAN": {
      "92770": true,
      "92800": true,
      "92890": true
    },
    "VEGA DE ALATORRE": {
      "93960": true
    },
    "VERACRUZ": {
      "91690": true,
      "91691": true,
      "91692": true,
      "91693": true,
      "91694": true,
      "91695": true,
      "91696": true,
      "91697": true,
      "91698": true,
      "91699": true,
      "91700": true,
      "91701": true,
      "91702": true,
      "91703": true,
      "91704": true,
      "91705": true,
      "91706": true,
      "91707": true,
      "91708": true,
      "91709": true,
      "91710": true,
      "91711": true,
      "91712": true,
      "91713": true,
      "91714": true,
      "91715": true,
      "91716": true,
      "91717": true,
      "91718": true,
      "91719": true,
      "91720": true,
      "91721": true,
      "91722": true,
      "91723": true,
      "91724": true,
      "91725": true,
      "91726": true,
      "91727": true,
      "91728": true,
      "91729": true,
      "91730": true,
      "91731": true,
      "91732": true,
      "91733": true,
      "91734": true,
      "91735": true,
      "91736": true,
      "91737": true,
      "91738": true,
      "91739": true,
      "91740": true,
      "91741": true,
      "91742": true,
      "91743": true,
      "91744": true,
      "91745": true,
      "91746": true,
      "91747": true,
      "91748": true,
      "91749": true,
      "91750": true,
      "91751": true,
      "91752": true,
      "91753": true,
      "91754": true,
      "91755": true,
      "91756": true,
      "91757": true,
      "91758": true,
      "91759": true,
      "91760": true,
      "91761": true,
      "91762": true,
      "91763": true,
      "91764": true,
      "91765": true,
      "91766": true,
      "91767": true,
      "91768": true,
      "91769": true,
      "91770": true,
      "91771": true,
      "91772": true,
      "91773": true,
      "91774": true,
      "91775": true,
      "91776": true,
      "91777": true,
      "91778": true,
      "91779": true,
      "91780": true,
      "91781": true,
      "91782": true,
      "91783": true,
      "91784": true,
      "91785": true,
      "91786": true,
      "91787": true,
      "91788": true,
      "91789": true,
      "91790": true,
      "91791": true,
      "91792": true,
      "91793": true,
      "91794": true,
      "91795": true,
      "91796": true,
      "91797": true,
      "91798": true,
      "91799": true,
      "91800": true,
      "91801": true,
      "91802": true,
      "91803": true,
      "91804": true,
      "91805": true,
      "91806": true,
      "91807": true,
      "91808": true,
      "91809": true,
      "91810": true,
      "91811": true,
      "91812": true,
      "91813": true,
      "91814": true,
      "91815": true,
      "91816": true,
      "91817": true,
      "91818": true,
      "91819": true,
      "91820": true,
      "91821": true,
      "91822": true,
      "91823": true,
      "91824": true,
      "91825": true,
      "91826": true,
      "91827": true,
      "91828": true,
      "91829": true,
      "91830": true,
      "91831": true,
      "91832": true,
      "91833": true,
      "91834": true,
      "91835": true,
      "91836": true,
      "91837": true,
      "91838": true,
      "91839": true,
      "91840": true,
      "91841": true,
      "91842": true,
      "91843": true,
      "91844": true,
      "91845": true,
      "91846": true,
      "91847": true,
      "91848": true,
      "91849": true,
      "91850": true,
      "91851": true,
      "91852": true,
      "91853": true,
      "91854": true,
      "91855": true,
      "91856": true,
      "91857": true,
      "91858": true,
      "91859": true,
      "91860": true,
      "91861": true,
      "91862": true,
      "91863": true,
      "91864": true,
      "91865": true,
      "91866": true,
      "91867": true,
      "91868": true,
      "91869": true,
      "91870": true,
      "91871": true,
      "91872": true,
      "91873": true,
      "91874": true,
      "91875": true,
      "91876": true,
      "91877": true,
      "91878": true,
      "91879": true,
      "91880": true,
      "91881": true,
      "91882": true,
      "91883": true,
      "91884": true,
      "91885": true,
      "91886": true,
      "91887": true,
      "91888": true,
      "91889": true,
      "91890": true,
      "91891": true,
      "91892": true,
      "91893": true,
      "91894": true,
      "91895": true,
      "91896": true,
      "91897": true,
      "91898": true,
      "91899": true,
      "91900": true,
      "91901": true,
      "91902": true,
      "91903": true,
      "91904": true,
      "91905": true,
      "91906": true,
      "91907": true,
      "91908": true,
      "91909": true,
      "91910": true,
      "91911": true,
      "91912": true,
      "91913": true,
      "91915": true,
      "91916": true,
      "91917": true,
      "91918": true,
      "91919": true,
      "91920": true,
      "91921": true,
      "91922": true,
      "91923": true,
      "91924": true,
      "91925": true,
      "91926": true,
      "91927": true,
      "91928": true,
      "91929": true,
      "91930": true,
      "91931": true,
      "91932": true,
      "91933": true,
      "91934": true,
      "91935": true,
      "91936": true,
      "91937": true,
      "91938": true,
      "91939": true,
      "91940": true,
      "91941": true,
      "91942": true,
      "91943": true,
      "91944": true,
      "91945": true,
      "91946": true,
      "91947": true,
      "91948": true,
      "91949": true,
      "91950": true,
      "91951": true,
      "91952": true,
      "91953": true,
      "91954": true,
      "91955": true,
      "91956": true,
      "91957": true,
      "91958": true,
      "91959": true,
      "91960": true,
      "91961": true,
      "91962": true,
      "91963": true,
      "91964": true,
      "91965": true,
      "91966": true,
      "91967": true,
      "91968": true,
      "91969": true,
      "91970": true,
      "91971": true,
      "91972": true,
      "91973": true,
      "91974": true,
      "91975": true,
      "91976": true,
      "91977": true,
      "91978": true,
      "91979": true,
      "91980": true,
      "91981": true,
      "91982": true,
      "91983": true,
      "91984": true,
      "91985": true,
      "91986": true,
      "91987": true,
      "91988": true,
      "91989": true,
      "91990": true,
      "91991": true,
      "91992": true,
      "91993": true,
      "91994": true,
      "91995": true,
      "91996": true,
      "91997": true,
      "91998": true,
      "91999": true
    },
    "VILLA ALDAMA": {
      "91340": true,
      "91341": true,
      "91342": true,
      "91343": true,
      "91344": true,
      "91345": true,
      "91346": true,
      "91347": true,
      "91348": true,
      "91349": true
    },
    "XALAPA": {
      "91000": true,
      "91001": true,
      "91002": true,
      "91003": true,
      "91004": true,
      "91005": true,
      "91006": true,
      "91007": true,
      "91008": true,
      "91009": true,
      "91010": true,
      "91011": true,
      "91012": true,
      "91013": true,
      "91014": true,
      "91015": true,
      "91016": true,
      "91017": true,
      "91018": true,
      "91019": true,
      "91020": true,
      "91021": true,
      "91022": true,
      "91023": true,
      "91024": true,
      "91025": true,
      "91026": true,
      "91027": true,
      "91028": true,
      "91029": true,
      "91030": true,
      "91031": true,
      "91032": true,
      "91033": true,
      "91034": true,
      "91035": true,
      "91036": true,
      "91037": true,
      "91038": true,
      "91039": true,
      "91040": true,
      "91041": true,
      "91042": true,
      "91043": true,
      "91044": true,
      "91045": true,
      "91046": true,
      "91047": true,
      "91048": true,
      "91049": true,
      "91050": true,
      "91051": true,
      "91052": true,
      "91053": true,
      "91054": true,
      "91055": true,
      "91056": true,
      "91057": true,
      "91058": true,
      "91059": true,
      "91060": true,
      "91061": true,
      "91062": true,
      "91063": true,
      "91064": true,
      "91065": true,
      "91066": true,
      "91067": true,
      "91068": true,
      "91069": true,
      "91070": true,
      "91071": true,
      "91072": true,
      "91073": true,
      "91074": true,
      "91075": true,
      "91076": true,
      "91077": true,
      "91078": true,
      "91079": true,
      "91080": true,
      "91081": true,
      "91082": true,
      "91083": true,
      "91084": true,
      "91085": true,
      "91086": true,
      "91087": true,
      "91088": true,
      "91089": true,
      "91090": true,
      "91091": true,
      "91092": true,
      "91093": true,
      "91094": true,
      "91095": true,
      "91096": true,
      "91097": true,
      "91098": true,
      "91099": true,
      "91100": true,
      "91101": true,
      "91102": true,
      "91103": true,
      "91104": true,
      "91105": true,
      "91106": true,
      "91107": true,
      "91108": true,
      "91109": true,
      "91110": true,
      "91111": true,
      "91112": true,
      "91113": true,
      "91114": true,
      "91115": true,
      "91116": true,
      "91117": true,
      "91118": true,
      "91119": true,
      "91120": true,
      "91121": true,
      "91122": true,
      "91123": true,
      "91124": true,
      "91125": true,
      "91126": true,
      "91127": true,
      "91128": true,
      "91129": true,
      "91130": true,
      "91131": true,
      "91132": true,
      "91133": true,
      "91134": true,
      "91135": true,
      "91136": true,
      "91137": true,
      "91138": true,
      "91139": true,
      "91140": true,
      "91141": true,
      "91142": true,
      "91143": true,
      "91144": true,
      "91145": true,
      "91146": true,
      "91147": true,
      "91148": true,
      "91149": true,
      "91150": true,
      "91151": true,
      "91152": true,
      "91153": true,
      "91154": true,
      "91155": true,
      "91156": true,
      "91157": true,
      "91158": true,
      "91159": true,
      "91160": true,
      "91161": true,
      "91162": true,
      "91163": true,
      "91164": true,
      "91165": true,
      "91166": true,
      "91167": true,
      "91168": true,
      "91169": true,
      "91170": true,
      "91171": true,
      "91172": true,
      "91173": true,
      "91174": true,
      "91175": true,
      "91176": true,
      "91177": true,
      "91178": true,
      "91179": true,
      "91180": true,
      "91181": true,
      "91182": true,
      "91183": true,
      "91184": true,
      "91185": true,
      "91186": true,
      "91187": true,
      "91188": true,
      "91189": true,
      "91190": true,
      "91191": true,
      "91192": true,
      "91193": true,
      "91194": true,
      "91195": true,
      "91196": true,
      "91197": true,
      "91198": true,
      "91199": true,
      "91200": true,
      "91201": true,
      "91202": true,
      "91203": true,
      "91204": true,
      "91205": true,
      "91206": true,
      "91207": true,
      "91208": true,
      "91209": true,
      "91210": true,
      "91211": true,
      "91212": true,
      "91213": true,
      "91214": true,
      "91215": true,
      "91216": true,
      "91217": true,
      "91218": true,
      "91219": true,
      "91220": true,
      "91221": true,
      "91222": true,
      "91223": true,
      "91224": true,
      "91225": true,
      "91226": true,
      "91227": true,
      "91228": true,
      "91229": true
    },
    "XICO": {
      "91240": true,
      "91241": true,
      "91242": true,
      "91244": true,
      "91245": true,
      "91247": true,
      "91248": true,
      "91249": true
    },
    "ZOZOCOLCO DE HIDALGO": {
      "93000": true,
      "93001": true,
      "93002": true,
      "93003": true,
      "93004": true,
      "93005": true,
      "93006": true,
      "93007": true,
      "93008": true,
      "93009": true,
      "93010": true,
      "93011": true,
      "93012": true,
      "93013": true,
      "93014": true,
      "93015": true,
      "93016": true,
      "93017": true,
      "93018": true,
      "93019": true,
      "93020": true,
      "93021": true,
      "93022": true,
      "93023": true,
      "93024": true,
      "93025": true,
      "93026": true,
      "93027": true,
      "93028": true,
      "93029": true,
      "93030": true,
      "93031": true,
      "93032": true,
      "93033": true,
      "93034": true,
      "93035": true,
      "93036": true,
      "93037": true,
      "93038": true,
      "93039": true
    }
  },
  "YUCATÁN": {
    "HALACHO": {
      "97830": true,
      "97831": true,
      "97832": true,
      "97833": true,
      "97834": true,
      "97835": true,
      "97836": true,
      "97837": true,
      "97838": true,
      "97839": true
    },
    "MAXCANU": {
      "97800": true,
      "97801": true,
      "97802": true,
      "97803": true,
      "97804": true,
      "97807": true,
      "97808": true,
      "97809": true
    },
    "MÉRIDA": {
      "97000": true,
      "97001": true,
      "97002": true,
      "97003": true,
      "97004": true,
      "97005": true,
      "97006": true,
      "97007": true,
      "97008": true,
      "97009": true,
      "97010": true,
      "97011": true,
      "97012": true,
      "97013": true,
      "97014": true,
      "97015": true,
      "97016": true,
      "97017": true,
      "97018": true,
      "97019": true,
      "97020": true,
      "97021": true,
      "97022": true,
      "97023": true,
      "97024": true,
      "97025": true,
      "97026": true,
      "97027": true,
      "97028": true,
      "97029": true,
      "97030": true,
      "97031": true,
      "97032": true,
      "97033": true,
      "97034": true,
      "97035": true,
      "97036": true,
      "97037": true,
      "97038": true,
      "97039": true,
      "97040": true,
      "97041": true,
      "97042": true,
      "97043": true,
      "97044": true,
      "97045": true,
      "97046": true,
      "97047": true,
      "97048": true,
      "97049": true,
      "97050": true,
      "97051": true,
      "97052": true,
      "97053": true,
      "97054": true,
      "97055": true,
      "97056": true,
      "97057": true,
      "97058": true,
      "97059": true,
      "97060": true,
      "97061": true,
      "97062": true,
      "97063": true,
      "97064": true,
      "97065": true,
      "97066": true,
      "97067": true,
      "97068": true,
      "97069": true,
      "97070": true,
      "97071": true,
      "97072": true,
      "97073": true,
      "97074": true,
      "97075": true,
      "97076": true,
      "97077": true,
      "97078": true,
      "97079": true,
      "97080": true,
      "97081": true,
      "97082": true,
      "97083": true,
      "97084": true,
      "97085": true,
      "97086": true,
      "97087": true,
      "97088": true,
      "97089": true,
      "97090": true,
      "97091": true,
      "97092": true,
      "97093": true,
      "97094": true,
      "97095": true,
      "97096": true,
      "97097": true,
      "97098": true,
      "97099": true,
      "97100": true,
      "97101": true,
      "97102": true,
      "97103": true,
      "97104": true,
      "97105": true,
      "97106": true,
      "97107": true,
      "97108": true,
      "97109": true,
      "97110": true,
      "97111": true,
      "97112": true,
      "97113": true,
      "97114": true,
      "97115": true,
      "97116": true,
      "97117": true,
      "97118": true,
      "97119": true,
      "97120": true,
      "97121": true,
      "97122": true,
      "97123": true,
      "97124": true,
      "97125": true,
      "97126": true,
      "97127": true,
      "97128": true,
      "97129": true,
      "97130": true,
      "97131": true,
      "97132": true,
      "97133": true,
      "97134": true,
      "97135": true,
      "97136": true,
      "97137": true,
      "97138": true,
      "97139": true,
      "97140": true,
      "97141": true,
      "97142": true,
      "97143": true,
      "97144": true,
      "97145": true,
      "97146": true,
      "97147": true,
      "97148": true,
      "97149": true,
      "97150": true,
      "97151": true,
      "97152": true,
      "97153": true,
      "97154": true,
      "97155": true,
      "97156": true,
      "97157": true,
      "97158": true,
      "97159": true,
      "97160": true,
      "97161": true,
      "97162": true,
      "97163": true,
      "97164": true,
      "97165": true,
      "97166": true,
      "97167": true,
      "97168": true,
      "97169": true,
      "97170": true,
      "97171": true,
      "97172": true,
      "97173": true,
      "97174": true,
      "97175": true,
      "97176": true,
      "97177": true,
      "97178": true,
      "97179": true,
      "97180": true,
      "97181": true,
      "97182": true,
      "97183": true,
      "97184": true,
      "97185": true,
      "97186": true,
      "97187": true,
      "97188": true,
      "97189": true,
      "97190": true,
      "97191": true,
      "97192": true,
      "97193": true,
      "97194": true,
      "97195": true,
      "97196": true,
      "97197": true,
      "97198": true,
      "97199": true,
      "97200": true,
      "97201": true,
      "97202": true,
      "97203": true,
      "97204": true,
      "97205": true,
      "97206": true,
      "97207": true,
      "97208": true,
      "97209": true,
      "97210": true,
      "97211": true,
      "97212": true,
      "97213": true,
      "97214": true,
      "97215": true,
      "97216": true,
      "97217": true,
      "97218": true,
      "97219": true,
      "97220": true,
      "97221": true,
      "97222": true,
      "97223": true,
      "97224": true,
      "97225": true,
      "97226": true,
      "97227": true,
      "97228": true,
      "97229": true,
      "97230": true,
      "97231": true,
      "97232": true,
      "97233": true,
      "97234": true,
      "97235": true,
      "97236": true,
      "97237": true,
      "97238": true,
      "97239": true,
      "97240": true,
      "97241": true,
      "97242": true,
      "97243": true,
      "97244": true,
      "97245": true,
      "97246": true,
      "97247": true,
      "97248": true,
      "97249": true,
      "97250": true,
      "97251": true,
      "97252": true,
      "97253": true,
      "97254": true,
      "97255": true,
      "97256": true,
      "97257": true,
      "97258": true,
      "97259": true,
      "97260": true,
      "97261": true,
      "97262": true,
      "97263": true,
      "97264": true,
      "97265": true,
      "97266": true,
      "97267": true,
      "97268": true,
      "97269": true,
      "97270": true,
      "97271": true,
      "97272": true,
      "97273": true,
      "97274": true,
      "97275": true,
      "97276": true,
      "97277": true,
      "97278": true,
      "97279": true,
      "97280": true,
      "97281": true,
      "97282": true,
      "97283": true,
      "97284": true,
      "97285": true,
      "97286": true,
      "97287": true,
      "97288": true,
      "97289": true,
      "97290": true,
      "97291": true,
      "97292": true,
      "97293": true,
      "97294": true,
      "97295": true,
      "97296": true,
      "97297": true,
      "97298": true,
      "97299": true
    },
    "OXKUTZCAB": {
      "97880": true,
      "97881": true,
      "97882": true,
      "97883": true
    },
    "TICUL": {
      "97860": true,
      "97861": true,
      "97862": true,
      "97863": true,
      "97864": true,
      "97865": true,
      "97866": true,
      "97867": true,
      "97868": true,
      "97869": true,
      "97870": true,
      "97871": true,
      "97872": true,
      "97873": true,
      "97874": true,
      "97875": true,
      "97876": true,
      "97877": true,
      "97878": true,
      "97879": true
    }
  },
  "ZACATECAS": {
    "APOZOL": {
      "99940": true,
      "99941": true,
      "99942": true,
      "99943": true,
      "99944": true,
      "99945": true,
      "99946": true,
      "99947": true,
      "99948": true,
      "99949": true,
      "99950": true,
      "99951": true,
      "99952": true,
      "99953": true,
      "99954": true,
      "99955": true,
      "99956": true,
      "99957": true,
      "99958": true,
      "99959": true
    },
    "CALERA": {
      "98500": true,
      "98501": true,
      "98502": true,
      "98503": true,
      "98504": true,
      "98505": true,
      "98506": true,
      "98507": true,
      "98508": true,
      "98509": true,
      "98510": true,
      "98511": true,
      "98512": true,
      "98513": true,
      "98514": true,
      "98515": true,
      "98516": true,
      "98517": true,
      "98518": true,
      "98519": true,
      "98520": true,
      "98521": true,
      "98522": true,
      "98523": true,
      "98524": true,
      "98525": true
    },
    "CANITAS DE FELIPE PESCADOR": {
      "98480": true,
      "98481": true,
      "98482": true,
      "98483": true,
      "98484": true,
      "98485": true,
      "98486": true,
      "98487": true,
      "98488": true,
      "98489": true,
      "98490": true,
      "98491": true,
      "98492": true,
      "98493": true,
      "98494": true,
      "98495": true,
      "98496": true,
      "98497": true,
      "98498": true,
      "98499": true
    },
    "CONCEPCION DEL ORO": {
      "98200": true,
      "98201": true,
      "98202": true,
      "98203": true,
      "98204": true,
      "98205": true,
      "98206": true,
      "98207": true,
      "98208": true,
      "98209": true,
      "98212": true,
      "98213": true,
      "98214": true,
      "98215": true,
      "98216": true,
      "98217": true,
      "98218": true,
      "98219": true
    },
    "CUAUHTÉMOC": {
      "98680": true,
      "98681": true,
      "98682": true,
      "98683": true,
      "98684": true,
      "98685": true,
      "98686": true,
      "98687": true,
      "98688": true,
      "98689": true,
      "98690": true,
      "98691": true,
      "98692": true,
      "98693": true,
      "98694": true,
      "98695": true,
      "98696": true,
      "98697": true,
      "98698": true,
      "98699": true
    },
    "FRESNILLO": {
      "99000": true,
      "99001": true,
      "99002": true,
      "99003": true,
      "99004": true,
      "99005": true,
      "99006": true,
      "99007": true,
      "99008": true,
      "99009": true,
      "99010": true,
      "99011": true,
      "99012": true,
      "99013": true,
      "99014": true,
      "99015": true,
      "99016": true,
      "99017": true,
      "99018": true,
      "99019": true,
      "99020": true,
      "99021": true,
      "99022": true,
      "99023": true,
      "99024": true,
      "99025": true,
      "99026": true,
      "99027": true,
      "99028": true,
      "99029": true,
      "99030": true,
      "99031": true,
      "99032": true,
      "99034": true,
      "99035": true,
      "99036": true,
      "99037": true,
      "99038": true,
      "99039": true,
      "99040": true,
      "99041": true,
      "99042": true,
      "99043": true,
      "99044": true,
      "99045": true,
      "99046": true,
      "99047": true,
      "99048": true,
      "99049": true,
      "99050": true,
      "99051": true,
      "99052": true,
      "99053": true,
      "99054": true,
      "99055": true,
      "99056": true,
      "99057": true,
      "99058": true,
      "99059": true,
      "99060": true,
      "99061": true,
      "99062": true,
      "99063": true,
      "99064": true,
      "99065": true,
      "99066": true,
      "99067": true,
      "99068": true,
      "99069": true,
      "99070": true,
      "99071": true,
      "99072": true,
      "99073": true,
      "99074": true,
      "99075": true,
      "99076": true,
      "99077": true,
      "99078": true,
      "99079": true,
      "99080": true,
      "99081": true,
      "99082": true,
      "99083": true,
      "99084": true,
      "99085": true,
      "99086": true,
      "99087": true,
      "99088": true,
      "99089": true,
      "99090": true,
      "99091": true,
      "99092": true,
      "99093": true,
      "99094": true,
      "99095": true,
      "99096": true,
      "99097": true,
      "99098": true,
      "99099": true,
      "99150": true,
      "99151": true,
      "99152": true,
      "99153": true,
      "99154": true,
      "99158": true,
      "99170": true,
      "99171": true,
      "99172": true,
      "99173": true,
      "99176": true,
      "99185": true,
      "99186": true,
      "99187": true,
      "99188": true,
      "99189": true,
      "99192": true,
      "99194": true
    },
    "GENERAL ENRIQUE ESTRADA": {
      "98560": true,
      "98561": true,
      "98562": true,
      "98563": true,
      "98564": true,
      "98565": true,
      "98566": true,
      "98567": true,
      "98568": true,
      "98569": true,
      "98570": true,
      "98571": true,
      "98572": true,
      "98573": true,
      "98574": true,
      "98575": true,
      "98576": true,
      "98577": true,
      "98578": true,
      "98579": true,
      "98580": true,
      "98581": true,
      "98582": true,
      "98583": true,
      "98584": true,
      "98585": true,
      "98586": true,
      "98587": true,
      "98588": true,
      "98589": true,
      "98590": true,
      "98591": true,
      "98592": true,
      "98593": true,
      "98594": true,
      "98595": true,
      "98596": true,
      "98597": true,
      "98598": true,
      "98599": true
    },
    "GENERAL PANFILO NATERA": {
      "98730": true,
      "98731": true,
      "98732": true,
      "98733": true,
      "98734": true,
      "98735": true,
      "98736": true,
      "98737": true,
      "98738": true,
      "98739": true,
      "98740": true,
      "98741": true,
      "98742": true,
      "98743": true,
      "98744": true,
      "98745": true,
      "98746": true,
      "98747": true,
      "98748": true,
      "98749": true,
      "98750": true,
      "98751": true,
      "98752": true,
      "98753": true,
      "98754": true,
      "98755": true,
      "98756": true,
      "98757": true,
      "98758": true,
      "98759": true,
      "98760": true,
      "98761": true,
      "98762": true,
      "98763": true,
      "98764": true,
      "98765": true,
      "98766": true,
      "98767": true,
      "98768": true,
      "98769": true
    },
    "JALPA": {
      "99600": true,
      "99601": true,
      "99602": true,
      "99603": true,
      "99604": true,
      "99605": true,
      "99606": true,
      "99607": true,
      "99608": true,
      "99609": true,
      "99610": true,
      "99611": true,
      "99612": true,
      "99615": true,
      "99616": true,
      "99617": true,
      "99618": true,
      "99619": true,
      "99620": true,
      "99621": true,
      "99622": true,
      "99623": true,
      "99624": true,
      "99625": true,
      "99626": true,
      "99627": true,
      "99628": true,
      "99629": true
    },
    "JEREZ": {
      "99300": true,
      "99301": true,
      "99302": true,
      "99303": true,
      "99304": true,
      "99305": true,
      "99306": true,
      "99307": true,
      "99308": true,
      "99309": true,
      "99310": true,
      "99311": true,
      "99312": true,
      "99313": true,
      "99314": true,
      "99315": true,
      "99316": true,
      "99317": true,
      "99318": true,
      "99319": true,
      "99320": true,
      "99321": true,
      "99322": true,
      "99323": true,
      "99324": true,
      "99325": true,
      "99326": true,
      "99327": true,
      "99328": true,
      "99329": true,
      "99330": true,
      "99331": true,
      "99332": true,
      "99333": true,
      "99334": true,
      "99335": true,
      "99336": true,
      "99337": true,
      "99338": true,
      "99339": true,
      "99340": true,
      "99341": true,
      "99342": true,
      "99343": true,
      "99344": true,
      "99345": true,
      "99346": true,
      "99347": true,
      "99348": true,
      "99349": true,
      "99350": true,
      "99351": true,
      "99352": true,
      "99353": true,
      "99354": true,
      "99355": true,
      "99356": true,
      "99357": true,
      "99358": true,
      "99359": true,
      "99360": true,
      "99361": true,
      "99362": true,
      "99363": true,
      "99364": true,
      "99365": true,
      "99366": true,
      "99367": true,
      "99368": true,
      "99369": true,
      "99370": true,
      "99371": true,
      "99372": true,
      "99373": true,
      "99374": true,
      "99375": true,
      "99376": true,
      "99377": true,
      "99378": true,
      "99379": true,
      "99380": true,
      "99381": true,
      "99382": true,
      "99383": true,
      "99384": true,
      "99385": true,
      "99386": true,
      "99387": true,
      "99388": true,
      "99389": true,
      "99390": true,
      "99391": true,
      "99392": true,
      "99393": true,
      "99394": true,
      "99395": true,
      "99396": true,
      "99397": true,
      "99398": true,
      "99399": true,
      "99443": true,
      "99444": true,
      "99445": true,
      "99446": true,
      "99447": true,
      "99448": true,
      "99449": true,
      "99450": true,
      "99451": true,
      "99452": true,
      "99453": true,
      "99454": true,
      "99455": true,
      "99456": true,
      "99457": true,
      "99458": true,
      "99459": true,
      "99460": true,
      "99461": true,
      "99462": true,
      "99463": true,
      "99464": true,
      "99465": true,
      "99466": true,
      "99467": true,
      "99468": true,
      "99469": true,
      "99470": true,
      "99476": true,
      "99477": true
    },
    "JUAN ALDAMA": {
      "98300": true,
      "98301": true,
      "98302": true,
      "98303": true,
      "98304": true,
      "98305": true,
      "98306": true,
      "98307": true,
      "98308": true,
      "98309": true,
      "98310": true,
      "98311": true,
      "98312": true,
      "98313": true,
      "98314": true,
      "98315": true,
      "98316": true,
      "98317": true,
      "98318": true,
      "98319": true,
      "98320": true,
      "98321": true,
      "98322": true,
      "98323": true,
      "98324": true,
      "98325": true,
      "98326": true,
      "98327": true,
      "98328": true,
      "98329": true
    },
    "JUCHIPILA": {
      "99960": true,
      "99961": true,
      "99962": true,
      "99963": true,
      "99964": true,
      "99965": true,
      "99966": true,
      "99967": true,
      "99968": true,
      "99969": true,
      "99970": true,
      "99971": true,
      "99972": true,
      "99973": true,
      "99974": true,
      "99975": true,
      "99976": true,
      "99977": true,
      "99978": true,
      "99979": true
    },
    "LORETO": {
      "98800": true,
      "98801": true,
      "98802": true,
      "98803": true,
      "98804": true,
      "98807": true,
      "98808": true,
      "98809": true,
      "98810": true,
      "98811": true,
      "98812": true,
      "98813": true,
      "98814": true,
      "98815": true,
      "98816": true,
      "98817": true,
      "98818": true,
      "98819": true,
      "98820": true,
      "98821": true,
      "98822": true,
      "98823": true,
      "98824": true,
      "98825": true,
      "98826": true,
      "98827": true,
      "98828": true,
      "98829": true,
      "98830": true,
      "98831": true,
      "98832": true,
      "98833": true,
      "98834": true,
      "98835": true,
      "98836": true,
      "98837": true,
      "98838": true,
      "98839": true
    },
    "LUIS MOYA": {
      "98770": true,
      "98771": true,
      "98772": true,
      "98773": true,
      "98774": true,
      "98775": true,
      "98776": true,
      "98777": true,
      "98778": true,
      "98779": true,
      "98785": true,
      "98786": true,
      "98787": true,
      "98788": true,
      "98789": true,
      "98790": true,
      "98791": true,
      "98792": true,
      "98793": true,
      "98794": true,
      "98795": true,
      "98796": true,
      "98797": true,
      "98798": true,
      "98799": true
    },
    "NOCHISTLAN DE MEJIA": {
      "99900": true,
      "99901": true,
      "99902": true,
      "99903": true,
      "99904": true,
      "99905": true,
      "99906": true,
      "99907": true,
      "99908": true,
      "99909": true,
      "99910": true,
      "99911": true,
      "99912": true,
      "99913": true,
      "99914": true,
      "99915": true,
      "99916": true,
      "99917": true,
      "99918": true,
      "99919": true
    },
    "NORIA DE ANGELES": {
      "98880": true,
      "98881": true,
      "98882": true,
      "98883": true,
      "98884": true,
      "98885": true,
      "98886": true,
      "98887": true,
      "98888": true,
      "98889": true,
      "98890": true,
      "98891": true,
      "98892": true,
      "98893": true,
      "98894": true,
      "98895": true,
      "98896": true,
      "98897": true,
      "98898": true,
      "98899": true
    },
    "OJOCALIENTE": {
      "98700": true,
      "98701": true,
      "98702": true,
      "98703": true,
      "98704": true,
      "98706": true,
      "98707": true,
      "98708": true,
      "98709": true,
      "98710": true,
      "98711": true,
      "98712": true,
      "98713": true,
      "98714": true,
      "98715": true,
      "98716": true,
      "98717": true,
      "98718": true,
      "98719": true,
      "98720": true,
      "98721": true,
      "98722": true,
      "98723": true,
      "98724": true,
      "98725": true,
      "98726": true,
      "98727": true,
      "98728": true,
      "98729": true
    },
    "PINOS": {
      "98920": true,
      "98921": true,
      "98922": true,
      "98923": true,
      "98924": true,
      "98925": true,
      "98926": true,
      "98927": true,
      "98928": true,
      "98929": true,
      "98951": true,
      "98952": true,
      "98953": true,
      "98954": true,
      "98959": true,
      "98960": true,
      "98961": true,
      "98962": true,
      "98963": true,
      "98964": true,
      "98965": true,
      "98966": true,
      "98967": true,
      "98968": true,
      "98969": true,
      "98974": true,
      "98975": true,
      "98976": true,
      "98977": true,
      "98978": true
    },
    "RIO GRANDE": {
      "98400": true,
      "98401": true,
      "98402": true,
      "98403": true,
      "98404": true,
      "98405": true,
      "98406": true,
      "98407": true,
      "98408": true,
      "98409": true,
      "98416": true,
      "98417": true,
      "98418": true,
      "98419": true,
      "98420": true,
      "98421": true,
      "98422": true,
      "98423": true,
      "98424": true,
      "98425": true,
      "98426": true,
      "98427": true,
      "98428": true,
      "98429": true
    },
    "SAIN ALTO": {
      "99130": true,
      "99131": true,
      "99132": true,
      "99133": true,
      "99134": true,
      "99135": true,
      "99136": true,
      "99137": true,
      "99138": true,
      "99139": true,
      "99140": true,
      "99143": true,
      "99144": true,
      "99145": true,
      "99146": true,
      "99147": true,
      "99148": true,
      "99149": true
    },
    "TABASCO": {
      "99630": true,
      "99631": true,
      "99632": true,
      "99633": true,
      "99635": true,
      "99636": true,
      "99637": true,
      "99638": true,
      "99639": true,
      "99640": true,
      "99641": true,
      "99642": true,
      "99643": true,
      "99644": true,
      "99645": true,
      "99646": true,
      "99647": true,
      "99648": true,
      "99649": true,
      "99650": true,
      "99651": true,
      "99652": true,
      "99653": true,
      "99654": true,
      "99655": true
    },
    "TLALTENANGO DE SANCHEZ ROMAN": {
      "99700": true,
      "99701": true,
      "99702": true,
      "99703": true,
      "99704": true,
      "99705": true,
      "99706": true,
      "99707": true,
      "99708": true,
      "99709": true,
      "99713": true,
      "99714": true
    },
    "VALPARAISO": {
      "99200": true,
      "99201": true,
      "99202": true,
      "99203": true,
      "99204": true,
      "99205": true,
      "99207": true,
      "99215": true,
      "99216": true,
      "99220": true,
      "99221": true,
      "99222": true,
      "99223": true,
      "99224": true,
      "99225": true,
      "99226": true,
      "99227": true,
      "99228": true,
      "99229": true,
      "99230": true,
      "99231": true,
      "99232": true,
      "99233": true,
      "99234": true,
      "99235": true,
      "99236": true,
      "99237": true,
      "99245": true,
      "99250": true,
      "99251": true,
      "99252": true,
      "99253": true,
      "99254": true,
      "99255": true,
      "99256": true,
      "99257": true,
      "99258": true,
      "99259": true
    },
    "VILLA GARCIA": {
      "98900": true,
      "98901": true,
      "98902": true,
      "98903": true,
      "98904": true,
      "98905": true,
      "98906": true,
      "98907": true,
      "98908": true,
      "98909": true,
      "98910": true,
      "98911": true,
      "98912": true,
      "98913": true,
      "98914": true,
      "98915": true,
      "98916": true,
      "98917": true,
      "98918": true,
      "98919": true
    },
    "VILLA GONZALEZ ORTEGA": {
      "98840": true,
      "98841": true,
      "98842": true,
      "98843": true,
      "98844": true,
      "98845": true,
      "98846": true,
      "98847": true,
      "98848": true,
      "98849": true,
      "98850": true,
      "98851": true,
      "98852": true,
      "98853": true,
      "98854": true,
      "98855": true,
      "98856": true,
      "98857": true,
      "98858": true,
      "98859": true,
      "98870": true,
      "98871": true,
      "98872": true,
      "98873": true,
      "98874": true,
      "98875": true,
      "98876": true,
      "98877": true,
      "98878": true,
      "98879": true
    },
    "VILLA HIDALGO": {
      "98980": true,
      "98981": true,
      "98982": true,
      "98983": true,
      "98984": true,
      "98985": true,
      "98986": true,
      "98987": true,
      "98988": true,
      "98989": true,
      "98990": true,
      "98991": true,
      "98992": true,
      "98993": true,
      "98994": true,
      "98995": true,
      "98996": true,
      "98997": true,
      "98998": true,
      "98999": true
    },
    "VILLANUEVA": {
      "99500": true,
      "99501": true,
      "99502": true,
      "99503": true,
      "99504": true,
      "99505": true,
      "99520": true,
      "99521": true,
      "99522": true,
      "99530": true,
      "99531": true,
      "99532": true,
      "99533": true,
      "99534": true,
      "99535": true,
      "99536": true,
      "99537": true,
      "99538": true,
      "99539": true,
      "99540": true,
      "99541": true,
      "99542": true,
      "99543": true,
      "99544": true,
      "99545": true,
      "99546": true,
      "99547": true,
      "99548": true,
      "99549": true,
      "99550": true,
      "99551": true
    },
    "ZACATECAS": {
      "98000": true,
      "98001": true,
      "98002": true,
      "98003": true,
      "98004": true,
      "98005": true,
      "98006": true,
      "98007": true,
      "98008": true,
      "98009": true,
      "98010": true,
      "98011": true,
      "98012": true,
      "98013": true,
      "98014": true,
      "98015": true,
      "98016": true,
      "98017": true,
      "98018": true,
      "98019": true,
      "98020": true,
      "98021": true,
      "98022": true,
      "98023": true,
      "98024": true,
      "98025": true,
      "98026": true,
      "98027": true,
      "98028": true,
      "98029": true,
      "98030": true,
      "98031": true,
      "98032": true,
      "98033": true,
      "98034": true,
      "98035": true,
      "98036": true,
      "98037": true,
      "98038": true,
      "98039": true,
      "98040": true,
      "98041": true,
      "98042": true,
      "98043": true,
      "98044": true,
      "98045": true,
      "98046": true,
      "98047": true,
      "98048": true,
      "98049": true,
      "98050": true,
      "98051": true,
      "98052": true,
      "98053": true,
      "98054": true,
      "98055": true,
      "98056": true,
      "98057": true,
      "98058": true,
      "98059": true,
      "98060": true,
      "98061": true,
      "98062": true,
      "98063": true,
      "98064": true,
      "98065": true,
      "98066": true,
      "98067": true,
      "98068": true,
      "98069": true,
      "98070": true,
      "98071": true,
      "98072": true,
      "98073": true,
      "98074": true,
      "98075": true,
      "98076": true,
      "98077": true,
      "98078": true,
      "98079": true,
      "98080": true,
      "98081": true,
      "98082": true,
      "98083": true,
      "98084": true,
      "98085": true,
      "98086": true,
      "98087": true,
      "98088": true,
      "98089": true,
      "98090": true,
      "98091": true,
      "98092": true,
      "98093": true,
      "98094": true,
      "98095": true,
      "98096": true,
      "98097": true,
      "98098": true,
      "98099": true,
      "98160": true,
      "98161": true,
      "98162": true,
      "98163": true,
      "98164": true,
      "98165": true,
      "98166": true,
      "98167": true,
      "98168": true,
      "98169": true,
      "98170": true,
      "98171": true,
      "98172": true,
      "98173": true,
      "98176": true,
      "98177": true,
      "98178": true,
      "98179": true,
      "98183": true,
      "98185": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}